import * as Xo from "react";
import Sa, { isValidElement as aE, useLayoutEffect as Fk, useEffect as gt, useRef as Pt, useCallback as Ir, useMemo as Ur, useState as Qt, useReducer as iE, createContext as ka, useContext as Ui, Fragment as lE, createRef as Uk, forwardRef as O8 } from "react";
import { s as Wy, c as Yk } from "./sprinkles-DyY-9xTy.js";
/* empty css                              */
import { v as uh, b as $k } from "./vars-BxiGwZcN.js";
import { themeVars as oE } from "./theme.js";
var Wk = Object.defineProperty, zk = Object.defineProperties, qk = Object.getOwnPropertyDescriptors, x5 = Object.getOwnPropertySymbols, uE = Object.prototype.hasOwnProperty, sE = Object.prototype.propertyIsEnumerable, g_ = (e, t, a) => t in e ? Wk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, Q = (e, t) => {
  for (var a in t || (t = {}))
    uE.call(t, a) && g_(e, a, t[a]);
  if (x5)
    for (var a of x5(t))
      sE.call(t, a) && g_(e, a, t[a]);
  return e;
}, Oe = (e, t) => zk(e, qk(t)), Fe = (e, t) => {
  var a = {};
  for (var l in e)
    uE.call(e, l) && t.indexOf(l) < 0 && (a[l] = e[l]);
  if (e != null && x5)
    for (var l of x5(e))
      t.indexOf(l) < 0 && sE.call(e, l) && (a[l] = e[l]);
  return a;
}, Gk = Object.defineProperty, Kk = Object.defineProperties, Qk = Object.getOwnPropertyDescriptors, S5 = Object.getOwnPropertySymbols, cE = Object.prototype.hasOwnProperty, fE = Object.prototype.propertyIsEnumerable, w_ = (e, t, a) => t in e ? Gk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, _t = (e, t) => {
  for (var a in t || (t = {}))
    cE.call(t, a) && w_(e, a, t[a]);
  if (S5)
    for (var a of S5(t))
      fE.call(t, a) && w_(e, a, t[a]);
  return e;
}, gn = (e, t) => Kk(e, Qk(t)), Ap = (e, t) => {
  var a = {};
  for (var l in e)
    cE.call(e, l) && t.indexOf(l) < 0 && (a[l] = e[l]);
  if (e != null && S5)
    for (var l of S5(e))
      t.indexOf(l) < 0 && fE.call(e, l) && (a[l] = e[l]);
  return a;
};
function M4(...e) {
}
function Xk(e, t) {
  if (e === t)
    return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object")
    return !1;
  const a = Object.keys(e), l = Object.keys(t), { length: h } = a;
  if (l.length !== h)
    return !1;
  for (const g of a)
    if (e[g] !== t[g])
      return !1;
  return !0;
}
function T4(e, t) {
  if (Jk(e)) {
    const a = eL(t) ? t() : t;
    return e(a);
  }
  return e;
}
function Jk(e) {
  return typeof e == "function";
}
function eL(e) {
  return typeof e == "function";
}
function C5(e) {
  return typeof e == "object" && e != null;
}
function tL(e) {
  return typeof e == "number" ? Math.floor(e) === e : String(Math.floor(Number(e))) === e;
}
function df(e, t) {
  return typeof Object.hasOwn == "function" ? Object.hasOwn(e, t) : Object.prototype.hasOwnProperty.call(e, t);
}
function _o(...e) {
  return (...t) => {
    for (const a of e)
      typeof a == "function" && a(...t);
  };
}
function nL(...e) {
  return e.filter(Boolean).join(" ") || void 0;
}
function D8(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function rL(e, t) {
  const a = _t({}, e);
  for (const l of t)
    df(a, l) && delete a[l];
  return a;
}
function aL(e, t) {
  const a = {};
  for (const l of t)
    df(e, l) && (a[l] = e[l]);
  return a;
}
function dE(e) {
  return e;
}
function Ht(e, t) {
  if (!e)
    throw typeof t != "string" ? new Error("Invariant failed") : new Error(t);
}
function iL(e) {
  return Object.keys(e);
}
function I2(e, ...t) {
  const a = typeof e == "function" ? e(...t) : e;
  return a == null ? !1 : !a;
}
function pf(e) {
  return e.disabled || e["aria-disabled"] === !0 || e["aria-disabled"] === "true";
}
function La(e) {
  const t = {};
  for (const a in e)
    e[a] !== void 0 && (t[a] = e[a]);
  return t;
}
function st(...e) {
  for (const t of e)
    if (t !== void 0)
      return t;
}
function zy(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function lL(e) {
  return !(!e || !aE(e) || !("ref" in e));
}
function oL(e) {
  return lL(e) ? e.ref : null;
}
function uL(e, t) {
  const a = Q({}, e);
  for (const l in t) {
    if (!df(t, l))
      continue;
    if (l === "className") {
      const g = "className";
      a[g] = e[g] ? `${e[g]} ${t[g]}` : t[g];
      continue;
    }
    if (l === "style") {
      const g = "style";
      a[g] = e[g] ? Q(Q({}, e[g]), t[g]) : t[g];
      continue;
    }
    const h = t[l];
    if (typeof h == "function" && l.startsWith("on")) {
      const g = e[l];
      if (typeof g == "function") {
        a[l] = (...m) => {
          h(...m), g(...m);
        };
        continue;
      }
    }
    a[l] = h;
  }
  return a;
}
var kp = sL();
function sL() {
  var e;
  return typeof window < "u" && !!((e = window.document) != null && e.createElement);
}
function Qr(e) {
  return e ? e.ownerDocument || e : document;
}
function hE(e) {
  return Qr(e).defaultView || window;
}
function mf(e, t = !1) {
  const { activeElement: a } = Qr(e);
  if (!(a != null && a.nodeName))
    return null;
  if (j8(a) && a.contentDocument)
    return mf(
      a.contentDocument.body,
      t
    );
  if (t) {
    const l = a.getAttribute("aria-activedescendant");
    if (l) {
      const h = Qr(a).getElementById(l);
      if (h)
        return h;
    }
  }
  return a;
}
function ha(e, t) {
  return e === t || e.contains(t);
}
function j8(e) {
  return e.tagName === "IFRAME";
}
function k0(e) {
  const t = e.tagName.toLowerCase();
  return t === "button" ? !0 : t === "input" && e.type ? cL.indexOf(e.type) !== -1 : !1;
}
var cL = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function A8(e, t) {
  return "matches" in e ? e.matches(t) : "msMatchesSelector" in e ? e.msMatchesSelector(t) : e.webkitMatchesSelector(t);
}
function vE(e) {
  const t = e;
  return t.offsetWidth > 0 || t.offsetHeight > 0 || e.getClientRects().length > 0;
}
function pE(e, t) {
  if ("closest" in e)
    return e.closest(t);
  do {
    if (A8(e, t))
      return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null && e.nodeType === 1);
  return null;
}
function bo(e) {
  try {
    const t = e instanceof HTMLInputElement && e.selectionStart !== null, a = e.tagName === "TEXTAREA";
    return t || a || !1;
  } catch {
    return !1;
  }
}
function qy(e) {
  return e.isContentEditable || bo(e);
}
function fL(e) {
  if (bo(e))
    return e.value;
  if (e.isContentEditable) {
    const t = Qr(e).createRange();
    return t.selectNodeContents(e), t.toString();
  }
  return "";
}
function Gy(e) {
  let t = 0, a = 0;
  if (bo(e))
    t = e.selectionStart || 0, a = e.selectionEnd || 0;
  else if (e.isContentEditable) {
    const l = Qr(e).getSelection();
    if (l != null && l.rangeCount && l.anchorNode && ha(e, l.anchorNode) && l.focusNode && ha(e, l.focusNode)) {
      const h = l.getRangeAt(0), g = h.cloneRange();
      g.selectNodeContents(e), g.setEnd(h.startContainer, h.startOffset), t = g.toString().length, g.setEnd(h.endContainer, h.endOffset), a = g.toString().length;
    }
  }
  return { start: t, end: a };
}
function ph(e, t) {
  const a = ["dialog", "menu", "listbox", "tree", "grid"], l = e == null ? void 0 : e.getAttribute("role");
  return l && a.indexOf(l) !== -1 ? l : t;
}
function k8(e, t) {
  var a;
  const l = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }, h = ph(e);
  return h && (a = l[h]) != null ? a : t;
}
function L8(e) {
  if (!e)
    return null;
  if (e.clientHeight && e.scrollHeight > e.clientHeight) {
    const { overflowY: t } = getComputedStyle(e);
    if (t !== "visible" && t !== "hidden")
      return e;
  } else if (e.clientWidth && e.scrollWidth > e.clientWidth) {
    const { overflowX: t } = getComputedStyle(e);
    if (t !== "visible" && t !== "hidden")
      return e;
  }
  return L8(e.parentElement) || document.scrollingElement || document.body;
}
function Sy(e, ...t) {
  /text|search|password|tel|url/i.test(e.type) && e.setSelectionRange(...t);
}
function dL() {
  return kp && !!navigator.maxTouchPoints;
}
function I8() {
  return kp ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function H8() {
  return kp && I8() && /apple/i.test(navigator.vendor);
}
function hL() {
  return kp && /firefox\//i.test(navigator.userAgent);
}
function vL() {
  return kp && navigator.platform.startsWith("Mac") && !dL();
}
function mE(e) {
  return !!(e.currentTarget && !ha(e.currentTarget, e.target));
}
function Sl(e) {
  return e.target === e.currentTarget;
}
function Z8(e) {
  const t = e.currentTarget;
  if (!t)
    return !1;
  const a = I8();
  if (a && !e.metaKey || !a && !e.ctrlKey)
    return !1;
  const l = t.tagName.toLowerCase();
  return l === "a" || l === "button" && t.type === "submit" || l === "input" && t.type === "submit";
}
function P8(e) {
  const t = e.currentTarget;
  if (!t)
    return !1;
  const a = t.tagName.toLowerCase();
  return e.altKey ? a === "a" || a === "button" && t.type === "submit" || a === "input" && t.type === "submit" : !1;
}
function pL(e, t, a) {
  const l = new Event(t, a);
  return e.dispatchEvent(l);
}
function mp(e, t) {
  const a = new FocusEvent("blur", t), l = e.dispatchEvent(a), h = gn(_t({}, t), { bubbles: !0 });
  return e.dispatchEvent(new FocusEvent("focusout", h)), l;
}
function mL(e, t, a) {
  const l = new KeyboardEvent(t, a);
  return e.dispatchEvent(l);
}
function y_(e, t) {
  const a = new MouseEvent("click", t);
  return e.dispatchEvent(a);
}
function ah(e, t) {
  const a = t || e.currentTarget, l = e.relatedTarget;
  return !l || !ha(a, l);
}
function H2(e, t, a) {
  const l = requestAnimationFrame(() => {
    e.removeEventListener(t, h, !0), a();
  }), h = () => {
    cancelAnimationFrame(l), a();
  };
  return e.addEventListener(t, h, {
    once: !0,
    capture: !0
  }), l;
}
function Fi(e, t, a, l = window) {
  const h = [];
  try {
    l.document.addEventListener(e, t, a);
    for (const m of Array.from(l.frames))
      h.push(Fi(e, t, a, m));
  } catch {
  }
  return () => {
    try {
      l.document.removeEventListener(e, t, a);
    } catch {
    }
    h.forEach((m) => m());
  };
}
var gE = Q({}, Xo), x_ = gE.useId, S_ = gE.useInsertionEffect, kn = kp ? Fk : gt;
function N8(e) {
  const [t] = Qt(e);
  return t;
}
function wE(e) {
  const t = Pt(e);
  return kn(() => {
    t.current = e;
  }), t;
}
function nt(e) {
  const t = Pt(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return S_ ? S_(() => {
    t.current = e;
  }) : t.current = e, Ir((...a) => {
    var l;
    return (l = t.current) == null ? void 0 : l.call(t, ...a);
  }, []);
}
function Ln(...e) {
  return Ur(() => {
    if (e.some(Boolean))
      return (t) => {
        e.forEach((a) => zy(a, t));
      };
  }, e);
}
function Ia(e) {
  if (x_) {
    const l = x_();
    return e || l;
  }
  const [t, a] = Qt(e);
  return kn(() => {
    if (e || t)
      return;
    const l = Math.random().toString(36).substr(2, 6);
    a(`id-${l}`);
  }, [e, t]), e || t;
}
function mh(e, t) {
  const a = (g) => {
    if (typeof g == "string")
      return g;
  }, [l, h] = Qt(() => a(t));
  return kn(() => {
    const g = e && "current" in e ? e.current : e;
    h((g == null ? void 0 : g.tagName.toLowerCase()) || a(t));
  }, [e, t]), l;
}
function yE(e, t, a) {
  const [l, h] = Qt(a);
  return kn(() => {
    const g = e && "current" in e ? e.current : e;
    if (!g)
      return;
    const m = () => {
      const b = g.getAttribute(t);
      b != null && h(b);
    }, S = new MutationObserver(m);
    return S.observe(g, { attributeFilter: [t] }), m(), () => S.disconnect();
  }, [e, t]), l;
}
function b1(e, t) {
  const a = Pt(!1);
  gt(() => {
    if (a.current)
      return e();
    a.current = !0;
  }, t), gt(
    () => () => {
      a.current = !1;
    },
    []
  );
}
function gL(e, t) {
  const a = Pt(!1);
  kn(() => {
    if (a.current)
      return e();
    a.current = !0;
  }, t), kn(
    () => () => {
      a.current = !1;
    },
    []
  );
}
function Z5() {
  return iE(() => [], []);
}
function Jn(e) {
  return nt(
    typeof e == "function" ? e : () => e
  );
}
function Vn(e, t, a = []) {
  const l = Ir(
    (h) => (e.wrapElement && (h = e.wrapElement(h)), t(h)),
    [...a, e.wrapElement]
  );
  return Oe(Q({}, e), { wrapElement: l });
}
function V8(e = !1, t) {
  const [a, l] = Qt(null);
  return { portalRef: Ln(l, t), portalNode: a, domReady: !e || a };
}
function xE(e, t, a) {
  const l = e.onLoadedMetadataCapture, h = Ur(() => Object.assign(() => {
  }, Oe(Q({}, l), { [t]: a })), [l, t, a]);
  return [l == null ? void 0 : l[t], { onLoadedMetadataCapture: h }];
}
function SE() {
  return gt(() => {
    Fi("mousemove", yL, !0), Fi("mousedown", r5, !0), Fi("mouseup", r5, !0), Fi("keydown", r5, !0), Fi("scroll", r5, !0);
  }, []), nt(() => B8);
}
var B8 = !1, C_ = 0, b_ = 0;
function wL(e) {
  const t = e.movementX || e.screenX - C_, a = e.movementY || e.screenY - b_;
  return C_ = e.screenX, b_ = e.screenY, t || a || process.env.NODE_ENV === "test";
}
function yL(e) {
  wL(e) && (B8 = !0);
}
function r5() {
  B8 = !1;
}
function B2(e, t) {
  const a = e.__unstableInternals;
  return Ht(a, "Invalid store"), a[t];
}
function fi(e, ...t) {
  let a = e, l = a, h = Symbol(), g = M4;
  const m = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Set(), D = /* @__PURE__ */ new Set(), T = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), A = (Ce) => (b.add(Ce), () => b.delete(Ce)), L = () => {
    const Ce = m.size, ae = Symbol();
    m.add(ae);
    const me = () => {
      m.delete(ae), !m.size && g();
    };
    if (Ce)
      return me;
    const K = iL(a).map(
      (ge) => _o(
        ...t.map((Te) => {
          var be;
          const Ue = (be = Te == null ? void 0 : Te.getState) == null ? void 0 : be.call(Te);
          if (Ue && df(Ue, ge))
            return xa(Te, [ge], (le) => {
              ce(
                ge,
                le[ge],
                // @ts-expect-error - Not public API. This is just to prevent
                // infinite loops.
                !0
              );
            });
        })
      )
    ), we = [];
    b.forEach((ge) => we.push(ge()));
    const ue = t.map(P5);
    return g = _o(...K, ...we, ...ue), me;
  }, P = (Ce, ae, me = R) => (me.add(ae), j.set(ae, Ce), () => {
    var K;
    (K = T.get(ae)) == null || K(), T.delete(ae), j.delete(ae), me.delete(ae);
  }), N = (Ce, ae) => P(Ce, ae), F = (Ce, ae) => (T.set(ae, ae(a, a)), P(Ce, ae)), Y = (Ce, ae) => (T.set(ae, ae(a, l)), P(Ce, ae, D)), G = (Ce) => fi(aL(a, Ce), X), z = (Ce) => fi(rL(a, Ce), X), $ = () => a, ce = (Ce, ae, me = !1) => {
    if (!df(a, Ce))
      return;
    const K = T4(ae, a[Ce]);
    if (K === a[Ce])
      return;
    me || t.forEach((Te) => {
      var be;
      (be = Te == null ? void 0 : Te.setState) == null || be.call(Te, Ce, K);
    });
    const we = a;
    a = gn(_t({}, a), { [Ce]: K });
    const ue = Symbol();
    h = ue, S.add(Ce);
    const ge = (Te, be, Ue) => {
      var le;
      const _e = j.get(Te), Pe = (mt) => Ue ? Ue.has(mt) : mt === Ce;
      (!_e || _e.some(Pe)) && ((le = T.get(Te)) == null || le(), T.set(Te, Te(a, be)));
    };
    R.forEach((Te) => {
      ge(Te, we);
    }), queueMicrotask(() => {
      if (h !== ue)
        return;
      const Te = a;
      D.forEach((be) => {
        ge(be, l, S);
      }), l = Te, S.clear();
    });
  }, X = {
    getState: $,
    setState: ce,
    __unstableInternals: {
      setup: A,
      init: L,
      subscribe: N,
      sync: F,
      batch: Y,
      pick: G,
      omit: z
    }
  };
  return X;
}
function Aa(e, ...t) {
  if (e)
    return B2(e, "setup")(...t);
}
function P5(e, ...t) {
  if (e)
    return B2(e, "init")(...t);
}
function CE(e, ...t) {
  if (e)
    return B2(e, "subscribe")(...t);
}
function xa(e, ...t) {
  if (e)
    return B2(e, "sync")(...t);
}
function Z2(e, ...t) {
  if (e)
    return B2(e, "batch")(...t);
}
function Op(e, ...t) {
  if (e)
    return B2(e, "omit")(...t);
}
function bE(e, ...t) {
  if (e)
    return B2(e, "pick")(...t);
}
function Lp(...e) {
  const t = e.reduce((l, h) => {
    var g;
    const m = (g = h == null ? void 0 : h.getState) == null ? void 0 : g.call(h);
    return m ? _t(_t({}, l), m) : l;
  }, {});
  return fi(t, ...e);
}
function gh(e, t) {
  if (process.env.NODE_ENV === "production" || !t)
    return;
  const a = Object.entries(e).filter(([g, m]) => g.startsWith("default") && m !== void 0).map(([g]) => {
    var m;
    const S = g.replace("default", "");
    return `${((m = S[0]) == null ? void 0 : m.toLowerCase()) || ""}${S.slice(1)}`;
  });
  if (!a.length)
    return;
  const l = t.getState();
  if (a.filter(
    (g) => df(l, g)
  ).length)
    throw new Error(
      `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
    );
}
var S4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _E(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ky = { exports: {} }, Cy = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __;
function xL() {
  if (__) return Cy;
  __ = 1;
  var e = Sa;
  function t(T, j) {
    return T === j && (T !== 0 || 1 / T === 1 / j) || T !== T && j !== j;
  }
  var a = typeof Object.is == "function" ? Object.is : t, l = e.useState, h = e.useEffect, g = e.useLayoutEffect, m = e.useDebugValue;
  function S(T, j) {
    var A = j(), L = l({ inst: { value: A, getSnapshot: j } }), P = L[0].inst, N = L[1];
    return g(
      function() {
        P.value = A, P.getSnapshot = j, b(P) && N({ inst: P });
      },
      [T, A, j]
    ), h(
      function() {
        return b(P) && N({ inst: P }), T(function() {
          b(P) && N({ inst: P });
        });
      },
      [T]
    ), m(A), A;
  }
  function b(T) {
    var j = T.getSnapshot;
    T = T.value;
    try {
      var A = j();
      return !a(T, A);
    } catch {
      return !0;
    }
  }
  function R(T, j) {
    return j();
  }
  var D = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? R : S;
  return Cy.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : D, Cy;
}
var by = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R_;
function SL() {
  return R_ || (R_ = 1, process.env.NODE_ENV !== "production" && function() {
    function e(A, L) {
      return A === L && (A !== 0 || 1 / A === 1 / L) || A !== A && L !== L;
    }
    function t(A, L) {
      D || h.startTransition === void 0 || (D = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var P = L();
      if (!T) {
        var N = L();
        g(P, N) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), T = !0);
      }
      N = m({
        inst: { value: P, getSnapshot: L }
      });
      var F = N[0].inst, Y = N[1];
      return b(
        function() {
          F.value = P, F.getSnapshot = L, a(F) && Y({ inst: F });
        },
        [A, P, L]
      ), S(
        function() {
          return a(F) && Y({ inst: F }), A(function() {
            a(F) && Y({ inst: F });
          });
        },
        [A]
      ), R(P), P;
    }
    function a(A) {
      var L = A.getSnapshot;
      A = A.value;
      try {
        var P = L();
        return !g(A, P);
      } catch {
        return !0;
      }
    }
    function l(A, L) {
      return L();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var h = Sa, g = typeof Object.is == "function" ? Object.is : e, m = h.useState, S = h.useEffect, b = h.useLayoutEffect, R = h.useDebugValue, D = !1, T = !1, j = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : t;
    by.useSyncExternalStore = h.useSyncExternalStore !== void 0 ? h.useSyncExternalStore : j, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), by;
}
process.env.NODE_ENV === "production" ? Ky.exports = xL() : Ky.exports = SL();
var CL = Ky.exports;
const bL = /* @__PURE__ */ _E(CL);
var { useSyncExternalStore: _L } = bL, RL = () => () => {
};
function ja(e, t = dE) {
  const a = Xo.useCallback(
    (h) => e ? CE(e, null, h) : RL(),
    [e]
  ), l = () => {
    const h = typeof t == "string" ? t : null, g = typeof t == "function" ? t : null, m = e == null ? void 0 : e.getState();
    if (g)
      return g(m);
    if (m && h && df(m, h))
      return m[h];
  };
  return _L(a, l, l);
}
function lr(e, t, a, l) {
  const h = df(t, a) ? t[a] : void 0, g = l ? t[l] : void 0, m = wE({ value: h, setValue: g });
  kn(() => xa(e, [a], (S, b) => {
    const { value: R, setValue: D } = m.current;
    D && S[a] !== b[a] && S[a] !== R && D(S[a]);
  }), [e, a]), kn(() => {
    if (h !== void 0)
      return e.setState(a, h), Z2(e, [a], () => {
        h !== void 0 && e.setState(a, h);
      });
  });
}
function Cl(e, t) {
  const [a, l] = Xo.useState(() => e(t));
  kn(() => P5(a), [a]);
  const h = Xo.useCallback(
    (S) => ja(a, S),
    [a]
  ), g = Xo.useMemo(
    () => Oe(Q({}, a), { useState: h }),
    [a, h]
  ), m = nt(() => {
    l((S) => e(Q(Q({}, t), S.getState())));
  });
  return [g, m];
}
function EL(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function ML(e) {
  const t = e.map((l, h) => [h, l]);
  let a = !1;
  return t.sort(([l, h], [g, m]) => {
    const S = h.element, b = m.element;
    return S === b || !S || !b ? 0 : EL(S, b) ? (l > g && (a = !0), -1) : (l < g && (a = !0), 1);
  }), a ? t.map(([l, h]) => h) : e;
}
function TL(e) {
  var t;
  const a = e.find((g) => !!g.element), l = [...e].reverse().find((g) => !!g.element);
  let h = (t = a == null ? void 0 : a.element) == null ? void 0 : t.parentElement;
  for (; h && (l != null && l.element); ) {
    if (l && h.contains(l.element))
      return h;
    h = h.parentElement;
  }
  return Qr(h).body;
}
function OL(e) {
  return e == null ? void 0 : e.__unstablePrivateStore;
}
function N5(e = {}) {
  var t;
  gh(e, e.store);
  const a = (t = e.store) == null ? void 0 : t.getState(), l = st(
    e.items,
    a == null ? void 0 : a.items,
    e.defaultItems,
    []
  ), h = new Map(l.map((j) => [j.id, j])), g = {
    items: l,
    renderedItems: st(a == null ? void 0 : a.renderedItems, [])
  }, m = OL(e.store), S = fi(
    { items: l, renderedItems: g.renderedItems },
    m
  ), b = fi(g, e.store), R = (j) => {
    const A = ML(j);
    S.setState("renderedItems", A), b.setState("renderedItems", A);
  };
  Aa(b, () => P5(S)), Aa(S, () => Z2(S, ["items"], (j) => {
    b.setState("items", j.items);
  })), Aa(S, () => Z2(S, ["renderedItems"], (j) => {
    let A = !0, L = requestAnimationFrame(() => {
      const { renderedItems: Y } = b.getState();
      j.renderedItems !== Y && R(j.renderedItems);
    });
    if (typeof IntersectionObserver != "function")
      return () => cancelAnimationFrame(L);
    const P = () => {
      if (A) {
        A = !1;
        return;
      }
      cancelAnimationFrame(L), L = requestAnimationFrame(() => R(j.renderedItems));
    }, N = TL(j.renderedItems), F = new IntersectionObserver(P, { root: N });
    for (const Y of j.renderedItems)
      Y.element && F.observe(Y.element);
    return () => {
      cancelAnimationFrame(L), F.disconnect();
    };
  }));
  const D = (j, A, L = !1) => {
    let P;
    return A((F) => {
      const Y = F.findIndex(({ id: z }) => z === j.id), G = F.slice();
      if (Y !== -1) {
        P = F[Y];
        const z = _t(_t({}, P), j);
        G[Y] = z, h.set(j.id, z);
      } else
        G.push(j), h.set(j.id, j);
      return G;
    }), () => {
      A((F) => {
        if (!P)
          return L && h.delete(j.id), F.filter(({ id: z }) => z !== j.id);
        const Y = F.findIndex(({ id: z }) => z === j.id);
        if (Y === -1)
          return F;
        const G = F.slice();
        return G[Y] = P, h.set(j.id, P), G;
      });
    };
  }, T = (j) => D(
    j,
    (A) => S.setState("items", A),
    !0
  );
  return gn(_t({}, b), {
    registerItem: T,
    renderItem: (j) => _o(
      T(j),
      D(
        j,
        (A) => S.setState("renderedItems", A)
      )
    ),
    item: (j) => {
      if (!j)
        return null;
      let A = h.get(j);
      if (!A) {
        const { items: L } = b.getState();
        A = L.find((P) => P.id === j), A && h.set(j, A);
      }
      return A || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: S
  });
}
function F8(e, t, a) {
  return b1(t, [a.store]), lr(e, a, "items", "setItems"), e;
}
function RE(e = {}) {
  const [t, a] = Cl(N5, e);
  return F8(t, a, e);
}
var Qy = { exports: {} }, C4 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E_;
function DL() {
  if (E_) return C4;
  E_ = 1;
  var e = Sa, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), l = Object.prototype.hasOwnProperty, h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(S, b, R) {
    var D, T = {}, j = null, A = null;
    R !== void 0 && (j = "" + R), b.key !== void 0 && (j = "" + b.key), b.ref !== void 0 && (A = b.ref);
    for (D in b) l.call(b, D) && !g.hasOwnProperty(D) && (T[D] = b[D]);
    if (S && S.defaultProps) for (D in b = S.defaultProps, b) T[D] === void 0 && (T[D] = b[D]);
    return { $$typeof: t, type: S, key: j, ref: A, props: T, _owner: h.current };
  }
  return C4.Fragment = a, C4.jsx = m, C4.jsxs = m, C4;
}
var b4 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M_;
function jL() {
  return M_ || (M_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Sa, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), S = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), L = Symbol.iterator, P = "@@iterator";
    function N(J) {
      if (J === null || typeof J != "object")
        return null;
      var $e = L && J[L] || J[P];
      return typeof $e == "function" ? $e : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Y(J) {
      {
        for (var $e = arguments.length, ft = new Array($e > 1 ? $e - 1 : 0), Et = 1; Et < $e; Et++)
          ft[Et - 1] = arguments[Et];
        G("error", J, ft);
      }
    }
    function G(J, $e, ft) {
      {
        var Et = F.ReactDebugCurrentFrame, Bn = Et.getStackAddendum();
        Bn !== "" && ($e += "%s", ft = ft.concat([Bn]));
        var xn = ft.map(function(hn) {
          return String(hn);
        });
        xn.unshift("Warning: " + $e), Function.prototype.apply.call(console[J], console, xn);
      }
    }
    var z = !1, $ = !1, ce = !1, X = !1, Ce = !1, ae;
    ae = Symbol.for("react.module.reference");
    function me(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === l || J === g || Ce || J === h || J === R || J === D || X || J === A || z || $ || ce || typeof J == "object" && J !== null && (J.$$typeof === j || J.$$typeof === T || J.$$typeof === m || J.$$typeof === S || J.$$typeof === b || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === ae || J.getModuleId !== void 0));
    }
    function K(J, $e, ft) {
      var Et = J.displayName;
      if (Et)
        return Et;
      var Bn = $e.displayName || $e.name || "";
      return Bn !== "" ? ft + "(" + Bn + ")" : ft;
    }
    function we(J) {
      return J.displayName || "Context";
    }
    function ue(J) {
      if (J == null)
        return null;
      if (typeof J.tag == "number" && Y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof J == "function")
        return J.displayName || J.name || null;
      if (typeof J == "string")
        return J;
      switch (J) {
        case l:
          return "Fragment";
        case a:
          return "Portal";
        case g:
          return "Profiler";
        case h:
          return "StrictMode";
        case R:
          return "Suspense";
        case D:
          return "SuspenseList";
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case S:
            var $e = J;
            return we($e) + ".Consumer";
          case m:
            var ft = J;
            return we(ft._context) + ".Provider";
          case b:
            return K(J, J.render, "ForwardRef");
          case T:
            var Et = J.displayName || null;
            return Et !== null ? Et : ue(J.type) || "Memo";
          case j: {
            var Bn = J, xn = Bn._payload, hn = Bn._init;
            try {
              return ue(hn(xn));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ge = Object.assign, Te = 0, be, Ue, le, _e, Pe, mt, Ze;
    function Nt() {
    }
    Nt.__reactDisabledLog = !0;
    function kt() {
      {
        if (Te === 0) {
          be = console.log, Ue = console.info, le = console.warn, _e = console.error, Pe = console.group, mt = console.groupCollapsed, Ze = console.groupEnd;
          var J = {
            configurable: !0,
            enumerable: !0,
            value: Nt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: J,
            log: J,
            warn: J,
            error: J,
            group: J,
            groupCollapsed: J,
            groupEnd: J
          });
        }
        Te++;
      }
    }
    function Qe() {
      {
        if (Te--, Te === 0) {
          var J = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ge({}, J, {
              value: be
            }),
            info: ge({}, J, {
              value: Ue
            }),
            warn: ge({}, J, {
              value: le
            }),
            error: ge({}, J, {
              value: _e
            }),
            group: ge({}, J, {
              value: Pe
            }),
            groupCollapsed: ge({}, J, {
              value: mt
            }),
            groupEnd: ge({}, J, {
              value: Ze
            })
          });
        }
        Te < 0 && Y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var rt = F.ReactCurrentDispatcher, vt;
    function Ot(J, $e, ft) {
      {
        if (vt === void 0)
          try {
            throw Error();
          } catch (Bn) {
            var Et = Bn.stack.trim().match(/\n( *(at )?)/);
            vt = Et && Et[1] || "";
          }
        return `
` + vt + J;
      }
    }
    var yn = !1, Ar;
    {
      var In = typeof WeakMap == "function" ? WeakMap : Map;
      Ar = new In();
    }
    function zn(J, $e) {
      if (!J || yn)
        return "";
      {
        var ft = Ar.get(J);
        if (ft !== void 0)
          return ft;
      }
      var Et;
      yn = !0;
      var Bn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var xn;
      xn = rt.current, rt.current = null, kt();
      try {
        if ($e) {
          var hn = function() {
            throw Error();
          };
          if (Object.defineProperty(hn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(hn, []);
            } catch (na) {
              Et = na;
            }
            Reflect.construct(J, [], hn);
          } else {
            try {
              hn.call();
            } catch (na) {
              Et = na;
            }
            J.call(hn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (na) {
            Et = na;
          }
          J();
        }
      } catch (na) {
        if (na && Et && typeof na.stack == "string") {
          for (var vn = na.stack.split(`
`), Za = Et.stack.split(`
`), Rr = vn.length - 1, Er = Za.length - 1; Rr >= 1 && Er >= 0 && vn[Rr] !== Za[Er]; )
            Er--;
          for (; Rr >= 1 && Er >= 0; Rr--, Er--)
            if (vn[Rr] !== Za[Er]) {
              if (Rr !== 1 || Er !== 1)
                do
                  if (Rr--, Er--, Er < 0 || vn[Rr] !== Za[Er]) {
                    var di = `
` + vn[Rr].replace(" at new ", " at ");
                    return J.displayName && di.includes("<anonymous>") && (di = di.replace("<anonymous>", J.displayName)), typeof J == "function" && Ar.set(J, di), di;
                  }
                while (Rr >= 1 && Er >= 0);
              break;
            }
        }
      } finally {
        yn = !1, rt.current = xn, Qe(), Error.prepareStackTrace = Bn;
      }
      var hi = J ? J.displayName || J.name : "", Gt = hi ? Ot(hi) : "";
      return typeof J == "function" && Ar.set(J, Gt), Gt;
    }
    function er(J, $e, ft) {
      return zn(J, !1);
    }
    function wr(J) {
      var $e = J.prototype;
      return !!($e && $e.isReactComponent);
    }
    function ea(J, $e, ft) {
      if (J == null)
        return "";
      if (typeof J == "function")
        return zn(J, wr(J));
      if (typeof J == "string")
        return Ot(J);
      switch (J) {
        case R:
          return Ot("Suspense");
        case D:
          return Ot("SuspenseList");
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case b:
            return er(J.render);
          case T:
            return ea(J.type);
          case j: {
            var Et = J, Bn = Et._payload, xn = Et._init;
            try {
              return ea(xn(Bn));
            } catch {
            }
          }
        }
      return "";
    }
    var Ca = Object.prototype.hasOwnProperty, Hr = {}, xt = F.ReactDebugCurrentFrame;
    function ln(J) {
      if (J) {
        var $e = ea(J.type);
        xt.setExtraStackFrame($e);
      } else
        xt.setExtraStackFrame(null);
    }
    function dn(J, $e, ft, Et, Bn) {
      {
        var xn = Function.call.bind(Ca);
        for (var hn in J)
          if (xn(J, hn)) {
            var vn = void 0;
            try {
              if (typeof J[hn] != "function") {
                var Za = Error((Et || "React class") + ": " + ft + " type `" + hn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof J[hn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Za.name = "Invariant Violation", Za;
              }
              vn = J[hn]($e, hn, Et, ft, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rr) {
              vn = Rr;
            }
            vn && !(vn instanceof Error) && (ln(Bn), Y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Et || "React class", ft, hn, typeof vn), ln(null)), vn instanceof Error && !(vn.message in Hr) && (Hr[vn.message] = !0, ln(Bn), Y("Failed %s type: %s", ft, vn.message), ln(null));
          }
      }
    }
    var Vt = Array.isArray;
    function Rn(J) {
      return Vt(J);
    }
    function yr(J) {
      {
        var $e = typeof Symbol == "function" && Symbol.toStringTag, ft = $e && J[Symbol.toStringTag] || J.constructor.name || "Object";
        return ft;
      }
    }
    function Xe(J) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function Xt(J) {
      return "" + J;
    }
    function En(J) {
      if (Xe())
        return Y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yr(J)), Xt(J);
    }
    var Cn = F.ReactCurrentOwner, qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wt, St;
    function un(J) {
      if (Ca.call(J, "ref")) {
        var $e = Object.getOwnPropertyDescriptor(J, "ref").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return J.ref !== void 0;
    }
    function sr(J) {
      if (Ca.call(J, "key")) {
        var $e = Object.getOwnPropertyDescriptor(J, "key").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return J.key !== void 0;
    }
    function ta(J, $e) {
      {
        var ft = function() {
          wt || (wt = !0, Y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        ft.isReactWarning = !0, Object.defineProperty(J, "key", {
          get: ft,
          configurable: !0
        });
      }
    }
    function xr(J, $e) {
      {
        var ft = function() {
          St || (St = !0, Y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        ft.isReactWarning = !0, Object.defineProperty(J, "ref", {
          get: ft,
          configurable: !0
        });
      }
    }
    var ji = function(J, $e, ft, Et, Bn, xn, hn) {
      var vn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: J,
        key: $e,
        ref: ft,
        props: hn,
        // Record the component responsible for creating this element.
        _owner: xn
      };
      return vn._store = {}, Object.defineProperty(vn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(vn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Et
      }), Object.defineProperty(vn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Bn
      }), Object.freeze && (Object.freeze(vn.props), Object.freeze(vn)), vn;
    };
    function wn(J, $e, ft, Et, Bn) {
      {
        var xn, hn = {}, vn = null, Za = null;
        ft !== void 0 && (En(ft), vn = "" + ft), sr($e) && (En($e.key), vn = "" + $e.key), un($e) && (Za = $e.ref);
        for (xn in $e)
          Ca.call($e, xn) && !qe.hasOwnProperty(xn) && (hn[xn] = $e[xn]);
        if (J && J.defaultProps) {
          var Rr = J.defaultProps;
          for (xn in Rr)
            hn[xn] === void 0 && (hn[xn] = Rr[xn]);
        }
        if (vn || Za) {
          var Er = typeof J == "function" ? J.displayName || J.name || "Unknown" : J;
          vn && ta(hn, Er), Za && xr(hn, Er);
        }
        return ji(J, vn, Za, Bn, Et, Cn.current, hn);
      }
    }
    var qn = F.ReactCurrentOwner, M1 = F.ReactDebugCurrentFrame;
    function _l(J) {
      if (J) {
        var $e = ea(J.type);
        M1.setExtraStackFrame($e);
      } else
        M1.setExtraStackFrame(null);
    }
    var Jo;
    Jo = !1;
    function zl(J) {
      return typeof J == "object" && J !== null && J.$$typeof === t;
    }
    function Eo() {
      {
        if (qn.current) {
          var J = ue(qn.current.type);
          if (J)
            return `

Check the render method of \`` + J + "`.";
        }
        return "";
      }
    }
    function B0(J) {
      return "";
    }
    var T1 = {};
    function Cf(J) {
      {
        var $e = Eo();
        if (!$e) {
          var ft = typeof J == "string" ? J : J.displayName || J.name;
          ft && ($e = `

Check the top-level render call using <` + ft + ">.");
        }
        return $e;
      }
    }
    function O1(J, $e) {
      {
        if (!J._store || J._store.validated || J.key != null)
          return;
        J._store.validated = !0;
        var ft = Cf($e);
        if (T1[ft])
          return;
        T1[ft] = !0;
        var Et = "";
        J && J._owner && J._owner !== qn.current && (Et = " It was passed a child from " + ue(J._owner.type) + "."), _l(J), Y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ft, Et), _l(null);
      }
    }
    function Pu(J, $e) {
      {
        if (typeof J != "object")
          return;
        if (Rn(J))
          for (var ft = 0; ft < J.length; ft++) {
            var Et = J[ft];
            zl(Et) && O1(Et, $e);
          }
        else if (zl(J))
          J._store && (J._store.validated = !0);
        else if (J) {
          var Bn = N(J);
          if (typeof Bn == "function" && Bn !== J.entries)
            for (var xn = Bn.call(J), hn; !(hn = xn.next()).done; )
              zl(hn.value) && O1(hn.value, $e);
        }
      }
    }
    function Mo(J) {
      {
        var $e = J.type;
        if ($e == null || typeof $e == "string")
          return;
        var ft;
        if (typeof $e == "function")
          ft = $e.propTypes;
        else if (typeof $e == "object" && ($e.$$typeof === b || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        $e.$$typeof === T))
          ft = $e.propTypes;
        else
          return;
        if (ft) {
          var Et = ue($e);
          dn(ft, J.props, "prop", Et, J);
        } else if ($e.PropTypes !== void 0 && !Jo) {
          Jo = !0;
          var Bn = ue($e);
          Y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Bn || "Unknown");
        }
        typeof $e.getDefaultProps == "function" && !$e.getDefaultProps.isReactClassApproved && Y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function To(J) {
      {
        for (var $e = Object.keys(J.props), ft = 0; ft < $e.length; ft++) {
          var Et = $e[ft];
          if (Et !== "children" && Et !== "key") {
            _l(J), Y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Et), _l(null);
            break;
          }
        }
        J.ref !== null && (_l(J), Y("Invalid attribute `ref` supplied to `React.Fragment`."), _l(null));
      }
    }
    var $i = {};
    function Oo(J, $e, ft, Et, Bn, xn) {
      {
        var hn = me(J);
        if (!hn) {
          var vn = "";
          (J === void 0 || typeof J == "object" && J !== null && Object.keys(J).length === 0) && (vn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Za = B0();
          Za ? vn += Za : vn += Eo();
          var Rr;
          J === null ? Rr = "null" : Rn(J) ? Rr = "array" : J !== void 0 && J.$$typeof === t ? (Rr = "<" + (ue(J.type) || "Unknown") + " />", vn = " Did you accidentally export a JSX literal instead of a component?") : Rr = typeof J, Y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rr, vn);
        }
        var Er = wn(J, $e, ft, Bn, xn);
        if (Er == null)
          return Er;
        if (hn) {
          var di = $e.children;
          if (di !== void 0)
            if (Et)
              if (Rn(di)) {
                for (var hi = 0; hi < di.length; hi++)
                  Pu(di[hi], J);
                Object.freeze && Object.freeze(di);
              } else
                Y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pu(di, J);
        }
        if (Ca.call($e, "key")) {
          var Gt = ue(J), na = Object.keys($e).filter(function(D1) {
            return D1 !== "key";
          }), Xn = na.length > 0 ? "{key: someKey, " + na.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!$i[Gt + Xn]) {
            var bf = na.length > 0 ? "{" + na.join(": ..., ") + ": ...}" : "{}";
            Y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xn, Gt, bf, Gt), $i[Gt + Xn] = !0;
          }
        }
        return J === l ? To(Er) : Mo(Er), Er;
      }
    }
    function eu(J, $e, ft) {
      return Oo(J, $e, ft, !0);
    }
    function Ds(J, $e, ft) {
      return Oo(J, $e, ft, !1);
    }
    var tu = Ds, ql = eu;
    b4.Fragment = l, b4.jsx = tu, b4.jsxs = ql;
  }()), b4;
}
process.env.NODE_ENV === "production" ? Qy.exports = DL() : Qy.exports = jL();
var f = Qy.exports;
function De(e) {
  const t = Xo.forwardRef((a, l) => e(Oe(Q({}, a), { ref: l })));
  return t.displayName = e.displayName || e.name, t;
}
function Ha(e, t) {
  return Xo.memo(e, t);
}
function ke(e, t) {
  const a = t, { wrapElement: l, render: h } = a, g = Fe(a, ["wrapElement", "render"]), m = Ln(t.ref, oL(h));
  let S;
  if (Xo.isValidElement(h)) {
    const b = Oe(Q({}, h.props), { ref: m });
    S = Xo.cloneElement(h, uL(g, b));
  } else h ? S = h(g) : S = /* @__PURE__ */ f.jsx(e, Q({}, g));
  return l ? l(S) : S;
}
function Le(e) {
  const t = (a = {}) => e(a);
  return t.displayName = e.name, t;
}
function bl(e = [], t = []) {
  const a = Xo.createContext(void 0), l = Xo.createContext(void 0), h = () => Xo.useContext(a), g = (R = !1) => {
    const D = Xo.useContext(l), T = h();
    return R ? D : D || T;
  }, m = () => {
    const R = Xo.useContext(l), D = h();
    if (!(R && R === D))
      return D;
  }, S = (R) => e.reduceRight(
    (D, T) => /* @__PURE__ */ f.jsx(T, Oe(Q({}, R), { children: D })),
    /* @__PURE__ */ f.jsx(a.Provider, Q({}, R))
  );
  return {
    context: a,
    scopedContext: l,
    useContext: h,
    useScopedContext: g,
    useProviderContext: m,
    ContextProvider: S,
    ScopedContextProvider: (R) => /* @__PURE__ */ f.jsx(S, Oe(Q({}, R), { children: t.reduceRight(
      (D, T) => /* @__PURE__ */ f.jsx(T, Oe(Q({}, R), { children: D })),
      /* @__PURE__ */ f.jsx(l.Provider, Q({}, R))
    ) }))
  };
}
var V5 = bl(), EE = V5.useContext, AL = V5.useProviderContext, U8 = V5.ContextProvider, Y8 = V5.ScopedContextProvider, kL = "div", LL = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = AL();
    return l = l || g, h = Vn(
      h,
      (m) => /* @__PURE__ */ f.jsx(Y8, { value: l, children: m }),
      [l]
    ), La(h);
  }
), IL = De(function(t) {
  const a = LL(t);
  return ke(kL, a);
});
function HL(e = {}) {
  const t = RE(e);
  return /* @__PURE__ */ f.jsx(U8, { value: t, children: e.children });
}
var ZL = "div", wh = Le(
  function(t) {
    var a = t, {
      store: l,
      shouldRegisterItem: h = !0,
      getItem: g = dE,
      element: m
    } = a, S = Fe(a, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const b = EE();
    l = l || b;
    const R = Ia(S.id), D = Pt(m);
    return gt(() => {
      const T = D.current;
      if (!R || !T || !h)
        return;
      const j = g({ id: R, element: T });
      return l == null ? void 0 : l.renderItem(j);
    }, [R, h, g, l]), S = Oe(Q({}, S), {
      ref: Ln(D, S.ref)
    }), La(S);
  }
), PL = De(function(t) {
  const a = wh(t);
  return ke(ZL, a);
});
function NL(e = {}) {
  var t;
  gh(e, e.store);
  const a = (t = e.store) == null ? void 0 : t.getState(), l = {
    value: st(
      e.value,
      a == null ? void 0 : a.value,
      e.defaultValue,
      !1
    )
  }, h = fi(l, e.store);
  return gn(_t({}, h), {
    setValue: (g) => h.setState("value", g)
  });
}
function VL(e, t, a) {
  return b1(t, [a.store]), lr(e, a, "value", "setValue"), e;
}
function U4(e = {}) {
  const [t, a] = Cl(NL, e);
  return VL(t, a, e);
}
var ME = bl(), TE = ME.useContext, BL = ME.ContextProvider, OE = ka(!1), DE = ka(!0), $8 = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function FL(e) {
  return parseInt(e.getAttribute("tabindex") || "0", 10) < 0;
}
function j0(e) {
  return !(!A8(e, $8) || !vE(e) || pE(e, "[inert]"));
}
function L4(e) {
  if (!j0(e) || FL(e))
    return !1;
  if (!("form" in e) || !e.form || e.checked || e.type !== "radio")
    return !0;
  const t = e.form.elements.namedItem(e.name);
  if (!t || !("length" in t))
    return !0;
  const a = mf(e);
  return !a || a === e || !("form" in a) || a.form !== e.form || a.name !== e.name;
}
function W8(e, t) {
  const a = Array.from(
    e.querySelectorAll($8)
  );
  t && a.unshift(e);
  const l = a.filter(j0);
  return l.forEach((h, g) => {
    if (j8(h) && h.contentDocument) {
      const m = h.contentDocument.body;
      l.splice(g, 1, ...W8(m));
    }
  }), l;
}
function Ip(e, t, a) {
  const l = Array.from(
    e.querySelectorAll($8)
  ), h = l.filter(L4);
  return t && L4(e) && h.unshift(e), h.forEach((g, m) => {
    if (j8(g) && g.contentDocument) {
      const S = g.contentDocument.body, b = Ip(
        S,
        !1,
        a
      );
      h.splice(m, 1, ...b);
    }
  }), !h.length && a ? l : h;
}
function B5(e, t, a) {
  const [l] = Ip(
    e,
    t,
    a
  );
  return l || null;
}
function UL(e, t, a, l) {
  const h = mf(e), g = W8(e, t), m = g.indexOf(h), S = g.slice(m + 1);
  return S.find(L4) || (a ? g.find(L4) : null) || (l ? S[0] : null) || null;
}
function _y(e, t) {
  return UL(
    document.body,
    !1,
    e,
    t
  );
}
function YL(e, t, a, l) {
  const h = mf(e), g = W8(e, t).reverse(), m = g.indexOf(h);
  return g.slice(m + 1).find(L4) || null || null || null;
}
function T_(e, t) {
  return YL(
    document.body,
    !1
  );
}
function P2(e) {
  const t = mf(e);
  if (!t)
    return !1;
  if (t === e)
    return !0;
  const a = t.getAttribute("aria-activedescendant");
  return a ? a === e.id : !1;
}
function sh(e) {
  const t = mf(e);
  if (!t)
    return !1;
  if (ha(e, t))
    return !0;
  const a = t.getAttribute("aria-activedescendant");
  return !a || !("id" in e) ? !1 : a === e.id ? !0 : !!e.querySelector(`#${CSS.escape(a)}`);
}
function jE(e) {
  !sh(e) && j0(e) && e.focus();
}
function $L(e) {
  var t;
  const a = (t = e.getAttribute("tabindex")) != null ? t : "";
  e.setAttribute("data-tabindex", a), e.setAttribute("tabindex", "-1");
}
function xp(e, t) {
  Ip(e, t).forEach($L);
}
function b5(e) {
  const t = e.querySelectorAll("[data-tabindex]"), a = (l) => {
    const h = l.getAttribute("data-tabindex");
    l.removeAttribute("data-tabindex"), h ? l.setAttribute("tabindex", h) : l.removeAttribute("tabindex");
  };
  e.hasAttribute("data-tabindex") && a(e), t.forEach(a);
}
function WL(e, t) {
  "scrollIntoView" in e ? (e.focus({ preventScroll: !0 }), e.scrollIntoView(_t({ block: "nearest", inline: "nearest" }, t))) : e.focus();
}
var zL = "div", O_ = H8(), qL = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function GL(e) {
  const { tagName: t, readOnly: a, type: l } = e;
  return t === "TEXTAREA" && !a || t === "SELECT" && !a ? !0 : t === "INPUT" && !a ? qL.includes(l) : !!e.isContentEditable;
}
function KL(e) {
  return e.getAttribute("role") !== "combobox" ? !1 : !!e.dataset.name;
}
function QL(e) {
  return "labels" in e ? e.labels : null;
}
function D_(e) {
  return e.tagName.toLowerCase() === "input" && e.type ? e.type === "radio" || e.type === "checkbox" : !1;
}
function XL(e) {
  return e ? e === "button" || e === "summary" || e === "input" || e === "select" || e === "textarea" || e === "a" : !0;
}
function JL(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" : !0;
}
function eI(e, t, a, l, h) {
  return e ? t ? a && !l ? -1 : void 0 : a ? h : h || 0 : h;
}
function Ry(e, t) {
  return nt((a) => {
    e == null || e(a), !a.defaultPrevented && t && (a.stopPropagation(), a.preventDefault());
  });
}
var z8 = !0;
function tI(e) {
  const t = e.target;
  t && "hasAttribute" in t && (t.hasAttribute("data-focus-visible") || (z8 = !1));
}
function nI(e) {
  e.metaKey || e.ctrlKey || e.altKey || (z8 = !0);
}
var F2 = Le(
  function(t) {
    var a = t, {
      focusable: l = !0,
      accessibleWhenDisabled: h,
      autoFocus: g,
      onFocusVisible: m
    } = a, S = Fe(a, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const b = Pt(null);
    gt(() => {
      l && (Fi("mousedown", tI, !0), Fi("keydown", nI, !0));
    }, [l]), O_ && gt(() => {
      if (!l)
        return;
      const be = b.current;
      if (!be || !D_(be))
        return;
      const Ue = QL(be);
      if (!Ue)
        return;
      const le = () => queueMicrotask(() => be.focus());
      return Ue.forEach((_e) => _e.addEventListener("mouseup", le)), () => {
        Ue.forEach(
          (_e) => _e.removeEventListener("mouseup", le)
        );
      };
    }, [l]);
    const R = l && pf(S), D = !!R && !h, [T, j] = Qt(!1);
    gt(() => {
      l && D && T && j(!1);
    }, [l, D, T]), gt(() => {
      if (!l || !T)
        return;
      const be = b.current;
      if (!be || typeof IntersectionObserver > "u")
        return;
      const Ue = new IntersectionObserver(() => {
        j0(be) || j(!1);
      });
      return Ue.observe(be), () => Ue.disconnect();
    }, [l, T]);
    const A = Ry(
      S.onKeyPressCapture,
      R
    ), L = Ry(
      S.onMouseDownCapture,
      R
    ), P = Ry(S.onClickCapture, R), N = S.onMouseDown, F = nt((be) => {
      if (N == null || N(be), be.defaultPrevented || !l)
        return;
      const Ue = be.currentTarget;
      if (!O_ || mE(be) || !k0(Ue) && !D_(Ue))
        return;
      let le = !1;
      const _e = () => {
        le = !0;
      }, Pe = { capture: !0, once: !0 };
      Ue.addEventListener("focusin", _e, Pe), H2(Ue, "mouseup", () => {
        Ue.removeEventListener("focusin", _e, !0), !le && jE(Ue);
      });
    }), Y = (be, Ue) => {
      if (Ue && (be.currentTarget = Ue), !l)
        return;
      const le = be.currentTarget;
      le && P2(le) && (m == null || m(be), !be.defaultPrevented && j(!0));
    }, G = S.onKeyDownCapture, z = nt((be) => {
      if (G == null || G(be), be.defaultPrevented || !l || T || be.metaKey || be.altKey || be.ctrlKey || !Sl(be))
        return;
      const Ue = be.currentTarget;
      queueMicrotask(() => Y(be, Ue));
    }), $ = S.onFocusCapture, ce = nt((be) => {
      if ($ == null || $(be), be.defaultPrevented || !l)
        return;
      if (!Sl(be)) {
        j(!1);
        return;
      }
      const Ue = be.currentTarget, le = () => Y(be, Ue);
      z8 || GL(be.target) ? queueMicrotask(le) : KL(be.target) ? H2(be.target, "focusout", le) : j(!1);
    }), X = S.onBlur, Ce = nt((be) => {
      X == null || X(be), l && ah(be) && j(!1);
    }), ae = Ui(DE), me = nt((be) => {
      l && g && be && ae && queueMicrotask(() => {
        P2(be) || j0(be) && be.focus();
      });
    }), K = mh(b), we = l && XL(K), ue = l && JL(K), ge = S.style, Te = Ur(() => D ? Q({ pointerEvents: "none" }, ge) : ge, [D, ge]);
    return S = Oe(Q({
      "data-focus-visible": l && T || void 0,
      "data-autofocus": g || void 0,
      "aria-disabled": R || void 0
    }, S), {
      ref: Ln(b, me, S.ref),
      style: Te,
      tabIndex: eI(
        l,
        D,
        we,
        ue,
        S.tabIndex
      ),
      disabled: ue && D ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: R ? void 0 : S.contentEditable,
      onKeyPressCapture: A,
      onClickCapture: P,
      onMouseDownCapture: L,
      onMouseDown: F,
      onKeyDownCapture: z,
      onFocusCapture: ce,
      onBlur: Ce
    }), La(S);
  }
), rI = De(function(t) {
  const a = F2(t);
  return ke(zL, a);
}), aI = "button";
function j_(e) {
  if (!e.isTrusted)
    return !1;
  const t = e.currentTarget;
  return e.key === "Enter" ? k0(t) || t.tagName === "SUMMARY" || t.tagName === "A" : e.key === " " ? k0(t) || t.tagName === "SUMMARY" || t.tagName === "INPUT" || t.tagName === "SELECT" : !1;
}
var iI = Symbol("command"), F5 = Le(
  function(t) {
    var a = t, { clickOnEnter: l = !0, clickOnSpace: h = !0 } = a, g = Fe(a, ["clickOnEnter", "clickOnSpace"]);
    const m = Pt(null), S = mh(m), b = g.type, [R, D] = Qt(
      () => !!S && k0({ tagName: S, type: b })
    );
    gt(() => {
      m.current && D(k0(m.current));
    }, []);
    const [T, j] = Qt(!1), A = Pt(!1), L = pf(g), [P, N] = xE(g, iI, !0), F = g.onKeyDown, Y = nt(($) => {
      F == null || F($);
      const ce = $.currentTarget;
      if ($.defaultPrevented || P || L || !Sl($) || bo(ce) || ce.isContentEditable)
        return;
      const X = l && $.key === "Enter", Ce = h && $.key === " ", ae = $.key === "Enter" && !l, me = $.key === " " && !h;
      if (ae || me) {
        $.preventDefault();
        return;
      }
      if (X || Ce) {
        const K = j_($);
        if (X) {
          if (!K) {
            $.preventDefault();
            const we = $, ue = Fe(we, ["view"]), ge = () => y_(ce, ue);
            hL() ? H2(ce, "keyup", ge) : queueMicrotask(ge);
          }
        } else Ce && (A.current = !0, K || ($.preventDefault(), j(!0)));
      }
    }), G = g.onKeyUp, z = nt(($) => {
      if (G == null || G($), $.defaultPrevented || P || L || $.metaKey)
        return;
      const ce = h && $.key === " ";
      if (A.current && ce && (A.current = !1, !j_($))) {
        $.preventDefault(), j(!1);
        const X = $.currentTarget, Ce = $, ae = Fe(Ce, ["view"]);
        queueMicrotask(() => y_(X, ae));
      }
    });
    return g = Oe(Q(Q({
      "data-active": T || void 0,
      type: R ? "button" : void 0
    }, N), g), {
      ref: Ln(m, g.ref),
      onKeyDown: Y,
      onKeyUp: z
    }), g = F2(g), g;
  }
), lI = De(function(t) {
  const a = F5(t);
  return ke(aI, a);
}), AE = "input";
function A_(e, t) {
  t ? e.indeterminate = !0 : e.indeterminate && (e.indeterminate = !1);
}
function oI(e, t) {
  return e === "input" && (!t || t === "checkbox");
}
function k_(e) {
  return Array.isArray(e) ? e.toString() : e;
}
var q8 = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      value: g,
      checked: m,
      defaultChecked: S
    } = a, b = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked"
    ]);
    const R = TE();
    l = l || R;
    const [D, T] = Qt(S ?? !1), j = ja(l, (ae) => {
      if (m !== void 0)
        return m;
      if ((ae == null ? void 0 : ae.value) === void 0)
        return D;
      if (g != null) {
        if (Array.isArray(ae.value)) {
          const me = k_(g);
          return ae.value.includes(me);
        }
        return ae.value === g;
      }
      return Array.isArray(ae.value) ? !1 : typeof ae.value == "boolean" ? ae.value : !1;
    }), A = Pt(null), L = mh(A, AE), P = oI(L, b.type), N = j ? j === "mixed" : void 0, F = j === "mixed" ? !1 : j, Y = pf(b), [G, z] = Z5();
    gt(() => {
      const ae = A.current;
      ae && (A_(ae, N), !P && (ae.checked = F, h !== void 0 && (ae.name = h), g !== void 0 && (ae.value = `${g}`)));
    }, [G, N, P, F, h, g]);
    const $ = b.onChange, ce = nt((ae) => {
      if (Y) {
        ae.stopPropagation(), ae.preventDefault();
        return;
      }
      if (A_(ae.currentTarget, N), P || (ae.currentTarget.checked = !ae.currentTarget.checked, z()), $ == null || $(ae), ae.defaultPrevented)
        return;
      const me = ae.currentTarget.checked;
      T(me), l == null || l.setValue((K) => {
        if (g == null)
          return me;
        const we = k_(g);
        return Array.isArray(K) ? me ? K.includes(we) ? K : [...K, we] : K.filter((ue) => ue !== we) : K === we ? !1 : we;
      });
    }), X = b.onClick, Ce = nt((ae) => {
      X == null || X(ae), !ae.defaultPrevented && (P || ce(ae));
    });
    return b = Vn(
      b,
      (ae) => /* @__PURE__ */ f.jsx(OE.Provider, { value: F, children: ae }),
      [F]
    ), b = Oe(Q({
      role: P ? void 0 : "checkbox",
      type: P ? "checkbox" : void 0,
      "aria-checked": j
    }, b), {
      ref: Ln(A, b.ref),
      onChange: ce,
      onClick: Ce
    }), b = F5(Q({ clickOnEnter: !P }, b)), La(Q({
      name: P ? h : void 0,
      value: P ? g : void 0,
      checked: F
    }, b));
  }
), kE = De(function(t) {
  const a = q8(t);
  return ke(AE, a);
});
function uI(e = {}) {
  const t = U4(e);
  return /* @__PURE__ */ f.jsx(BL, { value: t, children: e.children });
}
var sI = "span", cI = /* @__PURE__ */ f.jsx(
  "svg",
  {
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    children: /* @__PURE__ */ f.jsx("polyline", { points: "4,8 7,12 12,4" })
  }
);
function fI(e) {
  return e.checked ? e.children || cI : typeof e.children == "function" ? e.children : null;
}
var U5 = Le(
  function(t) {
    var a = t, { store: l, checked: h } = a, g = Fe(a, ["store", "checked"]);
    const m = Ui(OE);
    h = h ?? m;
    const S = fI({ checked: h, children: g.children });
    return g = Oe(Q({
      "aria-hidden": !0
    }, g), {
      children: S,
      style: Q({
        width: "1em",
        height: "1em",
        pointerEvents: "none"
      }, g.style)
    }), La(g);
  }
), dI = De(function(t) {
  const a = U5(t);
  return ke(sI, a);
}), LE = "button", yh = Le(
  function(t) {
    const a = Pt(null), l = mh(a, LE), [h, g] = Qt(
      () => !!l && k0({ tagName: l, type: t.type })
    );
    return gt(() => {
      a.current && g(k0(a.current));
    }, []), t = Oe(Q({
      role: !h && l !== "a" ? "button" : void 0
    }, t), {
      ref: Ln(a, t.ref)
    }), t = F5(t), t;
  }
), Y5 = De(function(t) {
  const a = yh(t);
  return ke(LE, a);
});
function L_() {
  return new Promise((e) => requestAnimationFrame(() => e()));
}
function f5(e) {
  return Object.keys(e).some((t) => C5(e[t]) ? f5(e[t]) : !!e[t]);
}
function af(e, t, a) {
  var l;
  const [h, ...g] = Array.isArray(t) ? t : `${t}`.split(".");
  return h == null || !e ? a : g.length ? af(e[h], g, a) : (l = e[h]) != null ? l : a;
}
function wp(e, t, a) {
  const [l, ...h] = Array.isArray(t) ? t : `${t}`.split(".");
  if (l == null)
    return e;
  const g = l, m = tL(g), b = (m ? e || [] : e || {})[g], R = h.length && (Array.isArray(b) || C5(b)) ? wp(b, h, a) : a;
  if (m) {
    const D = Number(g);
    if (e && Array.isArray(e))
      return [
        ...e.slice(0, D),
        R,
        ...e.slice(D + 1)
      ];
    const T = [];
    return T[D] = R, T;
  }
  return gn(_t({}, e), { [g]: R });
}
function Xy(e, t) {
  const a = {}, l = Object.keys(e);
  for (const h of l) {
    const g = e[h];
    Array.isArray(g) ? a[h] = g.map((m) => C5(m) ? Xy(m, t) : t) : C5(g) ? a[h] = Xy(g, t) : a[h] = t;
  }
  return a;
}
function IE(e, t = []) {
  return {
    get(l, h) {
      if (["toString", "valueOf", Symbol.toPrimitive].includes(h))
        return () => t.join(".");
      const g = [...t, h], m = g.join(".");
      if (e[m])
        return e[m];
      const S = new Proxy(l, IE(e, g));
      return e[m] = S, S;
    }
  };
}
function hI(e) {
  return e == null ? void 0 : e.__unstableCallbacks;
}
function vI() {
  const e = /* @__PURE__ */ Object.create(null);
  return new Proxy(/* @__PURE__ */ Object.create(null), IE(e));
}
function pI(e = {}) {
  var t;
  gh(e, e.store);
  const a = (t = e.store) == null ? void 0 : t.getState(), l = N5(e), h = st(
    e.values,
    a == null ? void 0 : a.values,
    e.defaultValues,
    {}
  ), g = st(
    e.errors,
    a == null ? void 0 : a.errors,
    e.defaultErrors,
    {}
  ), m = st(
    e.touched,
    a == null ? void 0 : a.touched,
    e.defaultTouched,
    {}
  ), S = gn(_t({}, l.getState()), {
    values: h,
    errors: g,
    touched: m,
    validating: st(a == null ? void 0 : a.validating, !1),
    submitting: st(a == null ? void 0 : a.submitting, !1),
    submitSucceed: st(a == null ? void 0 : a.submitSucceed, 0),
    submitFailed: st(a == null ? void 0 : a.submitFailed, 0),
    valid: !f5(g)
  }), b = fi(S, l, e.store), R = hI(e.store), D = R == null ? void 0 : R.getState(), T = {
    validate: (D == null ? void 0 : D.validate) || [],
    submit: (D == null ? void 0 : D.submit) || []
  }, j = fi(T, R);
  Aa(b, () => P5(j));
  const A = async () => {
    b.setState("validating", !0), b.setState("errors", {});
    const L = j.getState().validate;
    try {
      for (const P of L)
        await P(b.getState());
      return await L_(), !f5(b.getState().errors);
    } finally {
      b.setState("validating", !1);
    }
  };
  return gn(_t(_t({}, l), b), {
    names: vI(),
    setValues: (L) => b.setState("values", L),
    getValue: (L) => af(b.getState().values, L),
    setValue: (L, P) => b.setState("values", (N) => {
      const F = af(N, L), Y = T4(P, F);
      return Y === F ? N : wp(N, L, Y);
    }),
    pushValue: (L, P) => b.setState("values", (N) => {
      const F = af(N, L, []);
      return wp(N, L, [...F, P]);
    }),
    removeValue: (L, P) => b.setState("values", (N) => {
      const F = af(N, L, []);
      return wp(N, L, [
        ...F.slice(0, P),
        null,
        ...F.slice(P + 1)
      ]);
    }),
    setErrors: (L) => b.setState("errors", L),
    getError: (L) => af(b.getState().errors, L),
    setError: (L, P) => b.setState("errors", (N) => {
      const F = af(N, L), Y = T4(P, F);
      return Y === F ? N : wp(N, L, Y);
    }),
    setTouched: (L) => b.setState("touched", L),
    getFieldTouched: (L) => !!af(b.getState().touched, L),
    setFieldTouched: (L, P) => b.setState("touched", (N) => {
      const F = af(N, L), Y = T4(P, F);
      return Y === F ? N : wp(N, L, Y);
    }),
    onValidate: (L) => (j.setState("validate", (P) => [...P, L]), () => {
      j.setState(
        "validate",
        (P) => P.filter((N) => N !== L)
      );
    }),
    validate: A,
    onSubmit: (L) => (j.setState("submit", (P) => [...P, L]), () => {
      j.setState(
        "submit",
        (P) => P.filter((N) => N !== L)
      );
    }),
    submit: async () => {
      b.setState("submitting", !0), b.setState("touched", Xy(b.getState().values, !0));
      try {
        if (await A()) {
          const L = j.getState().submit;
          for (const P of L)
            await P(b.getState());
          if (await L_(), !f5(b.getState().errors))
            return b.setState("submitSucceed", (P) => P + 1), !0;
        }
        return b.setState("submitFailed", (L) => L + 1), !1;
      } catch (L) {
        throw b.setState("submitFailed", (P) => P + 1), L;
      } finally {
        b.setState("submitting", !1);
      }
    },
    reset: () => {
      b.setState("values", h), b.setState("errors", g), b.setState("touched", m), b.setState("validating", !1), b.setState("submitting", !1), b.setState("submitSucceed", 0), b.setState("submitFailed", 0);
    },
    // @ts-expect-error Internal
    __unstableCallbacks: j
  });
}
function mI(e, t, a) {
  e = F8(e, t, a), lr(e, a, "values", "setValues"), lr(e, a, "errors", "setErrors"), lr(e, a, "touched", "setTouched");
  const l = Ir(
    (m) => e.useState(() => e.getValue(m)),
    [e]
  ), h = Ir(
    (m) => {
      m = nt(m);
      const S = e.useState("items");
      gt(() => e.onValidate(m), [S, m]);
    },
    [e]
  ), g = Ir(
    (m) => {
      m = nt(m);
      const S = e.useState("items");
      gt(() => e.onSubmit(m), [S, m]);
    },
    [e]
  );
  return Ur(
    () => Oe(Q({}, e), {
      useValue: l,
      useValidate: h,
      useSubmit: g
    }),
    []
  );
}
function G8(e = {}) {
  const [t, a] = Cl(pI, e);
  return mI(t, a, e);
}
var K8 = bl(
  [U8],
  [Y8]
), Ro = K8.useContext, gI = K8.ContextProvider, wI = K8.ScopedContextProvider, HE = "form";
function yI(e, t) {
  return t.some(
    (a) => a.type === "field" && a.element === e
  );
}
function xI(e) {
  return e.find(
    (t) => {
      var a;
      return t.type === "field" && ((a = t.element) == null ? void 0 : a.getAttribute("aria-invalid")) === "true";
    }
  );
}
var SI = Le(function(t) {
  var a = t, {
    store: l,
    validateOnChange: h = !0,
    validateOnBlur: g = !0,
    resetOnUnmount: m = !1,
    resetOnSubmit: S = !0,
    autoFocusOnSubmit: b = !0
  } = a, R = Fe(a, [
    "store",
    "validateOnChange",
    "validateOnBlur",
    "resetOnUnmount",
    "resetOnSubmit",
    "autoFocusOnSubmit"
  ]);
  const D = Ro();
  l = l || D, Ht(
    l,
    process.env.NODE_ENV !== "production" && "Form must receive a `store` prop or be wrapped in a FormProvider component."
  );
  const T = Pt(null), j = l.useState("values"), A = l.useState("submitSucceed"), L = l.useState("submitFailed"), P = l.useState("items"), N = N8(j);
  gt(
    () => m ? l == null ? void 0 : l.reset : void 0,
    [m, l]
  ), b1(() => {
    h && j !== N && (l == null || l.validate());
  }, [h, j, N, l]), gt(() => {
    S && A && (l == null || l.reset());
  }, [S, A, l]);
  const [F, Y] = Qt(!1);
  gt(() => {
    if (!F || !L)
      return;
    const me = xI(P), K = me == null ? void 0 : me.element;
    K && (Y(!1), K.focus(), bo(K) && K.select());
  }, [b, L, P]);
  const G = R.onSubmit, z = nt((me) => {
    G == null || G(me), !me.defaultPrevented && (me.preventDefault(), l == null || l.submit(), b && Y(!0));
  }), $ = R.onBlur, ce = nt((me) => {
    $ == null || $(me), !me.defaultPrevented && g && l && yI(me.target, l.getState().items) && l.validate();
  }), X = R.onReset, Ce = nt((me) => {
    X == null || X(me), !me.defaultPrevented && (me.preventDefault(), l == null || l.reset());
  });
  R = Vn(
    R,
    (me) => /* @__PURE__ */ f.jsx(wI, { value: l, children: me }),
    [l]
  );
  const ae = mh(T, HE);
  return R = Oe(Q({
    role: ae !== "form" ? "form" : void 0,
    noValidate: !0
  }, R), {
    ref: Ln(T, R.ref),
    onSubmit: z,
    onBlur: ce,
    onReset: Ce
  }), R;
}), ZE = De(function(t) {
  const a = SI(t);
  return ke(HE, a);
});
function PE(e = {}) {
  const t = G8(e);
  return /* @__PURE__ */ f.jsx(gI, { value: t, children: e.children });
}
var CI = "input";
function bI(e, t) {
  const a = e.current;
  return a ? a.name === t ? a : a.form ? a.form.elements.namedItem(t) : Qr(a).getElementsByName(t)[0] : null;
}
function Ey(e, t, a) {
  return e.useState(
    (l) => l.items.find((h) => h.type === a && h.name === t)
  );
}
var Y4 = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      getItem: g,
      touchOnBlur: m = !0
    } = a, S = Fe(a, [
      "store",
      "name",
      "getItem",
      "touchOnBlur"
    ]);
    const b = Ro();
    l = l || b, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormControl must be wrapped in a Form component."
    );
    const R = `${h}`, D = Ia(S.id), T = Pt(null);
    l.useValidate(async () => {
      const $ = bI(T, R);
      $ && (await Promise.resolve(), "validity" in $ && !$.validity.valid && (l == null || l.setError(R, $.validationMessage)));
    });
    const j = Ir(
      ($) => {
        const ce = Oe(Q({}, $), { id: D || $.id, name: R, type: "field" });
        return g ? g(ce) : ce;
      },
      [D, R, g]
    ), A = S.onBlur, L = Jn(m), P = nt(($) => {
      A == null || A($), !$.defaultPrevented && L($) && (l == null || l.setFieldTouched(R, !0));
    }), N = Ey(l, R, "label"), F = Ey(l, R, "error"), Y = Ey(l, R, "description"), G = nL(
      F == null ? void 0 : F.id,
      Y == null ? void 0 : Y.id,
      S["aria-describedby"]
    ), z = l.useState(
      () => !!(l != null && l.getError(R)) && l.getFieldTouched(R)
    );
    return S = Oe(Q({
      id: D,
      "aria-labelledby": N == null ? void 0 : N.id,
      "aria-invalid": z
    }, S), {
      "aria-describedby": G || void 0,
      ref: Ln(T, S.ref),
      onBlur: P
    }), S = wh(Oe(Q({ store: l }, S), { name: R, getItem: j })), S;
  }
), _I = Ha(
  De(function(t) {
    const a = Y4(t);
    return ke(CI, a);
  })
), RI = "input", EI = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      value: g,
      checked: m,
      defaultChecked: S
    } = a, b = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked"
    ]);
    const R = Ro();
    l = l || R, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormCheckbox must be wrapped in a Form component."
    );
    const D = `${h}`, T = U4({
      value: l.useValue(D),
      setValue: (j) => l == null ? void 0 : l.setValue(D, j)
    });
    return b = q8(Q({ store: T, value: g, checked: m }, b)), b = Y4(Q({
      store: l,
      name: D,
      "aria-labelledby": void 0
    }, b)), b;
  }
), MI = Ha(
  De(function(t) {
    const a = EI(t);
    return ke(RI, a);
  })
), TI = "div", OI = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      getItem: g
    } = a, m = Fe(a, [
      "store",
      "name",
      "getItem"
    ]);
    const S = Ro();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormDescription must be wrapped in a Form component."
    );
    const b = Ia(m.id), R = Pt(null), D = `${h}`, T = Ir(
      (j) => {
        const A = Oe(Q({}, j), {
          id: b || j.id,
          name: D,
          type: "description"
        });
        return g ? g(A) : A;
      },
      [b, D, g]
    );
    return m = Oe(Q({
      id: b
    }, m), {
      ref: Ln(R, m.ref)
    }), m = wh(Oe(Q({ store: l }, m), { getItem: T })), m;
  }
), DI = Ha(
  De(function(t) {
    const a = OI(t);
    return ke(TI, a);
  })
), jI = "div", AI = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      getItem: g
    } = a, m = Fe(a, [
      "store",
      "name",
      "getItem"
    ]);
    const S = Ro();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component."
    );
    const b = Ia(m.id), R = Pt(null), D = `${h}`, T = Ir(
      (A) => {
        const L = Oe(Q({}, A), { id: b || A.id, name: D, type: "error" });
        return g ? g(L) : L;
      },
      [b, D, g]
    ), j = l.useState(() => {
      const A = l == null ? void 0 : l.getError(D);
      if (A != null && l != null && l.getFieldTouched(D))
        return A;
    });
    return m = Oe(Q({
      id: b,
      role: "alert",
      children: j
    }, m), {
      ref: Ln(R, m.ref)
    }), m = wh(Oe(Q({ store: l }, m), { getItem: T })), m;
  }
), NE = Ha(
  De(function(t) {
    const a = AI(t);
    return ke(jI, a);
  })
), kI = "input", LI = Le(
  function(t) {
    return Y4(t);
  }
), II = Ha(
  De(function(t) {
    const a = LI(t);
    return ke(kI, a);
  })
), VE = ka(void 0), HI = "div", Q8 = Le(
  function(t) {
    const a = Ui(VE), l = Ia(t.id);
    return kn(() => (a == null || a(l), () => a == null ? void 0 : a(void 0)), [a, l]), t = Q({
      id: l,
      "aria-hidden": !0
    }, t), La(t);
  }
), ZI = De(function(t) {
  const a = Q8(t);
  return ke(HI, a);
}), PI = "div", NI = Le(
  function(t) {
    var a = t, l = Fe(a, ["store"]);
    return l = Q8(l), l;
  }
), VI = De(function(t) {
  const a = NI(t);
  return ke(PI, a);
}), BI = "div", X8 = Le(
  function(t) {
    const [a, l] = Qt();
    return t = Vn(
      t,
      (h) => /* @__PURE__ */ f.jsx(VE.Provider, { value: l, children: h }),
      []
    ), t = Q({
      role: "group",
      "aria-labelledby": a
    }, t), La(t);
  }
), FI = De(function(t) {
  const a = X8(t);
  return ke(BI, a);
}), UI = "div", BE = Le(
  function(t) {
    var a = t, l = Fe(a, ["store"]);
    return l = X8(l), l;
  }
), YI = De(function(t) {
  const a = BE(t);
  return ke(UI, a);
}), $I = "input", WI = Le(
  function(t) {
    var a = t, { store: l, name: h } = a, g = Fe(a, ["store", "name"]);
    const m = Ro();
    l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component."
    );
    const S = `${h}`, b = g.onChange, R = nt((T) => {
      b == null || b(T), !T.defaultPrevented && (l == null || l.setValue(S, T.target.value));
    }), D = l.useValue(S);
    return g = Oe(Q({
      value: D
    }, g), {
      onChange: R
    }), g = F2(g), g = Y4(Q({ store: l, name: S }, g)), g;
  }
), J8 = Ha(
  De(function(t) {
    const a = WI(t);
    return ke($I, a);
  })
), zI = "label";
function qI(e) {
  return e === "input" || e === "textarea" || e === "select" || e === "meter" || e === "progress";
}
var GI = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      getItem: g
    } = a, m = Fe(a, [
      "store",
      "name",
      "getItem"
    ]);
    const S = Ro();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormLabel must be wrapped in a Form component."
    );
    const b = Ia(m.id), R = Pt(null), D = `${h}`, T = Ir(
      (F) => {
        const Y = Oe(Q({}, F), { id: b || F.id, name: D, type: "label" });
        return g ? g(Y) : Y;
      },
      [b, D, g]
    ), j = l.useState(
      (F) => F.items.find((Y) => Y.type === "field" && Y.name === D)
    ), A = mh(j == null ? void 0 : j.element, "input"), L = qI(A), P = m.onClick, N = nt((F) => {
      if (P == null || P(F), F.defaultPrevented || L)
        return;
      const Y = j == null ? void 0 : j.element;
      Y && queueMicrotask(() => {
        const G = B5(Y, !0, !0);
        G == null || G.focus(), G == null || G.click();
      });
    });
    return m = Oe(Q({
      id: b,
      render: L ? /* @__PURE__ */ f.jsx("label", {}) : /* @__PURE__ */ f.jsx("span", {}),
      htmlFor: L ? j == null ? void 0 : j.id : void 0
    }, m), {
      ref: Ln(R, m.ref),
      onClick: N
    }), L || (m = Oe(Q({}, m), {
      style: Q({
        cursor: "default"
      }, m.style)
    })), m = wh(Oe(Q({ store: l }, m), { getItem: T })), m;
  }
), FE = Ha(
  De(function(t) {
    const a = GI(t);
    return ke(zI, a);
  })
), KI = "button";
function QI(e, t) {
  if (!e)
    return [];
  const a = [];
  for (const l of e) {
    if (l.type !== "field" || !l.name.startsWith(t))
      continue;
    const h = l.name.replace(/(\.\d+)\..+$/, "$1"), g = new RegExp(`^${h}`);
    a.some((m) => g.test(m.name)) || a.push(l);
  }
  return a;
}
var XI = Le(
  function(t) {
    var a = t, {
      store: l,
      value: h,
      name: g,
      getItem: m,
      autoFocusOnClick: S = !0
    } = a, b = Fe(a, [
      "store",
      "value",
      "name",
      "getItem",
      "autoFocusOnClick"
    ]);
    const R = Ro();
    l = l || R, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormPush must be wrapped in a Form component."
    );
    const D = `${g}`, [T, j] = Qt(!1);
    gt(() => {
      var N;
      if (!T)
        return;
      const F = QI(l == null ? void 0 : l.getState().items, D), Y = (N = F == null ? void 0 : F[F.length - 1]) == null ? void 0 : N.element;
      Y && (Y.focus(), j(!1));
    }, [l, T, D]);
    const A = Ir(
      (N) => {
        const F = Oe(Q({}, N), { type: "button", name: D });
        return m ? m(F) : F;
      },
      [D, m]
    ), L = b.onClick, P = nt((N) => {
      L == null || L(N), !N.defaultPrevented && (l == null || l.pushValue(D, h), S && j(!0));
    });
    return b = Oe(Q({}, b), {
      onClick: P
    }), b = yh(b), b = wh(Oe(Q({ store: l }, b), { getItem: A })), b;
  }
), JI = De(function(t) {
  const a = XI(t);
  return ke(KI, a);
}), eH = "div", tH = Le(
  function(t) {
    var a = t, l = Fe(a, ["store"]);
    return l = Q({ role: "radiogroup" }, l), l = BE(l), l;
  }
), nH = De(function(t) {
  const a = tH(t);
  return ke(eH, a);
}), $5 = bl(
  [U8],
  [Y8]
), U2 = $5.useContext, rH = $5.useProviderContext, Z0 = $5.ContextProvider, xh = $5.ScopedContextProvider, aH = ka(
  void 0
), UE = ka(
  void 0
), W5 = bl(
  [Z0],
  [xh]
), YE = W5.useContext, iH = W5.useProviderContext, lH = W5.ContextProvider, oH = W5.ScopedContextProvider, uH = { id: null };
function sH(e, t, a = !1) {
  const l = e.findIndex((h) => h.id === t);
  return [
    ...e.slice(l + 1),
    ...a ? [uH] : [],
    ...e.slice(0, l)
  ];
}
function cH(e, t) {
  return e.find((a) => !a.disabled);
}
function ih(e, t) {
  return t && e.item(t) || null;
}
function fH(e) {
  const t = [];
  for (const a of e) {
    const l = t.find((h) => {
      var g;
      return ((g = h[0]) == null ? void 0 : g.rowId) === a.rowId;
    });
    l ? l.push(a) : t.push([a]);
  }
  return t;
}
function $E(e, t = !1) {
  if (bo(e))
    e.setSelectionRange(
      t ? e.value.length : 0,
      e.value.length
    );
  else if (e.isContentEditable) {
    const a = Qr(e).getSelection();
    a == null || a.selectAllChildren(e), t && (a == null || a.collapseToEnd());
  }
}
var Jy = Symbol("FOCUS_SILENTLY");
function dH(e) {
  e[Jy] = !0, e.focus({ preventScroll: !0 });
}
function hH(e) {
  const t = e[Jy];
  return delete e[Jy], t;
}
function O4(e, t, a) {
  return !(!t || t === a || !e.item(t.id));
}
var vH = "button";
function pH(e) {
  return qy(e) ? !0 : e.tagName === "INPUT" && !k0(e);
}
function mH(e, t = !1) {
  const a = e.clientHeight, { top: l } = e.getBoundingClientRect(), h = Math.max(a * 0.875, a - 40) * 1.5, g = t ? a - h + l : h + l;
  return e.tagName === "HTML" ? g + e.scrollTop : g;
}
function gH(e, t = !1) {
  const { top: a } = e.getBoundingClientRect();
  return t ? a + e.clientHeight : a;
}
function I_(e, t, a, l = !1) {
  var h;
  if (!t || !a)
    return;
  const { renderedItems: g } = t.getState(), m = L8(e);
  if (!m)
    return;
  const S = mH(m, l);
  let b, R;
  for (let D = 0; D < g.length; D += 1) {
    const T = b;
    if (b = a(D), !b)
      break;
    if (b === T)
      continue;
    const j = (h = ih(t, b)) == null ? void 0 : h.element;
    if (!j)
      continue;
    const L = gH(j, l) - S, P = Math.abs(L);
    if (l && L <= 0 || !l && L >= 0) {
      R !== void 0 && R < P && (b = T);
      break;
    }
    R = P;
  }
  return b;
}
function wH(e, t) {
  return Sl(e) ? !1 : O4(t, e.target);
}
function yH(e, t) {
  const a = t.role, [l, h] = Qt(a);
  return kn(() => {
    const g = e.current;
    g && h(g.getAttribute("role") || a);
  }, [a]), l;
}
function xH(e) {
  return e === "option" || e === "treeitem";
}
function SH(e) {
  return e === "option" || e === "tab" || e === "treeitem" || e === "gridcell" || e === "row" || e === "columnheader" || e === "rowheader";
}
var Y2 = Le(
  function(t) {
    var a = t, {
      store: l,
      rowId: h,
      preventScrollOnKeyDown: g = !1,
      moveOnKeyPress: m = !0,
      tabbable: S = !1,
      getItem: b,
      "aria-setsize": R,
      "aria-posinset": D
    } = a, T = Fe(a, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "tabbable",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]);
    const j = U2();
    l = l || j;
    const A = Ia(T.id), L = Pt(null), P = Ui(UE), N = ja(l, (Ze) => {
      if (h)
        return h;
      if (Ze && P != null && P.baseElement && P.baseElement === Ze.baseElement)
        return P.id;
    }), Y = pf(T) && !T.accessibleWhenDisabled, G = Ir(
      (Ze) => {
        const Nt = Oe(Q({}, Ze), {
          id: A || Ze.id,
          rowId: N,
          disabled: !!Y
        });
        return b ? b(Nt) : Nt;
      },
      [A, N, Y, b]
    ), z = T.onFocus, $ = Pt(!1), ce = nt((Ze) => {
      if (z == null || z(Ze), Ze.defaultPrevented || mE(Ze) || !A || !l || wH(Ze, l))
        return;
      const { virtualFocus: Nt, baseElement: kt } = l.getState();
      if (l.setActiveId(A), qy(Ze.currentTarget) && $E(Ze.currentTarget), !Nt || !Sl(Ze) || pH(Ze.currentTarget) || !(kt != null && kt.isConnected))
        return;
      $.current = !0, Ze.relatedTarget === kt || O4(l, Ze.relatedTarget) ? dH(kt) : kt.focus();
    }), X = T.onBlurCapture, Ce = nt((Ze) => {
      if (X == null || X(Ze), Ze.defaultPrevented)
        return;
      const Nt = l == null ? void 0 : l.getState();
      Nt != null && Nt.virtualFocus && $.current && ($.current = !1, Ze.preventDefault(), Ze.stopPropagation());
    }), ae = T.onKeyDown, me = Jn(g), K = Jn(m), we = nt((Ze) => {
      if (ae == null || ae(Ze), Ze.defaultPrevented || !Sl(Ze) || !l)
        return;
      const { currentTarget: Nt } = Ze, kt = l.getState(), Qe = l.item(A), rt = !!(Qe != null && Qe.rowId), vt = kt.orientation !== "horizontal", Ot = kt.orientation !== "vertical", yn = () => !!(rt || Ot || !kt.baseElement || !bo(kt.baseElement)), In = {
        ArrowUp: (rt || vt) && l.up,
        ArrowRight: (rt || Ot) && l.next,
        ArrowDown: (rt || vt) && l.down,
        ArrowLeft: (rt || Ot) && l.previous,
        Home: () => {
          if (yn())
            return !rt || Ze.ctrlKey ? l == null ? void 0 : l.first() : l == null ? void 0 : l.previous(-1);
        },
        End: () => {
          if (yn())
            return !rt || Ze.ctrlKey ? l == null ? void 0 : l.last() : l == null ? void 0 : l.next(-1);
        },
        PageUp: () => I_(Nt, l, l == null ? void 0 : l.up, !0),
        PageDown: () => I_(Nt, l, l == null ? void 0 : l.down)
      }[Ze.key];
      if (In) {
        if (qy(Nt)) {
          const er = Gy(Nt), wr = Ot && Ze.key === "ArrowLeft", ea = Ot && Ze.key === "ArrowRight", Ca = vt && Ze.key === "ArrowUp", Hr = vt && Ze.key === "ArrowDown";
          if (ea || Hr) {
            const { length: xt } = fL(Nt);
            if (er.end !== xt)
              return;
          } else if ((wr || Ca) && er.start !== 0)
            return;
        }
        const zn = In();
        if (me(Ze) || zn !== void 0) {
          if (!K(Ze))
            return;
          Ze.preventDefault(), l.move(zn);
        }
      }
    }), ue = ja(
      l,
      (Ze) => (Ze == null ? void 0 : Ze.baseElement) || void 0
    ), ge = Ur(
      () => ({ id: A, baseElement: ue }),
      [A, ue]
    );
    T = Vn(
      T,
      (Ze) => /* @__PURE__ */ f.jsx(aH.Provider, { value: ge, children: Ze }),
      [ge]
    );
    const Te = ja(
      l,
      (Ze) => !!Ze && Ze.activeId === A
    ), be = ja(l, "virtualFocus"), Ue = yH(L, T);
    let le;
    Te && (xH(Ue) || be && SH(Ue)) && (le = !0);
    const _e = ja(l, (Ze) => {
      if (R != null)
        return R;
      if (Ze && P != null && P.ariaSetSize && P.baseElement === Ze.baseElement)
        return P.ariaSetSize;
    }), Pe = ja(l, (Ze) => {
      if (D != null)
        return D;
      if (!Ze || !(P != null && P.ariaPosInSet) || P.baseElement !== Ze.baseElement)
        return;
      const Nt = Ze.renderedItems.filter(
        (kt) => kt.rowId === N
      );
      return P.ariaPosInSet + Nt.findIndex((kt) => kt.id === A);
    }), mt = ja(l, (Ze) => Ze != null && Ze.renderedItems.length ? Ze.virtualFocus ? !1 : S ? !0 : Ze.activeId === A : !0);
    return T = Oe(Q({
      id: A,
      "aria-selected": le,
      "data-active-item": Te || void 0
    }, T), {
      ref: Ln(L, T.ref),
      tabIndex: mt ? T.tabIndex : -1,
      onFocus: ce,
      onBlurCapture: Ce,
      onKeyDown: we
    }), T = F5(T), T = wh(Oe(Q({
      store: l
    }, T), {
      getItem: G,
      shouldRegisterItem: A ? T.shouldRegisterItem : !1
    })), La(Oe(Q({}, T), {
      "aria-setsize": _e,
      "aria-posinset": Pe
    }));
  }
), e8 = Ha(
  De(function(t) {
    const a = Y2(t);
    return ke(vH, a);
  })
), WE = "input";
function CH(e, t) {
  if (t !== void 0)
    return e != null && t != null ? t === e : !!t;
}
function bH(e, t) {
  return e === "input" && (!t || t === "radio");
}
var ex = Le(function(t) {
  var a = t, {
    store: l,
    name: h,
    value: g,
    checked: m
  } = a, S = Fe(a, [
    "store",
    "name",
    "value",
    "checked"
  ]);
  const b = YE();
  l = l || b;
  const R = Ia(S.id), D = Pt(null), T = ja(
    l,
    (X) => m ?? CH(g, X == null ? void 0 : X.value)
  );
  gt(() => {
    !R || !T || (l == null ? void 0 : l.getState().activeId) === R || l == null || l.setActiveId(R);
  }, [l, T, R]);
  const j = S.onChange, A = mh(D, WE), L = bH(A, S.type), P = pf(S), [N, F] = Z5();
  gt(() => {
    const X = D.current;
    X && (L || (T !== void 0 && (X.checked = T), h !== void 0 && (X.name = h), g !== void 0 && (X.value = `${g}`)));
  }, [N, L, T, h, g]);
  const Y = nt((X) => {
    if (P) {
      X.preventDefault(), X.stopPropagation();
      return;
    }
    L || (X.currentTarget.checked = !0, F()), j == null || j(X), !X.defaultPrevented && (l == null || l.setValue(g));
  }), G = S.onClick, z = nt((X) => {
    G == null || G(X), !X.defaultPrevented && (L || Y(X));
  }), $ = S.onFocus, ce = nt((X) => {
    if ($ == null || $(X), X.defaultPrevented || !L || !l)
      return;
    const { moves: Ce, activeId: ae } = l.getState();
    Ce && (R && ae !== R || Y(X));
  });
  return S = Oe(Q({
    id: R,
    role: L ? void 0 : "radio",
    type: L ? "radio" : void 0,
    "aria-checked": T
  }, S), {
    ref: Ln(D, S.ref),
    onChange: Y,
    onClick: z,
    onFocus: ce
  }), S = Y2(Q({
    store: l,
    clickOnEnter: !L
  }, S)), La(Q({
    name: L ? h : void 0,
    value: L ? g : void 0,
    checked: T
  }, S));
}), zE = Ha(
  De(function(t) {
    const a = ex(t);
    return ke(WE, a);
  })
), _H = "input", RH = Le(
  function(t) {
    var a = t, { store: l, name: h, value: g } = a, m = Fe(a, ["store", "name", "value"]);
    const S = Ro();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormRadio must be wrapped in a Form component."
    );
    const b = `${h}`, R = m.onChange, D = nt((A) => {
      R == null || R(A), !A.defaultPrevented && (l == null || l.setValue(b, g));
    }), T = m.checked, j = l.useState(
      () => T ?? (l == null ? void 0 : l.getValue(b)) === g
    );
    return m = Oe(Q({}, m), {
      checked: j,
      onChange: D
    }), m = ex(Q({ value: g }, m)), m = Y4(Q({
      store: l,
      name: b,
      "aria-labelledby": void 0
    }, m)), m;
  }
), EH = Ha(
  De(function(t) {
    const a = RH(t);
    return ke(_H, a);
  })
), MH = "button";
function TH(e, t, a) {
  const l = e == null ? void 0 : e.filter(
    (m) => m.type === "field" && m.name.startsWith(t)
  ), h = new RegExp(`^${t}\\.(\\d+)`), g = l == null ? void 0 : l.find((m) => {
    const S = m.name.replace(h, "$1");
    return parseInt(S) > a;
  });
  return g || (l == null ? void 0 : l.reverse().find((m) => {
    const S = m.name.replace(h, "$1");
    return parseInt(S) < a;
  }));
}
function OH(e, t) {
  return e == null ? void 0 : e.find((a) => a.type === "button" && a.name === t);
}
var DH = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      index: g,
      autoFocusOnClick: m = !0
    } = a, S = Fe(a, [
      "store",
      "name",
      "index",
      "autoFocusOnClick"
    ]);
    const b = Ro();
    l = l || b, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormRemove must be wrapped in a Form component."
    );
    const R = `${h}`, D = S.onClick, T = nt((j) => {
      var A;
      if (D == null || D(j), j.defaultPrevented || !l || (l.removeValue(R, g), !m))
        return;
      const { items: L } = l.getState(), P = TH(L, R, g), N = P == null ? void 0 : P.element;
      if (N)
        N.focus(), bo(N) && N.select();
      else {
        const F = OH(L, R);
        (A = F == null ? void 0 : F.element) == null || A.focus();
      }
    });
    return S = Oe(Q({}, S), {
      onClick: T
    }), S = yh(S), S;
  }
), jH = De(function(t) {
  const a = DH(t);
  return ke(MH, a);
}), AH = "button", kH = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = Ro();
    return l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormReset must be wrapped in a Form component."
    ), h = Q({
      type: "reset",
      disabled: l.useState("submitting")
    }, h), h = yh(h), h;
  }
), LH = De(function(t) {
  const a = kH(t);
  return ke(AH, a);
}), IH = "button", HH = Le(
  function(t) {
    var a = t, { store: l, accessibleWhenDisabled: h = !0 } = a, g = Fe(a, ["store", "accessibleWhenDisabled"]);
    const m = Ro();
    return l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "FormSubmit must be wrapped in a Form component."
    ), g = Q({
      type: "submit",
      disabled: l.useState("submitting")
    }, g), g = yh(Oe(Q({}, g), { accessibleWhenDisabled: h })), g;
  }
), qE = De(function(t) {
  const a = HH(t);
  return ke(IH, a);
}), ZH = "span", tx = Le(
  function(t) {
    return t = Oe(Q({}, t), {
      style: Q({
        border: 0,
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
      }, t.style)
    }), t;
  }
), PH = De(function(t) {
  const a = tx(t);
  return ke(ZH, a);
}), NH = "span", VH = Le(
  function(t) {
    return t = Oe(Q({
      "data-focus-trap": "",
      tabIndex: 0,
      "aria-hidden": !0
    }, t), {
      style: Q({
        // Prevents unintended scroll jumps.
        position: "fixed",
        top: 0,
        left: 0
      }, t.style)
    }), t = tx(t), t;
  }
), Sp = De(function(t) {
  const a = VH(t);
  return ke(NH, a);
}), BH = "div", FH = Le(
  function(t) {
    var a = t, { enabled: l = !1 } = a, h = Fe(a, ["enabled"]);
    const g = Pt(null);
    return h = Vn(
      h,
      (m) => {
        const S = () => l ? /* @__PURE__ */ f.jsx(
          Sp,
          {
            onFocus: (b) => {
              const R = g.current;
              if (!R)
                return;
              const D = Ip(R, !0), T = D[0], j = D[D.length - 1];
              if (!D.length) {
                R.focus();
                return;
              }
              b.relatedTarget === T ? j == null || j.focus() : T == null || T.focus();
            }
          }
        ) : null;
        return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          S(),
          m,
          S()
        ] });
      },
      [l]
    ), h = Oe(Q({}, h), {
      ref: Ln(g, h.ref)
    }), La(h);
  }
), UH = De(function(t) {
  const a = FH(t);
  return ke(BH, a);
});
function GE(e = {}) {
  const t = Lp(
    e.store,
    Op(e.disclosure, ["contentElement", "disclosureElement"])
  );
  gh(e, t);
  const a = t == null ? void 0 : t.getState(), l = st(
    e.open,
    a == null ? void 0 : a.open,
    e.defaultOpen,
    !1
  ), h = st(e.animated, a == null ? void 0 : a.animated, !1), g = {
    open: l,
    animated: h,
    animating: !!h && l,
    mounted: l,
    contentElement: st(a == null ? void 0 : a.contentElement, null),
    disclosureElement: st(a == null ? void 0 : a.disclosureElement, null)
  }, m = fi(g, t);
  return Aa(
    m,
    () => xa(m, ["animated", "animating"], (S) => {
      S.animated || m.setState("animating", !1);
    })
  ), Aa(
    m,
    () => CE(m, ["open"], () => {
      m.getState().animated && m.setState("animating", !0);
    })
  ), Aa(
    m,
    () => xa(m, ["open", "animating"], (S) => {
      m.setState("mounted", S.open || S.animating);
    })
  ), gn(_t({}, m), {
    disclosure: e.disclosure,
    setOpen: (S) => m.setState("open", S),
    show: () => m.setState("open", !0),
    hide: () => m.setState("open", !1),
    toggle: () => m.setState("open", (S) => !S),
    stopAnimation: () => m.setState("animating", !1),
    setContentElement: (S) => m.setState("contentElement", S),
    setDisclosureElement: (S) => m.setState("disclosureElement", S)
  });
}
function KE(e, t, a) {
  return b1(t, [a.store, a.disclosure]), lr(e, a, "open", "setOpen"), lr(e, a, "mounted", "setMounted"), lr(e, a, "animated"), Object.assign(e, { disclosure: a.disclosure });
}
function z5(e = {}) {
  const [t, a] = Cl(GE, e);
  return KE(t, a, e);
}
var q5 = bl(), YH = q5.useContext, nx = q5.useProviderContext, QE = q5.ContextProvider, $H = q5.ScopedContextProvider, WH = "button", zH = Symbol("disclosure"), XE = Le(
  function(t) {
    var a = t, { store: l, toggleOnClick: h = !0 } = a, g = Fe(a, ["store", "toggleOnClick"]);
    const m = nx();
    l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component."
    );
    const S = Pt(null), [b, R] = Qt(!1), D = l.useState("disclosureElement"), T = l.useState("open");
    gt(() => {
      let Y = D === S.current;
      D != null && D.isConnected || (l == null || l.setDisclosureElement(S.current), Y = !0), R(T && Y);
    }, [D, l, T]);
    const j = g.onClick, A = Jn(h), [L, P] = xE(g, zH, !0), N = nt((Y) => {
      j == null || j(Y), !Y.defaultPrevented && (L || A(Y) && (l == null || l.setDisclosureElement(Y.currentTarget), l == null || l.toggle()));
    }), F = l.useState("contentElement");
    return g = Oe(Q(Q({
      "aria-expanded": b,
      "aria-controls": F == null ? void 0 : F.id
    }, P), g), {
      ref: Ln(S, g.ref),
      onClick: N
    }), g = yh(g), g;
  }
), qH = De(function(t) {
  const a = XE(t);
  return ke(WH, a);
});
function GH(e = {}) {
  const t = z5(e);
  return /* @__PURE__ */ f.jsx(QE, { value: t, children: e.children });
}
var $4 = bl(
  [QE],
  [$H]
), W4 = $4.useContext, KH = $4.useScopedContext, G5 = $4.useProviderContext, JE = $4.ContextProvider, rx = $4.ScopedContextProvider, eM = ka(void 0), tM = ka(void 0), t8 = { exports: {} }, Go = {}, a5 = { exports: {} }, My = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H_;
function QH() {
  return H_ || (H_ = 1, function(e) {
    function t(le, _e) {
      var Pe = le.length;
      le.push(_e);
      e: for (; 0 < Pe; ) {
        var mt = Pe - 1 >>> 1, Ze = le[mt];
        if (0 < h(Ze, _e)) le[mt] = _e, le[Pe] = Ze, Pe = mt;
        else break e;
      }
    }
    function a(le) {
      return le.length === 0 ? null : le[0];
    }
    function l(le) {
      if (le.length === 0) return null;
      var _e = le[0], Pe = le.pop();
      if (Pe !== _e) {
        le[0] = Pe;
        e: for (var mt = 0, Ze = le.length, Nt = Ze >>> 1; mt < Nt; ) {
          var kt = 2 * (mt + 1) - 1, Qe = le[kt], rt = kt + 1, vt = le[rt];
          if (0 > h(Qe, Pe)) rt < Ze && 0 > h(vt, Qe) ? (le[mt] = vt, le[rt] = Pe, mt = rt) : (le[mt] = Qe, le[kt] = Pe, mt = kt);
          else if (rt < Ze && 0 > h(vt, Pe)) le[mt] = vt, le[rt] = Pe, mt = rt;
          else break e;
        }
      }
      return _e;
    }
    function h(le, _e) {
      var Pe = le.sortIndex - _e.sortIndex;
      return Pe !== 0 ? Pe : le.id - _e.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var g = performance;
      e.unstable_now = function() {
        return g.now();
      };
    } else {
      var m = Date, S = m.now();
      e.unstable_now = function() {
        return m.now() - S;
      };
    }
    var b = [], R = [], D = 1, T = null, j = 3, A = !1, L = !1, P = !1, N = typeof setTimeout == "function" ? setTimeout : null, F = typeof clearTimeout == "function" ? clearTimeout : null, Y = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G(le) {
      for (var _e = a(R); _e !== null; ) {
        if (_e.callback === null) l(R);
        else if (_e.startTime <= le) l(R), _e.sortIndex = _e.expirationTime, t(b, _e);
        else break;
        _e = a(R);
      }
    }
    function z(le) {
      if (P = !1, G(le), !L) if (a(b) !== null) L = !0, be($);
      else {
        var _e = a(R);
        _e !== null && Ue(z, _e.startTime - le);
      }
    }
    function $(le, _e) {
      L = !1, P && (P = !1, F(Ce), Ce = -1), A = !0;
      var Pe = j;
      try {
        for (G(_e), T = a(b); T !== null && (!(T.expirationTime > _e) || le && !K()); ) {
          var mt = T.callback;
          if (typeof mt == "function") {
            T.callback = null, j = T.priorityLevel;
            var Ze = mt(T.expirationTime <= _e);
            _e = e.unstable_now(), typeof Ze == "function" ? T.callback = Ze : T === a(b) && l(b), G(_e);
          } else l(b);
          T = a(b);
        }
        if (T !== null) var Nt = !0;
        else {
          var kt = a(R);
          kt !== null && Ue(z, kt.startTime - _e), Nt = !1;
        }
        return Nt;
      } finally {
        T = null, j = Pe, A = !1;
      }
    }
    var ce = !1, X = null, Ce = -1, ae = 5, me = -1;
    function K() {
      return !(e.unstable_now() - me < ae);
    }
    function we() {
      if (X !== null) {
        var le = e.unstable_now();
        me = le;
        var _e = !0;
        try {
          _e = X(!0, le);
        } finally {
          _e ? ue() : (ce = !1, X = null);
        }
      } else ce = !1;
    }
    var ue;
    if (typeof Y == "function") ue = function() {
      Y(we);
    };
    else if (typeof MessageChannel < "u") {
      var ge = new MessageChannel(), Te = ge.port2;
      ge.port1.onmessage = we, ue = function() {
        Te.postMessage(null);
      };
    } else ue = function() {
      N(we, 0);
    };
    function be(le) {
      X = le, ce || (ce = !0, ue());
    }
    function Ue(le, _e) {
      Ce = N(function() {
        le(e.unstable_now());
      }, _e);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(le) {
      le.callback = null;
    }, e.unstable_continueExecution = function() {
      L || A || (L = !0, be($));
    }, e.unstable_forceFrameRate = function(le) {
      0 > le || 125 < le ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : ae = 0 < le ? Math.floor(1e3 / le) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return j;
    }, e.unstable_getFirstCallbackNode = function() {
      return a(b);
    }, e.unstable_next = function(le) {
      switch (j) {
        case 1:
        case 2:
        case 3:
          var _e = 3;
          break;
        default:
          _e = j;
      }
      var Pe = j;
      j = _e;
      try {
        return le();
      } finally {
        j = Pe;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(le, _e) {
      switch (le) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          le = 3;
      }
      var Pe = j;
      j = le;
      try {
        return _e();
      } finally {
        j = Pe;
      }
    }, e.unstable_scheduleCallback = function(le, _e, Pe) {
      var mt = e.unstable_now();
      switch (typeof Pe == "object" && Pe !== null ? (Pe = Pe.delay, Pe = typeof Pe == "number" && 0 < Pe ? mt + Pe : mt) : Pe = mt, le) {
        case 1:
          var Ze = -1;
          break;
        case 2:
          Ze = 250;
          break;
        case 5:
          Ze = 1073741823;
          break;
        case 4:
          Ze = 1e4;
          break;
        default:
          Ze = 5e3;
      }
      return Ze = Pe + Ze, le = { id: D++, callback: _e, priorityLevel: le, startTime: Pe, expirationTime: Ze, sortIndex: -1 }, Pe > mt ? (le.sortIndex = Pe, t(R, le), a(b) === null && le === a(R) && (P ? (F(Ce), Ce = -1) : P = !0, Ue(z, Pe - mt))) : (le.sortIndex = Ze, t(b, le), L || A || (L = !0, be($))), le;
    }, e.unstable_shouldYield = K, e.unstable_wrapCallback = function(le) {
      var _e = j;
      return function() {
        var Pe = j;
        j = _e;
        try {
          return le.apply(this, arguments);
        } finally {
          j = Pe;
        }
      };
    };
  }(My)), My;
}
var Ty = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z_;
function XH() {
  return Z_ || (Z_ = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = 5;
      function a(qe, wt) {
        var St = qe.length;
        qe.push(wt), g(qe, wt, St);
      }
      function l(qe) {
        return qe.length === 0 ? null : qe[0];
      }
      function h(qe) {
        if (qe.length === 0)
          return null;
        var wt = qe[0], St = qe.pop();
        return St !== wt && (qe[0] = St, m(qe, St, 0)), wt;
      }
      function g(qe, wt, St) {
        for (var un = St; un > 0; ) {
          var sr = un - 1 >>> 1, ta = qe[sr];
          if (S(ta, wt) > 0)
            qe[sr] = wt, qe[un] = ta, un = sr;
          else
            return;
        }
      }
      function m(qe, wt, St) {
        for (var un = St, sr = qe.length, ta = sr >>> 1; un < ta; ) {
          var xr = (un + 1) * 2 - 1, ji = qe[xr], wn = xr + 1, qn = qe[wn];
          if (S(ji, wt) < 0)
            wn < sr && S(qn, ji) < 0 ? (qe[un] = qn, qe[wn] = wt, un = wn) : (qe[un] = ji, qe[xr] = wt, un = xr);
          else if (wn < sr && S(qn, wt) < 0)
            qe[un] = qn, qe[wn] = wt, un = wn;
          else
            return;
        }
      }
      function S(qe, wt) {
        var St = qe.sortIndex - wt.sortIndex;
        return St !== 0 ? St : qe.id - wt.id;
      }
      var b = 1, R = 2, D = 3, T = 4, j = 5, A = typeof performance == "object" && typeof performance.now == "function";
      if (A) {
        var L = performance;
        e.unstable_now = function() {
          return L.now();
        };
      } else {
        var P = Date, N = P.now();
        e.unstable_now = function() {
          return P.now() - N;
        };
      }
      var F = 1073741823, Y = -1, G = 250, z = 5e3, $ = 1e4, ce = F, X = [], Ce = [], ae = 1, me = null, K = D, we = !1, ue = !1, ge = !1, Te = typeof setTimeout == "function" ? setTimeout : null, be = typeof clearTimeout == "function" ? clearTimeout : null, Ue = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function le(qe) {
        for (var wt = l(Ce); wt !== null; ) {
          if (wt.callback === null)
            h(Ce);
          else if (wt.startTime <= qe)
            h(Ce), wt.sortIndex = wt.expirationTime, a(X, wt);
          else
            return;
          wt = l(Ce);
        }
      }
      function _e(qe) {
        if (ge = !1, le(qe), !ue)
          if (l(X) !== null)
            ue = !0, yr(Pe);
          else {
            var wt = l(Ce);
            wt !== null && Xe(_e, wt.startTime - qe);
          }
      }
      function Pe(qe, wt) {
        ue = !1, ge && (ge = !1, Xt()), we = !0;
        var St = K;
        try {
          return mt(qe, wt);
        } finally {
          me = null, K = St, we = !1;
        }
      }
      function mt(qe, wt) {
        var St = wt;
        for (le(St), me = l(X); me !== null && !(me.expirationTime > St && (!qe || Ca())); ) {
          var un = me.callback;
          if (typeof un == "function") {
            me.callback = null, K = me.priorityLevel;
            var sr = me.expirationTime <= St, ta = un(sr);
            St = e.unstable_now(), typeof ta == "function" ? me.callback = ta : me === l(X) && h(X), le(St);
          } else
            h(X);
          me = l(X);
        }
        if (me !== null)
          return !0;
        var xr = l(Ce);
        return xr !== null && Xe(_e, xr.startTime - St), !1;
      }
      function Ze(qe, wt) {
        switch (qe) {
          case b:
          case R:
          case D:
          case T:
          case j:
            break;
          default:
            qe = D;
        }
        var St = K;
        K = qe;
        try {
          return wt();
        } finally {
          K = St;
        }
      }
      function Nt(qe) {
        var wt;
        switch (K) {
          case b:
          case R:
          case D:
            wt = D;
            break;
          default:
            wt = K;
            break;
        }
        var St = K;
        K = wt;
        try {
          return qe();
        } finally {
          K = St;
        }
      }
      function kt(qe) {
        var wt = K;
        return function() {
          var St = K;
          K = wt;
          try {
            return qe.apply(this, arguments);
          } finally {
            K = St;
          }
        };
      }
      function Qe(qe, wt, St) {
        var un = e.unstable_now(), sr;
        if (typeof St == "object" && St !== null) {
          var ta = St.delay;
          typeof ta == "number" && ta > 0 ? sr = un + ta : sr = un;
        } else
          sr = un;
        var xr;
        switch (qe) {
          case b:
            xr = Y;
            break;
          case R:
            xr = G;
            break;
          case j:
            xr = ce;
            break;
          case T:
            xr = $;
            break;
          case D:
          default:
            xr = z;
            break;
        }
        var ji = sr + xr, wn = {
          id: ae++,
          callback: wt,
          priorityLevel: qe,
          startTime: sr,
          expirationTime: ji,
          sortIndex: -1
        };
        return sr > un ? (wn.sortIndex = sr, a(Ce, wn), l(X) === null && wn === l(Ce) && (ge ? Xt() : ge = !0, Xe(_e, sr - un))) : (wn.sortIndex = ji, a(X, wn), !ue && !we && (ue = !0, yr(Pe))), wn;
      }
      function rt() {
      }
      function vt() {
        !ue && !we && (ue = !0, yr(Pe));
      }
      function Ot() {
        return l(X);
      }
      function yn(qe) {
        qe.callback = null;
      }
      function Ar() {
        return K;
      }
      var In = !1, zn = null, er = -1, wr = t, ea = -1;
      function Ca() {
        var qe = e.unstable_now() - ea;
        return !(qe < wr);
      }
      function Hr() {
      }
      function xt(qe) {
        if (qe < 0 || qe > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        qe > 0 ? wr = Math.floor(1e3 / qe) : wr = t;
      }
      var ln = function() {
        if (zn !== null) {
          var qe = e.unstable_now();
          ea = qe;
          var wt = !0, St = !0;
          try {
            St = zn(wt, qe);
          } finally {
            St ? dn() : (In = !1, zn = null);
          }
        } else
          In = !1;
      }, dn;
      if (typeof Ue == "function")
        dn = function() {
          Ue(ln);
        };
      else if (typeof MessageChannel < "u") {
        var Vt = new MessageChannel(), Rn = Vt.port2;
        Vt.port1.onmessage = ln, dn = function() {
          Rn.postMessage(null);
        };
      } else
        dn = function() {
          Te(ln, 0);
        };
      function yr(qe) {
        zn = qe, In || (In = !0, dn());
      }
      function Xe(qe, wt) {
        er = Te(function() {
          qe(e.unstable_now());
        }, wt);
      }
      function Xt() {
        be(er), er = -1;
      }
      var En = Hr, Cn = null;
      e.unstable_IdlePriority = j, e.unstable_ImmediatePriority = b, e.unstable_LowPriority = T, e.unstable_NormalPriority = D, e.unstable_Profiling = Cn, e.unstable_UserBlockingPriority = R, e.unstable_cancelCallback = yn, e.unstable_continueExecution = vt, e.unstable_forceFrameRate = xt, e.unstable_getCurrentPriorityLevel = Ar, e.unstable_getFirstCallbackNode = Ot, e.unstable_next = Nt, e.unstable_pauseExecution = rt, e.unstable_requestPaint = En, e.unstable_runWithPriority = Ze, e.unstable_scheduleCallback = Qe, e.unstable_shouldYield = Ca, e.unstable_wrapCallback = kt, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(Ty)), Ty;
}
var P_;
function nM() {
  return P_ || (P_ = 1, process.env.NODE_ENV === "production" ? a5.exports = QH() : a5.exports = XH()), a5.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N_;
function JH() {
  if (N_) return Go;
  N_ = 1;
  var e = Sa, t = nM();
  function a(i) {
    for (var o = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, v = 1; v < arguments.length; v++) o += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + i + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var l = /* @__PURE__ */ new Set(), h = {};
  function g(i, o) {
    m(i, o), m(i + "Capture", o);
  }
  function m(i, o) {
    for (h[i] = o, i = 0; i < o.length; i++) l.add(o[i]);
  }
  var S = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), b = Object.prototype.hasOwnProperty, R = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, D = {}, T = {};
  function j(i) {
    return b.call(T, i) ? !0 : b.call(D, i) ? !1 : R.test(i) ? T[i] = !0 : (D[i] = !0, !1);
  }
  function A(i, o, v, w) {
    if (v !== null && v.type === 0) return !1;
    switch (typeof o) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return w ? !1 : v !== null ? !v.acceptsBooleans : (i = i.toLowerCase().slice(0, 5), i !== "data-" && i !== "aria-");
      default:
        return !1;
    }
  }
  function L(i, o, v, w) {
    if (o === null || typeof o > "u" || A(i, o, v, w)) return !0;
    if (w) return !1;
    if (v !== null) switch (v.type) {
      case 3:
        return !o;
      case 4:
        return o === !1;
      case 5:
        return isNaN(o);
      case 6:
        return isNaN(o) || 1 > o;
    }
    return !1;
  }
  function P(i, o, v, w, C, E, Z) {
    this.acceptsBooleans = o === 2 || o === 3 || o === 4, this.attributeName = w, this.attributeNamespace = C, this.mustUseProperty = v, this.propertyName = i, this.type = o, this.sanitizeURL = E, this.removeEmptyString = Z;
  }
  var N = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    N[i] = new P(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var o = i[0];
    N[o] = new P(o, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    N[i] = new P(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    N[i] = new P(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    N[i] = new P(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    N[i] = new P(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    N[i] = new P(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    N[i] = new P(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    N[i] = new P(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var F = /[\-:]([a-z])/g;
  function Y(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var o = i.replace(
      F,
      Y
    );
    N[o] = new P(o, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var o = i.replace(F, Y);
    N[o] = new P(o, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var o = i.replace(F, Y);
    N[o] = new P(o, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    N[i] = new P(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), N.xlinkHref = new P("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    N[i] = new P(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  function G(i, o, v, w) {
    var C = N.hasOwnProperty(o) ? N[o] : null;
    (C !== null ? C.type !== 0 : w || !(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (L(o, v, C, w) && (v = null), w || C === null ? j(o) && (v === null ? i.removeAttribute(o) : i.setAttribute(o, "" + v)) : C.mustUseProperty ? i[C.propertyName] = v === null ? C.type === 3 ? !1 : "" : v : (o = C.attributeName, w = C.attributeNamespace, v === null ? i.removeAttribute(o) : (C = C.type, v = C === 3 || C === 4 && v === !0 ? "" : "" + v, w ? i.setAttributeNS(w, o, v) : i.setAttribute(o, v))));
  }
  var z = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ = Symbol.for("react.element"), ce = Symbol.for("react.portal"), X = Symbol.for("react.fragment"), Ce = Symbol.for("react.strict_mode"), ae = Symbol.for("react.profiler"), me = Symbol.for("react.provider"), K = Symbol.for("react.context"), we = Symbol.for("react.forward_ref"), ue = Symbol.for("react.suspense"), ge = Symbol.for("react.suspense_list"), Te = Symbol.for("react.memo"), be = Symbol.for("react.lazy"), Ue = Symbol.for("react.offscreen"), le = Symbol.iterator;
  function _e(i) {
    return i === null || typeof i != "object" ? null : (i = le && i[le] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var Pe = Object.assign, mt;
  function Ze(i) {
    if (mt === void 0) try {
      throw Error();
    } catch (v) {
      var o = v.stack.trim().match(/\n( *(at )?)/);
      mt = o && o[1] || "";
    }
    return `
` + mt + i;
  }
  var Nt = !1;
  function kt(i, o) {
    if (!i || Nt) return "";
    Nt = !0;
    var v = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (o) if (o = function() {
        throw Error();
      }, Object.defineProperty(o.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(o, []);
        } catch (xe) {
          var w = xe;
        }
        Reflect.construct(i, [], o);
      } else {
        try {
          o.call();
        } catch (xe) {
          w = xe;
        }
        i.call(o.prototype);
      }
      else {
        try {
          throw Error();
        } catch (xe) {
          w = xe;
        }
        i();
      }
    } catch (xe) {
      if (xe && w && typeof xe.stack == "string") {
        for (var C = xe.stack.split(`
`), E = w.stack.split(`
`), Z = C.length - 1, W = E.length - 1; 1 <= Z && 0 <= W && C[Z] !== E[W]; ) W--;
        for (; 1 <= Z && 0 <= W; Z--, W--) if (C[Z] !== E[W]) {
          if (Z !== 1 || W !== 1)
            do
              if (Z--, W--, 0 > W || C[Z] !== E[W]) {
                var ee = `
` + C[Z].replace(" at new ", " at ");
                return i.displayName && ee.includes("<anonymous>") && (ee = ee.replace("<anonymous>", i.displayName)), ee;
              }
            while (1 <= Z && 0 <= W);
          break;
        }
      }
    } finally {
      Nt = !1, Error.prepareStackTrace = v;
    }
    return (i = i ? i.displayName || i.name : "") ? Ze(i) : "";
  }
  function Qe(i) {
    switch (i.tag) {
      case 5:
        return Ze(i.type);
      case 16:
        return Ze("Lazy");
      case 13:
        return Ze("Suspense");
      case 19:
        return Ze("SuspenseList");
      case 0:
      case 2:
      case 15:
        return i = kt(i.type, !1), i;
      case 11:
        return i = kt(i.type.render, !1), i;
      case 1:
        return i = kt(i.type, !0), i;
      default:
        return "";
    }
  }
  function rt(i) {
    if (i == null) return null;
    if (typeof i == "function") return i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case X:
        return "Fragment";
      case ce:
        return "Portal";
      case ae:
        return "Profiler";
      case Ce:
        return "StrictMode";
      case ue:
        return "Suspense";
      case ge:
        return "SuspenseList";
    }
    if (typeof i == "object") switch (i.$$typeof) {
      case K:
        return (i.displayName || "Context") + ".Consumer";
      case me:
        return (i._context.displayName || "Context") + ".Provider";
      case we:
        var o = i.render;
        return i = i.displayName, i || (i = o.displayName || o.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
      case Te:
        return o = i.displayName || null, o !== null ? o : rt(i.type) || "Memo";
      case be:
        o = i._payload, i = i._init;
        try {
          return rt(i(o));
        } catch {
        }
    }
    return null;
  }
  function vt(i) {
    var o = i.type;
    switch (i.tag) {
      case 24:
        return "Cache";
      case 9:
        return (o.displayName || "Context") + ".Consumer";
      case 10:
        return (o._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return i = o.render, i = i.displayName || i.name || "", o.displayName || (i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return o;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return rt(o);
      case 8:
        return o === Ce ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof o == "function") return o.displayName || o.name || null;
        if (typeof o == "string") return o;
    }
    return null;
  }
  function Ot(i) {
    switch (typeof i) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return i;
      case "object":
        return i;
      default:
        return "";
    }
  }
  function yn(i) {
    var o = i.type;
    return (i = i.nodeName) && i.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function Ar(i) {
    var o = yn(i) ? "checked" : "value", v = Object.getOwnPropertyDescriptor(i.constructor.prototype, o), w = "" + i[o];
    if (!i.hasOwnProperty(o) && typeof v < "u" && typeof v.get == "function" && typeof v.set == "function") {
      var C = v.get, E = v.set;
      return Object.defineProperty(i, o, { configurable: !0, get: function() {
        return C.call(this);
      }, set: function(Z) {
        w = "" + Z, E.call(this, Z);
      } }), Object.defineProperty(i, o, { enumerable: v.enumerable }), { getValue: function() {
        return w;
      }, setValue: function(Z) {
        w = "" + Z;
      }, stopTracking: function() {
        i._valueTracker = null, delete i[o];
      } };
    }
  }
  function In(i) {
    i._valueTracker || (i._valueTracker = Ar(i));
  }
  function zn(i) {
    if (!i) return !1;
    var o = i._valueTracker;
    if (!o) return !0;
    var v = o.getValue(), w = "";
    return i && (w = yn(i) ? i.checked ? "true" : "false" : i.value), i = w, i !== v ? (o.setValue(i), !0) : !1;
  }
  function er(i) {
    if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u") return null;
    try {
      return i.activeElement || i.body;
    } catch {
      return i.body;
    }
  }
  function wr(i, o) {
    var v = o.checked;
    return Pe({}, o, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: v ?? i._wrapperState.initialChecked });
  }
  function ea(i, o) {
    var v = o.defaultValue == null ? "" : o.defaultValue, w = o.checked != null ? o.checked : o.defaultChecked;
    v = Ot(o.value != null ? o.value : v), i._wrapperState = { initialChecked: w, initialValue: v, controlled: o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null };
  }
  function Ca(i, o) {
    o = o.checked, o != null && G(i, "checked", o, !1);
  }
  function Hr(i, o) {
    Ca(i, o);
    var v = Ot(o.value), w = o.type;
    if (v != null) w === "number" ? (v === 0 && i.value === "" || i.value != v) && (i.value = "" + v) : i.value !== "" + v && (i.value = "" + v);
    else if (w === "submit" || w === "reset") {
      i.removeAttribute("value");
      return;
    }
    o.hasOwnProperty("value") ? ln(i, o.type, v) : o.hasOwnProperty("defaultValue") && ln(i, o.type, Ot(o.defaultValue)), o.checked == null && o.defaultChecked != null && (i.defaultChecked = !!o.defaultChecked);
  }
  function xt(i, o, v) {
    if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
      var w = o.type;
      if (!(w !== "submit" && w !== "reset" || o.value !== void 0 && o.value !== null)) return;
      o = "" + i._wrapperState.initialValue, v || o === i.value || (i.value = o), i.defaultValue = o;
    }
    v = i.name, v !== "" && (i.name = ""), i.defaultChecked = !!i._wrapperState.initialChecked, v !== "" && (i.name = v);
  }
  function ln(i, o, v) {
    (o !== "number" || er(i.ownerDocument) !== i) && (v == null ? i.defaultValue = "" + i._wrapperState.initialValue : i.defaultValue !== "" + v && (i.defaultValue = "" + v));
  }
  var dn = Array.isArray;
  function Vt(i, o, v, w) {
    if (i = i.options, o) {
      o = {};
      for (var C = 0; C < v.length; C++) o["$" + v[C]] = !0;
      for (v = 0; v < i.length; v++) C = o.hasOwnProperty("$" + i[v].value), i[v].selected !== C && (i[v].selected = C), C && w && (i[v].defaultSelected = !0);
    } else {
      for (v = "" + Ot(v), o = null, C = 0; C < i.length; C++) {
        if (i[C].value === v) {
          i[C].selected = !0, w && (i[C].defaultSelected = !0);
          return;
        }
        o !== null || i[C].disabled || (o = i[C]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Rn(i, o) {
    if (o.dangerouslySetInnerHTML != null) throw Error(a(91));
    return Pe({}, o, { value: void 0, defaultValue: void 0, children: "" + i._wrapperState.initialValue });
  }
  function yr(i, o) {
    var v = o.value;
    if (v == null) {
      if (v = o.children, o = o.defaultValue, v != null) {
        if (o != null) throw Error(a(92));
        if (dn(v)) {
          if (1 < v.length) throw Error(a(93));
          v = v[0];
        }
        o = v;
      }
      o == null && (o = ""), v = o;
    }
    i._wrapperState = { initialValue: Ot(v) };
  }
  function Xe(i, o) {
    var v = Ot(o.value), w = Ot(o.defaultValue);
    v != null && (v = "" + v, v !== i.value && (i.value = v), o.defaultValue == null && i.defaultValue !== v && (i.defaultValue = v)), w != null && (i.defaultValue = "" + w);
  }
  function Xt(i) {
    var o = i.textContent;
    o === i._wrapperState.initialValue && o !== "" && o !== null && (i.value = o);
  }
  function En(i) {
    switch (i) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Cn(i, o) {
    return i == null || i === "http://www.w3.org/1999/xhtml" ? En(o) : i === "http://www.w3.org/2000/svg" && o === "foreignObject" ? "http://www.w3.org/1999/xhtml" : i;
  }
  var qe, wt = function(i) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(o, v, w, C) {
      MSApp.execUnsafeLocalFunction(function() {
        return i(o, v, w, C);
      });
    } : i;
  }(function(i, o) {
    if (i.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in i) i.innerHTML = o;
    else {
      for (qe = qe || document.createElement("div"), qe.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>", o = qe.firstChild; i.firstChild; ) i.removeChild(i.firstChild);
      for (; o.firstChild; ) i.appendChild(o.firstChild);
    }
  });
  function St(i, o) {
    if (o) {
      var v = i.firstChild;
      if (v && v === i.lastChild && v.nodeType === 3) {
        v.nodeValue = o;
        return;
      }
    }
    i.textContent = o;
  }
  var un = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, sr = ["Webkit", "ms", "Moz", "O"];
  Object.keys(un).forEach(function(i) {
    sr.forEach(function(o) {
      o = o + i.charAt(0).toUpperCase() + i.substring(1), un[o] = un[i];
    });
  });
  function ta(i, o, v) {
    return o == null || typeof o == "boolean" || o === "" ? "" : v || typeof o != "number" || o === 0 || un.hasOwnProperty(i) && un[i] ? ("" + o).trim() : o + "px";
  }
  function xr(i, o) {
    i = i.style;
    for (var v in o) if (o.hasOwnProperty(v)) {
      var w = v.indexOf("--") === 0, C = ta(v, o[v], w);
      v === "float" && (v = "cssFloat"), w ? i.setProperty(v, C) : i[v] = C;
    }
  }
  var ji = Pe({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function wn(i, o) {
    if (o) {
      if (ji[i] && (o.children != null || o.dangerouslySetInnerHTML != null)) throw Error(a(137, i));
      if (o.dangerouslySetInnerHTML != null) {
        if (o.children != null) throw Error(a(60));
        if (typeof o.dangerouslySetInnerHTML != "object" || !("__html" in o.dangerouslySetInnerHTML)) throw Error(a(61));
      }
      if (o.style != null && typeof o.style != "object") throw Error(a(62));
    }
  }
  function qn(i, o) {
    if (i.indexOf("-") === -1) return typeof o.is == "string";
    switch (i) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var M1 = null;
  function _l(i) {
    return i = i.target || i.srcElement || window, i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === 3 ? i.parentNode : i;
  }
  var Jo = null, zl = null, Eo = null;
  function B0(i) {
    if (i = qt(i)) {
      if (typeof Jo != "function") throw Error(a(280));
      var o = i.stateNode;
      o && (o = Bs(o), Jo(i.stateNode, i.type, o));
    }
  }
  function T1(i) {
    zl ? Eo ? Eo.push(i) : Eo = [i] : zl = i;
  }
  function Cf() {
    if (zl) {
      var i = zl, o = Eo;
      if (Eo = zl = null, B0(i), o) for (i = 0; i < o.length; i++) B0(o[i]);
    }
  }
  function O1(i, o) {
    return i(o);
  }
  function Pu() {
  }
  var Mo = !1;
  function To(i, o, v) {
    if (Mo) return i(o, v);
    Mo = !0;
    try {
      return O1(i, o, v);
    } finally {
      Mo = !1, (zl !== null || Eo !== null) && (Pu(), Cf());
    }
  }
  function $i(i, o) {
    var v = i.stateNode;
    if (v === null) return null;
    var w = Bs(v);
    if (w === null) return null;
    v = w[o];
    e: switch (o) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (w = !w.disabled) || (i = i.type, w = !(i === "button" || i === "input" || i === "select" || i === "textarea")), i = !w;
        break e;
      default:
        i = !1;
    }
    if (i) return null;
    if (v && typeof v != "function") throw Error(a(231, o, typeof v));
    return v;
  }
  var Oo = !1;
  if (S) try {
    var eu = {};
    Object.defineProperty(eu, "passive", { get: function() {
      Oo = !0;
    } }), window.addEventListener("test", eu, eu), window.removeEventListener("test", eu, eu);
  } catch {
    Oo = !1;
  }
  function Ds(i, o, v, w, C, E, Z, W, ee) {
    var xe = Array.prototype.slice.call(arguments, 3);
    try {
      o.apply(v, xe);
    } catch (Ve) {
      this.onError(Ve);
    }
  }
  var tu = !1, ql = null, J = !1, $e = null, ft = { onError: function(i) {
    tu = !0, ql = i;
  } };
  function Et(i, o, v, w, C, E, Z, W, ee) {
    tu = !1, ql = null, Ds.apply(ft, arguments);
  }
  function Bn(i, o, v, w, C, E, Z, W, ee) {
    if (Et.apply(this, arguments), tu) {
      if (tu) {
        var xe = ql;
        tu = !1, ql = null;
      } else throw Error(a(198));
      J || (J = !0, $e = xe);
    }
  }
  function xn(i) {
    var o = i, v = i;
    if (i.alternate) for (; o.return; ) o = o.return;
    else {
      i = o;
      do
        o = i, o.flags & 4098 && (v = o.return), i = o.return;
      while (i);
    }
    return o.tag === 3 ? v : null;
  }
  function hn(i) {
    if (i.tag === 13) {
      var o = i.memoizedState;
      if (o === null && (i = i.alternate, i !== null && (o = i.memoizedState)), o !== null) return o.dehydrated;
    }
    return null;
  }
  function vn(i) {
    if (xn(i) !== i) throw Error(a(188));
  }
  function Za(i) {
    var o = i.alternate;
    if (!o) {
      if (o = xn(i), o === null) throw Error(a(188));
      return o !== i ? null : i;
    }
    for (var v = i, w = o; ; ) {
      var C = v.return;
      if (C === null) break;
      var E = C.alternate;
      if (E === null) {
        if (w = C.return, w !== null) {
          v = w;
          continue;
        }
        break;
      }
      if (C.child === E.child) {
        for (E = C.child; E; ) {
          if (E === v) return vn(C), i;
          if (E === w) return vn(C), o;
          E = E.sibling;
        }
        throw Error(a(188));
      }
      if (v.return !== w.return) v = C, w = E;
      else {
        for (var Z = !1, W = C.child; W; ) {
          if (W === v) {
            Z = !0, v = C, w = E;
            break;
          }
          if (W === w) {
            Z = !0, w = C, v = E;
            break;
          }
          W = W.sibling;
        }
        if (!Z) {
          for (W = E.child; W; ) {
            if (W === v) {
              Z = !0, v = E, w = C;
              break;
            }
            if (W === w) {
              Z = !0, w = E, v = C;
              break;
            }
            W = W.sibling;
          }
          if (!Z) throw Error(a(189));
        }
      }
      if (v.alternate !== w) throw Error(a(190));
    }
    if (v.tag !== 3) throw Error(a(188));
    return v.stateNode.current === v ? i : o;
  }
  function Rr(i) {
    return i = Za(i), i !== null ? Er(i) : null;
  }
  function Er(i) {
    if (i.tag === 5 || i.tag === 6) return i;
    for (i = i.child; i !== null; ) {
      var o = Er(i);
      if (o !== null) return o;
      i = i.sibling;
    }
    return null;
  }
  var di = t.unstable_scheduleCallback, hi = t.unstable_cancelCallback, Gt = t.unstable_shouldYield, na = t.unstable_requestPaint, Xn = t.unstable_now, bf = t.unstable_getCurrentPriorityLevel, D1 = t.unstable_ImmediatePriority, Mh = t.unstable_UserBlockingPriority, j1 = t.unstable_NormalPriority, Th = t.unstable_LowPriority, _f = t.unstable_IdlePriority, F0 = null, Do = null;
  function $p(i) {
    if (Do && typeof Do.onCommitFiberRoot == "function") try {
      Do.onCommitFiberRoot(F0, i, void 0, (i.current.flags & 128) === 128);
    } catch {
    }
  }
  var Wi = Math.clz32 ? Math.clz32 : Ef, Rf = Math.log, nu = Math.LN2;
  function Ef(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (Rf(i) / nu | 0) | 0;
  }
  var ru = 64, Mf = 4194304;
  function Nu(i) {
    switch (i & -i) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return i & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return i;
    }
  }
  function js(i, o) {
    var v = i.pendingLanes;
    if (v === 0) return 0;
    var w = 0, C = i.suspendedLanes, E = i.pingedLanes, Z = v & 268435455;
    if (Z !== 0) {
      var W = Z & ~C;
      W !== 0 ? w = Nu(W) : (E &= Z, E !== 0 && (w = Nu(E)));
    } else Z = v & ~C, Z !== 0 ? w = Nu(Z) : E !== 0 && (w = Nu(E));
    if (w === 0) return 0;
    if (o !== 0 && o !== w && !(o & C) && (C = w & -w, E = o & -o, C >= E || C === 16 && (E & 4194240) !== 0)) return o;
    if (w & 4 && (w |= v & 16), o = i.entangledLanes, o !== 0) for (i = i.entanglements, o &= w; 0 < o; ) v = 31 - Wi(o), C = 1 << v, w |= i[v], o &= ~C;
    return w;
  }
  function Tf(i, o) {
    switch (i) {
      case 1:
      case 2:
      case 4:
        return o + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Wp(i, o) {
    for (var v = i.suspendedLanes, w = i.pingedLanes, C = i.expirationTimes, E = i.pendingLanes; 0 < E; ) {
      var Z = 31 - Wi(E), W = 1 << Z, ee = C[Z];
      ee === -1 ? (!(W & v) || W & w) && (C[Z] = Tf(W, o)) : ee <= o && (i.expiredLanes |= W), E &= ~W;
    }
  }
  function A1(i) {
    return i = i.pendingLanes & -1073741825, i !== 0 ? i : i & 1073741824 ? 1073741824 : 0;
  }
  function Oh() {
    var i = ru;
    return ru <<= 1, !(ru & 4194240) && (ru = 64), i;
  }
  function k1(i) {
    for (var o = [], v = 0; 31 > v; v++) o.push(i);
    return o;
  }
  function U0(i, o, v) {
    i.pendingLanes |= o, o !== 536870912 && (i.suspendedLanes = 0, i.pingedLanes = 0), i = i.eventTimes, o = 31 - Wi(o), i[o] = v;
  }
  function Dh(i, o) {
    var v = i.pendingLanes & ~o;
    i.pendingLanes = o, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= o, i.mutableReadLanes &= o, i.entangledLanes &= o, o = i.entanglements;
    var w = i.eventTimes;
    for (i = i.expirationTimes; 0 < v; ) {
      var C = 31 - Wi(v), E = 1 << C;
      o[C] = 0, w[C] = -1, i[C] = -1, v &= ~E;
    }
  }
  function Hn(i, o) {
    var v = i.entangledLanes |= o;
    for (i = i.entanglements; v; ) {
      var w = 31 - Wi(v), C = 1 << w;
      C & o | i[w] & o && (i[w] |= o), v &= ~C;
    }
  }
  var Fn = 0;
  function Vu(i) {
    return i &= -i, 1 < i ? 4 < i ? i & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var en, Y0, Ai, As, ks, Of = !1, va = [], tr = null, Bu = null, Pa = null, Na = /* @__PURE__ */ new Map(), Rl = /* @__PURE__ */ new Map(), Fu = [], jh = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Ah(i, o) {
    switch (i) {
      case "focusin":
      case "focusout":
        tr = null;
        break;
      case "dragenter":
      case "dragleave":
        Bu = null;
        break;
      case "mouseover":
      case "mouseout":
        Pa = null;
        break;
      case "pointerover":
      case "pointerout":
        Na.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Rl.delete(o.pointerId);
    }
  }
  function Uu(i, o, v, w, C, E) {
    return i === null || i.nativeEvent !== E ? (i = { blockedOn: o, domEventName: v, eventSystemFlags: w, nativeEvent: E, targetContainers: [C] }, o !== null && (o = qt(o), o !== null && Y0(o)), i) : (i.eventSystemFlags |= w, o = i.targetContainers, C !== null && o.indexOf(C) === -1 && o.push(C), i);
  }
  function zp(i, o, v, w, C) {
    switch (o) {
      case "focusin":
        return tr = Uu(tr, i, o, v, w, C), !0;
      case "dragenter":
        return Bu = Uu(Bu, i, o, v, w, C), !0;
      case "mouseover":
        return Pa = Uu(Pa, i, o, v, w, C), !0;
      case "pointerover":
        var E = C.pointerId;
        return Na.set(E, Uu(Na.get(E) || null, i, o, v, w, C)), !0;
      case "gotpointercapture":
        return E = C.pointerId, Rl.set(E, Uu(Rl.get(E) || null, i, o, v, w, C)), !0;
    }
    return !1;
  }
  function z2(i) {
    var o = cr(i.target);
    if (o !== null) {
      var v = xn(o);
      if (v !== null) {
        if (o = v.tag, o === 13) {
          if (o = hn(v), o !== null) {
            i.blockedOn = o, ks(i.priority, function() {
              Ai(v);
            });
            return;
          }
        } else if (o === 3 && v.stateNode.current.memoizedState.isDehydrated) {
          i.blockedOn = v.tag === 3 ? v.stateNode.containerInfo : null;
          return;
        }
      }
    }
    i.blockedOn = null;
  }
  function Df(i) {
    if (i.blockedOn !== null) return !1;
    for (var o = i.targetContainers; 0 < o.length; ) {
      var v = G0(i.domEventName, i.eventSystemFlags, o[0], i.nativeEvent);
      if (v === null) {
        v = i.nativeEvent;
        var w = new v.constructor(v.type, v);
        M1 = w, v.target.dispatchEvent(w), M1 = null;
      } else return o = qt(v), o !== null && Y0(o), i.blockedOn = v, !1;
      o.shift();
    }
    return !0;
  }
  function $0(i, o, v) {
    Df(i) && v.delete(o);
  }
  function q2() {
    Of = !1, tr !== null && Df(tr) && (tr = null), Bu !== null && Df(Bu) && (Bu = null), Pa !== null && Df(Pa) && (Pa = null), Na.forEach($0), Rl.forEach($0);
  }
  function Zn(i, o) {
    i.blockedOn === o && (i.blockedOn = null, Of || (Of = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, q2)));
  }
  function Un(i) {
    function o(C) {
      return Zn(C, i);
    }
    if (0 < va.length) {
      Zn(va[0], i);
      for (var v = 1; v < va.length; v++) {
        var w = va[v];
        w.blockedOn === i && (w.blockedOn = null);
      }
    }
    for (tr !== null && Zn(tr, i), Bu !== null && Zn(Bu, i), Pa !== null && Zn(Pa, i), Na.forEach(o), Rl.forEach(o), v = 0; v < Fu.length; v++) w = Fu[v], w.blockedOn === i && (w.blockedOn = null);
    for (; 0 < Fu.length && (v = Fu[0], v.blockedOn === null); ) z2(v), v.blockedOn === null && Fu.shift();
  }
  var Ls = z.ReactCurrentBatchConfig, W0 = !0;
  function G2(i, o, v, w) {
    var C = Fn, E = Ls.transition;
    Ls.transition = null;
    try {
      Fn = 1, z0(i, o, v, w);
    } finally {
      Fn = C, Ls.transition = E;
    }
  }
  function K2(i, o, v, w) {
    var C = Fn, E = Ls.transition;
    Ls.transition = null;
    try {
      Fn = 4, z0(i, o, v, w);
    } finally {
      Fn = C, Ls.transition = E;
    }
  }
  function z0(i, o, v, w) {
    if (W0) {
      var C = G0(i, o, v, w);
      if (C === null) uc(i, o, w, q0, v), Ah(i, w);
      else if (zp(C, i, o, v, w)) w.stopPropagation();
      else if (Ah(i, w), o & 4 && -1 < jh.indexOf(i)) {
        for (; C !== null; ) {
          var E = qt(C);
          if (E !== null && en(E), E = G0(i, o, v, w), E === null && uc(i, o, w, q0, v), E === C) break;
          C = E;
        }
        C !== null && w.stopPropagation();
      } else uc(i, o, w, null, v);
    }
  }
  var q0 = null;
  function G0(i, o, v, w) {
    if (q0 = null, i = _l(w), i = cr(i), i !== null) if (o = xn(i), o === null) i = null;
    else if (v = o.tag, v === 13) {
      if (i = hn(o), i !== null) return i;
      i = null;
    } else if (v === 3) {
      if (o.stateNode.current.memoizedState.isDehydrated) return o.tag === 3 ? o.stateNode.containerInfo : null;
      i = null;
    } else o !== i && (i = null);
    return q0 = i, null;
  }
  function jf(i) {
    switch (i) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (bf()) {
          case D1:
            return 1;
          case Mh:
            return 4;
          case j1:
          case Th:
            return 16;
          case _f:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Sr = null, K0 = null, jo = null;
  function Q0() {
    if (jo) return jo;
    var i, o = K0, v = o.length, w, C = "value" in Sr ? Sr.value : Sr.textContent, E = C.length;
    for (i = 0; i < v && o[i] === C[i]; i++) ;
    var Z = v - i;
    for (w = 1; w <= Z && o[v - w] === C[E - w]; w++) ;
    return jo = C.slice(i, 1 < w ? 1 - w : void 0);
  }
  function Is(i) {
    var o = i.keyCode;
    return "charCode" in i ? (i = i.charCode, i === 0 && o === 13 && (i = 13)) : i = o, i === 10 && (i = 13), 32 <= i || i === 13 ? i : 0;
  }
  function Xa() {
    return !0;
  }
  function Af() {
    return !1;
  }
  function vi(i) {
    function o(v, w, C, E, Z) {
      this._reactName = v, this._targetInst = C, this.type = w, this.nativeEvent = E, this.target = Z, this.currentTarget = null;
      for (var W in i) i.hasOwnProperty(W) && (v = i[W], this[W] = v ? v(E) : E[W]);
      return this.isDefaultPrevented = (E.defaultPrevented != null ? E.defaultPrevented : E.returnValue === !1) ? Xa : Af, this.isPropagationStopped = Af, this;
    }
    return Pe(o.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var v = this.nativeEvent;
      v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = Xa);
    }, stopPropagation: function() {
      var v = this.nativeEvent;
      v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = Xa);
    }, persist: function() {
    }, isPersistent: Xa }), o;
  }
  var Hs = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(i) {
    return i.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, kf = vi(Hs), ra = Pe({}, Hs, { view: 0, detail: 0 }), Lf = vi(ra), Ja, If, ei, au = Pe({}, ra, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: ec, button: 0, buttons: 0, relatedTarget: function(i) {
    return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
  }, movementX: function(i) {
    return "movementX" in i ? i.movementX : (i !== ei && (ei && i.type === "mousemove" ? (Ja = i.screenX - ei.screenX, If = i.screenY - ei.screenY) : If = Ja = 0, ei = i), Ja);
  }, movementY: function(i) {
    return "movementY" in i ? i.movementY : If;
  } }), X0 = vi(au), iu = Pe({}, au, { dataTransfer: 0 }), Hf = vi(iu), kh = Pe({}, ra, { relatedTarget: 0 }), dr = vi(kh), lu = Pe({}, Hs, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), J0 = vi(lu), Q2 = Pe({}, Hs, { clipboardData: function(i) {
    return "clipboardData" in i ? i.clipboardData : window.clipboardData;
  } }), Zf = vi(Q2), X2 = Pe({}, Hs, { data: 0 }), J2 = vi(X2), ou = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, ev = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, L1 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Yu(i) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(i) : (i = L1[i]) ? !!o[i] : !1;
  }
  function ec() {
    return Yu;
  }
  var tv = Pe({}, ra, { key: function(i) {
    if (i.key) {
      var o = ou[i.key] || i.key;
      if (o !== "Unidentified") return o;
    }
    return i.type === "keypress" ? (i = Is(i), i === 13 ? "Enter" : String.fromCharCode(i)) : i.type === "keydown" || i.type === "keyup" ? ev[i.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: ec, charCode: function(i) {
    return i.type === "keypress" ? Is(i) : 0;
  }, keyCode: function(i) {
    return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  }, which: function(i) {
    return i.type === "keypress" ? Is(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  } }), tc = vi(tv), Pf = Pe({}, au, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Va = vi(Pf), Ao = Pe({}, ra, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: ec }), aa = vi(Ao), Gl = Pe({}, Hs, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), nc = vi(Gl), Nf = Pe({}, au, {
    deltaX: function(i) {
      return "deltaX" in i ? i.deltaX : "wheelDeltaX" in i ? -i.wheelDeltaX : 0;
    },
    deltaY: function(i) {
      return "deltaY" in i ? i.deltaY : "wheelDeltaY" in i ? -i.wheelDeltaY : "wheelDelta" in i ? -i.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), nv = vi(Nf), Ba = [9, 13, 27, 32], rc = S && "CompositionEvent" in window, uu = null;
  S && "documentMode" in document && (uu = document.documentMode);
  var Vf = S && "TextEvent" in window && !uu, Lh = S && (!rc || uu && 8 < uu && 11 >= uu), rv = " ", av = !1;
  function Ih(i, o) {
    switch (i) {
      case "keyup":
        return Ba.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function iv(i) {
    return i = i.detail, typeof i == "object" && "data" in i ? i.data : null;
  }
  var I1 = !1;
  function H1(i, o) {
    switch (i) {
      case "compositionend":
        return iv(o);
      case "keypress":
        return o.which !== 32 ? null : (av = !0, rv);
      case "textInput":
        return i = o.data, i === rv && av ? null : i;
      default:
        return null;
    }
  }
  function lv(i, o) {
    if (I1) return i === "compositionend" || !rc && Ih(i, o) ? (i = Q0(), jo = K0 = Sr = null, I1 = !1, i) : null;
    switch (i) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length) return o.char;
          if (o.which) return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return Lh && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var Z1 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function P1(i) {
    var o = i && i.nodeName && i.nodeName.toLowerCase();
    return o === "input" ? !!Z1[i.type] : o === "textarea";
  }
  function Bf(i, o, v, w) {
    T1(w), o = sc(o, "onChange"), 0 < o.length && (v = new kf("onChange", "change", null, v, w), i.push({ event: v, listeners: o }));
  }
  var zi = null, $u = null;
  function qp(i) {
    fv(i, 0);
  }
  function Ff(i) {
    var o = Kt(i);
    if (zn(o)) return i;
  }
  function Gp(i, o) {
    if (i === "change") return o;
  }
  var Zs = !1;
  if (S) {
    var qi;
    if (S) {
      var Uf = "oninput" in document;
      if (!Uf) {
        var ov = document.createElement("div");
        ov.setAttribute("oninput", "return;"), Uf = typeof ov.oninput == "function";
      }
      qi = Uf;
    } else qi = !1;
    Zs = qi && (!document.documentMode || 9 < document.documentMode);
  }
  function Hh() {
    zi && (zi.detachEvent("onpropertychange", uv), $u = zi = null);
  }
  function uv(i) {
    if (i.propertyName === "value" && Ff($u)) {
      var o = [];
      Bf(o, $u, i, _l(i)), To(qp, o);
    }
  }
  function sv(i, o, v) {
    i === "focusin" ? (Hh(), zi = o, $u = v, zi.attachEvent("onpropertychange", uv)) : i === "focusout" && Hh();
  }
  function Kp(i) {
    if (i === "selectionchange" || i === "keyup" || i === "keydown") return Ff($u);
  }
  function N1(i, o) {
    if (i === "click") return Ff(o);
  }
  function oe(i, o) {
    if (i === "input" || i === "change") return Ff(o);
  }
  function Re(i, o) {
    return i === o && (i !== 0 || 1 / i === 1 / o) || i !== i && o !== o;
  }
  var pe = typeof Object.is == "function" ? Object.is : Re;
  function Je(i, o) {
    if (pe(i, o)) return !0;
    if (typeof i != "object" || i === null || typeof o != "object" || o === null) return !1;
    var v = Object.keys(i), w = Object.keys(o);
    if (v.length !== w.length) return !1;
    for (w = 0; w < v.length; w++) {
      var C = v[w];
      if (!b.call(o, C) || !pe(i[C], o[C])) return !1;
    }
    return !0;
  }
  function zt(i) {
    for (; i && i.firstChild; ) i = i.firstChild;
    return i;
  }
  function Mn(i, o) {
    var v = zt(i);
    i = 0;
    for (var w; v; ) {
      if (v.nodeType === 3) {
        if (w = i + v.textContent.length, i <= o && w >= o) return { node: v, offset: o - i };
        i = w;
      }
      e: {
        for (; v; ) {
          if (v.nextSibling) {
            v = v.nextSibling;
            break e;
          }
          v = v.parentNode;
        }
        v = void 0;
      }
      v = zt(v);
    }
  }
  function Cr(i, o) {
    return i && o ? i === o ? !0 : i && i.nodeType === 3 ? !1 : o && o.nodeType === 3 ? Cr(i, o.parentNode) : "contains" in i ? i.contains(o) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function nr() {
    for (var i = window, o = er(); o instanceof i.HTMLIFrameElement; ) {
      try {
        var v = typeof o.contentWindow.location.href == "string";
      } catch {
        v = !1;
      }
      if (v) i = o.contentWindow;
      else break;
      o = er(i.document);
    }
    return o;
  }
  function ac(i) {
    var o = i && i.nodeName && i.nodeName.toLowerCase();
    return o && (o === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || o === "textarea" || i.contentEditable === "true");
  }
  function Qp(i) {
    var o = nr(), v = i.focusedElem, w = i.selectionRange;
    if (o !== v && v && v.ownerDocument && Cr(v.ownerDocument.documentElement, v)) {
      if (w !== null && ac(v)) {
        if (o = w.start, i = w.end, i === void 0 && (i = o), "selectionStart" in v) v.selectionStart = o, v.selectionEnd = Math.min(i, v.value.length);
        else if (i = (o = v.ownerDocument || document) && o.defaultView || window, i.getSelection) {
          i = i.getSelection();
          var C = v.textContent.length, E = Math.min(w.start, C);
          w = w.end === void 0 ? E : Math.min(w.end, C), !i.extend && E > w && (C = w, w = E, E = C), C = Mn(v, E);
          var Z = Mn(
            v,
            w
          );
          C && Z && (i.rangeCount !== 1 || i.anchorNode !== C.node || i.anchorOffset !== C.offset || i.focusNode !== Z.node || i.focusOffset !== Z.offset) && (o = o.createRange(), o.setStart(C.node, C.offset), i.removeAllRanges(), E > w ? (i.addRange(o), i.extend(Z.node, Z.offset)) : (o.setEnd(Z.node, Z.offset), i.addRange(o)));
        }
      }
      for (o = [], i = v; i = i.parentNode; ) i.nodeType === 1 && o.push({ element: i, left: i.scrollLeft, top: i.scrollTop });
      for (typeof v.focus == "function" && v.focus(), v = 0; v < o.length; v++) i = o[v], i.element.scrollLeft = i.left, i.element.scrollTop = i.top;
    }
  }
  var El = S && "documentMode" in document && 11 >= document.documentMode, su = null, Yf = null, ko = null, Ps = !1;
  function pa(i, o, v) {
    var w = v.window === v ? v.document : v.nodeType === 9 ? v : v.ownerDocument;
    Ps || su == null || su !== er(w) || (w = su, "selectionStart" in w && ac(w) ? w = { start: w.selectionStart, end: w.selectionEnd } : (w = (w.ownerDocument && w.ownerDocument.defaultView || window).getSelection(), w = { anchorNode: w.anchorNode, anchorOffset: w.anchorOffset, focusNode: w.focusNode, focusOffset: w.focusOffset }), ko && Je(ko, w) || (ko = w, w = sc(Yf, "onSelect"), 0 < w.length && (o = new kf("onSelect", "select", null, o, v), i.push({ event: o, listeners: w }), o.target = su)));
  }
  function Tn(i, o) {
    var v = {};
    return v[i.toLowerCase()] = o.toLowerCase(), v["Webkit" + i] = "webkit" + o, v["Moz" + i] = "moz" + o, v;
  }
  var V1 = { animationend: Tn("Animation", "AnimationEnd"), animationiteration: Tn("Animation", "AnimationIteration"), animationstart: Tn("Animation", "AnimationStart"), transitionend: Tn("Transition", "TransitionEnd") }, $f = {}, ic = {};
  S && (ic = document.createElement("div").style, "AnimationEvent" in window || (delete V1.animationend.animation, delete V1.animationiteration.animation, delete V1.animationstart.animation), "TransitionEvent" in window || delete V1.transitionend.transition);
  function Wf(i) {
    if ($f[i]) return $f[i];
    if (!V1[i]) return i;
    var o = V1[i], v;
    for (v in o) if (o.hasOwnProperty(v) && v in ic) return $f[i] = o[v];
    return i;
  }
  var cv = Wf("animationend"), Zh = Wf("animationiteration"), Ns = Wf("animationstart"), Gi = Wf("transitionend"), lc = /* @__PURE__ */ new Map(), Vs = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Kl(i, o) {
    lc.set(i, o), g(o, [i]);
  }
  for (var zf = 0; zf < Vs.length; zf++) {
    var qf = Vs[zf], B1 = qf.toLowerCase(), Gf = qf[0].toUpperCase() + qf.slice(1);
    Kl(B1, "on" + Gf);
  }
  Kl(cv, "onAnimationEnd"), Kl(Zh, "onAnimationIteration"), Kl(Ns, "onAnimationStart"), Kl("dblclick", "onDoubleClick"), Kl("focusin", "onFocus"), Kl("focusout", "onBlur"), Kl(Gi, "onTransitionEnd"), m("onMouseEnter", ["mouseout", "mouseover"]), m("onMouseLeave", ["mouseout", "mouseover"]), m("onPointerEnter", ["pointerout", "pointerover"]), m("onPointerLeave", ["pointerout", "pointerover"]), g("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), g("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), g("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), g("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var ki = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ml = new Set("cancel close invalid load scroll toggle".split(" ").concat(ki));
  function F1(i, o, v) {
    var w = i.type || "unknown-event";
    i.currentTarget = v, Bn(w, o, void 0, i), i.currentTarget = null;
  }
  function fv(i, o) {
    o = (o & 4) !== 0;
    for (var v = 0; v < i.length; v++) {
      var w = i[v], C = w.event;
      w = w.listeners;
      e: {
        var E = void 0;
        if (o) for (var Z = w.length - 1; 0 <= Z; Z--) {
          var W = w[Z], ee = W.instance, xe = W.currentTarget;
          if (W = W.listener, ee !== E && C.isPropagationStopped()) break e;
          F1(C, W, xe), E = ee;
        }
        else for (Z = 0; Z < w.length; Z++) {
          if (W = w[Z], ee = W.instance, xe = W.currentTarget, W = W.listener, ee !== E && C.isPropagationStopped()) break e;
          F1(C, W, xe), E = ee;
        }
      }
    }
    if (J) throw i = $e, J = !1, $e = null, i;
  }
  function hr(i, o) {
    var v = o[Qf];
    v === void 0 && (v = o[Qf] = /* @__PURE__ */ new Set());
    var w = i + "__bubble";
    v.has(w) || (oc(o, i, 2, !1), v.add(w));
  }
  function Ph(i, o, v) {
    var w = 0;
    o && (w |= 4), oc(v, i, w, o);
  }
  var Wu = "_reactListening" + Math.random().toString(36).slice(2);
  function cu(i) {
    if (!i[Wu]) {
      i[Wu] = !0, l.forEach(function(v) {
        v !== "selectionchange" && (Ml.has(v) || Ph(v, !1, i), Ph(v, !0, i));
      });
      var o = i.nodeType === 9 ? i : i.ownerDocument;
      o === null || o[Wu] || (o[Wu] = !0, Ph("selectionchange", !1, o));
    }
  }
  function oc(i, o, v, w) {
    switch (jf(o)) {
      case 1:
        var C = G2;
        break;
      case 4:
        C = K2;
        break;
      default:
        C = z0;
    }
    v = C.bind(null, o, v, i), C = void 0, !Oo || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (C = !0), w ? C !== void 0 ? i.addEventListener(o, v, { capture: !0, passive: C }) : i.addEventListener(o, v, !0) : C !== void 0 ? i.addEventListener(o, v, { passive: C }) : i.addEventListener(o, v, !1);
  }
  function uc(i, o, v, w, C) {
    var E = w;
    if (!(o & 1) && !(o & 2) && w !== null) e: for (; ; ) {
      if (w === null) return;
      var Z = w.tag;
      if (Z === 3 || Z === 4) {
        var W = w.stateNode.containerInfo;
        if (W === C || W.nodeType === 8 && W.parentNode === C) break;
        if (Z === 4) for (Z = w.return; Z !== null; ) {
          var ee = Z.tag;
          if ((ee === 3 || ee === 4) && (ee = Z.stateNode.containerInfo, ee === C || ee.nodeType === 8 && ee.parentNode === C)) return;
          Z = Z.return;
        }
        for (; W !== null; ) {
          if (Z = cr(W), Z === null) return;
          if (ee = Z.tag, ee === 5 || ee === 6) {
            w = E = Z;
            continue e;
          }
          W = W.parentNode;
        }
      }
      w = w.return;
    }
    To(function() {
      var xe = E, Ve = _l(v), Ye = [];
      e: {
        var Ne = lc.get(i);
        if (Ne !== void 0) {
          var ot = kf, yt = i;
          switch (i) {
            case "keypress":
              if (Is(v) === 0) break e;
            case "keydown":
            case "keyup":
              ot = tc;
              break;
            case "focusin":
              yt = "focus", ot = dr;
              break;
            case "focusout":
              yt = "blur", ot = dr;
              break;
            case "beforeblur":
            case "afterblur":
              ot = dr;
              break;
            case "click":
              if (v.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              ot = X0;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              ot = Hf;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              ot = aa;
              break;
            case cv:
            case Zh:
            case Ns:
              ot = J0;
              break;
            case Gi:
              ot = nc;
              break;
            case "scroll":
              ot = Lf;
              break;
            case "wheel":
              ot = nv;
              break;
            case "copy":
            case "cut":
            case "paste":
              ot = Zf;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              ot = Va;
          }
          var Ct = (o & 4) !== 0, Vr = !Ct && i === "scroll", fe = Ct ? Ne !== null ? Ne + "Capture" : null : Ne;
          Ct = [];
          for (var ne = xe, de; ne !== null; ) {
            de = ne;
            var ze = de.stateNode;
            if (de.tag === 5 && ze !== null && (de = ze, fe !== null && (ze = $i(ne, fe), ze != null && Ct.push(U1(ne, ze, de)))), Vr) break;
            ne = ne.return;
          }
          0 < Ct.length && (Ne = new ot(Ne, yt, null, v, Ve), Ye.push({ event: Ne, listeners: Ct }));
        }
      }
      if (!(o & 7)) {
        e: {
          if (Ne = i === "mouseover" || i === "pointerover", ot = i === "mouseout" || i === "pointerout", Ne && v !== M1 && (yt = v.relatedTarget || v.fromElement) && (cr(yt) || yt[Xi])) break e;
          if ((ot || Ne) && (Ne = Ve.window === Ve ? Ve : (Ne = Ve.ownerDocument) ? Ne.defaultView || Ne.parentWindow : window, ot ? (yt = v.relatedTarget || v.toElement, ot = xe, yt = yt ? cr(yt) : null, yt !== null && (Vr = xn(yt), yt !== Vr || yt.tag !== 5 && yt.tag !== 6) && (yt = null)) : (ot = null, yt = xe), ot !== yt)) {
            if (Ct = X0, ze = "onMouseLeave", fe = "onMouseEnter", ne = "mouse", (i === "pointerout" || i === "pointerover") && (Ct = Va, ze = "onPointerLeave", fe = "onPointerEnter", ne = "pointer"), Vr = ot == null ? Ne : Kt(ot), de = yt == null ? Ne : Kt(yt), Ne = new Ct(ze, ne + "leave", ot, v, Ve), Ne.target = Vr, Ne.relatedTarget = de, ze = null, cr(Ve) === xe && (Ct = new Ct(fe, ne + "enter", yt, v, Ve), Ct.target = de, Ct.relatedTarget = Vr, ze = Ct), Vr = ze, ot && yt) t: {
              for (Ct = ot, fe = yt, ne = 0, de = Ct; de; de = Y1(de)) ne++;
              for (de = 0, ze = fe; ze; ze = Y1(ze)) de++;
              for (; 0 < ne - de; ) Ct = Y1(Ct), ne--;
              for (; 0 < de - ne; ) fe = Y1(fe), de--;
              for (; ne--; ) {
                if (Ct === fe || fe !== null && Ct === fe.alternate) break t;
                Ct = Y1(Ct), fe = Y1(fe);
              }
              Ct = null;
            }
            else Ct = null;
            ot !== null && ia(Ye, Ne, ot, Ct, !1), yt !== null && Vr !== null && ia(Ye, Vr, yt, Ct, !0);
          }
        }
        e: {
          if (Ne = xe ? Kt(xe) : window, ot = Ne.nodeName && Ne.nodeName.toLowerCase(), ot === "select" || ot === "input" && Ne.type === "file") var bt = Gp;
          else if (P1(Ne)) if (Zs) bt = oe;
          else {
            bt = Kp;
            var Zt = sv;
          }
          else (ot = Ne.nodeName) && ot.toLowerCase() === "input" && (Ne.type === "checkbox" || Ne.type === "radio") && (bt = N1);
          if (bt && (bt = bt(i, xe))) {
            Bf(Ye, bt, v, Ve);
            break e;
          }
          Zt && Zt(i, Ne, xe), i === "focusout" && (Zt = Ne._wrapperState) && Zt.controlled && Ne.type === "number" && ln(Ne, "number", Ne.value);
        }
        switch (Zt = xe ? Kt(xe) : window, i) {
          case "focusin":
            (P1(Zt) || Zt.contentEditable === "true") && (su = Zt, Yf = xe, ko = null);
            break;
          case "focusout":
            ko = Yf = su = null;
            break;
          case "mousedown":
            Ps = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Ps = !1, pa(Ye, v, Ve);
            break;
          case "selectionchange":
            if (El) break;
          case "keydown":
          case "keyup":
            pa(Ye, v, Ve);
        }
        var Bt;
        if (rc) e: {
          switch (i) {
            case "compositionstart":
              var Wt = "onCompositionStart";
              break e;
            case "compositionend":
              Wt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Wt = "onCompositionUpdate";
              break e;
          }
          Wt = void 0;
        }
        else I1 ? Ih(i, v) && (Wt = "onCompositionEnd") : i === "keydown" && v.keyCode === 229 && (Wt = "onCompositionStart");
        Wt && (Lh && v.locale !== "ko" && (I1 || Wt !== "onCompositionStart" ? Wt === "onCompositionEnd" && I1 && (Bt = Q0()) : (Sr = Ve, K0 = "value" in Sr ? Sr.value : Sr.textContent, I1 = !0)), Zt = sc(xe, Wt), 0 < Zt.length && (Wt = new J2(Wt, i, null, v, Ve), Ye.push({ event: Wt, listeners: Zt }), Bt ? Wt.data = Bt : (Bt = iv(v), Bt !== null && (Wt.data = Bt)))), (Bt = Vf ? H1(i, v) : lv(i, v)) && (xe = sc(xe, "onBeforeInput"), 0 < xe.length && (Ve = new J2("onBeforeInput", "beforeinput", null, v, Ve), Ye.push({ event: Ve, listeners: xe }), Ve.data = Bt));
      }
      fv(Ye, o);
    });
  }
  function U1(i, o, v) {
    return { instance: i, listener: o, currentTarget: v };
  }
  function sc(i, o) {
    for (var v = o + "Capture", w = []; i !== null; ) {
      var C = i, E = C.stateNode;
      C.tag === 5 && E !== null && (C = E, E = $i(i, v), E != null && w.unshift(U1(i, E, C)), E = $i(i, o), E != null && w.push(U1(i, E, C))), i = i.return;
    }
    return w;
  }
  function Y1(i) {
    if (i === null) return null;
    do
      i = i.return;
    while (i && i.tag !== 5);
    return i || null;
  }
  function ia(i, o, v, w, C) {
    for (var E = o._reactName, Z = []; v !== null && v !== w; ) {
      var W = v, ee = W.alternate, xe = W.stateNode;
      if (ee !== null && ee === w) break;
      W.tag === 5 && xe !== null && (W = xe, C ? (ee = $i(v, E), ee != null && Z.unshift(U1(v, ee, W))) : C || (ee = $i(v, E), ee != null && Z.push(U1(v, ee, W)))), v = v.return;
    }
    Z.length !== 0 && i.push({ event: o, listeners: Z });
  }
  var ti = /\r\n?/g, cc = /\u0000|\uFFFD/g;
  function Kf(i) {
    return (typeof i == "string" ? i : "" + i).replace(ti, `
`).replace(cc, "");
  }
  function fu(i, o, v) {
    if (o = Kf(o), Kf(i) !== o && v) throw Error(a(425));
  }
  function fc() {
  }
  var $1 = null, du = null;
  function dc(i, o) {
    return i === "textarea" || i === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var Ki = typeof setTimeout == "function" ? setTimeout : void 0, zu = typeof clearTimeout == "function" ? clearTimeout : void 0, hu = typeof Promise == "function" ? Promise : void 0, W1 = typeof queueMicrotask == "function" ? queueMicrotask : typeof hu < "u" ? function(i) {
    return hu.resolve(null).then(i).catch(z1);
  } : Ki;
  function z1(i) {
    setTimeout(function() {
      throw i;
    });
  }
  function hc(i, o) {
    var v = o, w = 0;
    do {
      var C = v.nextSibling;
      if (i.removeChild(v), C && C.nodeType === 8) if (v = C.data, v === "/$") {
        if (w === 0) {
          i.removeChild(C), Un(o);
          return;
        }
        w--;
      } else v !== "$" && v !== "$?" && v !== "$!" || w++;
      v = C;
    } while (v);
    Un(o);
  }
  function qu(i) {
    for (; i != null; i = i.nextSibling) {
      var o = i.nodeType;
      if (o === 1 || o === 3) break;
      if (o === 8) {
        if (o = i.data, o === "$" || o === "$!" || o === "$?") break;
        if (o === "/$") return null;
      }
    }
    return i;
  }
  function dv(i) {
    i = i.previousSibling;
    for (var o = 0; i; ) {
      if (i.nodeType === 8) {
        var v = i.data;
        if (v === "$" || v === "$!" || v === "$?") {
          if (o === 0) return i;
          o--;
        } else v === "/$" && o++;
      }
      i = i.previousSibling;
    }
    return null;
  }
  var q1 = Math.random().toString(36).slice(2), Tl = "__reactFiber$" + q1, Qi = "__reactProps$" + q1, Xi = "__reactContainer$" + q1, Qf = "__reactEvents$" + q1, H = "__reactListeners$" + q1, Ql = "__reactHandles$" + q1;
  function cr(i) {
    var o = i[Tl];
    if (o) return o;
    for (var v = i.parentNode; v; ) {
      if (o = v[Xi] || v[Tl]) {
        if (v = o.alternate, o.child !== null || v !== null && v.child !== null) for (i = dv(i); i !== null; ) {
          if (v = i[Tl]) return v;
          i = dv(i);
        }
        return o;
      }
      i = v, v = i.parentNode;
    }
    return null;
  }
  function qt(i) {
    return i = i[Tl] || i[Xi], !i || i.tag !== 5 && i.tag !== 6 && i.tag !== 13 && i.tag !== 3 ? null : i;
  }
  function Kt(i) {
    if (i.tag === 5 || i.tag === 6) return i.stateNode;
    throw Error(a(33));
  }
  function Bs(i) {
    return i[Qi] || null;
  }
  var Xf = [], pn = -1;
  function la(i) {
    return { current: i };
  }
  function Yn(i) {
    0 > pn || (i.current = Xf[pn], Xf[pn] = null, pn--);
  }
  function $n(i, o) {
    pn++, Xf[pn] = i.current, i.current = o;
  }
  var pi = {}, Zr = la(pi), oa = la(!1), Fa = pi;
  function G1(i, o) {
    var v = i.type.contextTypes;
    if (!v) return pi;
    var w = i.stateNode;
    if (w && w.__reactInternalMemoizedUnmaskedChildContext === o) return w.__reactInternalMemoizedMaskedChildContext;
    var C = {}, E;
    for (E in v) C[E] = o[E];
    return w && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = o, i.__reactInternalMemoizedMaskedChildContext = C), C;
  }
  function Ua(i) {
    return i = i.childContextTypes, i != null;
  }
  function Li() {
    Yn(oa), Yn(Zr);
  }
  function Jf(i, o, v) {
    if (Zr.current !== pi) throw Error(a(168));
    $n(Zr, o), $n(oa, v);
  }
  function Nh(i, o, v) {
    var w = i.stateNode;
    if (o = o.childContextTypes, typeof w.getChildContext != "function") return v;
    w = w.getChildContext();
    for (var C in w) if (!(C in o)) throw Error(a(108, vt(i) || "Unknown", C));
    return Pe({}, v, w);
  }
  function Ii(i) {
    return i = (i = i.stateNode) && i.__reactInternalMemoizedMergedChildContext || pi, Fa = Zr.current, $n(Zr, i), $n(oa, oa.current), !0;
  }
  function Gu(i, o, v) {
    var w = i.stateNode;
    if (!w) throw Error(a(169));
    v ? (i = Nh(i, o, Fa), w.__reactInternalMemoizedMergedChildContext = i, Yn(oa), Yn(Zr), $n(Zr, i)) : Yn(oa), $n(oa, v);
  }
  var Xl = null, Jl = !1, vc = !1;
  function ed(i) {
    Xl === null ? Xl = [i] : Xl.push(i);
  }
  function vu(i) {
    Jl = !0, ed(i);
  }
  function Ol() {
    if (!vc && Xl !== null) {
      vc = !0;
      var i = 0, o = Fn;
      try {
        var v = Xl;
        for (Fn = 1; i < v.length; i++) {
          var w = v[i];
          do
            w = w(!0);
          while (w !== null);
        }
        Xl = null, Jl = !1;
      } catch (C) {
        throw Xl !== null && (Xl = Xl.slice(i + 1)), di(D1, Ol), C;
      } finally {
        Fn = o, vc = !1;
      }
    }
    return null;
  }
  var eo = [], Mr = 0, td = null, Lo = 0, Ji = [], el = 0, Fs = null, Io = 1, to = "";
  function Ku(i, o) {
    eo[Mr++] = Lo, eo[Mr++] = td, td = i, Lo = o;
  }
  function Vh(i, o, v) {
    Ji[el++] = Io, Ji[el++] = to, Ji[el++] = Fs, Fs = i;
    var w = Io;
    i = to;
    var C = 32 - Wi(w) - 1;
    w &= ~(1 << C), v += 1;
    var E = 32 - Wi(o) + C;
    if (30 < E) {
      var Z = C - C % 5;
      E = (w & (1 << Z) - 1).toString(32), w >>= Z, C -= Z, Io = 1 << 32 - Wi(o) + C | v << C | w, to = E + i;
    } else Io = 1 << E | v << C | w, to = i;
  }
  function K1(i) {
    i.return !== null && (Ku(i, 1), Vh(i, 1, 0));
  }
  function Us(i) {
    for (; i === td; ) td = eo[--Mr], eo[Mr] = null, Lo = eo[--Mr], eo[Mr] = null;
    for (; i === Fs; ) Fs = Ji[--el], Ji[el] = null, to = Ji[--el], Ji[el] = null, Io = Ji[--el], Ji[el] = null;
  }
  var Ya = null, Hi = null, br = !1, no = null;
  function Ho(i, o) {
    var v = Pl(5, null, null, 0);
    v.elementType = "DELETED", v.stateNode = o, v.return = i, o = i.deletions, o === null ? (i.deletions = [v], i.flags |= 16) : o.push(v);
  }
  function $r(i, o) {
    switch (i.tag) {
      case 5:
        var v = i.type;
        return o = o.nodeType !== 1 || v.toLowerCase() !== o.nodeName.toLowerCase() ? null : o, o !== null ? (i.stateNode = o, Ya = i, Hi = qu(o.firstChild), !0) : !1;
      case 6:
        return o = i.pendingProps === "" || o.nodeType !== 3 ? null : o, o !== null ? (i.stateNode = o, Ya = i, Hi = null, !0) : !1;
      case 13:
        return o = o.nodeType !== 8 ? null : o, o !== null ? (v = Fs !== null ? { id: Io, overflow: to } : null, i.memoizedState = { dehydrated: o, treeContext: v, retryLane: 1073741824 }, v = Pl(18, null, null, 0), v.stateNode = o, v.return = i, i.child = v, Ya = i, Hi = null, !0) : !1;
      default:
        return !1;
    }
  }
  function pu(i) {
    return (i.mode & 1) !== 0 && (i.flags & 128) === 0;
  }
  function $a(i) {
    if (br) {
      var o = Hi;
      if (o) {
        var v = o;
        if (!$r(i, o)) {
          if (pu(i)) throw Error(a(418));
          o = qu(v.nextSibling);
          var w = Ya;
          o && $r(i, o) ? Ho(w, v) : (i.flags = i.flags & -4097 | 2, br = !1, Ya = i);
        }
      } else {
        if (pu(i)) throw Error(a(418));
        i.flags = i.flags & -4097 | 2, br = !1, Ya = i;
      }
    }
  }
  function nd(i) {
    for (i = i.return; i !== null && i.tag !== 5 && i.tag !== 3 && i.tag !== 13; ) i = i.return;
    Ya = i;
  }
  function ro(i) {
    if (i !== Ya) return !1;
    if (!br) return nd(i), br = !0, !1;
    var o;
    if ((o = i.tag !== 3) && !(o = i.tag !== 5) && (o = i.type, o = o !== "head" && o !== "body" && !dc(i.type, i.memoizedProps)), o && (o = Hi)) {
      if (pu(i)) throw Bh(), Error(a(418));
      for (; o; ) Ho(i, o), o = qu(o.nextSibling);
    }
    if (nd(i), i.tag === 13) {
      if (i = i.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(a(317));
      e: {
        for (i = i.nextSibling, o = 0; i; ) {
          if (i.nodeType === 8) {
            var v = i.data;
            if (v === "/$") {
              if (o === 0) {
                Hi = qu(i.nextSibling);
                break e;
              }
              o--;
            } else v !== "$" && v !== "$!" && v !== "$?" || o++;
          }
          i = i.nextSibling;
        }
        Hi = null;
      }
    } else Hi = Ya ? qu(i.stateNode.nextSibling) : null;
    return !0;
  }
  function Bh() {
    for (var i = Hi; i; ) i = qu(i.nextSibling);
  }
  function Dl() {
    Hi = Ya = null, br = !1;
  }
  function Zo(i) {
    no === null ? no = [i] : no.push(i);
  }
  var hv = z.ReactCurrentBatchConfig;
  function Po(i, o, v) {
    if (i = v.ref, i !== null && typeof i != "function" && typeof i != "object") {
      if (v._owner) {
        if (v = v._owner, v) {
          if (v.tag !== 1) throw Error(a(309));
          var w = v.stateNode;
        }
        if (!w) throw Error(a(147, i));
        var C = w, E = "" + i;
        return o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === E ? o.ref : (o = function(Z) {
          var W = C.refs;
          Z === null ? delete W[E] : W[E] = Z;
        }, o._stringRef = E, o);
      }
      if (typeof i != "string") throw Error(a(284));
      if (!v._owner) throw Error(a(290, i));
    }
    return i;
  }
  function Pr(i, o) {
    throw i = Object.prototype.toString.call(o), Error(a(31, i === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : i));
  }
  function at(i) {
    var o = i._init;
    return o(i._payload);
  }
  function jl(i) {
    function o(fe, ne) {
      if (i) {
        var de = fe.deletions;
        de === null ? (fe.deletions = [ne], fe.flags |= 16) : de.push(ne);
      }
    }
    function v(fe, ne) {
      if (!i) return null;
      for (; ne !== null; ) o(fe, ne), ne = ne.sibling;
      return null;
    }
    function w(fe, ne) {
      for (fe = /* @__PURE__ */ new Map(); ne !== null; ) ne.key !== null ? fe.set(ne.key, ne) : fe.set(ne.index, ne), ne = ne.sibling;
      return fe;
    }
    function C(fe, ne) {
      return fe = xi(fe, ne), fe.index = 0, fe.sibling = null, fe;
    }
    function E(fe, ne, de) {
      return fe.index = de, i ? (de = fe.alternate, de !== null ? (de = de.index, de < ne ? (fe.flags |= 2, ne) : de) : (fe.flags |= 2, ne)) : (fe.flags |= 1048576, ne);
    }
    function Z(fe) {
      return i && fe.alternate === null && (fe.flags |= 2), fe;
    }
    function W(fe, ne, de, ze) {
      return ne === null || ne.tag !== 6 ? (ne = Dd(de, fe.mode, ze), ne.return = fe, ne) : (ne = C(ne, de), ne.return = fe, ne);
    }
    function ee(fe, ne, de, ze) {
      var bt = de.type;
      return bt === X ? Ve(fe, ne, de.props.children, ze, de.key) : ne !== null && (ne.elementType === bt || typeof bt == "object" && bt !== null && bt.$$typeof === be && at(bt) === ne.type) ? (ze = C(ne, de.props), ze.ref = Po(fe, ne, de), ze.return = fe, ze) : (ze = Od(de.type, de.key, de.props, null, fe.mode, ze), ze.ref = Po(fe, ne, de), ze.return = fe, ze);
    }
    function xe(fe, ne, de, ze) {
      return ne === null || ne.tag !== 4 || ne.stateNode.containerInfo !== de.containerInfo || ne.stateNode.implementation !== de.implementation ? (ne = e2(de, fe.mode, ze), ne.return = fe, ne) : (ne = C(ne, de.children || []), ne.return = fe, ne);
    }
    function Ve(fe, ne, de, ze, bt) {
      return ne === null || ne.tag !== 7 ? (ne = ps(de, fe.mode, ze, bt), ne.return = fe, ne) : (ne = C(ne, de), ne.return = fe, ne);
    }
    function Ye(fe, ne, de) {
      if (typeof ne == "string" && ne !== "" || typeof ne == "number") return ne = Dd("" + ne, fe.mode, de), ne.return = fe, ne;
      if (typeof ne == "object" && ne !== null) {
        switch (ne.$$typeof) {
          case $:
            return de = Od(ne.type, ne.key, ne.props, null, fe.mode, de), de.ref = Po(fe, null, ne), de.return = fe, de;
          case ce:
            return ne = e2(ne, fe.mode, de), ne.return = fe, ne;
          case be:
            var ze = ne._init;
            return Ye(fe, ze(ne._payload), de);
        }
        if (dn(ne) || _e(ne)) return ne = ps(ne, fe.mode, de, null), ne.return = fe, ne;
        Pr(fe, ne);
      }
      return null;
    }
    function Ne(fe, ne, de, ze) {
      var bt = ne !== null ? ne.key : null;
      if (typeof de == "string" && de !== "" || typeof de == "number") return bt !== null ? null : W(fe, ne, "" + de, ze);
      if (typeof de == "object" && de !== null) {
        switch (de.$$typeof) {
          case $:
            return de.key === bt ? ee(fe, ne, de, ze) : null;
          case ce:
            return de.key === bt ? xe(fe, ne, de, ze) : null;
          case be:
            return bt = de._init, Ne(
              fe,
              ne,
              bt(de._payload),
              ze
            );
        }
        if (dn(de) || _e(de)) return bt !== null ? null : Ve(fe, ne, de, ze, null);
        Pr(fe, de);
      }
      return null;
    }
    function ot(fe, ne, de, ze, bt) {
      if (typeof ze == "string" && ze !== "" || typeof ze == "number") return fe = fe.get(de) || null, W(ne, fe, "" + ze, bt);
      if (typeof ze == "object" && ze !== null) {
        switch (ze.$$typeof) {
          case $:
            return fe = fe.get(ze.key === null ? de : ze.key) || null, ee(ne, fe, ze, bt);
          case ce:
            return fe = fe.get(ze.key === null ? de : ze.key) || null, xe(ne, fe, ze, bt);
          case be:
            var Zt = ze._init;
            return ot(fe, ne, de, Zt(ze._payload), bt);
        }
        if (dn(ze) || _e(ze)) return fe = fe.get(de) || null, Ve(ne, fe, ze, bt, null);
        Pr(ne, ze);
      }
      return null;
    }
    function yt(fe, ne, de, ze) {
      for (var bt = null, Zt = null, Bt = ne, Wt = ne = 0, ga = null; Bt !== null && Wt < de.length; Wt++) {
        Bt.index > Wt ? (ga = Bt, Bt = null) : ga = Bt.sibling;
        var Dn = Ne(fe, Bt, de[Wt], ze);
        if (Dn === null) {
          Bt === null && (Bt = ga);
          break;
        }
        i && Bt && Dn.alternate === null && o(fe, Bt), ne = E(Dn, ne, Wt), Zt === null ? bt = Dn : Zt.sibling = Dn, Zt = Dn, Bt = ga;
      }
      if (Wt === de.length) return v(fe, Bt), br && Ku(fe, Wt), bt;
      if (Bt === null) {
        for (; Wt < de.length; Wt++) Bt = Ye(fe, de[Wt], ze), Bt !== null && (ne = E(Bt, ne, Wt), Zt === null ? bt = Bt : Zt.sibling = Bt, Zt = Bt);
        return br && Ku(fe, Wt), bt;
      }
      for (Bt = w(fe, Bt); Wt < de.length; Wt++) ga = ot(Bt, fe, Wt, de[Wt], ze), ga !== null && (i && ga.alternate !== null && Bt.delete(ga.key === null ? Wt : ga.key), ne = E(ga, ne, Wt), Zt === null ? bt = ga : Zt.sibling = ga, Zt = ga);
      return i && Bt.forEach(function(Ou) {
        return o(fe, Ou);
      }), br && Ku(fe, Wt), bt;
    }
    function Ct(fe, ne, de, ze) {
      var bt = _e(de);
      if (typeof bt != "function") throw Error(a(150));
      if (de = bt.call(de), de == null) throw Error(a(151));
      for (var Zt = bt = null, Bt = ne, Wt = ne = 0, ga = null, Dn = de.next(); Bt !== null && !Dn.done; Wt++, Dn = de.next()) {
        Bt.index > Wt ? (ga = Bt, Bt = null) : ga = Bt.sibling;
        var Ou = Ne(fe, Bt, Dn.value, ze);
        if (Ou === null) {
          Bt === null && (Bt = ga);
          break;
        }
        i && Bt && Ou.alternate === null && o(fe, Bt), ne = E(Ou, ne, Wt), Zt === null ? bt = Ou : Zt.sibling = Ou, Zt = Ou, Bt = ga;
      }
      if (Dn.done) return v(
        fe,
        Bt
      ), br && Ku(fe, Wt), bt;
      if (Bt === null) {
        for (; !Dn.done; Wt++, Dn = de.next()) Dn = Ye(fe, Dn.value, ze), Dn !== null && (ne = E(Dn, ne, Wt), Zt === null ? bt = Dn : Zt.sibling = Dn, Zt = Dn);
        return br && Ku(fe, Wt), bt;
      }
      for (Bt = w(fe, Bt); !Dn.done; Wt++, Dn = de.next()) Dn = ot(Bt, fe, Wt, Dn.value, ze), Dn !== null && (i && Dn.alternate !== null && Bt.delete(Dn.key === null ? Wt : Dn.key), ne = E(Dn, ne, Wt), Zt === null ? bt = Dn : Zt.sibling = Dn, Zt = Dn);
      return i && Bt.forEach(function(fm) {
        return o(fe, fm);
      }), br && Ku(fe, Wt), bt;
    }
    function Vr(fe, ne, de, ze) {
      if (typeof de == "object" && de !== null && de.type === X && de.key === null && (de = de.props.children), typeof de == "object" && de !== null) {
        switch (de.$$typeof) {
          case $:
            e: {
              for (var bt = de.key, Zt = ne; Zt !== null; ) {
                if (Zt.key === bt) {
                  if (bt = de.type, bt === X) {
                    if (Zt.tag === 7) {
                      v(fe, Zt.sibling), ne = C(Zt, de.props.children), ne.return = fe, fe = ne;
                      break e;
                    }
                  } else if (Zt.elementType === bt || typeof bt == "object" && bt !== null && bt.$$typeof === be && at(bt) === Zt.type) {
                    v(fe, Zt.sibling), ne = C(Zt, de.props), ne.ref = Po(fe, Zt, de), ne.return = fe, fe = ne;
                    break e;
                  }
                  v(fe, Zt);
                  break;
                } else o(fe, Zt);
                Zt = Zt.sibling;
              }
              de.type === X ? (ne = ps(de.props.children, fe.mode, ze, de.key), ne.return = fe, fe = ne) : (ze = Od(de.type, de.key, de.props, null, fe.mode, ze), ze.ref = Po(fe, ne, de), ze.return = fe, fe = ze);
            }
            return Z(fe);
          case ce:
            e: {
              for (Zt = de.key; ne !== null; ) {
                if (ne.key === Zt) if (ne.tag === 4 && ne.stateNode.containerInfo === de.containerInfo && ne.stateNode.implementation === de.implementation) {
                  v(fe, ne.sibling), ne = C(ne, de.children || []), ne.return = fe, fe = ne;
                  break e;
                } else {
                  v(fe, ne);
                  break;
                }
                else o(fe, ne);
                ne = ne.sibling;
              }
              ne = e2(de, fe.mode, ze), ne.return = fe, fe = ne;
            }
            return Z(fe);
          case be:
            return Zt = de._init, Vr(fe, ne, Zt(de._payload), ze);
        }
        if (dn(de)) return yt(fe, ne, de, ze);
        if (_e(de)) return Ct(fe, ne, de, ze);
        Pr(fe, de);
      }
      return typeof de == "string" && de !== "" || typeof de == "number" ? (de = "" + de, ne !== null && ne.tag === 6 ? (v(fe, ne.sibling), ne = C(ne, de), ne.return = fe, fe = ne) : (v(fe, ne), ne = Dd(de, fe.mode, ze), ne.return = fe, fe = ne), Z(fe)) : v(fe, ne);
    }
    return Vr;
  }
  var Pn = jl(!0), rd = jl(!1), pc = la(null), tl = null, Qu = null, Q1 = null;
  function vr() {
    Q1 = Qu = tl = null;
  }
  function ad(i) {
    var o = pc.current;
    Yn(pc), i._currentValue = o;
  }
  function Wa(i, o, v) {
    for (; i !== null; ) {
      var w = i.alternate;
      if ((i.childLanes & o) !== o ? (i.childLanes |= o, w !== null && (w.childLanes |= o)) : w !== null && (w.childLanes & o) !== o && (w.childLanes |= o), i === v) break;
      i = i.return;
    }
  }
  function Xu(i, o) {
    tl = i, Q1 = Qu = null, i = i.dependencies, i !== null && i.firstContext !== null && (i.lanes & o && (ua = !0), i.firstContext = null);
  }
  function nl(i) {
    var o = i._currentValue;
    if (Q1 !== i) if (i = { context: i, memoizedValue: o, next: null }, Qu === null) {
      if (tl === null) throw Error(a(308));
      Qu = i, tl.dependencies = { lanes: 0, firstContext: i };
    } else Qu = Qu.next = i;
    return o;
  }
  var ao = null;
  function Ju(i) {
    ao === null ? ao = [i] : ao.push(i);
  }
  function id(i, o, v, w) {
    var C = o.interleaved;
    return C === null ? (v.next = v, Ju(o)) : (v.next = C.next, C.next = v), o.interleaved = v, mu(i, w);
  }
  function mu(i, o) {
    i.lanes |= o;
    var v = i.alternate;
    for (v !== null && (v.lanes |= o), v = i, i = i.return; i !== null; ) i.childLanes |= o, v = i.alternate, v !== null && (v.childLanes |= o), v = i, i = i.return;
    return v.tag === 3 ? v.stateNode : null;
  }
  var Al = !1;
  function ld(i) {
    i.updateQueue = { baseState: i.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function vv(i, o) {
    i = i.updateQueue, o.updateQueue === i && (o.updateQueue = { baseState: i.baseState, firstBaseUpdate: i.firstBaseUpdate, lastBaseUpdate: i.lastBaseUpdate, shared: i.shared, effects: i.effects });
  }
  function gu(i, o) {
    return { eventTime: i, lane: o, tag: 0, payload: null, callback: null, next: null };
  }
  function rl(i, o, v) {
    var w = i.updateQueue;
    if (w === null) return null;
    if (w = w.shared, On & 2) {
      var C = w.pending;
      return C === null ? o.next = o : (o.next = C.next, C.next = o), w.pending = o, mu(i, v);
    }
    return C = w.interleaved, C === null ? (o.next = o, Ju(w)) : (o.next = C.next, C.next = o), w.interleaved = o, mu(i, v);
  }
  function mc(i, o, v) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (v & 4194240) !== 0)) {
      var w = o.lanes;
      w &= i.pendingLanes, v |= w, o.lanes = v, Hn(i, v);
    }
  }
  function pv(i, o) {
    var v = i.updateQueue, w = i.alternate;
    if (w !== null && (w = w.updateQueue, v === w)) {
      var C = null, E = null;
      if (v = v.firstBaseUpdate, v !== null) {
        do {
          var Z = { eventTime: v.eventTime, lane: v.lane, tag: v.tag, payload: v.payload, callback: v.callback, next: null };
          E === null ? C = E = Z : E = E.next = Z, v = v.next;
        } while (v !== null);
        E === null ? C = E = o : E = E.next = o;
      } else C = E = o;
      v = { baseState: w.baseState, firstBaseUpdate: C, lastBaseUpdate: E, shared: w.shared, effects: w.effects }, i.updateQueue = v;
      return;
    }
    i = v.lastBaseUpdate, i === null ? v.firstBaseUpdate = o : i.next = o, v.lastBaseUpdate = o;
  }
  function X1(i, o, v, w) {
    var C = i.updateQueue;
    Al = !1;
    var E = C.firstBaseUpdate, Z = C.lastBaseUpdate, W = C.shared.pending;
    if (W !== null) {
      C.shared.pending = null;
      var ee = W, xe = ee.next;
      ee.next = null, Z === null ? E = xe : Z.next = xe, Z = ee;
      var Ve = i.alternate;
      Ve !== null && (Ve = Ve.updateQueue, W = Ve.lastBaseUpdate, W !== Z && (W === null ? Ve.firstBaseUpdate = xe : W.next = xe, Ve.lastBaseUpdate = ee));
    }
    if (E !== null) {
      var Ye = C.baseState;
      Z = 0, Ve = xe = ee = null, W = E;
      do {
        var Ne = W.lane, ot = W.eventTime;
        if ((w & Ne) === Ne) {
          Ve !== null && (Ve = Ve.next = {
            eventTime: ot,
            lane: 0,
            tag: W.tag,
            payload: W.payload,
            callback: W.callback,
            next: null
          });
          e: {
            var yt = i, Ct = W;
            switch (Ne = o, ot = v, Ct.tag) {
              case 1:
                if (yt = Ct.payload, typeof yt == "function") {
                  Ye = yt.call(ot, Ye, Ne);
                  break e;
                }
                Ye = yt;
                break e;
              case 3:
                yt.flags = yt.flags & -65537 | 128;
              case 0:
                if (yt = Ct.payload, Ne = typeof yt == "function" ? yt.call(ot, Ye, Ne) : yt, Ne == null) break e;
                Ye = Pe({}, Ye, Ne);
                break e;
              case 2:
                Al = !0;
            }
          }
          W.callback !== null && W.lane !== 0 && (i.flags |= 64, Ne = C.effects, Ne === null ? C.effects = [W] : Ne.push(W));
        } else ot = { eventTime: ot, lane: Ne, tag: W.tag, payload: W.payload, callback: W.callback, next: null }, Ve === null ? (xe = Ve = ot, ee = Ye) : Ve = Ve.next = ot, Z |= Ne;
        if (W = W.next, W === null) {
          if (W = C.shared.pending, W === null) break;
          Ne = W, W = Ne.next, Ne.next = null, C.lastBaseUpdate = Ne, C.shared.pending = null;
        }
      } while (!0);
      if (Ve === null && (ee = Ye), C.baseState = ee, C.firstBaseUpdate = xe, C.lastBaseUpdate = Ve, o = C.shared.interleaved, o !== null) {
        C = o;
        do
          Z |= C.lane, C = C.next;
        while (C !== o);
      } else E === null && (C.shared.lanes = 0);
      ds |= Z, i.lanes = Z, i.memoizedState = Ye;
    }
  }
  function Fh(i, o, v) {
    if (i = o.effects, o.effects = null, i !== null) for (o = 0; o < i.length; o++) {
      var w = i[o], C = w.callback;
      if (C !== null) {
        if (w.callback = null, w = v, typeof C != "function") throw Error(a(191, C));
        C.call(w);
      }
    }
  }
  var gc = {}, No = la(gc), wc = la(gc), Ys = la(gc);
  function wu(i) {
    if (i === gc) throw Error(a(174));
    return i;
  }
  function od(i, o) {
    switch ($n(Ys, o), $n(wc, i), $n(No, gc), i = o.nodeType, i) {
      case 9:
      case 11:
        o = (o = o.documentElement) ? o.namespaceURI : Cn(null, "");
        break;
      default:
        i = i === 8 ? o.parentNode : o, o = i.namespaceURI || null, i = i.tagName, o = Cn(o, i);
    }
    Yn(No), $n(No, o);
  }
  function es() {
    Yn(No), Yn(wc), Yn(Ys);
  }
  function Uh(i) {
    wu(Ys.current);
    var o = wu(No.current), v = Cn(o, i.type);
    o !== v && ($n(wc, i), $n(No, v));
  }
  function J1(i) {
    wc.current === i && (Yn(No), Yn(wc));
  }
  var et = la(0);
  function on(i) {
    for (var o = i; o !== null; ) {
      if (o.tag === 13) {
        var v = o.memoizedState;
        if (v !== null && (v = v.dehydrated, v === null || v.data === "$?" || v.data === "$!")) return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if (o.flags & 128) return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === i) break;
      for (; o.sibling === null; ) {
        if (o.return === null || o.return === i) return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  var Nn = [];
  function _r() {
    for (var i = 0; i < Nn.length; i++) Nn[i]._workInProgressVersionPrimary = null;
    Nn.length = 0;
  }
  var Zi = z.ReactCurrentDispatcher, ud = z.ReactCurrentBatchConfig, ts = 0, kr = null, Wr = null, zr = null, He = !1, Nr = !1, It = 0, tn = 0;
  function Tr() {
    throw Error(a(321));
  }
  function yu(i, o) {
    if (o === null) return !1;
    for (var v = 0; v < o.length && v < i.length; v++) if (!pe(i[v], o[v])) return !1;
    return !0;
  }
  function ni(i, o, v, w, C, E) {
    if (ts = E, kr = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, Zi.current = i === null || i.memoizedState === null ? Jp : cd, i = v(w, C), Nr) {
      E = 0;
      do {
        if (Nr = !1, It = 0, 25 <= E) throw Error(a(301));
        E += 1, zr = Wr = null, o.updateQueue = null, Zi.current = o0, i = v(w, C);
      } while (Nr);
    }
    if (Zi.current = qs, o = Wr !== null && Wr.next !== null, ts = 0, zr = Wr = kr = null, He = !1, o) throw Error(a(300));
    return i;
  }
  function ns() {
    var i = It !== 0;
    return It = 0, i;
  }
  function mi() {
    var i = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return zr === null ? kr.memoizedState = zr = i : zr = zr.next = i, zr;
  }
  function ri() {
    if (Wr === null) {
      var i = kr.alternate;
      i = i !== null ? i.memoizedState : null;
    } else i = Wr.next;
    var o = zr === null ? kr.memoizedState : zr.next;
    if (o !== null) zr = o, Wr = i;
    else {
      if (i === null) throw Error(a(310));
      Wr = i, i = { memoizedState: Wr.memoizedState, baseState: Wr.baseState, baseQueue: Wr.baseQueue, queue: Wr.queue, next: null }, zr === null ? kr.memoizedState = zr = i : zr = zr.next = i;
    }
    return zr;
  }
  function ba(i, o) {
    return typeof o == "function" ? o(i) : o;
  }
  function yc(i) {
    var o = ri(), v = o.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = i;
    var w = Wr, C = w.baseQueue, E = v.pending;
    if (E !== null) {
      if (C !== null) {
        var Z = C.next;
        C.next = E.next, E.next = Z;
      }
      w.baseQueue = C = E, v.pending = null;
    }
    if (C !== null) {
      E = C.next, w = w.baseState;
      var W = Z = null, ee = null, xe = E;
      do {
        var Ve = xe.lane;
        if ((ts & Ve) === Ve) ee !== null && (ee = ee.next = { lane: 0, action: xe.action, hasEagerState: xe.hasEagerState, eagerState: xe.eagerState, next: null }), w = xe.hasEagerState ? xe.eagerState : i(w, xe.action);
        else {
          var Ye = {
            lane: Ve,
            action: xe.action,
            hasEagerState: xe.hasEagerState,
            eagerState: xe.eagerState,
            next: null
          };
          ee === null ? (W = ee = Ye, Z = w) : ee = ee.next = Ye, kr.lanes |= Ve, ds |= Ve;
        }
        xe = xe.next;
      } while (xe !== null && xe !== E);
      ee === null ? Z = w : ee.next = W, pe(w, o.memoizedState) || (ua = !0), o.memoizedState = w, o.baseState = Z, o.baseQueue = ee, v.lastRenderedState = w;
    }
    if (i = v.interleaved, i !== null) {
      C = i;
      do
        E = C.lane, kr.lanes |= E, ds |= E, C = C.next;
      while (C !== i);
    } else C === null && (v.lanes = 0);
    return [o.memoizedState, v.dispatch];
  }
  function rs(i) {
    var o = ri(), v = o.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = i;
    var w = v.dispatch, C = v.pending, E = o.memoizedState;
    if (C !== null) {
      v.pending = null;
      var Z = C = C.next;
      do
        E = i(E, Z.action), Z = Z.next;
      while (Z !== C);
      pe(E, o.memoizedState) || (ua = !0), o.memoizedState = E, o.baseQueue === null && (o.baseState = E), v.lastRenderedState = E;
    }
    return [E, w];
  }
  function e0() {
  }
  function xc(i, o) {
    var v = kr, w = ri(), C = o(), E = !pe(w.memoizedState, C);
    if (E && (w.memoizedState = C, ua = !0), w = w.queue, gi(io.bind(null, v, w, i), [i]), w.getSnapshot !== o || E || zr !== null && zr.memoizedState.tag & 1) {
      if (v.flags |= 2048, as(9, ai.bind(null, v, w, C, o), void 0, null), Ma === null) throw Error(a(349));
      ts & 30 || Sc(v, o, C);
    }
    return C;
  }
  function Sc(i, o, v) {
    i.flags |= 16384, i = { getSnapshot: o, value: v }, o = kr.updateQueue, o === null ? (o = { lastEffect: null, stores: null }, kr.updateQueue = o, o.stores = [i]) : (v = o.stores, v === null ? o.stores = [i] : v.push(i));
  }
  function ai(i, o, v, w) {
    o.value = v, o.getSnapshot = w, t0(o) && Cc(i);
  }
  function io(i, o, v) {
    return v(function() {
      t0(o) && Cc(i);
    });
  }
  function t0(i) {
    var o = i.getSnapshot;
    i = i.value;
    try {
      var v = o();
      return !pe(i, v);
    } catch {
      return !0;
    }
  }
  function Cc(i) {
    var o = mu(i, 1);
    o !== null && ol(o, i, 1, -1);
  }
  function $s(i) {
    var o = mi();
    return typeof i == "function" && (i = i()), o.memoizedState = o.baseState = i, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: ba, lastRenderedState: i }, o.queue = i, i = i.dispatch = fr.bind(null, kr, i), [o.memoizedState, i];
  }
  function as(i, o, v, w) {
    return i = { tag: i, create: o, destroy: v, deps: w, next: null }, o = kr.updateQueue, o === null ? (o = { lastEffect: null, stores: null }, kr.updateQueue = o, o.lastEffect = i.next = i) : (v = o.lastEffect, v === null ? o.lastEffect = i.next = i : (w = v.next, v.next = i, i.next = w, o.lastEffect = i)), i;
  }
  function n0() {
    return ri().memoizedState;
  }
  function Ws(i, o, v, w) {
    var C = mi();
    kr.flags |= i, C.memoizedState = as(1 | o, v, void 0, w === void 0 ? null : w);
  }
  function is(i, o, v, w) {
    var C = ri();
    w = w === void 0 ? null : w;
    var E = void 0;
    if (Wr !== null) {
      var Z = Wr.memoizedState;
      if (E = Z.destroy, w !== null && yu(w, Z.deps)) {
        C.memoizedState = as(o, v, E, w);
        return;
      }
    }
    kr.flags |= i, C.memoizedState = as(1 | o, v, E, w);
  }
  function zs(i, o) {
    return Ws(8390656, 8, i, o);
  }
  function gi(i, o) {
    return is(2048, 8, i, o);
  }
  function sd(i, o) {
    return is(4, 2, i, o);
  }
  function lo(i, o) {
    return is(4, 4, i, o);
  }
  function bc(i, o) {
    if (typeof o == "function") return i = i(), o(i), function() {
      o(null);
    };
    if (o != null) return i = i(), o.current = i, function() {
      o.current = null;
    };
  }
  function _c(i, o, v) {
    return v = v != null ? v.concat([i]) : null, is(4, 4, bc.bind(null, o, i), v);
  }
  function r0() {
  }
  function a0(i, o) {
    var v = ri();
    o = o === void 0 ? null : o;
    var w = v.memoizedState;
    return w !== null && o !== null && yu(o, w[1]) ? w[0] : (v.memoizedState = [i, o], i);
  }
  function Yh(i, o) {
    var v = ri();
    o = o === void 0 ? null : o;
    var w = v.memoizedState;
    return w !== null && o !== null && yu(o, w[1]) ? w[0] : (i = i(), v.memoizedState = [i, o], i);
  }
  function i0(i, o, v) {
    return ts & 21 ? (pe(v, o) || (v = Oh(), kr.lanes |= v, ds |= v, i.baseState = !0), o) : (i.baseState && (i.baseState = !1, ua = !0), i.memoizedState = v);
  }
  function ls(i, o) {
    var v = Fn;
    Fn = v !== 0 && 4 > v ? v : 4, i(!0);
    var w = ud.transition;
    ud.transition = {};
    try {
      i(!1), o();
    } finally {
      Fn = v, ud.transition = w;
    }
  }
  function Pi() {
    return ri().memoizedState;
  }
  function Xp(i, o, v) {
    var w = Yo(i);
    if (v = { lane: w, action: v, hasEagerState: !1, eagerState: null, next: null }, l0(i)) _a(o, v);
    else if (v = id(i, o, v, w), v !== null) {
      var C = yi();
      ol(v, i, w, C), wi(v, o, w);
    }
  }
  function fr(i, o, v) {
    var w = Yo(i), C = { lane: w, action: v, hasEagerState: !1, eagerState: null, next: null };
    if (l0(i)) _a(o, C);
    else {
      var E = i.alternate;
      if (i.lanes === 0 && (E === null || E.lanes === 0) && (E = o.lastRenderedReducer, E !== null)) try {
        var Z = o.lastRenderedState, W = E(Z, v);
        if (C.hasEagerState = !0, C.eagerState = W, pe(W, Z)) {
          var ee = o.interleaved;
          ee === null ? (C.next = C, Ju(o)) : (C.next = ee.next, ee.next = C), o.interleaved = C;
          return;
        }
      } catch {
      } finally {
      }
      v = id(i, o, C, w), v !== null && (C = yi(), ol(v, i, w, C), wi(v, o, w));
    }
  }
  function l0(i) {
    var o = i.alternate;
    return i === kr || o !== null && o === kr;
  }
  function _a(i, o) {
    Nr = He = !0;
    var v = i.pending;
    v === null ? o.next = o : (o.next = v.next, v.next = o), i.pending = o;
  }
  function wi(i, o, v) {
    if (v & 4194240) {
      var w = o.lanes;
      w &= i.pendingLanes, v |= w, o.lanes = v, Hn(i, v);
    }
  }
  var qs = { readContext: nl, useCallback: Tr, useContext: Tr, useEffect: Tr, useImperativeHandle: Tr, useInsertionEffect: Tr, useLayoutEffect: Tr, useMemo: Tr, useReducer: Tr, useRef: Tr, useState: Tr, useDebugValue: Tr, useDeferredValue: Tr, useTransition: Tr, useMutableSource: Tr, useSyncExternalStore: Tr, useId: Tr, unstable_isNewReconciler: !1 }, Jp = { readContext: nl, useCallback: function(i, o) {
    return mi().memoizedState = [i, o === void 0 ? null : o], i;
  }, useContext: nl, useEffect: zs, useImperativeHandle: function(i, o, v) {
    return v = v != null ? v.concat([i]) : null, Ws(
      4194308,
      4,
      bc.bind(null, o, i),
      v
    );
  }, useLayoutEffect: function(i, o) {
    return Ws(4194308, 4, i, o);
  }, useInsertionEffect: function(i, o) {
    return Ws(4, 2, i, o);
  }, useMemo: function(i, o) {
    var v = mi();
    return o = o === void 0 ? null : o, i = i(), v.memoizedState = [i, o], i;
  }, useReducer: function(i, o, v) {
    var w = mi();
    return o = v !== void 0 ? v(o) : o, w.memoizedState = w.baseState = o, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: i, lastRenderedState: o }, w.queue = i, i = i.dispatch = Xp.bind(null, kr, i), [w.memoizedState, i];
  }, useRef: function(i) {
    var o = mi();
    return i = { current: i }, o.memoizedState = i;
  }, useState: $s, useDebugValue: r0, useDeferredValue: function(i) {
    return mi().memoizedState = i;
  }, useTransition: function() {
    var i = $s(!1), o = i[0];
    return i = ls.bind(null, i[1]), mi().memoizedState = i, [o, i];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(i, o, v) {
    var w = kr, C = mi();
    if (br) {
      if (v === void 0) throw Error(a(407));
      v = v();
    } else {
      if (v = o(), Ma === null) throw Error(a(349));
      ts & 30 || Sc(w, o, v);
    }
    C.memoizedState = v;
    var E = { value: v, getSnapshot: o };
    return C.queue = E, zs(io.bind(
      null,
      w,
      E,
      i
    ), [i]), w.flags |= 2048, as(9, ai.bind(null, w, E, v, o), void 0, null), v;
  }, useId: function() {
    var i = mi(), o = Ma.identifierPrefix;
    if (br) {
      var v = to, w = Io;
      v = (w & ~(1 << 32 - Wi(w) - 1)).toString(32) + v, o = ":" + o + "R" + v, v = It++, 0 < v && (o += "H" + v.toString(32)), o += ":";
    } else v = tn++, o = ":" + o + "r" + v.toString(32) + ":";
    return i.memoizedState = o;
  }, unstable_isNewReconciler: !1 }, cd = {
    readContext: nl,
    useCallback: a0,
    useContext: nl,
    useEffect: gi,
    useImperativeHandle: _c,
    useInsertionEffect: sd,
    useLayoutEffect: lo,
    useMemo: Yh,
    useReducer: yc,
    useRef: n0,
    useState: function() {
      return yc(ba);
    },
    useDebugValue: r0,
    useDeferredValue: function(i) {
      var o = ri();
      return i0(o, Wr.memoizedState, i);
    },
    useTransition: function() {
      var i = yc(ba)[0], o = ri().memoizedState;
      return [i, o];
    },
    useMutableSource: e0,
    useSyncExternalStore: xc,
    useId: Pi,
    unstable_isNewReconciler: !1
  }, o0 = { readContext: nl, useCallback: a0, useContext: nl, useEffect: gi, useImperativeHandle: _c, useInsertionEffect: sd, useLayoutEffect: lo, useMemo: Yh, useReducer: rs, useRef: n0, useState: function() {
    return rs(ba);
  }, useDebugValue: r0, useDeferredValue: function(i) {
    var o = ri();
    return Wr === null ? o.memoizedState = i : i0(o, Wr.memoizedState, i);
  }, useTransition: function() {
    var i = rs(ba)[0], o = ri().memoizedState;
    return [i, o];
  }, useMutableSource: e0, useSyncExternalStore: xc, useId: Pi, unstable_isNewReconciler: !1 };
  function kl(i, o) {
    if (i && i.defaultProps) {
      o = Pe({}, o), i = i.defaultProps;
      for (var v in i) o[v] === void 0 && (o[v] = i[v]);
      return o;
    }
    return o;
  }
  function u0(i, o, v, w) {
    o = i.memoizedState, v = v(w, o), v = v == null ? o : Pe({}, o, v), i.memoizedState = v, i.lanes === 0 && (i.updateQueue.baseState = v);
  }
  var fd = { isMounted: function(i) {
    return (i = i._reactInternals) ? xn(i) === i : !1;
  }, enqueueSetState: function(i, o, v) {
    i = i._reactInternals;
    var w = yi(), C = Yo(i), E = gu(w, C);
    E.payload = o, v != null && (E.callback = v), o = rl(i, E, C), o !== null && (ol(o, i, C, w), mc(o, i, C));
  }, enqueueReplaceState: function(i, o, v) {
    i = i._reactInternals;
    var w = yi(), C = Yo(i), E = gu(w, C);
    E.tag = 1, E.payload = o, v != null && (E.callback = v), o = rl(i, E, C), o !== null && (ol(o, i, C, w), mc(o, i, C));
  }, enqueueForceUpdate: function(i, o) {
    i = i._reactInternals;
    var v = yi(), w = Yo(i), C = gu(v, w);
    C.tag = 2, o != null && (C.callback = o), o = rl(i, C, w), o !== null && (ol(o, i, w, v), mc(o, i, w));
  } };
  function Rc(i, o, v, w, C, E, Z) {
    return i = i.stateNode, typeof i.shouldComponentUpdate == "function" ? i.shouldComponentUpdate(w, E, Z) : o.prototype && o.prototype.isPureReactComponent ? !Je(v, w) || !Je(C, E) : !0;
  }
  function os(i, o, v) {
    var w = !1, C = pi, E = o.contextType;
    return typeof E == "object" && E !== null ? E = nl(E) : (C = Ua(o) ? Fa : Zr.current, w = o.contextTypes, E = (w = w != null) ? G1(i, C) : pi), o = new o(v, E), i.memoizedState = o.state !== null && o.state !== void 0 ? o.state : null, o.updater = fd, i.stateNode = o, o._reactInternals = i, w && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = C, i.__reactInternalMemoizedMaskedChildContext = E), o;
  }
  function s0(i, o, v, w) {
    i = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(v, w), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(v, w), o.state !== i && fd.enqueueReplaceState(o, o.state, null);
  }
  function $h(i, o, v, w) {
    var C = i.stateNode;
    C.props = v, C.state = i.memoizedState, C.refs = {}, ld(i);
    var E = o.contextType;
    typeof E == "object" && E !== null ? C.context = nl(E) : (E = Ua(o) ? Fa : Zr.current, C.context = G1(i, E)), C.state = i.memoizedState, E = o.getDerivedStateFromProps, typeof E == "function" && (u0(i, o, E, v), C.state = i.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function" || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (o = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), o !== C.state && fd.enqueueReplaceState(C, C.state, null), X1(i, v, C, w), C.state = i.memoizedState), typeof C.componentDidMount == "function" && (i.flags |= 4194308);
  }
  function Vo(i, o) {
    try {
      var v = "", w = o;
      do
        v += Qe(w), w = w.return;
      while (w);
      var C = v;
    } catch (E) {
      C = `
Error generating stack: ` + E.message + `
` + E.stack;
    }
    return { value: i, source: o, stack: C, digest: null };
  }
  function dd(i, o, v) {
    return { value: i, source: null, stack: v ?? null, digest: o ?? null };
  }
  function Gs(i, o) {
    try {
      console.error(o.value);
    } catch (v) {
      setTimeout(function() {
        throw v;
      });
    }
  }
  var Wh = typeof WeakMap == "function" ? WeakMap : Map;
  function Ec(i, o, v) {
    v = gu(-1, v), v.tag = 3, v.payload = { element: null };
    var w = o.value;
    return v.callback = function() {
      Cd || (Cd = !0, bd = w), Gs(i, o);
    }, v;
  }
  function Bo(i, o, v) {
    v = gu(-1, v), v.tag = 3;
    var w = i.type.getDerivedStateFromError;
    if (typeof w == "function") {
      var C = o.value;
      v.payload = function() {
        return w(C);
      }, v.callback = function() {
        Gs(i, o);
      };
    }
    var E = i.stateNode;
    return E !== null && typeof E.componentDidCatch == "function" && (v.callback = function() {
      Gs(i, o), typeof w != "function" && (Eu === null ? Eu = /* @__PURE__ */ new Set([this]) : Eu.add(this));
      var Z = o.stack;
      this.componentDidCatch(o.value, { componentStack: Z !== null ? Z : "" });
    }), v;
  }
  function xu(i, o, v) {
    var w = i.pingCache;
    if (w === null) {
      w = i.pingCache = new Wh();
      var C = /* @__PURE__ */ new Set();
      w.set(o, C);
    } else C = w.get(o), C === void 0 && (C = /* @__PURE__ */ new Set(), w.set(o, C));
    C.has(v) || (C.add(v), i = bv.bind(null, i, o, v), o.then(i, i));
  }
  function us(i) {
    do {
      var o;
      if ((o = i.tag === 13) && (o = i.memoizedState, o = o !== null ? o.dehydrated !== null : !0), o) return i;
      i = i.return;
    } while (i !== null);
    return null;
  }
  function Mc(i, o, v, w, C) {
    return i.mode & 1 ? (i.flags |= 65536, i.lanes = C, i) : (i === o ? i.flags |= 65536 : (i.flags |= 128, v.flags |= 131072, v.flags &= -52805, v.tag === 1 && (v.alternate === null ? v.tag = 17 : (o = gu(-1, 1), o.tag = 2, rl(v, o, 1))), v.lanes |= 1), i);
  }
  var ii = z.ReactCurrentOwner, ua = !1;
  function jt(i, o, v, w) {
    o.child = i === null ? rd(o, null, v, w) : Pn(o, i.child, v, w);
  }
  function Tc(i, o, v, w, C) {
    v = v.render;
    var E = o.ref;
    return Xu(o, C), w = ni(i, o, v, w, E, C), v = ns(), i !== null && !ua ? (o.updateQueue = i.updateQueue, o.flags &= -2053, i.lanes &= ~C, rr(i, o, C)) : (br && v && K1(o), o.flags |= 1, jt(i, o, w, C), o.child);
  }
  function hd(i, o, v, w, C) {
    if (i === null) {
      var E = v.type;
      return typeof E == "function" && !Zc(E) && E.defaultProps === void 0 && v.compare === null && v.defaultProps === void 0 ? (o.tag = 15, o.type = E, Su(i, o, E, w, C)) : (i = Od(v.type, null, w, o, o.mode, C), i.ref = o.ref, i.return = o, o.child = i);
    }
    if (E = i.child, !(i.lanes & C)) {
      var Z = E.memoizedProps;
      if (v = v.compare, v = v !== null ? v : Je, v(Z, w) && i.ref === o.ref) return rr(i, o, C);
    }
    return o.flags |= 1, i = xi(E, w), i.ref = o.ref, i.return = o, o.child = i;
  }
  function Su(i, o, v, w, C) {
    if (i !== null) {
      var E = i.memoizedProps;
      if (Je(E, w) && i.ref === o.ref) if (ua = !1, o.pendingProps = w = E, (i.lanes & C) !== 0) i.flags & 131072 && (ua = !0);
      else return o.lanes = i.lanes, rr(i, o, C);
    }
    return Ks(i, o, v, w, C);
  }
  function zh(i, o, v) {
    var w = o.pendingProps, C = w.children, E = i !== null ? i.memoizedState : null;
    if (w.mode === "hidden") if (!(o.mode & 1)) o.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, $n(_u, ll), ll |= v;
    else {
      if (!(v & 1073741824)) return i = E !== null ? E.baseLanes | v : v, o.lanes = o.childLanes = 1073741824, o.memoizedState = { baseLanes: i, cachePool: null, transitions: null }, o.updateQueue = null, $n(_u, ll), ll |= i, null;
      o.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, w = E !== null ? E.baseLanes : v, $n(_u, ll), ll |= w;
    }
    else E !== null ? (w = E.baseLanes | v, o.memoizedState = null) : w = v, $n(_u, ll), ll |= w;
    return jt(i, o, C, v), o.child;
  }
  function Oc(i, o) {
    var v = o.ref;
    (i === null && v !== null || i !== null && i.ref !== v) && (o.flags |= 512, o.flags |= 2097152);
  }
  function Ks(i, o, v, w, C) {
    var E = Ua(v) ? Fa : Zr.current;
    return E = G1(o, E), Xu(o, C), v = ni(i, o, v, w, E, C), w = ns(), i !== null && !ua ? (o.updateQueue = i.updateQueue, o.flags &= -2053, i.lanes &= ~C, rr(i, o, C)) : (br && w && K1(o), o.flags |= 1, jt(i, o, v, C), o.child);
  }
  function qh(i, o, v, w, C) {
    if (Ua(v)) {
      var E = !0;
      Ii(o);
    } else E = !1;
    if (Xu(o, C), o.stateNode === null) Ni(i, o), os(o, v, w), $h(o, v, w, C), w = !0;
    else if (i === null) {
      var Z = o.stateNode, W = o.memoizedProps;
      Z.props = W;
      var ee = Z.context, xe = v.contextType;
      typeof xe == "object" && xe !== null ? xe = nl(xe) : (xe = Ua(v) ? Fa : Zr.current, xe = G1(o, xe));
      var Ve = v.getDerivedStateFromProps, Ye = typeof Ve == "function" || typeof Z.getSnapshotBeforeUpdate == "function";
      Ye || typeof Z.UNSAFE_componentWillReceiveProps != "function" && typeof Z.componentWillReceiveProps != "function" || (W !== w || ee !== xe) && s0(o, Z, w, xe), Al = !1;
      var Ne = o.memoizedState;
      Z.state = Ne, X1(o, w, Z, C), ee = o.memoizedState, W !== w || Ne !== ee || oa.current || Al ? (typeof Ve == "function" && (u0(o, v, Ve, w), ee = o.memoizedState), (W = Al || Rc(o, v, W, w, Ne, ee, xe)) ? (Ye || typeof Z.UNSAFE_componentWillMount != "function" && typeof Z.componentWillMount != "function" || (typeof Z.componentWillMount == "function" && Z.componentWillMount(), typeof Z.UNSAFE_componentWillMount == "function" && Z.UNSAFE_componentWillMount()), typeof Z.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof Z.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = w, o.memoizedState = ee), Z.props = w, Z.state = ee, Z.context = xe, w = W) : (typeof Z.componentDidMount == "function" && (o.flags |= 4194308), w = !1);
    } else {
      Z = o.stateNode, vv(i, o), W = o.memoizedProps, xe = o.type === o.elementType ? W : kl(o.type, W), Z.props = xe, Ye = o.pendingProps, Ne = Z.context, ee = v.contextType, typeof ee == "object" && ee !== null ? ee = nl(ee) : (ee = Ua(v) ? Fa : Zr.current, ee = G1(o, ee));
      var ot = v.getDerivedStateFromProps;
      (Ve = typeof ot == "function" || typeof Z.getSnapshotBeforeUpdate == "function") || typeof Z.UNSAFE_componentWillReceiveProps != "function" && typeof Z.componentWillReceiveProps != "function" || (W !== Ye || Ne !== ee) && s0(o, Z, w, ee), Al = !1, Ne = o.memoizedState, Z.state = Ne, X1(o, w, Z, C);
      var yt = o.memoizedState;
      W !== Ye || Ne !== yt || oa.current || Al ? (typeof ot == "function" && (u0(o, v, ot, w), yt = o.memoizedState), (xe = Al || Rc(o, v, xe, w, Ne, yt, ee) || !1) ? (Ve || typeof Z.UNSAFE_componentWillUpdate != "function" && typeof Z.componentWillUpdate != "function" || (typeof Z.componentWillUpdate == "function" && Z.componentWillUpdate(w, yt, ee), typeof Z.UNSAFE_componentWillUpdate == "function" && Z.UNSAFE_componentWillUpdate(w, yt, ee)), typeof Z.componentDidUpdate == "function" && (o.flags |= 4), typeof Z.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof Z.componentDidUpdate != "function" || W === i.memoizedProps && Ne === i.memoizedState || (o.flags |= 4), typeof Z.getSnapshotBeforeUpdate != "function" || W === i.memoizedProps && Ne === i.memoizedState || (o.flags |= 1024), o.memoizedProps = w, o.memoizedState = yt), Z.props = w, Z.state = yt, Z.context = ee, w = xe) : (typeof Z.componentDidUpdate != "function" || W === i.memoizedProps && Ne === i.memoizedState || (o.flags |= 4), typeof Z.getSnapshotBeforeUpdate != "function" || W === i.memoizedProps && Ne === i.memoizedState || (o.flags |= 1024), w = !1);
    }
    return vd(i, o, v, w, E, C);
  }
  function vd(i, o, v, w, C, E) {
    Oc(i, o);
    var Z = (o.flags & 128) !== 0;
    if (!w && !Z) return C && Gu(o, v, !1), rr(i, o, E);
    w = o.stateNode, ii.current = o;
    var W = Z && typeof v.getDerivedStateFromError != "function" ? null : w.render();
    return o.flags |= 1, i !== null && Z ? (o.child = Pn(o, i.child, null, E), o.child = Pn(o, null, W, E)) : jt(i, o, W, E), o.memoizedState = w.state, C && Gu(o, v, !0), o.child;
  }
  function mv(i) {
    var o = i.stateNode;
    o.pendingContext ? Jf(i, o.pendingContext, o.pendingContext !== o.context) : o.context && Jf(i, o.context, !1), od(i, o.containerInfo);
  }
  function Ll(i, o, v, w, C) {
    return Dl(), Zo(C), o.flags |= 256, jt(i, o, v, w), o.child;
  }
  var Dc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function c0(i) {
    return { baseLanes: i, cachePool: null, transitions: null };
  }
  function jc(i, o, v) {
    var w = o.pendingProps, C = et.current, E = !1, Z = (o.flags & 128) !== 0, W;
    if ((W = Z) || (W = i !== null && i.memoizedState === null ? !1 : (C & 2) !== 0), W ? (E = !0, o.flags &= -129) : (i === null || i.memoizedState !== null) && (C |= 1), $n(et, C & 1), i === null)
      return $a(o), i = o.memoizedState, i !== null && (i = i.dehydrated, i !== null) ? (o.mode & 1 ? i.data === "$!" ? o.lanes = 8 : o.lanes = 1073741824 : o.lanes = 1, null) : (Z = w.children, i = w.fallback, E ? (w = o.mode, E = o.child, Z = { mode: "hidden", children: Z }, !(w & 1) && E !== null ? (E.childLanes = 0, E.pendingProps = Z) : E = Pc(Z, w, 0, null), i = ps(i, w, v, null), E.return = o, i.return = o, E.sibling = i, o.child = E, o.child.memoizedState = c0(v), o.memoizedState = Dc, i) : Qs(o, Z));
    if (C = i.memoizedState, C !== null && (W = C.dehydrated, W !== null)) return Dt(i, o, Z, w, W, C, v);
    if (E) {
      E = w.fallback, Z = o.mode, C = i.child, W = C.sibling;
      var ee = { mode: "hidden", children: w.children };
      return !(Z & 1) && o.child !== C ? (w = o.child, w.childLanes = 0, w.pendingProps = ee, o.deletions = null) : (w = xi(C, ee), w.subtreeFlags = C.subtreeFlags & 14680064), W !== null ? E = xi(W, E) : (E = ps(E, Z, v, null), E.flags |= 2), E.return = o, w.return = o, w.sibling = E, o.child = w, w = E, E = o.child, Z = i.child.memoizedState, Z = Z === null ? c0(v) : { baseLanes: Z.baseLanes | v, cachePool: null, transitions: Z.transitions }, E.memoizedState = Z, E.childLanes = i.childLanes & ~v, o.memoizedState = Dc, w;
    }
    return E = i.child, i = E.sibling, w = xi(E, { mode: "visible", children: w.children }), !(o.mode & 1) && (w.lanes = v), w.return = o, w.sibling = null, i !== null && (v = o.deletions, v === null ? (o.deletions = [i], o.flags |= 16) : v.push(i)), o.child = w, o.memoizedState = null, w;
  }
  function Qs(i, o) {
    return o = Pc({ mode: "visible", children: o }, i.mode, 0, null), o.return = i, i.child = o;
  }
  function qr(i, o, v, w) {
    return w !== null && Zo(w), Pn(o, i.child, null, v), i = Qs(o, o.pendingProps.children), i.flags |= 2, o.memoizedState = null, i;
  }
  function Dt(i, o, v, w, C, E, Z) {
    if (v)
      return o.flags & 256 ? (o.flags &= -257, w = dd(Error(a(422))), qr(i, o, Z, w)) : o.memoizedState !== null ? (o.child = i.child, o.flags |= 128, null) : (E = w.fallback, C = o.mode, w = Pc({ mode: "visible", children: w.children }, C, 0, null), E = ps(E, C, Z, null), E.flags |= 2, w.return = o, E.return = o, w.sibling = E, o.child = w, o.mode & 1 && Pn(o, i.child, null, Z), o.child.memoizedState = c0(Z), o.memoizedState = Dc, E);
    if (!(o.mode & 1)) return qr(i, o, Z, null);
    if (C.data === "$!") {
      if (w = C.nextSibling && C.nextSibling.dataset, w) var W = w.dgst;
      return w = W, E = Error(a(419)), w = dd(E, w, void 0), qr(i, o, Z, w);
    }
    if (W = (Z & i.childLanes) !== 0, ua || W) {
      if (w = Ma, w !== null) {
        switch (Z & -Z) {
          case 4:
            C = 2;
            break;
          case 16:
            C = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            C = 32;
            break;
          case 536870912:
            C = 268435456;
            break;
          default:
            C = 0;
        }
        C = C & (w.suspendedLanes | Z) ? 0 : C, C !== 0 && C !== E.retryLane && (E.retryLane = C, mu(i, C), ol(w, i, C, -1));
      }
      return Ed(), w = dd(Error(a(421))), qr(i, o, Z, w);
    }
    return C.data === "$?" ? (o.flags |= 128, o.child = i.child, o = lm.bind(null, i), C._reactRetry = o, null) : (i = E.treeContext, Hi = qu(C.nextSibling), Ya = o, br = !0, no = null, i !== null && (Ji[el++] = Io, Ji[el++] = to, Ji[el++] = Fs, Io = i.id, to = i.overflow, Fs = o), o = Qs(o, w.children), o.flags |= 4096, o);
  }
  function al(i, o, v) {
    i.lanes |= o;
    var w = i.alternate;
    w !== null && (w.lanes |= o), Wa(i.return, o, v);
  }
  function ss(i, o, v, w, C) {
    var E = i.memoizedState;
    E === null ? i.memoizedState = { isBackwards: o, rendering: null, renderingStartTime: 0, last: w, tail: v, tailMode: C } : (E.isBackwards = o, E.rendering = null, E.renderingStartTime = 0, E.last = w, E.tail = v, E.tailMode = C);
  }
  function Il(i, o, v) {
    var w = o.pendingProps, C = w.revealOrder, E = w.tail;
    if (jt(i, o, w.children, v), w = et.current, w & 2) w = w & 1 | 2, o.flags |= 128;
    else {
      if (i !== null && i.flags & 128) e: for (i = o.child; i !== null; ) {
        if (i.tag === 13) i.memoizedState !== null && al(i, v, o);
        else if (i.tag === 19) al(i, v, o);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === o) break e;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === o) break e;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      w &= 1;
    }
    if ($n(et, w), !(o.mode & 1)) o.memoizedState = null;
    else switch (C) {
      case "forwards":
        for (v = o.child, C = null; v !== null; ) i = v.alternate, i !== null && on(i) === null && (C = v), v = v.sibling;
        v = C, v === null ? (C = o.child, o.child = null) : (C = v.sibling, v.sibling = null), ss(o, !1, C, v, E);
        break;
      case "backwards":
        for (v = null, C = o.child, o.child = null; C !== null; ) {
          if (i = C.alternate, i !== null && on(i) === null) {
            o.child = C;
            break;
          }
          i = C.sibling, C.sibling = v, v = C, C = i;
        }
        ss(o, !0, v, null, E);
        break;
      case "together":
        ss(o, !1, null, null, void 0);
        break;
      default:
        o.memoizedState = null;
    }
    return o.child;
  }
  function Ni(i, o) {
    !(o.mode & 1) && i !== null && (i.alternate = null, o.alternate = null, o.flags |= 2);
  }
  function rr(i, o, v) {
    if (i !== null && (o.dependencies = i.dependencies), ds |= o.lanes, !(v & o.childLanes)) return null;
    if (i !== null && o.child !== i.child) throw Error(a(153));
    if (o.child !== null) {
      for (i = o.child, v = xi(i, i.pendingProps), o.child = v, v.return = o; i.sibling !== null; ) i = i.sibling, v = v.sibling = xi(i, i.pendingProps), v.return = o;
      v.sibling = null;
    }
    return o.child;
  }
  function gv(i, o, v) {
    switch (o.tag) {
      case 3:
        mv(o), Dl();
        break;
      case 5:
        Uh(o);
        break;
      case 1:
        Ua(o.type) && Ii(o);
        break;
      case 4:
        od(o, o.stateNode.containerInfo);
        break;
      case 10:
        var w = o.type._context, C = o.memoizedProps.value;
        $n(pc, w._currentValue), w._currentValue = C;
        break;
      case 13:
        if (w = o.memoizedState, w !== null)
          return w.dehydrated !== null ? ($n(et, et.current & 1), o.flags |= 128, null) : v & o.child.childLanes ? jc(i, o, v) : ($n(et, et.current & 1), i = rr(i, o, v), i !== null ? i.sibling : null);
        $n(et, et.current & 1);
        break;
      case 19:
        if (w = (v & o.childLanes) !== 0, i.flags & 128) {
          if (w) return Il(i, o, v);
          o.flags |= 128;
        }
        if (C = o.memoizedState, C !== null && (C.rendering = null, C.tail = null, C.lastEffect = null), $n(et, et.current), w) break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, zh(i, o, v);
    }
    return rr(i, o, v);
  }
  var za, Gh, pd, md;
  za = function(i, o) {
    for (var v = o.child; v !== null; ) {
      if (v.tag === 5 || v.tag === 6) i.appendChild(v.stateNode);
      else if (v.tag !== 4 && v.child !== null) {
        v.child.return = v, v = v.child;
        continue;
      }
      if (v === o) break;
      for (; v.sibling === null; ) {
        if (v.return === null || v.return === o) return;
        v = v.return;
      }
      v.sibling.return = v.return, v = v.sibling;
    }
  }, Gh = function() {
  }, pd = function(i, o, v, w) {
    var C = i.memoizedProps;
    if (C !== w) {
      i = o.stateNode, wu(No.current);
      var E = null;
      switch (v) {
        case "input":
          C = wr(i, C), w = wr(i, w), E = [];
          break;
        case "select":
          C = Pe({}, C, { value: void 0 }), w = Pe({}, w, { value: void 0 }), E = [];
          break;
        case "textarea":
          C = Rn(i, C), w = Rn(i, w), E = [];
          break;
        default:
          typeof C.onClick != "function" && typeof w.onClick == "function" && (i.onclick = fc);
      }
      wn(v, w);
      var Z;
      v = null;
      for (xe in C) if (!w.hasOwnProperty(xe) && C.hasOwnProperty(xe) && C[xe] != null) if (xe === "style") {
        var W = C[xe];
        for (Z in W) W.hasOwnProperty(Z) && (v || (v = {}), v[Z] = "");
      } else xe !== "dangerouslySetInnerHTML" && xe !== "children" && xe !== "suppressContentEditableWarning" && xe !== "suppressHydrationWarning" && xe !== "autoFocus" && (h.hasOwnProperty(xe) ? E || (E = []) : (E = E || []).push(xe, null));
      for (xe in w) {
        var ee = w[xe];
        if (W = C != null ? C[xe] : void 0, w.hasOwnProperty(xe) && ee !== W && (ee != null || W != null)) if (xe === "style") if (W) {
          for (Z in W) !W.hasOwnProperty(Z) || ee && ee.hasOwnProperty(Z) || (v || (v = {}), v[Z] = "");
          for (Z in ee) ee.hasOwnProperty(Z) && W[Z] !== ee[Z] && (v || (v = {}), v[Z] = ee[Z]);
        } else v || (E || (E = []), E.push(
          xe,
          v
        )), v = ee;
        else xe === "dangerouslySetInnerHTML" ? (ee = ee ? ee.__html : void 0, W = W ? W.__html : void 0, ee != null && W !== ee && (E = E || []).push(xe, ee)) : xe === "children" ? typeof ee != "string" && typeof ee != "number" || (E = E || []).push(xe, "" + ee) : xe !== "suppressContentEditableWarning" && xe !== "suppressHydrationWarning" && (h.hasOwnProperty(xe) ? (ee != null && xe === "onScroll" && hr("scroll", i), E || W === ee || (E = [])) : (E = E || []).push(xe, ee));
      }
      v && (E = E || []).push("style", v);
      var xe = E;
      (o.updateQueue = xe) && (o.flags |= 4);
    }
  }, md = function(i, o, v, w) {
    v !== w && (o.flags |= 4);
  };
  function cs(i, o) {
    if (!br) switch (i.tailMode) {
      case "hidden":
        o = i.tail;
        for (var v = null; o !== null; ) o.alternate !== null && (v = o), o = o.sibling;
        v === null ? i.tail = null : v.sibling = null;
        break;
      case "collapsed":
        v = i.tail;
        for (var w = null; v !== null; ) v.alternate !== null && (w = v), v = v.sibling;
        w === null ? o || i.tail === null ? i.tail = null : i.tail.sibling = null : w.sibling = null;
    }
  }
  function Ra(i) {
    var o = i.alternate !== null && i.alternate.child === i.child, v = 0, w = 0;
    if (o) for (var C = i.child; C !== null; ) v |= C.lanes | C.childLanes, w |= C.subtreeFlags & 14680064, w |= C.flags & 14680064, C.return = i, C = C.sibling;
    else for (C = i.child; C !== null; ) v |= C.lanes | C.childLanes, w |= C.subtreeFlags, w |= C.flags, C.return = i, C = C.sibling;
    return i.subtreeFlags |= w, i.childLanes = v, o;
  }
  function em(i, o, v) {
    var w = o.pendingProps;
    switch (Us(o), o.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ra(o), null;
      case 1:
        return Ua(o.type) && Li(), Ra(o), null;
      case 3:
        return w = o.stateNode, es(), Yn(oa), Yn(Zr), _r(), w.pendingContext && (w.context = w.pendingContext, w.pendingContext = null), (i === null || i.child === null) && (ro(o) ? o.flags |= 4 : i === null || i.memoizedState.isDehydrated && !(o.flags & 256) || (o.flags |= 1024, no !== null && (Rd(no), no = null))), Gh(i, o), Ra(o), null;
      case 5:
        J1(o);
        var C = wu(Ys.current);
        if (v = o.type, i !== null && o.stateNode != null) pd(i, o, v, w, C), i.ref !== o.ref && (o.flags |= 512, o.flags |= 2097152);
        else {
          if (!w) {
            if (o.stateNode === null) throw Error(a(166));
            return Ra(o), null;
          }
          if (i = wu(No.current), ro(o)) {
            w = o.stateNode, v = o.type;
            var E = o.memoizedProps;
            switch (w[Tl] = o, w[Qi] = E, i = (o.mode & 1) !== 0, v) {
              case "dialog":
                hr("cancel", w), hr("close", w);
                break;
              case "iframe":
              case "object":
              case "embed":
                hr("load", w);
                break;
              case "video":
              case "audio":
                for (C = 0; C < ki.length; C++) hr(ki[C], w);
                break;
              case "source":
                hr("error", w);
                break;
              case "img":
              case "image":
              case "link":
                hr(
                  "error",
                  w
                ), hr("load", w);
                break;
              case "details":
                hr("toggle", w);
                break;
              case "input":
                ea(w, E), hr("invalid", w);
                break;
              case "select":
                w._wrapperState = { wasMultiple: !!E.multiple }, hr("invalid", w);
                break;
              case "textarea":
                yr(w, E), hr("invalid", w);
            }
            wn(v, E), C = null;
            for (var Z in E) if (E.hasOwnProperty(Z)) {
              var W = E[Z];
              Z === "children" ? typeof W == "string" ? w.textContent !== W && (E.suppressHydrationWarning !== !0 && fu(w.textContent, W, i), C = ["children", W]) : typeof W == "number" && w.textContent !== "" + W && (E.suppressHydrationWarning !== !0 && fu(
                w.textContent,
                W,
                i
              ), C = ["children", "" + W]) : h.hasOwnProperty(Z) && W != null && Z === "onScroll" && hr("scroll", w);
            }
            switch (v) {
              case "input":
                In(w), xt(w, E, !0);
                break;
              case "textarea":
                In(w), Xt(w);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof E.onClick == "function" && (w.onclick = fc);
            }
            w = C, o.updateQueue = w, w !== null && (o.flags |= 4);
          } else {
            Z = C.nodeType === 9 ? C : C.ownerDocument, i === "http://www.w3.org/1999/xhtml" && (i = En(v)), i === "http://www.w3.org/1999/xhtml" ? v === "script" ? (i = Z.createElement("div"), i.innerHTML = "<script><\/script>", i = i.removeChild(i.firstChild)) : typeof w.is == "string" ? i = Z.createElement(v, { is: w.is }) : (i = Z.createElement(v), v === "select" && (Z = i, w.multiple ? Z.multiple = !0 : w.size && (Z.size = w.size))) : i = Z.createElementNS(i, v), i[Tl] = o, i[Qi] = w, za(i, o, !1, !1), o.stateNode = i;
            e: {
              switch (Z = qn(v, w), v) {
                case "dialog":
                  hr("cancel", i), hr("close", i), C = w;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  hr("load", i), C = w;
                  break;
                case "video":
                case "audio":
                  for (C = 0; C < ki.length; C++) hr(ki[C], i);
                  C = w;
                  break;
                case "source":
                  hr("error", i), C = w;
                  break;
                case "img":
                case "image":
                case "link":
                  hr(
                    "error",
                    i
                  ), hr("load", i), C = w;
                  break;
                case "details":
                  hr("toggle", i), C = w;
                  break;
                case "input":
                  ea(i, w), C = wr(i, w), hr("invalid", i);
                  break;
                case "option":
                  C = w;
                  break;
                case "select":
                  i._wrapperState = { wasMultiple: !!w.multiple }, C = Pe({}, w, { value: void 0 }), hr("invalid", i);
                  break;
                case "textarea":
                  yr(i, w), C = Rn(i, w), hr("invalid", i);
                  break;
                default:
                  C = w;
              }
              wn(v, C), W = C;
              for (E in W) if (W.hasOwnProperty(E)) {
                var ee = W[E];
                E === "style" ? xr(i, ee) : E === "dangerouslySetInnerHTML" ? (ee = ee ? ee.__html : void 0, ee != null && wt(i, ee)) : E === "children" ? typeof ee == "string" ? (v !== "textarea" || ee !== "") && St(i, ee) : typeof ee == "number" && St(i, "" + ee) : E !== "suppressContentEditableWarning" && E !== "suppressHydrationWarning" && E !== "autoFocus" && (h.hasOwnProperty(E) ? ee != null && E === "onScroll" && hr("scroll", i) : ee != null && G(i, E, ee, Z));
              }
              switch (v) {
                case "input":
                  In(i), xt(i, w, !1);
                  break;
                case "textarea":
                  In(i), Xt(i);
                  break;
                case "option":
                  w.value != null && i.setAttribute("value", "" + Ot(w.value));
                  break;
                case "select":
                  i.multiple = !!w.multiple, E = w.value, E != null ? Vt(i, !!w.multiple, E, !1) : w.defaultValue != null && Vt(
                    i,
                    !!w.multiple,
                    w.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof C.onClick == "function" && (i.onclick = fc);
              }
              switch (v) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  w = !!w.autoFocus;
                  break e;
                case "img":
                  w = !0;
                  break e;
                default:
                  w = !1;
              }
            }
            w && (o.flags |= 4);
          }
          o.ref !== null && (o.flags |= 512, o.flags |= 2097152);
        }
        return Ra(o), null;
      case 6:
        if (i && o.stateNode != null) md(i, o, i.memoizedProps, w);
        else {
          if (typeof w != "string" && o.stateNode === null) throw Error(a(166));
          if (v = wu(Ys.current), wu(No.current), ro(o)) {
            if (w = o.stateNode, v = o.memoizedProps, w[Tl] = o, (E = w.nodeValue !== v) && (i = Ya, i !== null)) switch (i.tag) {
              case 3:
                fu(w.nodeValue, v, (i.mode & 1) !== 0);
                break;
              case 5:
                i.memoizedProps.suppressHydrationWarning !== !0 && fu(w.nodeValue, v, (i.mode & 1) !== 0);
            }
            E && (o.flags |= 4);
          } else w = (v.nodeType === 9 ? v : v.ownerDocument).createTextNode(w), w[Tl] = o, o.stateNode = w;
        }
        return Ra(o), null;
      case 13:
        if (Yn(et), w = o.memoizedState, i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
          if (br && Hi !== null && o.mode & 1 && !(o.flags & 128)) Bh(), Dl(), o.flags |= 98560, E = !1;
          else if (E = ro(o), w !== null && w.dehydrated !== null) {
            if (i === null) {
              if (!E) throw Error(a(318));
              if (E = o.memoizedState, E = E !== null ? E.dehydrated : null, !E) throw Error(a(317));
              E[Tl] = o;
            } else Dl(), !(o.flags & 128) && (o.memoizedState = null), o.flags |= 4;
            Ra(o), E = !1;
          } else no !== null && (Rd(no), no = null), E = !0;
          if (!E) return o.flags & 65536 ? o : null;
        }
        return o.flags & 128 ? (o.lanes = v, o) : (w = w !== null, w !== (i !== null && i.memoizedState !== null) && w && (o.child.flags |= 8192, o.mode & 1 && (i === null || et.current & 1 ? Gr === 0 && (Gr = 3) : Ed())), o.updateQueue !== null && (o.flags |= 4), Ra(o), null);
      case 4:
        return es(), Gh(i, o), i === null && cu(o.stateNode.containerInfo), Ra(o), null;
      case 10:
        return ad(o.type._context), Ra(o), null;
      case 17:
        return Ua(o.type) && Li(), Ra(o), null;
      case 19:
        if (Yn(et), E = o.memoizedState, E === null) return Ra(o), null;
        if (w = (o.flags & 128) !== 0, Z = E.rendering, Z === null) if (w) cs(E, !1);
        else {
          if (Gr !== 0 || i !== null && i.flags & 128) for (i = o.child; i !== null; ) {
            if (Z = on(i), Z !== null) {
              for (o.flags |= 128, cs(E, !1), w = Z.updateQueue, w !== null && (o.updateQueue = w, o.flags |= 4), o.subtreeFlags = 0, w = v, v = o.child; v !== null; ) E = v, i = w, E.flags &= 14680066, Z = E.alternate, Z === null ? (E.childLanes = 0, E.lanes = i, E.child = null, E.subtreeFlags = 0, E.memoizedProps = null, E.memoizedState = null, E.updateQueue = null, E.dependencies = null, E.stateNode = null) : (E.childLanes = Z.childLanes, E.lanes = Z.lanes, E.child = Z.child, E.subtreeFlags = 0, E.deletions = null, E.memoizedProps = Z.memoizedProps, E.memoizedState = Z.memoizedState, E.updateQueue = Z.updateQueue, E.type = Z.type, i = Z.dependencies, E.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }), v = v.sibling;
              return $n(et, et.current & 1 | 2), o.child;
            }
            i = i.sibling;
          }
          E.tail !== null && Xn() > vo && (o.flags |= 128, w = !0, cs(E, !1), o.lanes = 4194304);
        }
        else {
          if (!w) if (i = on(Z), i !== null) {
            if (o.flags |= 128, w = !0, v = i.updateQueue, v !== null && (o.updateQueue = v, o.flags |= 4), cs(E, !0), E.tail === null && E.tailMode === "hidden" && !Z.alternate && !br) return Ra(o), null;
          } else 2 * Xn() - E.renderingStartTime > vo && v !== 1073741824 && (o.flags |= 128, w = !0, cs(E, !1), o.lanes = 4194304);
          E.isBackwards ? (Z.sibling = o.child, o.child = Z) : (v = E.last, v !== null ? v.sibling = Z : o.child = Z, E.last = Z);
        }
        return E.tail !== null ? (o = E.tail, E.rendering = o, E.tail = o.sibling, E.renderingStartTime = Xn(), o.sibling = null, v = et.current, $n(et, w ? v & 1 | 2 : v & 1), o) : (Ra(o), null);
      case 22:
      case 23:
        return Qh(), w = o.memoizedState !== null, i !== null && i.memoizedState !== null !== w && (o.flags |= 8192), w && o.mode & 1 ? ll & 1073741824 && (Ra(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : Ra(o), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(a(156, o.tag));
  }
  function tm(i, o) {
    switch (Us(o), o.tag) {
      case 1:
        return Ua(o.type) && Li(), i = o.flags, i & 65536 ? (o.flags = i & -65537 | 128, o) : null;
      case 3:
        return es(), Yn(oa), Yn(Zr), _r(), i = o.flags, i & 65536 && !(i & 128) ? (o.flags = i & -65537 | 128, o) : null;
      case 5:
        return J1(o), null;
      case 13:
        if (Yn(et), i = o.memoizedState, i !== null && i.dehydrated !== null) {
          if (o.alternate === null) throw Error(a(340));
          Dl();
        }
        return i = o.flags, i & 65536 ? (o.flags = i & -65537 | 128, o) : null;
      case 19:
        return Yn(et), null;
      case 4:
        return es(), null;
      case 10:
        return ad(o.type._context), null;
      case 22:
      case 23:
        return Qh(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var f0 = !1, Or = !1, li = typeof WeakSet == "function" ? WeakSet : Set, dt = null;
  function Xs(i, o) {
    var v = i.ref;
    if (v !== null) if (typeof v == "function") try {
      v(null);
    } catch (w) {
      Lr(i, o, w);
    }
    else v.current = null;
  }
  function Ac(i, o, v) {
    try {
      v();
    } catch (w) {
      Lr(i, o, w);
    }
  }
  var Kh = !1;
  function nm(i, o) {
    if ($1 = W0, i = nr(), ac(i)) {
      if ("selectionStart" in i) var v = { start: i.selectionStart, end: i.selectionEnd };
      else {
        v = (v = i.ownerDocument) && v.defaultView || window;
        var w = v.getSelection && v.getSelection();
        if (w && w.rangeCount !== 0) {
          v = w.anchorNode;
          var C = w.anchorOffset, E = w.focusNode;
          w = w.focusOffset;
          var Z = 0, W = -1, ee = -1, xe = 0, Ve = 0, Ye = i, Ne = null;
          e: for (; ; ) {
            for (var ot; Ye !== v || C !== 0 && Ye.nodeType !== 3 || (W = Z + C), Ye !== E || w !== 0 && Ye.nodeType !== 3 || (ee = Z + w), Ye.nodeType === 3 && (Z += Ye.nodeValue.length), (ot = Ye.firstChild) !== null; )
              Ne = Ye, Ye = ot;
            for (; ; ) {
              if (Ye === i) break e;
              if (Ne === v && ++xe === C && (W = Z), Ne === E && ++Ve === w && (ee = Z), (ot = Ye.nextSibling) !== null) break;
              Ye = Ne, Ne = Ye.parentNode;
            }
            Ye = ot;
          }
          v = W === -1 || ee === -1 ? null : { start: W, end: ee };
        } else v = null;
      }
      v = v || { start: 0, end: 0 };
    } else v = null;
    for (du = { focusedElem: i, selectionRange: v }, W0 = !1, dt = o; dt !== null; ) if (o = dt, i = o.child, (o.subtreeFlags & 1028) !== 0 && i !== null) i.return = o, dt = i;
    else for (; dt !== null; ) {
      o = dt;
      try {
        var yt = o.alternate;
        if (o.flags & 1024) switch (o.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (yt !== null) {
              var Ct = yt.memoizedProps, Vr = yt.memoizedState, fe = o.stateNode, ne = fe.getSnapshotBeforeUpdate(o.elementType === o.type ? Ct : kl(o.type, Ct), Vr);
              fe.__reactInternalSnapshotBeforeUpdate = ne;
            }
            break;
          case 3:
            var de = o.stateNode.containerInfo;
            de.nodeType === 1 ? de.textContent = "" : de.nodeType === 9 && de.documentElement && de.removeChild(de.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(a(163));
        }
      } catch (ze) {
        Lr(o, o.return, ze);
      }
      if (i = o.sibling, i !== null) {
        i.return = o.return, dt = i;
        break;
      }
      dt = o.return;
    }
    return yt = Kh, Kh = !1, yt;
  }
  function oo(i, o, v) {
    var w = o.updateQueue;
    if (w = w !== null ? w.lastEffect : null, w !== null) {
      var C = w = w.next;
      do {
        if ((C.tag & i) === i) {
          var E = C.destroy;
          C.destroy = void 0, E !== void 0 && Ac(o, v, E);
        }
        C = C.next;
      } while (C !== w);
    }
  }
  function fs(i, o) {
    if (o = o.updateQueue, o = o !== null ? o.lastEffect : null, o !== null) {
      var v = o = o.next;
      do {
        if ((v.tag & i) === i) {
          var w = v.create;
          v.destroy = w();
        }
        v = v.next;
      } while (v !== o);
    }
  }
  function uo(i) {
    var o = i.ref;
    if (o !== null) {
      var v = i.stateNode;
      switch (i.tag) {
        case 5:
          i = v;
          break;
        default:
          i = v;
      }
      typeof o == "function" ? o(i) : o.current = i;
    }
  }
  function Cu(i) {
    var o = i.alternate;
    o !== null && (i.alternate = null, Cu(o)), i.child = null, i.deletions = null, i.sibling = null, i.tag === 5 && (o = i.stateNode, o !== null && (delete o[Tl], delete o[Qi], delete o[Qf], delete o[H], delete o[Ql])), i.stateNode = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
  }
  function bu(i) {
    return i.tag === 5 || i.tag === 3 || i.tag === 4;
  }
  function d0(i) {
    e: for (; ; ) {
      for (; i.sibling === null; ) {
        if (i.return === null || bu(i.return)) return null;
        i = i.return;
      }
      for (i.sibling.return = i.return, i = i.sibling; i.tag !== 5 && i.tag !== 6 && i.tag !== 18; ) {
        if (i.flags & 2 || i.child === null || i.tag === 4) continue e;
        i.child.return = i, i = i.child;
      }
      if (!(i.flags & 2)) return i.stateNode;
    }
  }
  function Js(i, o, v) {
    var w = i.tag;
    if (w === 5 || w === 6) i = i.stateNode, o ? v.nodeType === 8 ? v.parentNode.insertBefore(i, o) : v.insertBefore(i, o) : (v.nodeType === 8 ? (o = v.parentNode, o.insertBefore(i, v)) : (o = v, o.appendChild(i)), v = v._reactRootContainer, v != null || o.onclick !== null || (o.onclick = fc));
    else if (w !== 4 && (i = i.child, i !== null)) for (Js(i, o, v), i = i.sibling; i !== null; ) Js(i, o, v), i = i.sibling;
  }
  function so(i, o, v) {
    var w = i.tag;
    if (w === 5 || w === 6) i = i.stateNode, o ? v.insertBefore(i, o) : v.appendChild(i);
    else if (w !== 4 && (i = i.child, i !== null)) for (so(i, o, v), i = i.sibling; i !== null; ) so(i, o, v), i = i.sibling;
  }
  var Ea = null, co = !1;
  function Fo(i, o, v) {
    for (v = v.child; v !== null; ) gd(i, o, v), v = v.sibling;
  }
  function gd(i, o, v) {
    if (Do && typeof Do.onCommitFiberUnmount == "function") try {
      Do.onCommitFiberUnmount(F0, v);
    } catch {
    }
    switch (v.tag) {
      case 5:
        Or || Xs(v, o);
      case 6:
        var w = Ea, C = co;
        Ea = null, Fo(i, o, v), Ea = w, co = C, Ea !== null && (co ? (i = Ea, v = v.stateNode, i.nodeType === 8 ? i.parentNode.removeChild(v) : i.removeChild(v)) : Ea.removeChild(v.stateNode));
        break;
      case 18:
        Ea !== null && (co ? (i = Ea, v = v.stateNode, i.nodeType === 8 ? hc(i.parentNode, v) : i.nodeType === 1 && hc(i, v), Un(i)) : hc(Ea, v.stateNode));
        break;
      case 4:
        w = Ea, C = co, Ea = v.stateNode.containerInfo, co = !0, Fo(i, o, v), Ea = w, co = C;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Or && (w = v.updateQueue, w !== null && (w = w.lastEffect, w !== null))) {
          C = w = w.next;
          do {
            var E = C, Z = E.destroy;
            E = E.tag, Z !== void 0 && (E & 2 || E & 4) && Ac(v, o, Z), C = C.next;
          } while (C !== w);
        }
        Fo(i, o, v);
        break;
      case 1:
        if (!Or && (Xs(v, o), w = v.stateNode, typeof w.componentWillUnmount == "function")) try {
          w.props = v.memoizedProps, w.state = v.memoizedState, w.componentWillUnmount();
        } catch (W) {
          Lr(v, o, W);
        }
        Fo(i, o, v);
        break;
      case 21:
        Fo(i, o, v);
        break;
      case 22:
        v.mode & 1 ? (Or = (w = Or) || v.memoizedState !== null, Fo(i, o, v), Or = w) : Fo(i, o, v);
        break;
      default:
        Fo(i, o, v);
    }
  }
  function Uo(i) {
    var o = i.updateQueue;
    if (o !== null) {
      i.updateQueue = null;
      var v = i.stateNode;
      v === null && (v = i.stateNode = new li()), o.forEach(function(w) {
        var C = om.bind(null, i, w);
        v.has(w) || (v.add(w), w.then(C, C));
      });
    }
  }
  function il(i, o) {
    var v = o.deletions;
    if (v !== null) for (var w = 0; w < v.length; w++) {
      var C = v[w];
      try {
        var E = i, Z = o, W = Z;
        e: for (; W !== null; ) {
          switch (W.tag) {
            case 5:
              Ea = W.stateNode, co = !1;
              break e;
            case 3:
              Ea = W.stateNode.containerInfo, co = !0;
              break e;
            case 4:
              Ea = W.stateNode.containerInfo, co = !0;
              break e;
          }
          W = W.return;
        }
        if (Ea === null) throw Error(a(160));
        gd(E, Z, C), Ea = null, co = !1;
        var ee = C.alternate;
        ee !== null && (ee.return = null), C.return = null;
      } catch (xe) {
        Lr(C, o, xe);
      }
    }
    if (o.subtreeFlags & 12854) for (o = o.child; o !== null; ) wd(o, i), o = o.sibling;
  }
  function wd(i, o) {
    var v = i.alternate, w = i.flags;
    switch (i.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (il(o, i), fo(i), w & 4) {
          try {
            oo(3, i, i.return), fs(3, i);
          } catch (Ct) {
            Lr(i, i.return, Ct);
          }
          try {
            oo(5, i, i.return);
          } catch (Ct) {
            Lr(i, i.return, Ct);
          }
        }
        break;
      case 1:
        il(o, i), fo(i), w & 512 && v !== null && Xs(v, v.return);
        break;
      case 5:
        if (il(o, i), fo(i), w & 512 && v !== null && Xs(v, v.return), i.flags & 32) {
          var C = i.stateNode;
          try {
            St(C, "");
          } catch (Ct) {
            Lr(i, i.return, Ct);
          }
        }
        if (w & 4 && (C = i.stateNode, C != null)) {
          var E = i.memoizedProps, Z = v !== null ? v.memoizedProps : E, W = i.type, ee = i.updateQueue;
          if (i.updateQueue = null, ee !== null) try {
            W === "input" && E.type === "radio" && E.name != null && Ca(C, E), qn(W, Z);
            var xe = qn(W, E);
            for (Z = 0; Z < ee.length; Z += 2) {
              var Ve = ee[Z], Ye = ee[Z + 1];
              Ve === "style" ? xr(C, Ye) : Ve === "dangerouslySetInnerHTML" ? wt(C, Ye) : Ve === "children" ? St(C, Ye) : G(C, Ve, Ye, xe);
            }
            switch (W) {
              case "input":
                Hr(C, E);
                break;
              case "textarea":
                Xe(C, E);
                break;
              case "select":
                var Ne = C._wrapperState.wasMultiple;
                C._wrapperState.wasMultiple = !!E.multiple;
                var ot = E.value;
                ot != null ? Vt(C, !!E.multiple, ot, !1) : Ne !== !!E.multiple && (E.defaultValue != null ? Vt(
                  C,
                  !!E.multiple,
                  E.defaultValue,
                  !0
                ) : Vt(C, !!E.multiple, E.multiple ? [] : "", !1));
            }
            C[Qi] = E;
          } catch (Ct) {
            Lr(i, i.return, Ct);
          }
        }
        break;
      case 6:
        if (il(o, i), fo(i), w & 4) {
          if (i.stateNode === null) throw Error(a(162));
          C = i.stateNode, E = i.memoizedProps;
          try {
            C.nodeValue = E;
          } catch (Ct) {
            Lr(i, i.return, Ct);
          }
        }
        break;
      case 3:
        if (il(o, i), fo(i), w & 4 && v !== null && v.memoizedState.isDehydrated) try {
          Un(o.containerInfo);
        } catch (Ct) {
          Lr(i, i.return, Ct);
        }
        break;
      case 4:
        il(o, i), fo(i);
        break;
      case 13:
        il(o, i), fo(i), C = i.child, C.flags & 8192 && (E = C.memoizedState !== null, C.stateNode.isHidden = E, !E || C.alternate !== null && C.alternate.memoizedState !== null || (Ic = Xn())), w & 4 && Uo(i);
        break;
      case 22:
        if (Ve = v !== null && v.memoizedState !== null, i.mode & 1 ? (Or = (xe = Or) || Ve, il(o, i), Or = xe) : il(o, i), fo(i), w & 8192) {
          if (xe = i.memoizedState !== null, (i.stateNode.isHidden = xe) && !Ve && i.mode & 1) for (dt = i, Ve = i.child; Ve !== null; ) {
            for (Ye = dt = Ve; dt !== null; ) {
              switch (Ne = dt, ot = Ne.child, Ne.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  oo(4, Ne, Ne.return);
                  break;
                case 1:
                  Xs(Ne, Ne.return);
                  var yt = Ne.stateNode;
                  if (typeof yt.componentWillUnmount == "function") {
                    w = Ne, v = Ne.return;
                    try {
                      o = w, yt.props = o.memoizedProps, yt.state = o.memoizedState, yt.componentWillUnmount();
                    } catch (Ct) {
                      Lr(w, v, Ct);
                    }
                  }
                  break;
                case 5:
                  Xs(Ne, Ne.return);
                  break;
                case 22:
                  if (Ne.memoizedState !== null) {
                    Hl(Ye);
                    continue;
                  }
              }
              ot !== null ? (ot.return = Ne, dt = ot) : Hl(Ye);
            }
            Ve = Ve.sibling;
          }
          e: for (Ve = null, Ye = i; ; ) {
            if (Ye.tag === 5) {
              if (Ve === null) {
                Ve = Ye;
                try {
                  C = Ye.stateNode, xe ? (E = C.style, typeof E.setProperty == "function" ? E.setProperty("display", "none", "important") : E.display = "none") : (W = Ye.stateNode, ee = Ye.memoizedProps.style, Z = ee != null && ee.hasOwnProperty("display") ? ee.display : null, W.style.display = ta("display", Z));
                } catch (Ct) {
                  Lr(i, i.return, Ct);
                }
              }
            } else if (Ye.tag === 6) {
              if (Ve === null) try {
                Ye.stateNode.nodeValue = xe ? "" : Ye.memoizedProps;
              } catch (Ct) {
                Lr(i, i.return, Ct);
              }
            } else if ((Ye.tag !== 22 && Ye.tag !== 23 || Ye.memoizedState === null || Ye === i) && Ye.child !== null) {
              Ye.child.return = Ye, Ye = Ye.child;
              continue;
            }
            if (Ye === i) break e;
            for (; Ye.sibling === null; ) {
              if (Ye.return === null || Ye.return === i) break e;
              Ve === Ye && (Ve = null), Ye = Ye.return;
            }
            Ve === Ye && (Ve = null), Ye.sibling.return = Ye.return, Ye = Ye.sibling;
          }
        }
        break;
      case 19:
        il(o, i), fo(i), w & 4 && Uo(i);
        break;
      case 21:
        break;
      default:
        il(
          o,
          i
        ), fo(i);
    }
  }
  function fo(i) {
    var o = i.flags;
    if (o & 2) {
      try {
        e: {
          for (var v = i.return; v !== null; ) {
            if (bu(v)) {
              var w = v;
              break e;
            }
            v = v.return;
          }
          throw Error(a(160));
        }
        switch (w.tag) {
          case 5:
            var C = w.stateNode;
            w.flags & 32 && (St(C, ""), w.flags &= -33);
            var E = d0(i);
            so(i, E, C);
            break;
          case 3:
          case 4:
            var Z = w.stateNode.containerInfo, W = d0(i);
            Js(i, W, Z);
            break;
          default:
            throw Error(a(161));
        }
      } catch (ee) {
        Lr(i, i.return, ee);
      }
      i.flags &= -3;
    }
    o & 4096 && (i.flags &= -4097);
  }
  function e1(i, o, v) {
    dt = i, yd(i);
  }
  function yd(i, o, v) {
    for (var w = (i.mode & 1) !== 0; dt !== null; ) {
      var C = dt, E = C.child;
      if (C.tag === 22 && w) {
        var Z = C.memoizedState !== null || f0;
        if (!Z) {
          var W = C.alternate, ee = W !== null && W.memoizedState !== null || Or;
          W = f0;
          var xe = Or;
          if (f0 = Z, (Or = ee) && !xe) for (dt = C; dt !== null; ) Z = dt, ee = Z.child, Z.tag === 22 && Z.memoizedState !== null ? h0(C) : ee !== null ? (ee.return = Z, dt = ee) : h0(C);
          for (; E !== null; ) dt = E, yd(E), E = E.sibling;
          dt = C, f0 = W, Or = xe;
        }
        ho(i);
      } else C.subtreeFlags & 8772 && E !== null ? (E.return = C, dt = E) : ho(i);
    }
  }
  function ho(i) {
    for (; dt !== null; ) {
      var o = dt;
      if (o.flags & 8772) {
        var v = o.alternate;
        try {
          if (o.flags & 8772) switch (o.tag) {
            case 0:
            case 11:
            case 15:
              Or || fs(5, o);
              break;
            case 1:
              var w = o.stateNode;
              if (o.flags & 4 && !Or) if (v === null) w.componentDidMount();
              else {
                var C = o.elementType === o.type ? v.memoizedProps : kl(o.type, v.memoizedProps);
                w.componentDidUpdate(C, v.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
              }
              var E = o.updateQueue;
              E !== null && Fh(o, E, w);
              break;
            case 3:
              var Z = o.updateQueue;
              if (Z !== null) {
                if (v = null, o.child !== null) switch (o.child.tag) {
                  case 5:
                    v = o.child.stateNode;
                    break;
                  case 1:
                    v = o.child.stateNode;
                }
                Fh(o, Z, v);
              }
              break;
            case 5:
              var W = o.stateNode;
              if (v === null && o.flags & 4) {
                v = W;
                var ee = o.memoizedProps;
                switch (o.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    ee.autoFocus && v.focus();
                    break;
                  case "img":
                    ee.src && (v.src = ee.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (o.memoizedState === null) {
                var xe = o.alternate;
                if (xe !== null) {
                  var Ve = xe.memoizedState;
                  if (Ve !== null) {
                    var Ye = Ve.dehydrated;
                    Ye !== null && Un(Ye);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(a(163));
          }
          Or || o.flags & 512 && uo(o);
        } catch (Ne) {
          Lr(o, o.return, Ne);
        }
      }
      if (o === i) {
        dt = null;
        break;
      }
      if (v = o.sibling, v !== null) {
        v.return = o.return, dt = v;
        break;
      }
      dt = o.return;
    }
  }
  function Hl(i) {
    for (; dt !== null; ) {
      var o = dt;
      if (o === i) {
        dt = null;
        break;
      }
      var v = o.sibling;
      if (v !== null) {
        v.return = o.return, dt = v;
        break;
      }
      dt = o.return;
    }
  }
  function h0(i) {
    for (; dt !== null; ) {
      var o = dt;
      try {
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            var v = o.return;
            try {
              fs(4, o);
            } catch (ee) {
              Lr(o, v, ee);
            }
            break;
          case 1:
            var w = o.stateNode;
            if (typeof w.componentDidMount == "function") {
              var C = o.return;
              try {
                w.componentDidMount();
              } catch (ee) {
                Lr(o, C, ee);
              }
            }
            var E = o.return;
            try {
              uo(o);
            } catch (ee) {
              Lr(o, E, ee);
            }
            break;
          case 5:
            var Z = o.return;
            try {
              uo(o);
            } catch (ee) {
              Lr(o, Z, ee);
            }
        }
      } catch (ee) {
        Lr(o, o.return, ee);
      }
      if (o === i) {
        dt = null;
        break;
      }
      var W = o.sibling;
      if (W !== null) {
        W.return = o.return, dt = W;
        break;
      }
      dt = o.return;
    }
  }
  var t1 = Math.ceil, v0 = z.ReactCurrentDispatcher, xd = z.ReactCurrentOwner, Zl = z.ReactCurrentBatchConfig, On = 0, Ma = null, sa = null, ma = 0, ll = 0, _u = la(0), Gr = 0, p0 = null, ds = 0, kc = 0, Sd = 0, Lc = null, Ta = null, Ic = 0, vo = 1 / 0, Ru = null, Cd = !1, bd = null, Eu = null, n1 = !1, po = null, oi = 0, qa = 0, hs = null, m0 = -1, Mu = 0;
  function yi() {
    return On & 6 ? Xn() : m0 !== -1 ? m0 : m0 = Xn();
  }
  function Yo(i) {
    return i.mode & 1 ? On & 2 && ma !== 0 ? ma & -ma : hv.transition !== null ? (Mu === 0 && (Mu = Oh()), Mu) : (i = Fn, i !== 0 || (i = window.event, i = i === void 0 ? 16 : jf(i.type)), i) : 1;
  }
  function ol(i, o, v, w) {
    if (50 < qa) throw qa = 0, hs = null, Error(a(185));
    U0(i, v, w), (!(On & 2) || i !== Ma) && (i === Ma && (!(On & 2) && (kc |= v), Gr === 4 && vs(i, ma)), Oa(i, w), v === 1 && On === 0 && !(o.mode & 1) && (vo = Xn() + 500, Jl && Ol()));
  }
  function Oa(i, o) {
    var v = i.callbackNode;
    Wp(i, o);
    var w = js(i, i === Ma ? ma : 0);
    if (w === 0) v !== null && hi(v), i.callbackNode = null, i.callbackPriority = 0;
    else if (o = w & -w, i.callbackPriority !== o) {
      if (v != null && hi(v), o === 1) i.tag === 0 ? vu(wv.bind(null, i)) : ed(wv.bind(null, i)), W1(function() {
        !(On & 6) && Ol();
      }), v = null;
      else {
        switch (Vu(w)) {
          case 1:
            v = D1;
            break;
          case 4:
            v = Mh;
            break;
          case 16:
            v = j1;
            break;
          case 536870912:
            v = _f;
            break;
          default:
            v = j1;
        }
        v = Ev(v, _d.bind(null, i));
      }
      i.callbackPriority = o, i.callbackNode = v;
    }
  }
  function _d(i, o) {
    if (m0 = -1, Mu = 0, On & 6) throw Error(a(327));
    var v = i.callbackNode;
    if (w0() && i.callbackNode !== v) return null;
    var w = js(i, i === Ma ? ma : 0);
    if (w === 0) return null;
    if (w & 30 || w & i.expiredLanes || o) o = Md(i, w);
    else {
      o = w;
      var C = On;
      On |= 2;
      var E = xv();
      (Ma !== i || ma !== o) && (Ru = null, vo = Xn() + 500, a1(i, o));
      do
        try {
          im();
          break;
        } catch (W) {
          yv(i, W);
        }
      while (!0);
      vr(), v0.current = E, On = C, sa !== null ? o = 0 : (Ma = null, ma = 0, o = Gr);
    }
    if (o !== 0) {
      if (o === 2 && (C = A1(i), C !== 0 && (w = C, o = g0(i, C))), o === 1) throw v = p0, a1(i, 0), vs(i, w), Oa(i, Xn()), v;
      if (o === 6) vs(i, w);
      else {
        if (C = i.current.alternate, !(w & 30) && !rm(C) && (o = Md(i, w), o === 2 && (E = A1(i), E !== 0 && (w = E, o = g0(i, E))), o === 1)) throw v = p0, a1(i, 0), vs(i, w), Oa(i, Xn()), v;
        switch (i.finishedWork = C, i.finishedLanes = w, o) {
          case 0:
          case 1:
            throw Error(a(345));
          case 2:
            i1(i, Ta, Ru);
            break;
          case 3:
            if (vs(i, w), (w & 130023424) === w && (o = Ic + 500 - Xn(), 10 < o)) {
              if (js(i, 0) !== 0) break;
              if (C = i.suspendedLanes, (C & w) !== w) {
                yi(), i.pingedLanes |= i.suspendedLanes & C;
                break;
              }
              i.timeoutHandle = Ki(i1.bind(null, i, Ta, Ru), o);
              break;
            }
            i1(i, Ta, Ru);
            break;
          case 4:
            if (vs(i, w), (w & 4194240) === w) break;
            for (o = i.eventTimes, C = -1; 0 < w; ) {
              var Z = 31 - Wi(w);
              E = 1 << Z, Z = o[Z], Z > C && (C = Z), w &= ~E;
            }
            if (w = C, w = Xn() - w, w = (120 > w ? 120 : 480 > w ? 480 : 1080 > w ? 1080 : 1920 > w ? 1920 : 3e3 > w ? 3e3 : 4320 > w ? 4320 : 1960 * t1(w / 1960)) - w, 10 < w) {
              i.timeoutHandle = Ki(i1.bind(null, i, Ta, Ru), w);
              break;
            }
            i1(i, Ta, Ru);
            break;
          case 5:
            i1(i, Ta, Ru);
            break;
          default:
            throw Error(a(329));
        }
      }
    }
    return Oa(i, Xn()), i.callbackNode === v ? _d.bind(null, i) : null;
  }
  function g0(i, o) {
    var v = Lc;
    return i.current.memoizedState.isDehydrated && (a1(i, o).flags |= 256), i = Md(i, o), i !== 2 && (o = Ta, Ta = v, o !== null && Rd(o)), i;
  }
  function Rd(i) {
    Ta === null ? Ta = i : Ta.push.apply(Ta, i);
  }
  function rm(i) {
    for (var o = i; ; ) {
      if (o.flags & 16384) {
        var v = o.updateQueue;
        if (v !== null && (v = v.stores, v !== null)) for (var w = 0; w < v.length; w++) {
          var C = v[w], E = C.getSnapshot;
          C = C.value;
          try {
            if (!pe(E(), C)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (v = o.child, o.subtreeFlags & 16384 && v !== null) v.return = o, o = v;
      else {
        if (o === i) break;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === i) return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function vs(i, o) {
    for (o &= ~Sd, o &= ~kc, i.suspendedLanes |= o, i.pingedLanes &= ~o, i = i.expirationTimes; 0 < o; ) {
      var v = 31 - Wi(o), w = 1 << v;
      i[v] = -1, o &= ~w;
    }
  }
  function wv(i) {
    if (On & 6) throw Error(a(327));
    w0();
    var o = js(i, 0);
    if (!(o & 1)) return Oa(i, Xn()), null;
    var v = Md(i, o);
    if (i.tag !== 0 && v === 2) {
      var w = A1(i);
      w !== 0 && (o = w, v = g0(i, w));
    }
    if (v === 1) throw v = p0, a1(i, 0), vs(i, o), Oa(i, Xn()), v;
    if (v === 6) throw Error(a(345));
    return i.finishedWork = i.current.alternate, i.finishedLanes = o, i1(i, Ta, Ru), Oa(i, Xn()), null;
  }
  function Hc(i, o) {
    var v = On;
    On |= 1;
    try {
      return i(o);
    } finally {
      On = v, On === 0 && (vo = Xn() + 500, Jl && Ol());
    }
  }
  function r1(i) {
    po !== null && po.tag === 0 && !(On & 6) && w0();
    var o = On;
    On |= 1;
    var v = Zl.transition, w = Fn;
    try {
      if (Zl.transition = null, Fn = 1, i) return i();
    } finally {
      Fn = w, Zl.transition = v, On = o, !(On & 6) && Ol();
    }
  }
  function Qh() {
    ll = _u.current, Yn(_u);
  }
  function a1(i, o) {
    i.finishedWork = null, i.finishedLanes = 0;
    var v = i.timeoutHandle;
    if (v !== -1 && (i.timeoutHandle = -1, zu(v)), sa !== null) for (v = sa.return; v !== null; ) {
      var w = v;
      switch (Us(w), w.tag) {
        case 1:
          w = w.type.childContextTypes, w != null && Li();
          break;
        case 3:
          es(), Yn(oa), Yn(Zr), _r();
          break;
        case 5:
          J1(w);
          break;
        case 4:
          es();
          break;
        case 13:
          Yn(et);
          break;
        case 19:
          Yn(et);
          break;
        case 10:
          ad(w.type._context);
          break;
        case 22:
        case 23:
          Qh();
      }
      v = v.return;
    }
    if (Ma = i, sa = i = xi(i.current, null), ma = ll = o, Gr = 0, p0 = null, Sd = kc = ds = 0, Ta = Lc = null, ao !== null) {
      for (o = 0; o < ao.length; o++) if (v = ao[o], w = v.interleaved, w !== null) {
        v.interleaved = null;
        var C = w.next, E = v.pending;
        if (E !== null) {
          var Z = E.next;
          E.next = C, w.next = Z;
        }
        v.pending = w;
      }
      ao = null;
    }
    return i;
  }
  function yv(i, o) {
    do {
      var v = sa;
      try {
        if (vr(), Zi.current = qs, He) {
          for (var w = kr.memoizedState; w !== null; ) {
            var C = w.queue;
            C !== null && (C.pending = null), w = w.next;
          }
          He = !1;
        }
        if (ts = 0, zr = Wr = kr = null, Nr = !1, It = 0, xd.current = null, v === null || v.return === null) {
          Gr = 1, p0 = o, sa = null;
          break;
        }
        e: {
          var E = i, Z = v.return, W = v, ee = o;
          if (o = ma, W.flags |= 32768, ee !== null && typeof ee == "object" && typeof ee.then == "function") {
            var xe = ee, Ve = W, Ye = Ve.tag;
            if (!(Ve.mode & 1) && (Ye === 0 || Ye === 11 || Ye === 15)) {
              var Ne = Ve.alternate;
              Ne ? (Ve.updateQueue = Ne.updateQueue, Ve.memoizedState = Ne.memoizedState, Ve.lanes = Ne.lanes) : (Ve.updateQueue = null, Ve.memoizedState = null);
            }
            var ot = us(Z);
            if (ot !== null) {
              ot.flags &= -257, Mc(ot, Z, W, E, o), ot.mode & 1 && xu(E, xe, o), o = ot, ee = xe;
              var yt = o.updateQueue;
              if (yt === null) {
                var Ct = /* @__PURE__ */ new Set();
                Ct.add(ee), o.updateQueue = Ct;
              } else yt.add(ee);
              break e;
            } else {
              if (!(o & 1)) {
                xu(E, xe, o), Ed();
                break e;
              }
              ee = Error(a(426));
            }
          } else if (br && W.mode & 1) {
            var Vr = us(Z);
            if (Vr !== null) {
              !(Vr.flags & 65536) && (Vr.flags |= 256), Mc(Vr, Z, W, E, o), Zo(Vo(ee, W));
              break e;
            }
          }
          E = ee = Vo(ee, W), Gr !== 4 && (Gr = 2), Lc === null ? Lc = [E] : Lc.push(E), E = Z;
          do {
            switch (E.tag) {
              case 3:
                E.flags |= 65536, o &= -o, E.lanes |= o;
                var fe = Ec(E, ee, o);
                pv(E, fe);
                break e;
              case 1:
                W = ee;
                var ne = E.type, de = E.stateNode;
                if (!(E.flags & 128) && (typeof ne.getDerivedStateFromError == "function" || de !== null && typeof de.componentDidCatch == "function" && (Eu === null || !Eu.has(de)))) {
                  E.flags |= 65536, o &= -o, E.lanes |= o;
                  var ze = Bo(E, W, o);
                  pv(E, ze);
                  break e;
                }
            }
            E = E.return;
          } while (E !== null);
        }
        Cv(v);
      } catch (bt) {
        o = bt, sa === v && v !== null && (sa = v = v.return);
        continue;
      }
      break;
    } while (!0);
  }
  function xv() {
    var i = v0.current;
    return v0.current = qs, i === null ? qs : i;
  }
  function Ed() {
    (Gr === 0 || Gr === 3 || Gr === 2) && (Gr = 4), Ma === null || !(ds & 268435455) && !(kc & 268435455) || vs(Ma, ma);
  }
  function Md(i, o) {
    var v = On;
    On |= 2;
    var w = xv();
    (Ma !== i || ma !== o) && (Ru = null, a1(i, o));
    do
      try {
        am();
        break;
      } catch (C) {
        yv(i, C);
      }
    while (!0);
    if (vr(), On = v, v0.current = w, sa !== null) throw Error(a(261));
    return Ma = null, ma = 0, Gr;
  }
  function am() {
    for (; sa !== null; ) Sv(sa);
  }
  function im() {
    for (; sa !== null && !Gt(); ) Sv(sa);
  }
  function Sv(i) {
    var o = Rv(i.alternate, i, ll);
    i.memoizedProps = i.pendingProps, o === null ? Cv(i) : sa = o, xd.current = null;
  }
  function Cv(i) {
    var o = i;
    do {
      var v = o.alternate;
      if (i = o.return, o.flags & 32768) {
        if (v = tm(v, o), v !== null) {
          v.flags &= 32767, sa = v;
          return;
        }
        if (i !== null) i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null;
        else {
          Gr = 6, sa = null;
          return;
        }
      } else if (v = em(v, o, ll), v !== null) {
        sa = v;
        return;
      }
      if (o = o.sibling, o !== null) {
        sa = o;
        return;
      }
      sa = o = i;
    } while (o !== null);
    Gr === 0 && (Gr = 5);
  }
  function i1(i, o, v) {
    var w = Fn, C = Zl.transition;
    try {
      Zl.transition = null, Fn = 1, Xh(i, o, v, w);
    } finally {
      Zl.transition = C, Fn = w;
    }
    return null;
  }
  function Xh(i, o, v, w) {
    do
      w0();
    while (po !== null);
    if (On & 6) throw Error(a(327));
    v = i.finishedWork;
    var C = i.finishedLanes;
    if (v === null) return null;
    if (i.finishedWork = null, i.finishedLanes = 0, v === i.current) throw Error(a(177));
    i.callbackNode = null, i.callbackPriority = 0;
    var E = v.lanes | v.childLanes;
    if (Dh(i, E), i === Ma && (sa = Ma = null, ma = 0), !(v.subtreeFlags & 2064) && !(v.flags & 2064) || n1 || (n1 = !0, Ev(j1, function() {
      return w0(), null;
    })), E = (v.flags & 15990) !== 0, v.subtreeFlags & 15990 || E) {
      E = Zl.transition, Zl.transition = null;
      var Z = Fn;
      Fn = 1;
      var W = On;
      On |= 4, xd.current = null, nm(i, v), wd(v, i), Qp(du), W0 = !!$1, du = $1 = null, i.current = v, e1(v), na(), On = W, Fn = Z, Zl.transition = E;
    } else i.current = v;
    if (n1 && (n1 = !1, po = i, oi = C), E = i.pendingLanes, E === 0 && (Eu = null), $p(v.stateNode), Oa(i, Xn()), o !== null) for (w = i.onRecoverableError, v = 0; v < o.length; v++) C = o[v], w(C.value, { componentStack: C.stack, digest: C.digest });
    if (Cd) throw Cd = !1, i = bd, bd = null, i;
    return oi & 1 && i.tag !== 0 && w0(), E = i.pendingLanes, E & 1 ? i === hs ? qa++ : (qa = 0, hs = i) : qa = 0, Ol(), null;
  }
  function w0() {
    if (po !== null) {
      var i = Vu(oi), o = Zl.transition, v = Fn;
      try {
        if (Zl.transition = null, Fn = 16 > i ? 16 : i, po === null) var w = !1;
        else {
          if (i = po, po = null, oi = 0, On & 6) throw Error(a(331));
          var C = On;
          for (On |= 4, dt = i.current; dt !== null; ) {
            var E = dt, Z = E.child;
            if (dt.flags & 16) {
              var W = E.deletions;
              if (W !== null) {
                for (var ee = 0; ee < W.length; ee++) {
                  var xe = W[ee];
                  for (dt = xe; dt !== null; ) {
                    var Ve = dt;
                    switch (Ve.tag) {
                      case 0:
                      case 11:
                      case 15:
                        oo(8, Ve, E);
                    }
                    var Ye = Ve.child;
                    if (Ye !== null) Ye.return = Ve, dt = Ye;
                    else for (; dt !== null; ) {
                      Ve = dt;
                      var Ne = Ve.sibling, ot = Ve.return;
                      if (Cu(Ve), Ve === xe) {
                        dt = null;
                        break;
                      }
                      if (Ne !== null) {
                        Ne.return = ot, dt = Ne;
                        break;
                      }
                      dt = ot;
                    }
                  }
                }
                var yt = E.alternate;
                if (yt !== null) {
                  var Ct = yt.child;
                  if (Ct !== null) {
                    yt.child = null;
                    do {
                      var Vr = Ct.sibling;
                      Ct.sibling = null, Ct = Vr;
                    } while (Ct !== null);
                  }
                }
                dt = E;
              }
            }
            if (E.subtreeFlags & 2064 && Z !== null) Z.return = E, dt = Z;
            else e: for (; dt !== null; ) {
              if (E = dt, E.flags & 2048) switch (E.tag) {
                case 0:
                case 11:
                case 15:
                  oo(9, E, E.return);
              }
              var fe = E.sibling;
              if (fe !== null) {
                fe.return = E.return, dt = fe;
                break e;
              }
              dt = E.return;
            }
          }
          var ne = i.current;
          for (dt = ne; dt !== null; ) {
            Z = dt;
            var de = Z.child;
            if (Z.subtreeFlags & 2064 && de !== null) de.return = Z, dt = de;
            else e: for (Z = ne; dt !== null; ) {
              if (W = dt, W.flags & 2048) try {
                switch (W.tag) {
                  case 0:
                  case 11:
                  case 15:
                    fs(9, W);
                }
              } catch (bt) {
                Lr(W, W.return, bt);
              }
              if (W === Z) {
                dt = null;
                break e;
              }
              var ze = W.sibling;
              if (ze !== null) {
                ze.return = W.return, dt = ze;
                break e;
              }
              dt = W.return;
            }
          }
          if (On = C, Ol(), Do && typeof Do.onPostCommitFiberRoot == "function") try {
            Do.onPostCommitFiberRoot(F0, i);
          } catch {
          }
          w = !0;
        }
        return w;
      } finally {
        Fn = v, Zl.transition = o;
      }
    }
    return !1;
  }
  function Td(i, o, v) {
    o = Vo(v, o), o = Ec(i, o, 1), i = rl(i, o, 1), o = yi(), i !== null && (U0(i, 1, o), Oa(i, o));
  }
  function Lr(i, o, v) {
    if (i.tag === 3) Td(i, i, v);
    else for (; o !== null; ) {
      if (o.tag === 3) {
        Td(o, i, v);
        break;
      } else if (o.tag === 1) {
        var w = o.stateNode;
        if (typeof o.type.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && (Eu === null || !Eu.has(w))) {
          i = Vo(v, i), i = Bo(o, i, 1), o = rl(o, i, 1), i = yi(), o !== null && (U0(o, 1, i), Oa(o, i));
          break;
        }
      }
      o = o.return;
    }
  }
  function bv(i, o, v) {
    var w = i.pingCache;
    w !== null && w.delete(o), o = yi(), i.pingedLanes |= i.suspendedLanes & v, Ma === i && (ma & v) === v && (Gr === 4 || Gr === 3 && (ma & 130023424) === ma && 500 > Xn() - Ic ? a1(i, 0) : Sd |= v), Oa(i, o);
  }
  function _v(i, o) {
    o === 0 && (i.mode & 1 ? (o = Mf, Mf <<= 1, !(Mf & 130023424) && (Mf = 4194304)) : o = 1);
    var v = yi();
    i = mu(i, o), i !== null && (U0(i, o, v), Oa(i, v));
  }
  function lm(i) {
    var o = i.memoizedState, v = 0;
    o !== null && (v = o.retryLane), _v(i, v);
  }
  function om(i, o) {
    var v = 0;
    switch (i.tag) {
      case 13:
        var w = i.stateNode, C = i.memoizedState;
        C !== null && (v = C.retryLane);
        break;
      case 19:
        w = i.stateNode;
        break;
      default:
        throw Error(a(314));
    }
    w !== null && w.delete(o), _v(i, v);
  }
  var Rv;
  Rv = function(i, o, v) {
    if (i !== null) if (i.memoizedProps !== o.pendingProps || oa.current) ua = !0;
    else {
      if (!(i.lanes & v) && !(o.flags & 128)) return ua = !1, gv(i, o, v);
      ua = !!(i.flags & 131072);
    }
    else ua = !1, br && o.flags & 1048576 && Vh(o, Lo, o.index);
    switch (o.lanes = 0, o.tag) {
      case 2:
        var w = o.type;
        Ni(i, o), i = o.pendingProps;
        var C = G1(o, Zr.current);
        Xu(o, v), C = ni(null, o, w, i, C, v);
        var E = ns();
        return o.flags |= 1, typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0 ? (o.tag = 1, o.memoizedState = null, o.updateQueue = null, Ua(w) ? (E = !0, Ii(o)) : E = !1, o.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, ld(o), C.updater = fd, o.stateNode = C, C._reactInternals = o, $h(o, w, i, v), o = vd(null, o, w, !0, E, v)) : (o.tag = 0, br && E && K1(o), jt(null, o, C, v), o = o.child), o;
      case 16:
        w = o.elementType;
        e: {
          switch (Ni(i, o), i = o.pendingProps, C = w._init, w = C(w._payload), o.type = w, C = o.tag = Jh(w), i = kl(w, i), C) {
            case 0:
              o = Ks(null, o, w, i, v);
              break e;
            case 1:
              o = qh(null, o, w, i, v);
              break e;
            case 11:
              o = Tc(null, o, w, i, v);
              break e;
            case 14:
              o = hd(null, o, w, kl(w.type, i), v);
              break e;
          }
          throw Error(a(
            306,
            w,
            ""
          ));
        }
        return o;
      case 0:
        return w = o.type, C = o.pendingProps, C = o.elementType === w ? C : kl(w, C), Ks(i, o, w, C, v);
      case 1:
        return w = o.type, C = o.pendingProps, C = o.elementType === w ? C : kl(w, C), qh(i, o, w, C, v);
      case 3:
        e: {
          if (mv(o), i === null) throw Error(a(387));
          w = o.pendingProps, E = o.memoizedState, C = E.element, vv(i, o), X1(o, w, null, v);
          var Z = o.memoizedState;
          if (w = Z.element, E.isDehydrated) if (E = { element: w, isDehydrated: !1, cache: Z.cache, pendingSuspenseBoundaries: Z.pendingSuspenseBoundaries, transitions: Z.transitions }, o.updateQueue.baseState = E, o.memoizedState = E, o.flags & 256) {
            C = Vo(Error(a(423)), o), o = Ll(i, o, w, v, C);
            break e;
          } else if (w !== C) {
            C = Vo(Error(a(424)), o), o = Ll(i, o, w, v, C);
            break e;
          } else for (Hi = qu(o.stateNode.containerInfo.firstChild), Ya = o, br = !0, no = null, v = rd(o, null, w, v), o.child = v; v; ) v.flags = v.flags & -3 | 4096, v = v.sibling;
          else {
            if (Dl(), w === C) {
              o = rr(i, o, v);
              break e;
            }
            jt(i, o, w, v);
          }
          o = o.child;
        }
        return o;
      case 5:
        return Uh(o), i === null && $a(o), w = o.type, C = o.pendingProps, E = i !== null ? i.memoizedProps : null, Z = C.children, dc(w, C) ? Z = null : E !== null && dc(w, E) && (o.flags |= 32), Oc(i, o), jt(i, o, Z, v), o.child;
      case 6:
        return i === null && $a(o), null;
      case 13:
        return jc(i, o, v);
      case 4:
        return od(o, o.stateNode.containerInfo), w = o.pendingProps, i === null ? o.child = Pn(o, null, w, v) : jt(i, o, w, v), o.child;
      case 11:
        return w = o.type, C = o.pendingProps, C = o.elementType === w ? C : kl(w, C), Tc(i, o, w, C, v);
      case 7:
        return jt(i, o, o.pendingProps, v), o.child;
      case 8:
        return jt(i, o, o.pendingProps.children, v), o.child;
      case 12:
        return jt(i, o, o.pendingProps.children, v), o.child;
      case 10:
        e: {
          if (w = o.type._context, C = o.pendingProps, E = o.memoizedProps, Z = C.value, $n(pc, w._currentValue), w._currentValue = Z, E !== null) if (pe(E.value, Z)) {
            if (E.children === C.children && !oa.current) {
              o = rr(i, o, v);
              break e;
            }
          } else for (E = o.child, E !== null && (E.return = o); E !== null; ) {
            var W = E.dependencies;
            if (W !== null) {
              Z = E.child;
              for (var ee = W.firstContext; ee !== null; ) {
                if (ee.context === w) {
                  if (E.tag === 1) {
                    ee = gu(-1, v & -v), ee.tag = 2;
                    var xe = E.updateQueue;
                    if (xe !== null) {
                      xe = xe.shared;
                      var Ve = xe.pending;
                      Ve === null ? ee.next = ee : (ee.next = Ve.next, Ve.next = ee), xe.pending = ee;
                    }
                  }
                  E.lanes |= v, ee = E.alternate, ee !== null && (ee.lanes |= v), Wa(
                    E.return,
                    v,
                    o
                  ), W.lanes |= v;
                  break;
                }
                ee = ee.next;
              }
            } else if (E.tag === 10) Z = E.type === o.type ? null : E.child;
            else if (E.tag === 18) {
              if (Z = E.return, Z === null) throw Error(a(341));
              Z.lanes |= v, W = Z.alternate, W !== null && (W.lanes |= v), Wa(Z, v, o), Z = E.sibling;
            } else Z = E.child;
            if (Z !== null) Z.return = E;
            else for (Z = E; Z !== null; ) {
              if (Z === o) {
                Z = null;
                break;
              }
              if (E = Z.sibling, E !== null) {
                E.return = Z.return, Z = E;
                break;
              }
              Z = Z.return;
            }
            E = Z;
          }
          jt(i, o, C.children, v), o = o.child;
        }
        return o;
      case 9:
        return C = o.type, w = o.pendingProps.children, Xu(o, v), C = nl(C), w = w(C), o.flags |= 1, jt(i, o, w, v), o.child;
      case 14:
        return w = o.type, C = kl(w, o.pendingProps), C = kl(w.type, C), hd(i, o, w, C, v);
      case 15:
        return Su(i, o, o.type, o.pendingProps, v);
      case 17:
        return w = o.type, C = o.pendingProps, C = o.elementType === w ? C : kl(w, C), Ni(i, o), o.tag = 1, Ua(w) ? (i = !0, Ii(o)) : i = !1, Xu(o, v), os(o, w, C), $h(o, w, C, v), vd(null, o, w, !0, i, v);
      case 19:
        return Il(i, o, v);
      case 22:
        return zh(i, o, v);
    }
    throw Error(a(156, o.tag));
  };
  function Ev(i, o) {
    return di(i, o);
  }
  function um(i, o, v, w) {
    this.tag = i, this.key = v, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = w, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Pl(i, o, v, w) {
    return new um(i, o, v, w);
  }
  function Zc(i) {
    return i = i.prototype, !(!i || !i.isReactComponent);
  }
  function Jh(i) {
    if (typeof i == "function") return Zc(i) ? 1 : 0;
    if (i != null) {
      if (i = i.$$typeof, i === we) return 11;
      if (i === Te) return 14;
    }
    return 2;
  }
  function xi(i, o) {
    var v = i.alternate;
    return v === null ? (v = Pl(i.tag, o, i.key, i.mode), v.elementType = i.elementType, v.type = i.type, v.stateNode = i.stateNode, v.alternate = i, i.alternate = v) : (v.pendingProps = o, v.type = i.type, v.flags = 0, v.subtreeFlags = 0, v.deletions = null), v.flags = i.flags & 14680064, v.childLanes = i.childLanes, v.lanes = i.lanes, v.child = i.child, v.memoizedProps = i.memoizedProps, v.memoizedState = i.memoizedState, v.updateQueue = i.updateQueue, o = i.dependencies, v.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }, v.sibling = i.sibling, v.index = i.index, v.ref = i.ref, v;
  }
  function Od(i, o, v, w, C, E) {
    var Z = 2;
    if (w = i, typeof i == "function") Zc(i) && (Z = 1);
    else if (typeof i == "string") Z = 5;
    else e: switch (i) {
      case X:
        return ps(v.children, C, E, o);
      case Ce:
        Z = 8, C |= 8;
        break;
      case ae:
        return i = Pl(12, v, o, C | 2), i.elementType = ae, i.lanes = E, i;
      case ue:
        return i = Pl(13, v, o, C), i.elementType = ue, i.lanes = E, i;
      case ge:
        return i = Pl(19, v, o, C), i.elementType = ge, i.lanes = E, i;
      case Ue:
        return Pc(v, C, E, o);
      default:
        if (typeof i == "object" && i !== null) switch (i.$$typeof) {
          case me:
            Z = 10;
            break e;
          case K:
            Z = 9;
            break e;
          case we:
            Z = 11;
            break e;
          case Te:
            Z = 14;
            break e;
          case be:
            Z = 16, w = null;
            break e;
        }
        throw Error(a(130, i == null ? i : typeof i, ""));
    }
    return o = Pl(Z, v, o, C), o.elementType = i, o.type = w, o.lanes = E, o;
  }
  function ps(i, o, v, w) {
    return i = Pl(7, i, w, o), i.lanes = v, i;
  }
  function Pc(i, o, v, w) {
    return i = Pl(22, i, w, o), i.elementType = Ue, i.lanes = v, i.stateNode = { isHidden: !1 }, i;
  }
  function Dd(i, o, v) {
    return i = Pl(6, i, null, o), i.lanes = v, i;
  }
  function e2(i, o, v) {
    return o = Pl(4, i.children !== null ? i.children : [], i.key, o), o.lanes = v, o.stateNode = { containerInfo: i.containerInfo, pendingChildren: null, implementation: i.implementation }, o;
  }
  function Mv(i, o, v, w, C) {
    this.tag = o, this.containerInfo = i, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = k1(0), this.expirationTimes = k1(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = k1(0), this.identifierPrefix = w, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null;
  }
  function t2(i, o, v, w, C, E, Z, W, ee) {
    return i = new Mv(i, o, v, W, ee), o === 1 ? (o = 1, E === !0 && (o |= 8)) : o = 0, E = Pl(3, null, null, o), i.current = E, E.stateNode = i, E.memoizedState = { element: w, isDehydrated: v, cache: null, transitions: null, pendingSuspenseBoundaries: null }, ld(E), i;
  }
  function sm(i, o, v) {
    var w = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: ce, key: w == null ? null : "" + w, children: i, containerInfo: o, implementation: v };
  }
  function Tv(i) {
    if (!i) return pi;
    i = i._reactInternals;
    e: {
      if (xn(i) !== i || i.tag !== 1) throw Error(a(170));
      var o = i;
      do {
        switch (o.tag) {
          case 3:
            o = o.stateNode.context;
            break e;
          case 1:
            if (Ua(o.type)) {
              o = o.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        o = o.return;
      } while (o !== null);
      throw Error(a(171));
    }
    if (i.tag === 1) {
      var v = i.type;
      if (Ua(v)) return Nh(i, v, o);
    }
    return o;
  }
  function n2(i, o, v, w, C, E, Z, W, ee) {
    return i = t2(v, w, !0, i, C, E, Z, W, ee), i.context = Tv(null), v = i.current, w = yi(), C = Yo(v), E = gu(w, C), E.callback = o ?? null, rl(v, E, C), i.current.lanes = C, U0(i, C, w), Oa(i, w), i;
  }
  function Nc(i, o, v, w) {
    var C = o.current, E = yi(), Z = Yo(C);
    return v = Tv(v), o.context === null ? o.context = v : o.pendingContext = v, o = gu(E, Z), o.payload = { element: i }, w = w === void 0 ? null : w, w !== null && (o.callback = w), i = rl(C, o, Z), i !== null && (ol(i, C, Z, E), mc(i, C, Z)), Z;
  }
  function Vc(i) {
    if (i = i.current, !i.child) return null;
    switch (i.child.tag) {
      case 5:
        return i.child.stateNode;
      default:
        return i.child.stateNode;
    }
  }
  function l1(i, o) {
    if (i = i.memoizedState, i !== null && i.dehydrated !== null) {
      var v = i.retryLane;
      i.retryLane = v !== 0 && v < o ? v : o;
    }
  }
  function r2(i, o) {
    l1(i, o), (i = i.alternate) && l1(i, o);
  }
  var Ov = typeof reportError == "function" ? reportError : function(i) {
    console.error(i);
  };
  function a2(i) {
    this._internalRoot = i;
  }
  Bc.prototype.render = a2.prototype.render = function(i) {
    var o = this._internalRoot;
    if (o === null) throw Error(a(409));
    Nc(i, o, null, null);
  }, Bc.prototype.unmount = a2.prototype.unmount = function() {
    var i = this._internalRoot;
    if (i !== null) {
      this._internalRoot = null;
      var o = i.containerInfo;
      r1(function() {
        Nc(null, i, null, null);
      }), o[Xi] = null;
    }
  };
  function Bc(i) {
    this._internalRoot = i;
  }
  Bc.prototype.unstable_scheduleHydration = function(i) {
    if (i) {
      var o = As();
      i = { blockedOn: null, target: i, priority: o };
      for (var v = 0; v < Fu.length && o !== 0 && o < Fu[v].priority; v++) ;
      Fu.splice(v, 0, i), v === 0 && z2(i);
    }
  };
  function jd(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11);
  }
  function Ad(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11 && (i.nodeType !== 8 || i.nodeValue !== " react-mount-point-unstable "));
  }
  function i2() {
  }
  function cm(i, o, v, w, C) {
    if (C) {
      if (typeof w == "function") {
        var E = w;
        w = function() {
          var xe = Vc(Z);
          E.call(xe);
        };
      }
      var Z = n2(o, w, i, 0, null, !1, !1, "", i2);
      return i._reactRootContainer = Z, i[Xi] = Z.current, cu(i.nodeType === 8 ? i.parentNode : i), r1(), Z;
    }
    for (; C = i.lastChild; ) i.removeChild(C);
    if (typeof w == "function") {
      var W = w;
      w = function() {
        var xe = Vc(ee);
        W.call(xe);
      };
    }
    var ee = t2(i, 0, !1, null, null, !1, !1, "", i2);
    return i._reactRootContainer = ee, i[Xi] = ee.current, cu(i.nodeType === 8 ? i.parentNode : i), r1(function() {
      Nc(o, ee, v, w);
    }), ee;
  }
  function kd(i, o, v, w, C) {
    var E = v._reactRootContainer;
    if (E) {
      var Z = E;
      if (typeof C == "function") {
        var W = C;
        C = function() {
          var ee = Vc(Z);
          W.call(ee);
        };
      }
      Nc(o, Z, i, C);
    } else Z = cm(v, o, i, C, w);
    return Vc(Z);
  }
  en = function(i) {
    switch (i.tag) {
      case 3:
        var o = i.stateNode;
        if (o.current.memoizedState.isDehydrated) {
          var v = Nu(o.pendingLanes);
          v !== 0 && (Hn(o, v | 1), Oa(o, Xn()), !(On & 6) && (vo = Xn() + 500, Ol()));
        }
        break;
      case 13:
        r1(function() {
          var w = mu(i, 1);
          if (w !== null) {
            var C = yi();
            ol(w, i, 1, C);
          }
        }), r2(i, 1);
    }
  }, Y0 = function(i) {
    if (i.tag === 13) {
      var o = mu(i, 134217728);
      if (o !== null) {
        var v = yi();
        ol(o, i, 134217728, v);
      }
      r2(i, 134217728);
    }
  }, Ai = function(i) {
    if (i.tag === 13) {
      var o = Yo(i), v = mu(i, o);
      if (v !== null) {
        var w = yi();
        ol(v, i, o, w);
      }
      r2(i, o);
    }
  }, As = function() {
    return Fn;
  }, ks = function(i, o) {
    var v = Fn;
    try {
      return Fn = i, o();
    } finally {
      Fn = v;
    }
  }, Jo = function(i, o, v) {
    switch (o) {
      case "input":
        if (Hr(i, v), o = v.name, v.type === "radio" && o != null) {
          for (v = i; v.parentNode; ) v = v.parentNode;
          for (v = v.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), o = 0; o < v.length; o++) {
            var w = v[o];
            if (w !== i && w.form === i.form) {
              var C = Bs(w);
              if (!C) throw Error(a(90));
              zn(w), Hr(w, C);
            }
          }
        }
        break;
      case "textarea":
        Xe(i, v);
        break;
      case "select":
        o = v.value, o != null && Vt(i, !!v.multiple, o, !1);
    }
  }, O1 = Hc, Pu = r1;
  var Fc = { usingClientEntryPoint: !1, Events: [qt, Kt, Bs, T1, Cf, Hc] }, Tu = { findFiberByHostInstance: cr, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Uc = { bundleType: Tu.bundleType, version: Tu.version, rendererPackageName: Tu.rendererPackageName, rendererConfig: Tu.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: z.ReactCurrentDispatcher, findHostInstanceByFiber: function(i) {
    return i = Rr(i), i === null ? null : i.stateNode;
  }, findFiberByHostInstance: Tu.findFiberByHostInstance, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Ld = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Ld.isDisabled && Ld.supportsFiber) try {
      F0 = Ld.inject(Uc), Do = Ld;
    } catch {
    }
  }
  return Go.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Fc, Go.createPortal = function(i, o) {
    var v = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!jd(o)) throw Error(a(200));
    return sm(i, o, null, v);
  }, Go.createRoot = function(i, o) {
    if (!jd(i)) throw Error(a(299));
    var v = !1, w = "", C = Ov;
    return o != null && (o.unstable_strictMode === !0 && (v = !0), o.identifierPrefix !== void 0 && (w = o.identifierPrefix), o.onRecoverableError !== void 0 && (C = o.onRecoverableError)), o = t2(i, 1, !1, null, null, v, !1, w, C), i[Xi] = o.current, cu(i.nodeType === 8 ? i.parentNode : i), new a2(o);
  }, Go.findDOMNode = function(i) {
    if (i == null) return null;
    if (i.nodeType === 1) return i;
    var o = i._reactInternals;
    if (o === void 0)
      throw typeof i.render == "function" ? Error(a(188)) : (i = Object.keys(i).join(","), Error(a(268, i)));
    return i = Rr(o), i = i === null ? null : i.stateNode, i;
  }, Go.flushSync = function(i) {
    return r1(i);
  }, Go.hydrate = function(i, o, v) {
    if (!Ad(o)) throw Error(a(200));
    return kd(null, i, o, !0, v);
  }, Go.hydrateRoot = function(i, o, v) {
    if (!jd(i)) throw Error(a(405));
    var w = v != null && v.hydratedSources || null, C = !1, E = "", Z = Ov;
    if (v != null && (v.unstable_strictMode === !0 && (C = !0), v.identifierPrefix !== void 0 && (E = v.identifierPrefix), v.onRecoverableError !== void 0 && (Z = v.onRecoverableError)), o = n2(o, null, i, 1, v ?? null, C, !1, E, Z), i[Xi] = o.current, cu(i), w) for (i = 0; i < w.length; i++) v = w[i], C = v._getVersion, C = C(v._source), o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [v, C] : o.mutableSourceEagerHydrationData.push(
      v,
      C
    );
    return new Bc(o);
  }, Go.render = function(i, o, v) {
    if (!Ad(o)) throw Error(a(200));
    return kd(null, i, o, !1, v);
  }, Go.unmountComponentAtNode = function(i) {
    if (!Ad(i)) throw Error(a(40));
    return i._reactRootContainer ? (r1(function() {
      kd(null, null, i, !1, function() {
        i._reactRootContainer = null, i[Xi] = null;
      });
    }), !0) : !1;
  }, Go.unstable_batchedUpdates = Hc, Go.unstable_renderSubtreeIntoContainer = function(i, o, v, w) {
    if (!Ad(v)) throw Error(a(200));
    if (i == null || i._reactInternals === void 0) throw Error(a(38));
    return kd(i, o, v, !1, w);
  }, Go.version = "18.3.1-next-f1338f8080-20240426", Go;
}
var Ko = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V_;
function eZ() {
  return V_ || (V_ = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Sa, t = nM(), a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, l = !1;
    function h(n) {
      l = n;
    }
    function g(n) {
      if (!l) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++)
          u[c - 1] = arguments[c];
        S("warn", n, u);
      }
    }
    function m(n) {
      if (!l) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++)
          u[c - 1] = arguments[c];
        S("error", n, u);
      }
    }
    function S(n, r, u) {
      {
        var c = a.ReactDebugCurrentFrame, p = c.getStackAddendum();
        p !== "" && (r += "%s", u = u.concat([p]));
        var x = u.map(function(_) {
          return String(_);
        });
        x.unshift("Warning: " + r), Function.prototype.apply.call(console[n], console, x);
      }
    }
    var b = 0, R = 1, D = 2, T = 3, j = 4, A = 5, L = 6, P = 7, N = 8, F = 9, Y = 10, G = 11, z = 12, $ = 13, ce = 14, X = 15, Ce = 16, ae = 17, me = 18, K = 19, we = 21, ue = 22, ge = 23, Te = 24, be = 25, Ue = !0, le = !1, _e = !1, Pe = !1, mt = !1, Ze = !0, Nt = /* @__PURE__ */ new Set(), kt = {}, Qe = {};
    function rt(n, r) {
      vt(n, r), vt(n + "Capture", r);
    }
    function vt(n, r) {
      kt[n] && m("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", n), kt[n] = r;
      {
        var u = n.toLowerCase();
        Qe[u] = n, n === "onDoubleClick" && (Qe.ondblclick = n);
      }
      for (var c = 0; c < r.length; c++)
        Nt.add(r[c]);
    }
    var Ot = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", yn = Object.prototype.hasOwnProperty;
    function Ar(n) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, u = r && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function In(n) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function zn(n) {
      return "" + n;
    }
    function er(n, r) {
      if (In())
        return m("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Ar(n)), zn(n);
    }
    function wr(n) {
      if (In())
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ar(n)), zn(n);
    }
    function ea(n, r) {
      if (In())
        return m("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Ar(n)), zn(n);
    }
    function Ca(n, r) {
      if (In())
        return m("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Ar(n)), zn(n);
    }
    function Hr(n) {
      if (In())
        return m("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Ar(n)), zn(n);
    }
    function xt(n) {
      if (In())
        return m("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Ar(n)), zn(n);
    }
    var ln = 0, dn = 1, Vt = 2, Rn = 3, yr = 4, Xe = 5, Xt = 6, En = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Cn = En + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", qe = new RegExp("^[" + En + "][" + Cn + "]*$"), wt = {}, St = {};
    function un(n) {
      return yn.call(St, n) ? !0 : yn.call(wt, n) ? !1 : qe.test(n) ? (St[n] = !0, !0) : (wt[n] = !0, m("Invalid attribute name: `%s`", n), !1);
    }
    function sr(n, r, u) {
      return r !== null ? r.type === ln : u ? !1 : n.length > 2 && (n[0] === "o" || n[0] === "O") && (n[1] === "n" || n[1] === "N");
    }
    function ta(n, r, u, c) {
      if (u !== null && u.type === ln)
        return !1;
      switch (typeof r) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (c)
            return !1;
          if (u !== null)
            return !u.acceptsBooleans;
          var p = n.toLowerCase().slice(0, 5);
          return p !== "data-" && p !== "aria-";
        }
        default:
          return !1;
      }
    }
    function xr(n, r, u, c) {
      if (r === null || typeof r > "u" || ta(n, r, u, c))
        return !0;
      if (c)
        return !1;
      if (u !== null)
        switch (u.type) {
          case Rn:
            return !r;
          case yr:
            return r === !1;
          case Xe:
            return isNaN(r);
          case Xt:
            return isNaN(r) || r < 1;
        }
      return !1;
    }
    function ji(n) {
      return qn.hasOwnProperty(n) ? qn[n] : null;
    }
    function wn(n, r, u, c, p, x, _) {
      this.acceptsBooleans = r === Vt || r === Rn || r === yr, this.attributeName = c, this.attributeNamespace = p, this.mustUseProperty = u, this.propertyName = n, this.type = r, this.sanitizeURL = x, this.removeEmptyString = _;
    }
    var qn = {}, M1 = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    M1.forEach(function(n) {
      qn[n] = new wn(
        n,
        ln,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
      var r = n[0], u = n[1];
      qn[r] = new wn(
        r,
        dn,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
      qn[n] = new wn(
        n,
        Vt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
      qn[n] = new wn(
        n,
        Vt,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(n) {
      qn[n] = new wn(
        n,
        Rn,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      qn[n] = new wn(
        n,
        Rn,
        !0,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      qn[n] = new wn(
        n,
        yr,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      qn[n] = new wn(
        n,
        Xt,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(n) {
      qn[n] = new wn(
        n,
        Xe,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var _l = /[\-\:]([a-z])/g, Jo = function(n) {
      return n[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var r = n.replace(_l, Jo);
      qn[r] = new wn(
        r,
        dn,
        !1,
        // mustUseProperty
        n,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var r = n.replace(_l, Jo);
      qn[r] = new wn(
        r,
        dn,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var r = n.replace(_l, Jo);
      qn[r] = new wn(
        r,
        dn,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(n) {
      qn[n] = new wn(
        n,
        dn,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var zl = "xlinkHref";
    qn[zl] = new wn(
      "xlinkHref",
      dn,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(n) {
      qn[n] = new wn(
        n,
        dn,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Eo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, B0 = !1;
    function T1(n) {
      !B0 && Eo.test(n) && (B0 = !0, m("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(n)));
    }
    function Cf(n, r, u, c) {
      if (c.mustUseProperty) {
        var p = c.propertyName;
        return n[p];
      } else {
        er(u, r), c.sanitizeURL && T1("" + u);
        var x = c.attributeName, _ = null;
        if (c.type === yr) {
          if (n.hasAttribute(x)) {
            var O = n.getAttribute(x);
            return O === "" ? !0 : xr(r, u, c, !1) ? O : O === "" + u ? u : O;
          }
        } else if (n.hasAttribute(x)) {
          if (xr(r, u, c, !1))
            return n.getAttribute(x);
          if (c.type === Rn)
            return u;
          _ = n.getAttribute(x);
        }
        return xr(r, u, c, !1) ? _ === null ? u : _ : _ === "" + u ? u : _;
      }
    }
    function O1(n, r, u, c) {
      {
        if (!un(r))
          return;
        if (!n.hasAttribute(r))
          return u === void 0 ? void 0 : null;
        var p = n.getAttribute(r);
        return er(u, r), p === "" + u ? u : p;
      }
    }
    function Pu(n, r, u, c) {
      var p = ji(r);
      if (!sr(r, p, c)) {
        if (xr(r, u, p, c) && (u = null), c || p === null) {
          if (un(r)) {
            var x = r;
            u === null ? n.removeAttribute(x) : (er(u, r), n.setAttribute(x, "" + u));
          }
          return;
        }
        var _ = p.mustUseProperty;
        if (_) {
          var O = p.propertyName;
          if (u === null) {
            var k = p.type;
            n[O] = k === Rn ? !1 : "";
          } else
            n[O] = u;
          return;
        }
        var V = p.attributeName, U = p.attributeNamespace;
        if (u === null)
          n.removeAttribute(V);
        else {
          var ie = p.type, re;
          ie === Rn || ie === yr && u === !0 ? re = "" : (er(u, V), re = "" + u, p.sanitizeURL && T1(re.toString())), U ? n.setAttributeNS(U, V, re) : n.setAttribute(V, re);
        }
      }
    }
    var Mo = Symbol.for("react.element"), To = Symbol.for("react.portal"), $i = Symbol.for("react.fragment"), Oo = Symbol.for("react.strict_mode"), eu = Symbol.for("react.profiler"), Ds = Symbol.for("react.provider"), tu = Symbol.for("react.context"), ql = Symbol.for("react.forward_ref"), J = Symbol.for("react.suspense"), $e = Symbol.for("react.suspense_list"), ft = Symbol.for("react.memo"), Et = Symbol.for("react.lazy"), Bn = Symbol.for("react.scope"), xn = Symbol.for("react.debug_trace_mode"), hn = Symbol.for("react.offscreen"), vn = Symbol.for("react.legacy_hidden"), Za = Symbol.for("react.cache"), Rr = Symbol.for("react.tracing_marker"), Er = Symbol.iterator, di = "@@iterator";
    function hi(n) {
      if (n === null || typeof n != "object")
        return null;
      var r = Er && n[Er] || n[di];
      return typeof r == "function" ? r : null;
    }
    var Gt = Object.assign, na = 0, Xn, bf, D1, Mh, j1, Th, _f;
    function F0() {
    }
    F0.__reactDisabledLog = !0;
    function Do() {
      {
        if (na === 0) {
          Xn = console.log, bf = console.info, D1 = console.warn, Mh = console.error, j1 = console.group, Th = console.groupCollapsed, _f = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: F0,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        na++;
      }
    }
    function $p() {
      {
        if (na--, na === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Gt({}, n, {
              value: Xn
            }),
            info: Gt({}, n, {
              value: bf
            }),
            warn: Gt({}, n, {
              value: D1
            }),
            error: Gt({}, n, {
              value: Mh
            }),
            group: Gt({}, n, {
              value: j1
            }),
            groupCollapsed: Gt({}, n, {
              value: Th
            }),
            groupEnd: Gt({}, n, {
              value: _f
            })
          });
        }
        na < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Wi = a.ReactCurrentDispatcher, Rf;
    function nu(n, r, u) {
      {
        if (Rf === void 0)
          try {
            throw Error();
          } catch (p) {
            var c = p.stack.trim().match(/\n( *(at )?)/);
            Rf = c && c[1] || "";
          }
        return `
` + Rf + n;
      }
    }
    var Ef = !1, ru;
    {
      var Mf = typeof WeakMap == "function" ? WeakMap : Map;
      ru = new Mf();
    }
    function Nu(n, r) {
      if (!n || Ef)
        return "";
      {
        var u = ru.get(n);
        if (u !== void 0)
          return u;
      }
      var c;
      Ef = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = Wi.current, Wi.current = null, Do();
      try {
        if (r) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Se) {
              c = Se;
            }
            Reflect.construct(n, [], _);
          } else {
            try {
              _.call();
            } catch (Se) {
              c = Se;
            }
            n.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Se) {
            c = Se;
          }
          n();
        }
      } catch (Se) {
        if (Se && c && typeof Se.stack == "string") {
          for (var O = Se.stack.split(`
`), k = c.stack.split(`
`), V = O.length - 1, U = k.length - 1; V >= 1 && U >= 0 && O[V] !== k[U]; )
            U--;
          for (; V >= 1 && U >= 0; V--, U--)
            if (O[V] !== k[U]) {
              if (V !== 1 || U !== 1)
                do
                  if (V--, U--, U < 0 || O[V] !== k[U]) {
                    var ie = `
` + O[V].replace(" at new ", " at ");
                    return n.displayName && ie.includes("<anonymous>") && (ie = ie.replace("<anonymous>", n.displayName)), typeof n == "function" && ru.set(n, ie), ie;
                  }
                while (V >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Ef = !1, Wi.current = x, $p(), Error.prepareStackTrace = p;
      }
      var re = n ? n.displayName || n.name : "", ye = re ? nu(re) : "";
      return typeof n == "function" && ru.set(n, ye), ye;
    }
    function js(n, r, u) {
      return Nu(n, !0);
    }
    function Tf(n, r, u) {
      return Nu(n, !1);
    }
    function Wp(n) {
      var r = n.prototype;
      return !!(r && r.isReactComponent);
    }
    function A1(n, r, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Nu(n, Wp(n));
      if (typeof n == "string")
        return nu(n);
      switch (n) {
        case J:
          return nu("Suspense");
        case $e:
          return nu("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case ql:
            return Tf(n.render);
          case ft:
            return A1(n.type);
          case Et: {
            var c = n, p = c._payload, x = c._init;
            try {
              return A1(x(p));
            } catch {
            }
          }
        }
      return "";
    }
    function Oh(n) {
      switch (n.tag) {
        case A:
          return nu(n.type);
        case Ce:
          return nu("Lazy");
        case $:
          return nu("Suspense");
        case K:
          return nu("SuspenseList");
        case b:
        case D:
        case X:
          return Tf(n.type);
        case G:
          return Tf(n.type.render);
        case R:
          return js(n.type);
        default:
          return "";
      }
    }
    function k1(n) {
      try {
        var r = "", u = n;
        do
          r += Oh(u), u = u.return;
        while (u);
        return r;
      } catch (c) {
        return `
Error generating stack: ` + c.message + `
` + c.stack;
      }
    }
    function U0(n, r, u) {
      var c = n.displayName;
      if (c)
        return c;
      var p = r.displayName || r.name || "";
      return p !== "" ? u + "(" + p + ")" : u;
    }
    function Dh(n) {
      return n.displayName || "Context";
    }
    function Hn(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case $i:
          return "Fragment";
        case To:
          return "Portal";
        case eu:
          return "Profiler";
        case Oo:
          return "StrictMode";
        case J:
          return "Suspense";
        case $e:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case tu:
            var r = n;
            return Dh(r) + ".Consumer";
          case Ds:
            var u = n;
            return Dh(u._context) + ".Provider";
          case ql:
            return U0(n, n.render, "ForwardRef");
          case ft:
            var c = n.displayName || null;
            return c !== null ? c : Hn(n.type) || "Memo";
          case Et: {
            var p = n, x = p._payload, _ = p._init;
            try {
              return Hn(_(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Fn(n, r, u) {
      var c = r.displayName || r.name || "";
      return n.displayName || (c !== "" ? u + "(" + c + ")" : u);
    }
    function Vu(n) {
      return n.displayName || "Context";
    }
    function en(n) {
      var r = n.tag, u = n.type;
      switch (r) {
        case Te:
          return "Cache";
        case F:
          var c = u;
          return Vu(c) + ".Consumer";
        case Y:
          var p = u;
          return Vu(p._context) + ".Provider";
        case me:
          return "DehydratedFragment";
        case G:
          return Fn(u, u.render, "ForwardRef");
        case P:
          return "Fragment";
        case A:
          return u;
        case j:
          return "Portal";
        case T:
          return "Root";
        case L:
          return "Text";
        case Ce:
          return Hn(u);
        case N:
          return u === Oo ? "StrictMode" : "Mode";
        case ue:
          return "Offscreen";
        case z:
          return "Profiler";
        case we:
          return "Scope";
        case $:
          return "Suspense";
        case K:
          return "SuspenseList";
        case be:
          return "TracingMarker";
        case R:
        case b:
        case ae:
        case D:
        case ce:
        case X:
          if (typeof u == "function")
            return u.displayName || u.name || null;
          if (typeof u == "string")
            return u;
          break;
      }
      return null;
    }
    var Y0 = a.ReactDebugCurrentFrame, Ai = null, As = !1;
    function ks() {
      {
        if (Ai === null)
          return null;
        var n = Ai._debugOwner;
        if (n !== null && typeof n < "u")
          return en(n);
      }
      return null;
    }
    function Of() {
      return Ai === null ? "" : k1(Ai);
    }
    function va() {
      Y0.getCurrentStack = null, Ai = null, As = !1;
    }
    function tr(n) {
      Y0.getCurrentStack = n === null ? null : Of, Ai = n, As = !1;
    }
    function Bu() {
      return Ai;
    }
    function Pa(n) {
      As = n;
    }
    function Na(n) {
      return "" + n;
    }
    function Rl(n) {
      switch (typeof n) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return xt(n), n;
        default:
          return "";
      }
    }
    var Fu = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function jh(n, r) {
      Fu[r.type] || r.onChange || r.onInput || r.readOnly || r.disabled || r.value == null || m("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), r.onChange || r.readOnly || r.disabled || r.checked == null || m("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function Ah(n) {
      var r = n.type, u = n.nodeName;
      return u && u.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
    }
    function Uu(n) {
      return n._valueTracker;
    }
    function zp(n) {
      n._valueTracker = null;
    }
    function z2(n) {
      var r = "";
      return n && (Ah(n) ? r = n.checked ? "true" : "false" : r = n.value), r;
    }
    function Df(n) {
      var r = Ah(n) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(n.constructor.prototype, r);
      xt(n[r]);
      var c = "" + n[r];
      if (!(n.hasOwnProperty(r) || typeof u > "u" || typeof u.get != "function" || typeof u.set != "function")) {
        var p = u.get, x = u.set;
        Object.defineProperty(n, r, {
          configurable: !0,
          get: function() {
            return p.call(this);
          },
          set: function(O) {
            xt(O), c = "" + O, x.call(this, O);
          }
        }), Object.defineProperty(n, r, {
          enumerable: u.enumerable
        });
        var _ = {
          getValue: function() {
            return c;
          },
          setValue: function(O) {
            xt(O), c = "" + O;
          },
          stopTracking: function() {
            zp(n), delete n[r];
          }
        };
        return _;
      }
    }
    function $0(n) {
      Uu(n) || (n._valueTracker = Df(n));
    }
    function q2(n) {
      if (!n)
        return !1;
      var r = Uu(n);
      if (!r)
        return !0;
      var u = r.getValue(), c = z2(n);
      return c !== u ? (r.setValue(c), !0) : !1;
    }
    function Zn(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u")
        return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    var Un = !1, Ls = !1, W0 = !1, G2 = !1;
    function K2(n) {
      var r = n.type === "checkbox" || n.type === "radio";
      return r ? n.checked != null : n.value != null;
    }
    function z0(n, r) {
      var u = n, c = r.checked, p = Gt({}, r, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: c ?? u._wrapperState.initialChecked
      });
      return p;
    }
    function q0(n, r) {
      jh("input", r), r.checked !== void 0 && r.defaultChecked !== void 0 && !Ls && (m("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ks() || "A component", r.type), Ls = !0), r.value !== void 0 && r.defaultValue !== void 0 && !Un && (m("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ks() || "A component", r.type), Un = !0);
      var u = n, c = r.defaultValue == null ? "" : r.defaultValue;
      u._wrapperState = {
        initialChecked: r.checked != null ? r.checked : r.defaultChecked,
        initialValue: Rl(r.value != null ? r.value : c),
        controlled: K2(r)
      };
    }
    function G0(n, r) {
      var u = n, c = r.checked;
      c != null && Pu(u, "checked", c, !1);
    }
    function jf(n, r) {
      var u = n;
      {
        var c = K2(r);
        !u._wrapperState.controlled && c && !G2 && (m("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), G2 = !0), u._wrapperState.controlled && !c && !W0 && (m("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), W0 = !0);
      }
      G0(n, r);
      var p = Rl(r.value), x = r.type;
      if (p != null)
        x === "number" ? (p === 0 && u.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        u.value != p) && (u.value = Na(p)) : u.value !== Na(p) && (u.value = Na(p));
      else if (x === "submit" || x === "reset") {
        u.removeAttribute("value");
        return;
      }
      r.hasOwnProperty("value") ? Q0(u, r.type, p) : r.hasOwnProperty("defaultValue") && Q0(u, r.type, Rl(r.defaultValue)), r.checked == null && r.defaultChecked != null && (u.defaultChecked = !!r.defaultChecked);
    }
    function Sr(n, r, u) {
      var c = n;
      if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
        var p = r.type, x = p === "submit" || p === "reset";
        if (x && (r.value === void 0 || r.value === null))
          return;
        var _ = Na(c._wrapperState.initialValue);
        u || _ !== c.value && (c.value = _), c.defaultValue = _;
      }
      var O = c.name;
      O !== "" && (c.name = ""), c.defaultChecked = !c.defaultChecked, c.defaultChecked = !!c._wrapperState.initialChecked, O !== "" && (c.name = O);
    }
    function K0(n, r) {
      var u = n;
      jf(u, r), jo(u, r);
    }
    function jo(n, r) {
      var u = r.name;
      if (r.type === "radio" && u != null) {
        for (var c = n; c.parentNode; )
          c = c.parentNode;
        er(u, "name");
        for (var p = c.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), x = 0; x < p.length; x++) {
          var _ = p[x];
          if (!(_ === n || _.form !== n.form)) {
            var O = se(_);
            if (!O)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            q2(_), jf(_, O);
          }
        }
      }
    }
    function Q0(n, r, u) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (r !== "number" || Zn(n.ownerDocument) !== n) && (u == null ? n.defaultValue = Na(n._wrapperState.initialValue) : n.defaultValue !== Na(u) && (n.defaultValue = Na(u)));
    }
    var Is = !1, Xa = !1, Af = !1;
    function vi(n, r) {
      r.value == null && (typeof r.children == "object" && r.children !== null ? e.Children.forEach(r.children, function(u) {
        u != null && (typeof u == "string" || typeof u == "number" || Xa || (Xa = !0, m("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : r.dangerouslySetInnerHTML != null && (Af || (Af = !0, m("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), r.selected != null && !Is && (m("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Is = !0);
    }
    function Hs(n, r) {
      r.value != null && n.setAttribute("value", Na(Rl(r.value)));
    }
    var kf = Array.isArray;
    function ra(n) {
      return kf(n);
    }
    var Lf;
    Lf = !1;
    function Ja() {
      var n = ks();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    var If = ["value", "defaultValue"];
    function ei(n) {
      {
        jh("select", n);
        for (var r = 0; r < If.length; r++) {
          var u = If[r];
          if (n[u] != null) {
            var c = ra(n[u]);
            n.multiple && !c ? m("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", u, Ja()) : !n.multiple && c && m("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", u, Ja());
          }
        }
      }
    }
    function au(n, r, u, c) {
      var p = n.options;
      if (r) {
        for (var x = u, _ = {}, O = 0; O < x.length; O++)
          _["$" + x[O]] = !0;
        for (var k = 0; k < p.length; k++) {
          var V = _.hasOwnProperty("$" + p[k].value);
          p[k].selected !== V && (p[k].selected = V), V && c && (p[k].defaultSelected = !0);
        }
      } else {
        for (var U = Na(Rl(u)), ie = null, re = 0; re < p.length; re++) {
          if (p[re].value === U) {
            p[re].selected = !0, c && (p[re].defaultSelected = !0);
            return;
          }
          ie === null && !p[re].disabled && (ie = p[re]);
        }
        ie !== null && (ie.selected = !0);
      }
    }
    function X0(n, r) {
      return Gt({}, r, {
        value: void 0
      });
    }
    function iu(n, r) {
      var u = n;
      ei(r), u._wrapperState = {
        wasMultiple: !!r.multiple
      }, r.value !== void 0 && r.defaultValue !== void 0 && !Lf && (m("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Lf = !0);
    }
    function Hf(n, r) {
      var u = n;
      u.multiple = !!r.multiple;
      var c = r.value;
      c != null ? au(u, !!r.multiple, c, !1) : r.defaultValue != null && au(u, !!r.multiple, r.defaultValue, !0);
    }
    function kh(n, r) {
      var u = n, c = u._wrapperState.wasMultiple;
      u._wrapperState.wasMultiple = !!r.multiple;
      var p = r.value;
      p != null ? au(u, !!r.multiple, p, !1) : c !== !!r.multiple && (r.defaultValue != null ? au(u, !!r.multiple, r.defaultValue, !0) : au(u, !!r.multiple, r.multiple ? [] : "", !1));
    }
    function dr(n, r) {
      var u = n, c = r.value;
      c != null && au(u, !!r.multiple, c, !1);
    }
    var lu = !1;
    function J0(n, r) {
      var u = n;
      if (r.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var c = Gt({}, r, {
        value: void 0,
        defaultValue: void 0,
        children: Na(u._wrapperState.initialValue)
      });
      return c;
    }
    function Q2(n, r) {
      var u = n;
      jh("textarea", r), r.value !== void 0 && r.defaultValue !== void 0 && !lu && (m("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", ks() || "A component"), lu = !0);
      var c = r.value;
      if (c == null) {
        var p = r.children, x = r.defaultValue;
        if (p != null) {
          m("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (x != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (ra(p)) {
              if (p.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              p = p[0];
            }
            x = p;
          }
        }
        x == null && (x = ""), c = x;
      }
      u._wrapperState = {
        initialValue: Rl(c)
      };
    }
    function Zf(n, r) {
      var u = n, c = Rl(r.value), p = Rl(r.defaultValue);
      if (c != null) {
        var x = Na(c);
        x !== u.value && (u.value = x), r.defaultValue == null && u.defaultValue !== x && (u.defaultValue = x);
      }
      p != null && (u.defaultValue = Na(p));
    }
    function X2(n, r) {
      var u = n, c = u.textContent;
      c === u._wrapperState.initialValue && c !== "" && c !== null && (u.value = c);
    }
    function J2(n, r) {
      Zf(n, r);
    }
    var ou = "http://www.w3.org/1999/xhtml", ev = "http://www.w3.org/1998/Math/MathML", L1 = "http://www.w3.org/2000/svg";
    function Yu(n) {
      switch (n) {
        case "svg":
          return L1;
        case "math":
          return ev;
        default:
          return ou;
      }
    }
    function ec(n, r) {
      return n == null || n === ou ? Yu(r) : n === L1 && r === "foreignObject" ? ou : n;
    }
    var tv = function(n) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, c, p) {
        MSApp.execUnsafeLocalFunction(function() {
          return n(r, u, c, p);
        });
      } : n;
    }, tc, Pf = tv(function(n, r) {
      if (n.namespaceURI === L1 && !("innerHTML" in n)) {
        tc = tc || document.createElement("div"), tc.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>";
        for (var u = tc.firstChild; n.firstChild; )
          n.removeChild(n.firstChild);
        for (; u.firstChild; )
          n.appendChild(u.firstChild);
        return;
      }
      n.innerHTML = r;
    }), Va = 1, Ao = 3, aa = 8, Gl = 9, nc = 11, Nf = function(n, r) {
      if (r) {
        var u = n.firstChild;
        if (u && u === n.lastChild && u.nodeType === Ao) {
          u.nodeValue = r;
          return;
        }
      }
      n.textContent = r;
    }, nv = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Ba = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function rc(n, r) {
      return n + r.charAt(0).toUpperCase() + r.substring(1);
    }
    var uu = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Ba).forEach(function(n) {
      uu.forEach(function(r) {
        Ba[rc(r, n)] = Ba[n];
      });
    });
    function Vf(n, r, u) {
      var c = r == null || typeof r == "boolean" || r === "";
      return c ? "" : !u && typeof r == "number" && r !== 0 && !(Ba.hasOwnProperty(n) && Ba[n]) ? r + "px" : (Ca(r, n), ("" + r).trim());
    }
    var Lh = /([A-Z])/g, rv = /^ms-/;
    function av(n) {
      return n.replace(Lh, "-$1").toLowerCase().replace(rv, "-ms-");
    }
    var Ih = function() {
    };
    {
      var iv = /^(?:webkit|moz|o)[A-Z]/, I1 = /^-ms-/, H1 = /-(.)/g, lv = /;\s*$/, Z1 = {}, P1 = {}, Bf = !1, zi = !1, $u = function(n) {
        return n.replace(H1, function(r, u) {
          return u.toUpperCase();
        });
      }, qp = function(n) {
        Z1.hasOwnProperty(n) && Z1[n] || (Z1[n] = !0, m(
          "Unsupported style property %s. Did you mean %s?",
          n,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          $u(n.replace(I1, "ms-"))
        ));
      }, Ff = function(n) {
        Z1.hasOwnProperty(n) && Z1[n] || (Z1[n] = !0, m("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1)));
      }, Gp = function(n, r) {
        P1.hasOwnProperty(r) && P1[r] || (P1[r] = !0, m(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, r.replace(lv, "")));
      }, Zs = function(n, r) {
        Bf || (Bf = !0, m("`NaN` is an invalid value for the `%s` css style property.", n));
      }, qi = function(n, r) {
        zi || (zi = !0, m("`Infinity` is an invalid value for the `%s` css style property.", n));
      };
      Ih = function(n, r) {
        n.indexOf("-") > -1 ? qp(n) : iv.test(n) ? Ff(n) : lv.test(r) && Gp(n, r), typeof r == "number" && (isNaN(r) ? Zs(n, r) : isFinite(r) || qi(n, r));
      };
    }
    var Uf = Ih;
    function ov(n) {
      {
        var r = "", u = "";
        for (var c in n)
          if (n.hasOwnProperty(c)) {
            var p = n[c];
            if (p != null) {
              var x = c.indexOf("--") === 0;
              r += u + (x ? c : av(c)) + ":", r += Vf(c, p, x), u = ";";
            }
          }
        return r || null;
      }
    }
    function Hh(n, r) {
      var u = n.style;
      for (var c in r)
        if (r.hasOwnProperty(c)) {
          var p = c.indexOf("--") === 0;
          p || Uf(c, r[c]);
          var x = Vf(c, r[c], p);
          c === "float" && (c = "cssFloat"), p ? u.setProperty(c, x) : u[c] = x;
        }
    }
    function uv(n) {
      return n == null || typeof n == "boolean" || n === "";
    }
    function sv(n) {
      var r = {};
      for (var u in n)
        for (var c = nv[u] || [u], p = 0; p < c.length; p++)
          r[c[p]] = u;
      return r;
    }
    function Kp(n, r) {
      {
        if (!r)
          return;
        var u = sv(n), c = sv(r), p = {};
        for (var x in u) {
          var _ = u[x], O = c[x];
          if (O && _ !== O) {
            var k = _ + "," + O;
            if (p[k])
              continue;
            p[k] = !0, m("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", uv(n[_]) ? "Removing" : "Updating", _, O);
          }
        }
      }
    }
    var N1 = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, oe = Gt({
      menuitem: !0
    }, N1), Re = "__html";
    function pe(n, r) {
      if (r) {
        if (oe[n] && (r.children != null || r.dangerouslySetInnerHTML != null))
          throw new Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (r.dangerouslySetInnerHTML != null) {
          if (r.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof r.dangerouslySetInnerHTML != "object" || !(Re in r.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!r.suppressContentEditableWarning && r.contentEditable && r.children != null && m("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), r.style != null && typeof r.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Je(n, r) {
      if (n.indexOf("-") === -1)
        return typeof r.is == "string";
      switch (n) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var zt = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Mn = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Cr = {}, nr = new RegExp("^(aria)-[" + Cn + "]*$"), ac = new RegExp("^(aria)[A-Z][" + Cn + "]*$");
    function Qp(n, r) {
      {
        if (yn.call(Cr, r) && Cr[r])
          return !0;
        if (ac.test(r)) {
          var u = "aria-" + r.slice(4).toLowerCase(), c = Mn.hasOwnProperty(u) ? u : null;
          if (c == null)
            return m("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", r), Cr[r] = !0, !0;
          if (r !== c)
            return m("Invalid ARIA attribute `%s`. Did you mean `%s`?", r, c), Cr[r] = !0, !0;
        }
        if (nr.test(r)) {
          var p = r.toLowerCase(), x = Mn.hasOwnProperty(p) ? p : null;
          if (x == null)
            return Cr[r] = !0, !1;
          if (r !== x)
            return m("Unknown ARIA attribute `%s`. Did you mean `%s`?", r, x), Cr[r] = !0, !0;
        }
      }
      return !0;
    }
    function El(n, r) {
      {
        var u = [];
        for (var c in r) {
          var p = Qp(n, c);
          p || u.push(c);
        }
        var x = u.map(function(_) {
          return "`" + _ + "`";
        }).join(", ");
        u.length === 1 ? m("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", x, n) : u.length > 1 && m("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", x, n);
      }
    }
    function su(n, r) {
      Je(n, r) || El(n, r);
    }
    var Yf = !1;
    function ko(n, r) {
      {
        if (n !== "input" && n !== "textarea" && n !== "select")
          return;
        r != null && r.value === null && !Yf && (Yf = !0, n === "select" && r.multiple ? m("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", n) : m("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", n));
      }
    }
    var Ps = function() {
    };
    {
      var pa = {}, Tn = /^on./, V1 = /^on[^A-Z]/, $f = new RegExp("^(aria)-[" + Cn + "]*$"), ic = new RegExp("^(aria)[A-Z][" + Cn + "]*$");
      Ps = function(n, r, u, c) {
        if (yn.call(pa, r) && pa[r])
          return !0;
        var p = r.toLowerCase();
        if (p === "onfocusin" || p === "onfocusout")
          return m("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), pa[r] = !0, !0;
        if (c != null) {
          var x = c.registrationNameDependencies, _ = c.possibleRegistrationNames;
          if (x.hasOwnProperty(r))
            return !0;
          var O = _.hasOwnProperty(p) ? _[p] : null;
          if (O != null)
            return m("Invalid event handler property `%s`. Did you mean `%s`?", r, O), pa[r] = !0, !0;
          if (Tn.test(r))
            return m("Unknown event handler property `%s`. It will be ignored.", r), pa[r] = !0, !0;
        } else if (Tn.test(r))
          return V1.test(r) && m("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", r), pa[r] = !0, !0;
        if ($f.test(r) || ic.test(r))
          return !0;
        if (p === "innerhtml")
          return m("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), pa[r] = !0, !0;
        if (p === "aria")
          return m("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), pa[r] = !0, !0;
        if (p === "is" && u !== null && u !== void 0 && typeof u != "string")
          return m("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof u), pa[r] = !0, !0;
        if (typeof u == "number" && isNaN(u))
          return m("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", r), pa[r] = !0, !0;
        var k = ji(r), V = k !== null && k.type === ln;
        if (zt.hasOwnProperty(p)) {
          var U = zt[p];
          if (U !== r)
            return m("Invalid DOM property `%s`. Did you mean `%s`?", r, U), pa[r] = !0, !0;
        } else if (!V && r !== p)
          return m("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", r, p), pa[r] = !0, !0;
        return typeof u == "boolean" && ta(r, u, k, !1) ? (u ? m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', u, r, r, u, r) : m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', u, r, r, u, r, r, r), pa[r] = !0, !0) : V ? !0 : ta(r, u, k, !1) ? (pa[r] = !0, !1) : ((u === "false" || u === "true") && k !== null && k.type === Rn && (m("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", u, r, u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', r, u), pa[r] = !0), !0);
      };
    }
    var Wf = function(n, r, u) {
      {
        var c = [];
        for (var p in r) {
          var x = Ps(n, p, r[p], u);
          x || c.push(p);
        }
        var _ = c.map(function(O) {
          return "`" + O + "`";
        }).join(", ");
        c.length === 1 ? m("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, n) : c.length > 1 && m("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, n);
      }
    };
    function cv(n, r, u) {
      Je(n, r) || Wf(n, r, u);
    }
    var Zh = 1, Ns = 2, Gi = 4, lc = Zh | Ns | Gi, Vs = null;
    function Kl(n) {
      Vs !== null && m("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Vs = n;
    }
    function zf() {
      Vs === null && m("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Vs = null;
    }
    function qf(n) {
      return n === Vs;
    }
    function B1(n) {
      var r = n.target || n.srcElement || window;
      return r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === Ao ? r.parentNode : r;
    }
    var Gf = null, ki = null, Ml = null;
    function F1(n) {
      var r = q(n);
      if (r) {
        if (typeof Gf != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var u = r.stateNode;
        if (u) {
          var c = se(u);
          Gf(r.stateNode, r.type, c);
        }
      }
    }
    function fv(n) {
      Gf = n;
    }
    function hr(n) {
      ki ? Ml ? Ml.push(n) : Ml = [n] : ki = n;
    }
    function Ph() {
      return ki !== null || Ml !== null;
    }
    function Wu() {
      if (ki) {
        var n = ki, r = Ml;
        if (ki = null, Ml = null, F1(n), r)
          for (var u = 0; u < r.length; u++)
            F1(r[u]);
      }
    }
    var cu = function(n, r) {
      return n(r);
    }, oc = function() {
    }, uc = !1;
    function U1() {
      var n = Ph();
      n && (oc(), Wu());
    }
    function sc(n, r, u) {
      if (uc)
        return n(r, u);
      uc = !0;
      try {
        return cu(n, r, u);
      } finally {
        uc = !1, U1();
      }
    }
    function Y1(n, r, u) {
      cu = n, oc = u;
    }
    function ia(n) {
      return n === "button" || n === "input" || n === "select" || n === "textarea";
    }
    function ti(n, r, u) {
      switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(u.disabled && ia(r));
        default:
          return !1;
      }
    }
    function cc(n, r) {
      var u = n.stateNode;
      if (u === null)
        return null;
      var c = se(u);
      if (c === null)
        return null;
      var p = c[r];
      if (ti(r, n.type, c))
        return null;
      if (p && typeof p != "function")
        throw new Error("Expected `" + r + "` listener to be a function, instead got a value of `" + typeof p + "` type.");
      return p;
    }
    var Kf = !1;
    if (Ot)
      try {
        var fu = {};
        Object.defineProperty(fu, "passive", {
          get: function() {
            Kf = !0;
          }
        }), window.addEventListener("test", fu, fu), window.removeEventListener("test", fu, fu);
      } catch {
        Kf = !1;
      }
    function fc(n, r, u, c, p, x, _, O, k) {
      var V = Array.prototype.slice.call(arguments, 3);
      try {
        r.apply(u, V);
      } catch (U) {
        this.onError(U);
      }
    }
    var $1 = fc;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var du = document.createElement("react");
      $1 = function(r, u, c, p, x, _, O, k, V) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var U = document.createEvent("Event"), ie = !1, re = !0, ye = window.event, Se = Object.getOwnPropertyDescriptor(window, "event");
        function Ee() {
          du.removeEventListener(Me, Ut, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = ye);
        }
        var lt = Array.prototype.slice.call(arguments, 3);
        function Ut() {
          ie = !0, Ee(), u.apply(c, lt), re = !1;
        }
        var Lt, An = !1, Sn = !1;
        function he(ve) {
          if (Lt = ve.error, An = !0, Lt === null && ve.colno === 0 && ve.lineno === 0 && (Sn = !0), ve.defaultPrevented && Lt != null && typeof Lt == "object")
            try {
              Lt._suppressLogging = !0;
            } catch {
            }
        }
        var Me = "react-" + (r || "invokeguardedcallback");
        if (window.addEventListener("error", he), du.addEventListener(Me, Ut, !1), U.initEvent(Me, !1, !1), du.dispatchEvent(U), Se && Object.defineProperty(window, "event", Se), ie && re && (An ? Sn && (Lt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Lt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Lt)), window.removeEventListener("error", he), !ie)
          return Ee(), fc.apply(this, arguments);
      };
    }
    var dc = $1, Ki = !1, zu = null, hu = !1, W1 = null, z1 = {
      onError: function(n) {
        Ki = !0, zu = n;
      }
    };
    function hc(n, r, u, c, p, x, _, O, k) {
      Ki = !1, zu = null, dc.apply(z1, arguments);
    }
    function qu(n, r, u, c, p, x, _, O, k) {
      if (hc.apply(this, arguments), Ki) {
        var V = Tl();
        hu || (hu = !0, W1 = V);
      }
    }
    function dv() {
      if (hu) {
        var n = W1;
        throw hu = !1, W1 = null, n;
      }
    }
    function q1() {
      return Ki;
    }
    function Tl() {
      if (Ki) {
        var n = zu;
        return Ki = !1, zu = null, n;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Qi(n) {
      return n._reactInternals;
    }
    function Xi(n) {
      return n._reactInternals !== void 0;
    }
    function Qf(n, r) {
      n._reactInternals = r;
    }
    var H = (
      /*                      */
      0
    ), Ql = (
      /*                */
      1
    ), cr = (
      /*                    */
      2
    ), qt = (
      /*                       */
      4
    ), Kt = (
      /*                */
      16
    ), Bs = (
      /*                 */
      32
    ), Xf = (
      /*                     */
      64
    ), pn = (
      /*                   */
      128
    ), la = (
      /*            */
      256
    ), Yn = (
      /*                          */
      512
    ), $n = (
      /*                     */
      1024
    ), pi = (
      /*                      */
      2048
    ), Zr = (
      /*                    */
      4096
    ), oa = (
      /*                   */
      8192
    ), Fa = (
      /*             */
      16384
    ), G1 = (
      /*               */
      32767
    ), Ua = (
      /*                   */
      32768
    ), Li = (
      /*                */
      65536
    ), Jf = (
      /* */
      131072
    ), Nh = (
      /*                       */
      1048576
    ), Ii = (
      /*                    */
      2097152
    ), Gu = (
      /*                 */
      4194304
    ), Xl = (
      /*                */
      8388608
    ), Jl = (
      /*               */
      16777216
    ), vc = (
      /*              */
      33554432
    ), ed = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      qt | $n | 0
    ), vu = cr | qt | Kt | Bs | Yn | Zr | oa, Ol = qt | Xf | Yn | oa, eo = pi | Kt, Mr = Gu | Xl | Ii, td = a.ReactCurrentOwner;
    function Lo(n) {
      var r = n, u = n;
      if (n.alternate)
        for (; r.return; )
          r = r.return;
      else {
        var c = r;
        do
          r = c, (r.flags & (cr | Zr)) !== H && (u = r.return), c = r.return;
        while (c);
      }
      return r.tag === T ? u : null;
    }
    function Ji(n) {
      if (n.tag === $) {
        var r = n.memoizedState;
        if (r === null) {
          var u = n.alternate;
          u !== null && (r = u.memoizedState);
        }
        if (r !== null)
          return r.dehydrated;
      }
      return null;
    }
    function el(n) {
      return n.tag === T ? n.stateNode.containerInfo : null;
    }
    function Fs(n) {
      return Lo(n) === n;
    }
    function Io(n) {
      {
        var r = td.current;
        if (r !== null && r.tag === R) {
          var u = r, c = u.stateNode;
          c._warnedAboutRefsInRender || m("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", en(u) || "A component"), c._warnedAboutRefsInRender = !0;
        }
      }
      var p = Qi(n);
      return p ? Lo(p) === p : !1;
    }
    function to(n) {
      if (Lo(n) !== n)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Ku(n) {
      var r = n.alternate;
      if (!r) {
        var u = Lo(n);
        if (u === null)
          throw new Error("Unable to find node on an unmounted component.");
        return u !== n ? null : n;
      }
      for (var c = n, p = r; ; ) {
        var x = c.return;
        if (x === null)
          break;
        var _ = x.alternate;
        if (_ === null) {
          var O = x.return;
          if (O !== null) {
            c = p = O;
            continue;
          }
          break;
        }
        if (x.child === _.child) {
          for (var k = x.child; k; ) {
            if (k === c)
              return to(x), n;
            if (k === p)
              return to(x), r;
            k = k.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (c.return !== p.return)
          c = x, p = _;
        else {
          for (var V = !1, U = x.child; U; ) {
            if (U === c) {
              V = !0, c = x, p = _;
              break;
            }
            if (U === p) {
              V = !0, p = x, c = _;
              break;
            }
            U = U.sibling;
          }
          if (!V) {
            for (U = _.child; U; ) {
              if (U === c) {
                V = !0, c = _, p = x;
                break;
              }
              if (U === p) {
                V = !0, p = _, c = x;
                break;
              }
              U = U.sibling;
            }
            if (!V)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (c.alternate !== p)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (c.tag !== T)
        throw new Error("Unable to find node on an unmounted component.");
      return c.stateNode.current === c ? n : r;
    }
    function Vh(n) {
      var r = Ku(n);
      return r !== null ? K1(r) : null;
    }
    function K1(n) {
      if (n.tag === A || n.tag === L)
        return n;
      for (var r = n.child; r !== null; ) {
        var u = K1(r);
        if (u !== null)
          return u;
        r = r.sibling;
      }
      return null;
    }
    function Us(n) {
      var r = Ku(n);
      return r !== null ? Ya(r) : null;
    }
    function Ya(n) {
      if (n.tag === A || n.tag === L)
        return n;
      for (var r = n.child; r !== null; ) {
        if (r.tag !== j) {
          var u = Ya(r);
          if (u !== null)
            return u;
        }
        r = r.sibling;
      }
      return null;
    }
    var Hi = t.unstable_scheduleCallback, br = t.unstable_cancelCallback, no = t.unstable_shouldYield, Ho = t.unstable_requestPaint, $r = t.unstable_now, pu = t.unstable_getCurrentPriorityLevel, $a = t.unstable_ImmediatePriority, nd = t.unstable_UserBlockingPriority, ro = t.unstable_NormalPriority, Bh = t.unstable_LowPriority, Dl = t.unstable_IdlePriority, Zo = t.unstable_yieldValue, hv = t.unstable_setDisableYieldValue, Po = null, Pr = null, at = null, jl = !1, Pn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function rd(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var r = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (r.isDisabled)
        return !0;
      if (!r.supportsFiber)
        return m("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        n = Gt({}, n, {
          getLaneLabelMap: Wa,
          injectProfilingHooks: ad
        }), Po = r.inject(n), Pr = r;
      } catch (u) {
        m("React instrumentation encountered an error: %s.", u);
      }
      return !!r.checkDCE;
    }
    function pc(n, r) {
      if (Pr && typeof Pr.onScheduleFiberRoot == "function")
        try {
          Pr.onScheduleFiberRoot(Po, n, r);
        } catch (u) {
          jl || (jl = !0, m("React instrumentation encountered an error: %s", u));
        }
    }
    function tl(n, r) {
      if (Pr && typeof Pr.onCommitFiberRoot == "function")
        try {
          var u = (n.current.flags & pn) === pn;
          {
            var c;
            switch (r) {
              case qr:
                c = $a;
                break;
              case Dt:
                c = nd;
                break;
              case al:
                c = ro;
                break;
              case ss:
                c = Dl;
                break;
              default:
                c = ro;
                break;
            }
            Pr.onCommitFiberRoot(Po, n, c, u);
          }
        } catch (p) {
          jl || (jl = !0, m("React instrumentation encountered an error: %s", p));
        }
    }
    function Qu(n) {
      if (Pr && typeof Pr.onPostCommitFiberRoot == "function")
        try {
          Pr.onPostCommitFiberRoot(Po, n);
        } catch (r) {
          jl || (jl = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function Q1(n) {
      if (Pr && typeof Pr.onCommitFiberUnmount == "function")
        try {
          Pr.onCommitFiberUnmount(Po, n);
        } catch (r) {
          jl || (jl = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function vr(n) {
      if (typeof Zo == "function" && (hv(n), h(n)), Pr && typeof Pr.setStrictMode == "function")
        try {
          Pr.setStrictMode(Po, n);
        } catch (r) {
          jl || (jl = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function ad(n) {
      at = n;
    }
    function Wa() {
      {
        for (var n = /* @__PURE__ */ new Map(), r = 1, u = 0; u < zr; u++) {
          var c = Xp(r);
          n.set(r, c), r *= 2;
        }
        return n;
      }
    }
    function Xu(n) {
      at !== null && typeof at.markCommitStarted == "function" && at.markCommitStarted(n);
    }
    function nl() {
      at !== null && typeof at.markCommitStopped == "function" && at.markCommitStopped();
    }
    function ao(n) {
      at !== null && typeof at.markComponentRenderStarted == "function" && at.markComponentRenderStarted(n);
    }
    function Ju() {
      at !== null && typeof at.markComponentRenderStopped == "function" && at.markComponentRenderStopped();
    }
    function id(n) {
      at !== null && typeof at.markComponentPassiveEffectMountStarted == "function" && at.markComponentPassiveEffectMountStarted(n);
    }
    function mu() {
      at !== null && typeof at.markComponentPassiveEffectMountStopped == "function" && at.markComponentPassiveEffectMountStopped();
    }
    function Al(n) {
      at !== null && typeof at.markComponentPassiveEffectUnmountStarted == "function" && at.markComponentPassiveEffectUnmountStarted(n);
    }
    function ld() {
      at !== null && typeof at.markComponentPassiveEffectUnmountStopped == "function" && at.markComponentPassiveEffectUnmountStopped();
    }
    function vv(n) {
      at !== null && typeof at.markComponentLayoutEffectMountStarted == "function" && at.markComponentLayoutEffectMountStarted(n);
    }
    function gu() {
      at !== null && typeof at.markComponentLayoutEffectMountStopped == "function" && at.markComponentLayoutEffectMountStopped();
    }
    function rl(n) {
      at !== null && typeof at.markComponentLayoutEffectUnmountStarted == "function" && at.markComponentLayoutEffectUnmountStarted(n);
    }
    function mc() {
      at !== null && typeof at.markComponentLayoutEffectUnmountStopped == "function" && at.markComponentLayoutEffectUnmountStopped();
    }
    function pv(n, r, u) {
      at !== null && typeof at.markComponentErrored == "function" && at.markComponentErrored(n, r, u);
    }
    function X1(n, r, u) {
      at !== null && typeof at.markComponentSuspended == "function" && at.markComponentSuspended(n, r, u);
    }
    function Fh(n) {
      at !== null && typeof at.markLayoutEffectsStarted == "function" && at.markLayoutEffectsStarted(n);
    }
    function gc() {
      at !== null && typeof at.markLayoutEffectsStopped == "function" && at.markLayoutEffectsStopped();
    }
    function No(n) {
      at !== null && typeof at.markPassiveEffectsStarted == "function" && at.markPassiveEffectsStarted(n);
    }
    function wc() {
      at !== null && typeof at.markPassiveEffectsStopped == "function" && at.markPassiveEffectsStopped();
    }
    function Ys(n) {
      at !== null && typeof at.markRenderStarted == "function" && at.markRenderStarted(n);
    }
    function wu() {
      at !== null && typeof at.markRenderYielded == "function" && at.markRenderYielded();
    }
    function od() {
      at !== null && typeof at.markRenderStopped == "function" && at.markRenderStopped();
    }
    function es(n) {
      at !== null && typeof at.markRenderScheduled == "function" && at.markRenderScheduled(n);
    }
    function Uh(n, r) {
      at !== null && typeof at.markForceUpdateScheduled == "function" && at.markForceUpdateScheduled(n, r);
    }
    function J1(n, r) {
      at !== null && typeof at.markStateUpdateScheduled == "function" && at.markStateUpdateScheduled(n, r);
    }
    var et = (
      /*                         */
      0
    ), on = (
      /*                 */
      1
    ), Nn = (
      /*                    */
      2
    ), _r = (
      /*               */
      8
    ), Zi = (
      /*              */
      16
    ), ud = Math.clz32 ? Math.clz32 : Wr, ts = Math.log, kr = Math.LN2;
    function Wr(n) {
      var r = n >>> 0;
      return r === 0 ? 32 : 31 - (ts(r) / kr | 0) | 0;
    }
    var zr = 31, He = (
      /*                        */
      0
    ), Nr = (
      /*                          */
      0
    ), It = (
      /*                        */
      1
    ), tn = (
      /*    */
      2
    ), Tr = (
      /*             */
      4
    ), yu = (
      /*            */
      8
    ), ni = (
      /*                     */
      16
    ), ns = (
      /*                */
      32
    ), mi = (
      /*                       */
      4194240
    ), ri = (
      /*                        */
      64
    ), ba = (
      /*                        */
      128
    ), yc = (
      /*                        */
      256
    ), rs = (
      /*                        */
      512
    ), e0 = (
      /*                        */
      1024
    ), xc = (
      /*                        */
      2048
    ), Sc = (
      /*                        */
      4096
    ), ai = (
      /*                        */
      8192
    ), io = (
      /*                        */
      16384
    ), t0 = (
      /*                       */
      32768
    ), Cc = (
      /*                       */
      65536
    ), $s = (
      /*                       */
      131072
    ), as = (
      /*                       */
      262144
    ), n0 = (
      /*                       */
      524288
    ), Ws = (
      /*                       */
      1048576
    ), is = (
      /*                       */
      2097152
    ), zs = (
      /*                            */
      130023424
    ), gi = (
      /*                             */
      4194304
    ), sd = (
      /*                             */
      8388608
    ), lo = (
      /*                             */
      16777216
    ), bc = (
      /*                             */
      33554432
    ), _c = (
      /*                             */
      67108864
    ), r0 = gi, a0 = (
      /*          */
      134217728
    ), Yh = (
      /*                          */
      268435455
    ), i0 = (
      /*               */
      268435456
    ), ls = (
      /*                        */
      536870912
    ), Pi = (
      /*                   */
      1073741824
    );
    function Xp(n) {
      {
        if (n & It)
          return "Sync";
        if (n & tn)
          return "InputContinuousHydration";
        if (n & Tr)
          return "InputContinuous";
        if (n & yu)
          return "DefaultHydration";
        if (n & ni)
          return "Default";
        if (n & ns)
          return "TransitionHydration";
        if (n & mi)
          return "Transition";
        if (n & zs)
          return "Retry";
        if (n & a0)
          return "SelectiveHydration";
        if (n & i0)
          return "IdleHydration";
        if (n & ls)
          return "Idle";
        if (n & Pi)
          return "Offscreen";
      }
    }
    var fr = -1, l0 = ri, _a = gi;
    function wi(n) {
      switch (Bo(n)) {
        case It:
          return It;
        case tn:
          return tn;
        case Tr:
          return Tr;
        case yu:
          return yu;
        case ni:
          return ni;
        case ns:
          return ns;
        case ri:
        case ba:
        case yc:
        case rs:
        case e0:
        case xc:
        case Sc:
        case ai:
        case io:
        case t0:
        case Cc:
        case $s:
        case as:
        case n0:
        case Ws:
        case is:
          return n & mi;
        case gi:
        case sd:
        case lo:
        case bc:
        case _c:
          return n & zs;
        case a0:
          return a0;
        case i0:
          return i0;
        case ls:
          return ls;
        case Pi:
          return Pi;
        default:
          return m("Should have found matching lanes. This is a bug in React."), n;
      }
    }
    function qs(n, r) {
      var u = n.pendingLanes;
      if (u === He)
        return He;
      var c = He, p = n.suspendedLanes, x = n.pingedLanes, _ = u & Yh;
      if (_ !== He) {
        var O = _ & ~p;
        if (O !== He)
          c = wi(O);
        else {
          var k = _ & x;
          k !== He && (c = wi(k));
        }
      } else {
        var V = u & ~p;
        V !== He ? c = wi(V) : x !== He && (c = wi(x));
      }
      if (c === He)
        return He;
      if (r !== He && r !== c && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (r & p) === He) {
        var U = Bo(c), ie = Bo(r);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          U >= ie || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          U === ni && (ie & mi) !== He
        )
          return r;
      }
      (c & Tr) !== He && (c |= u & ni);
      var re = n.entangledLanes;
      if (re !== He)
        for (var ye = n.entanglements, Se = c & re; Se > 0; ) {
          var Ee = us(Se), lt = 1 << Ee;
          c |= ye[Ee], Se &= ~lt;
        }
      return c;
    }
    function Jp(n, r) {
      for (var u = n.eventTimes, c = fr; r > 0; ) {
        var p = us(r), x = 1 << p, _ = u[p];
        _ > c && (c = _), r &= ~x;
      }
      return c;
    }
    function cd(n, r) {
      switch (n) {
        case It:
        case tn:
        case Tr:
          return r + 250;
        case yu:
        case ni:
        case ns:
        case ri:
        case ba:
        case yc:
        case rs:
        case e0:
        case xc:
        case Sc:
        case ai:
        case io:
        case t0:
        case Cc:
        case $s:
        case as:
        case n0:
        case Ws:
        case is:
          return r + 5e3;
        case gi:
        case sd:
        case lo:
        case bc:
        case _c:
          return fr;
        case a0:
        case i0:
        case ls:
        case Pi:
          return fr;
        default:
          return m("Should have found matching lanes. This is a bug in React."), fr;
      }
    }
    function o0(n, r) {
      for (var u = n.pendingLanes, c = n.suspendedLanes, p = n.pingedLanes, x = n.expirationTimes, _ = u; _ > 0; ) {
        var O = us(_), k = 1 << O, V = x[O];
        V === fr ? ((k & c) === He || (k & p) !== He) && (x[O] = cd(k, r)) : V <= r && (n.expiredLanes |= k), _ &= ~k;
      }
    }
    function kl(n) {
      return wi(n.pendingLanes);
    }
    function u0(n) {
      var r = n.pendingLanes & -1073741825;
      return r !== He ? r : r & Pi ? Pi : He;
    }
    function fd(n) {
      return (n & It) !== He;
    }
    function Rc(n) {
      return (n & Yh) !== He;
    }
    function os(n) {
      return (n & zs) === n;
    }
    function s0(n) {
      var r = It | Tr | ni;
      return (n & r) === He;
    }
    function $h(n) {
      return (n & mi) === n;
    }
    function Vo(n, r) {
      var u = tn | Tr | yu | ni;
      return (r & u) !== He;
    }
    function dd(n, r) {
      return (r & n.expiredLanes) !== He;
    }
    function Gs(n) {
      return (n & mi) !== He;
    }
    function Wh() {
      var n = l0;
      return l0 <<= 1, (l0 & mi) === He && (l0 = ri), n;
    }
    function Ec() {
      var n = _a;
      return _a <<= 1, (_a & zs) === He && (_a = gi), n;
    }
    function Bo(n) {
      return n & -n;
    }
    function xu(n) {
      return Bo(n);
    }
    function us(n) {
      return 31 - ud(n);
    }
    function Mc(n) {
      return us(n);
    }
    function ii(n, r) {
      return (n & r) !== He;
    }
    function ua(n, r) {
      return (n & r) === r;
    }
    function jt(n, r) {
      return n | r;
    }
    function Tc(n, r) {
      return n & ~r;
    }
    function hd(n, r) {
      return n & r;
    }
    function Su(n) {
      return n;
    }
    function zh(n, r) {
      return n !== Nr && n < r ? n : r;
    }
    function Oc(n) {
      for (var r = [], u = 0; u < zr; u++)
        r.push(n);
      return r;
    }
    function Ks(n, r, u) {
      n.pendingLanes |= r, r !== ls && (n.suspendedLanes = He, n.pingedLanes = He);
      var c = n.eventTimes, p = Mc(r);
      c[p] = u;
    }
    function qh(n, r) {
      n.suspendedLanes |= r, n.pingedLanes &= ~r;
      for (var u = n.expirationTimes, c = r; c > 0; ) {
        var p = us(c), x = 1 << p;
        u[p] = fr, c &= ~x;
      }
    }
    function vd(n, r, u) {
      n.pingedLanes |= n.suspendedLanes & r;
    }
    function mv(n, r) {
      var u = n.pendingLanes & ~r;
      n.pendingLanes = r, n.suspendedLanes = He, n.pingedLanes = He, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r;
      for (var c = n.entanglements, p = n.eventTimes, x = n.expirationTimes, _ = u; _ > 0; ) {
        var O = us(_), k = 1 << O;
        c[O] = He, p[O] = fr, x[O] = fr, _ &= ~k;
      }
    }
    function Ll(n, r) {
      for (var u = n.entangledLanes |= r, c = n.entanglements, p = u; p; ) {
        var x = us(p), _ = 1 << x;
        // Is this one of the newly entangled lanes?
        _ & r | // Is this lane transitively entangled with the newly entangled lanes?
        c[x] & r && (c[x] |= r), p &= ~_;
      }
    }
    function Dc(n, r) {
      var u = Bo(r), c;
      switch (u) {
        case Tr:
          c = tn;
          break;
        case ni:
          c = yu;
          break;
        case ri:
        case ba:
        case yc:
        case rs:
        case e0:
        case xc:
        case Sc:
        case ai:
        case io:
        case t0:
        case Cc:
        case $s:
        case as:
        case n0:
        case Ws:
        case is:
        case gi:
        case sd:
        case lo:
        case bc:
        case _c:
          c = ns;
          break;
        case ls:
          c = i0;
          break;
        default:
          c = Nr;
          break;
      }
      return (c & (n.suspendedLanes | r)) !== Nr ? Nr : c;
    }
    function c0(n, r, u) {
      if (Pn)
        for (var c = n.pendingUpdatersLaneMap; u > 0; ) {
          var p = Mc(u), x = 1 << p, _ = c[p];
          _.add(r), u &= ~x;
        }
    }
    function jc(n, r) {
      if (Pn)
        for (var u = n.pendingUpdatersLaneMap, c = n.memoizedUpdaters; r > 0; ) {
          var p = Mc(r), x = 1 << p, _ = u[p];
          _.size > 0 && (_.forEach(function(O) {
            var k = O.alternate;
            (k === null || !c.has(k)) && c.add(O);
          }), _.clear()), r &= ~x;
        }
    }
    function Qs(n, r) {
      return null;
    }
    var qr = It, Dt = Tr, al = ni, ss = ls, Il = Nr;
    function Ni() {
      return Il;
    }
    function rr(n) {
      Il = n;
    }
    function gv(n, r) {
      var u = Il;
      try {
        return Il = n, r();
      } finally {
        Il = u;
      }
    }
    function za(n, r) {
      return n !== 0 && n < r ? n : r;
    }
    function Gh(n, r) {
      return n > r ? n : r;
    }
    function pd(n, r) {
      return n !== 0 && n < r;
    }
    function md(n) {
      var r = Bo(n);
      return pd(qr, r) ? pd(Dt, r) ? Rc(r) ? al : ss : Dt : qr;
    }
    function cs(n) {
      var r = n.current.memoizedState;
      return r.isDehydrated;
    }
    var Ra;
    function em(n) {
      Ra = n;
    }
    function tm(n) {
      Ra(n);
    }
    var f0;
    function Or(n) {
      f0 = n;
    }
    var li;
    function dt(n) {
      li = n;
    }
    var Xs;
    function Ac(n) {
      Xs = n;
    }
    var Kh;
    function nm(n) {
      Kh = n;
    }
    var oo = !1, fs = [], uo = null, Cu = null, bu = null, d0 = /* @__PURE__ */ new Map(), Js = /* @__PURE__ */ new Map(), so = [], Ea = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function co(n) {
      return Ea.indexOf(n) > -1;
    }
    function Fo(n, r, u, c, p) {
      return {
        blockedOn: n,
        domEventName: r,
        eventSystemFlags: u,
        nativeEvent: p,
        targetContainers: [c]
      };
    }
    function gd(n, r) {
      switch (n) {
        case "focusin":
        case "focusout":
          uo = null;
          break;
        case "dragenter":
        case "dragleave":
          Cu = null;
          break;
        case "mouseover":
        case "mouseout":
          bu = null;
          break;
        case "pointerover":
        case "pointerout": {
          var u = r.pointerId;
          d0.delete(u);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var c = r.pointerId;
          Js.delete(c);
          break;
        }
      }
    }
    function Uo(n, r, u, c, p, x) {
      if (n === null || n.nativeEvent !== x) {
        var _ = Fo(r, u, c, p, x);
        if (r !== null) {
          var O = q(r);
          O !== null && f0(O);
        }
        return _;
      }
      n.eventSystemFlags |= c;
      var k = n.targetContainers;
      return p !== null && k.indexOf(p) === -1 && k.push(p), n;
    }
    function il(n, r, u, c, p) {
      switch (r) {
        case "focusin": {
          var x = p;
          return uo = Uo(uo, n, r, u, c, x), !0;
        }
        case "dragenter": {
          var _ = p;
          return Cu = Uo(Cu, n, r, u, c, _), !0;
        }
        case "mouseover": {
          var O = p;
          return bu = Uo(bu, n, r, u, c, O), !0;
        }
        case "pointerover": {
          var k = p, V = k.pointerId;
          return d0.set(V, Uo(d0.get(V) || null, n, r, u, c, k)), !0;
        }
        case "gotpointercapture": {
          var U = p, ie = U.pointerId;
          return Js.set(ie, Uo(Js.get(ie) || null, n, r, u, c, U)), !0;
        }
      }
      return !1;
    }
    function wd(n) {
      var r = B(n.target);
      if (r !== null) {
        var u = Lo(r);
        if (u !== null) {
          var c = u.tag;
          if (c === $) {
            var p = Ji(u);
            if (p !== null) {
              n.blockedOn = p, Kh(n.priority, function() {
                li(u);
              });
              return;
            }
          } else if (c === T) {
            var x = u.stateNode;
            if (cs(x)) {
              n.blockedOn = el(u);
              return;
            }
          }
        }
      }
      n.blockedOn = null;
    }
    function fo(n) {
      for (var r = Xs(), u = {
        blockedOn: null,
        target: n,
        priority: r
      }, c = 0; c < so.length && pd(r, so[c].priority); c++)
        ;
      so.splice(c, 0, u), c === 0 && wd(u);
    }
    function e1(n) {
      if (n.blockedOn !== null)
        return !1;
      for (var r = n.targetContainers; r.length > 0; ) {
        var u = r[0], c = Gr(n.domEventName, n.eventSystemFlags, u, n.nativeEvent);
        if (c === null) {
          var p = n.nativeEvent, x = new p.constructor(p.type, p);
          Kl(x), p.target.dispatchEvent(x), zf();
        } else {
          var _ = q(c);
          return _ !== null && f0(_), n.blockedOn = c, !1;
        }
        r.shift();
      }
      return !0;
    }
    function yd(n, r, u) {
      e1(n) && u.delete(r);
    }
    function ho() {
      oo = !1, uo !== null && e1(uo) && (uo = null), Cu !== null && e1(Cu) && (Cu = null), bu !== null && e1(bu) && (bu = null), d0.forEach(yd), Js.forEach(yd);
    }
    function Hl(n, r) {
      n.blockedOn === r && (n.blockedOn = null, oo || (oo = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, ho)));
    }
    function h0(n) {
      if (fs.length > 0) {
        Hl(fs[0], n);
        for (var r = 1; r < fs.length; r++) {
          var u = fs[r];
          u.blockedOn === n && (u.blockedOn = null);
        }
      }
      uo !== null && Hl(uo, n), Cu !== null && Hl(Cu, n), bu !== null && Hl(bu, n);
      var c = function(O) {
        return Hl(O, n);
      };
      d0.forEach(c), Js.forEach(c);
      for (var p = 0; p < so.length; p++) {
        var x = so[p];
        x.blockedOn === n && (x.blockedOn = null);
      }
      for (; so.length > 0; ) {
        var _ = so[0];
        if (_.blockedOn !== null)
          break;
        wd(_), _.blockedOn === null && so.shift();
      }
    }
    var t1 = a.ReactCurrentBatchConfig, v0 = !0;
    function xd(n) {
      v0 = !!n;
    }
    function Zl() {
      return v0;
    }
    function On(n, r, u) {
      var c = p0(r), p;
      switch (c) {
        case qr:
          p = Ma;
          break;
        case Dt:
          p = sa;
          break;
        case al:
        default:
          p = ma;
          break;
      }
      return p.bind(null, r, u, n);
    }
    function Ma(n, r, u, c) {
      var p = Ni(), x = t1.transition;
      t1.transition = null;
      try {
        rr(qr), ma(n, r, u, c);
      } finally {
        rr(p), t1.transition = x;
      }
    }
    function sa(n, r, u, c) {
      var p = Ni(), x = t1.transition;
      t1.transition = null;
      try {
        rr(Dt), ma(n, r, u, c);
      } finally {
        rr(p), t1.transition = x;
      }
    }
    function ma(n, r, u, c) {
      v0 && ll(n, r, u, c);
    }
    function ll(n, r, u, c) {
      var p = Gr(n, r, u, c);
      if (p === null) {
        sl(n, r, c, _u, u), gd(n, c);
        return;
      }
      if (il(p, n, r, u, c)) {
        c.stopPropagation();
        return;
      }
      if (gd(n, c), r & Gi && co(n)) {
        for (; p !== null; ) {
          var x = q(p);
          x !== null && tm(x);
          var _ = Gr(n, r, u, c);
          if (_ === null && sl(n, r, c, _u, u), _ === p)
            break;
          p = _;
        }
        p !== null && c.stopPropagation();
        return;
      }
      sl(n, r, c, null, u);
    }
    var _u = null;
    function Gr(n, r, u, c) {
      _u = null;
      var p = B1(c), x = B(p);
      if (x !== null) {
        var _ = Lo(x);
        if (_ === null)
          x = null;
        else {
          var O = _.tag;
          if (O === $) {
            var k = Ji(_);
            if (k !== null)
              return k;
            x = null;
          } else if (O === T) {
            var V = _.stateNode;
            if (cs(V))
              return el(_);
            x = null;
          } else _ !== x && (x = null);
        }
      }
      return _u = x, null;
    }
    function p0(n) {
      switch (n) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return qr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Dt;
        case "message": {
          var r = pu();
          switch (r) {
            case $a:
              return qr;
            case nd:
              return Dt;
            case ro:
            case Bh:
              return al;
            case Dl:
              return ss;
            default:
              return al;
          }
        }
        default:
          return al;
      }
    }
    function ds(n, r, u) {
      return n.addEventListener(r, u, !1), u;
    }
    function kc(n, r, u) {
      return n.addEventListener(r, u, !0), u;
    }
    function Sd(n, r, u, c) {
      return n.addEventListener(r, u, {
        capture: !0,
        passive: c
      }), u;
    }
    function Lc(n, r, u, c) {
      return n.addEventListener(r, u, {
        passive: c
      }), u;
    }
    var Ta = null, Ic = null, vo = null;
    function Ru(n) {
      return Ta = n, Ic = Eu(), !0;
    }
    function Cd() {
      Ta = null, Ic = null, vo = null;
    }
    function bd() {
      if (vo)
        return vo;
      var n, r = Ic, u = r.length, c, p = Eu(), x = p.length;
      for (n = 0; n < u && r[n] === p[n]; n++)
        ;
      var _ = u - n;
      for (c = 1; c <= _ && r[u - c] === p[x - c]; c++)
        ;
      var O = c > 1 ? 1 - c : void 0;
      return vo = p.slice(n, O), vo;
    }
    function Eu() {
      return "value" in Ta ? Ta.value : Ta.textContent;
    }
    function n1(n) {
      var r, u = n.keyCode;
      return "charCode" in n ? (r = n.charCode, r === 0 && u === 13 && (r = 13)) : r = u, r === 10 && (r = 13), r >= 32 || r === 13 ? r : 0;
    }
    function po() {
      return !0;
    }
    function oi() {
      return !1;
    }
    function qa(n) {
      function r(u, c, p, x, _) {
        this._reactName = u, this._targetInst = p, this.type = c, this.nativeEvent = x, this.target = _, this.currentTarget = null;
        for (var O in n)
          if (n.hasOwnProperty(O)) {
            var k = n[O];
            k ? this[O] = k(x) : this[O] = x[O];
          }
        var V = x.defaultPrevented != null ? x.defaultPrevented : x.returnValue === !1;
        return V ? this.isDefaultPrevented = po : this.isDefaultPrevented = oi, this.isPropagationStopped = oi, this;
      }
      return Gt(r.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = po);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = po);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: po
      }), r;
    }
    var hs = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(n) {
        return n.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, m0 = qa(hs), Mu = Gt({}, hs, {
      view: 0,
      detail: 0
    }), yi = qa(Mu), Yo, ol, Oa;
    function _d(n) {
      n !== Oa && (Oa && n.type === "mousemove" ? (Yo = n.screenX - Oa.screenX, ol = n.screenY - Oa.screenY) : (Yo = 0, ol = 0), Oa = n);
    }
    var g0 = Gt({}, Mu, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Xh,
      button: 0,
      buttons: 0,
      relatedTarget: function(n) {
        return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
      },
      movementX: function(n) {
        return "movementX" in n ? n.movementX : (_d(n), Yo);
      },
      movementY: function(n) {
        return "movementY" in n ? n.movementY : ol;
      }
    }), Rd = qa(g0), rm = Gt({}, g0, {
      dataTransfer: 0
    }), vs = qa(rm), wv = Gt({}, Mu, {
      relatedTarget: 0
    }), Hc = qa(wv), r1 = Gt({}, hs, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Qh = qa(r1), a1 = Gt({}, hs, {
      clipboardData: function(n) {
        return "clipboardData" in n ? n.clipboardData : window.clipboardData;
      }
    }), yv = qa(a1), xv = Gt({}, hs, {
      data: 0
    }), Ed = qa(xv), Md = Ed, am = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, im = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Sv(n) {
      if (n.key) {
        var r = am[n.key] || n.key;
        if (r !== "Unidentified")
          return r;
      }
      if (n.type === "keypress") {
        var u = n1(n);
        return u === 13 ? "Enter" : String.fromCharCode(u);
      }
      return n.type === "keydown" || n.type === "keyup" ? im[n.keyCode] || "Unidentified" : "";
    }
    var Cv = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function i1(n) {
      var r = this, u = r.nativeEvent;
      if (u.getModifierState)
        return u.getModifierState(n);
      var c = Cv[n];
      return c ? !!u[c] : !1;
    }
    function Xh(n) {
      return i1;
    }
    var w0 = Gt({}, Mu, {
      key: Sv,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Xh,
      // Legacy Interface
      charCode: function(n) {
        return n.type === "keypress" ? n1(n) : 0;
      },
      keyCode: function(n) {
        return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      },
      which: function(n) {
        return n.type === "keypress" ? n1(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      }
    }), Td = qa(w0), Lr = Gt({}, g0, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), bv = qa(Lr), _v = Gt({}, Mu, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Xh
    }), lm = qa(_v), om = Gt({}, hs, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Rv = qa(om), Ev = Gt({}, g0, {
      deltaX: function(n) {
        return "deltaX" in n ? n.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in n ? -n.wheelDeltaX : 0
        );
      },
      deltaY: function(n) {
        return "deltaY" in n ? n.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in n ? -n.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in n ? -n.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), um = qa(Ev), Pl = [9, 13, 27, 32], Zc = 229, Jh = Ot && "CompositionEvent" in window, xi = null;
    Ot && "documentMode" in document && (xi = document.documentMode);
    var Od = Ot && "TextEvent" in window && !xi, ps = Ot && (!Jh || xi && xi > 8 && xi <= 11), Pc = 32, Dd = String.fromCharCode(Pc);
    function e2() {
      rt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), rt("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), rt("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), rt("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Mv = !1;
    function t2(n) {
      return (n.ctrlKey || n.altKey || n.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(n.ctrlKey && n.altKey);
    }
    function sm(n) {
      switch (n) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Tv(n, r) {
      return n === "keydown" && r.keyCode === Zc;
    }
    function n2(n, r) {
      switch (n) {
        case "keyup":
          return Pl.indexOf(r.keyCode) !== -1;
        case "keydown":
          return r.keyCode !== Zc;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Nc(n) {
      var r = n.detail;
      return typeof r == "object" && "data" in r ? r.data : null;
    }
    function Vc(n) {
      return n.locale === "ko";
    }
    var l1 = !1;
    function r2(n, r, u, c, p) {
      var x, _;
      if (Jh ? x = sm(r) : l1 ? n2(r, c) && (x = "onCompositionEnd") : Tv(r, c) && (x = "onCompositionStart"), !x)
        return null;
      ps && !Vc(c) && (!l1 && x === "onCompositionStart" ? l1 = Ru(p) : x === "onCompositionEnd" && l1 && (_ = bd()));
      var O = kv(u, x);
      if (O.length > 0) {
        var k = new Ed(x, r, null, c, p);
        if (n.push({
          event: k,
          listeners: O
        }), _)
          k.data = _;
        else {
          var V = Nc(c);
          V !== null && (k.data = V);
        }
      }
    }
    function Ov(n, r) {
      switch (n) {
        case "compositionend":
          return Nc(r);
        case "keypress":
          var u = r.which;
          return u !== Pc ? null : (Mv = !0, Dd);
        case "textInput":
          var c = r.data;
          return c === Dd && Mv ? null : c;
        default:
          return null;
      }
    }
    function a2(n, r) {
      if (l1) {
        if (n === "compositionend" || !Jh && n2(n, r)) {
          var u = bd();
          return Cd(), l1 = !1, u;
        }
        return null;
      }
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!t2(r)) {
            if (r.char && r.char.length > 1)
              return r.char;
            if (r.which)
              return String.fromCharCode(r.which);
          }
          return null;
        case "compositionend":
          return ps && !Vc(r) ? null : r.data;
        default:
          return null;
      }
    }
    function Bc(n, r, u, c, p) {
      var x;
      if (Od ? x = Ov(r, c) : x = a2(r, c), !x)
        return null;
      var _ = kv(u, "onBeforeInput");
      if (_.length > 0) {
        var O = new Md("onBeforeInput", "beforeinput", null, c, p);
        n.push({
          event: O,
          listeners: _
        }), O.data = x;
      }
    }
    function jd(n, r, u, c, p, x, _) {
      r2(n, r, u, c, p), Bc(n, r, u, c, p);
    }
    var Ad = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function i2(n) {
      var r = n && n.nodeName && n.nodeName.toLowerCase();
      return r === "input" ? !!Ad[n.type] : r === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function cm(n) {
      if (!Ot)
        return !1;
      var r = "on" + n, u = r in document;
      if (!u) {
        var c = document.createElement("div");
        c.setAttribute(r, "return;"), u = typeof c[r] == "function";
      }
      return u;
    }
    function kd() {
      rt("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Fc(n, r, u, c) {
      hr(c);
      var p = kv(r, "onChange");
      if (p.length > 0) {
        var x = new m0("onChange", "change", null, u, c);
        n.push({
          event: x,
          listeners: p
        });
      }
    }
    var Tu = null, Uc = null;
    function Ld(n) {
      var r = n.nodeName && n.nodeName.toLowerCase();
      return r === "select" || r === "input" && n.type === "file";
    }
    function i(n) {
      var r = [];
      Fc(r, Uc, n, B1(n)), sc(o, r);
    }
    function o(n) {
      E3(n, 0);
    }
    function v(n) {
      var r = te(n);
      if (q2(r))
        return n;
    }
    function w(n, r) {
      if (n === "change")
        return r;
    }
    var C = !1;
    Ot && (C = cm("input") && (!document.documentMode || document.documentMode > 9));
    function E(n, r) {
      Tu = n, Uc = r, Tu.attachEvent("onpropertychange", W);
    }
    function Z() {
      Tu && (Tu.detachEvent("onpropertychange", W), Tu = null, Uc = null);
    }
    function W(n) {
      n.propertyName === "value" && v(Uc) && i(n);
    }
    function ee(n, r, u) {
      n === "focusin" ? (Z(), E(r, u)) : n === "focusout" && Z();
    }
    function xe(n, r) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown")
        return v(Uc);
    }
    function Ve(n) {
      var r = n.nodeName;
      return r && r.toLowerCase() === "input" && (n.type === "checkbox" || n.type === "radio");
    }
    function Ye(n, r) {
      if (n === "click")
        return v(r);
    }
    function Ne(n, r) {
      if (n === "input" || n === "change")
        return v(r);
    }
    function ot(n) {
      var r = n._wrapperState;
      !r || !r.controlled || n.type !== "number" || Q0(n, "number", n.value);
    }
    function yt(n, r, u, c, p, x, _) {
      var O = u ? te(u) : window, k, V;
      if (Ld(O) ? k = w : i2(O) ? C ? k = Ne : (k = xe, V = ee) : Ve(O) && (k = Ye), k) {
        var U = k(r, u);
        if (U) {
          Fc(n, U, c, p);
          return;
        }
      }
      V && V(r, O, u), r === "focusout" && ot(O);
    }
    function Ct() {
      vt("onMouseEnter", ["mouseout", "mouseover"]), vt("onMouseLeave", ["mouseout", "mouseover"]), vt("onPointerEnter", ["pointerout", "pointerover"]), vt("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Vr(n, r, u, c, p, x, _) {
      var O = r === "mouseover" || r === "pointerover", k = r === "mouseout" || r === "pointerout";
      if (O && !qf(c)) {
        var V = c.relatedTarget || c.fromElement;
        if (V && (B(V) || I(V)))
          return;
      }
      if (!(!k && !O)) {
        var U;
        if (p.window === p)
          U = p;
        else {
          var ie = p.ownerDocument;
          ie ? U = ie.defaultView || ie.parentWindow : U = window;
        }
        var re, ye;
        if (k) {
          var Se = c.relatedTarget || c.toElement;
          if (re = u, ye = Se ? B(Se) : null, ye !== null) {
            var Ee = Lo(ye);
            (ye !== Ee || ye.tag !== A && ye.tag !== L) && (ye = null);
          }
        } else
          re = null, ye = u;
        if (re !== ye) {
          var lt = Rd, Ut = "onMouseLeave", Lt = "onMouseEnter", An = "mouse";
          (r === "pointerout" || r === "pointerover") && (lt = bv, Ut = "onPointerLeave", Lt = "onPointerEnter", An = "pointer");
          var Sn = re == null ? U : te(re), he = ye == null ? U : te(ye), Me = new lt(Ut, An + "leave", re, c, p);
          Me.target = Sn, Me.relatedTarget = he;
          var ve = null, We = B(p);
          if (We === u) {
            var pt = new lt(Lt, An + "enter", ye, c, p);
            pt.target = he, pt.relatedTarget = Sn, ve = pt;
          }
          T3(n, Me, ve, re, ye);
        }
      }
    }
    function fe(n, r) {
      return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
    }
    var ne = typeof Object.is == "function" ? Object.is : fe;
    function de(n, r) {
      if (ne(n, r))
        return !0;
      if (typeof n != "object" || n === null || typeof r != "object" || r === null)
        return !1;
      var u = Object.keys(n), c = Object.keys(r);
      if (u.length !== c.length)
        return !1;
      for (var p = 0; p < u.length; p++) {
        var x = u[p];
        if (!yn.call(r, x) || !ne(n[x], r[x]))
          return !1;
      }
      return !0;
    }
    function ze(n) {
      for (; n && n.firstChild; )
        n = n.firstChild;
      return n;
    }
    function bt(n) {
      for (; n; ) {
        if (n.nextSibling)
          return n.nextSibling;
        n = n.parentNode;
      }
    }
    function Zt(n, r) {
      for (var u = ze(n), c = 0, p = 0; u; ) {
        if (u.nodeType === Ao) {
          if (p = c + u.textContent.length, c <= r && p >= r)
            return {
              node: u,
              offset: r - c
            };
          c = p;
        }
        u = ze(bt(u));
      }
    }
    function Bt(n) {
      var r = n.ownerDocument, u = r && r.defaultView || window, c = u.getSelection && u.getSelection();
      if (!c || c.rangeCount === 0)
        return null;
      var p = c.anchorNode, x = c.anchorOffset, _ = c.focusNode, O = c.focusOffset;
      return Wt(n, p, x, _, O);
    }
    function Wt(n, r, u, c, p) {
      var x = 0, _ = -1, O = -1, k = 0, V = 0, U = n, ie = null;
      e: for (; ; ) {
        for (var re = null; U === r && (u === 0 || U.nodeType === Ao) && (_ = x + u), U === c && (p === 0 || U.nodeType === Ao) && (O = x + p), U.nodeType === Ao && (x += U.nodeValue.length), (re = U.firstChild) !== null; )
          ie = U, U = re;
        for (; ; ) {
          if (U === n)
            break e;
          if (ie === r && ++k === u && (_ = x), ie === c && ++V === p && (O = x), (re = U.nextSibling) !== null)
            break;
          U = ie, ie = U.parentNode;
        }
        U = re;
      }
      return _ === -1 || O === -1 ? null : {
        start: _,
        end: O
      };
    }
    function ga(n, r) {
      var u = n.ownerDocument || document, c = u && u.defaultView || window;
      if (c.getSelection) {
        var p = c.getSelection(), x = n.textContent.length, _ = Math.min(r.start, x), O = r.end === void 0 ? _ : Math.min(r.end, x);
        if (!p.extend && _ > O) {
          var k = O;
          O = _, _ = k;
        }
        var V = Zt(n, _), U = Zt(n, O);
        if (V && U) {
          if (p.rangeCount === 1 && p.anchorNode === V.node && p.anchorOffset === V.offset && p.focusNode === U.node && p.focusOffset === U.offset)
            return;
          var ie = u.createRange();
          ie.setStart(V.node, V.offset), p.removeAllRanges(), _ > O ? (p.addRange(ie), p.extend(U.node, U.offset)) : (ie.setEnd(U.node, U.offset), p.addRange(ie));
        }
      }
    }
    function Dn(n) {
      return n && n.nodeType === Ao;
    }
    function Ou(n, r) {
      return !n || !r ? !1 : n === r ? !0 : Dn(n) ? !1 : Dn(r) ? Ou(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1;
    }
    function fm(n) {
      return n && n.ownerDocument && Ou(n.ownerDocument.documentElement, n);
    }
    function Zw(n) {
      try {
        return typeof n.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function y3() {
      for (var n = window, r = Zn(); r instanceof n.HTMLIFrameElement; ) {
        if (Zw(r))
          n = r.contentWindow;
        else
          return r;
        r = Zn(n.document);
      }
      return r;
    }
    function dm(n) {
      var r = n && n.nodeName && n.nodeName.toLowerCase();
      return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
    }
    function Pw() {
      var n = y3();
      return {
        focusedElem: n,
        selectionRange: dm(n) ? Vw(n) : null
      };
    }
    function Nw(n) {
      var r = y3(), u = n.focusedElem, c = n.selectionRange;
      if (r !== u && fm(u)) {
        c !== null && dm(u) && Bw(u, c);
        for (var p = [], x = u; x = x.parentNode; )
          x.nodeType === Va && p.push({
            element: x,
            left: x.scrollLeft,
            top: x.scrollTop
          });
        typeof u.focus == "function" && u.focus();
        for (var _ = 0; _ < p.length; _++) {
          var O = p[_];
          O.element.scrollLeft = O.left, O.element.scrollTop = O.top;
        }
      }
    }
    function Vw(n) {
      var r;
      return "selectionStart" in n ? r = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : r = Bt(n), r || {
        start: 0,
        end: 0
      };
    }
    function Bw(n, r) {
      var u = r.start, c = r.end;
      c === void 0 && (c = u), "selectionStart" in n ? (n.selectionStart = u, n.selectionEnd = Math.min(c, n.value.length)) : ga(n, r);
    }
    var Fw = Ot && "documentMode" in document && document.documentMode <= 11;
    function Uw() {
      rt("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Vi = null, hm = null, l2 = null, o1 = !1;
    function sn(n) {
      if ("selectionStart" in n && dm(n))
        return {
          start: n.selectionStart,
          end: n.selectionEnd
        };
      var r = n.ownerDocument && n.ownerDocument.defaultView || window, u = r.getSelection();
      return {
        anchorNode: u.anchorNode,
        anchorOffset: u.anchorOffset,
        focusNode: u.focusNode,
        focusOffset: u.focusOffset
      };
    }
    function Yw(n) {
      return n.window === n ? n.document : n.nodeType === Gl ? n : n.ownerDocument;
    }
    function ul(n, r, u) {
      var c = Yw(u);
      if (!(o1 || Vi == null || Vi !== Zn(c))) {
        var p = sn(Vi);
        if (!l2 || !de(l2, p)) {
          l2 = p;
          var x = kv(hm, "onSelect");
          if (x.length > 0) {
            var _ = new m0("onSelect", "select", null, r, u);
            n.push({
              event: _,
              listeners: x
            }), _.target = Vi;
          }
        }
      }
    }
    function wa(n, r, u, c, p, x, _) {
      var O = u ? te(u) : window;
      switch (r) {
        case "focusin":
          (i2(O) || O.contentEditable === "true") && (Vi = O, hm = u, l2 = null);
          break;
        case "focusout":
          Vi = null, hm = null, l2 = null;
          break;
        case "mousedown":
          o1 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          o1 = !1, ul(n, c, p);
          break;
        case "selectionchange":
          if (Fw)
            break;
        case "keydown":
        case "keyup":
          ul(n, c, p);
      }
    }
    function Dv(n, r) {
      var u = {};
      return u[n.toLowerCase()] = r.toLowerCase(), u["Webkit" + n] = "webkit" + r, u["Moz" + n] = "moz" + r, u;
    }
    var mo = {
      animationend: Dv("Animation", "AnimationEnd"),
      animationiteration: Dv("Animation", "AnimationIteration"),
      animationstart: Dv("Animation", "AnimationStart"),
      transitionend: Dv("Transition", "TransitionEnd")
    }, vm = {}, x3 = {};
    Ot && (x3 = document.createElement("div").style, "AnimationEvent" in window || (delete mo.animationend.animation, delete mo.animationiteration.animation, delete mo.animationstart.animation), "TransitionEvent" in window || delete mo.transitionend.transition);
    function jv(n) {
      if (vm[n])
        return vm[n];
      if (!mo[n])
        return n;
      var r = mo[n];
      for (var u in r)
        if (r.hasOwnProperty(u) && u in x3)
          return vm[n] = r[u];
      return n;
    }
    var S3 = jv("animationend"), C3 = jv("animationiteration"), Av = jv("animationstart"), b3 = jv("transitionend"), ms = /* @__PURE__ */ new Map(), pm = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Du(n, r) {
      ms.set(n, r), rt(r, [n]);
    }
    function Kr() {
      for (var n = 0; n < pm.length; n++) {
        var r = pm[n], u = r.toLowerCase(), c = r[0].toUpperCase() + r.slice(1);
        Du(u, "on" + c);
      }
      Du(S3, "onAnimationEnd"), Du(C3, "onAnimationIteration"), Du(Av, "onAnimationStart"), Du("dblclick", "onDoubleClick"), Du("focusin", "onFocus"), Du("focusout", "onBlur"), Du(b3, "onTransitionEnd");
    }
    function ca(n, r, u, c, p, x, _) {
      var O = ms.get(r);
      if (O !== void 0) {
        var k = m0, V = r;
        switch (r) {
          case "keypress":
            if (n1(c) === 0)
              return;
          case "keydown":
          case "keyup":
            k = Td;
            break;
          case "focusin":
            V = "focus", k = Hc;
            break;
          case "focusout":
            V = "blur", k = Hc;
            break;
          case "beforeblur":
          case "afterblur":
            k = Hc;
            break;
          case "click":
            if (c.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Rd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = vs;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = lm;
            break;
          case S3:
          case C3:
          case Av:
            k = Qh;
            break;
          case b3:
            k = Rv;
            break;
          case "scroll":
            k = yi;
            break;
          case "wheel":
            k = um;
            break;
          case "copy":
          case "cut":
          case "paste":
            k = yv;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = bv;
            break;
        }
        var U = (x & Gi) !== 0;
        {
          var ie = !U && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          r === "scroll", re = zw(u, O, c.type, U, ie);
          if (re.length > 0) {
            var ye = new k(O, V, null, c, p);
            n.push({
              event: ye,
              listeners: re
            });
          }
        }
      }
    }
    Kr(), Ct(), kd(), Uw(), e2();
    function _3(n, r, u, c, p, x, _) {
      ca(n, r, u, c, p, x);
      var O = (x & lc) === 0;
      O && (Vr(n, r, u, c, p), yt(n, r, u, c, p), wa(n, r, u, c, p), jd(n, r, u, c, p));
    }
    var o2 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], mm = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(o2));
    function R3(n, r, u) {
      var c = n.type || "unknown-event";
      n.currentTarget = u, qu(c, r, void 0, n), n.currentTarget = null;
    }
    function $w(n, r, u) {
      var c;
      if (u)
        for (var p = r.length - 1; p >= 0; p--) {
          var x = r[p], _ = x.instance, O = x.currentTarget, k = x.listener;
          if (_ !== c && n.isPropagationStopped())
            return;
          R3(n, k, O), c = _;
        }
      else
        for (var V = 0; V < r.length; V++) {
          var U = r[V], ie = U.instance, re = U.currentTarget, ye = U.listener;
          if (ie !== c && n.isPropagationStopped())
            return;
          R3(n, ye, re), c = ie;
        }
    }
    function E3(n, r) {
      for (var u = (r & Gi) !== 0, c = 0; c < n.length; c++) {
        var p = n[c], x = p.event, _ = p.listeners;
        $w(x, _, u);
      }
      dv();
    }
    function Ww(n, r, u, c, p) {
      var x = B1(u), _ = [];
      _3(_, n, c, u, x, r), E3(_, r);
    }
    function Dr(n, r) {
      mm.has(n) || m('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', n);
      var u = !1, c = Ie(r), p = u1(n);
      c.has(p) || (gm(r, n, Ns, u), c.add(p));
    }
    function Yc(n, r, u) {
      mm.has(n) && !r && m('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', n);
      var c = 0;
      r && (c |= Gi), gm(u, n, c, r);
    }
    var Id = "_reactListening" + Math.random().toString(36).slice(2);
    function u2(n) {
      if (!n[Id]) {
        n[Id] = !0, Nt.forEach(function(u) {
          u !== "selectionchange" && (mm.has(u) || Yc(u, !1, n), Yc(u, !0, n));
        });
        var r = n.nodeType === Gl ? n : n.ownerDocument;
        r !== null && (r[Id] || (r[Id] = !0, Yc("selectionchange", !1, r)));
      }
    }
    function gm(n, r, u, c, p) {
      var x = On(n, r, u), _ = void 0;
      Kf && (r === "touchstart" || r === "touchmove" || r === "wheel") && (_ = !0), n = n, c ? _ !== void 0 ? Sd(n, r, x, _) : kc(n, r, x) : _ !== void 0 ? Lc(n, r, x, _) : ds(n, r, x);
    }
    function s2(n, r) {
      return n === r || n.nodeType === aa && n.parentNode === r;
    }
    function sl(n, r, u, c, p) {
      var x = c;
      if (!(r & Zh) && !(r & Ns)) {
        var _ = p;
        if (c !== null) {
          var O = c;
          e: for (; ; ) {
            if (O === null)
              return;
            var k = O.tag;
            if (k === T || k === j) {
              var V = O.stateNode.containerInfo;
              if (s2(V, _))
                break;
              if (k === j)
                for (var U = O.return; U !== null; ) {
                  var ie = U.tag;
                  if (ie === T || ie === j) {
                    var re = U.stateNode.containerInfo;
                    if (s2(re, _))
                      return;
                  }
                  U = U.return;
                }
              for (; V !== null; ) {
                var ye = B(V);
                if (ye === null)
                  return;
                var Se = ye.tag;
                if (Se === A || Se === L) {
                  O = x = ye;
                  continue e;
                }
                V = V.parentNode;
              }
            }
            O = O.return;
          }
        }
      }
      sc(function() {
        return Ww(n, r, u, x);
      });
    }
    function gs(n, r, u) {
      return {
        instance: n,
        listener: r,
        currentTarget: u
      };
    }
    function zw(n, r, u, c, p, x) {
      for (var _ = r !== null ? r + "Capture" : null, O = c ? _ : r, k = [], V = n, U = null; V !== null; ) {
        var ie = V, re = ie.stateNode, ye = ie.tag;
        if (ye === A && re !== null && (U = re, O !== null)) {
          var Se = cc(V, O);
          Se != null && k.push(gs(V, Se, U));
        }
        if (p)
          break;
        V = V.return;
      }
      return k;
    }
    function kv(n, r) {
      for (var u = r + "Capture", c = [], p = n; p !== null; ) {
        var x = p, _ = x.stateNode, O = x.tag;
        if (O === A && _ !== null) {
          var k = _, V = cc(p, u);
          V != null && c.unshift(gs(p, V, k));
          var U = cc(p, r);
          U != null && c.push(gs(p, U, k));
        }
        p = p.return;
      }
      return c;
    }
    function Hd(n) {
      if (n === null)
        return null;
      do
        n = n.return;
      while (n && n.tag !== A);
      return n || null;
    }
    function qw(n, r) {
      for (var u = n, c = r, p = 0, x = u; x; x = Hd(x))
        p++;
      for (var _ = 0, O = c; O; O = Hd(O))
        _++;
      for (; p - _ > 0; )
        u = Hd(u), p--;
      for (; _ - p > 0; )
        c = Hd(c), _--;
      for (var k = p; k--; ) {
        if (u === c || c !== null && u === c.alternate)
          return u;
        u = Hd(u), c = Hd(c);
      }
      return null;
    }
    function M3(n, r, u, c, p) {
      for (var x = r._reactName, _ = [], O = u; O !== null && O !== c; ) {
        var k = O, V = k.alternate, U = k.stateNode, ie = k.tag;
        if (V !== null && V === c)
          break;
        if (ie === A && U !== null) {
          var re = U;
          if (p) {
            var ye = cc(O, x);
            ye != null && _.unshift(gs(O, ye, re));
          } else if (!p) {
            var Se = cc(O, x);
            Se != null && _.push(gs(O, Se, re));
          }
        }
        O = O.return;
      }
      _.length !== 0 && n.push({
        event: r,
        listeners: _
      });
    }
    function T3(n, r, u, c, p) {
      var x = c && p ? qw(c, p) : null;
      c !== null && M3(n, r, c, x, !1), p !== null && u !== null && M3(n, u, p, x, !0);
    }
    function u1(n, r) {
      return n + "__bubble";
    }
    var Ft = !1, Zd = "dangerouslySetInnerHTML", cl = "suppressContentEditableWarning", s1 = "suppressHydrationWarning", O3 = "autoFocus", bn = "children", $c = "style", c2 = "__html", Pd, Lv, f2, D3, Iv, j3, A3;
    Pd = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Lv = function(n, r) {
      su(n, r), ko(n, r), cv(n, r, {
        registrationNameDependencies: kt,
        possibleRegistrationNames: Qe
      });
    }, j3 = Ot && !document.documentMode, f2 = function(n, r, u) {
      if (!Ft) {
        var c = Hv(u), p = Hv(r);
        p !== c && (Ft = !0, m("Prop `%s` did not match. Server: %s Client: %s", n, JSON.stringify(p), JSON.stringify(c)));
      }
    }, D3 = function(n) {
      if (!Ft) {
        Ft = !0;
        var r = [];
        n.forEach(function(u) {
          r.push(u);
        }), m("Extra attributes from the server: %s", r);
      }
    }, Iv = function(n, r) {
      r === !1 ? m("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", n, n, n) : m("Expected `%s` listener to be a function, instead got a value of `%s` type.", n, typeof r);
    }, A3 = function(n, r) {
      var u = n.namespaceURI === ou ? n.ownerDocument.createElement(n.tagName) : n.ownerDocument.createElementNS(n.namespaceURI, n.tagName);
      return u.innerHTML = r, u.innerHTML;
    };
    var Gw = /\r\n?/g, Kw = /\u0000|\uFFFD/g;
    function Hv(n) {
      Hr(n);
      var r = typeof n == "string" ? n : "" + n;
      return r.replace(Gw, `
`).replace(Kw, "");
    }
    function Zv(n, r, u, c) {
      var p = Hv(r), x = Hv(n);
      if (x !== p && (c && (Ft || (Ft = !0, m('Text content did not match. Server: "%s" Client: "%s"', x, p))), u && Ue))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function k3(n) {
      return n.nodeType === Gl ? n : n.ownerDocument;
    }
    function Qw() {
    }
    function Pv(n) {
      n.onclick = Qw;
    }
    function wm(n, r, u, c, p) {
      for (var x in c)
        if (c.hasOwnProperty(x)) {
          var _ = c[x];
          if (x === $c)
            _ && Object.freeze(_), Hh(r, _);
          else if (x === Zd) {
            var O = _ ? _[c2] : void 0;
            O != null && Pf(r, O);
          } else if (x === bn)
            if (typeof _ == "string") {
              var k = n !== "textarea" || _ !== "";
              k && Nf(r, _);
            } else typeof _ == "number" && Nf(r, "" + _);
          else x === cl || x === s1 || x === O3 || (kt.hasOwnProperty(x) ? _ != null && (typeof _ != "function" && Iv(x, _), x === "onScroll" && Dr("scroll", r)) : _ != null && Pu(r, x, _, p));
        }
    }
    function Xw(n, r, u, c) {
      for (var p = 0; p < r.length; p += 2) {
        var x = r[p], _ = r[p + 1];
        x === $c ? Hh(n, _) : x === Zd ? Pf(n, _) : x === bn ? Nf(n, _) : Pu(n, x, _, c);
      }
    }
    function ym(n, r, u, c) {
      var p, x = k3(u), _, O = c;
      if (O === ou && (O = Yu(n)), O === ou) {
        if (p = Je(n, r), !p && n !== n.toLowerCase() && m("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", n), n === "script") {
          var k = x.createElement("div");
          k.innerHTML = "<script><\/script>";
          var V = k.firstChild;
          _ = k.removeChild(V);
        } else if (typeof r.is == "string")
          _ = x.createElement(n, {
            is: r.is
          });
        else if (_ = x.createElement(n), n === "select") {
          var U = _;
          r.multiple ? U.multiple = !0 : r.size && (U.size = r.size);
        }
      } else
        _ = x.createElementNS(O, n);
      return O === ou && !p && Object.prototype.toString.call(_) === "[object HTMLUnknownElement]" && !yn.call(Pd, n) && (Pd[n] = !0, m("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", n)), _;
    }
    function Jw(n, r) {
      return k3(r).createTextNode(n);
    }
    function e6(n, r, u, c) {
      var p = Je(r, u);
      Lv(r, u);
      var x;
      switch (r) {
        case "dialog":
          Dr("cancel", n), Dr("close", n), x = u;
          break;
        case "iframe":
        case "object":
        case "embed":
          Dr("load", n), x = u;
          break;
        case "video":
        case "audio":
          for (var _ = 0; _ < o2.length; _++)
            Dr(o2[_], n);
          x = u;
          break;
        case "source":
          Dr("error", n), x = u;
          break;
        case "img":
        case "image":
        case "link":
          Dr("error", n), Dr("load", n), x = u;
          break;
        case "details":
          Dr("toggle", n), x = u;
          break;
        case "input":
          q0(n, u), x = z0(n, u), Dr("invalid", n);
          break;
        case "option":
          vi(n, u), x = u;
          break;
        case "select":
          iu(n, u), x = X0(n, u), Dr("invalid", n);
          break;
        case "textarea":
          Q2(n, u), x = J0(n, u), Dr("invalid", n);
          break;
        default:
          x = u;
      }
      switch (pe(r, x), wm(r, n, c, x, p), r) {
        case "input":
          $0(n), Sr(n, u, !1);
          break;
        case "textarea":
          $0(n), X2(n);
          break;
        case "option":
          Hs(n, u);
          break;
        case "select":
          Hf(n, u);
          break;
        default:
          typeof x.onClick == "function" && Pv(n);
          break;
      }
    }
    function t6(n, r, u, c, p) {
      Lv(r, c);
      var x = null, _, O;
      switch (r) {
        case "input":
          _ = z0(n, u), O = z0(n, c), x = [];
          break;
        case "select":
          _ = X0(n, u), O = X0(n, c), x = [];
          break;
        case "textarea":
          _ = J0(n, u), O = J0(n, c), x = [];
          break;
        default:
          _ = u, O = c, typeof _.onClick != "function" && typeof O.onClick == "function" && Pv(n);
          break;
      }
      pe(r, O);
      var k, V, U = null;
      for (k in _)
        if (!(O.hasOwnProperty(k) || !_.hasOwnProperty(k) || _[k] == null))
          if (k === $c) {
            var ie = _[k];
            for (V in ie)
              ie.hasOwnProperty(V) && (U || (U = {}), U[V] = "");
          } else k === Zd || k === bn || k === cl || k === s1 || k === O3 || (kt.hasOwnProperty(k) ? x || (x = []) : (x = x || []).push(k, null));
      for (k in O) {
        var re = O[k], ye = _ != null ? _[k] : void 0;
        if (!(!O.hasOwnProperty(k) || re === ye || re == null && ye == null))
          if (k === $c)
            if (re && Object.freeze(re), ye) {
              for (V in ye)
                ye.hasOwnProperty(V) && (!re || !re.hasOwnProperty(V)) && (U || (U = {}), U[V] = "");
              for (V in re)
                re.hasOwnProperty(V) && ye[V] !== re[V] && (U || (U = {}), U[V] = re[V]);
            } else
              U || (x || (x = []), x.push(k, U)), U = re;
          else if (k === Zd) {
            var Se = re ? re[c2] : void 0, Ee = ye ? ye[c2] : void 0;
            Se != null && Ee !== Se && (x = x || []).push(k, Se);
          } else k === bn ? (typeof re == "string" || typeof re == "number") && (x = x || []).push(k, "" + re) : k === cl || k === s1 || (kt.hasOwnProperty(k) ? (re != null && (typeof re != "function" && Iv(k, re), k === "onScroll" && Dr("scroll", n)), !x && ye !== re && (x = [])) : (x = x || []).push(k, re));
      }
      return U && (Kp(U, O[$c]), (x = x || []).push($c, U)), x;
    }
    function ui(n, r, u, c, p) {
      u === "input" && p.type === "radio" && p.name != null && G0(n, p);
      var x = Je(u, c), _ = Je(u, p);
      switch (Xw(n, r, x, _), u) {
        case "input":
          jf(n, p);
          break;
        case "textarea":
          Zf(n, p);
          break;
        case "select":
          kh(n, p);
          break;
      }
    }
    function Nl(n) {
      {
        var r = n.toLowerCase();
        return zt.hasOwnProperty(r) && zt[r] || null;
      }
    }
    function n6(n, r, u, c, p, x, _) {
      var O, k;
      switch (O = Je(r, u), Lv(r, u), r) {
        case "dialog":
          Dr("cancel", n), Dr("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          Dr("load", n);
          break;
        case "video":
        case "audio":
          for (var V = 0; V < o2.length; V++)
            Dr(o2[V], n);
          break;
        case "source":
          Dr("error", n);
          break;
        case "img":
        case "image":
        case "link":
          Dr("error", n), Dr("load", n);
          break;
        case "details":
          Dr("toggle", n);
          break;
        case "input":
          q0(n, u), Dr("invalid", n);
          break;
        case "option":
          vi(n, u);
          break;
        case "select":
          iu(n, u), Dr("invalid", n);
          break;
        case "textarea":
          Q2(n, u), Dr("invalid", n);
          break;
      }
      pe(r, u);
      {
        k = /* @__PURE__ */ new Set();
        for (var U = n.attributes, ie = 0; ie < U.length; ie++) {
          var re = U[ie].name.toLowerCase();
          switch (re) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              k.add(U[ie].name);
          }
        }
      }
      var ye = null;
      for (var Se in u)
        if (u.hasOwnProperty(Se)) {
          var Ee = u[Se];
          if (Se === bn)
            typeof Ee == "string" ? n.textContent !== Ee && (u[s1] !== !0 && Zv(n.textContent, Ee, x, _), ye = [bn, Ee]) : typeof Ee == "number" && n.textContent !== "" + Ee && (u[s1] !== !0 && Zv(n.textContent, Ee, x, _), ye = [bn, "" + Ee]);
          else if (kt.hasOwnProperty(Se))
            Ee != null && (typeof Ee != "function" && Iv(Se, Ee), Se === "onScroll" && Dr("scroll", n));
          else if (_ && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof O == "boolean") {
            var lt = void 0, Ut = ji(Se);
            if (u[s1] !== !0) {
              if (!(Se === cl || Se === s1 || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Se === "value" || Se === "checked" || Se === "selected")) {
                if (Se === Zd) {
                  var Lt = n.innerHTML, An = Ee ? Ee[c2] : void 0;
                  if (An != null) {
                    var Sn = A3(n, An);
                    Sn !== Lt && f2(Se, Lt, Sn);
                  }
                } else if (Se === $c) {
                  if (k.delete(Se), j3) {
                    var he = ov(Ee);
                    lt = n.getAttribute("style"), he !== lt && f2(Se, lt, he);
                  }
                } else if (O)
                  k.delete(Se.toLowerCase()), lt = O1(n, Se, Ee), Ee !== lt && f2(Se, lt, Ee);
                else if (!sr(Se, Ut, O) && !xr(Se, Ee, Ut, O)) {
                  var Me = !1;
                  if (Ut !== null)
                    k.delete(Ut.attributeName), lt = Cf(n, Se, Ee, Ut);
                  else {
                    var ve = c;
                    if (ve === ou && (ve = Yu(r)), ve === ou)
                      k.delete(Se.toLowerCase());
                    else {
                      var We = Nl(Se);
                      We !== null && We !== Se && (Me = !0, k.delete(We)), k.delete(Se);
                    }
                    lt = O1(n, Se, Ee);
                  }
                  var pt = mt;
                  !pt && Ee !== lt && !Me && f2(Se, lt, Ee);
                }
              }
            }
          }
        }
      switch (_ && // $FlowFixMe - Should be inferred as not undefined.
      k.size > 0 && u[s1] !== !0 && D3(k), r) {
        case "input":
          $0(n), Sr(n, u, !0);
          break;
        case "textarea":
          $0(n), X2(n);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof u.onClick == "function" && Pv(n);
          break;
      }
      return ye;
    }
    function r6(n, r, u) {
      var c = n.nodeValue !== r;
      return c;
    }
    function xm(n, r) {
      {
        if (Ft)
          return;
        Ft = !0, m("Did not expect server HTML to contain a <%s> in <%s>.", r.nodeName.toLowerCase(), n.nodeName.toLowerCase());
      }
    }
    function Nv(n, r) {
      {
        if (Ft)
          return;
        Ft = !0, m('Did not expect server HTML to contain the text node "%s" in <%s>.', r.nodeValue, n.nodeName.toLowerCase());
      }
    }
    function Sm(n, r, u) {
      {
        if (Ft)
          return;
        Ft = !0, m("Expected server HTML to contain a matching <%s> in <%s>.", r, n.nodeName.toLowerCase());
      }
    }
    function Cm(n, r) {
      {
        if (r === "" || Ft)
          return;
        Ft = !0, m('Expected server HTML to contain a matching text node for "%s" in <%s>.', r, n.nodeName.toLowerCase());
      }
    }
    function a6(n, r, u) {
      switch (r) {
        case "input":
          K0(n, u);
          return;
        case "textarea":
          J2(n, u);
          return;
        case "select":
          dr(n, u);
          return;
      }
    }
    var Nd = function() {
    }, d2 = function() {
    };
    {
      var i6 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], L3 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], I3 = L3.concat(["button"]), H3 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], Z3 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      d2 = function(n, r) {
        var u = Gt({}, n || Z3), c = {
          tag: r
        };
        return L3.indexOf(r) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), I3.indexOf(r) !== -1 && (u.pTagInButtonScope = null), i6.indexOf(r) !== -1 && r !== "address" && r !== "div" && r !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = c, r === "form" && (u.formTag = c), r === "a" && (u.aTagInScope = c), r === "button" && (u.buttonTagInScope = c), r === "nobr" && (u.nobrTagInScope = c), r === "p" && (u.pTagInButtonScope = c), r === "li" && (u.listItemTagAutoclosing = c), (r === "dd" || r === "dt") && (u.dlItemTagAutoclosing = c), u;
      };
      var l6 = function(n, r) {
        switch (r) {
          case "select":
            return n === "option" || n === "optgroup" || n === "#text";
          case "optgroup":
            return n === "option" || n === "#text";
          case "option":
            return n === "#text";
          case "tr":
            return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return n === "tr" || n === "style" || n === "script" || n === "template";
          case "colgroup":
            return n === "col" || n === "template";
          case "table":
            return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
          case "head":
            return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
          case "html":
            return n === "head" || n === "body" || n === "frameset";
          case "frameset":
            return n === "frame";
          case "#document":
            return n === "html";
        }
        switch (n) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r !== "h1" && r !== "h2" && r !== "h3" && r !== "h4" && r !== "h5" && r !== "h6";
          case "rp":
          case "rt":
            return H3.indexOf(r) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return r == null;
        }
        return !0;
      }, o6 = function(n, r) {
        switch (n) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r.pTagInButtonScope;
          case "form":
            return r.formTag || r.pTagInButtonScope;
          case "li":
            return r.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return r.dlItemTagAutoclosing;
          case "button":
            return r.buttonTagInScope;
          case "a":
            return r.aTagInScope;
          case "nobr":
            return r.nobrTagInScope;
        }
        return null;
      }, P3 = {};
      Nd = function(n, r, u) {
        u = u || Z3;
        var c = u.current, p = c && c.tag;
        r != null && (n != null && m("validateDOMNesting: when childText is passed, childTag should be null"), n = "#text");
        var x = l6(n, p) ? null : c, _ = x ? null : o6(n, u), O = x || _;
        if (O) {
          var k = O.tag, V = !!x + "|" + n + "|" + k;
          if (!P3[V]) {
            P3[V] = !0;
            var U = n, ie = "";
            if (n === "#text" ? /\S/.test(r) ? U = "Text nodes" : (U = "Whitespace text nodes", ie = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : U = "<" + n + ">", x) {
              var re = "";
              k === "table" && n === "tr" && (re += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), m("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", U, k, ie, re);
            } else
              m("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", U, k);
          }
        }
      };
    }
    var c1 = "suppressHydrationWarning", Vv = "$", Bv = "/$", h2 = "$?", v2 = "$!", u6 = "style", Fv = null, Uv = null;
    function s6(n) {
      var r, u, c = n.nodeType;
      switch (c) {
        case Gl:
        case nc: {
          r = c === Gl ? "#document" : "#fragment";
          var p = n.documentElement;
          u = p ? p.namespaceURI : ec(null, "");
          break;
        }
        default: {
          var x = c === aa ? n.parentNode : n, _ = x.namespaceURI || null;
          r = x.tagName, u = ec(_, r);
          break;
        }
      }
      {
        var O = r.toLowerCase(), k = d2(null, O);
        return {
          namespace: u,
          ancestorInfo: k
        };
      }
    }
    function c6(n, r, u) {
      {
        var c = n, p = ec(c.namespace, r), x = d2(c.ancestorInfo, r);
        return {
          namespace: p,
          ancestorInfo: x
        };
      }
    }
    function hS(n) {
      return n;
    }
    function f6(n) {
      Fv = Zl(), Uv = Pw();
      var r = null;
      return xd(!1), r;
    }
    function d6(n) {
      Nw(Uv), xd(Fv), Fv = null, Uv = null;
    }
    function h6(n, r, u, c, p) {
      var x;
      {
        var _ = c;
        if (Nd(n, null, _.ancestorInfo), typeof r.children == "string" || typeof r.children == "number") {
          var O = "" + r.children, k = d2(_.ancestorInfo, n);
          Nd(null, O, k);
        }
        x = _.namespace;
      }
      var V = ym(n, r, u, x);
      return d(p, V), je(V, r), V;
    }
    function v6(n, r) {
      n.appendChild(r);
    }
    function p6(n, r, u, c, p) {
      switch (e6(n, r, u, c), r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!u.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function m6(n, r, u, c, p, x) {
      {
        var _ = x;
        if (typeof c.children != typeof u.children && (typeof c.children == "string" || typeof c.children == "number")) {
          var O = "" + c.children, k = d2(_.ancestorInfo, r);
          Nd(null, O, k);
        }
      }
      return t6(n, r, u, c);
    }
    function bm(n, r) {
      return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
    }
    function g6(n, r, u, c) {
      {
        var p = u;
        Nd(null, n, p.ancestorInfo);
      }
      var x = Jw(n, r);
      return d(c, x), x;
    }
    function w6() {
      var n = window.event;
      return n === void 0 ? al : p0(n.type);
    }
    var _m = typeof setTimeout == "function" ? setTimeout : void 0, y6 = typeof clearTimeout == "function" ? clearTimeout : void 0, Rm = -1, N3 = typeof Promise == "function" ? Promise : void 0, x6 = typeof queueMicrotask == "function" ? queueMicrotask : typeof N3 < "u" ? function(n) {
      return N3.resolve(null).then(n).catch(S6);
    } : _m;
    function S6(n) {
      setTimeout(function() {
        throw n;
      });
    }
    function C6(n, r, u, c) {
      switch (r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && n.focus();
          return;
        case "img": {
          u.src && (n.src = u.src);
          return;
        }
      }
    }
    function b6(n, r, u, c, p, x) {
      ui(n, r, u, c, p), je(n, p);
    }
    function V3(n) {
      Nf(n, "");
    }
    function _6(n, r, u) {
      n.nodeValue = u;
    }
    function R6(n, r) {
      n.appendChild(r);
    }
    function E6(n, r) {
      var u;
      n.nodeType === aa ? (u = n.parentNode, u.insertBefore(r, n)) : (u = n, u.appendChild(r));
      var c = n._reactRootContainer;
      c == null && u.onclick === null && Pv(u);
    }
    function M6(n, r, u) {
      n.insertBefore(r, u);
    }
    function Em(n, r, u) {
      n.nodeType === aa ? n.parentNode.insertBefore(r, u) : n.insertBefore(r, u);
    }
    function B3(n, r) {
      n.removeChild(r);
    }
    function F3(n, r) {
      n.nodeType === aa ? n.parentNode.removeChild(r) : n.removeChild(r);
    }
    function Mm(n, r) {
      var u = r, c = 0;
      do {
        var p = u.nextSibling;
        if (n.removeChild(u), p && p.nodeType === aa) {
          var x = p.data;
          if (x === Bv)
            if (c === 0) {
              n.removeChild(p), h0(r);
              return;
            } else
              c--;
          else (x === Vv || x === h2 || x === v2) && c++;
        }
        u = p;
      } while (u);
      h0(r);
    }
    function T6(n, r) {
      n.nodeType === aa ? Mm(n.parentNode, r) : n.nodeType === Va && Mm(n, r), h0(n);
    }
    function O6(n) {
      n = n;
      var r = n.style;
      typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";
    }
    function Tm(n) {
      n.nodeValue = "";
    }
    function D6(n, r) {
      n = n;
      var u = r[u6], c = u != null && u.hasOwnProperty("display") ? u.display : null;
      n.style.display = Vf("display", c);
    }
    function j6(n, r) {
      n.nodeValue = r;
    }
    function A6(n) {
      n.nodeType === Va ? n.textContent = "" : n.nodeType === Gl && n.documentElement && n.removeChild(n.documentElement);
    }
    function Vl(n, r, u) {
      return n.nodeType !== Va || r.toLowerCase() !== n.nodeName.toLowerCase() ? null : n;
    }
    function Om(n, r) {
      return r === "" || n.nodeType !== Ao ? null : n;
    }
    function k6(n) {
      return n.nodeType !== aa ? null : n;
    }
    function U3(n) {
      return n.data === h2;
    }
    function Dm(n) {
      return n.data === v2;
    }
    function L6(n) {
      var r = n.nextSibling && n.nextSibling.dataset, u, c, p;
      return r && (u = r.dgst, c = r.msg, p = r.stck), {
        message: c,
        digest: u,
        stack: p
      };
    }
    function jm(n, r) {
      n._reactRetry = r;
    }
    function Yv(n) {
      for (; n != null; n = n.nextSibling) {
        var r = n.nodeType;
        if (r === Va || r === Ao)
          break;
        if (r === aa) {
          var u = n.data;
          if (u === Vv || u === v2 || u === h2)
            break;
          if (u === Bv)
            return null;
        }
      }
      return n;
    }
    function Wc(n) {
      return Yv(n.nextSibling);
    }
    function I6(n) {
      return Yv(n.firstChild);
    }
    function H6(n) {
      return Yv(n.firstChild);
    }
    function Z6(n) {
      return Yv(n.nextSibling);
    }
    function P6(n, r, u, c, p, x, _) {
      d(x, n), je(n, u);
      var O;
      {
        var k = p;
        O = k.namespace;
      }
      var V = (x.mode & on) !== et;
      return n6(n, r, u, O, c, V, _);
    }
    function Y3(n, r, u, c) {
      return d(u, n), r6(n, r);
    }
    function N6(n, r) {
      d(r, n);
    }
    function V6(n) {
      for (var r = n.nextSibling, u = 0; r; ) {
        if (r.nodeType === aa) {
          var c = r.data;
          if (c === Bv) {
            if (u === 0)
              return Wc(r);
            u--;
          } else (c === Vv || c === v2 || c === h2) && u++;
        }
        r = r.nextSibling;
      }
      return null;
    }
    function $3(n) {
      for (var r = n.previousSibling, u = 0; r; ) {
        if (r.nodeType === aa) {
          var c = r.data;
          if (c === Vv || c === v2 || c === h2) {
            if (u === 0)
              return r;
            u--;
          } else c === Bv && u++;
        }
        r = r.previousSibling;
      }
      return null;
    }
    function Am(n) {
      h0(n);
    }
    function km(n) {
      h0(n);
    }
    function B6(n) {
      return n !== "head" && n !== "body";
    }
    function F6(n, r, u, c) {
      var p = !0;
      Zv(r.nodeValue, u, c, p);
    }
    function U6(n, r, u, c, p, x) {
      if (r[c1] !== !0) {
        var _ = !0;
        Zv(c.nodeValue, p, x, _);
      }
    }
    function Y6(n, r) {
      r.nodeType === Va ? xm(n, r) : r.nodeType === aa || Nv(n, r);
    }
    function $6(n, r) {
      {
        var u = n.parentNode;
        u !== null && (r.nodeType === Va ? xm(u, r) : r.nodeType === aa || Nv(u, r));
      }
    }
    function W6(n, r, u, c, p) {
      (p || r[c1] !== !0) && (c.nodeType === Va ? xm(u, c) : c.nodeType === aa || Nv(u, c));
    }
    function z6(n, r, u) {
      Sm(n, r);
    }
    function q6(n, r) {
      Cm(n, r);
    }
    function G6(n, r, u) {
      {
        var c = n.parentNode;
        c !== null && Sm(c, r);
      }
    }
    function K6(n, r) {
      {
        var u = n.parentNode;
        u !== null && Cm(u, r);
      }
    }
    function Q6(n, r, u, c, p, x) {
      (x || r[c1] !== !0) && Sm(u, c);
    }
    function X6(n, r, u, c, p) {
      (p || r[c1] !== !0) && Cm(u, c);
    }
    function J6(n) {
      m("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", n.nodeName.toLowerCase());
    }
    function e7(n) {
      u2(n);
    }
    var Vd = Math.random().toString(36).slice(2), Bd = "__reactFiber$" + Vd, Lm = "__reactProps$" + Vd, p2 = "__reactContainer$" + Vd, Im = "__reactEvents$" + Vd, t7 = "__reactListeners$" + Vd, n7 = "__reactHandles$" + Vd;
    function s(n) {
      delete n[Bd], delete n[Lm], delete n[Im], delete n[t7], delete n[n7];
    }
    function d(n, r) {
      r[Bd] = n;
    }
    function y(n, r) {
      r[p2] = n;
    }
    function M(n) {
      n[p2] = null;
    }
    function I(n) {
      return !!n[p2];
    }
    function B(n) {
      var r = n[Bd];
      if (r)
        return r;
      for (var u = n.parentNode; u; ) {
        if (r = u[p2] || u[Bd], r) {
          var c = r.alternate;
          if (r.child !== null || c !== null && c.child !== null)
            for (var p = $3(n); p !== null; ) {
              var x = p[Bd];
              if (x)
                return x;
              p = $3(p);
            }
          return r;
        }
        n = u, u = n.parentNode;
      }
      return null;
    }
    function q(n) {
      var r = n[Bd] || n[p2];
      return r && (r.tag === A || r.tag === L || r.tag === $ || r.tag === T) ? r : null;
    }
    function te(n) {
      if (n.tag === A || n.tag === L)
        return n.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function se(n) {
      return n[Lm] || null;
    }
    function je(n, r) {
      n[Lm] = r;
    }
    function Ie(n) {
      var r = n[Im];
      return r === void 0 && (r = n[Im] = /* @__PURE__ */ new Set()), r;
    }
    var Be = {}, it = a.ReactDebugCurrentFrame;
    function Tt(n) {
      if (n) {
        var r = A1(n.type);
        it.setExtraStackFrame(r);
      } else
        it.setExtraStackFrame(null);
    }
    function At(n, r, u, c, p) {
      {
        var x = Function.call.bind(yn);
        for (var _ in n)
          if (x(n, _)) {
            var O = void 0;
            try {
              if (typeof n[_] != "function") {
                var k = Error((c || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k.name = "Invariant Violation", k;
              }
              O = n[_](r, _, c, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              O = V;
            }
            O && !(O instanceof Error) && (Tt(p), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", u, _, typeof O), Tt(null)), O instanceof Error && !(O.message in Be) && (Be[O.message] = !0, Tt(p), m("Failed %s type: %s", u, O.message), Tt(null));
          }
      }
    }
    var cn = [], Yt;
    Yt = [];
    var rn = -1;
    function fn(n) {
      return {
        current: n
      };
    }
    function pr(n, r) {
      if (rn < 0) {
        m("Unexpected pop.");
        return;
      }
      r !== Yt[rn] && m("Unexpected Fiber popped."), n.current = cn[rn], cn[rn] = null, Yt[rn] = null, rn--;
    }
    function ar(n, r, u) {
      rn++, cn[rn] = n.current, Yt[rn] = u, n.current = r;
    }
    var fl;
    fl = {};
    var Wn = {};
    Object.freeze(Wn);
    var Ga = fn(Wn), si = fn(!1), $v = Wn;
    function Wv(n, r, u) {
      return u && y0(r) ? $v : Ga.current;
    }
    function vS(n, r, u) {
      {
        var c = n.stateNode;
        c.__reactInternalMemoizedUnmaskedChildContext = r, c.__reactInternalMemoizedMaskedChildContext = u;
      }
    }
    function zv(n, r) {
      {
        var u = n.type, c = u.contextTypes;
        if (!c)
          return Wn;
        var p = n.stateNode;
        if (p && p.__reactInternalMemoizedUnmaskedChildContext === r)
          return p.__reactInternalMemoizedMaskedChildContext;
        var x = {};
        for (var _ in c)
          x[_] = r[_];
        {
          var O = en(n) || "Unknown";
          At(c, x, "context", O);
        }
        return p && vS(n, r, x), x;
      }
    }
    function W3() {
      return si.current;
    }
    function y0(n) {
      {
        var r = n.childContextTypes;
        return r != null;
      }
    }
    function z3(n) {
      pr(si, n), pr(Ga, n);
    }
    function r7(n) {
      pr(si, n), pr(Ga, n);
    }
    function pS(n, r, u) {
      {
        if (Ga.current !== Wn)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ar(Ga, r, n), ar(si, u, n);
      }
    }
    function mS(n, r, u) {
      {
        var c = n.stateNode, p = r.childContextTypes;
        if (typeof c.getChildContext != "function") {
          {
            var x = en(n) || "Unknown";
            fl[x] || (fl[x] = !0, m("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", x, x));
          }
          return u;
        }
        var _ = c.getChildContext();
        for (var O in _)
          if (!(O in p))
            throw new Error((en(n) || "Unknown") + '.getChildContext(): key "' + O + '" is not defined in childContextTypes.');
        {
          var k = en(n) || "Unknown";
          At(p, _, "child context", k);
        }
        return Gt({}, u, _);
      }
    }
    function q3(n) {
      {
        var r = n.stateNode, u = r && r.__reactInternalMemoizedMergedChildContext || Wn;
        return $v = Ga.current, ar(Ga, u, n), ar(si, si.current, n), !0;
      }
    }
    function gS(n, r, u) {
      {
        var c = n.stateNode;
        if (!c)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (u) {
          var p = mS(n, r, $v);
          c.__reactInternalMemoizedMergedChildContext = p, pr(si, n), pr(Ga, n), ar(Ga, p, n), ar(si, u, n);
        } else
          pr(si, n), ar(si, u, n);
      }
    }
    function GO(n) {
      {
        if (!Fs(n) || n.tag !== R)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var r = n;
        do {
          switch (r.tag) {
            case T:
              return r.stateNode.context;
            case R: {
              var u = r.type;
              if (y0(u))
                return r.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          r = r.return;
        } while (r !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Fd = 0, G3 = 1, zc = null, a7 = !1, i7 = !1;
    function wS(n) {
      zc === null ? zc = [n] : zc.push(n);
    }
    function KO(n) {
      a7 = !0, wS(n);
    }
    function yS() {
      a7 && Ud();
    }
    function Ud() {
      if (!i7 && zc !== null) {
        i7 = !0;
        var n = 0, r = Ni();
        try {
          var u = !0, c = zc;
          for (rr(qr); n < c.length; n++) {
            var p = c[n];
            do
              p = p(u);
            while (p !== null);
          }
          zc = null, a7 = !1;
        } catch (x) {
          throw zc !== null && (zc = zc.slice(n + 1)), Hi($a, Ud), x;
        } finally {
          rr(r), i7 = !1;
        }
      }
      return null;
    }
    var qv = [], Gv = 0, K3 = null, Q3 = 0, ws = [], ys = 0, m2 = null, qc = 1, Gc = "";
    function QO(n) {
      return w2(), (n.flags & Nh) !== H;
    }
    function XO(n) {
      return w2(), Q3;
    }
    function JO() {
      var n = Gc, r = qc, u = r & ~eD(r);
      return u.toString(32) + n;
    }
    function g2(n, r) {
      w2(), qv[Gv++] = Q3, qv[Gv++] = K3, K3 = n, Q3 = r;
    }
    function xS(n, r, u) {
      w2(), ws[ys++] = qc, ws[ys++] = Gc, ws[ys++] = m2, m2 = n;
      var c = qc, p = Gc, x = X3(c) - 1, _ = c & ~(1 << x), O = u + 1, k = X3(r) + x;
      if (k > 30) {
        var V = x - x % 5, U = (1 << V) - 1, ie = (_ & U).toString(32), re = _ >> V, ye = x - V, Se = X3(r) + ye, Ee = O << ye, lt = Ee | re, Ut = ie + p;
        qc = 1 << Se | lt, Gc = Ut;
      } else {
        var Lt = O << x, An = Lt | _, Sn = p;
        qc = 1 << k | An, Gc = Sn;
      }
    }
    function l7(n) {
      w2();
      var r = n.return;
      if (r !== null) {
        var u = 1, c = 0;
        g2(n, u), xS(n, u, c);
      }
    }
    function X3(n) {
      return 32 - ud(n);
    }
    function eD(n) {
      return 1 << X3(n) - 1;
    }
    function o7(n) {
      for (; n === K3; )
        K3 = qv[--Gv], qv[Gv] = null, Q3 = qv[--Gv], qv[Gv] = null;
      for (; n === m2; )
        m2 = ws[--ys], ws[ys] = null, Gc = ws[--ys], ws[ys] = null, qc = ws[--ys], ws[ys] = null;
    }
    function tD() {
      return w2(), m2 !== null ? {
        id: qc,
        overflow: Gc
      } : null;
    }
    function nD(n, r) {
      w2(), ws[ys++] = qc, ws[ys++] = Gc, ws[ys++] = m2, qc = r.id, Gc = r.overflow, m2 = n;
    }
    function w2() {
      hl() || m("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var dl = null, xs = null, f1 = !1, y2 = !1, Yd = null;
    function rD() {
      f1 && m("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function SS() {
      y2 = !0;
    }
    function aD() {
      return y2;
    }
    function iD(n) {
      var r = n.stateNode.containerInfo;
      return xs = H6(r), dl = n, f1 = !0, Yd = null, y2 = !1, !0;
    }
    function lD(n, r, u) {
      return xs = Z6(r), dl = n, f1 = !0, Yd = null, y2 = !1, u !== null && nD(n, u), !0;
    }
    function CS(n, r) {
      switch (n.tag) {
        case T: {
          Y6(n.stateNode.containerInfo, r);
          break;
        }
        case A: {
          var u = (n.mode & on) !== et;
          W6(
            n.type,
            n.memoizedProps,
            n.stateNode,
            r,
            // TODO: Delete this argument when we remove the legacy root API.
            u
          );
          break;
        }
        case $: {
          var c = n.memoizedState;
          c.dehydrated !== null && $6(c.dehydrated, r);
          break;
        }
      }
    }
    function bS(n, r) {
      CS(n, r);
      var u = sk();
      u.stateNode = r, u.return = n;
      var c = n.deletions;
      c === null ? (n.deletions = [u], n.flags |= Kt) : c.push(u);
    }
    function u7(n, r) {
      {
        if (y2)
          return;
        switch (n.tag) {
          case T: {
            var u = n.stateNode.containerInfo;
            switch (r.tag) {
              case A:
                var c = r.type;
                z6(u, c);
                break;
              case L:
                var p = r.pendingProps;
                q6(u, p);
                break;
            }
            break;
          }
          case A: {
            var x = n.type, _ = n.memoizedProps, O = n.stateNode;
            switch (r.tag) {
              case A: {
                var k = r.type, V = r.pendingProps, U = (n.mode & on) !== et;
                Q6(
                  x,
                  _,
                  O,
                  k,
                  V,
                  // TODO: Delete this argument when we remove the legacy root API.
                  U
                );
                break;
              }
              case L: {
                var ie = r.pendingProps, re = (n.mode & on) !== et;
                X6(
                  x,
                  _,
                  O,
                  ie,
                  // TODO: Delete this argument when we remove the legacy root API.
                  re
                );
                break;
              }
            }
            break;
          }
          case $: {
            var ye = n.memoizedState, Se = ye.dehydrated;
            if (Se !== null) switch (r.tag) {
              case A:
                var Ee = r.type;
                G6(Se, Ee);
                break;
              case L:
                var lt = r.pendingProps;
                K6(Se, lt);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function _S(n, r) {
      r.flags = r.flags & -4097 | cr, u7(n, r);
    }
    function RS(n, r) {
      switch (n.tag) {
        case A: {
          var u = n.type, c = Vl(r, u);
          return c !== null ? (n.stateNode = c, dl = n, xs = I6(c), !0) : !1;
        }
        case L: {
          var p = n.pendingProps, x = Om(r, p);
          return x !== null ? (n.stateNode = x, dl = n, xs = null, !0) : !1;
        }
        case $: {
          var _ = k6(r);
          if (_ !== null) {
            var O = {
              dehydrated: _,
              treeContext: tD(),
              retryLane: Pi
            };
            n.memoizedState = O;
            var k = ck(_);
            return k.return = n, n.child = k, dl = n, xs = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function s7(n) {
      return (n.mode & on) !== et && (n.flags & pn) === H;
    }
    function c7(n) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function f7(n) {
      if (f1) {
        var r = xs;
        if (!r) {
          s7(n) && (u7(dl, n), c7()), _S(dl, n), f1 = !1, dl = n;
          return;
        }
        var u = r;
        if (!RS(n, r)) {
          s7(n) && (u7(dl, n), c7()), r = Wc(u);
          var c = dl;
          if (!r || !RS(n, r)) {
            _S(dl, n), f1 = !1, dl = n;
            return;
          }
          bS(c, u);
        }
      }
    }
    function oD(n, r, u) {
      var c = n.stateNode, p = !y2, x = P6(c, n.type, n.memoizedProps, r, u, n, p);
      return n.updateQueue = x, x !== null;
    }
    function uD(n) {
      var r = n.stateNode, u = n.memoizedProps, c = Y3(r, u, n);
      if (c) {
        var p = dl;
        if (p !== null)
          switch (p.tag) {
            case T: {
              var x = p.stateNode.containerInfo, _ = (p.mode & on) !== et;
              F6(
                x,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                _
              );
              break;
            }
            case A: {
              var O = p.type, k = p.memoizedProps, V = p.stateNode, U = (p.mode & on) !== et;
              U6(
                O,
                k,
                V,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                U
              );
              break;
            }
          }
      }
      return c;
    }
    function sD(n) {
      var r = n.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      N6(u, n);
    }
    function cD(n) {
      var r = n.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return V6(u);
    }
    function ES(n) {
      for (var r = n.return; r !== null && r.tag !== A && r.tag !== T && r.tag !== $; )
        r = r.return;
      dl = r;
    }
    function J3(n) {
      if (n !== dl)
        return !1;
      if (!f1)
        return ES(n), f1 = !0, !1;
      if (n.tag !== T && (n.tag !== A || B6(n.type) && !bm(n.type, n.memoizedProps))) {
        var r = xs;
        if (r)
          if (s7(n))
            MS(n), c7();
          else
            for (; r; )
              bS(n, r), r = Wc(r);
      }
      return ES(n), n.tag === $ ? xs = cD(n) : xs = dl ? Wc(n.stateNode) : null, !0;
    }
    function fD() {
      return f1 && xs !== null;
    }
    function MS(n) {
      for (var r = xs; r; )
        CS(n, r), r = Wc(r);
    }
    function Kv() {
      dl = null, xs = null, f1 = !1, y2 = !1;
    }
    function TS() {
      Yd !== null && (Sb(Yd), Yd = null);
    }
    function hl() {
      return f1;
    }
    function d7(n) {
      Yd === null ? Yd = [n] : Yd.push(n);
    }
    var dD = a.ReactCurrentBatchConfig, hD = null;
    function vD() {
      return dD.transition;
    }
    var d1 = {
      recordUnsafeLifecycleWarnings: function(n, r) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(n, r) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var pD = function(n) {
        for (var r = null, u = n; u !== null; )
          u.mode & _r && (r = u), u = u.return;
        return r;
      }, x2 = function(n) {
        var r = [];
        return n.forEach(function(u) {
          r.push(u);
        }), r.sort().join(", ");
      }, Hm = [], Zm = [], Pm = [], Nm = [], Vm = [], Bm = [], S2 = /* @__PURE__ */ new Set();
      d1.recordUnsafeLifecycleWarnings = function(n, r) {
        S2.has(n.type) || (typeof r.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        r.componentWillMount.__suppressDeprecationWarning !== !0 && Hm.push(n), n.mode & _r && typeof r.UNSAFE_componentWillMount == "function" && Zm.push(n), typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Pm.push(n), n.mode & _r && typeof r.UNSAFE_componentWillReceiveProps == "function" && Nm.push(n), typeof r.componentWillUpdate == "function" && r.componentWillUpdate.__suppressDeprecationWarning !== !0 && Vm.push(n), n.mode & _r && typeof r.UNSAFE_componentWillUpdate == "function" && Bm.push(n));
      }, d1.flushPendingUnsafeLifecycleWarnings = function() {
        var n = /* @__PURE__ */ new Set();
        Hm.length > 0 && (Hm.forEach(function(re) {
          n.add(en(re) || "Component"), S2.add(re.type);
        }), Hm = []);
        var r = /* @__PURE__ */ new Set();
        Zm.length > 0 && (Zm.forEach(function(re) {
          r.add(en(re) || "Component"), S2.add(re.type);
        }), Zm = []);
        var u = /* @__PURE__ */ new Set();
        Pm.length > 0 && (Pm.forEach(function(re) {
          u.add(en(re) || "Component"), S2.add(re.type);
        }), Pm = []);
        var c = /* @__PURE__ */ new Set();
        Nm.length > 0 && (Nm.forEach(function(re) {
          c.add(en(re) || "Component"), S2.add(re.type);
        }), Nm = []);
        var p = /* @__PURE__ */ new Set();
        Vm.length > 0 && (Vm.forEach(function(re) {
          p.add(en(re) || "Component"), S2.add(re.type);
        }), Vm = []);
        var x = /* @__PURE__ */ new Set();
        if (Bm.length > 0 && (Bm.forEach(function(re) {
          x.add(en(re) || "Component"), S2.add(re.type);
        }), Bm = []), r.size > 0) {
          var _ = x2(r);
          m(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, _);
        }
        if (c.size > 0) {
          var O = x2(c);
          m(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, O);
        }
        if (x.size > 0) {
          var k = x2(x);
          m(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, k);
        }
        if (n.size > 0) {
          var V = x2(n);
          g(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, V);
        }
        if (u.size > 0) {
          var U = x2(u);
          g(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, U);
        }
        if (p.size > 0) {
          var ie = x2(p);
          g(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ie);
        }
      };
      var eg = /* @__PURE__ */ new Map(), OS = /* @__PURE__ */ new Set();
      d1.recordLegacyContextWarning = function(n, r) {
        var u = pD(n);
        if (u === null) {
          m("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!OS.has(n.type)) {
          var c = eg.get(u);
          (n.type.contextTypes != null || n.type.childContextTypes != null || r !== null && typeof r.getChildContext == "function") && (c === void 0 && (c = [], eg.set(u, c)), c.push(n));
        }
      }, d1.flushLegacyContextWarning = function() {
        eg.forEach(function(n, r) {
          if (n.length !== 0) {
            var u = n[0], c = /* @__PURE__ */ new Set();
            n.forEach(function(x) {
              c.add(en(x) || "Component"), OS.add(x.type);
            });
            var p = x2(c);
            try {
              tr(u), m(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, p);
            } finally {
              va();
            }
          }
        });
      }, d1.discardPendingWarnings = function() {
        Hm = [], Zm = [], Pm = [], Nm = [], Vm = [], Bm = [], eg = /* @__PURE__ */ new Map();
      };
    }
    var h7, v7, p7, m7, g7, DS = function(n, r) {
    };
    h7 = !1, v7 = !1, p7 = {}, m7 = {}, g7 = {}, DS = function(n, r) {
      if (!(n === null || typeof n != "object") && !(!n._store || n._store.validated || n.key != null)) {
        if (typeof n._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        n._store.validated = !0;
        var u = en(r) || "Component";
        m7[u] || (m7[u] = !0, m('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function mD(n) {
      return n.prototype && n.prototype.isReactComponent;
    }
    function Fm(n, r, u) {
      var c = u.ref;
      if (c !== null && typeof c != "function" && typeof c != "object") {
        if ((n.mode & _r || Ze) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(u._owner && u._self && u._owner.stateNode !== u._self) && // Will already throw with "Function components cannot have string refs"
        !(u._owner && u._owner.tag !== R) && // Will already warn with "Function components cannot be given refs"
        !(typeof u.type == "function" && !mD(u.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        u._owner) {
          var p = en(n) || "Component";
          p7[p] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', p, c), p7[p] = !0);
        }
        if (u._owner) {
          var x = u._owner, _;
          if (x) {
            var O = x;
            if (O.tag !== R)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            _ = O.stateNode;
          }
          if (!_)
            throw new Error("Missing owner for string ref " + c + ". This error is likely caused by a bug in React. Please file an issue.");
          var k = _;
          ea(c, "ref");
          var V = "" + c;
          if (r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === V)
            return r.ref;
          var U = function(ie) {
            var re = k.refs;
            ie === null ? delete re[V] : re[V] = ie;
          };
          return U._stringRef = V, U;
        } else {
          if (typeof c != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!u._owner)
            throw new Error("Element ref was specified as a string (" + c + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return c;
    }
    function tg(n, r) {
      var u = Object.prototype.toString.call(r);
      throw new Error("Objects are not valid as a React child (found: " + (u === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : u) + "). If you meant to render a collection of children, use an array instead.");
    }
    function ng(n) {
      {
        var r = en(n) || "Component";
        if (g7[r])
          return;
        g7[r] = !0, m("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function jS(n) {
      var r = n._payload, u = n._init;
      return u(r);
    }
    function AS(n) {
      function r(he, Me) {
        if (n) {
          var ve = he.deletions;
          ve === null ? (he.deletions = [Me], he.flags |= Kt) : ve.push(Me);
        }
      }
      function u(he, Me) {
        if (!n)
          return null;
        for (var ve = Me; ve !== null; )
          r(he, ve), ve = ve.sibling;
        return null;
      }
      function c(he, Me) {
        for (var ve = /* @__PURE__ */ new Map(), We = Me; We !== null; )
          We.key !== null ? ve.set(We.key, We) : ve.set(We.index, We), We = We.sibling;
        return ve;
      }
      function p(he, Me) {
        var ve = D2(he, Me);
        return ve.index = 0, ve.sibling = null, ve;
      }
      function x(he, Me, ve) {
        if (he.index = ve, !n)
          return he.flags |= Nh, Me;
        var We = he.alternate;
        if (We !== null) {
          var pt = We.index;
          return pt < Me ? (he.flags |= cr, Me) : pt;
        } else
          return he.flags |= cr, Me;
      }
      function _(he) {
        return n && he.alternate === null && (he.flags |= cr), he;
      }
      function O(he, Me, ve, We) {
        if (Me === null || Me.tag !== L) {
          var pt = fy(ve, he.mode, We);
          return pt.return = he, pt;
        } else {
          var ut = p(Me, ve);
          return ut.return = he, ut;
        }
      }
      function k(he, Me, ve, We) {
        var pt = ve.type;
        if (pt === $i)
          return U(he, Me, ve.props.children, We, ve.key);
        if (Me !== null && (Me.elementType === pt || // Keep this check inline so it only runs on the false path:
        Zb(Me, ve) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof pt == "object" && pt !== null && pt.$$typeof === Et && jS(pt) === Me.type)) {
          var ut = p(Me, ve.props);
          return ut.ref = Fm(he, Me, ve), ut.return = he, ut._debugSource = ve._source, ut._debugOwner = ve._owner, ut;
        }
        var Jt = cy(ve, he.mode, We);
        return Jt.ref = Fm(he, Me, ve), Jt.return = he, Jt;
      }
      function V(he, Me, ve, We) {
        if (Me === null || Me.tag !== j || Me.stateNode.containerInfo !== ve.containerInfo || Me.stateNode.implementation !== ve.implementation) {
          var pt = dy(ve, he.mode, We);
          return pt.return = he, pt;
        } else {
          var ut = p(Me, ve.children || []);
          return ut.return = he, ut;
        }
      }
      function U(he, Me, ve, We, pt) {
        if (Me === null || Me.tag !== P) {
          var ut = th(ve, he.mode, We, pt);
          return ut.return = he, ut;
        } else {
          var Jt = p(Me, ve);
          return Jt.return = he, Jt;
        }
      }
      function ie(he, Me, ve) {
        if (typeof Me == "string" && Me !== "" || typeof Me == "number") {
          var We = fy("" + Me, he.mode, ve);
          return We.return = he, We;
        }
        if (typeof Me == "object" && Me !== null) {
          switch (Me.$$typeof) {
            case Mo: {
              var pt = cy(Me, he.mode, ve);
              return pt.ref = Fm(he, null, Me), pt.return = he, pt;
            }
            case To: {
              var ut = dy(Me, he.mode, ve);
              return ut.return = he, ut;
            }
            case Et: {
              var Jt = Me._payload, an = Me._init;
              return ie(he, an(Jt), ve);
            }
          }
          if (ra(Me) || hi(Me)) {
            var gr = th(Me, he.mode, ve, null);
            return gr.return = he, gr;
          }
          tg(he, Me);
        }
        return typeof Me == "function" && ng(he), null;
      }
      function re(he, Me, ve, We) {
        var pt = Me !== null ? Me.key : null;
        if (typeof ve == "string" && ve !== "" || typeof ve == "number")
          return pt !== null ? null : O(he, Me, "" + ve, We);
        if (typeof ve == "object" && ve !== null) {
          switch (ve.$$typeof) {
            case Mo:
              return ve.key === pt ? k(he, Me, ve, We) : null;
            case To:
              return ve.key === pt ? V(he, Me, ve, We) : null;
            case Et: {
              var ut = ve._payload, Jt = ve._init;
              return re(he, Me, Jt(ut), We);
            }
          }
          if (ra(ve) || hi(ve))
            return pt !== null ? null : U(he, Me, ve, We, null);
          tg(he, ve);
        }
        return typeof ve == "function" && ng(he), null;
      }
      function ye(he, Me, ve, We, pt) {
        if (typeof We == "string" && We !== "" || typeof We == "number") {
          var ut = he.get(ve) || null;
          return O(Me, ut, "" + We, pt);
        }
        if (typeof We == "object" && We !== null) {
          switch (We.$$typeof) {
            case Mo: {
              var Jt = he.get(We.key === null ? ve : We.key) || null;
              return k(Me, Jt, We, pt);
            }
            case To: {
              var an = he.get(We.key === null ? ve : We.key) || null;
              return V(Me, an, We, pt);
            }
            case Et:
              var gr = We._payload, Gn = We._init;
              return ye(he, Me, ve, Gn(gr), pt);
          }
          if (ra(We) || hi(We)) {
            var Ka = he.get(ve) || null;
            return U(Me, Ka, We, pt, null);
          }
          tg(Me, We);
        }
        return typeof We == "function" && ng(Me), null;
      }
      function Se(he, Me, ve) {
        {
          if (typeof he != "object" || he === null)
            return Me;
          switch (he.$$typeof) {
            case Mo:
            case To:
              DS(he, ve);
              var We = he.key;
              if (typeof We != "string")
                break;
              if (Me === null) {
                Me = /* @__PURE__ */ new Set(), Me.add(We);
                break;
              }
              if (!Me.has(We)) {
                Me.add(We);
                break;
              }
              m("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", We);
              break;
            case Et:
              var pt = he._payload, ut = he._init;
              Se(ut(pt), Me, ve);
              break;
          }
        }
        return Me;
      }
      function Ee(he, Me, ve, We) {
        for (var pt = null, ut = 0; ut < ve.length; ut++) {
          var Jt = ve[ut];
          pt = Se(Jt, pt, he);
        }
        for (var an = null, gr = null, Gn = Me, Ka = 0, Kn = 0, Da = null; Gn !== null && Kn < ve.length; Kn++) {
          Gn.index > Kn ? (Da = Gn, Gn = null) : Da = Gn.sibling;
          var Fl = re(he, Gn, ve[Kn], We);
          if (Fl === null) {
            Gn === null && (Gn = Da);
            break;
          }
          n && Gn && Fl.alternate === null && r(he, Gn), Ka = x(Fl, Ka, Kn), gr === null ? an = Fl : gr.sibling = Fl, gr = Fl, Gn = Da;
        }
        if (Kn === ve.length) {
          if (u(he, Gn), hl()) {
            var xl = Kn;
            g2(he, xl);
          }
          return an;
        }
        if (Gn === null) {
          for (; Kn < ve.length; Kn++) {
            var Au = ie(he, ve[Kn], We);
            Au !== null && (Ka = x(Au, Ka, Kn), gr === null ? an = Au : gr.sibling = Au, gr = Au);
          }
          if (hl()) {
            var xo = Kn;
            g2(he, xo);
          }
          return an;
        }
        for (var So = c(he, Gn); Kn < ve.length; Kn++) {
          var Ul = ye(So, he, Kn, ve[Kn], We);
          Ul !== null && (n && Ul.alternate !== null && So.delete(Ul.key === null ? Kn : Ul.key), Ka = x(Ul, Ka, Kn), gr === null ? an = Ul : gr.sibling = Ul, gr = Ul);
        }
        if (n && So.forEach(function(pp) {
          return r(he, pp);
        }), hl()) {
          var nf = Kn;
          g2(he, nf);
        }
        return an;
      }
      function lt(he, Me, ve, We) {
        var pt = hi(ve);
        if (typeof pt != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          ve[Symbol.toStringTag] === "Generator" && (v7 || m("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), v7 = !0), ve.entries === pt && (h7 || m("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), h7 = !0);
          var ut = pt.call(ve);
          if (ut)
            for (var Jt = null, an = ut.next(); !an.done; an = ut.next()) {
              var gr = an.value;
              Jt = Se(gr, Jt, he);
            }
        }
        var Gn = pt.call(ve);
        if (Gn == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Ka = null, Kn = null, Da = Me, Fl = 0, xl = 0, Au = null, xo = Gn.next(); Da !== null && !xo.done; xl++, xo = Gn.next()) {
          Da.index > xl ? (Au = Da, Da = null) : Au = Da.sibling;
          var So = re(he, Da, xo.value, We);
          if (So === null) {
            Da === null && (Da = Au);
            break;
          }
          n && Da && So.alternate === null && r(he, Da), Fl = x(So, Fl, xl), Kn === null ? Ka = So : Kn.sibling = So, Kn = So, Da = Au;
        }
        if (xo.done) {
          if (u(he, Da), hl()) {
            var Ul = xl;
            g2(he, Ul);
          }
          return Ka;
        }
        if (Da === null) {
          for (; !xo.done; xl++, xo = Gn.next()) {
            var nf = ie(he, xo.value, We);
            nf !== null && (Fl = x(nf, Fl, xl), Kn === null ? Ka = nf : Kn.sibling = nf, Kn = nf);
          }
          if (hl()) {
            var pp = xl;
            g2(he, pp);
          }
          return Ka;
        }
        for (var x4 = c(he, Da); !xo.done; xl++, xo = Gn.next()) {
          var M0 = ye(x4, he, xl, xo.value, We);
          M0 !== null && (n && M0.alternate !== null && x4.delete(M0.key === null ? xl : M0.key), Fl = x(M0, Fl, xl), Kn === null ? Ka = M0 : Kn.sibling = M0, Kn = M0);
        }
        if (n && x4.forEach(function(Bk) {
          return r(he, Bk);
        }), hl()) {
          var Vk = xl;
          g2(he, Vk);
        }
        return Ka;
      }
      function Ut(he, Me, ve, We) {
        if (Me !== null && Me.tag === L) {
          u(he, Me.sibling);
          var pt = p(Me, ve);
          return pt.return = he, pt;
        }
        u(he, Me);
        var ut = fy(ve, he.mode, We);
        return ut.return = he, ut;
      }
      function Lt(he, Me, ve, We) {
        for (var pt = ve.key, ut = Me; ut !== null; ) {
          if (ut.key === pt) {
            var Jt = ve.type;
            if (Jt === $i) {
              if (ut.tag === P) {
                u(he, ut.sibling);
                var an = p(ut, ve.props.children);
                return an.return = he, an._debugSource = ve._source, an._debugOwner = ve._owner, an;
              }
            } else if (ut.elementType === Jt || // Keep this check inline so it only runs on the false path:
            Zb(ut, ve) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Jt == "object" && Jt !== null && Jt.$$typeof === Et && jS(Jt) === ut.type) {
              u(he, ut.sibling);
              var gr = p(ut, ve.props);
              return gr.ref = Fm(he, ut, ve), gr.return = he, gr._debugSource = ve._source, gr._debugOwner = ve._owner, gr;
            }
            u(he, ut);
            break;
          } else
            r(he, ut);
          ut = ut.sibling;
        }
        if (ve.type === $i) {
          var Gn = th(ve.props.children, he.mode, We, ve.key);
          return Gn.return = he, Gn;
        } else {
          var Ka = cy(ve, he.mode, We);
          return Ka.ref = Fm(he, Me, ve), Ka.return = he, Ka;
        }
      }
      function An(he, Me, ve, We) {
        for (var pt = ve.key, ut = Me; ut !== null; ) {
          if (ut.key === pt)
            if (ut.tag === j && ut.stateNode.containerInfo === ve.containerInfo && ut.stateNode.implementation === ve.implementation) {
              u(he, ut.sibling);
              var Jt = p(ut, ve.children || []);
              return Jt.return = he, Jt;
            } else {
              u(he, ut);
              break;
            }
          else
            r(he, ut);
          ut = ut.sibling;
        }
        var an = dy(ve, he.mode, We);
        return an.return = he, an;
      }
      function Sn(he, Me, ve, We) {
        var pt = typeof ve == "object" && ve !== null && ve.type === $i && ve.key === null;
        if (pt && (ve = ve.props.children), typeof ve == "object" && ve !== null) {
          switch (ve.$$typeof) {
            case Mo:
              return _(Lt(he, Me, ve, We));
            case To:
              return _(An(he, Me, ve, We));
            case Et:
              var ut = ve._payload, Jt = ve._init;
              return Sn(he, Me, Jt(ut), We);
          }
          if (ra(ve))
            return Ee(he, Me, ve, We);
          if (hi(ve))
            return lt(he, Me, ve, We);
          tg(he, ve);
        }
        return typeof ve == "string" && ve !== "" || typeof ve == "number" ? _(Ut(he, Me, "" + ve, We)) : (typeof ve == "function" && ng(he), u(he, Me));
      }
      return Sn;
    }
    var Qv = AS(!0), kS = AS(!1);
    function gD(n, r) {
      if (n !== null && r.child !== n.child)
        throw new Error("Resuming work not yet implemented.");
      if (r.child !== null) {
        var u = r.child, c = D2(u, u.pendingProps);
        for (r.child = c, c.return = r; u.sibling !== null; )
          u = u.sibling, c = c.sibling = D2(u, u.pendingProps), c.return = r;
        c.sibling = null;
      }
    }
    function wD(n, r) {
      for (var u = n.child; u !== null; )
        ak(u, r), u = u.sibling;
    }
    var w7 = fn(null), y7;
    y7 = {};
    var rg = null, Xv = null, x7 = null, ag = !1;
    function ig() {
      rg = null, Xv = null, x7 = null, ag = !1;
    }
    function LS() {
      ag = !0;
    }
    function IS() {
      ag = !1;
    }
    function HS(n, r, u) {
      ar(w7, r._currentValue, n), r._currentValue = u, r._currentRenderer !== void 0 && r._currentRenderer !== null && r._currentRenderer !== y7 && m("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), r._currentRenderer = y7;
    }
    function S7(n, r) {
      var u = w7.current;
      pr(w7, r), n._currentValue = u;
    }
    function C7(n, r, u) {
      for (var c = n; c !== null; ) {
        var p = c.alternate;
        if (ua(c.childLanes, r) ? p !== null && !ua(p.childLanes, r) && (p.childLanes = jt(p.childLanes, r)) : (c.childLanes = jt(c.childLanes, r), p !== null && (p.childLanes = jt(p.childLanes, r))), c === u)
          break;
        c = c.return;
      }
      c !== u && m("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function yD(n, r, u) {
      xD(n, r, u);
    }
    function xD(n, r, u) {
      var c = n.child;
      for (c !== null && (c.return = n); c !== null; ) {
        var p = void 0, x = c.dependencies;
        if (x !== null) {
          p = c.child;
          for (var _ = x.firstContext; _ !== null; ) {
            if (_.context === r) {
              if (c.tag === R) {
                var O = xu(u), k = Kc(fr, O);
                k.tag = og;
                var V = c.updateQueue;
                if (V !== null) {
                  var U = V.shared, ie = U.pending;
                  ie === null ? k.next = k : (k.next = ie.next, ie.next = k), U.pending = k;
                }
              }
              c.lanes = jt(c.lanes, u);
              var re = c.alternate;
              re !== null && (re.lanes = jt(re.lanes, u)), C7(c.return, u, n), x.lanes = jt(x.lanes, u);
              break;
            }
            _ = _.next;
          }
        } else if (c.tag === Y)
          p = c.type === n.type ? null : c.child;
        else if (c.tag === me) {
          var ye = c.return;
          if (ye === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          ye.lanes = jt(ye.lanes, u);
          var Se = ye.alternate;
          Se !== null && (Se.lanes = jt(Se.lanes, u)), C7(ye, u, n), p = c.sibling;
        } else
          p = c.child;
        if (p !== null)
          p.return = c;
        else
          for (p = c; p !== null; ) {
            if (p === n) {
              p = null;
              break;
            }
            var Ee = p.sibling;
            if (Ee !== null) {
              Ee.return = p.return, p = Ee;
              break;
            }
            p = p.return;
          }
        c = p;
      }
    }
    function Jv(n, r) {
      rg = n, Xv = null, x7 = null;
      var u = n.dependencies;
      if (u !== null) {
        var c = u.firstContext;
        c !== null && (ii(u.lanes, r) && r4(), u.firstContext = null);
      }
    }
    function ci(n) {
      ag && m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var r = n._currentValue;
      if (x7 !== n) {
        var u = {
          context: n,
          memoizedValue: r,
          next: null
        };
        if (Xv === null) {
          if (rg === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Xv = u, rg.dependencies = {
            lanes: He,
            firstContext: u
          };
        } else
          Xv = Xv.next = u;
      }
      return r;
    }
    var C2 = null;
    function b7(n) {
      C2 === null ? C2 = [n] : C2.push(n);
    }
    function SD() {
      if (C2 !== null) {
        for (var n = 0; n < C2.length; n++) {
          var r = C2[n], u = r.interleaved;
          if (u !== null) {
            r.interleaved = null;
            var c = u.next, p = r.pending;
            if (p !== null) {
              var x = p.next;
              p.next = c, u.next = x;
            }
            r.pending = u;
          }
        }
        C2 = null;
      }
    }
    function ZS(n, r, u, c) {
      var p = r.interleaved;
      return p === null ? (u.next = u, b7(r)) : (u.next = p.next, p.next = u), r.interleaved = u, lg(n, c);
    }
    function CD(n, r, u, c) {
      var p = r.interleaved;
      p === null ? (u.next = u, b7(r)) : (u.next = p.next, p.next = u), r.interleaved = u;
    }
    function bD(n, r, u, c) {
      var p = r.interleaved;
      return p === null ? (u.next = u, b7(r)) : (u.next = p.next, p.next = u), r.interleaved = u, lg(n, c);
    }
    function $o(n, r) {
      return lg(n, r);
    }
    var _D = lg;
    function lg(n, r) {
      n.lanes = jt(n.lanes, r);
      var u = n.alternate;
      u !== null && (u.lanes = jt(u.lanes, r)), u === null && (n.flags & (cr | Zr)) !== H && kb(n);
      for (var c = n, p = n.return; p !== null; )
        p.childLanes = jt(p.childLanes, r), u = p.alternate, u !== null ? u.childLanes = jt(u.childLanes, r) : (p.flags & (cr | Zr)) !== H && kb(n), c = p, p = p.return;
      if (c.tag === T) {
        var x = c.stateNode;
        return x;
      } else
        return null;
    }
    var PS = 0, NS = 1, og = 2, _7 = 3, ug = !1, R7, sg;
    R7 = !1, sg = null;
    function E7(n) {
      var r = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: He
        },
        effects: null
      };
      n.updateQueue = r;
    }
    function VS(n, r) {
      var u = r.updateQueue, c = n.updateQueue;
      if (u === c) {
        var p = {
          baseState: c.baseState,
          firstBaseUpdate: c.firstBaseUpdate,
          lastBaseUpdate: c.lastBaseUpdate,
          shared: c.shared,
          effects: c.effects
        };
        r.updateQueue = p;
      }
    }
    function Kc(n, r) {
      var u = {
        eventTime: n,
        lane: r,
        tag: PS,
        payload: null,
        callback: null,
        next: null
      };
      return u;
    }
    function $d(n, r, u) {
      var c = n.updateQueue;
      if (c === null)
        return null;
      var p = c.shared;
      if (sg === p && !R7 && (m("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), R7 = !0), SA()) {
        var x = p.pending;
        return x === null ? r.next = r : (r.next = x.next, x.next = r), p.pending = r, _D(n, u);
      } else
        return bD(n, p, r, u);
    }
    function cg(n, r, u) {
      var c = r.updateQueue;
      if (c !== null) {
        var p = c.shared;
        if (Gs(u)) {
          var x = p.lanes;
          x = hd(x, n.pendingLanes);
          var _ = jt(x, u);
          p.lanes = _, Ll(n, _);
        }
      }
    }
    function M7(n, r) {
      var u = n.updateQueue, c = n.alternate;
      if (c !== null) {
        var p = c.updateQueue;
        if (u === p) {
          var x = null, _ = null, O = u.firstBaseUpdate;
          if (O !== null) {
            var k = O;
            do {
              var V = {
                eventTime: k.eventTime,
                lane: k.lane,
                tag: k.tag,
                payload: k.payload,
                callback: k.callback,
                next: null
              };
              _ === null ? x = _ = V : (_.next = V, _ = V), k = k.next;
            } while (k !== null);
            _ === null ? x = _ = r : (_.next = r, _ = r);
          } else
            x = _ = r;
          u = {
            baseState: p.baseState,
            firstBaseUpdate: x,
            lastBaseUpdate: _,
            shared: p.shared,
            effects: p.effects
          }, n.updateQueue = u;
          return;
        }
      }
      var U = u.lastBaseUpdate;
      U === null ? u.firstBaseUpdate = r : U.next = r, u.lastBaseUpdate = r;
    }
    function RD(n, r, u, c, p, x) {
      switch (u.tag) {
        case NS: {
          var _ = u.payload;
          if (typeof _ == "function") {
            LS();
            var O = _.call(x, c, p);
            {
              if (n.mode & _r) {
                vr(!0);
                try {
                  _.call(x, c, p);
                } finally {
                  vr(!1);
                }
              }
              IS();
            }
            return O;
          }
          return _;
        }
        case _7:
          n.flags = n.flags & -65537 | pn;
        case PS: {
          var k = u.payload, V;
          if (typeof k == "function") {
            LS(), V = k.call(x, c, p);
            {
              if (n.mode & _r) {
                vr(!0);
                try {
                  k.call(x, c, p);
                } finally {
                  vr(!1);
                }
              }
              IS();
            }
          } else
            V = k;
          return V == null ? c : Gt({}, c, V);
        }
        case og:
          return ug = !0, c;
      }
      return c;
    }
    function fg(n, r, u, c) {
      var p = n.updateQueue;
      ug = !1, sg = p.shared;
      var x = p.firstBaseUpdate, _ = p.lastBaseUpdate, O = p.shared.pending;
      if (O !== null) {
        p.shared.pending = null;
        var k = O, V = k.next;
        k.next = null, _ === null ? x = V : _.next = V, _ = k;
        var U = n.alternate;
        if (U !== null) {
          var ie = U.updateQueue, re = ie.lastBaseUpdate;
          re !== _ && (re === null ? ie.firstBaseUpdate = V : re.next = V, ie.lastBaseUpdate = k);
        }
      }
      if (x !== null) {
        var ye = p.baseState, Se = He, Ee = null, lt = null, Ut = null, Lt = x;
        do {
          var An = Lt.lane, Sn = Lt.eventTime;
          if (ua(c, An)) {
            if (Ut !== null) {
              var Me = {
                eventTime: Sn,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Nr,
                tag: Lt.tag,
                payload: Lt.payload,
                callback: Lt.callback,
                next: null
              };
              Ut = Ut.next = Me;
            }
            ye = RD(n, p, Lt, ye, r, u);
            var ve = Lt.callback;
            if (ve !== null && // If the update was already committed, we should not queue its
            // callback again.
            Lt.lane !== Nr) {
              n.flags |= Xf;
              var We = p.effects;
              We === null ? p.effects = [Lt] : We.push(Lt);
            }
          } else {
            var he = {
              eventTime: Sn,
              lane: An,
              tag: Lt.tag,
              payload: Lt.payload,
              callback: Lt.callback,
              next: null
            };
            Ut === null ? (lt = Ut = he, Ee = ye) : Ut = Ut.next = he, Se = jt(Se, An);
          }
          if (Lt = Lt.next, Lt === null) {
            if (O = p.shared.pending, O === null)
              break;
            var pt = O, ut = pt.next;
            pt.next = null, Lt = ut, p.lastBaseUpdate = pt, p.shared.pending = null;
          }
        } while (!0);
        Ut === null && (Ee = ye), p.baseState = Ee, p.firstBaseUpdate = lt, p.lastBaseUpdate = Ut;
        var Jt = p.shared.interleaved;
        if (Jt !== null) {
          var an = Jt;
          do
            Se = jt(Se, an.lane), an = an.next;
          while (an !== Jt);
        } else x === null && (p.shared.lanes = He);
        p4(Se), n.lanes = Se, n.memoizedState = ye;
      }
      sg = null;
    }
    function ED(n, r) {
      if (typeof n != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + n));
      n.call(r);
    }
    function BS() {
      ug = !1;
    }
    function dg() {
      return ug;
    }
    function FS(n, r, u) {
      var c = r.effects;
      if (r.effects = null, c !== null)
        for (var p = 0; p < c.length; p++) {
          var x = c[p], _ = x.callback;
          _ !== null && (x.callback = null, ED(_, u));
        }
    }
    var Um = {}, Wd = fn(Um), Ym = fn(Um), hg = fn(Um);
    function vg(n) {
      if (n === Um)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return n;
    }
    function US() {
      var n = vg(hg.current);
      return n;
    }
    function T7(n, r) {
      ar(hg, r, n), ar(Ym, n, n), ar(Wd, Um, n);
      var u = s6(r);
      pr(Wd, n), ar(Wd, u, n);
    }
    function ep(n) {
      pr(Wd, n), pr(Ym, n), pr(hg, n);
    }
    function O7() {
      var n = vg(Wd.current);
      return n;
    }
    function YS(n) {
      vg(hg.current);
      var r = vg(Wd.current), u = c6(r, n.type);
      r !== u && (ar(Ym, n, n), ar(Wd, u, n));
    }
    function D7(n) {
      Ym.current === n && (pr(Wd, n), pr(Ym, n));
    }
    var MD = 0, $S = 1, WS = 1, $m = 2, h1 = fn(MD);
    function j7(n, r) {
      return (n & r) !== 0;
    }
    function tp(n) {
      return n & $S;
    }
    function A7(n, r) {
      return n & $S | r;
    }
    function TD(n, r) {
      return n | r;
    }
    function zd(n, r) {
      ar(h1, r, n);
    }
    function np(n) {
      pr(h1, n);
    }
    function OD(n, r) {
      var u = n.memoizedState;
      return u !== null ? u.dehydrated !== null : !0;
    }
    function pg(n) {
      for (var r = n; r !== null; ) {
        if (r.tag === $) {
          var u = r.memoizedState;
          if (u !== null) {
            var c = u.dehydrated;
            if (c === null || U3(c) || Dm(c))
              return r;
          }
        } else if (r.tag === K && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        r.memoizedProps.revealOrder !== void 0) {
          var p = (r.flags & pn) !== H;
          if (p)
            return r;
        } else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === n)
          return null;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n)
            return null;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return null;
    }
    var Wo = (
      /*   */
      0
    ), Si = (
      /* */
      1
    ), x0 = (
      /*  */
      2
    ), Ci = (
      /*    */
      4
    ), vl = (
      /*   */
      8
    ), k7 = [];
    function L7() {
      for (var n = 0; n < k7.length; n++) {
        var r = k7[n];
        r._workInProgressVersionPrimary = null;
      }
      k7.length = 0;
    }
    function DD(n, r) {
      var u = r._getVersion, c = u(r._source);
      n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [r, c] : n.mutableSourceEagerHydrationData.push(r, c);
    }
    var ht = a.ReactCurrentDispatcher, Wm = a.ReactCurrentBatchConfig, I7, rp;
    I7 = /* @__PURE__ */ new Set();
    var b2 = He, mr = null, bi = null, _i = null, mg = !1, zm = !1, qm = 0, jD = 0, AD = 25, Ae = null, Ss = null, qd = -1, H7 = !1;
    function ir() {
      {
        var n = Ae;
        Ss === null ? Ss = [n] : Ss.push(n);
      }
    }
    function tt() {
      {
        var n = Ae;
        Ss !== null && (qd++, Ss[qd] !== n && kD(n));
      }
    }
    function ap(n) {
      n != null && !ra(n) && m("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Ae, typeof n);
    }
    function kD(n) {
      {
        var r = en(mr);
        if (!I7.has(r) && (I7.add(r), Ss !== null)) {
          for (var u = "", c = 30, p = 0; p <= qd; p++) {
            for (var x = Ss[p], _ = p === qd ? n : x, O = p + 1 + ". " + x; O.length < c; )
              O += " ";
            O += _ + `
`, u += O;
          }
          m(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, r, u);
        }
      }
    }
    function Bl() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Z7(n, r) {
      if (H7)
        return !1;
      if (r === null)
        return m("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ae), !1;
      n.length !== r.length && m(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ae, "[" + r.join(", ") + "]", "[" + n.join(", ") + "]");
      for (var u = 0; u < r.length && u < n.length; u++)
        if (!ne(n[u], r[u]))
          return !1;
      return !0;
    }
    function ip(n, r, u, c, p, x) {
      b2 = x, mr = r, Ss = n !== null ? n._debugHookTypes : null, qd = -1, H7 = n !== null && n.type !== r.type, r.memoizedState = null, r.updateQueue = null, r.lanes = He, n !== null && n.memoizedState !== null ? ht.current = vC : Ss !== null ? ht.current = hC : ht.current = dC;
      var _ = u(c, p);
      if (zm) {
        var O = 0;
        do {
          if (zm = !1, qm = 0, O >= AD)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          O += 1, H7 = !1, bi = null, _i = null, r.updateQueue = null, qd = -1, ht.current = pC, _ = u(c, p);
        } while (zm);
      }
      ht.current = Og, r._debugHookTypes = Ss;
      var k = bi !== null && bi.next !== null;
      if (b2 = He, mr = null, bi = null, _i = null, Ae = null, Ss = null, qd = -1, n !== null && (n.flags & Mr) !== (r.flags & Mr) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (n.mode & on) !== et && m("Internal React error: Expected static flag was missing. Please notify the React team."), mg = !1, k)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return _;
    }
    function lp() {
      var n = qm !== 0;
      return qm = 0, n;
    }
    function zS(n, r, u) {
      r.updateQueue = n.updateQueue, (r.mode & Zi) !== et ? r.flags &= -50333701 : r.flags &= -2053, n.lanes = Tc(n.lanes, u);
    }
    function qS() {
      if (ht.current = Og, mg) {
        for (var n = mr.memoizedState; n !== null; ) {
          var r = n.queue;
          r !== null && (r.pending = null), n = n.next;
        }
        mg = !1;
      }
      b2 = He, mr = null, bi = null, _i = null, Ss = null, qd = -1, Ae = null, oC = !1, zm = !1, qm = 0;
    }
    function S0() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return _i === null ? mr.memoizedState = _i = n : _i = _i.next = n, _i;
    }
    function Cs() {
      var n;
      if (bi === null) {
        var r = mr.alternate;
        r !== null ? n = r.memoizedState : n = null;
      } else
        n = bi.next;
      var u;
      if (_i === null ? u = mr.memoizedState : u = _i.next, u !== null)
        _i = u, u = _i.next, bi = n;
      else {
        if (n === null)
          throw new Error("Rendered more hooks than during the previous render.");
        bi = n;
        var c = {
          memoizedState: bi.memoizedState,
          baseState: bi.baseState,
          baseQueue: bi.baseQueue,
          queue: bi.queue,
          next: null
        };
        _i === null ? mr.memoizedState = _i = c : _i = _i.next = c;
      }
      return _i;
    }
    function GS() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function P7(n, r) {
      return typeof r == "function" ? r(n) : r;
    }
    function N7(n, r, u) {
      var c = S0(), p;
      u !== void 0 ? p = u(r) : p = r, c.memoizedState = c.baseState = p;
      var x = {
        pending: null,
        interleaved: null,
        lanes: He,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: p
      };
      c.queue = x;
      var _ = x.dispatch = ZD.bind(null, mr, x);
      return [c.memoizedState, _];
    }
    function V7(n, r, u) {
      var c = Cs(), p = c.queue;
      if (p === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      p.lastRenderedReducer = n;
      var x = bi, _ = x.baseQueue, O = p.pending;
      if (O !== null) {
        if (_ !== null) {
          var k = _.next, V = O.next;
          _.next = V, O.next = k;
        }
        x.baseQueue !== _ && m("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), x.baseQueue = _ = O, p.pending = null;
      }
      if (_ !== null) {
        var U = _.next, ie = x.baseState, re = null, ye = null, Se = null, Ee = U;
        do {
          var lt = Ee.lane;
          if (ua(b2, lt)) {
            if (Se !== null) {
              var Lt = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Nr,
                action: Ee.action,
                hasEagerState: Ee.hasEagerState,
                eagerState: Ee.eagerState,
                next: null
              };
              Se = Se.next = Lt;
            }
            if (Ee.hasEagerState)
              ie = Ee.eagerState;
            else {
              var An = Ee.action;
              ie = n(ie, An);
            }
          } else {
            var Ut = {
              lane: lt,
              action: Ee.action,
              hasEagerState: Ee.hasEagerState,
              eagerState: Ee.eagerState,
              next: null
            };
            Se === null ? (ye = Se = Ut, re = ie) : Se = Se.next = Ut, mr.lanes = jt(mr.lanes, lt), p4(lt);
          }
          Ee = Ee.next;
        } while (Ee !== null && Ee !== U);
        Se === null ? re = ie : Se.next = ye, ne(ie, c.memoizedState) || r4(), c.memoizedState = ie, c.baseState = re, c.baseQueue = Se, p.lastRenderedState = ie;
      }
      var Sn = p.interleaved;
      if (Sn !== null) {
        var he = Sn;
        do {
          var Me = he.lane;
          mr.lanes = jt(mr.lanes, Me), p4(Me), he = he.next;
        } while (he !== Sn);
      } else _ === null && (p.lanes = He);
      var ve = p.dispatch;
      return [c.memoizedState, ve];
    }
    function B7(n, r, u) {
      var c = Cs(), p = c.queue;
      if (p === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      p.lastRenderedReducer = n;
      var x = p.dispatch, _ = p.pending, O = c.memoizedState;
      if (_ !== null) {
        p.pending = null;
        var k = _.next, V = k;
        do {
          var U = V.action;
          O = n(O, U), V = V.next;
        } while (V !== k);
        ne(O, c.memoizedState) || r4(), c.memoizedState = O, c.baseQueue === null && (c.baseState = O), p.lastRenderedState = O;
      }
      return [O, x];
    }
    function IQ(n, r, u) {
    }
    function HQ(n, r, u) {
    }
    function F7(n, r, u) {
      var c = mr, p = S0(), x, _ = hl();
      if (_) {
        if (u === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        x = u(), rp || x !== u() && (m("The result of getServerSnapshot should be cached to avoid an infinite loop"), rp = !0);
      } else {
        if (x = r(), !rp) {
          var O = r();
          ne(x, O) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), rp = !0);
        }
        var k = qg();
        if (k === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Vo(k, b2) || KS(c, r, x);
      }
      p.memoizedState = x;
      var V = {
        value: x,
        getSnapshot: r
      };
      return p.queue = V, Sg(XS.bind(null, c, V, n), [n]), c.flags |= pi, Gm(Si | vl, QS.bind(null, c, V, x, r), void 0, null), x;
    }
    function gg(n, r, u) {
      var c = mr, p = Cs(), x = r();
      if (!rp) {
        var _ = r();
        ne(x, _) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), rp = !0);
      }
      var O = p.memoizedState, k = !ne(O, x);
      k && (p.memoizedState = x, r4());
      var V = p.queue;
      if (Qm(XS.bind(null, c, V, n), [n]), V.getSnapshot !== r || k || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      _i !== null && _i.memoizedState.tag & Si) {
        c.flags |= pi, Gm(Si | vl, QS.bind(null, c, V, x, r), void 0, null);
        var U = qg();
        if (U === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Vo(U, b2) || KS(c, r, x);
      }
      return x;
    }
    function KS(n, r, u) {
      n.flags |= Fa;
      var c = {
        getSnapshot: r,
        value: u
      }, p = mr.updateQueue;
      if (p === null)
        p = GS(), mr.updateQueue = p, p.stores = [c];
      else {
        var x = p.stores;
        x === null ? p.stores = [c] : x.push(c);
      }
    }
    function QS(n, r, u, c) {
      r.value = u, r.getSnapshot = c, JS(r) && eC(n);
    }
    function XS(n, r, u) {
      var c = function() {
        JS(r) && eC(n);
      };
      return u(c);
    }
    function JS(n) {
      var r = n.getSnapshot, u = n.value;
      try {
        var c = r();
        return !ne(u, c);
      } catch {
        return !0;
      }
    }
    function eC(n) {
      var r = $o(n, It);
      r !== null && Ti(r, n, It, fr);
    }
    function wg(n) {
      var r = S0();
      typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n;
      var u = {
        pending: null,
        interleaved: null,
        lanes: He,
        dispatch: null,
        lastRenderedReducer: P7,
        lastRenderedState: n
      };
      r.queue = u;
      var c = u.dispatch = PD.bind(null, mr, u);
      return [r.memoizedState, c];
    }
    function U7(n) {
      return V7(P7);
    }
    function Y7(n) {
      return B7(P7);
    }
    function Gm(n, r, u, c) {
      var p = {
        tag: n,
        create: r,
        destroy: u,
        deps: c,
        // Circular
        next: null
      }, x = mr.updateQueue;
      if (x === null)
        x = GS(), mr.updateQueue = x, x.lastEffect = p.next = p;
      else {
        var _ = x.lastEffect;
        if (_ === null)
          x.lastEffect = p.next = p;
        else {
          var O = _.next;
          _.next = p, p.next = O, x.lastEffect = p;
        }
      }
      return p;
    }
    function $7(n) {
      var r = S0();
      {
        var u = {
          current: n
        };
        return r.memoizedState = u, u;
      }
    }
    function yg(n) {
      var r = Cs();
      return r.memoizedState;
    }
    function Km(n, r, u, c) {
      var p = S0(), x = c === void 0 ? null : c;
      mr.flags |= n, p.memoizedState = Gm(Si | r, u, void 0, x);
    }
    function xg(n, r, u, c) {
      var p = Cs(), x = c === void 0 ? null : c, _ = void 0;
      if (bi !== null) {
        var O = bi.memoizedState;
        if (_ = O.destroy, x !== null) {
          var k = O.deps;
          if (Z7(x, k)) {
            p.memoizedState = Gm(r, u, _, x);
            return;
          }
        }
      }
      mr.flags |= n, p.memoizedState = Gm(Si | r, u, _, x);
    }
    function Sg(n, r) {
      return (mr.mode & Zi) !== et ? Km(vc | pi | Xl, vl, n, r) : Km(pi | Xl, vl, n, r);
    }
    function Qm(n, r) {
      return xg(pi, vl, n, r);
    }
    function W7(n, r) {
      return Km(qt, x0, n, r);
    }
    function Cg(n, r) {
      return xg(qt, x0, n, r);
    }
    function z7(n, r) {
      var u = qt;
      return u |= Gu, (mr.mode & Zi) !== et && (u |= Jl), Km(u, Ci, n, r);
    }
    function bg(n, r) {
      return xg(qt, Ci, n, r);
    }
    function tC(n, r) {
      if (typeof r == "function") {
        var u = r, c = n();
        return u(c), function() {
          u(null);
        };
      } else if (r != null) {
        var p = r;
        p.hasOwnProperty("current") || m("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(p).join(", ") + "}");
        var x = n();
        return p.current = x, function() {
          p.current = null;
        };
      }
    }
    function q7(n, r, u) {
      typeof r != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var c = u != null ? u.concat([n]) : null, p = qt;
      return p |= Gu, (mr.mode & Zi) !== et && (p |= Jl), Km(p, Ci, tC.bind(null, r, n), c);
    }
    function _g(n, r, u) {
      typeof r != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var c = u != null ? u.concat([n]) : null;
      return xg(qt, Ci, tC.bind(null, r, n), c);
    }
    function LD(n, r) {
    }
    var Rg = LD;
    function G7(n, r) {
      var u = S0(), c = r === void 0 ? null : r;
      return u.memoizedState = [n, c], n;
    }
    function Eg(n, r) {
      var u = Cs(), c = r === void 0 ? null : r, p = u.memoizedState;
      if (p !== null && c !== null) {
        var x = p[1];
        if (Z7(c, x))
          return p[0];
      }
      return u.memoizedState = [n, c], n;
    }
    function K7(n, r) {
      var u = S0(), c = r === void 0 ? null : r, p = n();
      return u.memoizedState = [p, c], p;
    }
    function Mg(n, r) {
      var u = Cs(), c = r === void 0 ? null : r, p = u.memoizedState;
      if (p !== null && c !== null) {
        var x = p[1];
        if (Z7(c, x))
          return p[0];
      }
      var _ = n();
      return u.memoizedState = [_, c], _;
    }
    function Q7(n) {
      var r = S0();
      return r.memoizedState = n, n;
    }
    function nC(n) {
      var r = Cs(), u = bi, c = u.memoizedState;
      return aC(r, c, n);
    }
    function rC(n) {
      var r = Cs();
      if (bi === null)
        return r.memoizedState = n, n;
      var u = bi.memoizedState;
      return aC(r, u, n);
    }
    function aC(n, r, u) {
      var c = !s0(b2);
      if (c) {
        if (!ne(u, r)) {
          var p = Wh();
          mr.lanes = jt(mr.lanes, p), p4(p), n.baseState = !0;
        }
        return r;
      } else
        return n.baseState && (n.baseState = !1, r4()), n.memoizedState = u, u;
    }
    function ID(n, r, u) {
      var c = Ni();
      rr(za(c, Dt)), n(!0);
      var p = Wm.transition;
      Wm.transition = {};
      var x = Wm.transition;
      Wm.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        n(!1), r();
      } finally {
        if (rr(c), Wm.transition = p, p === null && x._updatedFibers) {
          var _ = x._updatedFibers.size;
          _ > 10 && g("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), x._updatedFibers.clear();
        }
      }
    }
    function X7() {
      var n = wg(!1), r = n[0], u = n[1], c = ID.bind(null, u), p = S0();
      return p.memoizedState = c, [r, c];
    }
    function iC() {
      var n = U7(), r = n[0], u = Cs(), c = u.memoizedState;
      return [r, c];
    }
    function lC() {
      var n = Y7(), r = n[0], u = Cs(), c = u.memoizedState;
      return [r, c];
    }
    var oC = !1;
    function HD() {
      return oC;
    }
    function J7() {
      var n = S0(), r = qg(), u = r.identifierPrefix, c;
      if (hl()) {
        var p = JO();
        c = ":" + u + "R" + p;
        var x = qm++;
        x > 0 && (c += "H" + x.toString(32)), c += ":";
      } else {
        var _ = jD++;
        c = ":" + u + "r" + _.toString(32) + ":";
      }
      return n.memoizedState = c, c;
    }
    function Tg() {
      var n = Cs(), r = n.memoizedState;
      return r;
    }
    function ZD(n, r, u) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Jd(n), p = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (uC(n))
        sC(r, p);
      else {
        var x = ZS(n, r, p, c);
        if (x !== null) {
          var _ = yo();
          Ti(x, n, c, _), cC(x, r, c);
        }
      }
      fC(n, c);
    }
    function PD(n, r, u) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Jd(n), p = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (uC(n))
        sC(r, p);
      else {
        var x = n.alternate;
        if (n.lanes === He && (x === null || x.lanes === He)) {
          var _ = r.lastRenderedReducer;
          if (_ !== null) {
            var O;
            O = ht.current, ht.current = v1;
            try {
              var k = r.lastRenderedState, V = _(k, u);
              if (p.hasEagerState = !0, p.eagerState = V, ne(V, k)) {
                CD(n, r, p);
                return;
              }
            } catch {
            } finally {
              ht.current = O;
            }
          }
        }
        var U = ZS(n, r, p, c);
        if (U !== null) {
          var ie = yo();
          Ti(U, n, c, ie), cC(U, r, c);
        }
      }
      fC(n, c);
    }
    function uC(n) {
      var r = n.alternate;
      return n === mr || r !== null && r === mr;
    }
    function sC(n, r) {
      zm = mg = !0;
      var u = n.pending;
      u === null ? r.next = r : (r.next = u.next, u.next = r), n.pending = r;
    }
    function cC(n, r, u) {
      if (Gs(u)) {
        var c = r.lanes;
        c = hd(c, n.pendingLanes);
        var p = jt(c, u);
        r.lanes = p, Ll(n, p);
      }
    }
    function fC(n, r, u) {
      J1(n, r);
    }
    var Og = {
      readContext: ci,
      useCallback: Bl,
      useContext: Bl,
      useEffect: Bl,
      useImperativeHandle: Bl,
      useInsertionEffect: Bl,
      useLayoutEffect: Bl,
      useMemo: Bl,
      useReducer: Bl,
      useRef: Bl,
      useState: Bl,
      useDebugValue: Bl,
      useDeferredValue: Bl,
      useTransition: Bl,
      useMutableSource: Bl,
      useSyncExternalStore: Bl,
      useId: Bl,
      unstable_isNewReconciler: le
    }, dC = null, hC = null, vC = null, pC = null, C0 = null, v1 = null, Dg = null;
    {
      var e9 = function() {
        m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, nn = function() {
        m("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      dC = {
        readContext: function(n) {
          return ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", ir(), ap(r), G7(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", ir(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", ir(), ap(r), Sg(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", ir(), ap(u), q7(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", ir(), ap(r), W7(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", ir(), ap(r), z7(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", ir(), ap(r);
          var u = ht.current;
          ht.current = C0;
          try {
            return K7(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", ir();
          var c = ht.current;
          ht.current = C0;
          try {
            return N7(n, r, u);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", ir(), $7(n);
        },
        useState: function(n) {
          Ae = "useState", ir();
          var r = ht.current;
          ht.current = C0;
          try {
            return wg(n);
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", ir(), void 0;
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", ir(), Q7(n);
        },
        useTransition: function() {
          return Ae = "useTransition", ir(), X7();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", ir(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", ir(), F7(n, r, u);
        },
        useId: function() {
          return Ae = "useId", ir(), J7();
        },
        unstable_isNewReconciler: le
      }, hC = {
        readContext: function(n) {
          return ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", tt(), G7(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", tt(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", tt(), Sg(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", tt(), q7(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", tt(), W7(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", tt(), z7(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", tt();
          var u = ht.current;
          ht.current = C0;
          try {
            return K7(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", tt();
          var c = ht.current;
          ht.current = C0;
          try {
            return N7(n, r, u);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", tt(), $7(n);
        },
        useState: function(n) {
          Ae = "useState", tt();
          var r = ht.current;
          ht.current = C0;
          try {
            return wg(n);
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", tt(), void 0;
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", tt(), Q7(n);
        },
        useTransition: function() {
          return Ae = "useTransition", tt(), X7();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", tt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", tt(), F7(n, r, u);
        },
        useId: function() {
          return Ae = "useId", tt(), J7();
        },
        unstable_isNewReconciler: le
      }, vC = {
        readContext: function(n) {
          return ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", tt(), Eg(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", tt(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", tt(), Qm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", tt(), _g(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", tt(), Cg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", tt(), bg(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", tt();
          var u = ht.current;
          ht.current = v1;
          try {
            return Mg(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", tt();
          var c = ht.current;
          ht.current = v1;
          try {
            return V7(n);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", tt(), yg();
        },
        useState: function(n) {
          Ae = "useState", tt();
          var r = ht.current;
          ht.current = v1;
          try {
            return U7();
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", tt(), Rg();
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", tt(), nC(n);
        },
        useTransition: function() {
          return Ae = "useTransition", tt(), iC();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", tt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", tt(), gg(n, r);
        },
        useId: function() {
          return Ae = "useId", tt(), Tg();
        },
        unstable_isNewReconciler: le
      }, pC = {
        readContext: function(n) {
          return ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", tt(), Eg(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", tt(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", tt(), Qm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", tt(), _g(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", tt(), Cg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", tt(), bg(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", tt();
          var u = ht.current;
          ht.current = Dg;
          try {
            return Mg(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", tt();
          var c = ht.current;
          ht.current = Dg;
          try {
            return B7(n);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", tt(), yg();
        },
        useState: function(n) {
          Ae = "useState", tt();
          var r = ht.current;
          ht.current = Dg;
          try {
            return Y7();
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", tt(), Rg();
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", tt(), rC(n);
        },
        useTransition: function() {
          return Ae = "useTransition", tt(), lC();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", tt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", tt(), gg(n, r);
        },
        useId: function() {
          return Ae = "useId", tt(), Tg();
        },
        unstable_isNewReconciler: le
      }, C0 = {
        readContext: function(n) {
          return e9(), ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", nn(), ir(), G7(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", nn(), ir(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", nn(), ir(), Sg(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", nn(), ir(), q7(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", nn(), ir(), W7(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", nn(), ir(), z7(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", nn(), ir();
          var u = ht.current;
          ht.current = C0;
          try {
            return K7(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", nn(), ir();
          var c = ht.current;
          ht.current = C0;
          try {
            return N7(n, r, u);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", nn(), ir(), $7(n);
        },
        useState: function(n) {
          Ae = "useState", nn(), ir();
          var r = ht.current;
          ht.current = C0;
          try {
            return wg(n);
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", nn(), ir(), void 0;
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", nn(), ir(), Q7(n);
        },
        useTransition: function() {
          return Ae = "useTransition", nn(), ir(), X7();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", nn(), ir(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", nn(), ir(), F7(n, r, u);
        },
        useId: function() {
          return Ae = "useId", nn(), ir(), J7();
        },
        unstable_isNewReconciler: le
      }, v1 = {
        readContext: function(n) {
          return e9(), ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", nn(), tt(), Eg(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", nn(), tt(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", nn(), tt(), Qm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", nn(), tt(), _g(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", nn(), tt(), Cg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", nn(), tt(), bg(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", nn(), tt();
          var u = ht.current;
          ht.current = v1;
          try {
            return Mg(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", nn(), tt();
          var c = ht.current;
          ht.current = v1;
          try {
            return V7(n);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", nn(), tt(), yg();
        },
        useState: function(n) {
          Ae = "useState", nn(), tt();
          var r = ht.current;
          ht.current = v1;
          try {
            return U7();
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", nn(), tt(), Rg();
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", nn(), tt(), nC(n);
        },
        useTransition: function() {
          return Ae = "useTransition", nn(), tt(), iC();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", nn(), tt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", nn(), tt(), gg(n, r);
        },
        useId: function() {
          return Ae = "useId", nn(), tt(), Tg();
        },
        unstable_isNewReconciler: le
      }, Dg = {
        readContext: function(n) {
          return e9(), ci(n);
        },
        useCallback: function(n, r) {
          return Ae = "useCallback", nn(), tt(), Eg(n, r);
        },
        useContext: function(n) {
          return Ae = "useContext", nn(), tt(), ci(n);
        },
        useEffect: function(n, r) {
          return Ae = "useEffect", nn(), tt(), Qm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return Ae = "useImperativeHandle", nn(), tt(), _g(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return Ae = "useInsertionEffect", nn(), tt(), Cg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return Ae = "useLayoutEffect", nn(), tt(), bg(n, r);
        },
        useMemo: function(n, r) {
          Ae = "useMemo", nn(), tt();
          var u = ht.current;
          ht.current = v1;
          try {
            return Mg(n, r);
          } finally {
            ht.current = u;
          }
        },
        useReducer: function(n, r, u) {
          Ae = "useReducer", nn(), tt();
          var c = ht.current;
          ht.current = v1;
          try {
            return B7(n);
          } finally {
            ht.current = c;
          }
        },
        useRef: function(n) {
          return Ae = "useRef", nn(), tt(), yg();
        },
        useState: function(n) {
          Ae = "useState", nn(), tt();
          var r = ht.current;
          ht.current = v1;
          try {
            return Y7();
          } finally {
            ht.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return Ae = "useDebugValue", nn(), tt(), Rg();
        },
        useDeferredValue: function(n) {
          return Ae = "useDeferredValue", nn(), tt(), rC(n);
        },
        useTransition: function() {
          return Ae = "useTransition", nn(), tt(), lC();
        },
        useMutableSource: function(n, r, u) {
          return Ae = "useMutableSource", nn(), tt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return Ae = "useSyncExternalStore", nn(), tt(), gg(n, r);
        },
        useId: function() {
          return Ae = "useId", nn(), tt(), Tg();
        },
        unstable_isNewReconciler: le
      };
    }
    var Gd = t.unstable_now, mC = 0, jg = -1, Xm = -1, Ag = -1, t9 = !1, kg = !1;
    function gC() {
      return t9;
    }
    function ND() {
      kg = !0;
    }
    function VD() {
      t9 = !1, kg = !1;
    }
    function BD() {
      t9 = kg, kg = !1;
    }
    function wC() {
      return mC;
    }
    function yC() {
      mC = Gd();
    }
    function n9(n) {
      Xm = Gd(), n.actualStartTime < 0 && (n.actualStartTime = Gd());
    }
    function xC(n) {
      Xm = -1;
    }
    function Lg(n, r) {
      if (Xm >= 0) {
        var u = Gd() - Xm;
        n.actualDuration += u, r && (n.selfBaseDuration = u), Xm = -1;
      }
    }
    function b0(n) {
      if (jg >= 0) {
        var r = Gd() - jg;
        jg = -1;
        for (var u = n.return; u !== null; ) {
          switch (u.tag) {
            case T:
              var c = u.stateNode;
              c.effectDuration += r;
              return;
            case z:
              var p = u.stateNode;
              p.effectDuration += r;
              return;
          }
          u = u.return;
        }
      }
    }
    function r9(n) {
      if (Ag >= 0) {
        var r = Gd() - Ag;
        Ag = -1;
        for (var u = n.return; u !== null; ) {
          switch (u.tag) {
            case T:
              var c = u.stateNode;
              c !== null && (c.passiveEffectDuration += r);
              return;
            case z:
              var p = u.stateNode;
              p !== null && (p.passiveEffectDuration += r);
              return;
          }
          u = u.return;
        }
      }
    }
    function _0() {
      jg = Gd();
    }
    function a9() {
      Ag = Gd();
    }
    function i9(n) {
      for (var r = n.child; r; )
        n.actualDuration += r.actualDuration, r = r.sibling;
    }
    function p1(n, r) {
      if (n && n.defaultProps) {
        var u = Gt({}, r), c = n.defaultProps;
        for (var p in c)
          u[p] === void 0 && (u[p] = c[p]);
        return u;
      }
      return r;
    }
    var l9 = {}, o9, u9, s9, c9, f9, SC, Ig, d9, h9, v9, Jm;
    {
      o9 = /* @__PURE__ */ new Set(), u9 = /* @__PURE__ */ new Set(), s9 = /* @__PURE__ */ new Set(), c9 = /* @__PURE__ */ new Set(), d9 = /* @__PURE__ */ new Set(), f9 = /* @__PURE__ */ new Set(), h9 = /* @__PURE__ */ new Set(), v9 = /* @__PURE__ */ new Set(), Jm = /* @__PURE__ */ new Set();
      var CC = /* @__PURE__ */ new Set();
      Ig = function(n, r) {
        if (!(n === null || typeof n == "function")) {
          var u = r + "_" + n;
          CC.has(u) || (CC.add(u), m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, n));
        }
      }, SC = function(n, r) {
        if (r === void 0) {
          var u = Hn(n) || "Component";
          f9.has(u) || (f9.add(u), m("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", u));
        }
      }, Object.defineProperty(l9, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(l9);
    }
    function p9(n, r, u, c) {
      var p = n.memoizedState, x = u(c, p);
      {
        if (n.mode & _r) {
          vr(!0);
          try {
            x = u(c, p);
          } finally {
            vr(!1);
          }
        }
        SC(r, x);
      }
      var _ = x == null ? p : Gt({}, p, x);
      if (n.memoizedState = _, n.lanes === He) {
        var O = n.updateQueue;
        O.baseState = _;
      }
    }
    var m9 = {
      isMounted: Io,
      enqueueSetState: function(n, r, u) {
        var c = Qi(n), p = yo(), x = Jd(c), _ = Kc(p, x);
        _.payload = r, u != null && (Ig(u, "setState"), _.callback = u);
        var O = $d(c, _, x);
        O !== null && (Ti(O, c, x, p), cg(O, c, x)), J1(c, x);
      },
      enqueueReplaceState: function(n, r, u) {
        var c = Qi(n), p = yo(), x = Jd(c), _ = Kc(p, x);
        _.tag = NS, _.payload = r, u != null && (Ig(u, "replaceState"), _.callback = u);
        var O = $d(c, _, x);
        O !== null && (Ti(O, c, x, p), cg(O, c, x)), J1(c, x);
      },
      enqueueForceUpdate: function(n, r) {
        var u = Qi(n), c = yo(), p = Jd(u), x = Kc(c, p);
        x.tag = og, r != null && (Ig(r, "forceUpdate"), x.callback = r);
        var _ = $d(u, x, p);
        _ !== null && (Ti(_, u, p, c), cg(_, u, p)), Uh(u, p);
      }
    };
    function bC(n, r, u, c, p, x, _) {
      var O = n.stateNode;
      if (typeof O.shouldComponentUpdate == "function") {
        var k = O.shouldComponentUpdate(c, x, _);
        {
          if (n.mode & _r) {
            vr(!0);
            try {
              k = O.shouldComponentUpdate(c, x, _);
            } finally {
              vr(!1);
            }
          }
          k === void 0 && m("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Hn(r) || "Component");
        }
        return k;
      }
      return r.prototype && r.prototype.isPureReactComponent ? !de(u, c) || !de(p, x) : !0;
    }
    function FD(n, r, u) {
      var c = n.stateNode;
      {
        var p = Hn(r) || "Component", x = c.render;
        x || (r.prototype && typeof r.prototype.render == "function" ? m("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", p) : m("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", p)), c.getInitialState && !c.getInitialState.isReactClassApproved && !c.state && m("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", p), c.getDefaultProps && !c.getDefaultProps.isReactClassApproved && m("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", p), c.propTypes && m("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", p), c.contextType && m("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", p), r.childContextTypes && !Jm.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (n.mode & _r) === et && (Jm.add(r), m(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, p)), r.contextTypes && !Jm.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (n.mode & _r) === et && (Jm.add(r), m(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, p)), c.contextTypes && m("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", p), r.contextType && r.contextTypes && !h9.has(r) && (h9.add(r), m("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", p)), typeof c.componentShouldUpdate == "function" && m("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", p), r.prototype && r.prototype.isPureReactComponent && typeof c.shouldComponentUpdate < "u" && m("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Hn(r) || "A pure component"), typeof c.componentDidUnmount == "function" && m("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", p), typeof c.componentDidReceiveProps == "function" && m("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", p), typeof c.componentWillRecieveProps == "function" && m("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", p), typeof c.UNSAFE_componentWillRecieveProps == "function" && m("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", p);
        var _ = c.props !== u;
        c.props !== void 0 && _ && m("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", p, p), c.defaultProps && m("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", p, p), typeof c.getSnapshotBeforeUpdate == "function" && typeof c.componentDidUpdate != "function" && !s9.has(r) && (s9.add(r), m("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Hn(r))), typeof c.getDerivedStateFromProps == "function" && m("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", p), typeof c.getDerivedStateFromError == "function" && m("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", p), typeof r.getSnapshotBeforeUpdate == "function" && m("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", p);
        var O = c.state;
        O && (typeof O != "object" || ra(O)) && m("%s.state: must be set to an object or null", p), typeof c.getChildContext == "function" && typeof r.childContextTypes != "object" && m("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", p);
      }
    }
    function _C(n, r) {
      r.updater = m9, n.stateNode = r, Qf(r, n), r._reactInternalInstance = l9;
    }
    function RC(n, r, u) {
      var c = !1, p = Wn, x = Wn, _ = r.contextType;
      if ("contextType" in r) {
        var O = (
          // Allow null for conditional declaration
          _ === null || _ !== void 0 && _.$$typeof === tu && _._context === void 0
        );
        if (!O && !v9.has(r)) {
          v9.add(r);
          var k = "";
          _ === void 0 ? k = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof _ != "object" ? k = " However, it is set to a " + typeof _ + "." : _.$$typeof === Ds ? k = " Did you accidentally pass the Context.Provider instead?" : _._context !== void 0 ? k = " Did you accidentally pass the Context.Consumer instead?" : k = " However, it is set to an object with keys {" + Object.keys(_).join(", ") + "}.", m("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Hn(r) || "Component", k);
        }
      }
      if (typeof _ == "object" && _ !== null)
        x = ci(_);
      else {
        p = Wv(n, r, !0);
        var V = r.contextTypes;
        c = V != null, x = c ? zv(n, p) : Wn;
      }
      var U = new r(u, x);
      if (n.mode & _r) {
        vr(!0);
        try {
          U = new r(u, x);
        } finally {
          vr(!1);
        }
      }
      var ie = n.memoizedState = U.state !== null && U.state !== void 0 ? U.state : null;
      _C(n, U);
      {
        if (typeof r.getDerivedStateFromProps == "function" && ie === null) {
          var re = Hn(r) || "Component";
          u9.has(re) || (u9.add(re), m("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", re, U.state === null ? "null" : "undefined", re));
        }
        if (typeof r.getDerivedStateFromProps == "function" || typeof U.getSnapshotBeforeUpdate == "function") {
          var ye = null, Se = null, Ee = null;
          if (typeof U.componentWillMount == "function" && U.componentWillMount.__suppressDeprecationWarning !== !0 ? ye = "componentWillMount" : typeof U.UNSAFE_componentWillMount == "function" && (ye = "UNSAFE_componentWillMount"), typeof U.componentWillReceiveProps == "function" && U.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Se = "componentWillReceiveProps" : typeof U.UNSAFE_componentWillReceiveProps == "function" && (Se = "UNSAFE_componentWillReceiveProps"), typeof U.componentWillUpdate == "function" && U.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ee = "componentWillUpdate" : typeof U.UNSAFE_componentWillUpdate == "function" && (Ee = "UNSAFE_componentWillUpdate"), ye !== null || Se !== null || Ee !== null) {
            var lt = Hn(r) || "Component", Ut = typeof r.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            c9.has(lt) || (c9.add(lt), m(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, lt, Ut, ye !== null ? `
  ` + ye : "", Se !== null ? `
  ` + Se : "", Ee !== null ? `
  ` + Ee : ""));
          }
        }
      }
      return c && vS(n, p, x), U;
    }
    function UD(n, r) {
      var u = r.state;
      typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), u !== r.state && (m("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", en(n) || "Component"), m9.enqueueReplaceState(r, r.state, null));
    }
    function EC(n, r, u, c) {
      var p = r.state;
      if (typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, c), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, c), r.state !== p) {
        {
          var x = en(n) || "Component";
          o9.has(x) || (o9.add(x), m("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", x));
        }
        m9.enqueueReplaceState(r, r.state, null);
      }
    }
    function g9(n, r, u, c) {
      FD(n, r, u);
      var p = n.stateNode;
      p.props = u, p.state = n.memoizedState, p.refs = {}, E7(n);
      var x = r.contextType;
      if (typeof x == "object" && x !== null)
        p.context = ci(x);
      else {
        var _ = Wv(n, r, !0);
        p.context = zv(n, _);
      }
      {
        if (p.state === u) {
          var O = Hn(r) || "Component";
          d9.has(O) || (d9.add(O), m("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", O));
        }
        n.mode & _r && d1.recordLegacyContextWarning(n, p), d1.recordUnsafeLifecycleWarnings(n, p);
      }
      p.state = n.memoizedState;
      var k = r.getDerivedStateFromProps;
      if (typeof k == "function" && (p9(n, r, k, u), p.state = n.memoizedState), typeof r.getDerivedStateFromProps != "function" && typeof p.getSnapshotBeforeUpdate != "function" && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (UD(n, p), fg(n, u, p, c), p.state = n.memoizedState), typeof p.componentDidMount == "function") {
        var V = qt;
        V |= Gu, (n.mode & Zi) !== et && (V |= Jl), n.flags |= V;
      }
    }
    function YD(n, r, u, c) {
      var p = n.stateNode, x = n.memoizedProps;
      p.props = x;
      var _ = p.context, O = r.contextType, k = Wn;
      if (typeof O == "object" && O !== null)
        k = ci(O);
      else {
        var V = Wv(n, r, !0);
        k = zv(n, V);
      }
      var U = r.getDerivedStateFromProps, ie = typeof U == "function" || typeof p.getSnapshotBeforeUpdate == "function";
      !ie && (typeof p.UNSAFE_componentWillReceiveProps == "function" || typeof p.componentWillReceiveProps == "function") && (x !== u || _ !== k) && EC(n, p, u, k), BS();
      var re = n.memoizedState, ye = p.state = re;
      if (fg(n, u, p, c), ye = n.memoizedState, x === u && re === ye && !W3() && !dg()) {
        if (typeof p.componentDidMount == "function") {
          var Se = qt;
          Se |= Gu, (n.mode & Zi) !== et && (Se |= Jl), n.flags |= Se;
        }
        return !1;
      }
      typeof U == "function" && (p9(n, r, U, u), ye = n.memoizedState);
      var Ee = dg() || bC(n, r, x, u, re, ye, k);
      if (Ee) {
        if (!ie && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (typeof p.componentWillMount == "function" && p.componentWillMount(), typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount()), typeof p.componentDidMount == "function") {
          var lt = qt;
          lt |= Gu, (n.mode & Zi) !== et && (lt |= Jl), n.flags |= lt;
        }
      } else {
        if (typeof p.componentDidMount == "function") {
          var Ut = qt;
          Ut |= Gu, (n.mode & Zi) !== et && (Ut |= Jl), n.flags |= Ut;
        }
        n.memoizedProps = u, n.memoizedState = ye;
      }
      return p.props = u, p.state = ye, p.context = k, Ee;
    }
    function $D(n, r, u, c, p) {
      var x = r.stateNode;
      VS(n, r);
      var _ = r.memoizedProps, O = r.type === r.elementType ? _ : p1(r.type, _);
      x.props = O;
      var k = r.pendingProps, V = x.context, U = u.contextType, ie = Wn;
      if (typeof U == "object" && U !== null)
        ie = ci(U);
      else {
        var re = Wv(r, u, !0);
        ie = zv(r, re);
      }
      var ye = u.getDerivedStateFromProps, Se = typeof ye == "function" || typeof x.getSnapshotBeforeUpdate == "function";
      !Se && (typeof x.UNSAFE_componentWillReceiveProps == "function" || typeof x.componentWillReceiveProps == "function") && (_ !== k || V !== ie) && EC(r, x, c, ie), BS();
      var Ee = r.memoizedState, lt = x.state = Ee;
      if (fg(r, c, x, p), lt = r.memoizedState, _ === k && Ee === lt && !W3() && !dg())
        return typeof x.componentDidUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= qt), typeof x.getSnapshotBeforeUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= $n), !1;
      typeof ye == "function" && (p9(r, u, ye, c), lt = r.memoizedState);
      var Ut = dg() || bC(r, u, O, c, Ee, lt, ie) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      _e;
      return Ut ? (!Se && (typeof x.UNSAFE_componentWillUpdate == "function" || typeof x.componentWillUpdate == "function") && (typeof x.componentWillUpdate == "function" && x.componentWillUpdate(c, lt, ie), typeof x.UNSAFE_componentWillUpdate == "function" && x.UNSAFE_componentWillUpdate(c, lt, ie)), typeof x.componentDidUpdate == "function" && (r.flags |= qt), typeof x.getSnapshotBeforeUpdate == "function" && (r.flags |= $n)) : (typeof x.componentDidUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= qt), typeof x.getSnapshotBeforeUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= $n), r.memoizedProps = c, r.memoizedState = lt), x.props = c, x.state = lt, x.context = ie, Ut;
    }
    function _2(n, r) {
      return {
        value: n,
        source: r,
        stack: k1(r),
        digest: null
      };
    }
    function w9(n, r, u) {
      return {
        value: n,
        source: null,
        stack: u ?? null,
        digest: r ?? null
      };
    }
    function WD(n, r) {
      return !0;
    }
    function y9(n, r) {
      try {
        var u = WD();
        if (u === !1)
          return;
        var c = r.value;
        {
          var p = r.source, x = r.stack, _ = x !== null ? x : "";
          if (c != null && c._suppressLogging) {
            if (n.tag === R)
              return;
            console.error(c);
          }
          var O = p ? en(p) : null, k = O ? "The above error occurred in the <" + O + "> component:" : "The above error occurred in one of your React components:", V;
          if (n.tag === T)
            V = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
          else {
            var U = en(n) || "Anonymous";
            V = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + U + ".");
          }
          var ie = k + `
` + _ + `

` + ("" + V);
          console.error(ie);
        }
      } catch (re) {
        setTimeout(function() {
          throw re;
        });
      }
    }
    var zD = typeof WeakMap == "function" ? WeakMap : Map;
    function MC(n, r, u) {
      var c = Kc(fr, u);
      c.tag = _7, c.payload = {
        element: null
      };
      var p = r.value;
      return c.callback = function() {
        PA(p), y9(n, r);
      }, c;
    }
    function x9(n, r, u) {
      var c = Kc(fr, u);
      c.tag = _7;
      var p = n.type.getDerivedStateFromError;
      if (typeof p == "function") {
        var x = r.value;
        c.payload = function() {
          return p(x);
        }, c.callback = function() {
          Pb(n), y9(n, r);
        };
      }
      var _ = n.stateNode;
      return _ !== null && typeof _.componentDidCatch == "function" && (c.callback = function() {
        Pb(n), y9(n, r), typeof p != "function" && HA(this);
        var k = r.value, V = r.stack;
        this.componentDidCatch(k, {
          componentStack: V !== null ? V : ""
        }), typeof p != "function" && (ii(n.lanes, It) || m("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", en(n) || "Unknown"));
      }), c;
    }
    function TC(n, r, u) {
      var c = n.pingCache, p;
      if (c === null ? (c = n.pingCache = new zD(), p = /* @__PURE__ */ new Set(), c.set(r, p)) : (p = c.get(r), p === void 0 && (p = /* @__PURE__ */ new Set(), c.set(r, p))), !p.has(u)) {
        p.add(u);
        var x = NA.bind(null, n, r, u);
        Pn && m4(n, u), r.then(x, x);
      }
    }
    function qD(n, r, u, c) {
      var p = n.updateQueue;
      if (p === null) {
        var x = /* @__PURE__ */ new Set();
        x.add(u), n.updateQueue = x;
      } else
        p.add(u);
    }
    function GD(n, r) {
      var u = n.tag;
      if ((n.mode & on) === et && (u === b || u === G || u === X)) {
        var c = n.alternate;
        c ? (n.updateQueue = c.updateQueue, n.memoizedState = c.memoizedState, n.lanes = c.lanes) : (n.updateQueue = null, n.memoizedState = null);
      }
    }
    function OC(n) {
      var r = n;
      do {
        if (r.tag === $ && OD(r))
          return r;
        r = r.return;
      } while (r !== null);
      return null;
    }
    function DC(n, r, u, c, p) {
      if ((n.mode & on) === et) {
        if (n === r)
          n.flags |= Li;
        else {
          if (n.flags |= pn, u.flags |= Jf, u.flags &= -52805, u.tag === R) {
            var x = u.alternate;
            if (x === null)
              u.tag = ae;
            else {
              var _ = Kc(fr, It);
              _.tag = og, $d(u, _, It);
            }
          }
          u.lanes = jt(u.lanes, It);
        }
        return n;
      }
      return n.flags |= Li, n.lanes = p, n;
    }
    function KD(n, r, u, c, p) {
      if (u.flags |= Ua, Pn && m4(n, p), c !== null && typeof c == "object" && typeof c.then == "function") {
        var x = c;
        GD(u), hl() && u.mode & on && SS();
        var _ = OC(r);
        if (_ !== null) {
          _.flags &= -257, DC(_, r, u, n, p), _.mode & on && TC(n, x, p), qD(_, n, x);
          return;
        } else {
          if (!fd(p)) {
            TC(n, x, p), X9();
            return;
          }
          var O = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          c = O;
        }
      } else if (hl() && u.mode & on) {
        SS();
        var k = OC(r);
        if (k !== null) {
          (k.flags & Li) === H && (k.flags |= la), DC(k, r, u, n, p), d7(_2(c, u));
          return;
        }
      }
      c = _2(c, u), TA(c);
      var V = r;
      do {
        switch (V.tag) {
          case T: {
            var U = c;
            V.flags |= Li;
            var ie = xu(p);
            V.lanes = jt(V.lanes, ie);
            var re = MC(V, U, ie);
            M7(V, re);
            return;
          }
          case R:
            var ye = c, Se = V.type, Ee = V.stateNode;
            if ((V.flags & pn) === H && (typeof Se.getDerivedStateFromError == "function" || Ee !== null && typeof Ee.componentDidCatch == "function" && !Ob(Ee))) {
              V.flags |= Li;
              var lt = xu(p);
              V.lanes = jt(V.lanes, lt);
              var Ut = x9(V, ye, lt);
              M7(V, Ut);
              return;
            }
            break;
        }
        V = V.return;
      } while (V !== null);
    }
    function QD() {
      return null;
    }
    var e4 = a.ReactCurrentOwner, m1 = !1, S9, t4, C9, b9, _9, R2, R9, Hg, n4;
    S9 = {}, t4 = {}, C9 = {}, b9 = {}, _9 = {}, R2 = !1, R9 = {}, Hg = {}, n4 = {};
    function go(n, r, u, c) {
      n === null ? r.child = kS(r, null, u, c) : r.child = Qv(r, n.child, u, c);
    }
    function XD(n, r, u, c) {
      r.child = Qv(r, n.child, null, c), r.child = Qv(r, null, u, c);
    }
    function jC(n, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = u.propTypes;
        x && At(
          x,
          c,
          // Resolved props
          "prop",
          Hn(u)
        );
      }
      var _ = u.render, O = r.ref, k, V;
      Jv(r, p), ao(r);
      {
        if (e4.current = r, Pa(!0), k = ip(n, r, _, c, O, p), V = lp(), r.mode & _r) {
          vr(!0);
          try {
            k = ip(n, r, _, c, O, p), V = lp();
          } finally {
            vr(!1);
          }
        }
        Pa(!1);
      }
      return Ju(), n !== null && !m1 ? (zS(n, r, p), Qc(n, r, p)) : (hl() && V && l7(r), r.flags |= Ql, go(n, r, k, p), r.child);
    }
    function AC(n, r, u, c, p) {
      if (n === null) {
        var x = u.type;
        if (nk(x) && u.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        u.defaultProps === void 0) {
          var _ = x;
          return _ = vp(x), r.tag = X, r.type = _, T9(r, x), kC(n, r, _, c, p);
        }
        {
          var O = x.propTypes;
          if (O && At(
            O,
            c,
            // Resolved props
            "prop",
            Hn(x)
          ), u.defaultProps !== void 0) {
            var k = Hn(x) || "Unknown";
            n4[k] || (m("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", k), n4[k] = !0);
          }
        }
        var V = sy(u.type, null, c, r, r.mode, p);
        return V.ref = r.ref, V.return = r, r.child = V, V;
      }
      {
        var U = u.type, ie = U.propTypes;
        ie && At(
          ie,
          c,
          // Resolved props
          "prop",
          Hn(U)
        );
      }
      var re = n.child, ye = L9(n, p);
      if (!ye) {
        var Se = re.memoizedProps, Ee = u.compare;
        if (Ee = Ee !== null ? Ee : de, Ee(Se, c) && n.ref === r.ref)
          return Qc(n, r, p);
      }
      r.flags |= Ql;
      var lt = D2(re, c);
      return lt.ref = r.ref, lt.return = r, r.child = lt, lt;
    }
    function kC(n, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = r.elementType;
        if (x.$$typeof === Et) {
          var _ = x, O = _._payload, k = _._init;
          try {
            x = k(O);
          } catch {
            x = null;
          }
          var V = x && x.propTypes;
          V && At(
            V,
            c,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Hn(x)
          );
        }
      }
      if (n !== null) {
        var U = n.memoizedProps;
        if (de(U, c) && n.ref === r.ref && // Prevent bailout if the implementation changed due to hot reload.
        r.type === n.type)
          if (m1 = !1, r.pendingProps = c = U, L9(n, p))
            (n.flags & Jf) !== H && (m1 = !0);
          else return r.lanes = n.lanes, Qc(n, r, p);
      }
      return E9(n, r, u, c, p);
    }
    function LC(n, r, u) {
      var c = r.pendingProps, p = c.children, x = n !== null ? n.memoizedState : null;
      if (c.mode === "hidden" || Pe)
        if ((r.mode & on) === et) {
          var _ = {
            baseLanes: He,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = _, Gg(r, u);
        } else if (ii(u, Pi)) {
          var ie = {
            baseLanes: He,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = ie;
          var re = x !== null ? x.baseLanes : u;
          Gg(r, re);
        } else {
          var O = null, k;
          if (x !== null) {
            var V = x.baseLanes;
            k = jt(V, u);
          } else
            k = u;
          r.lanes = r.childLanes = Pi;
          var U = {
            baseLanes: k,
            cachePool: O,
            transitions: null
          };
          return r.memoizedState = U, r.updateQueue = null, Gg(r, k), null;
        }
      else {
        var ye;
        x !== null ? (ye = jt(x.baseLanes, u), r.memoizedState = null) : ye = u, Gg(r, ye);
      }
      return go(n, r, p, u), r.child;
    }
    function JD(n, r, u) {
      var c = r.pendingProps;
      return go(n, r, c, u), r.child;
    }
    function ej(n, r, u) {
      var c = r.pendingProps.children;
      return go(n, r, c, u), r.child;
    }
    function tj(n, r, u) {
      {
        r.flags |= qt;
        {
          var c = r.stateNode;
          c.effectDuration = 0, c.passiveEffectDuration = 0;
        }
      }
      var p = r.pendingProps, x = p.children;
      return go(n, r, x, u), r.child;
    }
    function IC(n, r) {
      var u = r.ref;
      (n === null && u !== null || n !== null && n.ref !== u) && (r.flags |= Yn, r.flags |= Ii);
    }
    function E9(n, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = u.propTypes;
        x && At(
          x,
          c,
          // Resolved props
          "prop",
          Hn(u)
        );
      }
      var _;
      {
        var O = Wv(r, u, !0);
        _ = zv(r, O);
      }
      var k, V;
      Jv(r, p), ao(r);
      {
        if (e4.current = r, Pa(!0), k = ip(n, r, u, c, _, p), V = lp(), r.mode & _r) {
          vr(!0);
          try {
            k = ip(n, r, u, c, _, p), V = lp();
          } finally {
            vr(!1);
          }
        }
        Pa(!1);
      }
      return Ju(), n !== null && !m1 ? (zS(n, r, p), Qc(n, r, p)) : (hl() && V && l7(r), r.flags |= Ql, go(n, r, k, p), r.child);
    }
    function HC(n, r, u, c, p) {
      {
        switch (gk(r)) {
          case !1: {
            var x = r.stateNode, _ = r.type, O = new _(r.memoizedProps, x.context), k = O.state;
            x.updater.enqueueSetState(x, k, null);
            break;
          }
          case !0: {
            r.flags |= pn, r.flags |= Li;
            var V = new Error("Simulated error coming from DevTools"), U = xu(p);
            r.lanes = jt(r.lanes, U);
            var ie = x9(r, _2(V, r), U);
            M7(r, ie);
            break;
          }
        }
        if (r.type !== r.elementType) {
          var re = u.propTypes;
          re && At(
            re,
            c,
            // Resolved props
            "prop",
            Hn(u)
          );
        }
      }
      var ye;
      y0(u) ? (ye = !0, q3(r)) : ye = !1, Jv(r, p);
      var Se = r.stateNode, Ee;
      Se === null ? (Pg(n, r), RC(r, u, c), g9(r, u, c, p), Ee = !0) : n === null ? Ee = YD(r, u, c, p) : Ee = $D(n, r, u, c, p);
      var lt = M9(n, r, u, Ee, ye, p);
      {
        var Ut = r.stateNode;
        Ee && Ut.props !== c && (R2 || m("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", en(r) || "a component"), R2 = !0);
      }
      return lt;
    }
    function M9(n, r, u, c, p, x) {
      IC(n, r);
      var _ = (r.flags & pn) !== H;
      if (!c && !_)
        return p && gS(r, u, !1), Qc(n, r, x);
      var O = r.stateNode;
      e4.current = r;
      var k;
      if (_ && typeof u.getDerivedStateFromError != "function")
        k = null, xC();
      else {
        ao(r);
        {
          if (Pa(!0), k = O.render(), r.mode & _r) {
            vr(!0);
            try {
              O.render();
            } finally {
              vr(!1);
            }
          }
          Pa(!1);
        }
        Ju();
      }
      return r.flags |= Ql, n !== null && _ ? XD(n, r, k, x) : go(n, r, k, x), r.memoizedState = O.state, p && gS(r, u, !0), r.child;
    }
    function ZC(n) {
      var r = n.stateNode;
      r.pendingContext ? pS(n, r.pendingContext, r.pendingContext !== r.context) : r.context && pS(n, r.context, !1), T7(n, r.containerInfo);
    }
    function nj(n, r, u) {
      if (ZC(r), n === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var c = r.pendingProps, p = r.memoizedState, x = p.element;
      VS(n, r), fg(r, c, null, u);
      var _ = r.memoizedState, O = _.element;
      if (p.isDehydrated) {
        var k = {
          element: O,
          isDehydrated: !1,
          cache: _.cache,
          pendingSuspenseBoundaries: _.pendingSuspenseBoundaries,
          transitions: _.transitions
        }, V = r.updateQueue;
        if (V.baseState = k, r.memoizedState = k, r.flags & la) {
          var U = _2(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), r);
          return PC(n, r, O, u, U);
        } else if (O !== x) {
          var ie = _2(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), r);
          return PC(n, r, O, u, ie);
        } else {
          iD(r);
          var re = kS(r, null, O, u);
          r.child = re;
          for (var ye = re; ye; )
            ye.flags = ye.flags & -3 | Zr, ye = ye.sibling;
        }
      } else {
        if (Kv(), O === x)
          return Qc(n, r, u);
        go(n, r, O, u);
      }
      return r.child;
    }
    function PC(n, r, u, c, p) {
      return Kv(), d7(p), r.flags |= la, go(n, r, u, c), r.child;
    }
    function rj(n, r, u) {
      YS(r), n === null && f7(r);
      var c = r.type, p = r.pendingProps, x = n !== null ? n.memoizedProps : null, _ = p.children, O = bm(c, p);
      return O ? _ = null : x !== null && bm(c, x) && (r.flags |= Bs), IC(n, r), go(n, r, _, u), r.child;
    }
    function aj(n, r) {
      return n === null && f7(r), null;
    }
    function ij(n, r, u, c) {
      Pg(n, r);
      var p = r.pendingProps, x = u, _ = x._payload, O = x._init, k = O(_);
      r.type = k;
      var V = r.tag = rk(k), U = p1(k, p), ie;
      switch (V) {
        case b:
          return T9(r, k), r.type = k = vp(k), ie = E9(null, r, k, U, c), ie;
        case R:
          return r.type = k = ry(k), ie = HC(null, r, k, U, c), ie;
        case G:
          return r.type = k = ay(k), ie = jC(null, r, k, U, c), ie;
        case ce: {
          if (r.type !== r.elementType) {
            var re = k.propTypes;
            re && At(
              re,
              U,
              // Resolved for outer only
              "prop",
              Hn(k)
            );
          }
          return ie = AC(
            null,
            r,
            k,
            p1(k.type, U),
            // The inner type can have defaults too
            c
          ), ie;
        }
      }
      var ye = "";
      throw k !== null && typeof k == "object" && k.$$typeof === Et && (ye = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + k + ". " + ("Lazy element type must resolve to a class or function." + ye));
    }
    function lj(n, r, u, c, p) {
      Pg(n, r), r.tag = R;
      var x;
      return y0(u) ? (x = !0, q3(r)) : x = !1, Jv(r, p), RC(r, u, c), g9(r, u, c, p), M9(null, r, u, !0, x, p);
    }
    function oj(n, r, u, c) {
      Pg(n, r);
      var p = r.pendingProps, x;
      {
        var _ = Wv(r, u, !1);
        x = zv(r, _);
      }
      Jv(r, c);
      var O, k;
      ao(r);
      {
        if (u.prototype && typeof u.prototype.render == "function") {
          var V = Hn(u) || "Unknown";
          S9[V] || (m("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", V, V), S9[V] = !0);
        }
        r.mode & _r && d1.recordLegacyContextWarning(r, null), Pa(!0), e4.current = r, O = ip(null, r, u, p, x, c), k = lp(), Pa(!1);
      }
      if (Ju(), r.flags |= Ql, typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0) {
        var U = Hn(u) || "Unknown";
        t4[U] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", U, U, U), t4[U] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0
      ) {
        {
          var ie = Hn(u) || "Unknown";
          t4[ie] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ie, ie, ie), t4[ie] = !0);
        }
        r.tag = R, r.memoizedState = null, r.updateQueue = null;
        var re = !1;
        return y0(u) ? (re = !0, q3(r)) : re = !1, r.memoizedState = O.state !== null && O.state !== void 0 ? O.state : null, E7(r), _C(r, O), g9(r, u, p, c), M9(null, r, u, !0, re, c);
      } else {
        if (r.tag = b, r.mode & _r) {
          vr(!0);
          try {
            O = ip(null, r, u, p, x, c), k = lp();
          } finally {
            vr(!1);
          }
        }
        return hl() && k && l7(r), go(null, r, O, c), T9(r, u), r.child;
      }
    }
    function T9(n, r) {
      {
        if (r && r.childContextTypes && m("%s(...): childContextTypes cannot be defined on a function component.", r.displayName || r.name || "Component"), n.ref !== null) {
          var u = "", c = ks();
          c && (u += `

Check the render method of \`` + c + "`.");
          var p = c || "", x = n._debugSource;
          x && (p = x.fileName + ":" + x.lineNumber), _9[p] || (_9[p] = !0, m("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", u));
        }
        if (r.defaultProps !== void 0) {
          var _ = Hn(r) || "Unknown";
          n4[_] || (m("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", _), n4[_] = !0);
        }
        if (typeof r.getDerivedStateFromProps == "function") {
          var O = Hn(r) || "Unknown";
          b9[O] || (m("%s: Function components do not support getDerivedStateFromProps.", O), b9[O] = !0);
        }
        if (typeof r.contextType == "object" && r.contextType !== null) {
          var k = Hn(r) || "Unknown";
          C9[k] || (m("%s: Function components do not support contextType.", k), C9[k] = !0);
        }
      }
    }
    var O9 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Nr
    };
    function D9(n) {
      return {
        baseLanes: n,
        cachePool: QD(),
        transitions: null
      };
    }
    function uj(n, r) {
      var u = null;
      return {
        baseLanes: jt(n.baseLanes, r),
        cachePool: u,
        transitions: n.transitions
      };
    }
    function sj(n, r, u, c) {
      if (r !== null) {
        var p = r.memoizedState;
        if (p === null)
          return !1;
      }
      return j7(n, $m);
    }
    function cj(n, r) {
      return Tc(n.childLanes, r);
    }
    function NC(n, r, u) {
      var c = r.pendingProps;
      wk(r) && (r.flags |= pn);
      var p = h1.current, x = !1, _ = (r.flags & pn) !== H;
      if (_ || sj(p, n) ? (x = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (p = TD(p, WS)), p = tp(p), zd(r, p), n === null) {
        f7(r);
        var O = r.memoizedState;
        if (O !== null) {
          var k = O.dehydrated;
          if (k !== null)
            return pj(r, k);
        }
        var V = c.children, U = c.fallback;
        if (x) {
          var ie = fj(r, V, U, u), re = r.child;
          return re.memoizedState = D9(u), r.memoizedState = O9, ie;
        } else
          return j9(r, V);
      } else {
        var ye = n.memoizedState;
        if (ye !== null) {
          var Se = ye.dehydrated;
          if (Se !== null)
            return mj(n, r, _, c, Se, ye, u);
        }
        if (x) {
          var Ee = c.fallback, lt = c.children, Ut = hj(n, r, lt, Ee, u), Lt = r.child, An = n.child.memoizedState;
          return Lt.memoizedState = An === null ? D9(u) : uj(An, u), Lt.childLanes = cj(n, u), r.memoizedState = O9, Ut;
        } else {
          var Sn = c.children, he = dj(n, r, Sn, u);
          return r.memoizedState = null, he;
        }
      }
    }
    function j9(n, r, u) {
      var c = n.mode, p = {
        mode: "visible",
        children: r
      }, x = A9(p, c);
      return x.return = n, n.child = x, x;
    }
    function fj(n, r, u, c) {
      var p = n.mode, x = n.child, _ = {
        mode: "hidden",
        children: r
      }, O, k;
      return (p & on) === et && x !== null ? (O = x, O.childLanes = He, O.pendingProps = _, n.mode & Nn && (O.actualDuration = 0, O.actualStartTime = -1, O.selfBaseDuration = 0, O.treeBaseDuration = 0), k = th(u, p, c, null)) : (O = A9(_, p), k = th(u, p, c, null)), O.return = n, k.return = n, O.sibling = k, n.child = O, k;
    }
    function A9(n, r, u) {
      return Nb(n, r, He, null);
    }
    function VC(n, r) {
      return D2(n, r);
    }
    function dj(n, r, u, c) {
      var p = n.child, x = p.sibling, _ = VC(p, {
        mode: "visible",
        children: u
      });
      if ((r.mode & on) === et && (_.lanes = c), _.return = r, _.sibling = null, x !== null) {
        var O = r.deletions;
        O === null ? (r.deletions = [x], r.flags |= Kt) : O.push(x);
      }
      return r.child = _, _;
    }
    function hj(n, r, u, c, p) {
      var x = r.mode, _ = n.child, O = _.sibling, k = {
        mode: "hidden",
        children: u
      }, V;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (x & on) === et && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        r.child !== _
      ) {
        var U = r.child;
        V = U, V.childLanes = He, V.pendingProps = k, r.mode & Nn && (V.actualDuration = 0, V.actualStartTime = -1, V.selfBaseDuration = _.selfBaseDuration, V.treeBaseDuration = _.treeBaseDuration), r.deletions = null;
      } else
        V = VC(_, k), V.subtreeFlags = _.subtreeFlags & Mr;
      var ie;
      return O !== null ? ie = D2(O, c) : (ie = th(c, x, p, null), ie.flags |= cr), ie.return = r, V.return = r, V.sibling = ie, r.child = V, ie;
    }
    function Zg(n, r, u, c) {
      c !== null && d7(c), Qv(r, n.child, null, u);
      var p = r.pendingProps, x = p.children, _ = j9(r, x);
      return _.flags |= cr, r.memoizedState = null, _;
    }
    function vj(n, r, u, c, p) {
      var x = r.mode, _ = {
        mode: "visible",
        children: u
      }, O = A9(_, x), k = th(c, x, p, null);
      return k.flags |= cr, O.return = r, k.return = r, O.sibling = k, r.child = O, (r.mode & on) !== et && Qv(r, n.child, null, p), k;
    }
    function pj(n, r, u) {
      return (n.mode & on) === et ? (m("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), n.lanes = It) : Dm(r) ? n.lanes = yu : n.lanes = Pi, null;
    }
    function mj(n, r, u, c, p, x, _) {
      if (u)
        if (r.flags & la) {
          r.flags &= -257;
          var he = w9(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Zg(n, r, _, he);
        } else {
          if (r.memoizedState !== null)
            return r.child = n.child, r.flags |= pn, null;
          var Me = c.children, ve = c.fallback, We = vj(n, r, Me, ve, _), pt = r.child;
          return pt.memoizedState = D9(_), r.memoizedState = O9, We;
        }
      else {
        if (rD(), (r.mode & on) === et)
          return Zg(
            n,
            r,
            _,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Dm(p)) {
          var O, k, V;
          {
            var U = L6(p);
            O = U.digest, k = U.message, V = U.stack;
          }
          var ie;
          k ? ie = new Error(k) : ie = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var re = w9(ie, O, V);
          return Zg(n, r, _, re);
        }
        var ye = ii(_, n.childLanes);
        if (m1 || ye) {
          var Se = qg();
          if (Se !== null) {
            var Ee = Dc(Se, _);
            if (Ee !== Nr && Ee !== x.retryLane) {
              x.retryLane = Ee;
              var lt = fr;
              $o(n, Ee), Ti(Se, n, Ee, lt);
            }
          }
          X9();
          var Ut = w9(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Zg(n, r, _, Ut);
        } else if (U3(p)) {
          r.flags |= pn, r.child = n.child;
          var Lt = VA.bind(null, n);
          return jm(p, Lt), null;
        } else {
          lD(r, p, x.treeContext);
          var An = c.children, Sn = j9(r, An);
          return Sn.flags |= Zr, Sn;
        }
      }
    }
    function BC(n, r, u) {
      n.lanes = jt(n.lanes, r);
      var c = n.alternate;
      c !== null && (c.lanes = jt(c.lanes, r)), C7(n.return, r, u);
    }
    function gj(n, r, u) {
      for (var c = r; c !== null; ) {
        if (c.tag === $) {
          var p = c.memoizedState;
          p !== null && BC(c, u, n);
        } else if (c.tag === K)
          BC(c, u, n);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === n)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function wj(n) {
      for (var r = n, u = null; r !== null; ) {
        var c = r.alternate;
        c !== null && pg(c) === null && (u = r), r = r.sibling;
      }
      return u;
    }
    function yj(n) {
      if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !R9[n])
        if (R9[n] = !0, typeof n == "string")
          switch (n.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', n, n.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', n, n.toLowerCase());
              break;
            }
            default:
              m('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
              break;
          }
        else
          m('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
    }
    function xj(n, r) {
      n !== void 0 && !Hg[n] && (n !== "collapsed" && n !== "hidden" ? (Hg[n] = !0, m('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', n)) : r !== "forwards" && r !== "backwards" && (Hg[n] = !0, m('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', n)));
    }
    function FC(n, r) {
      {
        var u = ra(n), c = !u && typeof hi(n) == "function";
        if (u || c) {
          var p = u ? "array" : "iterable";
          return m("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", p, r, p), !1;
        }
      }
      return !0;
    }
    function Sj(n, r) {
      if ((r === "forwards" || r === "backwards") && n !== void 0 && n !== null && n !== !1)
        if (ra(n)) {
          for (var u = 0; u < n.length; u++)
            if (!FC(n[u], u))
              return;
        } else {
          var c = hi(n);
          if (typeof c == "function") {
            var p = c.call(n);
            if (p)
              for (var x = p.next(), _ = 0; !x.done; x = p.next()) {
                if (!FC(x.value, _))
                  return;
                _++;
              }
          } else
            m('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', r);
        }
    }
    function k9(n, r, u, c, p) {
      var x = n.memoizedState;
      x === null ? n.memoizedState = {
        isBackwards: r,
        rendering: null,
        renderingStartTime: 0,
        last: c,
        tail: u,
        tailMode: p
      } : (x.isBackwards = r, x.rendering = null, x.renderingStartTime = 0, x.last = c, x.tail = u, x.tailMode = p);
    }
    function UC(n, r, u) {
      var c = r.pendingProps, p = c.revealOrder, x = c.tail, _ = c.children;
      yj(p), xj(x, p), Sj(_, p), go(n, r, _, u);
      var O = h1.current, k = j7(O, $m);
      if (k)
        O = A7(O, $m), r.flags |= pn;
      else {
        var V = n !== null && (n.flags & pn) !== H;
        V && gj(r, r.child, u), O = tp(O);
      }
      if (zd(r, O), (r.mode & on) === et)
        r.memoizedState = null;
      else
        switch (p) {
          case "forwards": {
            var U = wj(r.child), ie;
            U === null ? (ie = r.child, r.child = null) : (ie = U.sibling, U.sibling = null), k9(
              r,
              !1,
              // isBackwards
              ie,
              U,
              x
            );
            break;
          }
          case "backwards": {
            var re = null, ye = r.child;
            for (r.child = null; ye !== null; ) {
              var Se = ye.alternate;
              if (Se !== null && pg(Se) === null) {
                r.child = ye;
                break;
              }
              var Ee = ye.sibling;
              ye.sibling = re, re = ye, ye = Ee;
            }
            k9(
              r,
              !0,
              // isBackwards
              re,
              null,
              // last
              x
            );
            break;
          }
          case "together": {
            k9(
              r,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            r.memoizedState = null;
        }
      return r.child;
    }
    function Cj(n, r, u) {
      T7(r, r.stateNode.containerInfo);
      var c = r.pendingProps;
      return n === null ? r.child = Qv(r, null, c, u) : go(n, r, c, u), r.child;
    }
    var YC = !1;
    function bj(n, r, u) {
      var c = r.type, p = c._context, x = r.pendingProps, _ = r.memoizedProps, O = x.value;
      {
        "value" in x || YC || (YC = !0, m("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var k = r.type.propTypes;
        k && At(k, x, "prop", "Context.Provider");
      }
      if (HS(r, p, O), _ !== null) {
        var V = _.value;
        if (ne(V, O)) {
          if (_.children === x.children && !W3())
            return Qc(n, r, u);
        } else
          yD(r, p, u);
      }
      var U = x.children;
      return go(n, r, U, u), r.child;
    }
    var $C = !1;
    function _j(n, r, u) {
      var c = r.type;
      c._context === void 0 ? c !== c.Consumer && ($C || ($C = !0, m("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : c = c._context;
      var p = r.pendingProps, x = p.children;
      typeof x != "function" && m("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Jv(r, u);
      var _ = ci(c);
      ao(r);
      var O;
      return e4.current = r, Pa(!0), O = x(_), Pa(!1), Ju(), r.flags |= Ql, go(n, r, O, u), r.child;
    }
    function r4() {
      m1 = !0;
    }
    function Pg(n, r) {
      (r.mode & on) === et && n !== null && (n.alternate = null, r.alternate = null, r.flags |= cr);
    }
    function Qc(n, r, u) {
      return n !== null && (r.dependencies = n.dependencies), xC(), p4(r.lanes), ii(u, r.childLanes) ? (gD(n, r), r.child) : null;
    }
    function Rj(n, r, u) {
      {
        var c = r.return;
        if (c === null)
          throw new Error("Cannot swap the root fiber.");
        if (n.alternate = null, r.alternate = null, u.index = r.index, u.sibling = r.sibling, u.return = r.return, u.ref = r.ref, r === c.child)
          c.child = u;
        else {
          var p = c.child;
          if (p === null)
            throw new Error("Expected parent to have a child.");
          for (; p.sibling !== r; )
            if (p = p.sibling, p === null)
              throw new Error("Expected to find the previous sibling.");
          p.sibling = u;
        }
        var x = c.deletions;
        return x === null ? (c.deletions = [n], c.flags |= Kt) : x.push(n), u.flags |= cr, u;
      }
    }
    function L9(n, r) {
      var u = n.lanes;
      return !!ii(u, r);
    }
    function Ej(n, r, u) {
      switch (r.tag) {
        case T:
          ZC(r), Kv();
          break;
        case A:
          YS(r);
          break;
        case R: {
          var c = r.type;
          y0(c) && q3(r);
          break;
        }
        case j:
          T7(r, r.stateNode.containerInfo);
          break;
        case Y: {
          var p = r.memoizedProps.value, x = r.type._context;
          HS(r, x, p);
          break;
        }
        case z:
          {
            var _ = ii(u, r.childLanes);
            _ && (r.flags |= qt);
            {
              var O = r.stateNode;
              O.effectDuration = 0, O.passiveEffectDuration = 0;
            }
          }
          break;
        case $: {
          var k = r.memoizedState;
          if (k !== null) {
            if (k.dehydrated !== null)
              return zd(r, tp(h1.current)), r.flags |= pn, null;
            var V = r.child, U = V.childLanes;
            if (ii(u, U))
              return NC(n, r, u);
            zd(r, tp(h1.current));
            var ie = Qc(n, r, u);
            return ie !== null ? ie.sibling : null;
          } else
            zd(r, tp(h1.current));
          break;
        }
        case K: {
          var re = (n.flags & pn) !== H, ye = ii(u, r.childLanes);
          if (re) {
            if (ye)
              return UC(n, r, u);
            r.flags |= pn;
          }
          var Se = r.memoizedState;
          if (Se !== null && (Se.rendering = null, Se.tail = null, Se.lastEffect = null), zd(r, h1.current), ye)
            break;
          return null;
        }
        case ue:
        case ge:
          return r.lanes = He, LC(n, r, u);
      }
      return Qc(n, r, u);
    }
    function WC(n, r, u) {
      if (r._debugNeedsRemount && n !== null)
        return Rj(n, r, sy(r.type, r.key, r.pendingProps, r._debugOwner || null, r.mode, r.lanes));
      if (n !== null) {
        var c = n.memoizedProps, p = r.pendingProps;
        if (c !== p || W3() || // Force a re-render if the implementation changed due to hot reload:
        r.type !== n.type)
          m1 = !0;
        else {
          var x = L9(n, u);
          if (!x && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (r.flags & pn) === H)
            return m1 = !1, Ej(n, r, u);
          (n.flags & Jf) !== H ? m1 = !0 : m1 = !1;
        }
      } else if (m1 = !1, hl() && QO(r)) {
        var _ = r.index, O = XO();
        xS(r, O, _);
      }
      switch (r.lanes = He, r.tag) {
        case D:
          return oj(n, r, r.type, u);
        case Ce: {
          var k = r.elementType;
          return ij(n, r, k, u);
        }
        case b: {
          var V = r.type, U = r.pendingProps, ie = r.elementType === V ? U : p1(V, U);
          return E9(n, r, V, ie, u);
        }
        case R: {
          var re = r.type, ye = r.pendingProps, Se = r.elementType === re ? ye : p1(re, ye);
          return HC(n, r, re, Se, u);
        }
        case T:
          return nj(n, r, u);
        case A:
          return rj(n, r, u);
        case L:
          return aj(n, r);
        case $:
          return NC(n, r, u);
        case j:
          return Cj(n, r, u);
        case G: {
          var Ee = r.type, lt = r.pendingProps, Ut = r.elementType === Ee ? lt : p1(Ee, lt);
          return jC(n, r, Ee, Ut, u);
        }
        case P:
          return JD(n, r, u);
        case N:
          return ej(n, r, u);
        case z:
          return tj(n, r, u);
        case Y:
          return bj(n, r, u);
        case F:
          return _j(n, r, u);
        case ce: {
          var Lt = r.type, An = r.pendingProps, Sn = p1(Lt, An);
          if (r.type !== r.elementType) {
            var he = Lt.propTypes;
            he && At(
              he,
              Sn,
              // Resolved for outer only
              "prop",
              Hn(Lt)
            );
          }
          return Sn = p1(Lt.type, Sn), AC(n, r, Lt, Sn, u);
        }
        case X:
          return kC(n, r, r.type, r.pendingProps, u);
        case ae: {
          var Me = r.type, ve = r.pendingProps, We = r.elementType === Me ? ve : p1(Me, ve);
          return lj(n, r, Me, We, u);
        }
        case K:
          return UC(n, r, u);
        case we:
          break;
        case ue:
          return LC(n, r, u);
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function op(n) {
      n.flags |= qt;
    }
    function zC(n) {
      n.flags |= Yn, n.flags |= Ii;
    }
    var qC, I9, GC, KC;
    qC = function(n, r, u, c) {
      for (var p = r.child; p !== null; ) {
        if (p.tag === A || p.tag === L)
          v6(n, p.stateNode);
        else if (p.tag !== j) {
          if (p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
        }
        if (p === r)
          return;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === r)
            return;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }, I9 = function(n, r) {
    }, GC = function(n, r, u, c, p) {
      var x = n.memoizedProps;
      if (x !== c) {
        var _ = r.stateNode, O = O7(), k = m6(_, u, x, c, p, O);
        r.updateQueue = k, k && op(r);
      }
    }, KC = function(n, r, u, c) {
      u !== c && op(r);
    };
    function a4(n, r) {
      if (!hl())
        switch (n.tailMode) {
          case "hidden": {
            for (var u = n.tail, c = null; u !== null; )
              u.alternate !== null && (c = u), u = u.sibling;
            c === null ? n.tail = null : c.sibling = null;
            break;
          }
          case "collapsed": {
            for (var p = n.tail, x = null; p !== null; )
              p.alternate !== null && (x = p), p = p.sibling;
            x === null ? !r && n.tail !== null ? n.tail.sibling = null : n.tail = null : x.sibling = null;
            break;
          }
        }
    }
    function pl(n) {
      var r = n.alternate !== null && n.alternate.child === n.child, u = He, c = H;
      if (r) {
        if ((n.mode & Nn) !== et) {
          for (var k = n.selfBaseDuration, V = n.child; V !== null; )
            u = jt(u, jt(V.lanes, V.childLanes)), c |= V.subtreeFlags & Mr, c |= V.flags & Mr, k += V.treeBaseDuration, V = V.sibling;
          n.treeBaseDuration = k;
        } else
          for (var U = n.child; U !== null; )
            u = jt(u, jt(U.lanes, U.childLanes)), c |= U.subtreeFlags & Mr, c |= U.flags & Mr, U.return = n, U = U.sibling;
        n.subtreeFlags |= c;
      } else {
        if ((n.mode & Nn) !== et) {
          for (var p = n.actualDuration, x = n.selfBaseDuration, _ = n.child; _ !== null; )
            u = jt(u, jt(_.lanes, _.childLanes)), c |= _.subtreeFlags, c |= _.flags, p += _.actualDuration, x += _.treeBaseDuration, _ = _.sibling;
          n.actualDuration = p, n.treeBaseDuration = x;
        } else
          for (var O = n.child; O !== null; )
            u = jt(u, jt(O.lanes, O.childLanes)), c |= O.subtreeFlags, c |= O.flags, O.return = n, O = O.sibling;
        n.subtreeFlags |= c;
      }
      return n.childLanes = u, r;
    }
    function Mj(n, r, u) {
      if (fD() && (r.mode & on) !== et && (r.flags & pn) === H)
        return MS(r), Kv(), r.flags |= la | Ua | Li, !1;
      var c = J3(r);
      if (u !== null && u.dehydrated !== null)
        if (n === null) {
          if (!c)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (sD(r), pl(r), (r.mode & Nn) !== et) {
            var p = u !== null;
            if (p) {
              var x = r.child;
              x !== null && (r.treeBaseDuration -= x.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Kv(), (r.flags & pn) === H && (r.memoizedState = null), r.flags |= qt, pl(r), (r.mode & Nn) !== et) {
            var _ = u !== null;
            if (_) {
              var O = r.child;
              O !== null && (r.treeBaseDuration -= O.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return TS(), !0;
    }
    function QC(n, r, u) {
      var c = r.pendingProps;
      switch (o7(r), r.tag) {
        case D:
        case Ce:
        case X:
        case b:
        case G:
        case P:
        case N:
        case z:
        case F:
        case ce:
          return pl(r), null;
        case R: {
          var p = r.type;
          return y0(p) && z3(r), pl(r), null;
        }
        case T: {
          var x = r.stateNode;
          if (ep(r), r7(r), L7(), x.pendingContext && (x.context = x.pendingContext, x.pendingContext = null), n === null || n.child === null) {
            var _ = J3(r);
            if (_)
              op(r);
            else if (n !== null) {
              var O = n.memoizedState;
              // Check if this is a client root
              (!O.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (r.flags & la) !== H) && (r.flags |= $n, TS());
            }
          }
          return I9(n, r), pl(r), null;
        }
        case A: {
          D7(r);
          var k = US(), V = r.type;
          if (n !== null && r.stateNode != null)
            GC(n, r, V, c, k), n.ref !== r.ref && zC(r);
          else {
            if (!c) {
              if (r.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return pl(r), null;
            }
            var U = O7(), ie = J3(r);
            if (ie)
              oD(r, k, U) && op(r);
            else {
              var re = h6(V, c, k, U, r);
              qC(re, r, !1, !1), r.stateNode = re, p6(re, V, c, k) && op(r);
            }
            r.ref !== null && zC(r);
          }
          return pl(r), null;
        }
        case L: {
          var ye = c;
          if (n && r.stateNode != null) {
            var Se = n.memoizedProps;
            KC(n, r, Se, ye);
          } else {
            if (typeof ye != "string" && r.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Ee = US(), lt = O7(), Ut = J3(r);
            Ut ? uD(r) && op(r) : r.stateNode = g6(ye, Ee, lt, r);
          }
          return pl(r), null;
        }
        case $: {
          np(r);
          var Lt = r.memoizedState;
          if (n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
            var An = Mj(n, r, Lt);
            if (!An)
              return r.flags & Li ? r : null;
          }
          if ((r.flags & pn) !== H)
            return r.lanes = u, (r.mode & Nn) !== et && i9(r), r;
          var Sn = Lt !== null, he = n !== null && n.memoizedState !== null;
          if (Sn !== he && Sn) {
            var Me = r.child;
            if (Me.flags |= oa, (r.mode & on) !== et) {
              var ve = n === null && (r.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              ve || j7(h1.current, WS) ? MA() : X9();
            }
          }
          var We = r.updateQueue;
          if (We !== null && (r.flags |= qt), pl(r), (r.mode & Nn) !== et && Sn) {
            var pt = r.child;
            pt !== null && (r.treeBaseDuration -= pt.treeBaseDuration);
          }
          return null;
        }
        case j:
          return ep(r), I9(n, r), n === null && e7(r.stateNode.containerInfo), pl(r), null;
        case Y:
          var ut = r.type._context;
          return S7(ut, r), pl(r), null;
        case ae: {
          var Jt = r.type;
          return y0(Jt) && z3(r), pl(r), null;
        }
        case K: {
          np(r);
          var an = r.memoizedState;
          if (an === null)
            return pl(r), null;
          var gr = (r.flags & pn) !== H, Gn = an.rendering;
          if (Gn === null)
            if (gr)
              a4(an, !1);
            else {
              var Ka = OA() && (n === null || (n.flags & pn) === H);
              if (!Ka)
                for (var Kn = r.child; Kn !== null; ) {
                  var Da = pg(Kn);
                  if (Da !== null) {
                    gr = !0, r.flags |= pn, a4(an, !1);
                    var Fl = Da.updateQueue;
                    return Fl !== null && (r.updateQueue = Fl, r.flags |= qt), r.subtreeFlags = H, wD(r, u), zd(r, A7(h1.current, $m)), r.child;
                  }
                  Kn = Kn.sibling;
                }
              an.tail !== null && $r() > wb() && (r.flags |= pn, gr = !0, a4(an, !1), r.lanes = r0);
            }
          else {
            if (!gr) {
              var xl = pg(Gn);
              if (xl !== null) {
                r.flags |= pn, gr = !0;
                var Au = xl.updateQueue;
                if (Au !== null && (r.updateQueue = Au, r.flags |= qt), a4(an, !0), an.tail === null && an.tailMode === "hidden" && !Gn.alternate && !hl())
                  return pl(r), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              $r() * 2 - an.renderingStartTime > wb() && u !== Pi && (r.flags |= pn, gr = !0, a4(an, !1), r.lanes = r0);
            }
            if (an.isBackwards)
              Gn.sibling = r.child, r.child = Gn;
            else {
              var xo = an.last;
              xo !== null ? xo.sibling = Gn : r.child = Gn, an.last = Gn;
            }
          }
          if (an.tail !== null) {
            var So = an.tail;
            an.rendering = So, an.tail = So.sibling, an.renderingStartTime = $r(), So.sibling = null;
            var Ul = h1.current;
            return gr ? Ul = A7(Ul, $m) : Ul = tp(Ul), zd(r, Ul), So;
          }
          return pl(r), null;
        }
        case we:
          break;
        case ue:
        case ge: {
          Q9(r);
          var nf = r.memoizedState, pp = nf !== null;
          if (n !== null) {
            var x4 = n.memoizedState, M0 = x4 !== null;
            M0 !== pp && (r.flags |= oa);
          }
          return !pp || (r.mode & on) === et ? pl(r) : ii(E0, Pi) && (pl(r), r.subtreeFlags & (cr | qt) && (r.flags |= oa)), null;
        }
        case Te:
          return null;
        case be:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Tj(n, r, u) {
      switch (o7(r), r.tag) {
        case R: {
          var c = r.type;
          y0(c) && z3(r);
          var p = r.flags;
          return p & Li ? (r.flags = p & -65537 | pn, (r.mode & Nn) !== et && i9(r), r) : null;
        }
        case T: {
          ep(r), r7(r), L7();
          var x = r.flags;
          return (x & Li) !== H && (x & pn) === H ? (r.flags = x & -65537 | pn, r) : null;
        }
        case A:
          return D7(r), null;
        case $: {
          np(r);
          var _ = r.memoizedState;
          if (_ !== null && _.dehydrated !== null) {
            if (r.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Kv();
          }
          var O = r.flags;
          return O & Li ? (r.flags = O & -65537 | pn, (r.mode & Nn) !== et && i9(r), r) : null;
        }
        case K:
          return np(r), null;
        case j:
          return ep(r), null;
        case Y:
          var k = r.type._context;
          return S7(k, r), null;
        case ue:
        case ge:
          return Q9(r), null;
        case Te:
          return null;
        default:
          return null;
      }
    }
    function XC(n, r, u) {
      switch (o7(r), r.tag) {
        case R: {
          var c = r.type.childContextTypes;
          c != null && z3(r);
          break;
        }
        case T: {
          ep(r), r7(r), L7();
          break;
        }
        case A: {
          D7(r);
          break;
        }
        case j:
          ep(r);
          break;
        case $:
          np(r);
          break;
        case K:
          np(r);
          break;
        case Y:
          var p = r.type._context;
          S7(p, r);
          break;
        case ue:
        case ge:
          Q9(r);
          break;
      }
    }
    var JC = null;
    JC = /* @__PURE__ */ new Set();
    var Ng = !1, ml = !1, Oj = typeof WeakSet == "function" ? WeakSet : Set, Mt = null, up = null, sp = null;
    function Dj(n) {
      hc(null, function() {
        throw n;
      }), Tl();
    }
    var jj = function(n, r) {
      if (r.props = n.memoizedProps, r.state = n.memoizedState, n.mode & Nn)
        try {
          _0(), r.componentWillUnmount();
        } finally {
          b0(n);
        }
      else
        r.componentWillUnmount();
    };
    function eb(n, r) {
      try {
        Kd(Ci, n);
      } catch (u) {
        Br(n, r, u);
      }
    }
    function H9(n, r, u) {
      try {
        jj(n, u);
      } catch (c) {
        Br(n, r, c);
      }
    }
    function Aj(n, r, u) {
      try {
        u.componentDidMount();
      } catch (c) {
        Br(n, r, c);
      }
    }
    function tb(n, r) {
      try {
        rb(n);
      } catch (u) {
        Br(n, r, u);
      }
    }
    function cp(n, r) {
      var u = n.ref;
      if (u !== null)
        if (typeof u == "function") {
          var c;
          try {
            if (n.mode & Nn)
              try {
                _0(), c = u(null);
              } finally {
                b0(n);
              }
            else
              c = u(null);
          } catch (p) {
            Br(n, r, p);
          }
          typeof c == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", en(n));
        } else
          u.current = null;
    }
    function Vg(n, r, u) {
      try {
        u();
      } catch (c) {
        Br(n, r, c);
      }
    }
    var nb = !1;
    function kj(n, r) {
      f6(), Mt = r, Lj();
      var u = nb;
      return nb = !1, u;
    }
    function Lj() {
      for (; Mt !== null; ) {
        var n = Mt, r = n.child;
        (n.subtreeFlags & ed) !== H && r !== null ? (r.return = n, Mt = r) : Ij();
      }
    }
    function Ij() {
      for (; Mt !== null; ) {
        var n = Mt;
        tr(n);
        try {
          Hj(n);
        } catch (u) {
          Br(n, n.return, u);
        }
        va();
        var r = n.sibling;
        if (r !== null) {
          r.return = n.return, Mt = r;
          return;
        }
        Mt = n.return;
      }
    }
    function Hj(n) {
      var r = n.alternate, u = n.flags;
      if ((u & $n) !== H) {
        switch (tr(n), n.tag) {
          case b:
          case G:
          case X:
            break;
          case R: {
            if (r !== null) {
              var c = r.memoizedProps, p = r.memoizedState, x = n.stateNode;
              n.type === n.elementType && !R2 && (x.props !== n.memoizedProps && m("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(n) || "instance"), x.state !== n.memoizedState && m("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(n) || "instance"));
              var _ = x.getSnapshotBeforeUpdate(n.elementType === n.type ? c : p1(n.type, c), p);
              {
                var O = JC;
                _ === void 0 && !O.has(n.type) && (O.add(n.type), m("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", en(n)));
              }
              x.__reactInternalSnapshotBeforeUpdate = _;
            }
            break;
          }
          case T: {
            {
              var k = n.stateNode;
              A6(k.containerInfo);
            }
            break;
          }
          case A:
          case L:
          case j:
          case ae:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        va();
      }
    }
    function g1(n, r, u) {
      var c = r.updateQueue, p = c !== null ? c.lastEffect : null;
      if (p !== null) {
        var x = p.next, _ = x;
        do {
          if ((_.tag & n) === n) {
            var O = _.destroy;
            _.destroy = void 0, O !== void 0 && ((n & vl) !== Wo ? Al(r) : (n & Ci) !== Wo && rl(r), (n & x0) !== Wo && g4(!0), Vg(r, u, O), (n & x0) !== Wo && g4(!1), (n & vl) !== Wo ? ld() : (n & Ci) !== Wo && mc());
          }
          _ = _.next;
        } while (_ !== x);
      }
    }
    function Kd(n, r) {
      var u = r.updateQueue, c = u !== null ? u.lastEffect : null;
      if (c !== null) {
        var p = c.next, x = p;
        do {
          if ((x.tag & n) === n) {
            (n & vl) !== Wo ? id(r) : (n & Ci) !== Wo && vv(r);
            var _ = x.create;
            (n & x0) !== Wo && g4(!0), x.destroy = _(), (n & x0) !== Wo && g4(!1), (n & vl) !== Wo ? mu() : (n & Ci) !== Wo && gu();
            {
              var O = x.destroy;
              if (O !== void 0 && typeof O != "function") {
                var k = void 0;
                (x.tag & Ci) !== H ? k = "useLayoutEffect" : (x.tag & x0) !== H ? k = "useInsertionEffect" : k = "useEffect";
                var V = void 0;
                O === null ? V = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof O.then == "function" ? V = `

It looks like you wrote ` + k + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + k + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : V = " You returned: " + O, m("%s must not return anything besides a function, which is used for clean-up.%s", k, V);
              }
            }
          }
          x = x.next;
        } while (x !== p);
      }
    }
    function Zj(n, r) {
      if ((r.flags & qt) !== H)
        switch (r.tag) {
          case z: {
            var u = r.stateNode.passiveEffectDuration, c = r.memoizedProps, p = c.id, x = c.onPostCommit, _ = wC(), O = r.alternate === null ? "mount" : "update";
            gC() && (O = "nested-update"), typeof x == "function" && x(p, O, u, _);
            var k = r.return;
            e: for (; k !== null; ) {
              switch (k.tag) {
                case T:
                  var V = k.stateNode;
                  V.passiveEffectDuration += u;
                  break e;
                case z:
                  var U = k.stateNode;
                  U.passiveEffectDuration += u;
                  break e;
              }
              k = k.return;
            }
            break;
          }
        }
    }
    function Pj(n, r, u, c) {
      if ((u.flags & Ol) !== H)
        switch (u.tag) {
          case b:
          case G:
          case X: {
            if (!ml)
              if (u.mode & Nn)
                try {
                  _0(), Kd(Ci | Si, u);
                } finally {
                  b0(u);
                }
              else
                Kd(Ci | Si, u);
            break;
          }
          case R: {
            var p = u.stateNode;
            if (u.flags & qt && !ml)
              if (r === null)
                if (u.type === u.elementType && !R2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(u) || "instance")), u.mode & Nn)
                  try {
                    _0(), p.componentDidMount();
                  } finally {
                    b0(u);
                  }
                else
                  p.componentDidMount();
              else {
                var x = u.elementType === u.type ? r.memoizedProps : p1(u.type, r.memoizedProps), _ = r.memoizedState;
                if (u.type === u.elementType && !R2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(u) || "instance")), u.mode & Nn)
                  try {
                    _0(), p.componentDidUpdate(x, _, p.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    b0(u);
                  }
                else
                  p.componentDidUpdate(x, _, p.__reactInternalSnapshotBeforeUpdate);
              }
            var O = u.updateQueue;
            O !== null && (u.type === u.elementType && !R2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(u) || "instance")), FS(u, O, p));
            break;
          }
          case T: {
            var k = u.updateQueue;
            if (k !== null) {
              var V = null;
              if (u.child !== null)
                switch (u.child.tag) {
                  case A:
                    V = u.child.stateNode;
                    break;
                  case R:
                    V = u.child.stateNode;
                    break;
                }
              FS(u, k, V);
            }
            break;
          }
          case A: {
            var U = u.stateNode;
            if (r === null && u.flags & qt) {
              var ie = u.type, re = u.memoizedProps;
              C6(U, ie, re);
            }
            break;
          }
          case L:
            break;
          case j:
            break;
          case z: {
            {
              var ye = u.memoizedProps, Se = ye.onCommit, Ee = ye.onRender, lt = u.stateNode.effectDuration, Ut = wC(), Lt = r === null ? "mount" : "update";
              gC() && (Lt = "nested-update"), typeof Ee == "function" && Ee(u.memoizedProps.id, Lt, u.actualDuration, u.treeBaseDuration, u.actualStartTime, Ut);
              {
                typeof Se == "function" && Se(u.memoizedProps.id, Lt, lt, Ut), LA(u);
                var An = u.return;
                e: for (; An !== null; ) {
                  switch (An.tag) {
                    case T:
                      var Sn = An.stateNode;
                      Sn.effectDuration += lt;
                      break e;
                    case z:
                      var he = An.stateNode;
                      he.effectDuration += lt;
                      break e;
                  }
                  An = An.return;
                }
              }
            }
            break;
          }
          case $: {
            $j(n, u);
            break;
          }
          case K:
          case ae:
          case we:
          case ue:
          case ge:
          case be:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      ml || u.flags & Yn && rb(u);
    }
    function Nj(n) {
      switch (n.tag) {
        case b:
        case G:
        case X: {
          if (n.mode & Nn)
            try {
              _0(), eb(n, n.return);
            } finally {
              b0(n);
            }
          else
            eb(n, n.return);
          break;
        }
        case R: {
          var r = n.stateNode;
          typeof r.componentDidMount == "function" && Aj(n, n.return, r), tb(n, n.return);
          break;
        }
        case A: {
          tb(n, n.return);
          break;
        }
      }
    }
    function Vj(n, r) {
      for (var u = null, c = n; ; ) {
        if (c.tag === A) {
          if (u === null) {
            u = c;
            try {
              var p = c.stateNode;
              r ? O6(p) : D6(c.stateNode, c.memoizedProps);
            } catch (_) {
              Br(n, n.return, _);
            }
          }
        } else if (c.tag === L) {
          if (u === null)
            try {
              var x = c.stateNode;
              r ? Tm(x) : j6(x, c.memoizedProps);
            } catch (_) {
              Br(n, n.return, _);
            }
        } else if (!((c.tag === ue || c.tag === ge) && c.memoizedState !== null && c !== n)) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === n)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return;
          u === c && (u = null), c = c.return;
        }
        u === c && (u = null), c.sibling.return = c.return, c = c.sibling;
      }
    }
    function rb(n) {
      var r = n.ref;
      if (r !== null) {
        var u = n.stateNode, c;
        switch (n.tag) {
          case A:
            c = u;
            break;
          default:
            c = u;
        }
        if (typeof r == "function") {
          var p;
          if (n.mode & Nn)
            try {
              _0(), p = r(c);
            } finally {
              b0(n);
            }
          else
            p = r(c);
          typeof p == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", en(n));
        } else
          r.hasOwnProperty("current") || m("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", en(n)), r.current = c;
      }
    }
    function Bj(n) {
      var r = n.alternate;
      r !== null && (r.return = null), n.return = null;
    }
    function ab(n) {
      var r = n.alternate;
      r !== null && (n.alternate = null, ab(r));
      {
        if (n.child = null, n.deletions = null, n.sibling = null, n.tag === A) {
          var u = n.stateNode;
          u !== null && s(u);
        }
        n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
      }
    }
    function Fj(n) {
      for (var r = n.return; r !== null; ) {
        if (ib(r))
          return r;
        r = r.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function ib(n) {
      return n.tag === A || n.tag === T || n.tag === j;
    }
    function lb(n) {
      var r = n;
      e: for (; ; ) {
        for (; r.sibling === null; ) {
          if (r.return === null || ib(r.return))
            return null;
          r = r.return;
        }
        for (r.sibling.return = r.return, r = r.sibling; r.tag !== A && r.tag !== L && r.tag !== me; ) {
          if (r.flags & cr || r.child === null || r.tag === j)
            continue e;
          r.child.return = r, r = r.child;
        }
        if (!(r.flags & cr))
          return r.stateNode;
      }
    }
    function Uj(n) {
      var r = Fj(n);
      switch (r.tag) {
        case A: {
          var u = r.stateNode;
          r.flags & Bs && (V3(u), r.flags &= -33);
          var c = lb(n);
          P9(n, c, u);
          break;
        }
        case T:
        case j: {
          var p = r.stateNode.containerInfo, x = lb(n);
          Z9(n, x, p);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Z9(n, r, u) {
      var c = n.tag, p = c === A || c === L;
      if (p) {
        var x = n.stateNode;
        r ? Em(u, x, r) : E6(u, x);
      } else if (c !== j) {
        var _ = n.child;
        if (_ !== null) {
          Z9(_, r, u);
          for (var O = _.sibling; O !== null; )
            Z9(O, r, u), O = O.sibling;
        }
      }
    }
    function P9(n, r, u) {
      var c = n.tag, p = c === A || c === L;
      if (p) {
        var x = n.stateNode;
        r ? M6(u, x, r) : R6(u, x);
      } else if (c !== j) {
        var _ = n.child;
        if (_ !== null) {
          P9(_, r, u);
          for (var O = _.sibling; O !== null; )
            P9(O, r, u), O = O.sibling;
        }
      }
    }
    var gl = null, w1 = !1;
    function Yj(n, r, u) {
      {
        var c = r;
        e: for (; c !== null; ) {
          switch (c.tag) {
            case A: {
              gl = c.stateNode, w1 = !1;
              break e;
            }
            case T: {
              gl = c.stateNode.containerInfo, w1 = !0;
              break e;
            }
            case j: {
              gl = c.stateNode.containerInfo, w1 = !0;
              break e;
            }
          }
          c = c.return;
        }
        if (gl === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        ob(n, r, u), gl = null, w1 = !1;
      }
      Bj(u);
    }
    function Qd(n, r, u) {
      for (var c = u.child; c !== null; )
        ob(n, r, c), c = c.sibling;
    }
    function ob(n, r, u) {
      switch (Q1(u), u.tag) {
        case A:
          ml || cp(u, r);
        case L: {
          {
            var c = gl, p = w1;
            gl = null, Qd(n, r, u), gl = c, w1 = p, gl !== null && (w1 ? F3(gl, u.stateNode) : B3(gl, u.stateNode));
          }
          return;
        }
        case me: {
          gl !== null && (w1 ? T6(gl, u.stateNode) : Mm(gl, u.stateNode));
          return;
        }
        case j: {
          {
            var x = gl, _ = w1;
            gl = u.stateNode.containerInfo, w1 = !0, Qd(n, r, u), gl = x, w1 = _;
          }
          return;
        }
        case b:
        case G:
        case ce:
        case X: {
          if (!ml) {
            var O = u.updateQueue;
            if (O !== null) {
              var k = O.lastEffect;
              if (k !== null) {
                var V = k.next, U = V;
                do {
                  var ie = U, re = ie.destroy, ye = ie.tag;
                  re !== void 0 && ((ye & x0) !== Wo ? Vg(u, r, re) : (ye & Ci) !== Wo && (rl(u), u.mode & Nn ? (_0(), Vg(u, r, re), b0(u)) : Vg(u, r, re), mc())), U = U.next;
                } while (U !== V);
              }
            }
          }
          Qd(n, r, u);
          return;
        }
        case R: {
          if (!ml) {
            cp(u, r);
            var Se = u.stateNode;
            typeof Se.componentWillUnmount == "function" && H9(u, r, Se);
          }
          Qd(n, r, u);
          return;
        }
        case we: {
          Qd(n, r, u);
          return;
        }
        case ue: {
          if (
            // TODO: Remove this dead flag
            u.mode & on
          ) {
            var Ee = ml;
            ml = Ee || u.memoizedState !== null, Qd(n, r, u), ml = Ee;
          } else
            Qd(n, r, u);
          break;
        }
        default: {
          Qd(n, r, u);
          return;
        }
      }
    }
    function $j(n, r) {
      var u = r.memoizedState;
      if (u === null) {
        var c = r.alternate;
        if (c !== null) {
          var p = c.memoizedState;
          if (p !== null) {
            var x = p.dehydrated;
            x !== null && km(x);
          }
        }
      }
    }
    function ub(n) {
      var r = n.updateQueue;
      if (r !== null) {
        n.updateQueue = null;
        var u = n.stateNode;
        u === null && (u = n.stateNode = new Oj()), r.forEach(function(c) {
          var p = BA.bind(null, n, c);
          if (!u.has(c)) {
            if (u.add(c), Pn)
              if (up !== null && sp !== null)
                m4(sp, up);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            c.then(p, p);
          }
        });
      }
    }
    function Wj(n, r, u) {
      up = u, sp = n, tr(r), sb(r, n), tr(r), up = null, sp = null;
    }
    function y1(n, r, u) {
      var c = r.deletions;
      if (c !== null)
        for (var p = 0; p < c.length; p++) {
          var x = c[p];
          try {
            Yj(n, r, x);
          } catch (k) {
            Br(x, r, k);
          }
        }
      var _ = Bu();
      if (r.subtreeFlags & vu)
        for (var O = r.child; O !== null; )
          tr(O), sb(O, n), O = O.sibling;
      tr(_);
    }
    function sb(n, r, u) {
      var c = n.alternate, p = n.flags;
      switch (n.tag) {
        case b:
        case G:
        case ce:
        case X: {
          if (y1(r, n), R0(n), p & qt) {
            try {
              g1(x0 | Si, n, n.return), Kd(x0 | Si, n);
            } catch (Jt) {
              Br(n, n.return, Jt);
            }
            if (n.mode & Nn) {
              try {
                _0(), g1(Ci | Si, n, n.return);
              } catch (Jt) {
                Br(n, n.return, Jt);
              }
              b0(n);
            } else
              try {
                g1(Ci | Si, n, n.return);
              } catch (Jt) {
                Br(n, n.return, Jt);
              }
          }
          return;
        }
        case R: {
          y1(r, n), R0(n), p & Yn && c !== null && cp(c, c.return);
          return;
        }
        case A: {
          y1(r, n), R0(n), p & Yn && c !== null && cp(c, c.return);
          {
            if (n.flags & Bs) {
              var x = n.stateNode;
              try {
                V3(x);
              } catch (Jt) {
                Br(n, n.return, Jt);
              }
            }
            if (p & qt) {
              var _ = n.stateNode;
              if (_ != null) {
                var O = n.memoizedProps, k = c !== null ? c.memoizedProps : O, V = n.type, U = n.updateQueue;
                if (n.updateQueue = null, U !== null)
                  try {
                    b6(_, U, V, k, O);
                  } catch (Jt) {
                    Br(n, n.return, Jt);
                  }
              }
            }
          }
          return;
        }
        case L: {
          if (y1(r, n), R0(n), p & qt) {
            if (n.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var ie = n.stateNode, re = n.memoizedProps, ye = c !== null ? c.memoizedProps : re;
            try {
              _6(ie, ye, re);
            } catch (Jt) {
              Br(n, n.return, Jt);
            }
          }
          return;
        }
        case T: {
          if (y1(r, n), R0(n), p & qt && c !== null) {
            var Se = c.memoizedState;
            if (Se.isDehydrated)
              try {
                Am(r.containerInfo);
              } catch (Jt) {
                Br(n, n.return, Jt);
              }
          }
          return;
        }
        case j: {
          y1(r, n), R0(n);
          return;
        }
        case $: {
          y1(r, n), R0(n);
          var Ee = n.child;
          if (Ee.flags & oa) {
            var lt = Ee.stateNode, Ut = Ee.memoizedState, Lt = Ut !== null;
            if (lt.isHidden = Lt, Lt) {
              var An = Ee.alternate !== null && Ee.alternate.memoizedState !== null;
              An || EA();
            }
          }
          p & qt && ub(n);
          return;
        }
        case ue: {
          var Sn = c !== null && c.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            n.mode & on
          ) {
            var he = ml;
            ml = he || Sn, y1(r, n), ml = he;
          } else
            y1(r, n);
          if (R0(n), p & oa) {
            var Me = n.stateNode, ve = n.memoizedState, We = ve !== null, pt = n;
            if (Me.isHidden = We, We && !Sn && (pt.mode & on) !== et) {
              Mt = pt;
              for (var ut = pt.child; ut !== null; )
                Mt = ut, qj(ut), ut = ut.sibling;
            }
            Vj(pt, We);
          }
          return;
        }
        case K: {
          y1(r, n), R0(n), p & qt && ub(n);
          return;
        }
        case we:
          return;
        default: {
          y1(r, n), R0(n);
          return;
        }
      }
    }
    function R0(n) {
      var r = n.flags;
      if (r & cr) {
        try {
          Uj(n);
        } catch (u) {
          Br(n, n.return, u);
        }
        n.flags &= -3;
      }
      r & Zr && (n.flags &= -4097);
    }
    function zj(n, r, u) {
      up = u, sp = r, Mt = n, cb(n, r), up = null, sp = null;
    }
    function cb(n, r, u) {
      for (var c = (n.mode & on) !== et; Mt !== null; ) {
        var p = Mt, x = p.child;
        if (p.tag === ue && c) {
          var _ = p.memoizedState !== null, O = _ || Ng;
          if (O) {
            N9(n, r);
            continue;
          } else {
            var k = p.alternate, V = k !== null && k.memoizedState !== null, U = V || ml, ie = Ng, re = ml;
            Ng = O, ml = U, ml && !re && (Mt = p, Gj(p));
            for (var ye = x; ye !== null; )
              Mt = ye, cb(
                ye,
                // New root; bubble back up to here and stop.
                r
              ), ye = ye.sibling;
            Mt = p, Ng = ie, ml = re, N9(n, r);
            continue;
          }
        }
        (p.subtreeFlags & Ol) !== H && x !== null ? (x.return = p, Mt = x) : N9(n, r);
      }
    }
    function N9(n, r, u) {
      for (; Mt !== null; ) {
        var c = Mt;
        if ((c.flags & Ol) !== H) {
          var p = c.alternate;
          tr(c);
          try {
            Pj(r, p, c);
          } catch (_) {
            Br(c, c.return, _);
          }
          va();
        }
        if (c === n) {
          Mt = null;
          return;
        }
        var x = c.sibling;
        if (x !== null) {
          x.return = c.return, Mt = x;
          return;
        }
        Mt = c.return;
      }
    }
    function qj(n) {
      for (; Mt !== null; ) {
        var r = Mt, u = r.child;
        switch (r.tag) {
          case b:
          case G:
          case ce:
          case X: {
            if (r.mode & Nn)
              try {
                _0(), g1(Ci, r, r.return);
              } finally {
                b0(r);
              }
            else
              g1(Ci, r, r.return);
            break;
          }
          case R: {
            cp(r, r.return);
            var c = r.stateNode;
            typeof c.componentWillUnmount == "function" && H9(r, r.return, c);
            break;
          }
          case A: {
            cp(r, r.return);
            break;
          }
          case ue: {
            var p = r.memoizedState !== null;
            if (p) {
              fb(n);
              continue;
            }
            break;
          }
        }
        u !== null ? (u.return = r, Mt = u) : fb(n);
      }
    }
    function fb(n) {
      for (; Mt !== null; ) {
        var r = Mt;
        if (r === n) {
          Mt = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, Mt = u;
          return;
        }
        Mt = r.return;
      }
    }
    function Gj(n) {
      for (; Mt !== null; ) {
        var r = Mt, u = r.child;
        if (r.tag === ue) {
          var c = r.memoizedState !== null;
          if (c) {
            db(n);
            continue;
          }
        }
        u !== null ? (u.return = r, Mt = u) : db(n);
      }
    }
    function db(n) {
      for (; Mt !== null; ) {
        var r = Mt;
        tr(r);
        try {
          Nj(r);
        } catch (c) {
          Br(r, r.return, c);
        }
        if (va(), r === n) {
          Mt = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, Mt = u;
          return;
        }
        Mt = r.return;
      }
    }
    function Kj(n, r, u, c) {
      Mt = r, Qj(r, n);
    }
    function Qj(n, r, u, c) {
      for (; Mt !== null; ) {
        var p = Mt, x = p.child;
        (p.subtreeFlags & eo) !== H && x !== null ? (x.return = p, Mt = x) : Xj(n, r);
      }
    }
    function Xj(n, r, u, c) {
      for (; Mt !== null; ) {
        var p = Mt;
        if ((p.flags & pi) !== H) {
          tr(p);
          try {
            Jj(r, p);
          } catch (_) {
            Br(p, p.return, _);
          }
          va();
        }
        if (p === n) {
          Mt = null;
          return;
        }
        var x = p.sibling;
        if (x !== null) {
          x.return = p.return, Mt = x;
          return;
        }
        Mt = p.return;
      }
    }
    function Jj(n, r, u, c) {
      switch (r.tag) {
        case b:
        case G:
        case X: {
          if (r.mode & Nn) {
            a9();
            try {
              Kd(vl | Si, r);
            } finally {
              r9(r);
            }
          } else
            Kd(vl | Si, r);
          break;
        }
      }
    }
    function eA(n) {
      Mt = n, tA();
    }
    function tA() {
      for (; Mt !== null; ) {
        var n = Mt, r = n.child;
        if ((Mt.flags & Kt) !== H) {
          var u = n.deletions;
          if (u !== null) {
            for (var c = 0; c < u.length; c++) {
              var p = u[c];
              Mt = p, aA(p, n);
            }
            {
              var x = n.alternate;
              if (x !== null) {
                var _ = x.child;
                if (_ !== null) {
                  x.child = null;
                  do {
                    var O = _.sibling;
                    _.sibling = null, _ = O;
                  } while (_ !== null);
                }
              }
            }
            Mt = n;
          }
        }
        (n.subtreeFlags & eo) !== H && r !== null ? (r.return = n, Mt = r) : nA();
      }
    }
    function nA() {
      for (; Mt !== null; ) {
        var n = Mt;
        (n.flags & pi) !== H && (tr(n), rA(n), va());
        var r = n.sibling;
        if (r !== null) {
          r.return = n.return, Mt = r;
          return;
        }
        Mt = n.return;
      }
    }
    function rA(n) {
      switch (n.tag) {
        case b:
        case G:
        case X: {
          n.mode & Nn ? (a9(), g1(vl | Si, n, n.return), r9(n)) : g1(vl | Si, n, n.return);
          break;
        }
      }
    }
    function aA(n, r) {
      for (; Mt !== null; ) {
        var u = Mt;
        tr(u), lA(u, r), va();
        var c = u.child;
        c !== null ? (c.return = u, Mt = c) : iA(n);
      }
    }
    function iA(n) {
      for (; Mt !== null; ) {
        var r = Mt, u = r.sibling, c = r.return;
        if (ab(r), r === n) {
          Mt = null;
          return;
        }
        if (u !== null) {
          u.return = c, Mt = u;
          return;
        }
        Mt = c;
      }
    }
    function lA(n, r) {
      switch (n.tag) {
        case b:
        case G:
        case X: {
          n.mode & Nn ? (a9(), g1(vl, n, r), r9(n)) : g1(vl, n, r);
          break;
        }
      }
    }
    function oA(n) {
      switch (n.tag) {
        case b:
        case G:
        case X: {
          try {
            Kd(Ci | Si, n);
          } catch (u) {
            Br(n, n.return, u);
          }
          break;
        }
        case R: {
          var r = n.stateNode;
          try {
            r.componentDidMount();
          } catch (u) {
            Br(n, n.return, u);
          }
          break;
        }
      }
    }
    function uA(n) {
      switch (n.tag) {
        case b:
        case G:
        case X: {
          try {
            Kd(vl | Si, n);
          } catch (r) {
            Br(n, n.return, r);
          }
          break;
        }
      }
    }
    function sA(n) {
      switch (n.tag) {
        case b:
        case G:
        case X: {
          try {
            g1(Ci | Si, n, n.return);
          } catch (u) {
            Br(n, n.return, u);
          }
          break;
        }
        case R: {
          var r = n.stateNode;
          typeof r.componentWillUnmount == "function" && H9(n, n.return, r);
          break;
        }
      }
    }
    function cA(n) {
      switch (n.tag) {
        case b:
        case G:
        case X:
          try {
            g1(vl | Si, n, n.return);
          } catch (r) {
            Br(n, n.return, r);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var i4 = Symbol.for;
      i4("selector.component"), i4("selector.has_pseudo_class"), i4("selector.role"), i4("selector.test_id"), i4("selector.text");
    }
    var fA = [];
    function dA() {
      fA.forEach(function(n) {
        return n();
      });
    }
    var hA = a.ReactCurrentActQueue;
    function vA(n) {
      {
        var r = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), u = typeof jest < "u";
        return u && r !== !1;
      }
    }
    function hb() {
      {
        var n = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !n && hA.current !== null && m("The current testing environment is not configured to support act(...)"), n;
      }
    }
    var pA = Math.ceil, V9 = a.ReactCurrentDispatcher, B9 = a.ReactCurrentOwner, wl = a.ReactCurrentBatchConfig, x1 = a.ReactCurrentActQueue, Ri = (
      /*             */
      0
    ), vb = (
      /*               */
      1
    ), yl = (
      /*                */
      2
    ), bs = (
      /*                */
      4
    ), Xc = 0, l4 = 1, E2 = 2, Bg = 3, o4 = 4, pb = 5, F9 = 6, jn = Ri, wo = null, ya = null, Ei = He, E0 = He, U9 = fn(He), Mi = Xc, u4 = null, Fg = He, s4 = He, Ug = He, c4 = null, zo = null, Y9 = 0, mb = 500, gb = 1 / 0, mA = 500, Jc = null;
    function f4() {
      gb = $r() + mA;
    }
    function wb() {
      return gb;
    }
    var Yg = !1, $9 = null, fp = null, M2 = !1, Xd = null, d4 = He, W9 = [], gA = 50, h4 = 0, z9 = null, q9 = !1, $g = !1, wA = 50, dp = 0, Wg = null, v4 = fr, zg = He, yb = !1;
    function qg() {
      return wo;
    }
    function yo() {
      return (jn & (yl | bs)) !== Ri ? $r() : (v4 !== fr || (v4 = $r()), v4);
    }
    function Jd(n) {
      var r = n.mode;
      if ((r & on) === et)
        return It;
      if ((jn & yl) !== Ri && Ei !== He)
        return xu(Ei);
      var u = vD() !== hD;
      if (u) {
        if (wl.transition !== null) {
          var c = wl.transition;
          c._updatedFibers || (c._updatedFibers = /* @__PURE__ */ new Set()), c._updatedFibers.add(n);
        }
        return zg === Nr && (zg = Wh()), zg;
      }
      var p = Ni();
      if (p !== Nr)
        return p;
      var x = w6();
      return x;
    }
    function yA(n) {
      var r = n.mode;
      return (r & on) === et ? It : Ec();
    }
    function Ti(n, r, u, c) {
      UA(), yb && m("useInsertionEffect must not schedule updates."), q9 && ($g = !0), Ks(n, u, c), (jn & yl) !== He && n === wo ? WA(r) : (Pn && c0(n, r, u), zA(r), n === wo && ((jn & yl) === Ri && (s4 = jt(s4, u)), Mi === o4 && eh(n, Ei)), qo(n, c), u === It && jn === Ri && (r.mode & on) === et && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !x1.isBatchingLegacy && (f4(), yS()));
    }
    function xA(n, r, u) {
      var c = n.current;
      c.lanes = r, Ks(n, r, u), qo(n, u);
    }
    function SA(n) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (jn & yl) !== Ri
      );
    }
    function qo(n, r) {
      var u = n.callbackNode;
      o0(n, r);
      var c = qs(n, n === wo ? Ei : He);
      if (c === He) {
        u !== null && Ib(u), n.callbackNode = null, n.callbackPriority = Nr;
        return;
      }
      var p = Bo(c), x = n.callbackPriority;
      if (x === p && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(x1.current !== null && u !== ty)) {
        u == null && x !== It && m("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      u != null && Ib(u);
      var _;
      if (p === It)
        n.tag === Fd ? (x1.isBatchingLegacy !== null && (x1.didScheduleLegacyUpdate = !0), KO(Cb.bind(null, n))) : wS(Cb.bind(null, n)), x1.current !== null ? x1.current.push(Ud) : x6(function() {
          (jn & (yl | bs)) === Ri && Ud();
        }), _ = null;
      else {
        var O;
        switch (md(c)) {
          case qr:
            O = $a;
            break;
          case Dt:
            O = nd;
            break;
          case al:
            O = ro;
            break;
          case ss:
            O = Dl;
            break;
          default:
            O = ro;
            break;
        }
        _ = ny(O, xb.bind(null, n));
      }
      n.callbackPriority = p, n.callbackNode = _;
    }
    function xb(n, r) {
      if (VD(), v4 = fr, zg = He, (jn & (yl | bs)) !== Ri)
        throw new Error("Should not already be working.");
      var u = n.callbackNode, c = tf();
      if (c && n.callbackNode !== u)
        return null;
      var p = qs(n, n === wo ? Ei : He);
      if (p === He)
        return null;
      var x = !Vo(n, p) && !dd(n, p) && !r, _ = x ? jA(n, p) : Kg(n, p);
      if (_ !== Xc) {
        if (_ === E2) {
          var O = u0(n);
          O !== He && (p = O, _ = G9(n, O));
        }
        if (_ === l4) {
          var k = u4;
          throw T2(n, He), eh(n, p), qo(n, $r()), k;
        }
        if (_ === F9)
          eh(n, p);
        else {
          var V = !Vo(n, p), U = n.current.alternate;
          if (V && !bA(U)) {
            if (_ = Kg(n, p), _ === E2) {
              var ie = u0(n);
              ie !== He && (p = ie, _ = G9(n, ie));
            }
            if (_ === l4) {
              var re = u4;
              throw T2(n, He), eh(n, p), qo(n, $r()), re;
            }
          }
          n.finishedWork = U, n.finishedLanes = p, CA(n, _, p);
        }
      }
      return qo(n, $r()), n.callbackNode === u ? xb.bind(null, n) : null;
    }
    function G9(n, r) {
      var u = c4;
      if (cs(n)) {
        var c = T2(n, r);
        c.flags |= la, J6(n.containerInfo);
      }
      var p = Kg(n, r);
      if (p !== E2) {
        var x = zo;
        zo = u, x !== null && Sb(x);
      }
      return p;
    }
    function Sb(n) {
      zo === null ? zo = n : zo.push.apply(zo, n);
    }
    function CA(n, r, u) {
      switch (r) {
        case Xc:
        case l4:
          throw new Error("Root did not complete. This is a bug in React.");
        case E2: {
          O2(n, zo, Jc);
          break;
        }
        case Bg: {
          if (eh(n, u), os(u) && // do not delay if we're inside an act() scope
          !Hb()) {
            var c = Y9 + mb - $r();
            if (c > 10) {
              var p = qs(n, He);
              if (p !== He)
                break;
              var x = n.suspendedLanes;
              if (!ua(x, u)) {
                yo(), vd(n, x);
                break;
              }
              n.timeoutHandle = _m(O2.bind(null, n, zo, Jc), c);
              break;
            }
          }
          O2(n, zo, Jc);
          break;
        }
        case o4: {
          if (eh(n, u), $h(u))
            break;
          if (!Hb()) {
            var _ = Jp(n, u), O = _, k = $r() - O, V = FA(k) - k;
            if (V > 10) {
              n.timeoutHandle = _m(O2.bind(null, n, zo, Jc), V);
              break;
            }
          }
          O2(n, zo, Jc);
          break;
        }
        case pb: {
          O2(n, zo, Jc);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function bA(n) {
      for (var r = n; ; ) {
        if (r.flags & Fa) {
          var u = r.updateQueue;
          if (u !== null) {
            var c = u.stores;
            if (c !== null)
              for (var p = 0; p < c.length; p++) {
                var x = c[p], _ = x.getSnapshot, O = x.value;
                try {
                  if (!ne(_(), O))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var k = r.child;
        if (r.subtreeFlags & Fa && k !== null) {
          k.return = r, r = k;
          continue;
        }
        if (r === n)
          return !0;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n)
            return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return !0;
    }
    function eh(n, r) {
      r = Tc(r, Ug), r = Tc(r, s4), qh(n, r);
    }
    function Cb(n) {
      if (BD(), (jn & (yl | bs)) !== Ri)
        throw new Error("Should not already be working.");
      tf();
      var r = qs(n, He);
      if (!ii(r, It))
        return qo(n, $r()), null;
      var u = Kg(n, r);
      if (n.tag !== Fd && u === E2) {
        var c = u0(n);
        c !== He && (r = c, u = G9(n, c));
      }
      if (u === l4) {
        var p = u4;
        throw T2(n, He), eh(n, r), qo(n, $r()), p;
      }
      if (u === F9)
        throw new Error("Root did not complete. This is a bug in React.");
      var x = n.current.alternate;
      return n.finishedWork = x, n.finishedLanes = r, O2(n, zo, Jc), qo(n, $r()), null;
    }
    function _A(n, r) {
      r !== He && (Ll(n, jt(r, It)), qo(n, $r()), (jn & (yl | bs)) === Ri && (f4(), Ud()));
    }
    function K9(n, r) {
      var u = jn;
      jn |= vb;
      try {
        return n(r);
      } finally {
        jn = u, jn === Ri && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !x1.isBatchingLegacy && (f4(), yS());
      }
    }
    function RA(n, r, u, c, p) {
      var x = Ni(), _ = wl.transition;
      try {
        return wl.transition = null, rr(qr), n(r, u, c, p);
      } finally {
        rr(x), wl.transition = _, jn === Ri && f4();
      }
    }
    function ef(n) {
      Xd !== null && Xd.tag === Fd && (jn & (yl | bs)) === Ri && tf();
      var r = jn;
      jn |= vb;
      var u = wl.transition, c = Ni();
      try {
        return wl.transition = null, rr(qr), n ? n() : void 0;
      } finally {
        rr(c), wl.transition = u, jn = r, (jn & (yl | bs)) === Ri && Ud();
      }
    }
    function bb() {
      return (jn & (yl | bs)) !== Ri;
    }
    function Gg(n, r) {
      ar(U9, E0, n), E0 = jt(E0, r);
    }
    function Q9(n) {
      E0 = U9.current, pr(U9, n);
    }
    function T2(n, r) {
      n.finishedWork = null, n.finishedLanes = He;
      var u = n.timeoutHandle;
      if (u !== Rm && (n.timeoutHandle = Rm, y6(u)), ya !== null)
        for (var c = ya.return; c !== null; ) {
          var p = c.alternate;
          XC(p, c), c = c.return;
        }
      wo = n;
      var x = D2(n.current, null);
      return ya = x, Ei = E0 = r, Mi = Xc, u4 = null, Fg = He, s4 = He, Ug = He, c4 = null, zo = null, SD(), d1.discardPendingWarnings(), x;
    }
    function _b(n, r) {
      do {
        var u = ya;
        try {
          if (ig(), qS(), va(), B9.current = null, u === null || u.return === null) {
            Mi = l4, u4 = r, ya = null;
            return;
          }
          if (u.mode & Nn && Lg(u, !0), Ju(), r !== null && typeof r == "object" && typeof r.then == "function") {
            var c = r;
            X1(u, c, Ei);
          } else
            pv(u, r, Ei);
          KD(n, u.return, u, r, Ei), Tb(u);
        } catch (p) {
          r = p, ya === u && u !== null ? (u = u.return, ya = u) : u = ya;
          continue;
        }
        return;
      } while (!0);
    }
    function Rb() {
      var n = V9.current;
      return V9.current = Og, n === null ? Og : n;
    }
    function Eb(n) {
      V9.current = n;
    }
    function EA() {
      Y9 = $r();
    }
    function p4(n) {
      Fg = jt(n, Fg);
    }
    function MA() {
      Mi === Xc && (Mi = Bg);
    }
    function X9() {
      (Mi === Xc || Mi === Bg || Mi === E2) && (Mi = o4), wo !== null && (Rc(Fg) || Rc(s4)) && eh(wo, Ei);
    }
    function TA(n) {
      Mi !== o4 && (Mi = E2), c4 === null ? c4 = [n] : c4.push(n);
    }
    function OA() {
      return Mi === Xc;
    }
    function Kg(n, r) {
      var u = jn;
      jn |= yl;
      var c = Rb();
      if (wo !== n || Ei !== r) {
        if (Pn) {
          var p = n.memoizedUpdaters;
          p.size > 0 && (m4(n, Ei), p.clear()), jc(n, r);
        }
        Jc = Qs(), T2(n, r);
      }
      Ys(r);
      do
        try {
          DA();
          break;
        } catch (x) {
          _b(n, x);
        }
      while (!0);
      if (ig(), jn = u, Eb(c), ya !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return od(), wo = null, Ei = He, Mi;
    }
    function DA() {
      for (; ya !== null; )
        Mb(ya);
    }
    function jA(n, r) {
      var u = jn;
      jn |= yl;
      var c = Rb();
      if (wo !== n || Ei !== r) {
        if (Pn) {
          var p = n.memoizedUpdaters;
          p.size > 0 && (m4(n, Ei), p.clear()), jc(n, r);
        }
        Jc = Qs(), f4(), T2(n, r);
      }
      Ys(r);
      do
        try {
          AA();
          break;
        } catch (x) {
          _b(n, x);
        }
      while (!0);
      return ig(), Eb(c), jn = u, ya !== null ? (wu(), Xc) : (od(), wo = null, Ei = He, Mi);
    }
    function AA() {
      for (; ya !== null && !no(); )
        Mb(ya);
    }
    function Mb(n) {
      var r = n.alternate;
      tr(n);
      var u;
      (n.mode & Nn) !== et ? (n9(n), u = J9(r, n, E0), Lg(n, !0)) : u = J9(r, n, E0), va(), n.memoizedProps = n.pendingProps, u === null ? Tb(n) : ya = u, B9.current = null;
    }
    function Tb(n) {
      var r = n;
      do {
        var u = r.alternate, c = r.return;
        if ((r.flags & Ua) === H) {
          tr(r);
          var p = void 0;
          if ((r.mode & Nn) === et ? p = QC(u, r, E0) : (n9(r), p = QC(u, r, E0), Lg(r, !1)), va(), p !== null) {
            ya = p;
            return;
          }
        } else {
          var x = Tj(u, r);
          if (x !== null) {
            x.flags &= G1, ya = x;
            return;
          }
          if ((r.mode & Nn) !== et) {
            Lg(r, !1);
            for (var _ = r.actualDuration, O = r.child; O !== null; )
              _ += O.actualDuration, O = O.sibling;
            r.actualDuration = _;
          }
          if (c !== null)
            c.flags |= Ua, c.subtreeFlags = H, c.deletions = null;
          else {
            Mi = F9, ya = null;
            return;
          }
        }
        var k = r.sibling;
        if (k !== null) {
          ya = k;
          return;
        }
        r = c, ya = r;
      } while (r !== null);
      Mi === Xc && (Mi = pb);
    }
    function O2(n, r, u) {
      var c = Ni(), p = wl.transition;
      try {
        wl.transition = null, rr(qr), kA(n, r, u, c);
      } finally {
        wl.transition = p, rr(c);
      }
      return null;
    }
    function kA(n, r, u, c) {
      do
        tf();
      while (Xd !== null);
      if (YA(), (jn & (yl | bs)) !== Ri)
        throw new Error("Should not already be working.");
      var p = n.finishedWork, x = n.finishedLanes;
      if (Xu(x), p === null)
        return nl(), null;
      if (x === He && m("root.finishedLanes should not be empty during a commit. This is a bug in React."), n.finishedWork = null, n.finishedLanes = He, p === n.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      n.callbackNode = null, n.callbackPriority = Nr;
      var _ = jt(p.lanes, p.childLanes);
      mv(n, _), n === wo && (wo = null, ya = null, Ei = He), ((p.subtreeFlags & eo) !== H || (p.flags & eo) !== H) && (M2 || (M2 = !0, ny(ro, function() {
        return tf(), null;
      })));
      var O = (p.subtreeFlags & (ed | vu | Ol | eo)) !== H, k = (p.flags & (ed | vu | Ol | eo)) !== H;
      if (O || k) {
        var V = wl.transition;
        wl.transition = null;
        var U = Ni();
        rr(qr);
        var ie = jn;
        jn |= bs, B9.current = null, kj(n, p), yC(), Wj(n, p, x), d6(), n.current = p, Fh(x), zj(p, n, x), gc(), Ho(), jn = ie, rr(U), wl.transition = V;
      } else
        n.current = p, yC();
      var re = M2;
      if (M2 ? (M2 = !1, Xd = n, d4 = x) : (dp = 0, Wg = null), _ = n.pendingLanes, _ === He && (fp = null), re || Ab(n.current, !1), tl(p.stateNode, c), Pn && n.memoizedUpdaters.clear(), dA(), qo(n, $r()), r !== null)
        for (var ye = n.onRecoverableError, Se = 0; Se < r.length; Se++) {
          var Ee = r[Se], lt = Ee.stack, Ut = Ee.digest;
          ye(Ee.value, {
            componentStack: lt,
            digest: Ut
          });
        }
      if (Yg) {
        Yg = !1;
        var Lt = $9;
        throw $9 = null, Lt;
      }
      return ii(d4, It) && n.tag !== Fd && tf(), _ = n.pendingLanes, ii(_, It) ? (ND(), n === z9 ? h4++ : (h4 = 0, z9 = n)) : h4 = 0, Ud(), nl(), null;
    }
    function tf() {
      if (Xd !== null) {
        var n = md(d4), r = Gh(al, n), u = wl.transition, c = Ni();
        try {
          return wl.transition = null, rr(r), IA();
        } finally {
          rr(c), wl.transition = u;
        }
      }
      return !1;
    }
    function LA(n) {
      W9.push(n), M2 || (M2 = !0, ny(ro, function() {
        return tf(), null;
      }));
    }
    function IA() {
      if (Xd === null)
        return !1;
      var n = Xd, r = d4;
      if (Xd = null, d4 = He, (jn & (yl | bs)) !== Ri)
        throw new Error("Cannot flush passive effects while already rendering.");
      q9 = !0, $g = !1, No(r);
      var u = jn;
      jn |= bs, eA(n.current), Kj(n, n.current);
      {
        var c = W9;
        W9 = [];
        for (var p = 0; p < c.length; p++) {
          var x = c[p];
          Zj(n, x);
        }
      }
      wc(), Ab(n.current, !0), jn = u, Ud(), $g ? n === Wg ? dp++ : (dp = 0, Wg = n) : dp = 0, q9 = !1, $g = !1, Qu(n);
      {
        var _ = n.current.stateNode;
        _.effectDuration = 0, _.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Ob(n) {
      return fp !== null && fp.has(n);
    }
    function HA(n) {
      fp === null ? fp = /* @__PURE__ */ new Set([n]) : fp.add(n);
    }
    function ZA(n) {
      Yg || (Yg = !0, $9 = n);
    }
    var PA = ZA;
    function Db(n, r, u) {
      var c = _2(u, r), p = MC(n, c, It), x = $d(n, p, It), _ = yo();
      x !== null && (Ks(x, It, _), qo(x, _));
    }
    function Br(n, r, u) {
      if (Dj(u), g4(!1), n.tag === T) {
        Db(n, n, u);
        return;
      }
      var c = null;
      for (c = r; c !== null; ) {
        if (c.tag === T) {
          Db(c, n, u);
          return;
        } else if (c.tag === R) {
          var p = c.type, x = c.stateNode;
          if (typeof p.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && !Ob(x)) {
            var _ = _2(u, n), O = x9(c, _, It), k = $d(c, O, It), V = yo();
            k !== null && (Ks(k, It, V), qo(k, V));
            return;
          }
        }
        c = c.return;
      }
      m(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, u);
    }
    function NA(n, r, u) {
      var c = n.pingCache;
      c !== null && c.delete(r);
      var p = yo();
      vd(n, u), qA(n), wo === n && ua(Ei, u) && (Mi === o4 || Mi === Bg && os(Ei) && $r() - Y9 < mb ? T2(n, He) : Ug = jt(Ug, u)), qo(n, p);
    }
    function jb(n, r) {
      r === Nr && (r = yA(n));
      var u = yo(), c = $o(n, r);
      c !== null && (Ks(c, r, u), qo(c, u));
    }
    function VA(n) {
      var r = n.memoizedState, u = Nr;
      r !== null && (u = r.retryLane), jb(n, u);
    }
    function BA(n, r) {
      var u = Nr, c;
      switch (n.tag) {
        case $:
          c = n.stateNode;
          var p = n.memoizedState;
          p !== null && (u = p.retryLane);
          break;
        case K:
          c = n.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      c !== null && c.delete(r), jb(n, u);
    }
    function FA(n) {
      return n < 120 ? 120 : n < 480 ? 480 : n < 1080 ? 1080 : n < 1920 ? 1920 : n < 3e3 ? 3e3 : n < 4320 ? 4320 : pA(n / 1960) * 1960;
    }
    function UA() {
      if (h4 > gA)
        throw h4 = 0, z9 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      dp > wA && (dp = 0, Wg = null, m("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function YA() {
      d1.flushLegacyContextWarning(), d1.flushPendingUnsafeLifecycleWarnings();
    }
    function Ab(n, r) {
      tr(n), Qg(n, Jl, sA), r && Qg(n, vc, cA), Qg(n, Jl, oA), r && Qg(n, vc, uA), va();
    }
    function Qg(n, r, u) {
      for (var c = n, p = null; c !== null; ) {
        var x = c.subtreeFlags & r;
        c !== p && c.child !== null && x !== H ? c = c.child : ((c.flags & r) !== H && u(c), c.sibling !== null ? c = c.sibling : c = p = c.return);
      }
    }
    var Xg = null;
    function kb(n) {
      {
        if ((jn & yl) !== Ri || !(n.mode & on))
          return;
        var r = n.tag;
        if (r !== D && r !== T && r !== R && r !== b && r !== G && r !== ce && r !== X)
          return;
        var u = en(n) || "ReactComponent";
        if (Xg !== null) {
          if (Xg.has(u))
            return;
          Xg.add(u);
        } else
          Xg = /* @__PURE__ */ new Set([u]);
        var c = Ai;
        try {
          tr(n), m("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          c ? tr(n) : va();
        }
      }
    }
    var J9;
    {
      var $A = null;
      J9 = function(n, r, u) {
        var c = Vb($A, r);
        try {
          return WC(n, r, u);
        } catch (x) {
          if (aD() || x !== null && typeof x == "object" && typeof x.then == "function")
            throw x;
          if (ig(), qS(), XC(n, r), Vb(r, c), r.mode & Nn && n9(r), hc(null, WC, null, n, r, u), q1()) {
            var p = Tl();
            typeof p == "object" && p !== null && p._suppressLogging && typeof x == "object" && x !== null && !x._suppressLogging && (x._suppressLogging = !0);
          }
          throw x;
        }
      };
    }
    var Lb = !1, ey;
    ey = /* @__PURE__ */ new Set();
    function WA(n) {
      if (As && !HD())
        switch (n.tag) {
          case b:
          case G:
          case X: {
            var r = ya && en(ya) || "Unknown", u = r;
            if (!ey.has(u)) {
              ey.add(u);
              var c = en(n) || "Unknown";
              m("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", c, r, r);
            }
            break;
          }
          case R: {
            Lb || (m("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Lb = !0);
            break;
          }
        }
    }
    function m4(n, r) {
      if (Pn) {
        var u = n.memoizedUpdaters;
        u.forEach(function(c) {
          c0(n, c, r);
        });
      }
    }
    var ty = {};
    function ny(n, r) {
      {
        var u = x1.current;
        return u !== null ? (u.push(r), ty) : Hi(n, r);
      }
    }
    function Ib(n) {
      if (n !== ty)
        return br(n);
    }
    function Hb() {
      return x1.current !== null;
    }
    function zA(n) {
      {
        if (n.mode & on) {
          if (!hb())
            return;
        } else if (!vA() || jn !== Ri || n.tag !== b && n.tag !== G && n.tag !== X)
          return;
        if (x1.current === null) {
          var r = Ai;
          try {
            tr(n), m(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, en(n));
          } finally {
            r ? tr(n) : va();
          }
        }
      }
    }
    function qA(n) {
      n.tag !== Fd && hb() && x1.current === null && m(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function g4(n) {
      yb = n;
    }
    var _s = null, hp = null, GA = function(n) {
      _s = n;
    };
    function vp(n) {
      {
        if (_s === null)
          return n;
        var r = _s(n);
        return r === void 0 ? n : r.current;
      }
    }
    function ry(n) {
      return vp(n);
    }
    function ay(n) {
      {
        if (_s === null)
          return n;
        var r = _s(n);
        if (r === void 0) {
          if (n != null && typeof n.render == "function") {
            var u = vp(n.render);
            if (n.render !== u) {
              var c = {
                $$typeof: ql,
                render: u
              };
              return n.displayName !== void 0 && (c.displayName = n.displayName), c;
            }
          }
          return n;
        }
        return r.current;
      }
    }
    function Zb(n, r) {
      {
        if (_s === null)
          return !1;
        var u = n.elementType, c = r.type, p = !1, x = typeof c == "object" && c !== null ? c.$$typeof : null;
        switch (n.tag) {
          case R: {
            typeof c == "function" && (p = !0);
            break;
          }
          case b: {
            (typeof c == "function" || x === Et) && (p = !0);
            break;
          }
          case G: {
            (x === ql || x === Et) && (p = !0);
            break;
          }
          case ce:
          case X: {
            (x === ft || x === Et) && (p = !0);
            break;
          }
          default:
            return !1;
        }
        if (p) {
          var _ = _s(u);
          if (_ !== void 0 && _ === _s(c))
            return !0;
        }
        return !1;
      }
    }
    function Pb(n) {
      {
        if (_s === null || typeof WeakSet != "function")
          return;
        hp === null && (hp = /* @__PURE__ */ new WeakSet()), hp.add(n);
      }
    }
    var KA = function(n, r) {
      {
        if (_s === null)
          return;
        var u = r.staleFamilies, c = r.updatedFamilies;
        tf(), ef(function() {
          iy(n.current, c, u);
        });
      }
    }, QA = function(n, r) {
      {
        if (n.context !== Wn)
          return;
        tf(), ef(function() {
          w4(r, n, null, null);
        });
      }
    };
    function iy(n, r, u) {
      {
        var c = n.alternate, p = n.child, x = n.sibling, _ = n.tag, O = n.type, k = null;
        switch (_) {
          case b:
          case X:
          case R:
            k = O;
            break;
          case G:
            k = O.render;
            break;
        }
        if (_s === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var V = !1, U = !1;
        if (k !== null) {
          var ie = _s(k);
          ie !== void 0 && (u.has(ie) ? U = !0 : r.has(ie) && (_ === R ? U = !0 : V = !0));
        }
        if (hp !== null && (hp.has(n) || c !== null && hp.has(c)) && (U = !0), U && (n._debugNeedsRemount = !0), U || V) {
          var re = $o(n, It);
          re !== null && Ti(re, n, It, fr);
        }
        p !== null && !U && iy(p, r, u), x !== null && iy(x, r, u);
      }
    }
    var XA = function(n, r) {
      {
        var u = /* @__PURE__ */ new Set(), c = new Set(r.map(function(p) {
          return p.current;
        }));
        return ly(n.current, c, u), u;
      }
    };
    function ly(n, r, u) {
      {
        var c = n.child, p = n.sibling, x = n.tag, _ = n.type, O = null;
        switch (x) {
          case b:
          case X:
          case R:
            O = _;
            break;
          case G:
            O = _.render;
            break;
        }
        var k = !1;
        O !== null && r.has(O) && (k = !0), k ? JA(n, u) : c !== null && ly(c, r, u), p !== null && ly(p, r, u);
      }
    }
    function JA(n, r) {
      {
        var u = ek(n, r);
        if (u)
          return;
        for (var c = n; ; ) {
          switch (c.tag) {
            case A:
              r.add(c.stateNode);
              return;
            case j:
              r.add(c.stateNode.containerInfo);
              return;
            case T:
              r.add(c.stateNode.containerInfo);
              return;
          }
          if (c.return === null)
            throw new Error("Expected to reach root first.");
          c = c.return;
        }
      }
    }
    function ek(n, r) {
      for (var u = n, c = !1; ; ) {
        if (u.tag === A)
          c = !0, r.add(u.stateNode);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === n)
          return c;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === n)
            return c;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !1;
    }
    var oy;
    {
      oy = !1;
      try {
        Object.preventExtensions({});
      } catch {
        oy = !0;
      }
    }
    function tk(n, r, u, c) {
      this.tag = n, this.key = u, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = r, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = c, this.flags = H, this.subtreeFlags = H, this.deletions = null, this.lanes = He, this.childLanes = He, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !oy && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var ju = function(n, r, u, c) {
      return new tk(n, r, u, c);
    };
    function uy(n) {
      var r = n.prototype;
      return !!(r && r.isReactComponent);
    }
    function nk(n) {
      return typeof n == "function" && !uy(n) && n.defaultProps === void 0;
    }
    function rk(n) {
      if (typeof n == "function")
        return uy(n) ? R : b;
      if (n != null) {
        var r = n.$$typeof;
        if (r === ql)
          return G;
        if (r === ft)
          return ce;
      }
      return D;
    }
    function D2(n, r) {
      var u = n.alternate;
      u === null ? (u = ju(n.tag, r, n.key, n.mode), u.elementType = n.elementType, u.type = n.type, u.stateNode = n.stateNode, u._debugSource = n._debugSource, u._debugOwner = n._debugOwner, u._debugHookTypes = n._debugHookTypes, u.alternate = n, n.alternate = u) : (u.pendingProps = r, u.type = n.type, u.flags = H, u.subtreeFlags = H, u.deletions = null, u.actualDuration = 0, u.actualStartTime = -1), u.flags = n.flags & Mr, u.childLanes = n.childLanes, u.lanes = n.lanes, u.child = n.child, u.memoizedProps = n.memoizedProps, u.memoizedState = n.memoizedState, u.updateQueue = n.updateQueue;
      var c = n.dependencies;
      switch (u.dependencies = c === null ? null : {
        lanes: c.lanes,
        firstContext: c.firstContext
      }, u.sibling = n.sibling, u.index = n.index, u.ref = n.ref, u.selfBaseDuration = n.selfBaseDuration, u.treeBaseDuration = n.treeBaseDuration, u._debugNeedsRemount = n._debugNeedsRemount, u.tag) {
        case D:
        case b:
        case X:
          u.type = vp(n.type);
          break;
        case R:
          u.type = ry(n.type);
          break;
        case G:
          u.type = ay(n.type);
          break;
      }
      return u;
    }
    function ak(n, r) {
      n.flags &= Mr | cr;
      var u = n.alternate;
      if (u === null)
        n.childLanes = He, n.lanes = r, n.child = null, n.subtreeFlags = H, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0;
      else {
        n.childLanes = u.childLanes, n.lanes = u.lanes, n.child = u.child, n.subtreeFlags = H, n.deletions = null, n.memoizedProps = u.memoizedProps, n.memoizedState = u.memoizedState, n.updateQueue = u.updateQueue, n.type = u.type;
        var c = u.dependencies;
        n.dependencies = c === null ? null : {
          lanes: c.lanes,
          firstContext: c.firstContext
        }, n.selfBaseDuration = u.selfBaseDuration, n.treeBaseDuration = u.treeBaseDuration;
      }
      return n;
    }
    function ik(n, r, u) {
      var c;
      return n === G3 ? (c = on, r === !0 && (c |= _r, c |= Zi)) : c = et, Pn && (c |= Nn), ju(T, null, null, c);
    }
    function sy(n, r, u, c, p, x) {
      var _ = D, O = n;
      if (typeof n == "function")
        uy(n) ? (_ = R, O = ry(O)) : O = vp(O);
      else if (typeof n == "string")
        _ = A;
      else
        e: switch (n) {
          case $i:
            return th(u.children, p, x, r);
          case Oo:
            _ = N, p |= _r, (p & on) !== et && (p |= Zi);
            break;
          case eu:
            return lk(u, p, x, r);
          case J:
            return ok(u, p, x, r);
          case $e:
            return uk(u, p, x, r);
          case hn:
            return Nb(u, p, x, r);
          case vn:
          case Bn:
          case Za:
          case Rr:
          case xn:
          default: {
            if (typeof n == "object" && n !== null)
              switch (n.$$typeof) {
                case Ds:
                  _ = Y;
                  break e;
                case tu:
                  _ = F;
                  break e;
                case ql:
                  _ = G, O = ay(O);
                  break e;
                case ft:
                  _ = ce;
                  break e;
                case Et:
                  _ = Ce, O = null;
                  break e;
              }
            var k = "";
            {
              (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var V = c ? en(c) : null;
              V && (k += `

Check the render method of \`` + V + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (n == null ? n : typeof n) + "." + k));
          }
        }
      var U = ju(_, u, r, p);
      return U.elementType = n, U.type = O, U.lanes = x, U._debugOwner = c, U;
    }
    function cy(n, r, u) {
      var c = null;
      c = n._owner;
      var p = n.type, x = n.key, _ = n.props, O = sy(p, x, _, c, r, u);
      return O._debugSource = n._source, O._debugOwner = n._owner, O;
    }
    function th(n, r, u, c) {
      var p = ju(P, n, c, r);
      return p.lanes = u, p;
    }
    function lk(n, r, u, c) {
      typeof n.id != "string" && m('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof n.id);
      var p = ju(z, n, c, r | Nn);
      return p.elementType = eu, p.lanes = u, p.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, p;
    }
    function ok(n, r, u, c) {
      var p = ju($, n, c, r);
      return p.elementType = J, p.lanes = u, p;
    }
    function uk(n, r, u, c) {
      var p = ju(K, n, c, r);
      return p.elementType = $e, p.lanes = u, p;
    }
    function Nb(n, r, u, c) {
      var p = ju(ue, n, c, r);
      p.elementType = hn, p.lanes = u;
      var x = {
        isHidden: !1
      };
      return p.stateNode = x, p;
    }
    function fy(n, r, u) {
      var c = ju(L, n, null, r);
      return c.lanes = u, c;
    }
    function sk() {
      var n = ju(A, null, null, et);
      return n.elementType = "DELETED", n;
    }
    function ck(n) {
      var r = ju(me, null, null, et);
      return r.stateNode = n, r;
    }
    function dy(n, r, u) {
      var c = n.children !== null ? n.children : [], p = ju(j, c, n.key, r);
      return p.lanes = u, p.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: n.implementation
      }, p;
    }
    function Vb(n, r) {
      return n === null && (n = ju(D, null, null, et)), n.tag = r.tag, n.key = r.key, n.elementType = r.elementType, n.type = r.type, n.stateNode = r.stateNode, n.return = r.return, n.child = r.child, n.sibling = r.sibling, n.index = r.index, n.ref = r.ref, n.pendingProps = r.pendingProps, n.memoizedProps = r.memoizedProps, n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.dependencies = r.dependencies, n.mode = r.mode, n.flags = r.flags, n.subtreeFlags = r.subtreeFlags, n.deletions = r.deletions, n.lanes = r.lanes, n.childLanes = r.childLanes, n.alternate = r.alternate, n.actualDuration = r.actualDuration, n.actualStartTime = r.actualStartTime, n.selfBaseDuration = r.selfBaseDuration, n.treeBaseDuration = r.treeBaseDuration, n._debugSource = r._debugSource, n._debugOwner = r._debugOwner, n._debugNeedsRemount = r._debugNeedsRemount, n._debugHookTypes = r._debugHookTypes, n;
    }
    function fk(n, r, u, c, p) {
      this.tag = r, this.containerInfo = n, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Rm, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Nr, this.eventTimes = Oc(He), this.expirationTimes = Oc(fr), this.pendingLanes = He, this.suspendedLanes = He, this.pingedLanes = He, this.expiredLanes = He, this.mutableReadLanes = He, this.finishedLanes = He, this.entangledLanes = He, this.entanglements = Oc(He), this.identifierPrefix = c, this.onRecoverableError = p, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var x = this.pendingUpdatersLaneMap = [], _ = 0; _ < zr; _++)
          x.push(/* @__PURE__ */ new Set());
      }
      switch (r) {
        case G3:
          this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
          break;
        case Fd:
          this._debugRootType = u ? "hydrate()" : "render()";
          break;
      }
    }
    function Bb(n, r, u, c, p, x, _, O, k, V) {
      var U = new fk(n, r, u, O, k), ie = ik(r, x);
      U.current = ie, ie.stateNode = U;
      {
        var re = {
          element: c,
          isDehydrated: u,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        ie.memoizedState = re;
      }
      return E7(ie), U;
    }
    var hy = "18.3.1";
    function dk(n, r, u) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return wr(c), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: To,
        key: c == null ? null : "" + c,
        children: n,
        containerInfo: r,
        implementation: u
      };
    }
    var vy, py;
    vy = !1, py = {};
    function Fb(n) {
      if (!n)
        return Wn;
      var r = Qi(n), u = GO(r);
      if (r.tag === R) {
        var c = r.type;
        if (y0(c))
          return mS(r, c, u);
      }
      return u;
    }
    function hk(n, r) {
      {
        var u = Qi(n);
        if (u === void 0) {
          if (typeof n.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var c = Object.keys(n).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + c);
        }
        var p = Vh(u);
        if (p === null)
          return null;
        if (p.mode & _r) {
          var x = en(u) || "Component";
          if (!py[x]) {
            py[x] = !0;
            var _ = Ai;
            try {
              tr(p), u.mode & _r ? m("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, x) : m("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, x);
            } finally {
              _ ? tr(_) : va();
            }
          }
        }
        return p.stateNode;
      }
    }
    function Ub(n, r, u, c, p, x, _, O) {
      var k = !1, V = null;
      return Bb(n, r, k, V, u, c, p, x, _);
    }
    function Yb(n, r, u, c, p, x, _, O, k, V) {
      var U = !0, ie = Bb(u, c, U, n, p, x, _, O, k);
      ie.context = Fb(null);
      var re = ie.current, ye = yo(), Se = Jd(re), Ee = Kc(ye, Se);
      return Ee.callback = r ?? null, $d(re, Ee, Se), xA(ie, Se, ye), ie;
    }
    function w4(n, r, u, c) {
      pc(r, n);
      var p = r.current, x = yo(), _ = Jd(p);
      es(_);
      var O = Fb(u);
      r.context === null ? r.context = O : r.pendingContext = O, As && Ai !== null && !vy && (vy = !0, m(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, en(Ai) || "Unknown"));
      var k = Kc(x, _);
      k.payload = {
        element: n
      }, c = c === void 0 ? null : c, c !== null && (typeof c != "function" && m("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c), k.callback = c);
      var V = $d(p, k, _);
      return V !== null && (Ti(V, p, _, x), cg(V, p, _)), _;
    }
    function Jg(n) {
      var r = n.current;
      if (!r.child)
        return null;
      switch (r.child.tag) {
        case A:
          return r.child.stateNode;
        default:
          return r.child.stateNode;
      }
    }
    function vk(n) {
      switch (n.tag) {
        case T: {
          var r = n.stateNode;
          if (cs(r)) {
            var u = kl(r);
            _A(r, u);
          }
          break;
        }
        case $: {
          ef(function() {
            var p = $o(n, It);
            if (p !== null) {
              var x = yo();
              Ti(p, n, It, x);
            }
          });
          var c = It;
          my(n, c);
          break;
        }
      }
    }
    function $b(n, r) {
      var u = n.memoizedState;
      u !== null && u.dehydrated !== null && (u.retryLane = zh(u.retryLane, r));
    }
    function my(n, r) {
      $b(n, r);
      var u = n.alternate;
      u && $b(u, r);
    }
    function pk(n) {
      if (n.tag === $) {
        var r = a0, u = $o(n, r);
        if (u !== null) {
          var c = yo();
          Ti(u, n, r, c);
        }
        my(n, r);
      }
    }
    function mk(n) {
      if (n.tag === $) {
        var r = Jd(n), u = $o(n, r);
        if (u !== null) {
          var c = yo();
          Ti(u, n, r, c);
        }
        my(n, r);
      }
    }
    function Wb(n) {
      var r = Us(n);
      return r === null ? null : r.stateNode;
    }
    var zb = function(n) {
      return null;
    };
    function gk(n) {
      return zb(n);
    }
    var qb = function(n) {
      return !1;
    };
    function wk(n) {
      return qb(n);
    }
    var Gb = null, Kb = null, Qb = null, Xb = null, Jb = null, e_ = null, t_ = null, n_ = null, r_ = null;
    {
      var a_ = function(n, r, u) {
        var c = r[u], p = ra(n) ? n.slice() : Gt({}, n);
        return u + 1 === r.length ? (ra(p) ? p.splice(c, 1) : delete p[c], p) : (p[c] = a_(n[c], r, u + 1), p);
      }, i_ = function(n, r) {
        return a_(n, r, 0);
      }, l_ = function(n, r, u, c) {
        var p = r[c], x = ra(n) ? n.slice() : Gt({}, n);
        if (c + 1 === r.length) {
          var _ = u[c];
          x[_] = x[p], ra(x) ? x.splice(p, 1) : delete x[p];
        } else
          x[p] = l_(
            // $FlowFixMe number or string is fine here
            n[p],
            r,
            u,
            c + 1
          );
        return x;
      }, o_ = function(n, r, u) {
        if (r.length !== u.length) {
          g("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var c = 0; c < u.length - 1; c++)
            if (r[c] !== u[c]) {
              g("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return l_(n, r, u, 0);
      }, u_ = function(n, r, u, c) {
        if (u >= r.length)
          return c;
        var p = r[u], x = ra(n) ? n.slice() : Gt({}, n);
        return x[p] = u_(n[p], r, u + 1, c), x;
      }, s_ = function(n, r, u) {
        return u_(n, r, 0, u);
      }, gy = function(n, r) {
        for (var u = n.memoizedState; u !== null && r > 0; )
          u = u.next, r--;
        return u;
      };
      Gb = function(n, r, u, c) {
        var p = gy(n, r);
        if (p !== null) {
          var x = s_(p.memoizedState, u, c);
          p.memoizedState = x, p.baseState = x, n.memoizedProps = Gt({}, n.memoizedProps);
          var _ = $o(n, It);
          _ !== null && Ti(_, n, It, fr);
        }
      }, Kb = function(n, r, u) {
        var c = gy(n, r);
        if (c !== null) {
          var p = i_(c.memoizedState, u);
          c.memoizedState = p, c.baseState = p, n.memoizedProps = Gt({}, n.memoizedProps);
          var x = $o(n, It);
          x !== null && Ti(x, n, It, fr);
        }
      }, Qb = function(n, r, u, c) {
        var p = gy(n, r);
        if (p !== null) {
          var x = o_(p.memoizedState, u, c);
          p.memoizedState = x, p.baseState = x, n.memoizedProps = Gt({}, n.memoizedProps);
          var _ = $o(n, It);
          _ !== null && Ti(_, n, It, fr);
        }
      }, Xb = function(n, r, u) {
        n.pendingProps = s_(n.memoizedProps, r, u), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = $o(n, It);
        c !== null && Ti(c, n, It, fr);
      }, Jb = function(n, r) {
        n.pendingProps = i_(n.memoizedProps, r), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var u = $o(n, It);
        u !== null && Ti(u, n, It, fr);
      }, e_ = function(n, r, u) {
        n.pendingProps = o_(n.memoizedProps, r, u), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = $o(n, It);
        c !== null && Ti(c, n, It, fr);
      }, t_ = function(n) {
        var r = $o(n, It);
        r !== null && Ti(r, n, It, fr);
      }, n_ = function(n) {
        zb = n;
      }, r_ = function(n) {
        qb = n;
      };
    }
    function yk(n) {
      var r = Vh(n);
      return r === null ? null : r.stateNode;
    }
    function xk(n) {
      return null;
    }
    function Sk() {
      return Ai;
    }
    function Ck(n) {
      var r = n.findFiberByHostInstance, u = a.ReactCurrentDispatcher;
      return rd({
        bundleType: n.bundleType,
        version: n.version,
        rendererPackageName: n.rendererPackageName,
        rendererConfig: n.rendererConfig,
        overrideHookState: Gb,
        overrideHookStateDeletePath: Kb,
        overrideHookStateRenamePath: Qb,
        overrideProps: Xb,
        overridePropsDeletePath: Jb,
        overridePropsRenamePath: e_,
        setErrorHandler: n_,
        setSuspenseHandler: r_,
        scheduleUpdate: t_,
        currentDispatcherRef: u,
        findHostInstanceByFiber: yk,
        findFiberByHostInstance: r || xk,
        // React Refresh
        findHostInstancesForRefresh: XA,
        scheduleRefresh: KA,
        scheduleRoot: QA,
        setRefreshHandler: GA,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: Sk,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: hy
      });
    }
    var c_ = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(n) {
      console.error(n);
    };
    function wy(n) {
      this._internalRoot = n;
    }
    e5.prototype.render = wy.prototype.render = function(n) {
      var r = this._internalRoot;
      if (r === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? m("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : t5(arguments[1]) ? m("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && m("You passed a second argument to root.render(...) but it only accepts one argument.");
        var u = r.containerInfo;
        if (u.nodeType !== aa) {
          var c = Wb(r.current);
          c && c.parentNode !== u && m("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      w4(n, r, null, null);
    }, e5.prototype.unmount = wy.prototype.unmount = function() {
      typeof arguments[0] == "function" && m("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var n = this._internalRoot;
      if (n !== null) {
        this._internalRoot = null;
        var r = n.containerInfo;
        bb() && m("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), ef(function() {
          w4(null, n, null, null);
        }), M(r);
      }
    };
    function bk(n, r) {
      if (!t5(n))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      f_(n);
      var u = !1, c = !1, p = "", x = c_;
      r != null && (r.hydrate ? g("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof r == "object" && r !== null && r.$$typeof === Mo && m(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (p = r.identifierPrefix), r.onRecoverableError !== void 0 && (x = r.onRecoverableError));
      var _ = Ub(n, G3, null, u, c, p, x);
      y(_.current, n);
      var O = n.nodeType === aa ? n.parentNode : n;
      return u2(O), new wy(_);
    }
    function e5(n) {
      this._internalRoot = n;
    }
    function _k(n) {
      n && fo(n);
    }
    e5.prototype.unstable_scheduleHydration = _k;
    function Rk(n, r, u) {
      if (!t5(n))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      f_(n), r === void 0 && m("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var c = u ?? null, p = u != null && u.hydratedSources || null, x = !1, _ = !1, O = "", k = c_;
      u != null && (u.unstable_strictMode === !0 && (x = !0), u.identifierPrefix !== void 0 && (O = u.identifierPrefix), u.onRecoverableError !== void 0 && (k = u.onRecoverableError));
      var V = Yb(r, null, n, G3, c, x, _, O, k);
      if (y(V.current, n), u2(n), p)
        for (var U = 0; U < p.length; U++) {
          var ie = p[U];
          DD(V, ie);
        }
      return new e5(V);
    }
    function t5(n) {
      return !!(n && (n.nodeType === Va || n.nodeType === Gl || n.nodeType === nc));
    }
    function y4(n) {
      return !!(n && (n.nodeType === Va || n.nodeType === Gl || n.nodeType === nc || n.nodeType === aa && n.nodeValue === " react-mount-point-unstable "));
    }
    function f_(n) {
      n.nodeType === Va && n.tagName && n.tagName.toUpperCase() === "BODY" && m("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), I(n) && (n._reactRootContainer ? m("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : m("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var Ek = a.ReactCurrentOwner, d_;
    d_ = function(n) {
      if (n._reactRootContainer && n.nodeType !== aa) {
        var r = Wb(n._reactRootContainer.current);
        r && r.parentNode !== n && m("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var u = !!n._reactRootContainer, c = yy(n), p = !!(c && q(c));
      p && !u && m("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), n.nodeType === Va && n.tagName && n.tagName.toUpperCase() === "BODY" && m("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function yy(n) {
      return n ? n.nodeType === Gl ? n.documentElement : n.firstChild : null;
    }
    function h_() {
    }
    function Mk(n, r, u, c, p) {
      if (p) {
        if (typeof c == "function") {
          var x = c;
          c = function() {
            var re = Jg(_);
            x.call(re);
          };
        }
        var _ = Yb(
          r,
          c,
          n,
          Fd,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          h_
        );
        n._reactRootContainer = _, y(_.current, n);
        var O = n.nodeType === aa ? n.parentNode : n;
        return u2(O), ef(), _;
      } else {
        for (var k; k = n.lastChild; )
          n.removeChild(k);
        if (typeof c == "function") {
          var V = c;
          c = function() {
            var re = Jg(U);
            V.call(re);
          };
        }
        var U = Ub(
          n,
          Fd,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          h_
        );
        n._reactRootContainer = U, y(U.current, n);
        var ie = n.nodeType === aa ? n.parentNode : n;
        return u2(ie), ef(function() {
          w4(r, U, u, c);
        }), U;
      }
    }
    function Tk(n, r) {
      n !== null && typeof n != "function" && m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, n);
    }
    function n5(n, r, u, c, p) {
      d_(u), Tk(p === void 0 ? null : p, "render");
      var x = u._reactRootContainer, _;
      if (!x)
        _ = Mk(u, r, n, p, c);
      else {
        if (_ = x, typeof p == "function") {
          var O = p;
          p = function() {
            var k = Jg(_);
            O.call(k);
          };
        }
        w4(r, _, n, p);
      }
      return Jg(_);
    }
    var v_ = !1;
    function Ok(n) {
      {
        v_ || (v_ = !0, m("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var r = Ek.current;
        if (r !== null && r.stateNode !== null) {
          var u = r.stateNode._warnedAboutRefsInRender;
          u || m("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Hn(r.type) || "A component"), r.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return n == null ? null : n.nodeType === Va ? n : hk(n, "findDOMNode");
    }
    function Dk(n, r, u) {
      if (m("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !y4(r))
        throw new Error("Target container is not a DOM element.");
      {
        var c = I(r) && r._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return n5(null, n, r, !0, u);
    }
    function jk(n, r, u) {
      if (m("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !y4(r))
        throw new Error("Target container is not a DOM element.");
      {
        var c = I(r) && r._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return n5(null, n, r, !1, u);
    }
    function Ak(n, r, u, c) {
      if (m("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !y4(u))
        throw new Error("Target container is not a DOM element.");
      if (n == null || !Xi(n))
        throw new Error("parentComponent must be a valid React Component");
      return n5(n, r, u, !1, c);
    }
    var p_ = !1;
    function kk(n) {
      if (p_ || (p_ = !0, m("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !y4(n))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var r = I(n) && n._reactRootContainer === void 0;
        r && m("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (n._reactRootContainer) {
        {
          var u = yy(n), c = u && !q(u);
          c && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return ef(function() {
          n5(null, null, n, !1, function() {
            n._reactRootContainer = null, M(n);
          });
        }), !0;
      } else {
        {
          var p = yy(n), x = !!(p && q(p)), _ = n.nodeType === Va && y4(n.parentNode) && !!n.parentNode._reactRootContainer;
          x && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", _ ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    em(vk), Or(pk), dt(mk), Ac(Ni), nm(gv), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && m("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), fv(a6), Y1(K9, RA, ef);
    function Lk(n, r) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!t5(r))
        throw new Error("Target container is not a DOM element.");
      return dk(n, r, null, u);
    }
    function Ik(n, r, u, c) {
      return Ak(n, r, u, c);
    }
    var xy = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [q, te, se, hr, Wu, K9]
    };
    function Hk(n, r) {
      return xy.usingClientEntryPoint || m('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), bk(n, r);
    }
    function Zk(n, r, u) {
      return xy.usingClientEntryPoint || m('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), Rk(n, r, u);
    }
    function Pk(n) {
      return bb() && m("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), ef(n);
    }
    var Nk = Ck({
      findFiberByHostInstance: B,
      bundleType: 1,
      version: hy,
      rendererPackageName: "react-dom"
    });
    if (!Nk && Ot && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var m_ = window.location.protocol;
      /^(https?|file):$/.test(m_) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (m_ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Ko.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = xy, Ko.createPortal = Lk, Ko.createRoot = Hk, Ko.findDOMNode = Ok, Ko.flushSync = Pk, Ko.hydrate = Dk, Ko.hydrateRoot = Zk, Ko.render = jk, Ko.unmountComponentAtNode = kk, Ko.unstable_batchedUpdates = K9, Ko.unstable_renderSubtreeIntoContainer = Ik, Ko.version = hy, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ko;
}
function rM() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(rM);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (rM(), t8.exports = JH()) : t8.exports = eZ();
var _5 = t8.exports, tZ = "div";
function B_(e, t) {
  const a = setTimeout(t, e);
  return () => clearTimeout(a);
}
function nZ(e) {
  let t = requestAnimationFrame(() => {
    t = requestAnimationFrame(e);
  });
  return () => cancelAnimationFrame(t);
}
function F_(...e) {
  return e.join(", ").split(", ").reduce((t, a) => {
    const l = a.endsWith("ms") ? 1 : 1e3, h = parseFloat(a || "0s") * l;
    return h > t ? h : t;
  }, 0);
}
function z4(e, t, a) {
  return !a && t !== !1 && (!e || !!t);
}
var K5 = Le(function(t) {
  var a = t, { store: l, alwaysVisible: h } = a, g = Fe(a, ["store", "alwaysVisible"]);
  const m = nx();
  l = l || m, Ht(
    l,
    process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component."
  );
  const S = Pt(null), b = Ia(g.id), [R, D] = Qt(null), T = l.useState("open"), j = l.useState("mounted"), A = l.useState("animated"), L = l.useState("contentElement"), P = ja(l.disclosure, "contentElement");
  kn(() => {
    S.current && (l == null || l.setContentElement(S.current));
  }, [l]), kn(() => {
    let G;
    return l == null || l.setState("animated", (z) => (G = z, !0)), () => {
      G !== void 0 && (l == null || l.setState("animated", G));
    };
  }, [l]), kn(() => {
    if (A) {
      if (!(L != null && L.isConnected)) {
        D(null);
        return;
      }
      return nZ(() => {
        D(T ? "enter" : j ? "leave" : null);
      });
    }
  }, [A, L, T, j]), kn(() => {
    if (!l || !A)
      return;
    const G = () => l == null ? void 0 : l.setState("animating", !1), z = () => _5.flushSync(G);
    if (!R || !L) {
      G();
      return;
    }
    if (R === "leave" && T || R === "enter" && !T)
      return;
    if (typeof A == "number")
      return B_(A, z);
    const {
      transitionDuration: $,
      animationDuration: ce,
      transitionDelay: X,
      animationDelay: Ce
    } = getComputedStyle(L), {
      transitionDuration: ae = "0",
      animationDuration: me = "0",
      transitionDelay: K = "0",
      animationDelay: we = "0"
    } = P ? getComputedStyle(P) : {}, ue = F_(
      X,
      Ce,
      K,
      we
    ), ge = F_(
      $,
      ce,
      ae,
      me
    ), Te = ue + ge;
    if (!Te) {
      R === "enter" && l.setState("animated", !1), G();
      return;
    }
    const be = 1e3 / 60, Ue = Math.max(Te - be, 0);
    return B_(Ue, z);
  }, [l, A, L, P, T, R]), g = Vn(
    g,
    (G) => /* @__PURE__ */ f.jsx(rx, { value: l, children: G }),
    [l]
  );
  const N = z4(j, g.hidden, h), F = g.style, Y = Ur(() => N ? Oe(Q({}, F), { display: "none" }) : F, [N, F]);
  return g = Oe(Q({
    id: b,
    "data-open": T || void 0,
    "data-enter": R === "enter" || void 0,
    "data-leave": R === "leave" || void 0,
    hidden: N
  }, g), {
    ref: Ln(b ? l.setContentElement : null, S, g.ref),
    style: Y
  }), La(g);
}), rZ = De(function(t) {
  const a = K5(t);
  return ke(tZ, a);
}), aZ = De(function(t) {
  var a = t, {
    unmountOnHide: l
  } = a, h = Fe(a, [
    "unmountOnHide"
  ]);
  const g = nx(), m = h.store || g;
  return ja(
    m,
    (b) => !l || (b == null ? void 0 : b.mounted)
  ) === !1 ? null : /* @__PURE__ */ f.jsx(rZ, Q({}, h));
});
function aM(e = {}) {
  return GE(e);
}
function iM(e, t, a) {
  return KE(e, t, a);
}
function q4(e = {}) {
  const [t, a] = Cl(aM, e);
  return iM(t, a, e);
}
function lM(e, ...t) {
  if (!e)
    return !1;
  const a = e.getAttribute("data-backdrop");
  return a == null ? !1 : a === "" || a === "true" || !t.length ? !0 : t.some((l) => a === l);
}
var Oy = /* @__PURE__ */ new WeakMap();
function G4(e, t, a) {
  Oy.has(e) || Oy.set(e, /* @__PURE__ */ new Map());
  const l = Oy.get(e), h = l.get(t);
  if (!h)
    return l.set(t, a()), () => {
      var S;
      (S = l.get(t)) == null || S(), l.delete(t);
    };
  const g = a(), m = () => {
    g(), h(), l.delete(t);
  };
  return l.set(t, m), () => {
    l.get(t) === m && (g(), l.set(t, h));
  };
}
function ax(e, t, a) {
  return G4(e, t, () => {
    const h = e.getAttribute(t);
    return e.setAttribute(t, a), () => {
      h == null ? e.removeAttribute(t) : e.setAttribute(t, h);
    };
  });
}
function N2(e, t, a) {
  return G4(e, t, () => {
    const h = t in e, g = e[t];
    return e[t] = a, () => {
      h ? e[t] = g : delete e[t];
    };
  });
}
function n8(e, t) {
  return e ? G4(e, "style", () => {
    const l = e.style.cssText;
    return Object.assign(e.style, t), () => {
      e.style.cssText = l;
    };
  }) : () => {
  };
}
function iZ(e, t, a) {
  return e ? G4(e, t, () => {
    const h = e.style.getPropertyValue(t);
    return e.style.setProperty(t, a), () => {
      h ? e.style.setProperty(t, h) : e.style.removeProperty(t);
    };
  }) : () => {
  };
}
var lZ = ["SCRIPT", "STYLE"];
function r8(e) {
  return `__ariakit-dialog-snapshot-${e}`;
}
function oZ(e, t) {
  const a = Qr(t), l = r8(e);
  if (!a.body[l])
    return !0;
  do {
    if (t === a.body)
      return !1;
    if (t[l])
      return !0;
    if (!t.parentElement)
      return !1;
    t = t.parentElement;
  } while (!0);
}
function uZ(e, t, a) {
  return lZ.includes(t.tagName) || !oZ(e, t) ? !1 : !a.some(
    (l) => l && ha(t, l)
  );
}
function ix(e, t, a, l) {
  for (let h of t) {
    if (!(h != null && h.isConnected))
      continue;
    const g = t.some((b) => !b || b === h ? !1 : b.contains(h)), m = Qr(h), S = h;
    for (; h.parentElement && h !== m.body; ) {
      if (l == null || l(h.parentElement, S), !g)
        for (const b of h.parentElement.children)
          uZ(e, b, t) && a(b, S);
      h = h.parentElement;
    }
  }
}
function sZ(e, t) {
  const { body: a } = Qr(t[0]), l = [];
  return ix(e, t, (g) => {
    l.push(N2(g, r8(e), !0));
  }), _o(
    N2(a, r8(e), !0),
    () => l.forEach((g) => g())
  );
}
function Dp(e = "", t = !1) {
  return `__ariakit-dialog-${t ? "ancestor" : "outside"}${e ? `-${e}` : ""}`;
}
function cZ(e, t = "") {
  return _o(
    N2(e, Dp(), !0),
    N2(e, Dp(t), !0)
  );
}
function oM(e, t = "") {
  return _o(
    N2(e, Dp("", !0), !0),
    N2(e, Dp(t, !0), !0)
  );
}
function lx(e, t) {
  const a = Dp(t, !0);
  if (e[a])
    return !0;
  const l = Dp(t);
  do {
    if (e[l])
      return !0;
    if (!e.parentElement)
      return !1;
    e = e.parentElement;
  } while (!0);
}
function U_(e, t) {
  const a = [], l = t.map((g) => g == null ? void 0 : g.id);
  return ix(
    e,
    t,
    (g) => {
      lM(g, ...l) || a.unshift(cZ(g, e));
    },
    (g, m) => {
      m.hasAttribute("data-dialog") && m.id !== e || a.unshift(oM(g, e));
    }
  ), () => {
    a.forEach((g) => g());
  };
}
var fZ = "div", dZ = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
Le(
  function(t) {
    return t;
  }
);
var I4 = De(
  // @ts-expect-error
  function(t) {
    return ke(fZ, t);
  }
);
Object.assign(
  I4,
  dZ.reduce((e, t) => (e[t] = De(function(l) {
    return ke(t, l);
  }), e), {})
);
function hZ({
  store: e,
  backdrop: t,
  alwaysVisible: a,
  hidden: l
}) {
  const h = Pt(null), g = z5({ disclosure: e }), m = e.useState("contentElement");
  kn(() => {
    const R = h.current, D = m;
    R && D && (R.style.zIndex = getComputedStyle(D).zIndex);
  }, [m]), kn(() => {
    const R = m == null ? void 0 : m.id;
    if (!R)
      return;
    const D = h.current;
    if (D)
      return oM(D, R);
  }, [m]);
  const S = K5({
    ref: h,
    store: g,
    role: "presentation",
    "data-backdrop": (m == null ? void 0 : m.id) || "",
    alwaysVisible: a,
    hidden: l ?? void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!t)
    return null;
  if (aE(t))
    return /* @__PURE__ */ f.jsx(I4, Oe(Q({}, S), { render: t }));
  const b = typeof t != "boolean" ? t : "div";
  return /* @__PURE__ */ f.jsx(I4, Oe(Q({}, S), { render: /* @__PURE__ */ f.jsx(b, {}) }));
}
var Y_ = ka({});
function vZ(e) {
  const t = Ui(Y_), [a, l] = Qt([]), h = Ir(
    (S) => {
      var b;
      return l((R) => [...R, S]), _o((b = t.add) == null ? void 0 : b.call(t, S), () => {
        l((R) => R.filter((D) => D !== S));
      });
    },
    [t]
  );
  kn(() => xa(e, ["open", "contentElement"], (S) => {
    var b;
    if (S.open && S.contentElement)
      return (b = t.add) == null ? void 0 : b.call(t, e);
  }), [e, t]);
  const g = Ur(() => ({ store: e, add: h }), [e, h]);
  return { wrapElement: Ir(
    (S) => /* @__PURE__ */ f.jsx(Y_.Provider, { value: g, children: S }),
    [g]
  ), nestedDialogs: a };
}
function pZ(e) {
  const t = Pt();
  return gt(() => {
    if (!e) {
      t.current = null;
      return;
    }
    return Fi("mousedown", (l) => {
      t.current = l.target;
    }, !0);
  }, [e]), t;
}
function mZ(e) {
  return e.tagName === "HTML" ? !0 : ha(Qr(e).body, e);
}
function gZ(e, t) {
  if (!e)
    return !1;
  if (ha(e, t))
    return !0;
  const a = t.getAttribute("aria-activedescendant");
  if (a) {
    const l = Qr(e).getElementById(a);
    if (l)
      return ha(e, l);
  }
  return !1;
}
function wZ(e, t) {
  if (!("clientY" in e))
    return !1;
  const a = t.getBoundingClientRect();
  return a.width === 0 || a.height === 0 ? !1 : a.top <= e.clientY && e.clientY <= a.top + a.height && a.left <= e.clientX && e.clientX <= a.left + a.width;
}
function Dy({
  store: e,
  type: t,
  listener: a,
  capture: l,
  domReady: h
}) {
  const g = nt(a), m = e.useState("open"), S = Pt(!1);
  kn(() => {
    if (!m || !h)
      return;
    const { contentElement: b } = e.getState();
    if (!b)
      return;
    const R = () => {
      S.current = !0;
    };
    return b.addEventListener("focusin", R, !0), () => b.removeEventListener("focusin", R, !0);
  }, [e, m, h]), gt(() => m ? Fi(t, (R) => {
    const { contentElement: D, disclosureElement: T } = e.getState(), j = R.target;
    !D || !j || !mZ(j) || ha(D, j) || gZ(T, j) || j.hasAttribute("data-focus-trap") || wZ(R, D) || S.current && !lx(j, D.id) || g(R);
  }, l) : void 0, [m, l]);
}
function jy(e, t) {
  return typeof e == "function" ? e(t) : !!e;
}
function yZ(e, t, a) {
  const l = e.useState("open"), h = pZ(l), g = { store: e, domReady: a, capture: !0 };
  Dy(Oe(Q({}, g), {
    type: "click",
    listener: (m) => {
      const { contentElement: S } = e.getState(), b = h.current;
      b && vE(b) && lx(b, S == null ? void 0 : S.id) && jy(t, m) && e.hide();
    }
  })), Dy(Oe(Q({}, g), {
    type: "focusin",
    listener: (m) => {
      const { contentElement: S } = e.getState();
      S && m.target !== Qr(S) && jy(t, m) && e.hide();
    }
  })), Dy(Oe(Q({}, g), {
    type: "contextmenu",
    listener: (m) => {
      jy(t, m) && e.hide();
    }
  }));
}
function xZ(e, t) {
  const l = Qr(e).createElement("button");
  return l.type = "button", l.tabIndex = -1, l.textContent = "Dismiss popup", Object.assign(l.style, {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }), l.addEventListener("click", t), e.prepend(l), () => {
    l.removeEventListener("click", t), l.remove();
  };
}
function SZ(e) {
  return ax(e, "aria-hidden", "true");
}
function uM() {
  return "inert" in HTMLElement.prototype;
}
function sM(e, t) {
  if (!("style" in e))
    return M4;
  if (uM())
    return N2(e, "inert", !0);
  const l = Ip(e, !0).map((h) => {
    if (t != null && t.some((m) => m && ha(m, h)))
      return M4;
    const g = G4(h, "focus", () => (h.focus = M4, () => {
      delete h.focus;
    }));
    return _o(ax(h, "tabindex", "-1"), g);
  });
  return _o(
    ...l,
    SZ(e),
    n8(e, {
      pointerEvents: "none",
      userSelect: "none",
      cursor: "default"
    })
  );
}
function CZ(e, t) {
  const a = [], l = t.map((g) => g == null ? void 0 : g.id);
  return ix(
    e,
    t,
    (g) => {
      lM(g, ...l) || a.unshift(sM(g, t));
    },
    (g) => {
      g.hasAttribute("role") && (t.some((m) => m && ha(m, g)) || a.unshift(ax(g, "role", "none")));
    }
  ), () => {
    a.forEach((g) => g());
  };
}
function bZ({
  attribute: e,
  contentId: t,
  contentElement: a,
  enabled: l
}) {
  const [h, g] = Z5(), m = Ir(() => {
    if (!l || !a)
      return !1;
    const { body: S } = Qr(a), b = S.getAttribute(e);
    return !b || b === t;
  }, [h, l, a, e, t]);
  return gt(() => {
    if (!l || !t || !a)
      return;
    const { body: S } = Qr(a);
    if (m())
      return S.setAttribute(e, t), () => S.removeAttribute(e);
    const b = new MutationObserver(() => _5.flushSync(g));
    return b.observe(S, { attributeFilter: [e] }), () => b.disconnect();
  }, [h, l, t, a, m, e]), m;
}
function _Z(e) {
  const t = e.getBoundingClientRect().left;
  return Math.round(t) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function RZ(e, t, a) {
  const l = bZ({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement: e,
    contentId: t,
    enabled: a
  });
  gt(() => {
    if (!l() || !e)
      return;
    const h = Qr(e), g = hE(e), { documentElement: m, body: S } = h, b = m.style.getPropertyValue("--scrollbar-width"), R = b ? parseInt(b) : g.innerWidth - m.clientWidth, D = () => iZ(
      m,
      "--scrollbar-width",
      `${R}px`
    ), T = _Z(m), j = () => n8(S, {
      overflow: "hidden",
      [T]: `${R}px`
    }), A = () => {
      var P, N;
      const { scrollX: F, scrollY: Y, visualViewport: G } = g, z = (P = G == null ? void 0 : G.offsetLeft) != null ? P : 0, $ = (N = G == null ? void 0 : G.offsetTop) != null ? N : 0, ce = n8(S, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(Y - Math.floor($))}px`,
        left: `${-(F - Math.floor(z))}px`,
        right: "0",
        [T]: `${R}px`
      });
      return () => {
        ce(), process.env.NODE_ENV !== "test" && g.scrollTo(F, Y);
      };
    }, L = I8() && !vL();
    return _o(
      D(),
      L ? A() : j()
    );
  }, [l, e]);
}
var EZ = "div", cM = Le(function(t) {
  var a = t, { autoFocusOnShow: l = !0 } = a, h = Fe(a, ["autoFocusOnShow"]);
  return h = Vn(
    h,
    (g) => /* @__PURE__ */ f.jsx(DE.Provider, { value: l, children: g }),
    [l]
  ), h;
});
De(function(t) {
  const a = cM(t);
  return ke(EZ, a);
});
var a8 = ka(0);
function fM({ level: e, children: t }) {
  const a = Ui(a8), l = Math.max(
    Math.min(e || a + 1, 6),
    1
  );
  return /* @__PURE__ */ f.jsx(a8.Provider, { value: l, children: t });
}
var i8 = ka(null), MZ = "div";
function TZ(e) {
  return Qr(e).body;
}
function OZ(e, t) {
  return t ? typeof t == "function" ? t(e) : t : Qr(e).createElement("div");
}
function DZ(e = "id") {
  return `${e ? `${e}-` : ""}${Math.random().toString(36).substr(2, 6)}`;
}
function nh(e) {
  queueMicrotask(() => {
    e == null || e.focus();
  });
}
var dM = Le(function(t) {
  var a = t, {
    preserveTabOrder: l,
    preserveTabOrderAnchor: h,
    portalElement: g,
    portalRef: m,
    portal: S = !0
  } = a, b = Fe(a, [
    "preserveTabOrder",
    "preserveTabOrderAnchor",
    "portalElement",
    "portalRef",
    "portal"
  ]);
  const R = Pt(null), D = Ln(R, b.ref), T = Ui(i8), [j, A] = Qt(null), [L, P] = Qt(
    null
  ), N = Pt(null), F = Pt(null), Y = Pt(null), G = Pt(null);
  return kn(() => {
    const z = R.current;
    if (!z || !S) {
      A(null);
      return;
    }
    const $ = OZ(z, g);
    if (!$) {
      A(null);
      return;
    }
    const ce = $.isConnected;
    if (ce || (T || TZ(z)).appendChild($), $.id || ($.id = z.id ? `portal/${z.id}` : DZ()), A($), zy(m, $), !ce)
      return () => {
        $.remove(), zy(m, null);
      };
  }, [S, g, T, m]), kn(() => {
    if (!S || !l || !h)
      return;
    const $ = Qr(h).createElement("span");
    return $.style.position = "fixed", h.insertAdjacentElement("afterend", $), P($), () => {
      $.remove(), P(null);
    };
  }, [S, l, h]), gt(() => {
    if (!j || !l)
      return;
    let z = 0;
    const $ = (ce) => {
      if (!ah(ce))
        return;
      const X = ce.type === "focusin";
      if (cancelAnimationFrame(z), X)
        return b5(j);
      z = requestAnimationFrame(() => {
        xp(j, !0);
      });
    };
    return j.addEventListener("focusin", $, !0), j.addEventListener("focusout", $, !0), () => {
      cancelAnimationFrame(z), j.removeEventListener("focusin", $, !0), j.removeEventListener("focusout", $, !0);
    };
  }, [j, l]), b = Vn(
    b,
    (z) => {
      if (z = // While the portal node is not in the DOM, we need to pass the
      // current context to the portal context, otherwise it's going to
      // reset to the body element on nested portals.
      /* @__PURE__ */ f.jsx(i8.Provider, { value: j || T, children: z }), !S)
        return z;
      if (!j)
        return /* @__PURE__ */ f.jsx(
          "span",
          {
            ref: D,
            id: b.id,
            style: { position: "fixed" },
            hidden: !0
          }
        );
      z = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        l && j && /* @__PURE__ */ f.jsx(
          Sp,
          {
            ref: F,
            className: "__focus-trap-inner-before",
            onFocus: (ce) => {
              ah(ce, j) ? nh(_y()) : nh(N.current);
            }
          }
        ),
        z,
        l && j && /* @__PURE__ */ f.jsx(
          Sp,
          {
            ref: Y,
            className: "__focus-trap-inner-after",
            onFocus: (ce) => {
              ah(ce, j) ? nh(T_()) : nh(G.current);
            }
          }
        )
      ] }), j && (z = _5.createPortal(z, j));
      let $ = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        l && j && /* @__PURE__ */ f.jsx(
          Sp,
          {
            ref: N,
            className: "__focus-trap-outer-before",
            onFocus: (ce) => {
              !(ce.relatedTarget === G.current) && ah(ce, j) ? nh(F.current) : nh(T_());
            }
          }
        ),
        l && // We're using position: fixed here so that the browser doesn't
        // add margin to the element when setting gap on a parent element.
        /* @__PURE__ */ f.jsx("span", { "aria-owns": j == null ? void 0 : j.id, style: { position: "fixed" } }),
        l && j && /* @__PURE__ */ f.jsx(
          Sp,
          {
            ref: G,
            className: "__focus-trap-outer-after",
            onFocus: (ce) => {
              if (ah(ce, j))
                nh(Y.current);
              else {
                const X = _y();
                if (X === F.current) {
                  requestAnimationFrame(() => {
                    var Ce;
                    return (Ce = _y()) == null ? void 0 : Ce.focus();
                  });
                  return;
                }
                nh(X);
              }
            }
          }
        )
      ] });
      return L && l && ($ = _5.createPortal(
        $,
        L
      )), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        $,
        z
      ] });
    },
    [j, T, S, b.id, l, L]
  ), b = Oe(Q({}, b), {
    ref: D
  }), b;
}), jZ = De(function(t) {
  const a = dM(t);
  return ke(MZ, a);
}), AZ = "div", $_ = H8();
function kZ(e) {
  const t = mf();
  return !t || e && ha(e, t) ? !1 : !!j0(t);
}
function W_(e, t = !1) {
  if (!e)
    return null;
  const a = "current" in e ? e.current : e;
  return a ? t ? j0(a) ? a : null : a : null;
}
var hM = Le(function(t) {
  var a = t, {
    store: l,
    open: h,
    onClose: g,
    focusable: m = !0,
    modal: S = !0,
    portal: b = !!S,
    backdrop: R = !!S,
    hideOnEscape: D = !0,
    hideOnInteractOutside: T = !0,
    getPersistentElements: j,
    preventBodyScroll: A = !!S,
    autoFocusOnShow: L = !0,
    autoFocusOnHide: P = !0,
    initialFocus: N,
    finalFocus: F,
    unmountOnHide: Y,
    unstable_treeSnapshotKey: G
  } = a, z = Fe(a, [
    "store",
    "open",
    "onClose",
    "focusable",
    "modal",
    "portal",
    "backdrop",
    "hideOnEscape",
    "hideOnInteractOutside",
    "getPersistentElements",
    "preventBodyScroll",
    "autoFocusOnShow",
    "autoFocusOnHide",
    "initialFocus",
    "finalFocus",
    "unmountOnHide",
    "unstable_treeSnapshotKey"
  ]);
  const $ = G5(), ce = Pt(null), X = q4({
    store: l || $,
    open: h,
    setOpen(xt) {
      if (xt)
        return;
      const ln = ce.current;
      if (!ln)
        return;
      const dn = new Event("close", { bubbles: !1, cancelable: !0 });
      g && ln.addEventListener("close", g, { once: !0 }), ln.dispatchEvent(dn), dn.defaultPrevented && X.setOpen(!0);
    }
  }), { portalRef: Ce, domReady: ae } = V8(b, z.portalRef), me = z.preserveTabOrder, K = X.useState(
    (xt) => me && !S && xt.mounted
  ), we = Ia(z.id), ue = X.useState("open"), ge = X.useState("mounted"), Te = X.useState("contentElement"), be = z4(ge, z.hidden, z.alwaysVisible);
  RZ(Te, we, A && !be), yZ(X, T, ae);
  const { wrapElement: Ue, nestedDialogs: le } = vZ(X);
  z = Vn(z, Ue, [Ue]), kn(() => {
    if (!ue)
      return;
    const xt = ce.current, ln = mf(xt, !0);
    ln && ln.tagName !== "BODY" && (xt && ha(xt, ln) || X.setDisclosureElement(ln));
  }, [X, ue]), $_ && gt(() => {
    if (!ge)
      return;
    const { disclosureElement: xt } = X.getState();
    if (!xt || !k0(xt))
      return;
    const ln = () => {
      let dn = !1;
      const Vt = () => {
        dn = !0;
      }, Rn = { capture: !0, once: !0 };
      xt.addEventListener("focusin", Vt, Rn), H2(xt, "mouseup", () => {
        xt.removeEventListener("focusin", Vt, !0), !dn && jE(xt);
      });
    };
    return xt.addEventListener("mousedown", ln), () => {
      xt.removeEventListener("mousedown", ln);
    };
  }, [X, ge]), gt(() => {
    if (!S || !ge || !ae)
      return;
    const xt = ce.current;
    if (!(!xt || xt.querySelector("[data-dialog-dismiss]")))
      return xZ(xt, X.hide);
  }, [X, S, ge, ae]), kn(() => {
    if (!uM() || ue || !ge || !ae)
      return;
    const xt = ce.current;
    if (xt)
      return sM(xt);
  }, [ue, ge, ae]);
  const _e = ue && ae;
  kn(() => {
    if (!we || !_e)
      return;
    const xt = ce.current;
    return sZ(we, [xt]);
  }, [we, _e, G]);
  const Pe = nt(j);
  kn(() => {
    if (!we || !_e)
      return;
    const { disclosureElement: xt } = X.getState(), ln = ce.current, dn = Pe() || [], Vt = [
      ln,
      ...dn,
      ...le.map((Rn) => Rn.getState().contentElement)
    ];
    return S ? _o(
      U_(we, Vt),
      CZ(we, Vt)
    ) : U_(we, [xt, ...Vt]);
  }, [
    we,
    X,
    _e,
    Pe,
    le,
    S,
    G
  ]);
  const mt = !!L, Ze = Jn(L), [Nt, kt] = Qt(!1);
  gt(() => {
    if (!ue || !mt || !ae || !(Te != null && Te.isConnected))
      return;
    const xt = W_(N, !0) || // If no initial focus is specified, we try to focus the first element
    // with the autofocus attribute. If it's an Ariakit component, the
    // Focusable component will consume the autoFocus prop and add the
    // data-autofocus attribute to the element instead.
    Te.querySelector(
      "[data-autofocus=true],[autofocus]"
    ) || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog receives
    // focus.
    B5(Te, !0, b && K) || // Finally, we fallback to the dialog element itself.
    Te, ln = j0(xt);
    Ze(ln ? xt : null) && (kt(!0), queueMicrotask(() => {
      xt.focus(), $_ && xt.scrollIntoView({ block: "nearest", inline: "nearest" });
    }));
  }, [
    ue,
    mt,
    ae,
    Te,
    N,
    b,
    K,
    Ze
  ]);
  const Qe = !!P, rt = Jn(P), [vt, Ot] = Qt(!1);
  gt(() => {
    if (ue)
      return Ot(!0), () => Ot(!1);
  }, [ue]);
  const yn = Ir(
    (xt, ln = !0) => {
      const { disclosureElement: dn } = X.getState();
      if (kZ(xt))
        return;
      let Vt = W_(F) || dn;
      if (Vt != null && Vt.id) {
        const yr = Qr(Vt), Xe = `[aria-activedescendant="${Vt.id}"]`, Xt = yr.querySelector(Xe);
        Xt && (Vt = Xt);
      }
      if (Vt && !j0(Vt)) {
        const yr = pE(Vt, "[data-dialog]");
        if (yr && yr.id) {
          const Xe = Qr(yr), Xt = `[aria-controls~="${yr.id}"]`, En = Xe.querySelector(Xt);
          En && (Vt = En);
        }
      }
      const Rn = Vt && j0(Vt);
      if (!Rn && ln) {
        requestAnimationFrame(() => yn(xt, !1));
        return;
      }
      rt(Rn ? Vt : null) && Rn && (Vt == null || Vt.focus());
    },
    [X, F, rt]
  ), Ar = Pt(!1);
  kn(() => {
    if (ue || !vt || !Qe)
      return;
    const xt = ce.current;
    Ar.current = !0, yn(xt);
  }, [ue, vt, ae, Qe, yn]), gt(() => {
    if (!vt || !Qe)
      return;
    const xt = ce.current;
    return () => {
      if (Ar.current) {
        Ar.current = !1;
        return;
      }
      yn(xt);
    };
  }, [vt, Qe, yn]);
  const In = Jn(D);
  gt(() => !ae || !ge ? void 0 : Fi("keydown", (ln) => {
    if (ln.key !== "Escape" || ln.defaultPrevented)
      return;
    const dn = ce.current;
    if (!dn || lx(dn))
      return;
    const Vt = ln.target;
    if (!Vt)
      return;
    const { disclosureElement: Rn } = X.getState();
    !!(Vt.tagName === "BODY" || ha(dn, Vt) || !Rn || ha(Rn, Vt)) && In(ln) && X.hide();
  }, !0), [X, ae, ge, In]), z = Vn(
    z,
    (xt) => /* @__PURE__ */ f.jsx(fM, { level: S ? 1 : void 0, children: xt }),
    [S]
  );
  const zn = z.hidden, er = z.alwaysVisible;
  z = Vn(
    z,
    (xt) => R ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(
        hZ,
        {
          store: X,
          backdrop: R,
          hidden: zn,
          alwaysVisible: er
        }
      ),
      xt
    ] }) : xt,
    [X, R, zn, er]
  );
  const [wr, ea] = Qt(), [Ca, Hr] = Qt();
  return z = Vn(
    z,
    (xt) => /* @__PURE__ */ f.jsx(rx, { value: X, children: /* @__PURE__ */ f.jsx(eM.Provider, { value: ea, children: /* @__PURE__ */ f.jsx(tM.Provider, { value: Hr, children: xt }) }) }),
    [X]
  ), z = Oe(Q({
    id: we,
    "data-dialog": "",
    role: "dialog",
    tabIndex: m ? -1 : void 0,
    "aria-labelledby": wr,
    "aria-describedby": Ca
  }, z), {
    ref: Ln(ce, z.ref)
  }), z = cM(Oe(Q({}, z), {
    autoFocusOnShow: Nt
  })), z = K5(Q({ store: X }, z)), z = F2(Oe(Q({}, z), { focusable: m })), z = dM(Oe(Q({ portal: b }, z), { portalRef: Ce, preserveTabOrder: K })), z;
});
function $2(e, t = G5) {
  return De(function(l) {
    const h = t(), g = l.store || h;
    return ja(
      g,
      (S) => !l.unmountOnHide || (S == null ? void 0 : S.mounted) || !!l.open
    ) ? /* @__PURE__ */ f.jsx(e, Q({}, l)) : null;
  });
}
var ox = $2(
  De(function(t) {
    const a = hM(t);
    return ke(AZ, a);
  }),
  G5
);
function ux(e = {}) {
  const t = q4(e);
  return /* @__PURE__ */ f.jsx(JE, { value: t, children: e.children });
}
var LZ = "p", vM = Le(function(t) {
  var a = t, l = Fe(a, ["store"]);
  const h = Ui(tM), g = Ia(l.id);
  return kn(() => (h == null || h(g), () => h == null ? void 0 : h(void 0)), [h, g]), l = Q({
    id: g
  }, l), La(l);
}), IZ = De(function(t) {
  const a = vM(t);
  return ke(LZ, a);
}), HZ = "button", Q5 = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = G5();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component."
    );
    const m = l.useState("contentElement");
    return h = Q({
      "aria-haspopup": ph(m, "dialog")
    }, h), h = XE(Q({ store: l }, h)), h;
  }
), ZZ = De(function(t) {
  const a = Q5(t);
  return ke(HZ, a);
}), PZ = "button", pM = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = KH();
    l = l || g;
    const m = h.onClick, S = nt((R) => {
      m == null || m(R), !R.defaultPrevented && (l == null || l.hide());
    }), b = Ur(
      () => /* @__PURE__ */ f.jsxs(
        "svg",
        {
          "aria-label": "Dismiss popup",
          display: "block",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          viewBox: "0 0 16 16",
          height: "1em",
          width: "1em",
          children: [
            /* @__PURE__ */ f.jsx("line", { x1: "4", y1: "4", x2: "12", y2: "12" }),
            /* @__PURE__ */ f.jsx("line", { x1: "4", y1: "12", x2: "12", y2: "4" })
          ]
        }
      ),
      []
    );
    return h = Oe(Q({
      "data-dialog-dismiss": "",
      children: b
    }, h), {
      onClick: S
    }), h = yh(h), h;
  }
), NZ = De(function(t) {
  const a = pM(t);
  return ke(PZ, a);
}), VZ = "h1", mM = Le(
  function(t) {
    const a = Pt(null), l = Ui(a8) || 1, h = `h${l}`, g = mh(a, h), m = Ur(
      () => !!g && /^h\d$/.test(g),
      [g]
    );
    return t = Oe(Q({
      render: /* @__PURE__ */ f.jsx(h, {}),
      role: m ? void 0 : "heading",
      "aria-level": m ? void 0 : l
    }, t), {
      ref: Ln(a, t.ref)
    }), t;
  }
), BZ = De(function(t) {
  const a = mM(t);
  return ke(VZ, a);
}), FZ = "h1", gM = Le(
  function(t) {
    var a = t, l = Fe(a, ["store"]);
    const h = Ui(eM), g = Ia(l.id);
    return kn(() => (h == null || h(g), () => h == null ? void 0 : h(void 0)), [h, g]), l = Q({
      id: g
    }, l), l = mM(l), l;
  }
), UZ = De(function(t) {
  const a = gM(t);
  return ke(FZ, a);
});
function wM(e) {
  return Array.isArray(e) ? e : typeof e < "u" ? [e] : [];
}
function l8(e) {
  const t = [];
  for (const a of e)
    t.push(...a);
  return t;
}
function E4(e) {
  return e.slice().reverse();
}
var YZ = { id: null };
function T0(e, t) {
  return e.find((a) => t ? !a.disabled && a.id !== t : !a.disabled);
}
function $Z(e, t) {
  return e.filter((a) => t ? !a.disabled && a.id !== t : !a.disabled);
}
function WZ(e) {
  if (e === "vertical")
    return "horizontal";
  if (e === "horizontal")
    return "vertical";
}
function z_(e, t) {
  return e.filter((a) => a.rowId === t);
}
function zZ(e, t, a = !1) {
  const l = e.findIndex((h) => h.id === t);
  return [
    ...e.slice(l + 1),
    ...a ? [YZ] : [],
    ...e.slice(0, l)
  ];
}
function o8(e) {
  const t = [];
  for (const a of e) {
    const l = t.find((h) => {
      var g;
      return ((g = h[0]) == null ? void 0 : g.rowId) === a.rowId;
    });
    l ? l.push(a) : t.push([a]);
  }
  return t;
}
function yM(e) {
  let t = 0;
  for (const { length: a } of e)
    a > t && (t = a);
  return t;
}
function qZ(e) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: e
  };
}
function q_(e, t, a) {
  const l = yM(e);
  for (const h of e)
    for (let g = 0; g < l; g += 1) {
      const m = h[g];
      if (!m || a && m.disabled) {
        const b = g === 0 && a ? T0(h) : h[g - 1];
        h[g] = b && t !== b.id && a ? b : qZ(b == null ? void 0 : b.rowId);
      }
    }
  return e;
}
function G_(e) {
  const t = o8(e), a = yM(t), l = [];
  for (let h = 0; h < a; h += 1)
    for (const g of t) {
      const m = g[h];
      m && l.push(gn(_t({}, m), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: m.rowId ? `${h}` : void 0
      }));
    }
  return l;
}
function Sh(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState(), l = N5(e), h = st(
    e.activeId,
    a == null ? void 0 : a.activeId,
    e.defaultActiveId
  ), g = gn(_t({}, l.getState()), {
    activeId: h,
    baseElement: st(a == null ? void 0 : a.baseElement, null),
    includesBaseElement: st(
      e.includesBaseElement,
      a == null ? void 0 : a.includesBaseElement,
      h === null
    ),
    moves: st(a == null ? void 0 : a.moves, 0),
    orientation: st(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "both"
    ),
    rtl: st(e.rtl, a == null ? void 0 : a.rtl, !1),
    virtualFocus: st(
      e.virtualFocus,
      a == null ? void 0 : a.virtualFocus,
      !1
    ),
    focusLoop: st(e.focusLoop, a == null ? void 0 : a.focusLoop, !1),
    focusWrap: st(e.focusWrap, a == null ? void 0 : a.focusWrap, !1),
    focusShift: st(e.focusShift, a == null ? void 0 : a.focusShift, !1)
  }), m = fi(g, l, e.store);
  Aa(
    m,
    () => xa(m, ["renderedItems", "activeId"], (b) => {
      m.setState("activeId", (R) => {
        var D;
        return R !== void 0 ? R : (D = T0(b.renderedItems)) == null ? void 0 : D.id;
      });
    })
  );
  const S = (b, R, D, T) => {
    var j, A;
    const { activeId: L, rtl: P, focusLoop: N, focusWrap: F, includesBaseElement: Y } = m.getState(), $ = P && R !== "vertical" ? E4(b) : b;
    if (L == null)
      return (j = T0($)) == null ? void 0 : j.id;
    const ce = $.find((Te) => Te.id === L);
    if (!ce)
      return (A = T0($)) == null ? void 0 : A.id;
    const X = !!ce.rowId, Ce = $.indexOf(ce), ae = $.slice(Ce + 1), me = z_(ae, ce.rowId);
    if (T !== void 0) {
      const Te = $Z(me, L), be = Te.slice(T)[0] || // If we can't find an item, just return the last one.
      Te[Te.length - 1];
      return be == null ? void 0 : be.id;
    }
    const K = WZ(
      // If it's a grid and orientation is not set, it's a next/previous call,
      // which is inherently horizontal. up/down will call next with orientation
      // set to vertical by default (see below on up/down methods).
      X ? R || "horizontal" : R
    ), we = N && N !== K, ue = X && F && F !== K;
    if (D = D || !X && we && Y, we) {
      const Te = ue && !D ? $ : z_($, ce.rowId), be = zZ(Te, L, D), Ue = T0(be, L);
      return Ue == null ? void 0 : Ue.id;
    }
    if (ue) {
      const Te = T0(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        D ? me : ae,
        L
      );
      return D ? (Te == null ? void 0 : Te.id) || null : Te == null ? void 0 : Te.id;
    }
    const ge = T0(me, L);
    return !ge && D ? null : ge == null ? void 0 : ge.id;
  };
  return gn(_t(_t({}, l), m), {
    setBaseElement: (b) => m.setState("baseElement", b),
    setActiveId: (b) => m.setState("activeId", b),
    move: (b) => {
      b !== void 0 && (m.setState("activeId", b), m.setState("moves", (R) => R + 1));
    },
    first: () => {
      var b;
      return (b = T0(m.getState().renderedItems)) == null ? void 0 : b.id;
    },
    last: () => {
      var b;
      return (b = T0(E4(m.getState().renderedItems))) == null ? void 0 : b.id;
    },
    next: (b) => {
      const { renderedItems: R, orientation: D } = m.getState();
      return S(R, D, !1, b);
    },
    previous: (b) => {
      var R;
      const { renderedItems: D, orientation: T, includesBaseElement: j } = m.getState(), L = !!!((R = T0(D)) != null && R.rowId) && j;
      return S(
        E4(D),
        T,
        L,
        b
      );
    },
    down: (b) => {
      const {
        activeId: R,
        renderedItems: D,
        focusShift: T,
        focusLoop: j,
        includesBaseElement: A
      } = m.getState(), L = T && !b, P = G_(
        l8(
          q_(o8(D), R, L)
        )
      );
      return S(P, "vertical", j && j !== "horizontal" && A, b);
    },
    up: (b) => {
      const { activeId: R, renderedItems: D, focusShift: T, includesBaseElement: j } = m.getState(), A = T && !b, L = G_(
        E4(
          l8(
            q_(
              o8(D),
              R,
              A
            )
          )
        )
      );
      return S(L, "vertical", j, b);
    }
  });
}
function Ch(e, t, a) {
  return e = F8(e, t, a), lr(e, a, "activeId", "setActiveId"), lr(e, a, "includesBaseElement"), lr(e, a, "virtualFocus"), lr(e, a, "orientation"), lr(e, a, "rtl"), lr(e, a, "focusLoop"), lr(e, a, "focusWrap"), lr(e, a, "focusShift"), e;
}
function xM(e = {}) {
  const [t, a] = Cl(Sh, e);
  return Ch(t, a, e);
}
var GZ = "div";
function KZ(e) {
  return e.some((t) => !!t.rowId);
}
function QZ(e) {
  const t = e.target;
  return t && !bo(t) ? !1 : e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function XZ(e) {
  return e.key === "Shift" || e.key === "Control" || e.key === "Alt" || e.key === "Meta";
}
function K_(e, t, a) {
  return nt((l) => {
    var h;
    if (t == null || t(l), l.defaultPrevented || l.isPropagationStopped() || !Sl(l) || XZ(l) || QZ(l))
      return;
    const g = e.getState(), m = (h = ih(e, g.activeId)) == null ? void 0 : h.element;
    if (!m)
      return;
    const S = l, b = Fe(S, ["view"]), R = a == null ? void 0 : a.current;
    m !== R && m.focus(), mL(m, l.type, b) || l.preventDefault(), l.currentTarget.contains(m) && l.stopPropagation();
  });
}
function JZ(e) {
  return cH(
    l8(E4(fH(e)))
  );
}
function eP(e) {
  const [t, a] = Qt(!1), l = Ir(() => a(!0), []), h = e.useState(
    (g) => ih(e, g.activeId)
  );
  return gt(() => {
    const g = h == null ? void 0 : h.element;
    t && g && (a(!1), g.focus({ preventScroll: !0 }));
  }, [h, t]), l;
}
var bh = Le(
  function(t) {
    var a = t, {
      store: l,
      composite: h = !0,
      focusOnMove: g = h,
      moveOnKeyPress: m = !0
    } = a, S = Fe(a, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const b = rH();
    l = l || b, Ht(
      l,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const R = Pt(null), D = eP(l), T = l.useState("moves");
    gt(() => {
      var K;
      if (!l || !T || !h || !g)
        return;
      const { activeId: we } = l.getState(), ue = (K = ih(l, we)) == null ? void 0 : K.element;
      ue && WL(ue);
    }, [l, T, h, g]), kn(() => {
      if (!l || !T || !h)
        return;
      const { baseElement: K, activeId: we } = l.getState();
      if (!(we === null) || !K)
        return;
      const ge = R.current;
      R.current = null, ge && mp(ge, { relatedTarget: K }), P2(K) || K.focus();
    }, [l, T, h]);
    const j = l.useState("activeId"), A = l.useState("virtualFocus");
    kn(() => {
      var K;
      if (!l || !h || !A)
        return;
      const we = R.current;
      if (R.current = null, !we)
        return;
      const ge = ((K = ih(l, j)) == null ? void 0 : K.element) || mf(we);
      ge !== we && mp(we, { relatedTarget: ge });
    }, [l, j, A, h]);
    const L = K_(
      l,
      S.onKeyDownCapture,
      R
    ), P = K_(
      l,
      S.onKeyUpCapture,
      R
    ), N = S.onFocusCapture, F = nt((K) => {
      if (N == null || N(K), K.defaultPrevented || !l)
        return;
      const { virtualFocus: we } = l.getState();
      if (!we)
        return;
      const ue = K.relatedTarget, ge = hH(K.currentTarget);
      Sl(K) && ge && (K.stopPropagation(), R.current = ue);
    }), Y = S.onFocus, G = nt((K) => {
      if (Y == null || Y(K), K.defaultPrevented || !h || !l)
        return;
      const { relatedTarget: we } = K, { virtualFocus: ue } = l.getState();
      ue ? Sl(K) && !O4(l, we) && queueMicrotask(D) : Sl(K) && l.setActiveId(null);
    }), z = S.onBlurCapture, $ = nt((K) => {
      var we;
      if (z == null || z(K), K.defaultPrevented || !l)
        return;
      const { virtualFocus: ue, activeId: ge } = l.getState();
      if (!ue)
        return;
      const Te = (we = ih(l, ge)) == null ? void 0 : we.element, be = K.relatedTarget, Ue = O4(l, be), le = R.current;
      R.current = null, Sl(K) && Ue ? (be === Te ? le && le !== be && mp(le, K) : Te ? mp(Te, K) : le && mp(le, K), K.stopPropagation()) : !O4(l, K.target) && Te && mp(Te, K);
    }), ce = S.onKeyDown, X = Jn(m), Ce = nt((K) => {
      var we;
      if (ce == null || ce(K), K.defaultPrevented || !l || !Sl(K))
        return;
      const { orientation: ue, items: ge, renderedItems: Te, activeId: be } = l.getState(), Ue = ih(l, be);
      if ((we = Ue == null ? void 0 : Ue.element) != null && we.isConnected)
        return;
      const le = ue !== "horizontal", _e = ue !== "vertical", Pe = KZ(Te);
      if ((K.key === "ArrowLeft" || K.key === "ArrowRight" || K.key === "Home" || K.key === "End") && bo(K.currentTarget))
        return;
      const kt = {
        ArrowUp: (Pe || le) && (() => {
          if (Pe) {
            const Qe = ge && JZ(ge);
            return Qe == null ? void 0 : Qe.id;
          }
          return l == null ? void 0 : l.last();
        }),
        ArrowRight: (Pe || _e) && l.first,
        ArrowDown: (Pe || le) && l.first,
        ArrowLeft: (Pe || _e) && l.last,
        Home: l.first,
        End: l.last,
        PageUp: l.first,
        PageDown: l.last
      }[K.key];
      if (kt) {
        const Qe = kt();
        if (Qe !== void 0) {
          if (!X(K))
            return;
          K.preventDefault(), l.move(Qe);
        }
      }
    });
    S = Vn(
      S,
      (K) => /* @__PURE__ */ f.jsx(Z0, { value: l, children: K }),
      [l]
    );
    const ae = l.useState((K) => {
      var we;
      if (l && h && K.virtualFocus)
        return (we = ih(l, K.activeId)) == null ? void 0 : we.id;
    });
    S = Oe(Q({
      "aria-activedescendant": ae
    }, S), {
      ref: Ln(h ? l.setBaseElement : null, S.ref),
      onKeyDownCapture: L,
      onKeyUpCapture: P,
      onFocusCapture: F,
      onFocus: G,
      onBlurCapture: $,
      onKeyDown: Ce
    });
    const me = l.useState(
      (K) => h && (K.virtualFocus || K.activeId === null)
    );
    return S = F2(Q({ focusable: me }, S)), S;
  }
), tP = De(function(t) {
  const a = bh(t);
  return ke(GZ, a);
});
function nP(e = {}) {
  const t = xM(e);
  return /* @__PURE__ */ f.jsx(Z0, { value: t, children: e.children });
}
var rP = "div", X5 = Le(function(t) {
  var a = t, l = Fe(a, ["store"]);
  return l = Q8(l), l;
}), aP = De(function(t) {
  const a = X5(t);
  return ke(rP, a);
}), iP = "div", J5 = Le(
  function(t) {
    var a = t, l = Fe(a, ["store"]);
    return l = X8(l), l;
  }
), lP = De(function(t) {
  const a = J5(t);
  return ke(iP, a);
}), oP = "div";
function SM(e) {
  const t = e.relatedTarget;
  return (t == null ? void 0 : t.nodeType) === Node.ELEMENT_NODE ? t : null;
}
function uP(e) {
  const t = SM(e);
  return t ? ha(e.currentTarget, t) : !1;
}
var u8 = Symbol("composite-hover");
function sP(e) {
  let t = SM(e);
  if (!t)
    return !1;
  do {
    if (df(t, u8) && t[u8])
      return !0;
    t = t.parentElement;
  } while (t);
  return !1;
}
var ew = Le(
  function(t) {
    var a = t, {
      store: l,
      focusOnHover: h = !0,
      blurOnHoverEnd: g = !!h
    } = a, m = Fe(a, [
      "store",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const S = U2();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const b = SE(), R = m.onMouseMove, D = Jn(h), T = nt((N) => {
      if (R == null || R(N), !N.defaultPrevented && b() && D(N)) {
        if (!sh(N.currentTarget)) {
          const F = l == null ? void 0 : l.getState().baseElement;
          F && !P2(F) && F.focus();
        }
        l == null || l.setActiveId(N.currentTarget.id);
      }
    }), j = m.onMouseLeave, A = Jn(g), L = nt((N) => {
      var F;
      j == null || j(N), !N.defaultPrevented && b() && (uP(N) || sP(N) || D(N) && A(N) && (l == null || l.setActiveId(null), (F = l == null ? void 0 : l.getState().baseElement) == null || F.focus()));
    }), P = Ir((N) => {
      N && (N[u8] = !0);
    }, []);
    return m = Oe(Q({}, m), {
      ref: Ln(P, m.ref),
      onMouseMove: T,
      onMouseLeave: L
    }), La(m);
  }
), cP = Ha(
  De(function(t) {
    const a = ew(t);
    return ke(oP, a);
  })
), fP = "div", sx = Le(
  function(t) {
    var a = t, {
      store: l,
      "aria-setsize": h,
      "aria-posinset": g
    } = a, m = Fe(a, [
      "store",
      "aria-setsize",
      "aria-posinset"
    ]);
    const S = U2();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "CompositeRow must be wrapped in a Composite component."
    );
    const b = Ia(m.id), R = l.useState(
      (T) => T.baseElement || void 0
    ), D = Ur(
      () => ({ id: b, baseElement: R, ariaSetSize: h, ariaPosInSet: g }),
      [b, R, h, g]
    );
    return m = Vn(
      m,
      (T) => /* @__PURE__ */ f.jsx(UE.Provider, { value: D, children: T }),
      [D]
    ), m = Q({ id: b }, m), La(m);
  }
), dP = De(function(t) {
  const a = sx(t);
  return ke(fP, a);
}), hP = "hr", CM = Le(
  function(t) {
    var a = t, { orientation: l = "horizontal" } = a, h = Fe(a, ["orientation"]);
    return h = Q({
      role: "separator",
      "aria-orientation": l
    }, h), h;
  }
), vP = De(function(t) {
  const a = CM(t);
  return ke(hP, a);
}), pP = "hr", K4 = Le(function(t) {
  var a = t, { store: l } = a, h = Fe(a, ["store"]);
  const g = U2();
  l = l || g, Ht(
    l,
    process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component."
  );
  const m = l.useState(
    (S) => S.orientation === "horizontal" ? "vertical" : "horizontal"
  );
  return h = CM(Oe(Q({}, h), { orientation: m })), h;
}), mP = De(function(t) {
  const a = K4(t);
  return ke(pP, a);
}), gP = "div", of = "";
function Ay() {
  of = "";
}
function wP(e) {
  const t = e.target;
  return t && bo(t) ? !1 : e.key === " " && of.length ? !0 : e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey && /^[\p{Letter}\p{Number}]$/u.test(e.key);
}
function yP(e, t) {
  if (Sl(e))
    return !0;
  const a = e.target;
  return a ? t.some((h) => h.element === a) : !1;
}
function xP(e) {
  return e.filter((t) => !t.disabled);
}
function d5(e, t) {
  var a;
  const l = ((a = e.element) == null ? void 0 : a.textContent) || e.children || // The composite item object itself doesn't include a value property, but
  // other components like Select do. Since CompositeTypeahead is a generic
  // component that can be used with those as well, we also consider the value
  // property as a fallback for the typeahead text content.
  "value" in e && e.value;
  return l ? D8(l).trim().toLowerCase().startsWith(t.toLowerCase()) : !1;
}
function SP(e, t, a) {
  if (!a)
    return e;
  const l = e.find((h) => h.id === a);
  return !l || !d5(l, t) || of !== t && d5(l, of) ? e : (of = t, sH(
    e.filter((h) => d5(h, of)),
    a
  ).filter((h) => h.id !== a));
}
var Q4 = Le(function(t) {
  var a = t, { store: l, typeahead: h = !0 } = a, g = Fe(a, ["store", "typeahead"]);
  const m = U2();
  l = l || m, Ht(
    l,
    process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component"
  );
  const S = g.onKeyDownCapture, b = Pt(0), R = nt((D) => {
    if (S == null || S(D), D.defaultPrevented || !h || !l)
      return;
    const { renderedItems: T, items: j, activeId: A } = l.getState();
    if (!wP(D))
      return Ay();
    let L = xP(
      T.length ? T : j
    );
    if (!yP(D, L))
      return Ay();
    D.preventDefault(), window.clearTimeout(b.current), b.current = window.setTimeout(() => {
      of = "";
    }, 500);
    const P = D.key.toLowerCase();
    of += P, L = SP(L, P, A);
    const N = L.find((F) => d5(F, of));
    N ? l.move(N.id) : Ay();
  });
  return g = Oe(Q({}, g), {
    onKeyDownCapture: R
  }), La(g);
}), CP = De(function(t) {
  const a = Q4(t);
  return ke(gP, a);
});
ka(null);
ka(
  null
);
var bP = bl(
  [Z0],
  [xh]
), _P = bP.useContext;
function tw(e = {}) {
  var t = e, {
    popover: a
  } = t, l = Ap(t, [
    "popover"
  ]);
  const h = Lp(
    l.store,
    Op(a, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  gh(l, h);
  const g = h == null ? void 0 : h.getState(), m = aM(gn(_t({}, l), { store: h })), S = st(
    l.placement,
    g == null ? void 0 : g.placement,
    "bottom"
  ), b = gn(_t({}, m.getState()), {
    placement: S,
    currentPlacement: S,
    anchorElement: st(g == null ? void 0 : g.anchorElement, null),
    popoverElement: st(g == null ? void 0 : g.popoverElement, null),
    arrowElement: st(g == null ? void 0 : g.arrowElement, null),
    rendered: Symbol("rendered")
  }), R = fi(b, m, h);
  return gn(_t(_t({}, m), R), {
    setAnchorElement: (D) => R.setState("anchorElement", D),
    setPopoverElement: (D) => R.setState("popoverElement", D),
    setArrowElement: (D) => R.setState("arrowElement", D),
    render: () => R.setState("rendered", Symbol("rendered"))
  });
}
function nw(e, t, a) {
  return b1(t, [a.popover]), lr(e, a, "placement"), iM(e, t, a);
}
function cx(e = {}) {
  const [t, a] = Cl(tw, e);
  return nw(t, a, e);
}
var RP = H8() && matchMedia("(hover:none)").matches;
function EP(e = {}) {
  var t = e, {
    tag: a
  } = t, l = Ap(t, [
    "tag"
  ]);
  const h = Lp(l.store, bE(a, ["value", "rtl"]));
  gh(l, h);
  const g = a == null ? void 0 : a.getState(), m = h == null ? void 0 : h.getState(), S = st(
    l.activeId,
    m == null ? void 0 : m.activeId,
    l.defaultActiveId,
    null
  ), b = Sh(gn(_t({}, l), {
    activeId: S,
    includesBaseElement: st(
      l.includesBaseElement,
      m == null ? void 0 : m.includesBaseElement,
      !0
    ),
    orientation: st(
      l.orientation,
      m == null ? void 0 : m.orientation,
      "vertical"
    ),
    focusLoop: st(l.focusLoop, m == null ? void 0 : m.focusLoop, !0),
    focusWrap: st(l.focusWrap, m == null ? void 0 : m.focusWrap, !0),
    virtualFocus: st(
      l.virtualFocus,
      m == null ? void 0 : m.virtualFocus,
      !RP
    )
  })), R = tw(gn(_t({}, l), {
    placement: st(
      l.placement,
      m == null ? void 0 : m.placement,
      "bottom-start"
    )
  })), D = st(
    l.value,
    m == null ? void 0 : m.value,
    l.defaultValue,
    ""
  ), T = st(
    l.selectedValue,
    m == null ? void 0 : m.selectedValue,
    g == null ? void 0 : g.values,
    l.defaultSelectedValue,
    ""
  ), j = Array.isArray(T), A = gn(_t(_t({}, b.getState()), R.getState()), {
    value: D,
    selectedValue: T,
    resetValueOnSelect: st(
      l.resetValueOnSelect,
      m == null ? void 0 : m.resetValueOnSelect,
      j
    ),
    resetValueOnHide: st(
      l.resetValueOnHide,
      m == null ? void 0 : m.resetValueOnHide,
      j && !a
    ),
    activeValue: m == null ? void 0 : m.activeValue
  }), L = fi(A, b, R, h);
  return Aa(L, () => {
    if (a)
      return _o(
        xa(L, ["selectedValue"], (P) => {
          Array.isArray(P.selectedValue) && a.setValues(P.selectedValue);
        }),
        xa(a, ["values"], (P) => {
          L.setState("selectedValue", P.values);
        })
      );
  }), Aa(
    L,
    () => xa(L, ["resetValueOnHide", "mounted"], (P) => {
      P.resetValueOnHide && (P.mounted || L.setState("value", D));
    })
  ), Aa(
    L,
    () => Z2(L, ["mounted"], (P) => {
      P.mounted || (L.setState("activeId", S), L.setState("moves", 0));
    })
  ), Aa(
    L,
    () => xa(L, ["moves", "activeId"], (P, N) => {
      P.moves === N.moves && L.setState("activeValue", void 0);
    })
  ), Aa(
    L,
    () => Z2(L, ["moves", "renderedItems"], (P, N) => {
      if (P.moves === N.moves)
        return;
      const { activeId: F } = L.getState(), Y = b.item(F);
      L.setState("activeValue", Y == null ? void 0 : Y.value);
    })
  ), gn(_t(_t(_t({}, R), b), L), {
    tag: a,
    setValue: (P) => L.setState("value", P),
    resetValue: () => L.setState("value", A.value),
    setSelectedValue: (P) => L.setState("selectedValue", P)
  });
}
function MP(e, t, a) {
  return b1(t, [a.tag]), lr(e, a, "value", "setValue"), lr(e, a, "selectedValue", "setSelectedValue"), lr(e, a, "resetValueOnHide"), lr(e, a, "resetValueOnSelect"), Object.assign(
    Ch(
      nw(e, t, a),
      t,
      a
    ),
    { tag: a.tag }
  );
}
function X4(e = {}) {
  const t = _P();
  e = Oe(Q({}, e), {
    tag: e.tag !== void 0 ? e.tag : t
  });
  const [a, l] = Cl(EP, e);
  return MP(a, l, e);
}
var J4 = bl(
  [JE],
  [rx]
), _h = J4.useContext, TP = J4.useScopedContext, rw = J4.useProviderContext, aw = J4.ContextProvider, e3 = J4.ScopedContextProvider, bM = ka(
  void 0
), t3 = bl(
  [aw, Z0],
  [e3, xh]
), fx = t3.useContext, Hp = t3.useScopedContext, Rh = t3.useProviderContext, OP = t3.ContextProvider, DP = t3.ScopedContextProvider, _M = ka(
  void 0
), RM = ka(!1), jP = "div", dx = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = rw();
    return l = l || g, h = Oe(Q({}, h), {
      ref: Ln(l == null ? void 0 : l.setAnchorElement, h.ref)
    }), h;
  }
), AP = De(function(t) {
  const a = dx(t);
  return ke(jP, a);
}), kP = "input";
function Q_(e, t, a) {
  if (!a)
    return !1;
  const l = e.find((h) => !h.disabled && h.value);
  return (l == null ? void 0 : l.value) === t;
}
function X_(e, t) {
  return !t || e == null ? !1 : (e = D8(e), t.length > e.length && t.toLowerCase().indexOf(e.toLowerCase()) === 0);
}
function LP(e) {
  return e.type === "input";
}
function IP(e) {
  return e === "inline" || e === "list" || e === "both" || e === "none";
}
function HP(e) {
  const t = e.find((a) => {
    var l;
    return a.disabled ? !1 : ((l = a.element) == null ? void 0 : l.getAttribute("role")) !== "tab";
  });
  return t == null ? void 0 : t.id;
}
var ZP = Le(
  function(t) {
    var a = t, {
      store: l,
      focusable: h = !0,
      autoSelect: g = !1,
      getAutoSelectId: m,
      setValueOnChange: S,
      showMinLength: b = 0,
      showOnChange: R,
      showOnMouseDown: D,
      showOnClick: T = D,
      showOnKeyDown: j,
      showOnKeyPress: A = j,
      blurActiveItemOnClick: L,
      setValueOnClick: P = !0,
      moveOnKeyPress: N = !0,
      autoComplete: F = "list"
    } = a, Y = Fe(a, [
      "store",
      "focusable",
      "autoSelect",
      "getAutoSelectId",
      "setValueOnChange",
      "showMinLength",
      "showOnChange",
      "showOnMouseDown",
      "showOnClick",
      "showOnKeyDown",
      "showOnKeyPress",
      "blurActiveItemOnClick",
      "setValueOnClick",
      "moveOnKeyPress",
      "autoComplete"
    ]);
    const G = Rh();
    l = l || G, Ht(
      l,
      process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const z = Pt(null), [$, ce] = Z5(), X = Pt(!1), Ce = Pt(!1), ae = l.useState(
      (Xe) => Xe.virtualFocus && g
    ), me = F === "inline" || F === "both", [K, we] = Qt(me);
    gL(() => {
      me && we(!0);
    }, [me]);
    const ue = l.useState("value"), ge = Pt();
    gt(() => xa(l, ["selectedValue", "activeId"], (Xe, Xt) => {
      ge.current = Xt.selectedValue;
    }), []);
    const Te = l.useState((Xe) => {
      var Xt;
      if (me && K && !(Xe.activeValue && Array.isArray(Xe.selectedValue) && (Xe.selectedValue.includes(Xe.activeValue) || (Xt = ge.current) != null && Xt.includes(Xe.activeValue))))
        return Xe.activeValue;
    }), be = l.useState("renderedItems"), Ue = l.useState("open"), le = l.useState("contentElement"), _e = Ur(() => {
      if (!me || !K)
        return ue;
      if (Q_(
        be,
        Te,
        ae
      )) {
        if (X_(ue, Te)) {
          const Xt = (Te == null ? void 0 : Te.slice(ue.length)) || "";
          return ue + Xt;
        }
        return ue;
      }
      return Te || ue;
    }, [me, K, be, Te, ae, ue]);
    gt(() => {
      const Xe = z.current;
      if (!Xe)
        return;
      const Xt = () => we(!0);
      return Xe.addEventListener("combobox-item-move", Xt), () => {
        Xe.removeEventListener("combobox-item-move", Xt);
      };
    }, []), gt(() => {
      if (!me || !K || !Te || !Q_(
        be,
        Te,
        ae
      ) || !X_(ue, Te))
        return;
      let Xt = M4;
      return queueMicrotask(() => {
        const En = z.current;
        if (!En)
          return;
        const { start: Cn, end: qe } = Gy(En), wt = ue.length, St = Te.length;
        Sy(En, wt, St), Xt = () => {
          if (!P2(En))
            return;
          const { start: un, end: sr } = Gy(En);
          un === wt && sr === St && Sy(En, Cn, qe);
        };
      }), () => Xt();
    }, [
      $,
      me,
      K,
      Te,
      be,
      ae,
      ue
    ]);
    const Pe = Pt(null), mt = nt(m), Ze = Pt(null);
    gt(() => {
      if (!Ue || !le)
        return;
      const Xe = L8(le);
      if (!Xe)
        return;
      Pe.current = Xe;
      const Xt = () => {
        X.current = !1;
      }, En = () => {
        if (!l || !X.current)
          return;
        const { activeId: qe } = l.getState();
        qe !== null && qe !== Ze.current && (X.current = !1);
      }, Cn = { passive: !0, capture: !0 };
      return Xe.addEventListener("wheel", Xt, Cn), Xe.addEventListener("scroll", En, Cn), () => {
        Xe.removeEventListener("wheel", Xt, !0), Xe.removeEventListener("scroll", En, !0);
      };
    }, [Ue, le, l]), kn(() => {
      ue && (Ce.current || (X.current = !0));
    }, [ue]), kn(() => {
      ae !== "always" && Ue || (X.current = Ue);
    }, [ae, Ue]);
    const Nt = l.useState("resetValueOnSelect");
    b1(() => {
      var Xe, Xt;
      const En = X.current;
      if (!l || !Ue || (!ae || !En) && !Nt)
        return;
      const { baseElement: Cn, contentElement: qe, activeId: wt } = l.getState();
      if (!(Cn && !P2(Cn))) {
        if (qe != null && qe.hasAttribute("data-placing")) {
          const St = new MutationObserver(ce);
          return St.observe(qe, { attributeFilter: ["data-placing"] }), () => St.disconnect();
        }
        if (ae && En) {
          const St = mt(be), un = St !== void 0 ? St : (Xe = HP(be)) != null ? Xe : l.first();
          Ze.current = un, l.move(un ?? null);
        } else {
          const St = (Xt = l.item(wt)) == null ? void 0 : Xt.element;
          St && "scrollIntoView" in St && St.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
    }, [
      l,
      Ue,
      $,
      ue,
      ae,
      Nt,
      mt,
      be
    ]), gt(() => {
      if (!me)
        return;
      const Xe = z.current;
      if (!Xe)
        return;
      const Xt = [Xe, le].filter(
        (Cn) => !!Cn
      ), En = (Cn) => {
        Xt.every((qe) => ah(Cn, qe)) && (l == null || l.setValue(_e));
      };
      return Xt.forEach((Cn) => Cn.addEventListener("focusout", En)), () => {
        Xt.forEach((Cn) => Cn.removeEventListener("focusout", En));
      };
    }, [me, le, l, _e]);
    const kt = (Xe) => Xe.currentTarget.value.length >= b, Qe = Y.onChange, rt = Jn(R ?? kt), vt = Jn(
      // If the combobox is combined with tags, the value will be set by the tag
      // input component.
      S ?? !l.tag
    ), Ot = nt((Xe) => {
      if (Qe == null || Qe(Xe), Xe.defaultPrevented || !l)
        return;
      const Xt = Xe.currentTarget, { value: En, selectionStart: Cn, selectionEnd: qe } = Xt, wt = Xe.nativeEvent;
      if (X.current = !0, LP(wt) && (wt.isComposing && (X.current = !1, Ce.current = !0), me)) {
        const St = wt.inputType === "insertText" || wt.inputType === "insertCompositionText", un = Cn === En.length;
        we(St && un);
      }
      if (vt(Xe)) {
        const St = En === l.getState().value;
        l.setValue(En), queueMicrotask(() => {
          Sy(Xt, Cn, qe);
        }), me && ae && St && ce();
      }
      rt(Xe) && l.show(), (!ae || !X.current) && l.setActiveId(null);
    }), yn = Y.onCompositionEnd, Ar = nt((Xe) => {
      X.current = !0, Ce.current = !1, yn == null || yn(Xe), !Xe.defaultPrevented && ae && ce();
    }), In = Y.onMouseDown, zn = Jn(
      L ?? (() => !!(l != null && l.getState().includesBaseElement))
    ), er = Jn(P), wr = Jn(T ?? kt), ea = nt((Xe) => {
      In == null || In(Xe), !Xe.defaultPrevented && (Xe.button || Xe.ctrlKey || l && (zn(Xe) && l.setActiveId(null), er(Xe) && l.setValue(_e), wr(Xe) && H2(Xe.currentTarget, "mouseup", l.show)));
    }), Ca = Y.onKeyDown, Hr = Jn(A ?? kt), xt = nt((Xe) => {
      if (Ca == null || Ca(Xe), Xe.repeat || (X.current = !1), Xe.defaultPrevented || Xe.ctrlKey || Xe.altKey || Xe.shiftKey || Xe.metaKey || !l)
        return;
      const { open: Xt, activeId: En } = l.getState();
      Xt || En === null && (Xe.key === "ArrowUp" || Xe.key === "ArrowDown") && Hr(Xe) && (Xe.preventDefault(), l.show());
    }), ln = Y.onBlur, dn = nt((Xe) => {
      X.current = !1, ln == null || ln(Xe), Xe.defaultPrevented;
    }), Vt = Ia(Y.id), Rn = IP(F) ? F : void 0, yr = l.useState((Xe) => Xe.activeId === null);
    return Y = Oe(Q({
      id: Vt,
      role: "combobox",
      "aria-autocomplete": Rn,
      "aria-haspopup": ph(le, "listbox"),
      "aria-expanded": Ue,
      "aria-controls": le == null ? void 0 : le.id,
      "data-active-item": yr || void 0,
      value: _e
    }, Y), {
      ref: Ln(z, Y.ref),
      onChange: Ot,
      onCompositionEnd: Ar,
      onMouseDown: ea,
      onKeyDown: xt,
      onBlur: dn
    }), Y = bh(Oe(Q({
      store: l,
      focusable: h
    }, Y), {
      // Enable inline autocomplete when the user moves from the combobox input
      // to an item.
      moveOnKeyPress: (Xe) => I2(N, Xe) ? !1 : (me && we(!0), !0)
    })), Y = dx(Q({ store: l }, Y)), Q({ autoComplete: "off" }, Y);
  }
), iw = De(function(t) {
  const a = ZP(t);
  return ke(kP, a);
});
function EM(e = {}) {
  const t = X4(e);
  return /* @__PURE__ */ f.jsx(OP, { value: t, children: e.children });
}
var PP = "button", NP = /* @__PURE__ */ f.jsxs(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    width: "1em",
    height: "1em",
    pointerEvents: "none",
    children: [
      /* @__PURE__ */ f.jsx("line", { x1: "5", y1: "5", x2: "11", y2: "11" }),
      /* @__PURE__ */ f.jsx("line", { x1: "5", y1: "11", x2: "11", y2: "5" })
    ]
  }
), VP = Le(
  function(t) {
    var a = t, { store: l, hideWhenEmpty: h } = a, g = Fe(a, ["store", "hideWhenEmpty"]);
    const m = Rh();
    l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxCancel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const S = g.onClick, b = nt((T) => {
      S == null || S(T), !T.defaultPrevented && (l == null || l.setValue(""), l == null || l.move(null));
    }), R = l.useState((T) => {
      var j;
      return (j = T.baseElement) == null ? void 0 : j.id;
    }), D = l.useState((T) => T.value === "");
    return g = Vn(
      g,
      (T) => h && D ? /* @__PURE__ */ f.jsx(lE, {}) : T,
      [h, D]
    ), g = Oe(Q({
      children: NP,
      "aria-label": "Clear input",
      // This aria-controls will ensure the combobox popup remains visible when
      // this element gets focused. This logic is done in the ComboboxPopover
      // component.
      "aria-controls": R
    }, g), {
      onClick: b
    }), g = yh(g), g;
  }
), BP = De(function(t) {
  const a = VP(t);
  return ke(PP, a);
}), FP = "button", UP = /* @__PURE__ */ f.jsx(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    pointerEvents: "none",
    children: /* @__PURE__ */ f.jsx("polyline", { points: "4,6 8,10 12,6" })
  }
), YP = Le(function(t) {
  var a = t, { store: l } = a, h = Fe(a, ["store"]);
  const g = Rh();
  l = l || g, Ht(
    l,
    process.env.NODE_ENV !== "production" && "ComboboxDisclosure must receive a `store` prop or be wrapped in a ComboboxProvider component."
  );
  const m = h.onMouseDown, S = nt((T) => {
    m == null || m(T), T.preventDefault(), l == null || l.move(null);
  }), b = h.onClick, R = nt((T) => {
    if (b == null || b(T), T.defaultPrevented || !l)
      return;
    const { baseElement: j } = l.getState();
    l.setDisclosureElement(j);
  }), D = l.useState("open");
  return h = Oe(Q({
    children: UP,
    tabIndex: -1,
    "aria-label": D ? "Hide popup" : "Show popup",
    "aria-expanded": D
  }, h), {
    onMouseDown: S,
    onClick: R
  }), h = Q5(Q({ store: l }, h)), h;
}), $P = De(function(t) {
  const a = YP(t);
  return ke(FP, a);
}), WP = "div", zP = Le(function(t) {
  return t = X5(t), t;
}), MM = De(function(t) {
  const a = zP(t);
  return ke(WP, a);
}), qP = "div", GP = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = Hp();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const m = l.useState("contentElement");
    return ph(m) === "grid" && (h = Q({ role: "rowgroup" }, h)), h = J5(Q({ store: l }, h)), h;
  }
), TM = De(function(t) {
  const a = GP(t);
  return ke(qP, a);
}), KP = "span", QP = Le(function(t) {
  var a = t, { store: l, checked: h } = a, g = Fe(a, ["store", "checked"]);
  const m = Ui(RM);
  return h = h ?? m, g = U5(Oe(Q({}, g), { checked: h })), g;
}), XP = De(function(t) {
  const a = QP(t);
  return ke(KP, a);
}), JP = "span";
function ky(e) {
  return D8(e).toLowerCase();
}
function eN(e, t) {
  t = ky(t);
  let a = ky(e).indexOf(t);
  const l = [];
  for (; a !== -1; )
    a !== 0 && l.push(
      /* @__PURE__ */ f.jsx("span", { "data-autocomplete-value": "", children: e.substr(0, a) }, l.length)
    ), l.push(
      /* @__PURE__ */ f.jsx("span", { "data-user-value": "", children: e.substr(a, t.length) }, l.length)
    ), e = e.substr(a + t.length), a = ky(e).indexOf(t);
  return e && l.push(
    /* @__PURE__ */ f.jsx("span", { "data-autocomplete-value": "", children: e }, l.length)
  ), l;
}
var tN = Le(function(t) {
  var a = t, { store: l, value: h } = a, g = Fe(a, ["store", "value"]);
  const m = Hp();
  l = l || m;
  const S = Ui(_M), b = h ?? S;
  Ht(
    l,
    process.env.NODE_ENV !== "production" && "ComboboxItemValue must be wrapped in a ComboboxItem component."
  );
  const R = l.useState(
    (T) => b && T.value ? T.value : void 0
  ), D = Ur(
    () => b && R ? eN(b, R) : b,
    [b, R]
  );
  return g = Q({
    children: D
  }, g), La(g);
}), nN = De(function(t) {
  const a = tN(t);
  return ke(JP, a);
}), rN = "div";
function aN(e, t) {
  if (t != null)
    return e == null ? !1 : Array.isArray(e) ? e.includes(t) : e === t;
}
function iN(e) {
  var t;
  return (t = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }[e]) != null ? t : "option";
}
var lN = Le(
  function(t) {
    var a = t, {
      store: l,
      value: h,
      hideOnClick: g,
      setValueOnClick: m,
      selectValueOnClick: S = !0,
      resetValueOnSelect: b,
      focusOnHover: R = !1,
      moveOnKeyPress: D = !0,
      getItem: T
    } = a, j = Fe(a, [
      "store",
      "value",
      "hideOnClick",
      "setValueOnClick",
      "selectValueOnClick",
      "resetValueOnSelect",
      "focusOnHover",
      "moveOnKeyPress",
      "getItem"
    ]), A;
    const L = Hp();
    l = l || L, Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxItem must be wrapped in a ComboboxList or ComboboxPopover component."
    );
    const P = Ir(
      (ue) => {
        const ge = Oe(Q({}, ue), { value: h });
        return T ? T(ge) : ge;
      },
      [h, T]
    ), N = l.useState(
      (ue) => Array.isArray(ue.selectedValue)
    ), F = l.useState(
      (ue) => aN(ue.selectedValue, h)
    ), Y = l.useState("resetValueOnSelect");
    m = m ?? !N, g = g ?? (h != null && !N);
    const G = j.onClick, z = Jn(m), $ = Jn(S), ce = Jn(
      (A = b ?? Y) != null ? A : N
    ), X = Jn(g), Ce = nt((ue) => {
      G == null || G(ue), !ue.defaultPrevented && (P8(ue) || Z8(ue) || (h != null && ($(ue) && (ce(ue) && (l == null || l.resetValue()), l == null || l.setSelectedValue((ge) => Array.isArray(ge) ? ge.includes(h) ? ge.filter((Te) => Te !== h) : [...ge, h] : h)), z(ue) && (l == null || l.setValue(h))), X(ue) && (l == null || l.hide())));
    }), ae = j.onKeyDown, me = nt((ue) => {
      if (ae == null || ae(ue), ue.defaultPrevented)
        return;
      const ge = l == null ? void 0 : l.getState().baseElement;
      if (!ge || P2(ge))
        return;
      (ue.key.length === 1 || ue.key === "Backspace" || ue.key === "Delete") && (queueMicrotask(() => ge.focus()), bo(ge) && (l == null || l.setValue(ge.value)));
    });
    N && F != null && (j = Q({
      "aria-selected": F
    }, j)), j = Vn(
      j,
      (ue) => /* @__PURE__ */ f.jsx(_M.Provider, { value: h, children: /* @__PURE__ */ f.jsx(RM.Provider, { value: F ?? !1, children: ue }) }),
      [h, F]
    );
    const K = Ui(bM);
    j = Oe(Q({
      role: iN(K),
      children: h
    }, j), {
      onClick: Ce,
      onKeyDown: me
    });
    const we = Jn(D);
    return j = Y2(Oe(Q({
      store: l
    }, j), {
      getItem: P,
      // Dispatch a custom event on the combobox input when moving to an item
      // with the keyboard so the Combobox component can enable inline
      // autocompletion.
      moveOnKeyPress: (ue) => {
        if (!we(ue))
          return !1;
        const ge = new Event("combobox-item-move"), Te = l == null ? void 0 : l.getState().baseElement;
        return Te == null || Te.dispatchEvent(ge), !0;
      }
    })), j = ew(Q({ store: l, focusOnHover: R }, j)), j;
  }
), H4 = Ha(
  De(function(t) {
    const a = lN(t);
    return ke(rN, a);
  })
), oN = "label", uN = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = Rh();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxLabel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const m = l.useState((S) => {
      var b;
      return (b = S.baseElement) == null ? void 0 : b.id;
    });
    return h = Q({
      htmlFor: m
    }, h), La(h);
  }
), sN = Ha(
  De(function(t) {
    const a = uN(t);
    return ke(oN, a);
  })
), cN = "div", OM = Le(
  function(t) {
    var a = t, { store: l, alwaysVisible: h } = a, g = Fe(a, ["store", "alwaysVisible"]);
    const m = Hp(!0), S = fx();
    l = l || S;
    const b = !!l && l === m;
    Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const R = Pt(null), D = Ia(g.id), T = l.useState("mounted"), j = z4(T, g.hidden, h), A = j ? Oe(Q({}, g.style), { display: "none" }) : g.style, L = l.useState(
      (ce) => Array.isArray(ce.selectedValue)
    ), P = yE(R, "role", g.role), F = (P === "listbox" || P === "tree" || P === "grid") && L || void 0, [Y, G] = Qt(!1), z = l.useState("contentElement");
    kn(() => {
      if (!T)
        return;
      const ce = R.current;
      if (!ce || z !== ce)
        return;
      const X = () => {
        G(!!ce.querySelector("[role='listbox']"));
      }, Ce = new MutationObserver(X);
      return Ce.observe(ce, {
        subtree: !0,
        childList: !0,
        attributeFilter: ["role"]
      }), X(), () => Ce.disconnect();
    }, [T, z]), Y || (g = Q({
      role: "listbox",
      "aria-multiselectable": F
    }, g)), g = Vn(
      g,
      (ce) => /* @__PURE__ */ f.jsx(DP, { value: l, children: /* @__PURE__ */ f.jsx(bM.Provider, { value: P, children: ce }) }),
      [l, P]
    );
    const $ = D && (!m || !b) ? l.setContentElement : null;
    return g = Oe(Q({
      id: D,
      hidden: j
    }, g), {
      ref: Ln($, R, g.ref),
      style: A
    }), La(g);
  }
), hx = De(function(t) {
  const a = OM(t);
  return ke(cN, a);
});
const D0 = Math.min, Lu = Math.max, R5 = Math.round, i5 = Math.floor, fh = (e) => ({
  x: e,
  y: e
}), fN = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, dN = {
  start: "end",
  end: "start"
};
function s8(e, t, a) {
  return Lu(e, D0(t, a));
}
function dh(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function hf(e) {
  return e.split("-")[0];
}
function Zp(e) {
  return e.split("-")[1];
}
function vx(e) {
  return e === "x" ? "y" : "x";
}
function px(e) {
  return e === "y" ? "height" : "width";
}
function hh(e) {
  return ["top", "bottom"].includes(hf(e)) ? "y" : "x";
}
function mx(e) {
  return vx(hh(e));
}
function hN(e, t, a) {
  a === void 0 && (a = !1);
  const l = Zp(e), h = mx(e), g = px(h);
  let m = h === "x" ? l === (a ? "end" : "start") ? "right" : "left" : l === "start" ? "bottom" : "top";
  return t.reference[g] > t.floating[g] && (m = E5(m)), [m, E5(m)];
}
function vN(e) {
  const t = E5(e);
  return [c8(e), t, c8(t)];
}
function c8(e) {
  return e.replace(/start|end/g, (t) => dN[t]);
}
function pN(e, t, a) {
  const l = ["left", "right"], h = ["right", "left"], g = ["top", "bottom"], m = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? h : l : t ? l : h;
    case "left":
    case "right":
      return t ? g : m;
    default:
      return [];
  }
}
function mN(e, t, a, l) {
  const h = Zp(e);
  let g = pN(hf(e), a === "start", l);
  return h && (g = g.map((m) => m + "-" + h), t && (g = g.concat(g.map(c8)))), g;
}
function E5(e) {
  return e.replace(/left|right|bottom|top/g, (t) => fN[t]);
}
function gN(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function DM(e) {
  return typeof e != "number" ? gN(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function M5(e) {
  const {
    x: t,
    y: a,
    width: l,
    height: h
  } = e;
  return {
    width: l,
    height: h,
    top: a,
    left: t,
    right: t + l,
    bottom: a + h,
    x: t,
    y: a
  };
}
function J_(e, t, a) {
  let {
    reference: l,
    floating: h
  } = e;
  const g = hh(t), m = mx(t), S = px(m), b = hf(t), R = g === "y", D = l.x + l.width / 2 - h.width / 2, T = l.y + l.height / 2 - h.height / 2, j = l[S] / 2 - h[S] / 2;
  let A;
  switch (b) {
    case "top":
      A = {
        x: D,
        y: l.y - h.height
      };
      break;
    case "bottom":
      A = {
        x: D,
        y: l.y + l.height
      };
      break;
    case "right":
      A = {
        x: l.x + l.width,
        y: T
      };
      break;
    case "left":
      A = {
        x: l.x - h.width,
        y: T
      };
      break;
    default:
      A = {
        x: l.x,
        y: l.y
      };
  }
  switch (Zp(t)) {
    case "start":
      A[m] -= j * (a && R ? -1 : 1);
      break;
    case "end":
      A[m] += j * (a && R ? -1 : 1);
      break;
  }
  return A;
}
const wN = async (e, t, a) => {
  const {
    placement: l = "bottom",
    strategy: h = "absolute",
    middleware: g = [],
    platform: m
  } = a, S = g.filter(Boolean), b = await (m.isRTL == null ? void 0 : m.isRTL(t));
  let R = await m.getElementRects({
    reference: e,
    floating: t,
    strategy: h
  }), {
    x: D,
    y: T
  } = J_(R, l, b), j = l, A = {}, L = 0;
  for (let P = 0; P < S.length; P++) {
    const {
      name: N,
      fn: F
    } = S[P], {
      x: Y,
      y: G,
      data: z,
      reset: $
    } = await F({
      x: D,
      y: T,
      initialPlacement: l,
      placement: j,
      strategy: h,
      middlewareData: A,
      rects: R,
      platform: m,
      elements: {
        reference: e,
        floating: t
      }
    });
    D = Y ?? D, T = G ?? T, A = {
      ...A,
      [N]: {
        ...A[N],
        ...z
      }
    }, $ && L <= 50 && (L++, typeof $ == "object" && ($.placement && (j = $.placement), $.rects && (R = $.rects === !0 ? await m.getElementRects({
      reference: e,
      floating: t,
      strategy: h
    }) : $.rects), {
      x: D,
      y: T
    } = J_(R, j, b)), P = -1);
  }
  return {
    x: D,
    y: T,
    placement: j,
    strategy: h,
    middlewareData: A
  };
};
async function gx(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: l,
    y: h,
    platform: g,
    rects: m,
    elements: S,
    strategy: b
  } = e, {
    boundary: R = "clippingAncestors",
    rootBoundary: D = "viewport",
    elementContext: T = "floating",
    altBoundary: j = !1,
    padding: A = 0
  } = dh(t, e), L = DM(A), N = S[j ? T === "floating" ? "reference" : "floating" : T], F = M5(await g.getClippingRect({
    element: (a = await (g.isElement == null ? void 0 : g.isElement(N))) == null || a ? N : N.contextElement || await (g.getDocumentElement == null ? void 0 : g.getDocumentElement(S.floating)),
    boundary: R,
    rootBoundary: D,
    strategy: b
  })), Y = T === "floating" ? {
    x: l,
    y: h,
    width: m.floating.width,
    height: m.floating.height
  } : m.reference, G = await (g.getOffsetParent == null ? void 0 : g.getOffsetParent(S.floating)), z = await (g.isElement == null ? void 0 : g.isElement(G)) ? await (g.getScale == null ? void 0 : g.getScale(G)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = M5(g.convertOffsetParentRelativeRectToViewportRelativeRect ? await g.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: S,
    rect: Y,
    offsetParent: G,
    strategy: b
  }) : Y);
  return {
    top: (F.top - $.top + L.top) / z.y,
    bottom: ($.bottom - F.bottom + L.bottom) / z.y,
    left: (F.left - $.left + L.left) / z.x,
    right: ($.right - F.right + L.right) / z.x
  };
}
const yN = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: l,
      placement: h,
      rects: g,
      platform: m,
      elements: S,
      middlewareData: b
    } = t, {
      element: R,
      padding: D = 0
    } = dh(e, t) || {};
    if (R == null)
      return {};
    const T = DM(D), j = {
      x: a,
      y: l
    }, A = mx(h), L = px(A), P = await m.getDimensions(R), N = A === "y", F = N ? "top" : "left", Y = N ? "bottom" : "right", G = N ? "clientHeight" : "clientWidth", z = g.reference[L] + g.reference[A] - j[A] - g.floating[L], $ = j[A] - g.reference[A], ce = await (m.getOffsetParent == null ? void 0 : m.getOffsetParent(R));
    let X = ce ? ce[G] : 0;
    (!X || !await (m.isElement == null ? void 0 : m.isElement(ce))) && (X = S.floating[G] || g.floating[L]);
    const Ce = z / 2 - $ / 2, ae = X / 2 - P[L] / 2 - 1, me = D0(T[F], ae), K = D0(T[Y], ae), we = me, ue = X - P[L] - K, ge = X / 2 - P[L] / 2 + Ce, Te = s8(we, ge, ue), be = !b.arrow && Zp(h) != null && ge !== Te && g.reference[L] / 2 - (ge < we ? me : K) - P[L] / 2 < 0, Ue = be ? ge < we ? ge - we : ge - ue : 0;
    return {
      [A]: j[A] + Ue,
      data: {
        [A]: Te,
        centerOffset: ge - Te - Ue,
        ...be && {
          alignmentOffset: Ue
        }
      },
      reset: be
    };
  }
}), xN = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, l;
      const {
        placement: h,
        middlewareData: g,
        rects: m,
        initialPlacement: S,
        platform: b,
        elements: R
      } = t, {
        mainAxis: D = !0,
        crossAxis: T = !0,
        fallbackPlacements: j,
        fallbackStrategy: A = "bestFit",
        fallbackAxisSideDirection: L = "none",
        flipAlignment: P = !0,
        ...N
      } = dh(e, t);
      if ((a = g.arrow) != null && a.alignmentOffset)
        return {};
      const F = hf(h), Y = hh(S), G = hf(S) === S, z = await (b.isRTL == null ? void 0 : b.isRTL(R.floating)), $ = j || (G || !P ? [E5(S)] : vN(S)), ce = L !== "none";
      !j && ce && $.push(...mN(S, P, L, z));
      const X = [S, ...$], Ce = await gx(t, N), ae = [];
      let me = ((l = g.flip) == null ? void 0 : l.overflows) || [];
      if (D && ae.push(Ce[F]), T) {
        const ge = hN(h, m, z);
        ae.push(Ce[ge[0]], Ce[ge[1]]);
      }
      if (me = [...me, {
        placement: h,
        overflows: ae
      }], !ae.every((ge) => ge <= 0)) {
        var K, we;
        const ge = (((K = g.flip) == null ? void 0 : K.index) || 0) + 1, Te = X[ge];
        if (Te)
          return {
            data: {
              index: ge,
              overflows: me
            },
            reset: {
              placement: Te
            }
          };
        let be = (we = me.filter((Ue) => Ue.overflows[0] <= 0).sort((Ue, le) => Ue.overflows[1] - le.overflows[1])[0]) == null ? void 0 : we.placement;
        if (!be)
          switch (A) {
            case "bestFit": {
              var ue;
              const Ue = (ue = me.filter((le) => {
                if (ce) {
                  const _e = hh(le.placement);
                  return _e === Y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  _e === "y";
                }
                return !0;
              }).map((le) => [le.placement, le.overflows.filter((_e) => _e > 0).reduce((_e, Pe) => _e + Pe, 0)]).sort((le, _e) => le[1] - _e[1])[0]) == null ? void 0 : ue[0];
              Ue && (be = Ue);
              break;
            }
            case "initialPlacement":
              be = S;
              break;
          }
        if (h !== be)
          return {
            reset: {
              placement: be
            }
          };
      }
      return {};
    }
  };
};
async function SN(e, t) {
  const {
    placement: a,
    platform: l,
    elements: h
  } = e, g = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), m = hf(a), S = Zp(a), b = hh(a) === "y", R = ["left", "top"].includes(m) ? -1 : 1, D = g && b ? -1 : 1, T = dh(t, e);
  let {
    mainAxis: j,
    crossAxis: A,
    alignmentAxis: L
  } = typeof T == "number" ? {
    mainAxis: T,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...T
  };
  return S && typeof L == "number" && (A = S === "end" ? L * -1 : L), b ? {
    x: A * D,
    y: j * R
  } : {
    x: j * R,
    y: A * D
  };
}
const CN = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, l;
      const {
        x: h,
        y: g,
        placement: m,
        middlewareData: S
      } = t, b = await SN(t, e);
      return m === ((a = S.offset) == null ? void 0 : a.placement) && (l = S.arrow) != null && l.alignmentOffset ? {} : {
        x: h + b.x,
        y: g + b.y,
        data: {
          ...b,
          placement: m
        }
      };
    }
  };
}, bN = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: l,
        placement: h
      } = t, {
        mainAxis: g = !0,
        crossAxis: m = !1,
        limiter: S = {
          fn: (N) => {
            let {
              x: F,
              y: Y
            } = N;
            return {
              x: F,
              y: Y
            };
          }
        },
        ...b
      } = dh(e, t), R = {
        x: a,
        y: l
      }, D = await gx(t, b), T = hh(hf(h)), j = vx(T);
      let A = R[j], L = R[T];
      if (g) {
        const N = j === "y" ? "top" : "left", F = j === "y" ? "bottom" : "right", Y = A + D[N], G = A - D[F];
        A = s8(Y, A, G);
      }
      if (m) {
        const N = T === "y" ? "top" : "left", F = T === "y" ? "bottom" : "right", Y = L + D[N], G = L - D[F];
        L = s8(Y, L, G);
      }
      const P = S.fn({
        ...t,
        [j]: A,
        [T]: L
      });
      return {
        ...P,
        data: {
          x: P.x - a,
          y: P.y - l
        }
      };
    }
  };
}, _N = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: a,
        y: l,
        placement: h,
        rects: g,
        middlewareData: m
      } = t, {
        offset: S = 0,
        mainAxis: b = !0,
        crossAxis: R = !0
      } = dh(e, t), D = {
        x: a,
        y: l
      }, T = hh(h), j = vx(T);
      let A = D[j], L = D[T];
      const P = dh(S, t), N = typeof P == "number" ? {
        mainAxis: P,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...P
      };
      if (b) {
        const G = j === "y" ? "height" : "width", z = g.reference[j] - g.floating[G] + N.mainAxis, $ = g.reference[j] + g.reference[G] - N.mainAxis;
        A < z ? A = z : A > $ && (A = $);
      }
      if (R) {
        var F, Y;
        const G = j === "y" ? "width" : "height", z = ["top", "left"].includes(hf(h)), $ = g.reference[T] - g.floating[G] + (z && ((F = m.offset) == null ? void 0 : F[T]) || 0) + (z ? 0 : N.crossAxis), ce = g.reference[T] + g.reference[G] + (z ? 0 : ((Y = m.offset) == null ? void 0 : Y[T]) || 0) - (z ? N.crossAxis : 0);
        L < $ ? L = $ : L > ce && (L = ce);
      }
      return {
        [j]: A,
        [T]: L
      };
    }
  };
}, RN = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: a,
        rects: l,
        platform: h,
        elements: g
      } = t, {
        apply: m = () => {
        },
        ...S
      } = dh(e, t), b = await gx(t, S), R = hf(a), D = Zp(a), T = hh(a) === "y", {
        width: j,
        height: A
      } = l.floating;
      let L, P;
      R === "top" || R === "bottom" ? (L = R, P = D === (await (h.isRTL == null ? void 0 : h.isRTL(g.floating)) ? "start" : "end") ? "left" : "right") : (P = R, L = D === "end" ? "top" : "bottom");
      const N = A - b.top - b.bottom, F = j - b.left - b.right, Y = D0(A - b[L], N), G = D0(j - b[P], F), z = !t.middlewareData.shift;
      let $ = Y, ce = G;
      if (T ? ce = D || z ? D0(G, F) : F : $ = D || z ? D0(Y, N) : N, z && !D) {
        const Ce = Lu(b.left, 0), ae = Lu(b.right, 0), me = Lu(b.top, 0), K = Lu(b.bottom, 0);
        T ? ce = j - 2 * (Ce !== 0 || ae !== 0 ? Ce + ae : Lu(b.left, b.right)) : $ = A - 2 * (me !== 0 || K !== 0 ? me + K : Lu(b.top, b.bottom));
      }
      await m({
        ...t,
        availableWidth: ce,
        availableHeight: $
      });
      const X = await h.getDimensions(g.floating);
      return j !== X.width || A !== X.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function vh(e) {
  return jM(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Hu(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function gf(e) {
  var t;
  return (t = (jM(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function jM(e) {
  return e instanceof Node || e instanceof Hu(e).Node;
}
function L0(e) {
  return e instanceof Element || e instanceof Hu(e).Element;
}
function I0(e) {
  return e instanceof HTMLElement || e instanceof Hu(e).HTMLElement;
}
function eR(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Hu(e).ShadowRoot;
}
function n3(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: l,
    display: h
  } = Es(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + l + a) && !["inline", "contents"].includes(h);
}
function EN(e) {
  return ["table", "td", "th"].includes(vh(e));
}
function MN(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function wx(e) {
  const t = yx(), a = L0(e) ? Es(e) : e;
  return a.transform !== "none" || a.perspective !== "none" || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((l) => (a.willChange || "").includes(l)) || ["paint", "layout", "strict", "content"].some((l) => (a.contain || "").includes(l));
}
function TN(e) {
  let t = jp(e);
  for (; I0(t) && !lw(t); ) {
    if (wx(t))
      return t;
    if (MN(t))
      return null;
    t = jp(t);
  }
  return null;
}
function yx() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function lw(e) {
  return ["html", "body", "#document"].includes(vh(e));
}
function Es(e) {
  return Hu(e).getComputedStyle(e);
}
function ow(e) {
  return L0(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function jp(e) {
  if (vh(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    eR(e) && e.host || // Fallback.
    gf(e)
  );
  return eR(t) ? t.host : t;
}
function AM(e) {
  const t = jp(e);
  return lw(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : I0(t) && n3(t) ? t : AM(t);
}
function Z4(e, t, a) {
  var l;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const h = AM(e), g = h === ((l = e.ownerDocument) == null ? void 0 : l.body), m = Hu(h);
  if (g) {
    const S = ON(m);
    return t.concat(m, m.visualViewport || [], n3(h) ? h : [], S && a ? Z4(S) : []);
  }
  return t.concat(h, Z4(h, [], a));
}
function ON(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function kM(e) {
  const t = Es(e);
  let a = parseFloat(t.width) || 0, l = parseFloat(t.height) || 0;
  const h = I0(e), g = h ? e.offsetWidth : a, m = h ? e.offsetHeight : l, S = R5(a) !== g || R5(l) !== m;
  return S && (a = g, l = m), {
    width: a,
    height: l,
    $: S
  };
}
function xx(e) {
  return L0(e) ? e : e.contextElement;
}
function _p(e) {
  const t = xx(e);
  if (!I0(t))
    return fh(1);
  const a = t.getBoundingClientRect(), {
    width: l,
    height: h,
    $: g
  } = kM(t);
  let m = (g ? R5(a.width) : a.width) / l, S = (g ? R5(a.height) : a.height) / h;
  return (!m || !Number.isFinite(m)) && (m = 1), (!S || !Number.isFinite(S)) && (S = 1), {
    x: m,
    y: S
  };
}
const DN = /* @__PURE__ */ fh(0);
function LM(e) {
  const t = Hu(e);
  return !yx() || !t.visualViewport ? DN : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function jN(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== Hu(e) ? !1 : t;
}
function V2(e, t, a, l) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const h = e.getBoundingClientRect(), g = xx(e);
  let m = fh(1);
  t && (l ? L0(l) && (m = _p(l)) : m = _p(e));
  const S = jN(g, a, l) ? LM(g) : fh(0);
  let b = (h.left + S.x) / m.x, R = (h.top + S.y) / m.y, D = h.width / m.x, T = h.height / m.y;
  if (g) {
    const j = Hu(g), A = l && L0(l) ? Hu(l) : l;
    let L = j, P = L.frameElement;
    for (; P && l && A !== L; ) {
      const N = _p(P), F = P.getBoundingClientRect(), Y = Es(P), G = F.left + (P.clientLeft + parseFloat(Y.paddingLeft)) * N.x, z = F.top + (P.clientTop + parseFloat(Y.paddingTop)) * N.y;
      b *= N.x, R *= N.y, D *= N.x, T *= N.y, b += G, R += z, L = Hu(P), P = L.frameElement;
    }
  }
  return M5({
    width: D,
    height: T,
    x: b,
    y: R
  });
}
const AN = [":popover-open", ":modal"];
function IM(e) {
  return AN.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function kN(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: l,
    strategy: h
  } = e;
  const g = h === "fixed", m = gf(l), S = t ? IM(t.floating) : !1;
  if (l === m || S && g)
    return a;
  let b = {
    scrollLeft: 0,
    scrollTop: 0
  }, R = fh(1);
  const D = fh(0), T = I0(l);
  if ((T || !T && !g) && ((vh(l) !== "body" || n3(m)) && (b = ow(l)), I0(l))) {
    const j = V2(l);
    R = _p(l), D.x = j.x + l.clientLeft, D.y = j.y + l.clientTop;
  }
  return {
    width: a.width * R.x,
    height: a.height * R.y,
    x: a.x * R.x - b.scrollLeft * R.x + D.x,
    y: a.y * R.y - b.scrollTop * R.y + D.y
  };
}
function LN(e) {
  return Array.from(e.getClientRects());
}
function HM(e) {
  return V2(gf(e)).left + ow(e).scrollLeft;
}
function IN(e) {
  const t = gf(e), a = ow(e), l = e.ownerDocument.body, h = Lu(t.scrollWidth, t.clientWidth, l.scrollWidth, l.clientWidth), g = Lu(t.scrollHeight, t.clientHeight, l.scrollHeight, l.clientHeight);
  let m = -a.scrollLeft + HM(e);
  const S = -a.scrollTop;
  return Es(l).direction === "rtl" && (m += Lu(t.clientWidth, l.clientWidth) - h), {
    width: h,
    height: g,
    x: m,
    y: S
  };
}
function HN(e, t) {
  const a = Hu(e), l = gf(e), h = a.visualViewport;
  let g = l.clientWidth, m = l.clientHeight, S = 0, b = 0;
  if (h) {
    g = h.width, m = h.height;
    const R = yx();
    (!R || R && t === "fixed") && (S = h.offsetLeft, b = h.offsetTop);
  }
  return {
    width: g,
    height: m,
    x: S,
    y: b
  };
}
function ZN(e, t) {
  const a = V2(e, !0, t === "fixed"), l = a.top + e.clientTop, h = a.left + e.clientLeft, g = I0(e) ? _p(e) : fh(1), m = e.clientWidth * g.x, S = e.clientHeight * g.y, b = h * g.x, R = l * g.y;
  return {
    width: m,
    height: S,
    x: b,
    y: R
  };
}
function tR(e, t, a) {
  let l;
  if (t === "viewport")
    l = HN(e, a);
  else if (t === "document")
    l = IN(gf(e));
  else if (L0(t))
    l = ZN(t, a);
  else {
    const h = LM(e);
    l = {
      ...t,
      x: t.x - h.x,
      y: t.y - h.y
    };
  }
  return M5(l);
}
function ZM(e, t) {
  const a = jp(e);
  return a === t || !L0(a) || lw(a) ? !1 : Es(a).position === "fixed" || ZM(a, t);
}
function PN(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let l = Z4(e, [], !1).filter((S) => L0(S) && vh(S) !== "body"), h = null;
  const g = Es(e).position === "fixed";
  let m = g ? jp(e) : e;
  for (; L0(m) && !lw(m); ) {
    const S = Es(m), b = wx(m);
    !b && S.position === "fixed" && (h = null), (g ? !b && !h : !b && S.position === "static" && !!h && ["absolute", "fixed"].includes(h.position) || n3(m) && !b && ZM(e, m)) ? l = l.filter((D) => D !== m) : h = S, m = jp(m);
  }
  return t.set(e, l), l;
}
function NN(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: l,
    strategy: h
  } = e;
  const m = [...a === "clippingAncestors" ? PN(t, this._c) : [].concat(a), l], S = m[0], b = m.reduce((R, D) => {
    const T = tR(t, D, h);
    return R.top = Lu(T.top, R.top), R.right = D0(T.right, R.right), R.bottom = D0(T.bottom, R.bottom), R.left = Lu(T.left, R.left), R;
  }, tR(t, S, h));
  return {
    width: b.right - b.left,
    height: b.bottom - b.top,
    x: b.left,
    y: b.top
  };
}
function VN(e) {
  const {
    width: t,
    height: a
  } = kM(e);
  return {
    width: t,
    height: a
  };
}
function BN(e, t, a) {
  const l = I0(t), h = gf(t), g = a === "fixed", m = V2(e, !0, g, t);
  let S = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const b = fh(0);
  if (l || !l && !g)
    if ((vh(t) !== "body" || n3(h)) && (S = ow(t)), l) {
      const T = V2(t, !0, g, t);
      b.x = T.x + t.clientLeft, b.y = T.y + t.clientTop;
    } else h && (b.x = HM(h));
  const R = m.left + S.scrollLeft - b.x, D = m.top + S.scrollTop - b.y;
  return {
    x: R,
    y: D,
    width: m.width,
    height: m.height
  };
}
function nR(e, t) {
  return !I0(e) || Es(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function PM(e, t) {
  const a = Hu(e);
  if (!I0(e) || IM(e))
    return a;
  let l = nR(e, t);
  for (; l && EN(l) && Es(l).position === "static"; )
    l = nR(l, t);
  return l && (vh(l) === "html" || vh(l) === "body" && Es(l).position === "static" && !wx(l)) ? a : l || TN(e) || a;
}
const FN = async function(e) {
  const t = this.getOffsetParent || PM, a = this.getDimensions;
  return {
    reference: BN(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await a(e.floating)
    }
  };
};
function UN(e) {
  return Es(e).direction === "rtl";
}
const YN = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kN,
  getDocumentElement: gf,
  getClippingRect: NN,
  getOffsetParent: PM,
  getElementRects: FN,
  getClientRects: LN,
  getDimensions: VN,
  getScale: _p,
  isElement: L0,
  isRTL: UN
};
function $N(e, t) {
  let a = null, l;
  const h = gf(e);
  function g() {
    var S;
    clearTimeout(l), (S = a) == null || S.disconnect(), a = null;
  }
  function m(S, b) {
    S === void 0 && (S = !1), b === void 0 && (b = 1), g();
    const {
      left: R,
      top: D,
      width: T,
      height: j
    } = e.getBoundingClientRect();
    if (S || t(), !T || !j)
      return;
    const A = i5(D), L = i5(h.clientWidth - (R + T)), P = i5(h.clientHeight - (D + j)), N = i5(R), Y = {
      rootMargin: -A + "px " + -L + "px " + -P + "px " + -N + "px",
      threshold: Lu(0, D0(1, b)) || 1
    };
    let G = !0;
    function z($) {
      const ce = $[0].intersectionRatio;
      if (ce !== b) {
        if (!G)
          return m();
        ce ? m(!1, ce) : l = setTimeout(() => {
          m(!1, 1e-7);
        }, 100);
      }
      G = !1;
    }
    try {
      a = new IntersectionObserver(z, {
        ...Y,
        // Handle <iframe>s
        root: h.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(z, Y);
    }
    a.observe(e);
  }
  return m(!0), g;
}
function WN(e, t, a, l) {
  l === void 0 && (l = {});
  const {
    ancestorScroll: h = !0,
    ancestorResize: g = !0,
    elementResize: m = typeof ResizeObserver == "function",
    layoutShift: S = typeof IntersectionObserver == "function",
    animationFrame: b = !1
  } = l, R = xx(e), D = h || g ? [...R ? Z4(R) : [], ...Z4(t)] : [];
  D.forEach((F) => {
    h && F.addEventListener("scroll", a, {
      passive: !0
    }), g && F.addEventListener("resize", a);
  });
  const T = R && S ? $N(R, a) : null;
  let j = -1, A = null;
  m && (A = new ResizeObserver((F) => {
    let [Y] = F;
    Y && Y.target === R && A && (A.unobserve(t), cancelAnimationFrame(j), j = requestAnimationFrame(() => {
      var G;
      (G = A) == null || G.observe(t);
    })), a();
  }), R && !b && A.observe(R), A.observe(t));
  let L, P = b ? V2(e) : null;
  b && N();
  function N() {
    const F = V2(e);
    P && (F.x !== P.x || F.y !== P.y || F.width !== P.width || F.height !== P.height) && a(), P = F, L = requestAnimationFrame(N);
  }
  return a(), () => {
    var F;
    D.forEach((Y) => {
      h && Y.removeEventListener("scroll", a), g && Y.removeEventListener("resize", a);
    }), T == null || T(), (F = A) == null || F.disconnect(), A = null, b && cancelAnimationFrame(L);
  };
}
const zN = bN, qN = xN, GN = RN, KN = yN, QN = _N, XN = (e, t, a) => {
  const l = /* @__PURE__ */ new Map(), h = {
    platform: YN,
    ...a
  }, g = {
    ...h.platform,
    _c: l
  };
  return wN(e, t, {
    ...h,
    platform: g
  });
};
var JN = "div";
function rR(e = 0, t = 0, a = 0, l = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(e, t, a, l);
  const h = {
    x: e,
    y: t,
    width: a,
    height: l,
    top: t,
    right: e + a,
    bottom: t + l,
    left: e
  };
  return Oe(Q({}, h), { toJSON: () => h });
}
function eV(e) {
  if (!e)
    return rR();
  const { x: t, y: a, width: l, height: h } = e;
  return rR(t, a, l, h);
}
function tV(e, t) {
  return {
    contextElement: e || void 0,
    getBoundingClientRect: () => {
      const l = e, h = t == null ? void 0 : t(l);
      return h || !l ? eV(h) : l.getBoundingClientRect();
    }
  };
}
function nV(e) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(e);
}
function aR(e) {
  const t = window.devicePixelRatio || 1;
  return Math.round(e * t) / t;
}
function rV(e, t) {
  return CN(({ placement: a }) => {
    var l;
    const h = ((e == null ? void 0 : e.clientHeight) || 0) / 2, g = typeof t.gutter == "number" ? t.gutter + h : (l = t.gutter) != null ? l : h;
    return {
      crossAxis: !!a.split("-")[1] ? void 0 : t.shift,
      mainAxis: g,
      alignmentAxis: t.shift
    };
  });
}
function aV(e) {
  if (e.flip === !1)
    return;
  const t = typeof e.flip == "string" ? e.flip.split(" ") : void 0;
  return Ht(
    !t || t.every(nV),
    process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements"
  ), qN({
    padding: e.overflowPadding,
    fallbackPlacements: t
  });
}
function iV(e) {
  if (!(!e.slide && !e.overlap))
    return zN({
      mainAxis: e.slide,
      crossAxis: e.overlap,
      padding: e.overflowPadding,
      limiter: QN()
    });
}
function lV(e) {
  return GN({
    padding: e.overflowPadding,
    apply({ elements: t, availableWidth: a, availableHeight: l, rects: h }) {
      const g = t.floating, m = Math.round(h.reference.width);
      a = Math.floor(a), l = Math.floor(l), g.style.setProperty(
        "--popover-anchor-width",
        `${m}px`
      ), g.style.setProperty(
        "--popover-available-width",
        `${a}px`
      ), g.style.setProperty(
        "--popover-available-height",
        `${l}px`
      ), e.sameWidth && (g.style.width = `${m}px`), e.fitViewport && (g.style.maxWidth = `${a}px`, g.style.maxHeight = `${l}px`);
    }
  });
}
function oV(e, t) {
  if (e)
    return KN({
      element: e,
      padding: t.arrowPadding
    });
}
var uw = Le(
  function(t) {
    var a = t, {
      store: l,
      modal: h = !1,
      portal: g = !!h,
      preserveTabOrder: m = !0,
      autoFocusOnShow: S = !0,
      wrapperProps: b,
      fixed: R = !1,
      flip: D = !0,
      shift: T = 0,
      slide: j = !0,
      overlap: A = !1,
      sameWidth: L = !1,
      fitViewport: P = !1,
      gutter: N,
      arrowPadding: F = 4,
      overflowPadding: Y = 8,
      getAnchorRect: G,
      updatePosition: z
    } = a, $ = Fe(a, [
      "store",
      "modal",
      "portal",
      "preserveTabOrder",
      "autoFocusOnShow",
      "wrapperProps",
      "fixed",
      "flip",
      "shift",
      "slide",
      "overlap",
      "sameWidth",
      "fitViewport",
      "gutter",
      "arrowPadding",
      "overflowPadding",
      "getAnchorRect",
      "updatePosition"
    ]);
    const ce = rw();
    l = l || ce, Ht(
      l,
      process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component."
    );
    const X = l.useState("arrowElement"), Ce = l.useState("anchorElement"), ae = l.useState("disclosureElement"), me = l.useState("popoverElement"), K = l.useState("contentElement"), we = l.useState("placement"), ue = l.useState("mounted"), ge = l.useState("rendered"), [Te, be] = Qt(!1), { portalRef: Ue, domReady: le } = V8(g, $.portalRef), _e = nt(G), Pe = nt(z), mt = !!z;
    kn(() => {
      if (!(me != null && me.isConnected))
        return;
      me.style.setProperty(
        "--popover-overflow-padding",
        `${Y}px`
      );
      const Nt = tV(Ce, _e), kt = async () => {
        if (!ue)
          return;
        const vt = [
          rV(X, { gutter: N, shift: T }),
          aV({ flip: D, overflowPadding: Y }),
          iV({ slide: j, shift: T, overlap: A, overflowPadding: Y }),
          oV(X, { arrowPadding: F }),
          lV({
            sameWidth: L,
            fitViewport: P,
            overflowPadding: Y
          })
        ], Ot = await XN(Nt, me, {
          placement: we,
          strategy: R ? "fixed" : "absolute",
          middleware: vt
        });
        l == null || l.setState("currentPlacement", Ot.placement), be(!0);
        const yn = aR(Ot.x), Ar = aR(Ot.y);
        if (Object.assign(me.style, {
          top: "0",
          left: "0",
          transform: `translate3d(${yn}px,${Ar}px,0)`
        }), X && Ot.middlewareData.arrow) {
          const { x: In, y: zn } = Ot.middlewareData.arrow, er = Ot.placement.split("-")[0];
          Object.assign(X.style, {
            left: In != null ? `${In}px` : "",
            top: zn != null ? `${zn}px` : "",
            [er]: "100%"
          });
        }
      }, rt = WN(Nt, me, async () => {
        mt ? (await Pe({ updatePosition: kt }), be(!0)) : await kt();
      }, {
        // JSDOM doesn't support ResizeObserver
        elementResize: typeof ResizeObserver == "function"
      });
      return () => {
        be(!1), rt();
      };
    }, [
      l,
      ge,
      me,
      X,
      Ce,
      me,
      we,
      ue,
      le,
      R,
      D,
      T,
      j,
      A,
      L,
      P,
      N,
      F,
      Y,
      _e,
      mt,
      Pe
    ]), kn(() => {
      if (!ue || !le || !(me != null && me.isConnected) || !(K != null && K.isConnected))
        return;
      const Nt = () => {
        me.style.zIndex = getComputedStyle(K).zIndex;
      };
      Nt();
      let kt = requestAnimationFrame(() => {
        kt = requestAnimationFrame(Nt);
      });
      return () => cancelAnimationFrame(kt);
    }, [ue, le, me, K]);
    const Ze = R ? "fixed" : "absolute";
    return $ = Vn(
      $,
      (Nt) => /* @__PURE__ */ f.jsx(
        "div",
        Oe(Q({}, b), {
          style: Q({
            // https://floating-ui.com/docs/computeposition#initial-layout
            position: Ze,
            top: 0,
            left: 0,
            width: "max-content"
          }, b == null ? void 0 : b.style),
          ref: l == null ? void 0 : l.setPopoverElement,
          children: Nt
        })
      ),
      [l, Ze, b]
    ), $ = Vn(
      $,
      (Nt) => /* @__PURE__ */ f.jsx(e3, { value: l, children: Nt }),
      [l]
    ), $ = Oe(Q({
      // data-placing is not part of the public API. We're setting this here so
      // we can wait for the popover to be positioned before other components
      // move focus into it. For example, this attribute is observed by the
      // Combobox component with the autoSelect behavior.
      "data-placing": !Te || void 0
    }, $), {
      style: Q({
        position: "relative"
      }, $.style)
    }), $ = hM(Oe(Q({
      store: l,
      modal: h,
      portal: g,
      preserveTabOrder: m,
      preserveTabOrderAnchor: ae || Ce,
      autoFocusOnShow: Te && S
    }, $), {
      portalRef: Ue
    })), $;
  }
), NM = $2(
  De(function(t) {
    const a = uw(t);
    return ke(JN, a);
  }),
  rw
), uV = "div";
function sV(e, ...t) {
  if (!e)
    return !1;
  if ("id" in e) {
    const a = t.filter(Boolean).map((l) => `[aria-controls~="${l}"]`).join(", ");
    return a ? A8(e, a) : !1;
  }
  return !1;
}
var cV = Le(
  function(t) {
    var a = t, {
      store: l,
      modal: h,
      tabIndex: g,
      alwaysVisible: m,
      autoFocusOnHide: S = !0,
      hideOnInteractOutside: b = !0
    } = a, R = Fe(a, [
      "store",
      "modal",
      "tabIndex",
      "alwaysVisible",
      "autoFocusOnHide",
      "hideOnInteractOutside"
    ]);
    const D = Rh();
    l = l || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxPopover must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const T = l.useState("baseElement"), j = Pt(!1), A = ja(
      l.tag,
      (L) => L == null ? void 0 : L.renderedItems.length
    );
    return R = OM(Q({ store: l, alwaysVisible: m }, R)), R = uw(Oe(Q({
      store: l,
      modal: h,
      alwaysVisible: m,
      backdrop: !1,
      autoFocusOnShow: !1,
      finalFocus: T,
      preserveTabOrderAnchor: null,
      unstable_treeSnapshotKey: A
    }, R), {
      // When the combobox popover is modal, we make sure to include the
      // combobox input and all the combobox controls (cancel, disclosure) in
      // the list of persistent elements so they make part of the modal context,
      // allowing users to tab through them.
      getPersistentElements() {
        var L;
        const P = ((L = R.getPersistentElements) == null ? void 0 : L.call(R)) || [];
        if (!h || !l)
          return P;
        const { contentElement: N, baseElement: F } = l.getState();
        if (!F)
          return P;
        const Y = Qr(F), G = [];
        if (N != null && N.id && G.push(`[aria-controls~="${N.id}"]`), F != null && F.id && G.push(`[aria-controls~="${F.id}"]`), !G.length)
          return [...P, F];
        const z = G.join(","), $ = Y.querySelectorAll(z);
        return [...P, ...$];
      },
      // The combobox popover should focus on the combobox input when it hides,
      // unless the event was triggered by a click outside the popover, in which
      // case the input shouldn't be re-focused.
      autoFocusOnHide(L) {
        return I2(S, L) ? !1 : j.current ? (j.current = !1, !1) : !0;
      },
      // Make sure we don't hide the popover when the user interacts with the
      // combobox cancel or the combobox disclosure buttons. They will have the
      // aria-controls attribute pointing to either the combobox input or the
      // combobox popover elements.
      hideOnInteractOutside(L) {
        var P, N;
        const F = l == null ? void 0 : l.getState(), Y = (P = F == null ? void 0 : F.contentElement) == null ? void 0 : P.id, G = (N = F == null ? void 0 : F.baseElement) == null ? void 0 : N.id;
        if (sV(L.target, Y, G))
          return !1;
        const z = typeof b == "function" ? b(L) : b;
        return z && (j.current = L.type === "click"), z;
      }
    })), R;
  }
), VM = $2(
  De(function(t) {
    const a = cV(t);
    return ke(uV, a);
  }),
  Rh
), fV = "div", dV = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = Hp();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const m = l.useState("contentElement"), b = ph(m) === "grid" ? "row" : "presentation";
    return h = Q({ role: b }, h), h = sx(Q({ store: l }, h)), h;
  }
), hV = De(function(t) {
  const a = dV(t);
  return ke(fV, a);
}), vV = "hr", pV = Le(function(t) {
  var a = t, { store: l } = a, h = Fe(a, ["store"]);
  const g = Hp();
  return l = l || g, Ht(
    l,
    process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component."
  ), h = K4(Q({ store: l }, h)), h;
}), mV = De(function(t) {
  const a = pV(t);
  return ke(vV, a);
});
function BM(e = {}) {
  const t = cx(e);
  return /* @__PURE__ */ f.jsx(aw, { value: t, children: e.children });
}
var iR = "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z", gV = "div", f8 = 30, rh = f8 / 2, wV = {
  top: `rotate(180 ${rh} ${rh})`,
  right: `rotate(-90 ${rh} ${rh})`,
  bottom: `rotate(0 ${rh} ${rh})`,
  left: `rotate(90 ${rh} ${rh})`
};
function yV(e) {
  const [t, a] = Qt(), l = e.useState("contentElement");
  return kn(() => {
    if (!l)
      return;
    const g = hE(l).getComputedStyle(l);
    a(g);
  }, [l]), t;
}
var sw = Le(
  function(t) {
    var a = t, { store: l, size: h = f8 } = a, g = Fe(a, ["store", "size"]);
    const m = _h();
    l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "PopoverArrow must be wrapped in a Popover component."
    );
    const S = l.useState(
      (P) => P.currentPlacement.split("-")[0]
    ), b = yV(l), R = (b == null ? void 0 : b.getPropertyValue("background-color")) || "none", D = (b == null ? void 0 : b.getPropertyValue(`border-${S}-color`)) || "none", T = (b == null ? void 0 : b.getPropertyValue(`border-${S}-width`)) || "0px", j = parseInt(T) * 2 * (f8 / h), A = wV[S], L = Ur(
      () => /* @__PURE__ */ f.jsx("svg", { display: "block", viewBox: "0 0 30 30", children: /* @__PURE__ */ f.jsxs("g", { transform: A, children: [
        /* @__PURE__ */ f.jsx("path", { fill: "none", d: iR }),
        /* @__PURE__ */ f.jsx("path", { stroke: "none", d: iR })
      ] }) }),
      [A]
    );
    return g = Oe(Q({
      children: L,
      "aria-hidden": !0
    }, g), {
      ref: Ln(l.setArrowElement, g.ref),
      style: Q({
        // server side rendering
        position: "absolute",
        fontSize: h,
        width: "1em",
        height: "1em",
        pointerEvents: "none",
        fill: R,
        stroke: D,
        strokeWidth: j
      }, g.style)
    }), La(g);
  }
), Pp = De(function(t) {
  const a = sw(t);
  return ke(gV, a);
}), xV = "p", FM = Le(function(t) {
  return t = vM(t), t;
}), SV = De(function(t) {
  const a = FM(t);
  return ke(xV, a);
}), CV = "span", bV = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
}, Sx = Le(function(t) {
  var a = t, { store: l, placement: h } = a, g = Fe(a, ["store", "placement"]);
  const m = _h();
  l = l || m, Ht(
    l,
    process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component."
  );
  const b = l.useState((T) => h || T.placement).split("-")[0], R = bV[b], D = Ur(
    () => /* @__PURE__ */ f.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ f.jsx("polyline", { points: R })
      }
    ),
    [R]
  );
  return g = Oe(Q({
    children: D,
    "aria-hidden": !0
  }, g), {
    style: Q({
      width: "1em",
      height: "1em",
      pointerEvents: "none"
    }, g.style)
  }), La(g);
}), _V = De(
  function(t) {
    const a = Sx(t);
    return ke(CV, a);
  }
), RV = "button", Cx = Le(function(t) {
  var a = t, { store: l } = a, h = Fe(a, ["store"]);
  const g = rw();
  l = l || g, Ht(
    l,
    process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component."
  );
  const m = h.onClick, S = nt((b) => {
    l == null || l.setAnchorElement(b.currentTarget), m == null || m(b);
  });
  return h = Vn(
    h,
    (b) => /* @__PURE__ */ f.jsx(e3, { value: l, children: b }),
    [l]
  ), h = Oe(Q({}, h), {
    onClick: S
  }), h = dx(Q({ store: l }, h)), h = Q5(Q({ store: l }, h)), h;
}), cw = De(function(t) {
  const a = Cx(t);
  return ke(RV, a);
}), EV = "button", UM = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = TP();
    return l = l || g, h = pM(Q({ store: l }, h)), h;
  }
), MV = De(function(t) {
  const a = UM(t);
  return ke(EV, a);
}), TV = "h1", YM = Le(
  function(t) {
    return t = gM(t), t;
  }
), OV = De(function(t) {
  const a = YM(t);
  return ke(TV, a);
}), r3 = bl(
  [Z0],
  [xh]
), bx = r3.useContext, DV = r3.useScopedContext, jV = r3.useProviderContext, AV = r3.ContextProvider, kV = r3.ScopedContextProvider;
ka(
  void 0
);
function LV(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState(), l = Sh(gn(_t({}, e), {
    orientation: st(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "horizontal"
    ),
    focusLoop: st(e.focusLoop, a == null ? void 0 : a.focusLoop, !0)
  })), h = _t({}, l.getState()), g = fi(h, l, e.store);
  return _t(_t({}, l), g);
}
function IV(e, t, a) {
  return Ch(e, t, a);
}
function fw(e = {}) {
  const [t, a] = Cl(LV, e);
  return IV(t, a, e);
}
var HV = "div", $M = Le(
  function(t) {
    var a = t, {
      store: l,
      composite: h = !0,
      orientation: g,
      virtualFocus: m,
      focusLoop: S,
      rtl: b
    } = a, R = Fe(a, [
      "store",
      "composite",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const D = jV();
    l = l || D;
    const T = fw({
      store: l,
      orientation: g,
      virtualFocus: m,
      focusLoop: S,
      rtl: b
    }), j = T.useState(
      (A) => !h || A.orientation === "both" ? void 0 : A.orientation
    );
    return R = Vn(
      R,
      (A) => /* @__PURE__ */ f.jsx(kV, { value: T, children: A }),
      [T]
    ), h && (R = Q({
      role: "menubar",
      "aria-orientation": j
    }, R)), R = bh(Q({ store: T, composite: h }, R)), R;
  }
), ZV = De(function(t) {
  const a = $M(t);
  return ke(HV, a);
});
function WM(e = {}) {
  const t = fw(e);
  return /* @__PURE__ */ f.jsx(AV, { value: t, children: e.children });
}
var a3 = bl(
  [aw],
  [e3]
), zM = a3.useContext, PV = a3.useScopedContext, dw = a3.useProviderContext, _x = a3.ContextProvider, Rx = a3.ScopedContextProvider, i3 = bl(
  [Z0, _x],
  [xh, Rx]
), wf = i3.useContext, hw = i3.useScopedContext, vw = i3.useProviderContext, qM = i3.ContextProvider, NV = i3.ScopedContextProvider, VV = bx, GM = ka(
  void 0
);
function Ex(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState(), l = tw(gn(_t({}, e), {
    placement: st(
      e.placement,
      a == null ? void 0 : a.placement,
      "bottom"
    )
  })), h = st(e.timeout, a == null ? void 0 : a.timeout, 500), g = gn(_t({}, l.getState()), {
    timeout: h,
    showTimeout: st(e.showTimeout, a == null ? void 0 : a.showTimeout),
    hideTimeout: st(e.hideTimeout, a == null ? void 0 : a.hideTimeout),
    autoFocusOnShow: st(a == null ? void 0 : a.autoFocusOnShow, !1)
  }), m = fi(g, l, e.store);
  return gn(_t(_t({}, l), m), {
    setAutoFocusOnShow: (S) => m.setState("autoFocusOnShow", S)
  });
}
function Mx(e, t, a) {
  return lr(e, a, "timeout"), lr(e, a, "showTimeout"), lr(e, a, "hideTimeout"), nw(e, t, a);
}
function KM(e = {}) {
  const [t, a] = Cl(Ex, e);
  return Mx(t, a, e);
}
function BV(e = {}) {
  var t = e, {
    combobox: a,
    parent: l,
    menubar: h
  } = t, g = Ap(t, [
    "combobox",
    "parent",
    "menubar"
  ]);
  const m = !!h && !l, S = Lp(
    g.store,
    bE(l, ["values"]),
    Op(a, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  gh(g, S);
  const b = S.getState(), R = Sh(gn(_t({}, g), {
    store: S,
    orientation: st(
      g.orientation,
      b.orientation,
      "vertical"
    )
  })), D = Ex(gn(_t({}, g), {
    store: S,
    placement: st(
      g.placement,
      b.placement,
      "bottom-start"
    ),
    timeout: st(
      g.timeout,
      b.timeout,
      m ? 0 : 150
    ),
    hideTimeout: st(g.hideTimeout, b.hideTimeout, 0)
  })), T = gn(_t(_t({}, R.getState()), D.getState()), {
    initialFocus: st(b.initialFocus, "container"),
    values: st(
      g.values,
      b.values,
      g.defaultValues,
      {}
    )
  }), j = fi(T, R, D, S);
  return Aa(
    j,
    () => xa(j, ["mounted"], (A) => {
      A.mounted || j.setState("activeId", null);
    })
  ), Aa(
    j,
    () => xa(l, ["orientation"], (A) => {
      j.setState(
        "placement",
        A.orientation === "vertical" ? "right-start" : "bottom-start"
      );
    })
  ), gn(_t(_t(_t({}, R), D), j), {
    combobox: a,
    parent: l,
    menubar: h,
    hideAll: () => {
      D.hide(), l == null || l.hideAll();
    },
    setInitialFocus: (A) => j.setState("initialFocus", A),
    setValues: (A) => j.setState("values", A),
    setValue: (A, L) => {
      A !== "__proto__" && A !== "constructor" && (Array.isArray(A) || j.setState("values", (P) => {
        const N = P[A], F = T4(L, N);
        return F === N ? P : gn(_t({}, P), {
          [A]: F !== void 0 && F
        });
      }));
    }
  });
}
function FV(e, t, a) {
  return b1(t, [a.combobox, a.parent, a.menubar]), lr(e, a, "values", "setValues"), Object.assign(
    Mx(
      Ch(e, t, a),
      t,
      a
    ),
    {
      combobox: a.combobox,
      parent: a.parent,
      menubar: a.menubar
    }
  );
}
function Tx(e = {}) {
  const t = wf(), a = bx(), l = Rh();
  e = Oe(Q({}, e), {
    parent: e.parent !== void 0 ? e.parent : t,
    menubar: e.menubar !== void 0 ? e.menubar : a,
    combobox: e.combobox !== void 0 ? e.combobox : l
  });
  const [h, g] = Cl(BV, e);
  return FV(h, g, e);
}
function UV(e = {}) {
  return gt(() => {
    process.env.NODE_ENV !== "production" && console.warn(
      "useMenuBarStore is deprecated. Use useMenubarStore instead.",
      "See https://ariakit.org/reference/use-menubar-store"
    );
  }, []), fw(e);
}
var YV = "div";
function $V(e) {
  var t = e, { store: a } = t, l = Fe(t, ["store"]);
  const [h, g] = Qt(void 0), m = l["aria-label"], S = ja(a, "disclosureElement"), b = ja(a, "contentElement");
  return gt(() => {
    const R = S;
    if (!R)
      return;
    const D = b;
    if (!D)
      return;
    m || D.hasAttribute("aria-label") ? g(void 0) : R.id && g(R.id);
  }, [m, S, b]), h;
}
var QM = Le(
  function(t) {
    var a = t, { store: l, alwaysVisible: h, composite: g } = a, m = Fe(a, ["store", "alwaysVisible", "composite"]);
    const S = vw();
    l = l || S, Ht(
      l,
      process.env.NODE_ENV !== "production" && "MenuList must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const b = l.parent, R = l.menubar, D = !!b, T = Ia(m.id), j = m.onKeyDown, A = l.useState(
      (X) => X.placement.split("-")[0]
    ), L = l.useState(
      (X) => X.orientation === "both" ? void 0 : X.orientation
    ), P = L !== "vertical", N = ja(
      R,
      (X) => !!X && X.orientation !== "vertical"
    ), F = nt((X) => {
      if (j == null || j(X), !X.defaultPrevented) {
        if (D || R && !P) {
          const ae = {
            ArrowRight: () => A === "left" && !P,
            ArrowLeft: () => A === "right" && !P,
            ArrowUp: () => A === "bottom" && P,
            ArrowDown: () => A === "top" && P
          }[X.key];
          if (ae != null && ae())
            return X.stopPropagation(), X.preventDefault(), l == null ? void 0 : l.hide();
        }
        if (R) {
          const ae = {
            ArrowRight: () => {
              if (N)
                return R.next();
            },
            ArrowLeft: () => {
              if (N)
                return R.previous();
            },
            ArrowDown: () => {
              if (!N)
                return R.next();
            },
            ArrowUp: () => {
              if (!N)
                return R.previous();
            }
          }[X.key], me = ae == null ? void 0 : ae();
          me !== void 0 && (X.stopPropagation(), X.preventDefault(), R.move(me));
        }
      }
    });
    m = Vn(
      m,
      (X) => /* @__PURE__ */ f.jsx(NV, { value: l, children: X }),
      [l]
    );
    const Y = $V(Q({ store: l }, m)), G = l.useState("mounted"), z = z4(G, m.hidden, h), $ = z ? Oe(Q({}, m.style), { display: "none" }) : m.style;
    m = Oe(Q({
      id: T,
      "aria-labelledby": Y,
      hidden: z
    }, m), {
      ref: Ln(T ? l.setContentElement : null, m.ref),
      style: $,
      onKeyDown: F
    });
    const ce = !!l.combobox;
    return g = g ?? !ce, g && (m = Q({
      role: "menu",
      "aria-orientation": L
    }, m)), m = bh(Q({ store: l, composite: g }, m)), m = Q4(Q({ store: l, typeahead: !ce }, m)), m;
  }
), WV = De(function(t) {
  const a = QM(t);
  return ke(YV, a);
});
function Ly(e) {
  return [e.clientX, e.clientY];
}
function lR(e, t) {
  const [a, l] = e;
  let h = !1;
  const g = t.length;
  for (let m = g, S = 0, b = m - 1; S < m; b = S++) {
    const [R, D] = t[S], [T, j] = t[b], [, A] = t[b === 0 ? m - 1 : b - 1] || [0, 0], L = (D - j) * (a - R) - (R - T) * (l - D);
    if (j < D) {
      if (l >= j && l < D) {
        if (L === 0)
          return !0;
        L > 0 && (l === j ? l > A && (h = !h) : h = !h);
      }
    } else if (D < j) {
      if (l > D && l <= j) {
        if (L === 0)
          return !0;
        L < 0 && (l === j ? l < A && (h = !h) : h = !h);
      }
    } else if (l == D && (a >= T && a <= R || a >= R && a <= T))
      return !0;
  }
  return h;
}
function zV(e, t) {
  const { top: a, right: l, bottom: h, left: g } = t, [m, S] = e, b = m < g ? "left" : m > l ? "right" : null, R = S < a ? "top" : S > h ? "bottom" : null;
  return [b, R];
}
function oR(e, t) {
  const a = e.getBoundingClientRect(), { top: l, right: h, bottom: g, left: m } = a, [S, b] = zV(t, a), R = [t];
  return S ? (b !== "top" && R.push([S === "left" ? m : h, l]), R.push([S === "left" ? h : m, l]), R.push([S === "left" ? h : m, g]), b !== "bottom" && R.push([S === "left" ? m : h, g])) : b === "top" ? (R.push([m, l]), R.push([m, g]), R.push([h, g]), R.push([h, l])) : (R.push([m, g]), R.push([m, l]), R.push([h, l]), R.push([h, g])), R;
}
var qV = "div";
function XM(e, t, a, l) {
  return sh(t) ? !0 : e ? !!(ha(t, e) || a && ha(a, e) || l != null && l.some((h) => XM(e, h, a))) : !1;
}
function GV(e) {
  var t = e, {
    store: a
  } = t, l = Fe(t, [
    "store"
  ]);
  const [h, g] = Qt(!1), m = a.useState("mounted");
  gt(() => {
    m || g(!1);
  }, [m]);
  const S = l.onFocus, b = nt((D) => {
    S == null || S(D), !D.defaultPrevented && g(!0);
  }), R = Pt(null);
  return gt(() => xa(a, ["anchorElement"], (D) => {
    R.current = D.anchorElement;
  }), []), l = Oe(Q({
    autoFocusOnHide: h,
    finalFocus: R
  }, l), {
    onFocus: b
  }), l;
}
var uR = ka(null), Ox = Le(
  function(t) {
    var a = t, {
      store: l,
      modal: h = !1,
      portal: g = !!h,
      hideOnEscape: m = !0,
      hideOnHoverOutside: S = !0,
      disablePointerEventsOnApproach: b = !!S
    } = a, R = Fe(a, [
      "store",
      "modal",
      "portal",
      "hideOnEscape",
      "hideOnHoverOutside",
      "disablePointerEventsOnApproach"
    ]);
    const D = dw();
    l = l || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "Hovercard must receive a `store` prop or be wrapped in a HovercardProvider component."
    );
    const T = Pt(null), [j, A] = Qt([]), L = Pt(0), P = Pt(null), { portalRef: N, domReady: F } = V8(g, R.portalRef), Y = !!S, G = Jn(S), z = !!b, $ = Jn(
      b
    ), ce = l.useState("open"), X = l.useState("mounted");
    gt(() => {
      if (!F || !X || !Y && !z)
        return;
      const we = T.current;
      return we ? _o(
        Fi("mousemove", (ge) => {
          if (!l)
            return;
          const { anchorElement: Te, hideTimeout: be, timeout: Ue } = l.getState(), le = P.current, [_e] = ge.composedPath(), Pe = Te;
          if (XM(_e, we, Pe, j)) {
            P.current = _e && Pe && ha(Pe, _e) ? Ly(ge) : null, window.clearTimeout(L.current), L.current = 0;
            return;
          }
          if (!L.current) {
            if (le) {
              const mt = Ly(ge), Ze = oR(we, le);
              if (lR(mt, Ze)) {
                if (P.current = mt, !$(ge))
                  return;
                ge.preventDefault(), ge.stopPropagation();
                return;
              }
            }
            G(ge) && (L.current = window.setTimeout(() => {
              L.current = 0, l == null || l.hide();
            }, be ?? Ue));
          }
        }, !0),
        () => clearTimeout(L.current)
      ) : void 0;
    }, [
      l,
      F,
      X,
      Y,
      z,
      j,
      $,
      G
    ]), gt(() => {
      if (!F || !X || !z)
        return;
      const we = (ue) => {
        const ge = T.current;
        if (!ge)
          return;
        const Te = P.current;
        if (!Te)
          return;
        const be = oR(ge, Te);
        if (lR(Ly(ue), be)) {
          if (!$(ue))
            return;
          ue.preventDefault(), ue.stopPropagation();
        }
      };
      return _o(
        // Note: we may need to add pointer events here in the future.
        Fi("mouseenter", we, !0),
        Fi("mouseover", we, !0),
        Fi("mouseout", we, !0),
        Fi("mouseleave", we, !0)
      );
    }, [F, X, z, $]), gt(() => {
      F && (ce || l == null || l.setAutoFocusOnShow(!1));
    }, [l, F, ce]);
    const Ce = wE(ce);
    gt(() => {
      if (F)
        return () => {
          Ce.current || l == null || l.setAutoFocusOnShow(!1);
        };
    }, [l, F]);
    const ae = Ui(uR);
    kn(() => {
      if (h || !g || !X || !F)
        return;
      const we = T.current;
      if (we)
        return ae == null ? void 0 : ae(we);
    }, [h, g, X, F]);
    const me = Ir(
      (we) => {
        A((ge) => [...ge, we]);
        const ue = ae == null ? void 0 : ae(we);
        return () => {
          A(
            (ge) => ge.filter((Te) => Te !== we)
          ), ue == null || ue();
        };
      },
      [ae]
    );
    R = Vn(
      R,
      (we) => /* @__PURE__ */ f.jsx(Rx, { value: l, children: /* @__PURE__ */ f.jsx(uR.Provider, { value: me, children: we }) }),
      [l, me]
    ), R = Oe(Q({}, R), {
      ref: Ln(T, R.ref)
    }), R = GV(Q({ store: l }, R));
    const K = l.useState(
      (we) => h || we.autoFocusOnShow
    );
    return R = uw(Oe(Q({
      store: l,
      modal: h,
      portal: g,
      autoFocusOnShow: K
    }, R), {
      portalRef: N,
      hideOnEscape(we) {
        return I2(m, we) ? !1 : (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            l == null || l.hide();
          });
        }), !0);
      }
    })), R;
  }
), KV = $2(
  De(function(t) {
    const a = Ox(t);
    return ke(qV, a);
  }),
  dw
), QV = "div", XV = Le(function(t) {
  var a = t, {
    store: l,
    modal: h = !1,
    portal: g = !!h,
    hideOnEscape: m = !0,
    autoFocusOnShow: S = !0,
    hideOnHoverOutside: b,
    alwaysVisible: R
  } = a, D = Fe(a, [
    "store",
    "modal",
    "portal",
    "hideOnEscape",
    "autoFocusOnShow",
    "hideOnHoverOutside",
    "alwaysVisible"
  ]);
  const T = vw();
  l = l || T, Ht(
    l,
    process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component."
  );
  const j = Pt(null), A = l.parent, L = l.menubar, P = !!A, N = !!L && !P;
  D = Oe(Q({}, D), {
    ref: Ln(j, D.ref)
  });
  const F = QM(Q({
    store: l,
    alwaysVisible: R
  }, D)), { "aria-labelledby": Y } = F;
  D = Fe(F, ["aria-labelledby"]);
  const [z, $] = Qt(), ce = l.useState("autoFocusOnShow"), X = l.useState("initialFocus"), Ce = l.useState("baseElement"), ae = l.useState("renderedItems");
  gt(() => {
    let be = !1;
    return $((Ue) => {
      var le, _e, Pe;
      if (be || !ce)
        return;
      if ((le = Ue == null ? void 0 : Ue.current) != null && le.isConnected)
        return Ue;
      const mt = Uk();
      switch (X) {
        case "first":
          mt.current = ((_e = ae.find((Ze) => !Ze.disabled && Ze.element)) == null ? void 0 : _e.element) || null;
          break;
        case "last":
          mt.current = ((Pe = [...ae].reverse().find((Ze) => !Ze.disabled && Ze.element)) == null ? void 0 : Pe.element) || null;
          break;
        default:
          mt.current = Ce;
      }
      return mt;
    }), () => {
      be = !0;
    };
  }, [l, ce, X, ae, Ce]);
  const me = P ? !1 : h, K = !!S, we = !!z || !!D.initialFocus || !!me, ue = ja(
    l.combobox || l,
    "contentElement"
  ), ge = ja(
    (A == null ? void 0 : A.combobox) || A,
    "contentElement"
  ), Te = Ur(() => {
    if (!ge || !ue)
      return;
    const be = ue.getAttribute("role"), Ue = ge.getAttribute("role");
    if (!((Ue === "menu" || Ue === "menubar") && be === "menu"))
      return ge;
  }, [ue, ge]);
  return Te !== void 0 && (D = Q({
    preserveTabOrderAnchor: Te
  }, D)), D = Ox(Oe(Q({
    store: l,
    alwaysVisible: R,
    initialFocus: z,
    autoFocusOnShow: K ? we && S : ce || !!me
  }, D), {
    hideOnEscape(be) {
      return I2(m, be) ? !1 : (l == null || l.hideAll(), !0);
    },
    hideOnHoverOutside(be) {
      const Ue = l == null ? void 0 : l.getState().disclosureElement;
      return (typeof b == "function" ? b(be) : b ?? (P ? !0 : N ? Ue ? !sh(Ue) : !0 : !1)) ? be.defaultPrevented || !P || !Ue || (pL(Ue, "mouseout", be), !sh(Ue)) ? !0 : (requestAnimationFrame(() => {
        sh(Ue) || l == null || l.hide();
      }), !1) : !1;
    },
    modal: me,
    portal: g,
    backdrop: P ? !1 : D.backdrop
  })), D = Q({
    "aria-labelledby": Y
  }, D), D;
}), JM = $2(
  De(function(t) {
    const a = XV(t);
    return ke(QV, a);
  }),
  vw
);
function eT(e = {}) {
  const t = Tx(e);
  return /* @__PURE__ */ f.jsx(qM, { value: t, children: e.children });
}
var JV = "div", eB = Le(
  function(t) {
    return gt(() => {
      process.env.NODE_ENV !== "production" && console.warn(
        "MenuBar is deprecated. Use Menubar instead.",
        "See https://ariakit.org/reference/menubar"
      );
    }, []), $M(t);
  }
), tB = De(function(t) {
  const a = eB(t);
  return ke(JV, a);
});
function nB(e = {}) {
  return gt(() => {
    process.env.NODE_ENV !== "production" && console.warn(
      "MenuBarProvider is deprecated. Use MenubarProvider instead.",
      "See https://ariakit.org/reference/menubar-provider"
    );
  }, []), /* @__PURE__ */ f.jsx(WM, Q({}, e));
}
var rB = "div", aB = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = wf();
    return l = l || g, sw(Q({ store: l }, h));
  }
), tT = De(function(t) {
  const a = aB(t);
  return ke(rB, a);
}), iB = "span", lB = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = wf();
    return l = l || g, h = Sx(Q({ store: l }, h)), h;
  }
), oB = De(function(t) {
  const a = lB(t);
  return ke(iB, a);
}), uB = "a", Dx = Le(
  function(t) {
    var a = t, { store: l, showOnHover: h = !0 } = a, g = Fe(a, ["store", "showOnHover"]);
    const m = dw();
    l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "HovercardAnchor must receive a `store` prop or be wrapped in a HovercardProvider component."
    );
    const S = pf(g), b = Pt(0);
    gt(() => () => window.clearTimeout(b.current), []), gt(() => Fi("mouseleave", (F) => {
      if (!l)
        return;
      const { anchorElement: Y } = l.getState();
      Y && F.target === Y && (window.clearTimeout(b.current), b.current = 0);
    }, !0), [l]);
    const R = g.onMouseMove, D = Jn(h), T = SE(), j = nt((N) => {
      if (R == null || R(N), S || !l || N.defaultPrevented || b.current || !T() || !D(N))
        return;
      const F = N.currentTarget;
      l.setAnchorElement(F), l.setDisclosureElement(F);
      const { showTimeout: Y, timeout: G } = l.getState(), z = () => {
        b.current = 0, T() && (l == null || l.setAnchorElement(F), l == null || l.show(), queueMicrotask(() => {
          l == null || l.setDisclosureElement(F);
        }));
      }, $ = Y ?? G;
      $ === 0 ? z() : b.current = window.setTimeout(z, $);
    }), A = g.onClick, L = nt((N) => {
      A == null || A(N), l && (window.clearTimeout(b.current), b.current = 0);
    }), P = Ir(
      (N) => {
        if (!l)
          return;
        const { anchorElement: F } = l.getState();
        F != null && F.isConnected || l.setAnchorElement(N);
      },
      [l]
    );
    return g = Oe(Q({}, g), {
      ref: Ln(P, g.ref),
      onMouseMove: j,
      onClick: L
    }), g = F2(g), g;
  }
), sB = De(function(t) {
  const a = Dx(t);
  return ke(uB, a);
}), cB = "button";
function fB(e, t) {
  return {
    ArrowDown: t === "bottom" || t === "top" ? "first" : !1,
    ArrowUp: t === "bottom" || t === "top" ? "last" : !1,
    ArrowRight: t === "right" ? "first" : !1,
    ArrowLeft: t === "left" ? "first" : !1
  }[e.key];
}
function sR(e, t) {
  return !!(e != null && e.some((a) => !a.element || a.element === t ? !1 : a.element.getAttribute("aria-expanded") === "true"));
}
var dB = Le(
  function(t) {
    var a = t, {
      store: l,
      focusable: h,
      accessibleWhenDisabled: g,
      showOnHover: m
    } = a, S = Fe(a, [
      "store",
      "focusable",
      "accessibleWhenDisabled",
      "showOnHover"
    ]);
    const b = vw();
    l = l || b, Ht(
      l,
      process.env.NODE_ENV !== "production" && "MenuButton must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const R = Pt(null), D = l.parent, T = l.menubar, j = !!D, A = !!T && !j, L = pf(S), P = () => {
      const K = R.current;
      K && (l == null || l.setDisclosureElement(K), l == null || l.setAnchorElement(K), l == null || l.show());
    }, N = S.onFocus, F = nt((K) => {
      if (N == null || N(K), L || K.defaultPrevented || (l == null || l.setAutoFocusOnShow(!1), l == null || l.setActiveId(null), !T) || !A)
        return;
      const { items: we } = T.getState();
      sR(we, K.currentTarget) && P();
    }), Y = l.useState(
      (K) => K.placement.split("-")[0]
    ), G = S.onKeyDown, z = nt((K) => {
      if (G == null || G(K), L || K.defaultPrevented)
        return;
      const we = fB(K, Y);
      we && (K.preventDefault(), P(), l == null || l.setAutoFocusOnShow(!0), l == null || l.setInitialFocus(we));
    }), $ = S.onClick, ce = nt((K) => {
      if ($ == null || $(K), K.defaultPrevented || !l)
        return;
      const we = !K.detail, { open: ue } = l.getState();
      (!ue || we) && ((!j || we) && l.setAutoFocusOnShow(!0), l.setInitialFocus(we ? "first" : "container")), j && P();
    });
    S = Vn(
      S,
      (K) => /* @__PURE__ */ f.jsx(qM, { value: l, children: K }),
      [l]
    ), j && (S = Oe(Q({}, S), {
      render: /* @__PURE__ */ f.jsx(I4.div, { render: S.render })
    }));
    const X = Ia(S.id), Ce = ja(
      (D == null ? void 0 : D.combobox) || D,
      "contentElement"
    ), ae = j || A ? k8(Ce, "menuitem") : void 0, me = l.useState("contentElement");
    return S = Oe(Q({
      id: X,
      role: ae,
      "aria-haspopup": ph(me, "menu")
    }, S), {
      ref: Ln(R, S.ref),
      onFocus: F,
      onKeyDown: z,
      onClick: ce
    }), S = Dx(Oe(Q({
      store: l,
      focusable: h,
      accessibleWhenDisabled: g
    }, S), {
      showOnHover: (K) => {
        if (!(() => {
          if (typeof m == "function")
            return m(K);
          if (m != null)
            return m;
          if (j)
            return !0;
          if (!T)
            return !1;
          const { items: Te } = T.getState();
          return A && sR(Te);
        })())
          return !1;
        const ge = A ? T : D;
        return ge && ge.setActiveId(K.currentTarget.id), !0;
      }
    })), S = Cx(Q({
      store: l,
      toggleOnClick: !j,
      focusable: h,
      accessibleWhenDisabled: g
    }, S)), S = Q4(Q({
      store: l,
      typeahead: A
    }, S)), S;
  }
), nT = De(function(t) {
  const a = dB(t);
  return ke(cB, a);
}), hB = "p", rT = Le(function(t) {
  return t = FM(t), t;
}), vB = De(function(t) {
  const a = rT(t);
  return ke(hB, a);
}), pB = "p", mB = Le(
  function(t) {
    return t = rT(t), t;
  }
), gB = De(function(t) {
  const a = mB(t);
  return ke(pB, a);
}), wB = "button", aT = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = PV();
    return l = l || g, h = UM(Q({ store: l }, h)), h;
  }
), yB = De(function(t) {
  const a = aT(t);
  return ke(wB, a);
}), xB = "button", SB = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = hw();
    return l = l || g, h = aT(Q({ store: l }, h)), h;
  }
), CB = De(function(t) {
  const a = SB(t);
  return ke(xB, a);
}), bB = "div", _B = Le(
  function(t) {
    return t = X5(t), t;
  }
), RB = De(function(t) {
  const a = _B(t);
  return ke(bB, a);
}), EB = "div", MB = Le(
  function(t) {
    return t = J5(t), t;
  }
), TB = De(function(t) {
  const a = MB(t);
  return ke(EB, a);
}), OB = "h1", iT = Le(
  function(t) {
    return t = YM(t), t;
  }
), DB = De(function(t) {
  const a = iT(t);
  return ke(OB, a);
}), jB = "h1", AB = Le(
  function(t) {
    return t = iT(t), t;
  }
), lT = De(function(t) {
  const a = AB(t);
  return ke(jB, a);
}), kB = "span", LB = Le(
  function(t) {
    var a = t, { store: l, checked: h } = a, g = Fe(a, ["store", "checked"]);
    const m = Ui(GM);
    return h = h ?? m, g = U5(Oe(Q({}, g), { checked: h })), g;
  }
), IB = De(function(t) {
  const a = LB(t);
  return ke(kB, a);
}), HB = "div";
function ZB(e, t, a) {
  var l;
  if (!e)
    return !1;
  if (sh(e))
    return !0;
  const h = t == null ? void 0 : t.find((b) => {
    var R;
    return b.element === a ? !1 : ((R = b.element) == null ? void 0 : R.getAttribute("aria-expanded")) === "true";
  }), g = (l = h == null ? void 0 : h.element) == null ? void 0 : l.getAttribute("aria-controls");
  if (!g)
    return !1;
  const S = Qr(e).getElementById(g);
  return S ? sh(S) ? !0 : !!S.querySelector("[role=menuitem][aria-expanded=true]") : !1;
}
var jx = Le(
  function(t) {
    var a = t, {
      store: l,
      hideOnClick: h = !0,
      preventScrollOnKeyDown: g = !0,
      focusOnHover: m,
      blurOnHoverEnd: S
    } = a, b = Fe(a, [
      "store",
      "hideOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const R = hw(!0), D = DV();
    l = l || R || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "MenuItem must be wrapped in a MenuList, Menu or Menubar component"
    );
    const T = b.onClick, j = Jn(h), A = "hideAll" in l ? l.hideAll : void 0, L = !!A, P = nt((Y) => {
      T == null || T(Y), !(Y.defaultPrevented || P8(Y) || Z8(Y) || !A || Y.currentTarget.getAttribute("aria-haspopup") === "menu") && j(Y) && A();
    }), N = ja(
      l,
      (Y) => "contentElement" in Y ? Y.contentElement : null
    ), F = k8(N, "menuitem");
    return b = Oe(Q({
      role: F
    }, b), {
      onClick: P
    }), b = Y2(Q({
      store: l,
      preventScrollOnKeyDown: g
    }, b)), b = ew(Oe(Q({
      store: l
    }, b), {
      focusOnHover(Y) {
        const G = () => typeof m == "function" ? m(Y) : m ?? !0;
        if (!l || !G())
          return !1;
        const { baseElement: z, items: $ } = l.getState();
        return L ? (Y.currentTarget.hasAttribute("aria-expanded") && Y.currentTarget.focus(), !0) : ZB(z, $, Y.currentTarget) ? (Y.currentTarget.focus(), !0) : !1;
      },
      blurOnHoverEnd(Y) {
        return typeof S == "function" ? S(Y) : S ?? L;
      }
    })), b;
  }
), oT = Ha(
  De(function(t) {
    const a = jx(t);
    return ke(HB, a);
  })
), PB = "div";
function NB(e) {
  return Array.isArray(e) ? e.toString() : e;
}
function Iy(e, t, a) {
  if (t === void 0)
    return Array.isArray(e) ? e : !!a;
  const l = NB(t);
  return Array.isArray(e) ? a ? e.includes(l) ? e : [...e, l] : e.filter((h) => h !== l) : a ? l : e === l ? !1 : e;
}
var VB = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      value: g,
      checked: m,
      defaultChecked: S,
      hideOnClick: b = !1
    } = a, R = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked",
      "hideOnClick"
    ]);
    const D = hw();
    l = l || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "MenuItemCheckbox must be wrapped in a MenuList or Menu component"
    );
    const T = N8(S);
    gt(() => {
      l == null || l.setValue(h, (A = []) => T ? Iy(A, g, !0) : A);
    }, [l, h, g, T]), gt(() => {
      m !== void 0 && (l == null || l.setValue(h, (A) => Iy(A, g, m)));
    }, [l, h, g, m]);
    const j = U4({
      value: l.useState((A) => A.values[h]),
      setValue(A) {
        l == null || l.setValue(h, () => {
          if (m === void 0)
            return A;
          const L = Iy(A, g, m);
          return !Array.isArray(L) || !Array.isArray(A) ? L : Xk(A, L) ? A : L;
        });
      }
    });
    return R = Q({
      role: "menuitemcheckbox"
    }, R), R = q8(Q({
      store: j,
      name: h,
      value: g,
      checked: m
    }, R)), R = jx(Q({ store: l, hideOnClick: b }, R)), R;
  }
), BB = Ha(
  De(function(t) {
    const a = VB(t);
    return ke(PB, a);
  })
), FB = "div";
function Hy(e, t, a) {
  return a === void 0 ? e : a ? t : e;
}
var UB = Le(
  function(t) {
    var a = t, {
      store: l,
      name: h,
      value: g,
      checked: m,
      onChange: S,
      hideOnClick: b = !1
    } = a, R = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "onChange",
      "hideOnClick"
    ]);
    const D = hw();
    l = l || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component"
    );
    const T = N8(R.defaultChecked);
    gt(() => {
      l == null || l.setValue(h, (A = !1) => Hy(A, g, T));
    }, [l, h, g, T]), gt(() => {
      m !== void 0 && (l == null || l.setValue(h, (A) => Hy(A, g, m)));
    }, [l, h, g, m]);
    const j = l.useState((A) => A.values[h] === g);
    return R = Vn(
      R,
      (A) => /* @__PURE__ */ f.jsx(GM.Provider, { value: !!j, children: A }),
      [j]
    ), R = Q({
      role: "menuitemradio"
    }, R), R = ex(Q({
      name: h,
      value: g,
      checked: j,
      onChange(A) {
        if (S == null || S(A), A.defaultPrevented)
          return;
        const L = A.currentTarget;
        l == null || l.setValue(h, (P) => Hy(P, g, m ?? L.checked));
      }
    }, R)), R = jx(Q({ store: l, hideOnClick: b }, R)), R;
  }
), YB = Ha(
  De(function(t) {
    const a = UB(t);
    return ke(FB, a);
  })
), $B = "hr", WB = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = wf();
    return l = l || g, h = K4(Q({ store: l }, h)), h;
  }
), uT = De(function(t) {
  const a = WB(t);
  return ke($B, a);
});
function zB(e = {}) {
  const t = KM(e);
  return /* @__PURE__ */ f.jsx(_x, { value: t, children: e.children });
}
var qB = "div", GB = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = zM();
    return l = l || g, h = sw(Q({ store: l }, h)), h;
  }
), KB = De(function(t) {
  const a = GB(t);
  return ke(qB, a);
}), QB = "button", XB = Le(function(t) {
  var a = t, { store: l } = a, h = Fe(a, ["store"]);
  const g = dw();
  l = l || g, Ht(
    l,
    process.env.NODE_ENV !== "production" && "HovercardDisclosure must receive a `store` prop or be wrapped in a HovercardProvider component."
  );
  const [m, S] = Qt(!1);
  gt(() => m ? Fi("focusout", (P) => {
    if (!l)
      return;
    const N = P.relatedTarget;
    if (N) {
      const {
        anchorElement: F,
        popoverElement: Y,
        disclosureElement: G
      } = l.getState();
      if (F && ha(F, N) || Y && ha(Y, N) || G && ha(G, N) || N.hasAttribute("data-focus-trap"))
        return;
    }
    S(!1);
  }, !0) : void 0, [m, l]), gt(() => xa(l, ["anchorElement"], (L) => {
    const P = L.anchorElement;
    if (!P)
      return;
    const N = new MutationObserver(() => {
      P.hasAttribute("data-focus-visible") && S(!0);
    });
    return N.observe(P, { attributeFilter: ["data-focus-visible"] }), () => N.disconnect();
  }), [l]);
  const b = h.onClick, R = nt((L) => {
    b == null || b(L), !L.defaultPrevented && (l == null || l.setAutoFocusOnShow(!0));
  }), D = h.onFocus, T = nt((L) => {
    D == null || D(L), !L.defaultPrevented && S(!0);
  }), { style: j } = tx();
  return m || (h = Oe(Q({}, h), {
    style: Q(Q({}, j), h.style)
  })), h = Oe(Q({
    children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ f.jsx("polyline", { points: "4,6 8,10 12,6" })
      }
    )
  }, h), {
    ref: Ln(l.setDisclosureElement, h.ref),
    onClick: R,
    onFocus: T
  }), h = Q5(Q({ store: l }, h)), h;
}), JB = De(function(t) {
  const a = XB(t);
  return ke(QB, a);
});
function eF(e = {}) {
  var t;
  process.env.NODE_ENV !== "production" && e.type === "label" && console.warn(
    "The `type` option on the tooltip store is deprecated.",
    "Render a visually hidden label or use the `aria-label` or `aria-labelledby` attributes on the anchor element instead.",
    "See https://ariakit.org/components/tooltip#tooltip-anchors-must-have-accessible-names"
  );
  const a = (t = e.store) == null ? void 0 : t.getState(), l = Ex(gn(_t({}, e), {
    placement: st(
      e.placement,
      a == null ? void 0 : a.placement,
      "top"
    ),
    hideTimeout: st(e.hideTimeout, a == null ? void 0 : a.hideTimeout, 0)
  })), h = gn(_t({}, l.getState()), {
    type: st(e.type, a == null ? void 0 : a.type, "description"),
    skipTimeout: st(e.skipTimeout, a == null ? void 0 : a.skipTimeout, 300)
  }), g = fi(h, l, e.store);
  return _t(_t({}, l), g);
}
function tF(e, t, a) {
  return lr(e, a, "type"), lr(e, a, "skipTimeout"), Mx(e, t, a);
}
function Ax(e = {}) {
  const [t, a] = Cl(eF, e);
  return tF(t, a, e);
}
var pw = bl(
  [_x],
  [Rx]
), sT = pw.useContext, kx = pw.useProviderContext, nF = pw.ContextProvider, rF = pw.ScopedContextProvider, aF = "div", iF = Le(
  function(t) {
    var a = t, {
      store: l,
      portal: h = !0,
      gutter: g = 8,
      preserveTabOrder: m = !1,
      hideOnHoverOutside: S = !0,
      hideOnInteractOutside: b = !0
    } = a, R = Fe(a, [
      "store",
      "portal",
      "gutter",
      "preserveTabOrder",
      "hideOnHoverOutside",
      "hideOnInteractOutside"
    ]);
    const D = kx();
    l = l || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    ), R = Vn(
      R,
      (j) => /* @__PURE__ */ f.jsx(rF, { value: l, children: j }),
      [l]
    );
    const T = l.useState(
      (j) => j.type === "description" ? "tooltip" : "none"
    );
    return R = Q({ role: T }, R), R = Ox(Oe(Q({}, R), {
      store: l,
      portal: h,
      gutter: g,
      preserveTabOrder: m,
      hideOnHoverOutside(j) {
        if (I2(S, j))
          return !1;
        const A = l == null ? void 0 : l.getState().anchorElement;
        return A ? !("focusVisible" in A.dataset) : !0;
      },
      hideOnInteractOutside: (j) => {
        if (I2(b, j))
          return !1;
        const A = l == null ? void 0 : l.getState().anchorElement;
        return A ? !ha(A, j.target) : !0;
      }
    })), R;
  }
), cT = $2(
  De(function(t) {
    const a = iF(t);
    return ke(aF, a);
  }),
  kx
);
function lF(e = {}) {
  const t = Ax(e);
  return /* @__PURE__ */ f.jsx(nF, { value: t, children: e.children });
}
var oF = "div", A2 = fi({
  activeStore: null
});
function cR(e) {
  return () => {
    const { activeStore: t } = A2.getState();
    t === e && A2.setState("activeStore", null);
  };
}
var uF = Le(
  function(t) {
    var a = t, { store: l, showOnHover: h = !0 } = a, g = Fe(a, ["store", "showOnHover"]);
    const m = kx();
    l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "TooltipAnchor must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    const S = Pt(!1);
    gt(() => xa(l, ["mounted"], (N) => {
      N.mounted || (S.current = !1);
    }), [l]), gt(() => {
      if (l)
        return _o(
          // Immediately remove the current store from the global store when
          // the component unmounts. This is useful, for example, to avoid
          // showing tooltips immediately on serial tests.
          cR(l),
          xa(l, ["mounted", "skipTimeout"], (N) => {
            if (!l)
              return;
            if (N.mounted) {
              const { activeStore: Y } = A2.getState();
              return Y !== l && (Y == null || Y.hide()), A2.setState("activeStore", l);
            }
            const F = setTimeout(
              cR(l),
              N.skipTimeout
            );
            return () => clearTimeout(F);
          })
        );
    }, [l]);
    const b = g.onMouseEnter, R = nt((N) => {
      b == null || b(N), S.current = !0;
    }), D = g.onFocusVisible, T = nt((N) => {
      D == null || D(N), !N.defaultPrevented && (l == null || l.setAnchorElement(N.currentTarget), l == null || l.show());
    }), j = g.onBlur, A = nt((N) => {
      if (j == null || j(N), N.defaultPrevented)
        return;
      const { activeStore: F } = A2.getState();
      S.current = !1, F === l && A2.setState("activeStore", null);
    }), L = l.useState("type"), P = l.useState((N) => {
      var F;
      return (F = N.contentElement) == null ? void 0 : F.id;
    });
    return g = Oe(Q({
      "aria-labelledby": L === "label" ? P : void 0
    }, g), {
      onMouseEnter: R,
      onFocusVisible: T,
      onBlur: A
    }), g = Dx(Q({
      store: l,
      showOnHover(N) {
        if (!S.current || I2(h, N))
          return !1;
        const { activeStore: F } = A2.getState();
        return F ? (l == null || l.show(), !1) : !0;
      }
    }, g)), g;
  }
), fT = De(function(t) {
  const a = uF(t);
  return ke(oF, a);
}), sF = "div", cF = Le(
  function(t) {
    var a = t, { store: l, size: h = 16 } = a, g = Fe(a, ["store", "size"]);
    const m = sT();
    return l = l || m, Ht(
      l,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component."
    ), g = sw(Q({ store: l, size: h }, g)), g;
  }
), dT = De(function(t) {
  const a = cF(t);
  return ke(sF, a);
});
function fF(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState();
  return Sh(gn(_t({}, e), {
    orientation: st(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "horizontal"
    ),
    focusLoop: st(e.focusLoop, a == null ? void 0 : a.focusLoop, !0)
  }));
}
function dF(e, t, a) {
  return Ch(e, t, a);
}
function Lx(e = {}) {
  const [t, a] = Cl(fF, e);
  return dF(t, a, e);
}
var mw = bl(
  [Z0],
  [xh]
), l3 = mw.useContext, hF = mw.useProviderContext, vF = mw.ContextProvider, pF = mw.ScopedContextProvider, mF = "div", gF = Le(
  function(t) {
    var a = t, {
      store: l,
      orientation: h,
      virtualFocus: g,
      focusLoop: m,
      rtl: S
    } = a, b = Fe(a, [
      "store",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const R = hF();
    l = l || R;
    const D = Lx({
      store: l,
      orientation: h,
      virtualFocus: g,
      focusLoop: m,
      rtl: S
    }), T = D.useState(
      (j) => j.orientation === "both" ? void 0 : j.orientation
    );
    return b = Vn(
      b,
      (j) => /* @__PURE__ */ f.jsx(pF, { value: D, children: j }),
      [D]
    ), b = Q({
      role: "toolbar",
      "aria-orientation": T
    }, b), b = bh(Q({ store: D }, b)), b;
  }
), wF = De(function(t) {
  const a = gF(t);
  return ke(mF, a);
});
function yF(e = {}) {
  const t = Lx(e);
  return /* @__PURE__ */ f.jsx(vF, { value: t, children: e.children });
}
var xF = "div";
function fR(e) {
  b5(e);
  const t = B5(e);
  return xp(e), t;
}
var hT = Le(function(t) {
  var a = t, { store: l } = a, h = Fe(a, ["store"]);
  const g = U2();
  l = l || g;
  const m = Pt(null), S = Pt(!1), b = (G = !1) => {
    const z = m.current;
    if (!z)
      return;
    b5(z);
    const $ = B5(z);
    if (!$) {
      xp(z);
      return;
    }
    S.current = !0, queueMicrotask(() => {
      $.focus(), (bo($) || $.isContentEditable) && $E($, G);
    });
  }, R = () => {
    const G = m.current;
    G && (S.current = !1, xp(G));
  }, D = ja(l, "renderedItems");
  gt(() => {
    const G = m.current;
    if (!G)
      return;
    !S.current && (D != null && D.length) && xp(G);
  }, [D]);
  const T = h.onFocus, j = nt((G) => {
    if (T == null || T(G), G.defaultPrevented || !l)
      return;
    const z = S.current;
    if (Sl(G)) {
      S.current = !1;
      const { baseElement: $ } = l.getState(), ce = $, Ce = ce == null ? void 0 : ce.querySelectorAll("[data-composite-container]");
      Ce == null || Ce.forEach((ae) => xp(ae));
    } else z || (S.current = !0, b5(G.currentTarget), l == null || l.setState("moves", 0));
  }), A = h.onBlur, L = nt((G) => {
    A == null || A(G), !G.defaultPrevented && ah(G) && R();
  }), P = h.onKeyDown, N = nt((G) => {
    if (P == null || P(G), G.defaultPrevented || G.altKey || G.ctrlKey || G.metaKey || G.shiftKey)
      return;
    const z = G.currentTarget;
    if (Sl(G)) {
      if (G.key.length === 1 && G.key !== " ") {
        const $ = fR(z);
        if (!$)
          return;
        (bo($) || $.isContentEditable) && (G.stopPropagation(), b());
      } else if (G.key === "Delete" || G.key === "Backspace") {
        const $ = fR(z);
        if (!$)
          return;
        if (bo($) || $.isContentEditable) {
          b();
          const ce = () => queueMicrotask(() => z.focus());
          z.addEventListener("input", ce, { once: !0 });
        }
      }
    } else if (G.key === "Escape")
      queueMicrotask(() => z.focus());
    else if (G.key === "Enter") {
      const $ = G.target;
      ($.tagName === "INPUT" && !k0($) || $.tagName === "TEXTAREA" || $.isContentEditable) && (G.preventDefault(), queueMicrotask(() => z.focus()));
    }
  }), F = h.onClick, Y = nt((G) => {
    F == null || F(G), !G.defaultPrevented && Sl(G) && !G.detail && b(!0);
  });
  return h = Oe(Q({
    "data-composite-container": ""
  }, h), {
    ref: Ln(m, h.ref),
    onFocus: j,
    onBlur: L,
    onKeyDown: N,
    onClick: Y
  }), La(h);
});
De(function(t) {
  const a = hT(t);
  return ke(xF, a);
});
var SF = "button", Ix = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = l3();
    return l = l || g, h = Y2(Q({ store: l }, h)), h;
  }
), CF = Ha(
  De(function(t) {
    const a = Ix(t);
    return ke(SF, a);
  })
), bF = "div", _F = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = l3();
    return l = l || g, h = hT(Q({ store: l }, h)), h = Ix(Q({ store: l }, h)), h;
  }
), RF = Ha(
  De(function(t) {
    const a = _F(t);
    return ke(bF, a);
  })
), EF = "input", MF = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = l3();
    return l = l || g, h = Ix(Q({ store: l }, h)), h;
  }
), TF = Ha(
  De(function(t) {
    const a = MF(t);
    return ke(EF, a);
  })
), OF = "hr", DF = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = l3();
    return l = l || g, h = K4(Q({ store: l }, h)), h;
  }
), jF = De(function(t) {
  const a = DF(t);
  return ke(OF, a);
}), o3 = bl(
  [aw, Z0],
  [e3, xh]
), yf = o3.useContext, AF = o3.useScopedContext, u3 = o3.useProviderContext, kF = o3.ContextProvider, vT = o3.ScopedContextProvider, pT = ka(!1);
function mT(e = {}) {
  var t = e, {
    composite: a,
    combobox: l
  } = t, h = Ap(t, [
    "composite",
    "combobox"
  ]);
  const g = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ], m = Lp(
    h.store,
    Op(a, g),
    Op(l, g)
  ), S = m == null ? void 0 : m.getState(), b = Sh(gn(_t({}, h), {
    orientation: st(
      h.orientation,
      S == null ? void 0 : S.orientation,
      "horizontal"
    ),
    focusLoop: st(h.focusLoop, S == null ? void 0 : S.focusLoop, !0)
  })), R = N5(), D = gn(_t({}, b.getState()), {
    selectedId: st(
      h.selectedId,
      S == null ? void 0 : S.selectedId,
      h.defaultSelectedId,
      void 0
    ),
    selectOnMove: st(
      h.selectOnMove,
      S == null ? void 0 : S.selectOnMove,
      !0
    )
  }), T = fi(D, b, m);
  return Aa(
    T,
    () => xa(T, ["moves"], () => {
      const { activeId: j, selectOnMove: A } = T.getState();
      if (!A || !j)
        return;
      const L = b.item(j);
      L && (L.dimmed || L.disabled || T.setState("selectedId", L.id));
    })
  ), Aa(
    T,
    () => Z2(
      T,
      ["selectedId"],
      (j) => T.setState("activeId", j.selectedId)
    )
  ), Aa(
    T,
    () => xa(T, ["selectedId", "renderedItems"], (j) => {
      if (j.selectedId !== void 0)
        return;
      const { activeId: A, renderedItems: L } = T.getState(), P = b.item(A);
      if (P && !P.disabled && !P.dimmed)
        T.setState("selectedId", P.id);
      else {
        const N = L.find(
          (F) => !F.disabled && !F.dimmed
        );
        T.setState("selectedId", N == null ? void 0 : N.id);
      }
    })
  ), Aa(
    T,
    () => xa(T, ["renderedItems"], (j) => {
      const A = j.renderedItems;
      if (A.length)
        return xa(R, ["renderedItems"], (L) => {
          const P = L.renderedItems;
          P.some((F) => !F.tabId) && P.forEach((F, Y) => {
            if (F.tabId)
              return;
            const G = A[Y];
            G && R.renderItem(gn(_t({}, F), { tabId: G.id }));
          });
        });
    })
  ), gn(_t(_t({}, b), T), {
    panels: R,
    setSelectedId: (j) => T.setState("selectedId", j),
    select: (j) => {
      T.setState("selectedId", j), b.move(j);
    }
  });
}
function LF(e, t, a) {
  b1(t, [a.composite, a.combobox]), e = Ch(e, t, a), lr(e, a, "selectedId", "setSelectedId"), lr(e, a, "selectOnMove");
  const [l, h] = Cl(() => e.panels, {});
  return b1(h, [e, h]), Object.assign(
    Ur(() => Oe(Q({}, e), { panels: l }), [e, l]),
    { composite: a.composite, combobox: a.combobox }
  );
}
function gw(e = {}) {
  const t = fx(), a = yf() || t;
  e = Oe(Q({}, e), {
    composite: e.composite !== void 0 ? e.composite : a,
    combobox: e.combobox !== void 0 ? e.combobox : t
  });
  const [l, h] = Cl(mT, e);
  return LF(l, h, e);
}
var s3 = bl(
  [Z0],
  [xh]
), Hx = s3.useContext, IF = s3.useScopedContext, gT = s3.useProviderContext, HF = s3.ContextProvider, wT = s3.ScopedContextProvider, ZF = "button", PF = Le(function(t) {
  var a = t, {
    store: l,
    accessibleWhenDisabled: h = !0,
    getItem: g
  } = a, m = Fe(a, [
    "store",
    "accessibleWhenDisabled",
    "getItem"
  ]);
  const S = IF();
  l = l || S, Ht(
    l,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const b = Ia(), R = m.id || b, D = pf(m), T = Ir(
    (F) => {
      const Y = Oe(Q({}, F), { dimmed: D });
      return g ? g(Y) : Y;
    },
    [D, g]
  ), j = m.onClick, A = nt((F) => {
    j == null || j(F), !F.defaultPrevented && (l == null || l.setSelectedId(R));
  }), L = l.panels.useState(
    (F) => {
      var Y;
      return (Y = F.items.find((G) => G.tabId === R)) == null ? void 0 : Y.id;
    }
  ), P = l.useState((F) => !!R && F.selectedId === R), N = b ? m.shouldRegisterItem : !1;
  return m = Vn(
    m,
    (F) => {
      if (!(l != null && l.composite))
        return F;
      const Y = {
        id: R,
        store: l.composite,
        shouldRegisterItem: P && N,
        render: F
      };
      return /* @__PURE__ */ f.jsx(
        e8,
        Oe(Q({}, Y), {
          render: l.combobox && l.composite !== l.combobox ? /* @__PURE__ */ f.jsx(e8, Oe(Q({}, Y), { store: l.combobox })) : F
        })
      );
    },
    [l, R, P, N]
  ), m = Oe(Q({
    id: R,
    role: "tab",
    "aria-selected": P,
    "aria-controls": L || void 0
  }, m), {
    onClick: A
  }), m = Y2(Oe(Q({
    store: l
  }, m), {
    accessibleWhenDisabled: h,
    getItem: T,
    shouldRegisterItem: N
  })), m;
}), yT = Ha(
  De(function(t) {
    const a = PF(t);
    return ke(ZF, a);
  })
);
function xT(e = {}) {
  const t = gw(e);
  return /* @__PURE__ */ f.jsx(HF, { value: t, children: e.children });
}
var NF = "div", VF = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = gT();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const m = l.useState(
      (S) => S.orientation === "both" ? void 0 : S.orientation
    );
    return h = Vn(
      h,
      (S) => /* @__PURE__ */ f.jsx(wT, { value: l, children: S }),
      [l]
    ), l.composite && (h = Q({
      focusable: !1
    }, h)), h = Q({
      role: "tablist",
      "aria-orientation": m
    }, h), h = bh(Q({ store: l }, h)), h;
  }
), ST = De(function(t) {
  const a = VF(t);
  return ke(NF, a);
}), BF = "div", FF = Le(
  function(t) {
    var a = t, {
      store: l,
      unmountOnHide: h,
      tabId: g,
      getItem: m
    } = a, S = Fe(a, [
      "store",
      "unmountOnHide",
      "tabId",
      "getItem"
    ]);
    const b = gT();
    l = l || b, Ht(
      l,
      process.env.NODE_ENV !== "production" && "TabPanel must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const R = Pt(null), D = Ia(S.id), [T, j] = Qt(!1);
    gt(() => {
      const z = R.current;
      if (!z)
        return;
      const $ = Ip(z);
      j(!!$.length);
    }, []);
    const A = Ir(
      (z) => {
        const $ = Oe(Q({}, z), { id: D || z.id, tabId: g });
        return m ? m($) : $;
      },
      [D, g, m]
    ), L = S.onKeyDown, P = nt((z) => {
      if (L == null || L(z), z.defaultPrevented || !(l != null && l.composite))
        return;
      const { items: $, renderedItems: ce, selectedId: X } = l.getState(), Ce = mT({ items: $, activeId: X });
      Ce.setState("renderedItems", ce);
      const me = {
        ArrowLeft: Ce.previous,
        ArrowRight: Ce.next,
        Home: Ce.first,
        End: Ce.last
      }[z.key];
      if (!me)
        return;
      const K = me();
      K && (z.preventDefault(), l.select(K));
    });
    S = Vn(
      S,
      (z) => /* @__PURE__ */ f.jsx(wT, { value: l, children: z }),
      [l]
    );
    const N = l.panels.useState(
      () => {
        var z;
        return g || ((z = l == null ? void 0 : l.panels.item(D)) == null ? void 0 : z.tabId);
      }
    ), F = l.useState(
      (z) => !!N && z.selectedId === N
    ), Y = z5({ open: F }), G = Y.useState("mounted");
    return S = Oe(Q({
      id: D,
      role: "tabpanel",
      "aria-labelledby": N || void 0
    }, S), {
      children: h && !G ? null : S.children,
      ref: Ln(R, S.ref),
      onKeyDown: P
    }), S = F2(Q({
      // If the tab panel is rendered as part of another composite widget such
      // as combobox, it should not be focusable.
      focusable: !l.composite && !T
    }, S)), S = K5(Q({ store: Y }, S)), S = wh(Oe(Q({ store: l.panels }, S), { getItem: A })), S;
  }
), CT = De(function(t) {
  const a = FF(t);
  return ke(BF, a);
});
function UF(e = {}) {
  var t = e, {
    combobox: a
  } = t, l = Ap(t, [
    "combobox"
  ]);
  const h = Lp(
    l.store,
    Op(a, [
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  gh(l, h);
  const g = h.getState(), m = Sh(gn(_t({}, l), {
    store: h,
    virtualFocus: st(
      l.virtualFocus,
      g.virtualFocus,
      !0
    ),
    includesBaseElement: st(
      l.includesBaseElement,
      g.includesBaseElement,
      !1
    ),
    activeId: st(
      l.activeId,
      g.activeId,
      l.defaultActiveId,
      null
    ),
    orientation: st(
      l.orientation,
      g.orientation,
      "vertical"
    )
  })), S = tw(gn(_t({}, l), {
    store: h,
    placement: st(
      l.placement,
      g.placement,
      "bottom-start"
    )
  })), b = new String(""), R = gn(_t(_t({}, m.getState()), S.getState()), {
    value: st(
      l.value,
      g.value,
      l.defaultValue,
      b
    ),
    setValueOnMove: st(
      l.setValueOnMove,
      g.setValueOnMove,
      !1
    ),
    selectElement: st(g.selectElement, null),
    labelElement: st(g.labelElement, null)
  }), D = fi(R, m, S, h);
  return Aa(
    D,
    () => xa(D, ["value", "items"], (T) => {
      if (T.value !== b || !T.items.length)
        return;
      const j = T.items.find(
        (A) => !A.disabled && A.value != null
      );
      (j == null ? void 0 : j.value) != null && D.setState("value", j.value);
    })
  ), Aa(
    D,
    () => xa(D, ["mounted", "items", "value"], (T) => {
      if (a || T.mounted)
        return;
      const j = wM(T.value), A = j[j.length - 1];
      if (A == null)
        return;
      const L = T.items.find(
        (P) => !P.disabled && P.value === A
      );
      L && D.setState("activeId", L.id);
    })
  ), Aa(
    D,
    () => Z2(D, ["setValueOnMove", "moves"], (T) => {
      const { mounted: j, value: A, activeId: L } = D.getState();
      if (!T.setValueOnMove && j || Array.isArray(A) || !T.moves || !L)
        return;
      const P = m.item(L);
      !P || P.disabled || P.value == null || D.setState("value", P.value);
    })
  ), gn(_t(_t(_t({}, m), S), D), {
    combobox: a,
    setValue: (T) => D.setState("value", T),
    setSelectElement: (T) => D.setState("selectElement", T),
    setLabelElement: (T) => D.setState("labelElement", T)
  });
}
function YF(e, t, a) {
  return b1(t, [a.combobox]), lr(e, a, "value", "setValue"), lr(e, a, "setValueOnMove"), Object.assign(
    nw(
      Ch(e, t, a),
      t,
      a
    ),
    { combobox: a.combobox }
  );
}
function Np(e = {}) {
  const t = Rh();
  e = Oe(Q({}, e), {
    combobox: e.combobox !== void 0 ? e.combobox : t
  });
  const [a, l] = Cl(UF, e);
  return YF(a, l, e);
}
var $F = "span", WF = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = yf();
    return l = l || g, h = Sx(Q({ store: l }, h)), h;
  }
), ww = De(function(t) {
  const a = WF(t);
  return ke($F, a);
}), zF = "button";
function qF(e) {
  return Array.from(e.selectedOptions).map((t) => t.value);
}
function l5(e, t) {
  return () => {
    const a = t();
    if (!a)
      return;
    let l = 0, h = e.item(a);
    const g = h;
    for (; h && h.value == null; ) {
      const m = t(++l);
      if (!m)
        return;
      if (h = e.item(m), h === g)
        break;
    }
    return h == null ? void 0 : h.id;
  };
}
var GF = Le(function(t) {
  var a = t, {
    store: l,
    name: h,
    form: g,
    required: m,
    showOnKeyDown: S = !0,
    moveOnKeyDown: b = !0,
    toggleOnClick: R = !1,
    toggleOnPress: D = !R
  } = a, T = Fe(a, [
    "store",
    "name",
    "form",
    "required",
    "showOnKeyDown",
    "moveOnKeyDown",
    "toggleOnClick",
    "toggleOnPress"
  ]);
  const j = u3();
  l = l || j, Ht(
    l,
    process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component."
  ), D = R ? !1 : D;
  const A = T.onKeyDown, L = Jn(S), P = Jn(b), N = Jn(D), Y = l.useState("placement").split("-")[0], G = l.useState("value"), z = Array.isArray(G), $ = nt((le) => {
    var _e;
    if (A == null || A(le), le.defaultPrevented || !l)
      return;
    const { orientation: Pe, items: mt, activeId: Ze } = l.getState();
    (le.key === " " || le.key === "Enter") && N(le) && (le.preventDefault(), l.toggle());
    const Nt = Pe !== "horizontal", kt = Pe !== "vertical", Qe = !!((_e = mt.find((er) => !er.disabled && er.value != null)) != null && _e.rowId), vt = {
      ArrowUp: (Qe || Nt) && l5(l, l.up),
      ArrowRight: (Qe || kt) && l5(l, l.next),
      ArrowDown: (Qe || Nt) && l5(l, l.down),
      ArrowLeft: (Qe || kt) && l5(l, l.previous)
    }[le.key];
    vt && P(le) && (le.preventDefault(), l.move(vt()));
    const Ot = Y === "top" || Y === "bottom";
    ({
      ArrowDown: Ot,
      ArrowUp: Ot,
      ArrowLeft: Y === "left",
      ArrowRight: Y === "right"
    })[le.key] && L(le) && (le.preventDefault(), l.move(Ze), H2(le.currentTarget, "keyup", l.show));
  }), ce = T.onMouseDown, X = nt((le) => {
    if (ce == null || ce(le), le.defaultPrevented || le.button || le.ctrlKey || !N(le))
      return;
    const _e = le.currentTarget;
    H2(_e, "focusin", () => {
      l == null || l.setDisclosureElement(_e), l == null || l.toggle();
    });
  });
  T = Vn(
    T,
    (le) => /* @__PURE__ */ f.jsx(vT, { value: l, children: le }),
    [l]
  );
  const [Ce, ae] = Qt(!1), me = Pt(!1);
  gt(() => {
    const le = me.current;
    me.current = !1, !le && ae(!1);
  }, [G]);
  const K = l.useState((le) => {
    var _e;
    return (_e = le.labelElement) == null ? void 0 : _e.id;
  }), we = T["aria-label"], ue = T["aria-labelledby"] || K, ge = l.useState((le) => {
    if (h)
      return le.items;
  }), Te = Ur(() => [...new Set(ge == null ? void 0 : ge.map((le) => le.value).filter((le) => le != null))], [ge]);
  T = Vn(
    T,
    (le) => h ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsxs(
        "select",
        {
          style: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            whiteSpace: "nowrap",
            width: "1px"
          },
          tabIndex: -1,
          "aria-hidden": !0,
          "aria-label": we,
          "aria-labelledby": ue,
          name: h,
          form: g,
          required: m,
          value: G,
          multiple: z,
          onFocus: () => {
            var _e;
            return (_e = l == null ? void 0 : l.getState().selectElement) == null ? void 0 : _e.focus();
          },
          onChange: (_e) => {
            me.current = !0, ae(!0), l == null || l.setValue(
              z ? qF(_e.target) : _e.target.value
            );
          },
          children: [
            wM(G).map((_e) => _e == null || Te.includes(_e) ? null : /* @__PURE__ */ f.jsx("option", { value: _e, children: _e }, _e)),
            Te.map((_e) => /* @__PURE__ */ f.jsx("option", { value: _e, children: _e }, _e))
          ]
        }
      ),
      le
    ] }) : le,
    [
      l,
      we,
      ue,
      h,
      g,
      m,
      G,
      z,
      Te
    ]
  );
  const be = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    G,
    /* @__PURE__ */ f.jsx(ww, {})
  ] }), Ue = l.useState("contentElement");
  return T = Oe(Q({
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": K,
    "aria-haspopup": ph(Ue, "listbox"),
    "data-autofill": Ce || void 0,
    "data-name": h,
    children: be
  }, T), {
    ref: Ln(l.setSelectElement, T.ref),
    onKeyDown: $,
    onMouseDown: X
  }), T = Cx(Q({ store: l, toggleOnClick: R }, T)), T = Q4(Q({ store: l }, T)), T;
}), c3 = De(function(t) {
  const a = GF(t);
  return ke(zF, a);
});
function bT(e = {}) {
  const t = Np(e);
  return /* @__PURE__ */ f.jsx(kF, { value: t, children: e.children });
}
var KF = "div", QF = Le(
  function(t) {
    return t = X5(t), t;
  }
), _T = De(function(t) {
  const a = QF(t);
  return ke(KF, a);
}), XF = "div", JF = Le(
  function(t) {
    return t = J5(t), t;
  }
), RT = De(function(t) {
  const a = JF(t);
  return ke(XF, a);
}), eU = "span", tU = Le(
  function(t) {
    var a = t, { store: l, checked: h } = a, g = Fe(a, ["store", "checked"]);
    const m = Ui(pT);
    return h = h ?? m, g = U5(Oe(Q({}, g), { checked: h })), g;
  }
), ET = De(function(t) {
  const a = tU(t);
  return ke(eU, a);
}), nU = "div";
function rU(e, t) {
  if (t != null)
    return e == null ? !1 : Array.isArray(e) ? e.includes(t) : e === t;
}
var aU = Le(
  function(t) {
    var a = t, {
      store: l,
      value: h,
      getItem: g,
      hideOnClick: m,
      setValueOnClick: S = h != null,
      preventScrollOnKeyDown: b = !0,
      focusOnHover: R = !0
    } = a, D = Fe(a, [
      "store",
      "value",
      "getItem",
      "hideOnClick",
      "setValueOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover"
    ]), T;
    const j = AF();
    l = l || j, Ht(
      l,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component."
    );
    const A = Ia(D.id), L = pf(D), P = Ir(
      (ae) => {
        const me = Oe(Q({}, ae), {
          value: L ? void 0 : h,
          children: h
        });
        return g ? g(me) : me;
      },
      [L, h, g]
    ), N = l.useState(
      (ae) => Array.isArray(ae.value)
    );
    m = m ?? (h != null && !N);
    const F = D.onClick, Y = Jn(S), G = Jn(m), z = nt((ae) => {
      F == null || F(ae), !ae.defaultPrevented && (P8(ae) || Z8(ae) || (Y(ae) && h != null && (l == null || l.setValue((me) => Array.isArray(me) ? me.includes(h) ? me.filter((K) => K !== h) : [...me, h] : h)), G(ae) && (l == null || l.hide())));
    }), $ = l.useState((ae) => rU(ae.value, h));
    D = Vn(
      D,
      (ae) => /* @__PURE__ */ f.jsx(pT.Provider, { value: $ ?? !1, children: ae }),
      [$]
    );
    const ce = l.useState("contentElement"), X = l.useState((ae) => ae.activeId !== A && (l != null && l.item(ae.activeId)) || ae.value == null || h == null ? !1 : Array.isArray(ae.value) ? ae.value[ae.value.length - 1] === h : ae.value === h);
    D = Oe(Q({
      id: A,
      role: k8(ce),
      "aria-selected": $,
      children: h
    }, D), {
      autoFocus: (T = D.autoFocus) != null ? T : X,
      onClick: z
    }), D = Y2(Q({
      store: l,
      getItem: P,
      preventScrollOnKeyDown: b
    }, D));
    const Ce = Jn(R);
    return D = ew(Oe(Q({
      store: l
    }, D), {
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover(ae) {
        if (!Ce(ae))
          return !1;
        const me = l == null ? void 0 : l.getState();
        return !!(me != null && me.open);
      }
    })), D;
  }
), yw = Ha(
  De(function(t) {
    const a = aU(t);
    return ke(nU, a);
  })
), iU = "div", lU = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = u3();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "SelectLabel must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const m = Ia(h.id), S = h.onClick, b = nt((R) => {
      S == null || S(R), !R.defaultPrevented && queueMicrotask(() => {
        const D = l == null ? void 0 : l.getState().selectElement;
        D == null || D.focus(), D == null || D.click();
      });
    });
    return h = Oe(Q({
      id: m
    }, h), {
      ref: Ln(l.setLabelElement, h.ref),
      onClick: b,
      style: Q({
        cursor: "default"
      }, h.style)
    }), La(h);
  }
), xw = Ha(
  De(function(t) {
    const a = lU(t);
    return ke(iU, a);
  })
), oU = "div", MT = Le(
  function(t) {
    var a = t, {
      store: l,
      resetOnEscape: h = !0,
      hideOnEnter: g = !0,
      focusOnMove: m = !0,
      composite: S,
      alwaysVisible: b
    } = a, R = Fe(a, [
      "store",
      "resetOnEscape",
      "hideOnEnter",
      "focusOnMove",
      "composite",
      "alwaysVisible"
    ]);
    const D = u3();
    l = l || D, Ht(
      l,
      process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const T = Pt(null), j = Ia(R.id), A = l.useState("value"), L = Array.isArray(A), [P, N] = Qt(A), F = l.useState("mounted");
    gt(() => {
      F || N(A);
    }, [F, A]), h = h && !L;
    const Y = R.onKeyDown, G = Jn(h), z = Jn(g), $ = nt((ue) => {
      Y == null || Y(ue), !ue.defaultPrevented && (ue.key === "Escape" && G(ue) && (l == null || l.setValue(P)), (ue.key === " " || ue.key === "Enter") && Sl(ue) && z(ue) && (ue.preventDefault(), l == null || l.hide()));
    });
    R = Vn(
      R,
      (ue) => /* @__PURE__ */ f.jsx(vT, { value: l, children: ue }),
      [l]
    );
    const ce = l.useState((ue) => {
      var ge;
      return (ge = ue.labelElement) == null ? void 0 : ge.id;
    }), X = !!l.combobox;
    S = S ?? !X, S && (R = Q({ role: "listbox" }, R));
    const Ce = yE(T, "role", R.role), me = (S || (Ce === "listbox" || Ce === "menu" || Ce === "tree" || Ce === "grid")) && L || void 0, K = z4(F, R.hidden, b), we = K ? Oe(Q({}, R.style), { display: "none" }) : R.style;
    return R = Oe(Q({
      id: j,
      "aria-labelledby": ce,
      "aria-multiselectable": me,
      hidden: K
    }, R), {
      ref: Ln(j ? l.setContentElement : null, T, R.ref),
      style: we,
      onKeyDown: $
    }), R = bh(Oe(Q({ store: l }, R), { composite: S })), R = Q4(Q({ store: l, typeahead: !X }, R)), R;
  }
), uU = De(function(t) {
  const a = MT(t);
  return ke(oU, a);
}), sU = "div", cU = Le(
  function(t) {
    var a = t, { store: l, alwaysVisible: h } = a, g = Fe(a, ["store", "alwaysVisible"]);
    const m = u3();
    return l = l || m, g = MT(Q({ store: l, alwaysVisible: h }, g)), g = uw(Q({ store: l, alwaysVisible: h }, g)), g;
  }
), Sw = $2(
  De(function(t) {
    const a = cU(t);
    return ke(sU, a);
  }),
  u3
), fU = "div", dU = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = yf();
    l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "SelectRow must be wrapped in a SelectList or SelectPopover component"
    );
    const m = l.useState("contentElement"), b = ph(m) === "grid" ? "row" : "presentation";
    return h = Q({ role: b }, h), h = sx(Q({ store: l }, h)), h;
  }
), hU = De(function(t) {
  const a = dU(t);
  return ke(fU, a);
}), vU = "hr", pU = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = yf();
    return l = l || g, h = K4(Q({ store: l }, h)), h;
  }
), mU = De(function(t) {
  const a = pU(t);
  return ke(vU, a);
});
function gU(e = {}) {
  var t = Ap(e, []), a;
  const l = (a = t.store) == null ? void 0 : a.getState(), h = Sh(gn(_t({}, t), {
    focusLoop: st(t.focusLoop, l == null ? void 0 : l.focusLoop, !0)
  })), g = gn(_t({}, h.getState()), {
    value: st(
      t.value,
      l == null ? void 0 : l.value,
      t.defaultValue,
      null
    )
  }), m = fi(g, h, t.store);
  return gn(_t(_t({}, h), m), {
    setValue: (S) => m.setState("value", S)
  });
}
function wU(e, t, a) {
  return e = Ch(e, t, a), lr(e, a, "value", "setValue"), e;
}
function TT(e = {}) {
  const [t, a] = Cl(gU, e);
  return wU(t, a, e);
}
function OT(e = {}) {
  const t = TT(e);
  return /* @__PURE__ */ f.jsx(lH, { value: t, children: e.children });
}
var yU = "div", xU = Le(
  function(t) {
    var a = t, { store: l } = a, h = Fe(a, ["store"]);
    const g = iH();
    return l = l || g, Ht(
      l,
      process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component."
    ), h = Vn(
      h,
      (m) => /* @__PURE__ */ f.jsx(oH, { value: l, children: m }),
      [l]
    ), h = Q({
      role: "radiogroup"
    }, h), h = bh(Q({ store: l }, h)), h;
  }
), DT = De(function(t) {
  const a = xU(t);
  return ke(yU, a);
});
const FQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Y5,
  Checkbox: kE,
  CheckboxCheck: dI,
  CheckboxProvider: uI,
  Collection: IL,
  CollectionItem: PL,
  CollectionProvider: HL,
  Combobox: iw,
  ComboboxCancel: BP,
  ComboboxDisclosure: $P,
  ComboboxGroup: TM,
  ComboboxGroupLabel: MM,
  ComboboxItem: H4,
  ComboboxItemCheck: XP,
  ComboboxItemValue: nN,
  ComboboxLabel: sN,
  ComboboxList: hx,
  ComboboxPopover: VM,
  ComboboxProvider: EM,
  ComboboxRow: hV,
  ComboboxSeparator: mV,
  Command: lI,
  Composite: tP,
  CompositeGroup: lP,
  CompositeGroupLabel: aP,
  CompositeHover: cP,
  CompositeItem: e8,
  CompositeProvider: nP,
  CompositeRow: dP,
  CompositeSeparator: mP,
  CompositeTypeahead: CP,
  Dialog: ox,
  DialogDescription: IZ,
  DialogDisclosure: ZZ,
  DialogDismiss: NZ,
  DialogHeading: UZ,
  DialogProvider: ux,
  Disclosure: qH,
  DisclosureContent: aZ,
  DisclosureProvider: GH,
  FocusTrap: Sp,
  FocusTrapRegion: UH,
  Focusable: rI,
  Form: ZE,
  FormCheckbox: MI,
  FormControl: _I,
  FormDescription: DI,
  FormError: NE,
  FormField: II,
  FormGroup: YI,
  FormGroupLabel: VI,
  FormInput: J8,
  FormLabel: FE,
  FormProvider: PE,
  FormPush: JI,
  FormRadio: EH,
  FormRadioGroup: nH,
  FormRemove: jH,
  FormReset: LH,
  FormSubmit: qE,
  Group: FI,
  GroupLabel: ZI,
  Heading: BZ,
  HeadingLevel: fM,
  Hovercard: KV,
  HovercardAnchor: sB,
  HovercardArrow: KB,
  HovercardDescription: vB,
  HovercardDisclosure: JB,
  HovercardDismiss: yB,
  HovercardHeading: DB,
  HovercardProvider: zB,
  Menu: JM,
  MenuArrow: tT,
  MenuBar: tB,
  MenuBarProvider: nB,
  MenuButton: nT,
  MenuButtonArrow: oB,
  MenuDescription: gB,
  MenuDismiss: CB,
  MenuGroup: TB,
  MenuGroupLabel: RB,
  MenuHeading: lT,
  MenuItem: oT,
  MenuItemCheck: IB,
  MenuItemCheckbox: BB,
  MenuItemRadio: YB,
  MenuList: WV,
  MenuProvider: eT,
  MenuSeparator: uT,
  Menubar: ZV,
  MenubarProvider: WM,
  Popover: NM,
  PopoverAnchor: AP,
  PopoverArrow: Pp,
  PopoverDescription: SV,
  PopoverDisclosure: cw,
  PopoverDisclosureArrow: _V,
  PopoverDismiss: MV,
  PopoverHeading: OV,
  PopoverProvider: BM,
  Portal: jZ,
  PortalContext: i8,
  Radio: zE,
  RadioGroup: DT,
  RadioProvider: OT,
  Role: I4,
  Select: c3,
  SelectArrow: ww,
  SelectGroup: RT,
  SelectGroupLabel: _T,
  SelectItem: yw,
  SelectItemCheck: ET,
  SelectLabel: xw,
  SelectList: uU,
  SelectPopover: Sw,
  SelectProvider: bT,
  SelectRow: hU,
  SelectSeparator: mU,
  Separator: vP,
  Tab: yT,
  TabList: ST,
  TabPanel: CT,
  TabProvider: xT,
  Toolbar: wF,
  ToolbarContainer: RF,
  ToolbarInput: TF,
  ToolbarItem: CF,
  ToolbarProvider: yF,
  ToolbarSeparator: jF,
  Tooltip: cT,
  TooltipAnchor: fT,
  TooltipArrow: dT,
  TooltipProvider: lF,
  VisuallyHidden: PH,
  useCheckboxContext: TE,
  useCheckboxStore: U4,
  useCollectionContext: EE,
  useCollectionStore: RE,
  useComboboxContext: fx,
  useComboboxStore: X4,
  useCompositeContext: U2,
  useCompositeStore: xM,
  useDialogContext: W4,
  useDialogStore: q4,
  useDisclosureContext: YH,
  useDisclosureStore: z5,
  useFormContext: Ro,
  useFormStore: G8,
  useHovercardContext: zM,
  useHovercardStore: KM,
  useMenuBarContext: VV,
  useMenuBarStore: UV,
  useMenuContext: wf,
  useMenuStore: Tx,
  useMenubarContext: bx,
  useMenubarStore: fw,
  usePopoverContext: _h,
  usePopoverStore: cx,
  useRadioContext: YE,
  useRadioStore: TT,
  useSelectContext: yf,
  useSelectStore: Np,
  useTabContext: Hx,
  useTabStore: gw,
  useToolbarContext: l3,
  useToolbarStore: Lx,
  useTooltipContext: sT,
  useTooltipStore: Ax
}, Symbol.toStringTag, { value: "Module" }));
function jT(e) {
  var t, a, l = "";
  if (typeof e == "string" || typeof e == "number") l += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (a = jT(e[t])) && (l && (l += " "), l += a);
  else for (t in e) e[t] && (l && (l += " "), l += t);
  return l;
}
function Fr() {
  for (var e, t, a = 0, l = ""; a < arguments.length; ) (e = arguments[a++]) && (t = jT(e)) && (l && (l += " "), l += t);
  return l;
}
var SU = "f08kno0";
const ct = Sa.forwardRef(
  ({ as: e = "div", cssClass: t, hiddenScroll: a, ...l }, h) => {
    const g = {}, m = {}, S = Fr(t);
    for (const b in l)
      Wy.properties.has(b) ? g[b] = l[b] : m[b] = l[b];
    return Sa.createElement(e, {
      className: Fr([
        Wy(g),
        S,
        { [SU]: a }
      ]),
      ref: h,
      ...m
    });
  }
);
ct.displayName = "Box";
function CU(e, t) {
  if (typeof e != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var l = a.call(e, t || "default");
    if (typeof l != "object") return l;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bU(e) {
  var t = CU(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function _U(e, t, a) {
  return t = bU(t), t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function dR(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    t && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(e, h).enumerable;
    })), a.push.apply(a, l);
  }
  return a;
}
function hR(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dR(Object(a), !0).forEach(function(l) {
      _U(e, l, a[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : dR(Object(a)).forEach(function(l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(a, l));
    });
  }
  return e;
}
function vR(e, t) {
  var a = {};
  for (var l in e)
    a[l] = t(e[l], l);
  return a;
}
var RU = (e, t, a) => {
  for (var l of Object.keys(e)) {
    var h;
    if (e[l] !== ((h = t[l]) !== null && h !== void 0 ? h : a[l]))
      return !1;
  }
  return !0;
}, Yi = (e) => {
  var t = (a) => {
    var l = e.defaultClassName, h = hR(hR({}, e.defaultVariants), a);
    for (var g in h) {
      var m, S = (m = h[g]) !== null && m !== void 0 ? m : e.defaultVariants[g];
      if (S != null) {
        var b = S;
        typeof b == "boolean" && (b = b === !0 ? "true" : "false");
        var R = (
          // @ts-expect-error
          e.variantClassNames[g][b]
        );
        R && (l += " " + R);
      }
    }
    for (var [D, T] of e.compoundVariants)
      RU(D, h, e.defaultVariants) && (l += " " + T);
    return l;
  };
  return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
    get base() {
      return e.defaultClassName.split(" ")[0];
    },
    get variants() {
      return vR(e.variantClassNames, (a) => vR(a, (l) => l.split(" ")[0]));
    }
  }, t;
}, EU = Yi({ defaultClassName: "_1x3701w0", variantClassNames: { lines: { 1: "_1x3701w1", 2: "_1x3701w2", 3: "_1x3701w3", 4: "_1x3701w4" } }, defaultVariants: {}, compoundVariants: [] });
const Zx = Sa.forwardRef(
  ({ children: e, lines: t }, a) => /* @__PURE__ */ f.jsx(ct, { as: "span", ref: a, cssClass: EU({ lines: t }), children: e })
);
Zx.displayName = "Truncate";
var MU = { fontSize: "11px", lineHeight: "12px", "::before": { content: "''", marginBottom: "-0.1818em", display: "table" }, "::after": { content: "''", marginTop: "-0.1818em", display: "table" } }, TU = { fontSize: "12px", lineHeight: "16px", "::before": { content: "''", marginBottom: "-0.303em", display: "table" }, "::after": { content: "''", marginTop: "-0.303em", display: "table" } }, OU = { fontSize: "13px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.4056em", display: "table" }, "::after": { content: "''", marginTop: "-0.4056em", display: "table" } }, DU = { fontSize: "14px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.3506em", display: "table" }, "::after": { content: "''", marginTop: "-0.3506em", display: "table" } }, jU = { fontSize: "16px", lineHeight: "24px", "::before": { content: "''", marginBottom: "-0.3864em", display: "table" }, "::after": { content: "''", marginTop: "-0.3864em", display: "table" } }, UQ = { fontSize: "13px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.4462em", display: "table" }, "::after": { content: "''", marginTop: "-0.3942em", display: "table" } }, AU = { body: { fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol" }, heading: { fontFamily: "Inter, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif" }, monospace: { fontFamily: "IBM Plex Mono, Menlo, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier, monospace" } }, YQ = { family: AU, size: { xxSmall: MU, xSmall: TU, small: OU, medium: DU, large: jU }, weight: { regular: { fontWeight: "400" }, medium: { fontWeight: "500" }, bold: { fontWeight: "600" } } }, kU = Yi({ defaultClassName: "_1j32j980", variantClassNames: { align: { center: "_1j32j981", left: "_1j32j982", right: "_1j32j983" }, family: { body: "_1j32j984", heading: "_1j32j985", monospace: "_1j32j986" }, size: { xxSmall: "_1j32j987", xSmall: "_1j32j988", small: "_1j32j989", medium: "_1j32j98a", large: "_1j32j98b" }, weight: { regular: "_1j32j98c", medium: "_1j32j98d", bold: "_1j32j98e" }, case: { capital: "_1j32j98f", upper: "_1j32j98g", lower: "_1j32j98h" }, break: { all: "_1j32j98i", word: "_1j32j98j", normal: "_1j32j98k", none: "_1j32j98l" } }, defaultVariants: { family: "body", size: "small", weight: "medium" }, compoundVariants: [[{ family: "monospace", size: "small" }, "_1j32j98m"], [{ family: "monospace", size: "xSmall" }, "_1j32j98n"], [{ family: "monospace", size: "xxSmall" }, "_1j32j98o"]] });
const Yr = Sa.forwardRef(
  ({
    as: e,
    children: t,
    color: a,
    decoration: l,
    display: h,
    lines: g,
    transform: m,
    userSelect: S,
    cssClass: b,
    title: R,
    whiteSpace: D,
    wrap: T,
    ...j
  }, A) => {
    const L = g ? /* @__PURE__ */ f.jsx(Zx, { ref: A, lines: g, children: t }) : t;
    return /* @__PURE__ */ f.jsx(
      ct,
      {
        as: e,
        color: a,
        cssClass: Fr(kU({ ...j }), b),
        display: h,
        overflowWrap: T,
        ref: g ? void 0 : A,
        textDecoration: l,
        textTransform: m,
        title: R,
        userSelect: S,
        whiteSpace: D,
        children: L
      }
    );
  }
);
Yr.displayName = "Text";
var LU = Yi({ defaultClassName: "_989awr4", variantClassNames: { size: { small: "_989awr5 _989awr0 _1faqfmv4a _1faqfmv4u", medium: "_989awr6 _989awr1 _1faqfmv4b _1faqfmv4v", large: "_989awr7 _989awr2 _1faqfmv4c _1faqfmv4w" }, shape: { rounded: "_989awr8", basic: "_989awr9" }, variant: { white: "_989awra", gray: "_989awrb", outlineGray: "_989awrc", green: "_989awrd", blue: "_989awre _989awr3 _1faqfmvcz", red: "_989awrf", yellow: "_989awrg", purple: "_989awrh", outlinePurple: "_989awri" } }, defaultVariants: { size: "small", shape: "basic", variant: "white" }, compoundVariants: [[{ size: "small", shape: "basic" }, "_989awrj"], [{ size: "medium", shape: "basic" }, "_989awrk"], [{ size: "large", shape: "basic" }, "_989awrl"], [{ size: "small", shape: "rounded" }, "_989awrm"], [{ size: "medium", shape: "rounded" }, "_989awrn"], [{ size: "large", shape: "rounded" }, "_989awro"]] });
const Vp = ({
  iconStart: e,
  iconEnd: t,
  label: a,
  lines: l,
  cssClass: h,
  size: g,
  shape: m,
  variant: S,
  ...b
}) => {
  let R;
  switch (g) {
    case "large":
      R = "small";
      break;
    default:
      R = "xSmall";
  }
  let D;
  switch (S) {
    case "red":
      D = "r11";
      break;
    case "blue":
      D = "lb700";
      break;
    case "yellow":
      D = "y11";
      break;
    case "green":
      D = "good";
      break;
    case "gray":
      D = "default";
      break;
    case "outlineGray":
      D = "default";
      break;
    case "outlinePurple":
      D = "p6";
      break;
    case "white":
      D = "moderate";
      break;
    case "purple":
      D = "informative";
      break;
    default:
      D = "moderate";
  }
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "2",
      cssClass: [LU({ size: g, shape: m, variant: S }), h],
      ...b,
      children: [
        e,
        a && /* @__PURE__ */ f.jsx(Yr, { size: R, color: D, as: "span", lines: l, children: a }),
        t
      ]
    }
  );
};
var IU = { grey: "inset 0px -1px 0px rgba(0, 0, 0, 0.1)", primary: "inset 0px -1px 0px rgba(0, 0, 0, 0.32)", neutral: "0 0 0 1px #f9f8f9 inset", n5: "0 0 0 1px #e9e8ea inset" }, Px = "small", d8 = Yi({ defaultClassName: "_6syg4r0", variantClassNames: { size: { xSmall: "_6syg4r1", small: "_6syg4r2", medium: "_6syg4r3", large: "_6syg4r4", xLarge: "_6syg4r5" }, emphasis: { high: "_6syg4r6", medium: "_6syg4r7", low: "_6syg4r8" }, kind: { primary: "_6syg4r9", secondary: "_6syg4ra", danger: "_6syg4rb" } }, defaultVariants: { size: "small" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "_6syg4rc"]] }), AT = Yi({ defaultClassName: "_6syg4rh _6syg4rd _1faqfmvsz _1faqfmvex _1faqfmv21 _1faqfmvwf", variantClassNames: { emphasis: { high: "_6syg4ri", medium: "_6syg4rj", low: "_6syg4rk" }, kind: { primary: "_6syg4rl", secondary: "_6syg4rm", danger: "_6syg4rn" }, size: { xSmall: "_6syg4ro _6syg4re _1faqfmv4c _1faqfmv4w _1faqfmv3 _1faqfmvuf", small: "_6syg4rp _6syg4rf _1faqfmv4c _1faqfmv4w _1faqfmv5 _1faqfmvuj", medium: "_6syg4rq _6syg4rg _1faqfmv4e _1faqfmv4y _1faqfmv5 _1faqfmvuj" } }, defaultVariants: { kind: "primary", emphasis: "high", size: "small" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "_6syg4rr"], [{ kind: "primary", emphasis: "medium" }, "_6syg4rs"], [{ kind: "primary", emphasis: "low" }, "_6syg4rt"], [{ kind: "secondary", emphasis: "high" }, "_6syg4ru"], [{ kind: "secondary", emphasis: "medium" }, "_6syg4rv"], [{ kind: "secondary", emphasis: "low" }, "_6syg4rw"]] });
const $Q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultSize: Px,
  iconVariants: d8,
  shadows: IU,
  variants: AT
}, Symbol.toStringTag, { value: "Module" })), HU = {
  xSmall: "xSmall",
  small: "small",
  medium: "small",
  large: "small",
  xLarge: "large"
}, f3 = Sa.forwardRef(
  ({
    children: e,
    iconLeft: t,
    iconRight: a,
    size: l = Px,
    kind: h,
    emphasis: g,
    className: m,
    cssClass: S,
    disabled: b,
    ...R
  }, D) => /* @__PURE__ */ f.jsx(
    Y5,
    {
      disabled: b,
      className: Fr(
        AT({
          kind: h,
          size: l,
          emphasis: g
        }),
        m,
        S
      ),
      ref: D,
      type: "button",
      ...R,
      children: /* @__PURE__ */ f.jsx(
        ZU,
        {
          iconLeft: t,
          iconRight: a,
          size: l,
          kind: h,
          emphasis: g,
          disabled: b,
          children: e
        }
      )
    }
  )
), ZU = ({
  children: e,
  disabled: t,
  emphasis: a,
  iconLeft: l,
  iconRight: h,
  kind: g,
  size: m = Px
}) => {
  const S = HU[m];
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    l && /* @__PURE__ */ f.jsx(
      ct,
      {
        as: "span",
        display: "inline-flex",
        disabled: t,
        cssClass: d8({
          size: m,
          emphasis: a,
          kind: g
        }),
        children: l
      }
    ),
    e && /* @__PURE__ */ f.jsx(
      Yr,
      {
        userSelect: "none",
        size: S,
        align: "center",
        display: "inline-flex",
        children: e
      }
    ),
    h && /* @__PURE__ */ f.jsx(
      ct,
      {
        as: "span",
        display: "inline-flex",
        disabled: t,
        cssClass: d8({
          size: m,
          emphasis: a,
          kind: g
        }),
        children: h
      }
    )
  ] });
};
var PU = Yi({ defaultClassName: "oor2ha0", variantClassNames: { shape: { thin: "oor2ha1", square: "oor2ha2" }, emphasis: { low: "oor2ha3", medium: "oor2ha4", high: "oor2ha5", none: "oor2ha6" }, size: { xSmall: "oor2ha7", small: "oor2ha8", medium: "oor2ha9", minimal: "oor2haa" }, kind: { primary: "oor2hab", secondary: "oor2hac" } }, defaultVariants: { kind: "primary", emphasis: "medium", shape: "square", size: "small" }, compoundVariants: [[{ size: "xSmall", shape: "thin" }, "oor2had"], [{ size: "small", shape: "thin" }, "oor2hae"], [{ size: "medium", shape: "thin" }, "oor2haf"], [{ emphasis: "high", kind: "primary" }, "oor2hag"], [{ emphasis: "medium", kind: "primary" }, "oor2hah"], [{ emphasis: "low", kind: "primary" }, "oor2hai"], [{ emphasis: "high", kind: "secondary" }, "oor2haj"], [{ emphasis: "medium", kind: "secondary" }, "oor2hak"], [{ emphasis: "low", kind: "secondary" }, "oor2hal"]] });
const d3 = O8(
  ({
    icon: e,
    kind: t,
    shape: a,
    emphasis: l,
    size: h,
    onClick: g,
    disabled: m,
    cssClass: S,
    className: b,
    type: R = "button"
  }, D) => /* @__PURE__ */ f.jsx(
    ct,
    {
      as: "button",
      display: "inline-flex",
      cssClass: Fr(
        PU({ kind: t, shape: a, emphasis: l, size: h }),
        b,
        S
      ),
      onClick: g,
      disabled: m,
      type: R,
      ref: D,
      children: e
    }
  )
);
var NU = "_88y39m0", VU = Yi({ defaultClassName: "_88y39m1", variantClassNames: { kind: { primary: "_88y39m2", secondary: "_88y39m3", light: "_88y39m4" } }, defaultVariants: { kind: "primary" }, compoundVariants: [] });
const WQ = ({
  children: e,
  kind: t,
  ...a
}) => /* @__PURE__ */ f.jsx(
  Y5,
  {
    render: /* @__PURE__ */ f.jsx("button", {}),
    className: Fr(NU, VU({ kind: t })),
    type: "button",
    ...a,
    children: /* @__PURE__ */ f.jsx(Yr, { children: e })
  }
), zQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 14 9-5-9-5-9 5 9 5Zm0 0 6.16-3.422a12.083 12.083 0 0 1 .665 6.479A11.952 11.952 0 0 0 12 20.055a11.952 11.952 0 0 0-6.824-2.998 12.078 12.078 0 0 1 .665-6.479L12 14Zm-4 6v-7.5l4-2.222"
      }
    )
  }
), qQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v1.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-9.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-6 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), GQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2.586l-3.707 3.707a1 1 0 0 1-1.414 0L7.586 17H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3a1 1 0 0 1 .707.293L12 18.586l3.293-3.293A1 1 0 0 1 16 15h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm1 3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KQ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 1 5.83V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8.83A3.001 3.001 0 0 1 2 6Zm4 3v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9H6ZM5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5Zm4 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), QQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v5.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), XQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.707-3.707a1 1 0 0 1 0 1.414L10.414 11H16a1 1 0 1 1 0 2h-5.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), JQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10.293-3.707a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 1 1 0-2h5.586l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), eX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9-1.586-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 10.414V16a1 1 0 1 1-2 0v-5.586Z",
        clipRule: "evenodd"
      }
    )
  }
), tX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), nX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.707 4.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 7.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), iX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.293 7.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), lX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414-1.414l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), oX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), uX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H6.414l3.293 3.293a1 1 0 0 1-1.414 1.414L5 6.414V8a1 1 0 0 1-2 0V4Zm13-1h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L17.586 5H16a1 1 0 1 1 0-2ZM9.707 14.293a1 1 0 0 1 0 1.414L6.414 19H8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v1.586l3.293-3.293a1 1 0 0 1 1.414 0Zm4.586 0a1 1 0 0 1 1.414 0L19 17.586V16a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.586l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), sX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a1 1 0 0 1 1 1v9.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L11 15.586V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.707 6.293a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), fX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L15.586 13H6a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), dX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 5.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L13 8.414V18a1 1 0 1 1-2 0V8.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l5-5Z",
        clipRule: "evenodd"
      }
    )
  }
), hX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l7-7Z",
        clipRule: "evenodd"
      }
    )
  }
), vX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 4 14.928 1 1 0 1 1 1 1.732A9.96 9.96 0 0 1 11.942 22C6.446 21.968 2 17.503 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 17 12v1.5a1.5 1.5 0 0 0 3 0V12a8 8 0 0 0-8-8Zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), pX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.707 4.879A3 3 0 0 1 10.828 4H19a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-8.172a3 3 0 0 1-2.12-.879l-6.415-6.414a1 1 0 0 1 0-1.414l6.414-6.414ZM10.828 6a1 1 0 0 0-.707.293L4.414 12l5.707 5.707a1 1 0 0 0 .707.293H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-8.172Zm.465 3.293a1 1 0 0 1 1.414 0L14 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L15.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L14 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L12.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), mX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.133 3.13a4.42 4.42 0 0 1 5.734 0c.388.33.87.53 1.378.57A4.42 4.42 0 0 1 20.3 7.755c.04.508.24.99.57 1.378a4.42 4.42 0 0 1 0 5.734c-.33.388-.53.87-.57 1.378a4.42 4.42 0 0 1-4.055 4.055c-.508.04-.99.24-1.378.57a4.42 4.42 0 0 1-5.734 0 2.42 2.42 0 0 0-1.378-.57A4.42 4.42 0 0 1 3.7 16.245a2.42 2.42 0 0 0-.57-1.378 4.42 4.42 0 0 1 0-5.734c.33-.388.53-.87.57-1.378A4.42 4.42 0 0 1 7.755 3.7c.508-.04.99-.24 1.378-.57Zm4.437 1.522a2.42 2.42 0 0 0-3.14 0 4.42 4.42 0 0 1-2.516 1.042 2.42 2.42 0 0 0-2.22 2.22 4.42 4.42 0 0 1-1.042 2.516 2.42 2.42 0 0 0 0 3.14 4.42 4.42 0 0 1 1.042 2.516 2.42 2.42 0 0 0 2.22 2.22 4.42 4.42 0 0 1 2.516 1.042 2.42 2.42 0 0 0 3.14 0 4.42 4.42 0 0 1 2.516-1.042 2.42 2.42 0 0 0 2.22-2.22 4.42 4.42 0 0 1 1.042-2.516 2.42 2.42 0 0 0 0-3.14 4.42 4.42 0 0 1-1.042-2.516 2.42 2.42 0 0 0-2.22-2.22 4.42 4.42 0 0 1-2.516-1.042Zm2.137 4.64a1 1 0 0 1 0 1.415l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.094 5.68 18.32 16.906A8.001 8.001 0 0 0 7.094 5.68Zm9.812 12.64L5.68 7.094A8.002 8.002 0 0 0 16.906 18.32ZM4.929 4.93c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142Z",
        clipRule: "evenodd"
      }
    )
  }
), wX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.076 3.617A1 1 0 0 1 8 3h8a1 1 0 0 1 .707 1.707L16 5.414v4.758a1 1 0 0 0 .293.707l3.84 3.84.002.002.001.001 1.157 1.157c1.89 1.89.551 5.121-2.122 5.121H4.828c-2.673 0-4.011-3.231-2.121-5.121l.828-.829h.001l4.17-4.171A1 1 0 0 0 8 10.172V5.414l-.707-.707a1 1 0 0 1-.217-1.09ZM10 5v5.172a3 3 0 0 1-.879 2.12l-2.093 2.094 1.15.23a5 5 0 0 0 3.216-.431l.317-.159a7 7 0 0 1 4.252-.648l-1.084-1.085a3 3 0 0 1-.88-2.121V5h-4Zm8.72 11.134a1 1 0 0 0-.51-.272l-2.388-.478a5 5 0 0 0-3.216.431l-.318.159a7 7 0 0 1-4.503.603l-1.932-.387a1 1 0 0 0-.903.274l-.829.829c-.63.63-.184 1.707.707 1.707h14.343c.891 0 1.337-1.077.707-1.707l-1.157-1.158h-.001Z",
        clipRule: "evenodd"
      }
    )
  }
), yX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.018 4.665a3 3 0 0 1 5.963 0A7 7 0 0 1 19 11v3.159c0 .273.109.535.302.729l1.405 1.405A1 1 0 0 1 20 18h-4a4 4 0 0 1-8 0H4a1 1 0 0 1-.707-1.707l1.405-1.405c.193-.194.302-.456.302-.73V11a7 7 0 0 1 4.018-6.335ZM10 18a2 2 0 1 0 4 0h-4Zm2-14a1 1 0 0 0-1 1v.341a1 1 0 0 1-.667.943A5.003 5.003 0 0 0 7 11v3.159c0 .669-.221 1.315-.623 1.841h11.246A3.032 3.032 0 0 1 17 14.159V11a5.002 5.002 0 0 0-3.333-4.716A1 1 0 0 1 13 5.341V5a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L12 18.618l-6.553 3.276A1 1 0 0 1 4 21V5Zm3-1a1 1 0 0 0-1 1v14.382l5.553-2.776a1 1 0 0 1 .894 0L18 19.382V5a1 1 0 0 0-1-1H7Z",
        clipRule: "evenodd"
      }
    )
  }
), SX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm12-1H9v9.382l2.553-1.276a1 1 0 0 1 .894 0L15 14.382V5ZM7 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1v11a1 1 0 0 1-1.447.894L12 15.118l-3.553 1.776A1 1 0 0 1 7 16V5Z",
        clipRule: "evenodd"
      }
    )
  }
), CX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 6.82v10.806A9.823 9.823 0 0 1 7.5 17c1.252 0 2.446.222 3.5.626V6.819C10.06 6.317 8.848 6 7.5 6c-1.348 0-2.56.317-3.5.82Zm9 0v10.806A9.823 9.823 0 0 1 16.5 17c1.252 0 2.446.222 3.5.626V6.819C19.06 6.317 17.848 6 16.5 6c-1.348 0-2.56.317-3.5.82Zm-1-1.734C10.733 4.395 9.168 4 7.5 4c-1.92 0-3.703.523-5.053 1.42A1 1 0 0 0 2 6.253v13a1 1 0 0 0 1.553.833C4.54 19.43 5.927 19 7.5 19s2.961.431 3.947 1.086a1 1 0 0 0 1.106 0C13.54 19.43 14.927 19 16.5 19s2.961.431 3.947 1.086A1 1 0 0 0 22 19.253v-13a1 1 0 0 0-.447-.833C20.203 4.523 18.42 4 16.5 4c-1.668 0-3.233.395-4.5 1.086Z",
        clipRule: "evenodd"
      }
    )
  }
), bX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h2V4ZM5 7a1 1 0 0 0-1 1v4.57A22.95 22.95 0 0 0 12 14c2.815 0 5.51-.505 8-1.43V8a1 1 0 0 0-1-1H5Zm10-2H9V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1Zm5 9.692A24.971 24.971 0 0 1 12 16a24.98 24.98 0 0 1-8-1.308V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3.308ZM11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _X = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1ZM9 5a1 1 0 0 1 1 1v1h1V6a1 1 0 1 1 2 0v1h1V6a1 1 0 1 1 2 0v1a3 3 0 0 1 3 3v1a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a3 3 0 0 1 3-3v-1a3 3 0 0 1 3-3V6a1 1 0 0 1 1-1ZM8 9a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1H8Zm-3 4a1 1 0 0 0-1 1v.683c.369.104.725.265 1.055.485a1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0c.33-.22.686-.381 1.055-.485V14a1 1 0 0 0-1-1H5Zm15 3.868a3.704 3.704 0 0 1-4.055-.036 1.704 1.704 0 0 0-1.89 0 3.704 3.704 0 0 1-4.11 0 1.704 1.704 0 0 0-1.89 0A3.704 3.704 0 0 1 4 16.868V20h16v-3.132Z",
        clipRule: "evenodd"
      }
    )
  }
), RX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm1 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm-6 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-7 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), EX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2V3a1 1 0 0 1 1-1ZM7 6H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6Zm-1 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), MX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.07 5a1 1 0 0 0-.832.445l-.812 1.22A3 3 0 0 1 5.93 8H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-.93a3 3 0 0 1-2.496-1.336l-.812-1.219A1 1 0 0 0 13.93 5h-3.86Zm-2.496-.664A3 3 0 0 1 10.07 3h3.86a3 3 0 0 1 2.496 1.336l.812 1.219A1 1 0 0 0 18.07 6H19a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h.93a1 1 0 0 0 .832-.445l.812-1.22ZM12 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), TX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3V7Zm6 10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6Zm8-9H9a3 3 0 0 0-3 3v3H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1Zm-2 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), OX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 13 22h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 7 22H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2c.35 0 .687.06 1 .17V9a3 3 0 0 1 3-3h2c.35 0 .687.06 1 .17V5Zm2 14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v14ZM14 9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9Zm-6 4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6Z",
        clipRule: "evenodd"
      }
    )
  }
), DX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.667 2.31a1 1 0 0 1 .333.745V12h8.945a1 1 0 0 1 .994 1.11C21.386 18.11 17.148 22 12 22 6.477 22 2 17.523 2 12c0-5.148 3.89-9.386 8.89-9.939a1 1 0 0 1 .777.249ZM10 4.252A8 8 0 1 0 19.748 14H11a1 1 0 0 1-1-1V4.252Zm4.423-1.556a1 1 0 0 1 .91-.127 10.025 10.025 0 0 1 6.098 6.098A1 1 0 0 1 20.488 10H15a1 1 0 0 1-1-1V3.512a1 1 0 0 1 .423-.816ZM16 5.07V8h2.93A8.044 8.044 0 0 0 16 5.07Z",
        clipRule: "evenodd"
      }
    )
  }
), jX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm10 2a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4 3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm-4 3a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), AX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5c-4.532 0-8 3.241-8 7 0 1.352.438 2.619 1.209 3.7a1 1 0 0 1 .122.931l-.763 2.036 2.98-.597a1 1 0 0 1 .628.079A8.862 8.862 0 0 0 12 19c4.532 0 8-3.242 8-7 0-3.759-3.468-7-8-7ZM2 12c0-5.078 4.591-9 10-9s10 3.922 10 9c0 5.078-4.591 9-10 9-1.565 0-3.051-.324-4.377-.905l-4.427.886a1 1 0 0 1-1.132-1.332l1.215-3.24A8.283 8.283 0 0 1 2 12Zm5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-4.586l-4.707 4.707A1 1 0 0 1 8 21v-4H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 1 1 1v2.586l3.293-3.293A1 1 0 0 1 14 15h5a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm2 5a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), LX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v3a1 1 0 0 1-1.707.707L12.586 19H9a2.99 2.99 0 0 1-1.293-.293A1 1 0 0 1 6 18v-3H5a3 3 0 0 1-3-3V6Zm7.414 11H13a1 1 0 0 1 .707.293L16 19.586V18a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-1v3a3 3 0 0 1-3 3h-3.586l-2 2ZM16 6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v1.586l2.293-2.293A1 1 0 0 1 11 13h4a1 1 0 0 0 1-1V6Z",
        clipRule: "evenodd"
      }
    )
  }
), IX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), HX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-2.707a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ZX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), PX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 0 1 0 1.414L9.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), NX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 19.707a1 1 0 0 1 0-1.414L14.586 12 8.293 5.707a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), VX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 15.707a1 1 0 0 1-1.414 0L12 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), BX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Zm0 8a1 1 0 0 1 1.414 0L12 18.586l6.293-6.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), FX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.707 4.293a1 1 0 0 1 0 1.414L5.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Zm8 0a1 1 0 0 1 0 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), UX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414Zm8 0a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 12l-6.293-6.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), YX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 3.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L12 5.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l7-7ZM12 13.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 1 0 1.414 1.414L12 13.414Z",
        clipRule: "evenodd"
      }
    )
  }
), $X = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 1 1 1v1h4V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v1h1a1 1 0 1 1 0 2h-1v4h1a1 1 0 1 1 0 2h-1v1a3 3 0 0 1-3 3h-1v1a1 1 0 1 1-2 0v-1h-4v1a1 1 0 1 1-2 0v-1H7a3 3 0 0 1-3-3v-1H3a1 1 0 1 1 0-2h1v-4H3a1 1 0 0 1 0-2h1V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1ZM7 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9Zm2 1v4h4v-4h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), WX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
        clipRule: "evenodd"
      }
    )
  }
), zX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm4.707 7.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 14.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), qX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.17 4A3.001 3.001 0 0 1 10 2h2c1.306 0 2.418.835 2.83 2H16a3 3 0 0 1 3 3v3a1 1 0 1 1-2 0V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 12 8h-2a3.001 3.001 0 0 1-2.83-2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17ZM10 4a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm3.707 6.293a1 1 0 0 1 0 1.414L12.414 13H20a1 1 0 1 1 0 2h-7.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), GX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-3 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm-3 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v3.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 11 12V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), QX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 6a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 18h9a4 4 0 1 0-.08-8 1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 6Zm-6 4a6 6 0 0 1 11.671-1.963A6 6 0 0 1 16 20H7a5 5 0 0 1-1.986-9.59A6.071 6.071 0 0 1 5 10Z",
        clipRule: "evenodd"
      }
    )
  }
), XX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 3a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 15a1 1 0 1 1 0 2 5 5 0 0 1-1.986-9.59A6 6 0 0 1 16.67 5.037a6 6 0 0 1 .53 11.843 1 1 0 1 1-.398-1.96A4.002 4.002 0 0 0 15.92 7a1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 3Zm1 6a1 1 0 0 1 1 1v9.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 19.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), JX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 3a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 15a1 1 0 1 1 0 2 5 5 0 0 1-1.986-9.59A6 6 0 0 1 16.67 5.037a6 6 0 0 1 .53 11.843 1 1 0 1 1-.398-1.96A4.002 4.002 0 0 0 15.92 7a1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 3Zm.293 6.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 12.414V22a1 1 0 1 1-2 0v-9.586l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), eJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.242 3.03a1 1 0 0 1 .728 1.213l-4 16a1 1 0 1 1-1.94-.485l4-16a1 1 0 0 1 1.213-.728ZM6.707 7.293a1 1 0 0 1 0 1.414L3.414 12l3.293 3.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Zm10.586 0a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L20.586 12l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), tJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.353 4.081c.674-2.775 4.62-2.775 5.294 0a.724.724 0 0 0 1.08.448c2.44-1.486 5.23 1.305 3.744 3.744a.724.724 0 0 0 .448 1.08c2.775.674 2.775 4.62 0 5.294a.724.724 0 0 0-.448 1.08c1.486 2.44-1.305 5.23-3.744 3.744a.724.724 0 0 0-1.08.448c-.674 2.775-4.62 2.775-5.294 0a.724.724 0 0 0-1.08-.448c-2.44 1.486-5.23-1.305-3.744-3.744a.724.724 0 0 0-.448-1.08c-2.775-.674-2.775-4.62 0-5.294a.724.724 0 0 0 .448-1.08c-1.486-2.44 1.305-5.23 3.744-3.744a.724.724 0 0 0 1.08-.448Zm3.35.472c-.178-.737-1.227-.737-1.407 0a2.724 2.724 0 0 1-4.064 1.684c-.648-.395-1.39.347-.995.995a2.723 2.723 0 0 1-1.684 4.064c-.737.18-.737 1.229 0 1.408a2.724 2.724 0 0 1 1.684 4.064c-.395.648.347 1.39.995.995a2.724 2.724 0 0 1 4.064 1.684c.18.737 1.229.737 1.408 0a2.724 2.724 0 0 1 4.064-1.684c.648.395 1.39-.347.995-.995a2.724 2.724 0 0 1 1.684-4.064c.737-.18.737-1.229 0-1.408a2.724 2.724 0 0 1-1.684-4.064c.395-.648-.347-1.39-.995-.995a2.723 2.723 0 0 1-4.064-1.684ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), nJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1.17c1.165.413 2 1.524 2 2.83v1.17c1.165.412 2 1.524 2 2.83v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6c0-1.306.835-2.418 2-2.83V9c0-1.306.835-2.417 2-2.83V5Zm2 1h8V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1Zm-2 4h12V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1Zm-1 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H5Z",
        clipRule: "evenodd"
      }
    )
  }
), rJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 2.93 3 3 0 0 1 4.192.05l2.829 2.828A3 3 0 0 1 19.069 12 3 3 0 0 1 22 15v4a3 3 0 0 1-3 3H7a5 5 0 0 1-5-5V5Zm9.071 15H19a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.929l-6 6Zm4.878-7.707h.001l1.657-1.657a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 0 0-1.414 0L12 7.757v8.486l3.95-3.95ZM9.123 19.12A2.99 2.99 0 0 0 10 17V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a3 3 0 0 0 5.123 2.12ZM6 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8Zm2 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5H4Zm16-2H4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1ZM6 15a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), iJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.553 2.106a1 1 0 0 1 .894 0l8 4A1 1 0 0 1 21 7v10a1 1 0 0 1-.553.894l-8 4a1 1 0 0 1-.894 0l-8-4A1 1 0 0 1 3 17V7a1 1 0 0 1 .553-.894l8-4ZM5 8.618l6 3v7.764l-6-3V8.618Zm8 10.764 6-3V8.618l-6 3v7.764Zm-1-9.5L17.764 7 12 4.118 6.236 7 12 9.882Z",
        clipRule: "evenodd"
      }
    )
  }
), lJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.553 2.106a1 1 0 0 1 .894 0l2 1a1 1 0 1 1-.894 1.788L12 4.118l-1.553.776a1 1 0 1 1-.894-1.788l2-1ZM6.894 5.553a1 1 0 0 1-.447 1.341L6.237 7l.21.106a1 1 0 0 1-.894 1.788L5 8.618V9.5a1 1 0 1 1-2 0V7a1 1 0 0 1 .553-.894l2-1a1 1 0 0 1 1.341.447Zm10.212 0a1 1 0 0 1 1.341-.447l2 1A1 1 0 0 1 21 7v2.5a1 1 0 1 1-2 0v-.882l-.553.276a1 1 0 1 1-.894-1.788l.21-.106-.21-.106a1 1 0 0 1-.447-1.341Zm-8 4a1 1 0 0 1 1.341-.447L12 9.882l1.553-.776a1 1 0 1 1 .894 1.788L13 11.618V13.5a1 1 0 1 1-2 0v-1.882l-1.447-.724a1 1 0 0 1-.447-1.341ZM4 13.5a1 1 0 0 1 1 1v1.882l1.447.724a1 1 0 1 1-.894 1.788l-2-1A1 1 0 0 1 3 17v-2.5a1 1 0 0 1 1-1Zm16 0a1 1 0 0 1 1 1V17a1 1 0 0 1-.553.894l-2 1a1 1 0 1 1-.894-1.788L19 16.382V14.5a1 1 0 0 1 1-1Zm-8 4a1 1 0 0 1 1 1v.882l.553-.276a1 1 0 1 1 .894 1.788l-2 1a1 1 0 0 1-.894 0l-2-1a1 1 0 1 1 .894-1.788l.553.276V18.5a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), oJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-5a1 1 0 0 1 1-1 3 3 0 0 1 3 3v1h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 0 2 0v-1a1 1 0 1 1 2 0v1a3 3 0 1 1-6 0v-3H9a1 1 0 1 1 0-2h1V9a1 1 0 0 0-1-1 1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-6a1 1 0 0 1 1 1v.092c.94.177 1.791.604 2.354 1.253a1 1 0 0 1-1.51 1.31c-.163-.187-.453-.377-.844-.504v1.941a4.535 4.535 0 0 1 1.676.662C15.398 12.234 16 13.009 16 14c0 .99-.602 1.765-1.324 2.246-.48.32-1.054.545-1.676.662V17a1 1 0 1 1-2 0v-.092c-.94-.177-1.791-.604-2.354-1.253a1 1 0 0 1 1.51-1.31c.163.187.453.377.844.504v-1.941a4.535 4.535 0 0 1-1.676-.662C8.602 11.766 8 10.991 8 10c0-.99.602-1.765 1.324-2.246A4.535 4.535 0 0 1 11 7.092V7a1 1 0 0 1 1-1Zm-1 3.151c-.22.071-.412.164-.567.267C10.07 9.66 10 9.886 10 10c0 .114.07.34.433.582.155.103.346.196.567.267V9.151Zm2 4v1.698c.22-.071.412-.164.567-.267.364-.243.433-.468.433-.582 0-.114-.07-.34-.433-.582A2.305 2.305 0 0 0 13 13.15Z",
        clipRule: "evenodd"
      }
    )
  }
), sJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4c-.304 0-.792.193-1.264.979a4.259 4.259 0 0 0-.264.521H12a1 1 0 1 1 0 2h-1.983a7.321 7.321 0 0 0 0 1H12a1 1 0 1 1 0 2h-1.528c.08.185.167.36.264.521.472.786.96.979 1.264.979.304 0 .792-.193 1.264-.979a1 1 0 0 1 1.715 1.029C14.279 17.216 13.232 18 12 18s-2.279-.784-2.979-1.95c-.285-.475-.507-1-.67-1.55H8a1 1 0 1 1 0-2h.013a9.358 9.358 0 0 1 0-1H8a1 1 0 1 1 0-2h.351c.163-.55.385-1.075.67-1.55C9.721 6.784 10.768 6 12 6s2.279.784 2.979 1.95a1 1 0 1 1-1.715 1.029C12.792 8.193 12.304 8 12 8Z",
        clipRule: "evenodd"
      }
    )
  }
), cJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm8-3a3 3 0 1 1 6 0 1 1 0 1 1-2 0 1 1 0 1 0-2 0v2h1a1 1 0 1 1 0 2h-1v1c0 .35-.06.687-.17 1H15a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-1H9a1 1 0 1 1 0-2h1V9Z",
        clipRule: "evenodd"
      }
    )
  }
), fJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-1.535c.179.31.318.645.409 1H15a1 1 0 1 1 0 2h-1.126a4.008 4.008 0 0 1-2.65 2.81l1.483 1.483a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 9 13h1a2 2 0 0 0 1.732-1H9a1 1 0 1 1 0-2h2.732A2 2 0 0 0 10 9H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), dJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6.486-4.857a1 1 0 0 1 1.371.343L11.967 11h.067l2.108-3.514a1 1 0 0 1 1.716 1.029L14.366 11H15a1 1 0 1 1 0 2h-1.834l-.166.277V14h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1H9a1 1 0 1 1 0-2h2v-.723L10.834 13H9a1 1 0 1 1 0-2h.634L8.143 8.514a1 1 0 0 1 .342-1.371Z",
        clipRule: "evenodd"
      }
    )
  }
), hJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.93 1.273a1 1 0 0 1 1.224.707l.777 2.897a1 1 0 0 1-1.932.518l-.777-2.898a1 1 0 0 1 .707-1.224Zm7.727 2.07a1 1 0 0 1 0 1.414L12.535 6.88a1 1 0 1 1-1.414-1.414l2.122-2.122a1 1 0 0 1 1.414 0ZM1.272 6.93a1 1 0 0 1 1.225-.707L5.395 7a1 1 0 0 1-.518 1.932L1.98 8.154a1 1 0 0 1-.708-1.225Zm7.02 1.364a1 1 0 0 1 1.05-.233l11 4a1 1 0 0 1 .03 1.868l-3.593 1.437 3.928 3.928a1 1 0 0 1-1.414 1.414l-3.928-3.928-1.437 3.592a1 1 0 0 1-1.868-.03l-4-11a1 1 0 0 1 .233-1.048Zm2.38 2.38 2.372 6.523 1.027-2.567a1 1 0 0 1 .558-.557l2.567-1.027-6.524-2.373Zm-3.793.448a1 1 0 0 1 0 1.415l-2.122 2.12a1 1 0 0 1-1.414-1.413l2.121-2.122a1 1 0 0 1 1.415 0Z",
        clipRule: "evenodd"
      }
    )
  }
), vJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.79 5.066C5.45 5.736 5 6.478 5 7s.449 1.263 1.79 1.934C8.072 9.574 9.912 10 12 10s3.928-.425 5.21-1.066C18.55 8.264 19 7.522 19 7s-.449-1.263-1.79-1.934C15.928 4.426 14.088 4 12 4s-3.928.425-5.21 1.066ZM19 10.201a7.846 7.846 0 0 1-.896.522C16.49 11.53 14.331 12 12 12c-2.33 0-4.49-.47-6.104-1.277A7.842 7.842 0 0 1 5 10.2V12c0 .522.449 1.263 1.79 1.934C8.072 14.574 9.912 15 12 15s3.928-.425 5.21-1.066C18.55 13.264 19 12.522 19 12v-1.8ZM21 7c0-1.687-1.342-2.946-2.896-3.723C16.49 2.47 14.331 2 12 2c-2.33 0-4.49.47-6.104 1.277C4.342 4.054 3 5.313 3 7v10c0 1.687 1.342 2.946 2.896 3.723C7.51 21.53 9.669 22 12 22c2.33 0 4.49-.47 6.104-1.277C19.658 19.946 21 18.687 21 17V7Zm-2 8.2a7.846 7.846 0 0 1-.896.523C16.49 16.53 14.331 17 12 17c-2.33 0-4.49-.47-6.104-1.277A7.842 7.842 0 0 1 5 15.2V17c0 .522.449 1.263 1.79 1.934C8.072 19.574 9.912 20 12 20s3.928-.425 5.21-1.066C18.55 18.264 19 17.522 19 17v-1.8Z",
        clipRule: "evenodd"
      }
    )
  }
), pJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-3.47l.373 1.489.804.804A1 1 0 0 1 16 22H8a1 1 0 0 1-.707-1.707l.804-.804L8.469 18H5a3 3 0 0 1-3-3V5Zm2 9v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1H4Zm16-2H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7Zm-6.53 6h-2.94l-.5 2h3.94l-.5-2Z",
        clipRule: "evenodd"
      }
    )
  }
), mJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8Zm3 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), gJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm4 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), wJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Z",
        clipRule: "evenodd"
      }
    )
  }
), yJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm8 4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm8 4a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), SJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.414L14.586 4H10ZM7 5a3 3 0 0 1 3-3h4.586A2 2 0 0 1 16 2.586L20.414 7A2 2 0 0 1 21 8.414V15a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1V5Zm0 3H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h-5a3 3 0 0 1-3-3V8Z",
        clipRule: "evenodd"
      }
    )
  }
), CJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm4 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm11 5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _J = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v11a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3h-7a1 1 0 1 1 0-2h7a1 1 0 0 0 1-1V9.414L12.586 4H7Zm5 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 1.968 3.446l-4.26 4.261a1 1 0 0 1-1.415-1.414l4.261-4.261A3.984 3.984 0 0 1 8 14Z",
        clipRule: "evenodd"
      }
    )
  }
), RJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm4 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), EJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), MJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), TJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
        clipRule: "evenodd"
      }
    )
  }
), OJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-1a1 1 0 1 1 2 0v1Zm2.293-5.707a1 1 0 0 1 1.414 0L11 13.586V4a1 1 0 1 1 2 0v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), DJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3V6Zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v8Zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1Z",
        clipRule: "evenodd"
      }
    )
  }
), jJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm-5.536 4.121a1 1 0 0 1 1.415 0 3 3 0 0 0 4.242 0 1 1 0 0 1 1.415 1.415 5 5 0 0 1-7.072 0 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), AJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm.121 6.879a3 3 0 0 0-4.242 0 1 1 0 1 1-1.414-1.415 5 5 0 0 1 7.07 0 1 1 0 0 1-1.414 1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), kJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.402 3.5c1.155-2 4.041-2 5.196 0l6.928 12c1.155 2-.288 4.5-2.598 4.5H5.072c-2.31 0-3.753-2.5-2.598-4.5l6.928-12Zm3.464 1a1 1 0 0 0-1.732 0l-6.928 12a1 1 0 0 0 .866 1.5h13.856a1 1 0 0 0 .866-1.5l-6.928-12ZM12 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-1 7a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), LJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), IJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2H6Zm10.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H7a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), HJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L17.586 5H14ZM6 7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4a1 1 0 1 1 0 2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), ZJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.512 12a9.004 9.004 0 0 0 16.977 0 9.004 9.004 0 0 0-16.977 0Zm-2.008-.3C2.906 7.238 7.074 4 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6C21.095 16.762 16.927 20 12 20s-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), PJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l3.04 3.04A10.955 10.955 0 0 1 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6 11.014 11.014 0 0 1-3.552 5.231l2.762 2.762a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm5.943 4.53 1.732 1.731a4 4 0 0 1 5.478 5.478l2.076 2.076A9.022 9.022 0 0 0 20.489 12 9.004 9.004 0 0 0 8.236 6.822Zm5.696 5.695a2 2 0 0 0-2.45-2.45l2.45 2.45ZM4.625 8.174a1 1 0 0 1 .194 1.4A8.975 8.975 0 0 0 3.512 12a9.004 9.004 0 0 0 10.177 5.842 1 1 0 0 1 .372 1.965c-.668.127-1.357.193-2.06.193-4.927 0-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6 10.97 10.97 0 0 1 1.72-3.332 1 1 0 0 1 1.4-.194Z",
        clipRule: "evenodd"
      }
    )
  }
), NJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 8c0-1.648 1.882-2.589 3.2-1.6L12 10V8c0-1.648 1.882-2.589 3.2-1.6l5.333 4a2 2 0 0 1 0 3.2l-5.333 4c-1.318.989-3.2.048-3.2-1.6v-2l-4.8 3.6c-1.318.989-3.2.048-3.2-1.6V8Zm7.333 4L6 8v8l5.333-4Zm8 0L14 8v8l5.333-4Z",
        clipRule: "evenodd"
      }
    )
  }
), VJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm4 0H4v2h2V5Zm2 0v6h8V5H8Zm10 0v2h2V5h-2Zm2 4h-2v2h2V9Zm0 4h-2v2h2v-2Zm0 4h-2v2h2v-2Zm-4 2v-6H8v6h8ZM6 19v-2H4v2h2Zm-2-4h2v-2H4v2Zm0-4h2V9H4v2Z",
        clipRule: "evenodd"
      }
    )
  }
), BJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.586A2 2 0 0 1 21.414 8L15 14.414V17a1 1 0 0 1-.293.707l-4 4A1 1 0 0 1 9 21v-6.586L2.586 8A2 2 0 0 1 2 6.586V4Zm18 0H4v2.586L10.414 13A2 2 0 0 1 11 14.414v4.172l2-2v-2.172A2 2 0 0 1 13.586 13L20 6.586V4Z",
        clipRule: "evenodd"
      }
    )
  }
), FJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 3.205A9 9 0 0 1 21 11c0 2.567-.358 5.051-1.029 7.406a1 1 0 0 1-1.923-.548C18.668 15.68 19 13.38 19 11A7 7 0 0 0 8.5 4.936a1 1 0 1 1-1-1.731Zm-1.93 2.93A1 1 0 0 1 5.936 7.5 6.963 6.963 0 0 0 5 11c0 1.72-.395 3.35-1.1 4.801a1 1 0 0 1-1.8-.874A8.96 8.96 0 0 0 3 11c0-1.638.438-3.176 1.205-4.5a1 1 0 0 1 1.366-.366ZM7 11a5 5 0 0 1 10 0 23 23 0 0 1-.213 3.135 1 1 0 0 1-1.981-.27c.128-.937.194-1.893.194-2.865a3 3 0 1 0-6 0 14.916 14.916 0 0 1-2.333 8.041 1 1 0 1 1-1.72-1.021l.068-.111.846.532-.846-.532A12.916 12.916 0 0 0 7 11Zm5-1a1 1 0 0 1 1 1 18.92 18.92 0 0 1-2.906 10.104A1 1 0 1 1 8.4 20.039 16.915 16.915 0 0 0 11 11a1 1 0 0 1 1-1Zm3.443 6.038a1 1 0 0 1 .69 1.234 22.876 22.876 0 0 1-1.56 4.02 1 1 0 1 1-1.788-.896 20.882 20.882 0 0 0 1.424-3.668 1 1 0 0 1 1.234-.69Z",
        clipRule: "evenodd"
      }
    )
  }
), UJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.359 2.22a1 1 0 0 1 1.332.07c.93.925 1.884 1.573 2.85 2.21l.185.122c.89.586 1.825 1.201 2.638 2.014A8.975 8.975 0 0 1 21 13 9 9 0 1 1 5.636 6.636a1 1 0 0 1 1.634.331v.003l.002.002m-.002-.005v.001l.013.028a4.197 4.197 0 0 0 .432.691c.114.15.253.312.418.476A12.62 12.62 0 0 0 8 10h1l.447-.894a5.051 5.051 0 0 1-1.314-.943C8.42 6.222 9.25 3.917 11.36 2.221m.623 2.14C10.379 6.05 10 8.32 10 10a1 1 0 0 1-1.447.894 6.998 6.998 0 0 1-2.323-1.86A6.98 6.98 0 0 0 5 13a7 7 0 1 0 11.95-4.95c-.664-.663-1.438-1.173-2.371-1.789l-.14-.092c-.765-.504-1.607-1.07-2.457-1.809Zm-4.71 2.613Zm3.795 3.706a1 1 0 0 1 .952-.68 3.99 3.99 0 0 1 2.81 1.171A3.99 3.99 0 0 1 16 14a4 4 0 1 1-8 0 1 1 0 0 1 1-1h1.283l.784-2.32Zm1.624 1.442-.744 2.198A1 1 0 0 1 11 15h-.733a2 2 0 1 0 2.424-2.878Z",
        clipRule: "evenodd"
      }
    )
  }
), YJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v9.17c.313-.11.65-.17 1-.17h6.5a1 1 0 0 1 .707.293l.707.707h6.468l-2.276-4.553a1 1 0 0 1 0-.894L19.382 5H13v4a1 1 0 1 1-2 0V4H5Zm7.914-1H21a1 1 0 0 1 .894 1.447L19.118 10l2.776 5.553A1 1 0 0 1 21 17h-8.5a1 1 0 0 1-.707-.293L11.086 16H5a1 1 0 0 0-1 1v4a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h6.5a1 1 0 0 1 .707.293l.5.5.207.207Z",
        clipRule: "evenodd"
      }
    )
  }
), $J = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Z",
        clipRule: "evenodd"
      }
    )
  }
), WJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm10 2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm10 2a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), qJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-5a3 3 0 0 1 3-3h7a1 1 0 0 0-1-1h-4.414l-2-2H5Zm4 5a1 1 0 0 0-1 1v5c0 .35-.06.687-.17 1H19a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H9Zm-4 9a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4.414l2 2H15a3 3 0 0 1 3 3h1a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H5Z",
        clipRule: "evenodd"
      }
    )
  }
), GJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm6 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.5 4a1.5 1.5 0 1 0 0 3H11V5.5A1.5 1.5 0 0 0 9.5 4Zm2.863-.514A3.5 3.5 0 0 0 6.337 7H5a3 3 0 0 0-1 5.83V19a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6.17A3.001 3.001 0 0 0 19 7h-2.17a3 3 0 0 0-4.467-3.514ZM13 6v1h1a1 1 0 1 0-1-1Zm-2 3H5a1 1 0 0 0 0 2h6V9Zm0 4H6v6a1 1 0 0 0 1 1h4v-7Zm2 7v-7h5v6a1 1 0 0 1-1 1h-4Zm0-9V9h6a1 1 0 1 1 0 2h-6Z",
        clipRule: "evenodd"
      }
    )
  }
), QJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.252 10H5a3 3 0 0 1 3 3v1a1 1 0 0 0 1 1 3 3 0 0 1 3 3v2a8 8 0 0 0 2-.252V18a3 3 0 0 1 3-3h2.419c.375-.926.581-1.94.581-3s-.206-2.074-.581-3H19a1 1 0 0 0-1 1 3 3 0 1 1-6 0 1 1 0 0 0-1-1h-.5a3.5 3.5 0 0 1-3.491-3.252A8.004 8.004 0 0 0 4.252 10Zm3.304-6.96A10 10 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10a9.958 9.958 0 0 0-1.039-4.444v-.001A10 10 0 0 0 12 2a9.959 9.959 0 0 0-4.444 1.04ZM9 4.581V5.5A1.5 1.5 0 0 0 10.5 7h.5a3 3 0 0 1 3 3 1 1 0 1 0 2 0 3 3 0 0 1 2.309-2.92A7.986 7.986 0 0 0 12 4a7.98 7.98 0 0 0-3 .582ZM18.245 17H17a1 1 0 0 0-1 1v.93A8.038 8.038 0 0 0 18.245 17ZM10 19.748C6.55 18.86 4 15.728 4 12h1a1 1 0 0 1 1 1v1a3 3 0 0 0 3 3 1 1 0 0 1 1 1v1.748Z",
        clipRule: "evenodd"
      }
    )
  }
), XJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 0 1 9-9"
      }
    )
  }
), JJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 4a.5.5 0 0 0-.5.5V11a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V14a1 1 0 1 1-2 0v-2.5a.5.5 0 0 0-1 0v2a6.5 6.5 0 1 0 13 0v-5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V4.5a.5.5 0 0 0-.5-.5Zm2.112-.838A2.5 2.5 0 0 1 17 5.5v.55a2.5 2.5 0 0 1 3 2.45v5a8.5 8.5 0 0 1-17 0v-2a2.5 2.5 0 0 1 3-2.45V5.5a2.5 2.5 0 0 1 3.388-2.338 2.498 2.498 0 0 1 4.224 0Z",
        clipRule: "evenodd"
      }
    )
  }
), eee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.242 3.03a1 1 0 0 1 .728 1.213L11.03 8h3.94l1.06-4.243a1 1 0 1 1 1.94.486L17.03 8H20a1 1 0 1 1 0 2h-3.47l-1 4H18a1 1 0 1 1 0 2h-2.97l-1.06 4.242a1 1 0 1 1-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 1 1-1.94-.485L6.97 16H4a1 1 0 1 1 0-2h3.47l1-4H6a1 1 0 0 1 0-2h2.97l1.06-4.243a1 1 0 0 1 1.213-.727ZM10.531 10l-1 4h3.938l1-4h-3.938Z",
        clipRule: "evenodd"
      }
    )
  }
), tee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m14.025 7.025-1.318 1.318a1 1 0 0 1-1.414 0L9.975 7.025a3.5 3.5 0 1 0-4.95 4.95L12 18.95l6.975-6.975.707.707-.707-.707a3.5 3.5 0 0 0-4.95-4.95Zm-1.414-1.414a5.5 5.5 0 0 1 7.778 7.778l-7.682 7.682a1 1 0 0 1-1.414 0L3.61 13.39a5.5 5.5 0 0 1 7.778-7.778l.611.61.61-.61Z",
        clipRule: "evenodd"
      }
    )
  }
), nee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l9 9a1 1 0 0 1-1.414 1.414L20 12.414V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.586l-.293.293a1 1 0 0 1-1.414-1.414l9-9ZM6 10.414V20h3v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h3v-9.586l-6-6-6 6ZM13 20v-4h-2v4h2Z",
        clipRule: "evenodd"
      }
    )
  }
), ree = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm10 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm-5 3a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-7 5a7 7 0 1 1 14 0v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 5a3 3 0 1 1 6 0h4a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4Zm.17 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4.17a3.001 3.001 0 0 1-5.66 0ZM12 4a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1Zm-3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.4 2.8a3 3 0 1 0-4.8 0 4.01 4.01 0 0 0-1.372 1.867 1 1 0 1 0 1.885.666 2.001 2.001 0 0 1 3.773 0 1 1 0 1 0 1.886-.666A4.01 4.01 0 0 0 11.4 13.8ZM14 11a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), iee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v6h1.586A2 2 0 0 1 8 12.586L10.414 15h3.172L16 12.586A2 2 0 0 1 17.414 12H19V6a1 1 0 0 0-1-1H6Zm13 9h-1.586L15 16.414a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 9 16.414L6.586 14H5v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), lee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v5.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L11 8.586V3a1 1 0 0 1 1-1ZM6 5a1 1 0 0 0-1 1v6h1.586A2 2 0 0 1 8 12.586L10.414 15h3.172L16 12.586A2 2 0 0 1 17.414 12H19V6a1 1 0 0 0-1-1h-2a1 1 0 1 1 0-2h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2H6Zm-1 9v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4h-1.586L15 16.414a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 9 16.414L6.586 14H5Z",
        clipRule: "evenodd"
      }
    )
  }
), oee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9-4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm-1 4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 4a5 5 0 0 0-4.786 6.453 1 1 0 0 1-.25.997L4 17.414V20h2v-1a1 1 0 0 1 1-1h1v-1a1 1 0 0 1 1-1h1.586l1.964-1.964a1 1 0 0 1 .997-.25A5 5 0 1 0 15 4ZM8 20v1a1 1 0 0 1-1 1H4a2 2 0 0 1-2-2v-2.586A2 2 0 0 1 2.586 16l5.562-5.562a7 7 0 1 1 5.414 5.414l-1.855 1.855A1 1 0 0 1 11 18h-1v1a1 1 0 0 1-1 1H8Zm6-13a1 1 0 0 1 1-1 3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), see = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.594 2.086a1 1 0 0 1 .812 0l9 4a1 1 0 0 1-.812 1.828L12 4.094l-8.594 3.82a1 1 0 1 1-.812-1.828l9-4ZM2 10a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v9a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2v-9a1 1 0 0 1-1-1Zm3 1v9h14v-9H5Zm3 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.929 4.929a1 1 0 0 1 1.414 0l.707.707A1 1 0 1 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414Zm14.142 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0Zm-9.9 4.243a4 4 0 0 0 0 5.656l.548.548c.193.193.366.402.518.624h3.526a4.38 4.38 0 0 1 .518-.624l.547-.547a4 4 0 0 0-5.656-5.657Zm6.074 8.247c.114-.231.265-.444.45-.63l.548-.546a6 6 0 1 0-8.486 0l.547.547A2.374 2.374 0 0 1 9 18.469V19a3 3 0 1 0 6 0v-.531a2.374 2.374 0 0 1 .245-1.05Zm-2.22.581h-2.05c.017.155.025.312.025.469V19a1 1 0 1 0 2 0v-.531c0-.157.008-.314.025-.469ZM2 12a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm17 0a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.336 2.058A1 1 0 0 1 14 3v6h6a1 1 0 0 1 .774 1.633l-9 11A1 1 0 0 1 10 21v-6H4a1 1 0 0 1-.774-1.633l9-11a1 1 0 0 1 1.11-.309ZM6.11 13H11a1 1 0 0 1 1 1v4.199L17.89 11H13a1 1 0 0 1-1-1V5.801L6.11 13Z",
        clipRule: "evenodd"
      }
    )
  }
), dee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.121 4.879a3 3 0 0 0-4.242 0l-1.1 1.1a1 1 0 1 1-1.414-1.415l1.1-1.1a5 5 0 1 1 7.07 7.072l-4 4a5 5 0 0 1-7.07 0 1 1 0 1 1 1.414-1.415 3 3 0 0 0 4.242 0l4-4a3 3 0 0 0 0-4.242Zm-6 6a3 3 0 0 0-4.242 0l-4 4A3 3 0 1 0 9.12 19.12l1.102-1.101a1 1 0 1 1 1.414 1.414l-1.101 1.101a5 5 0 1 1-7.072-7.07l4-4a5 5 0 0 1 7.072 0 1 1 0 1 1-1.415 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), hee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.95 6.05a7 7 0 1 0-9.9 9.9l4.244 4.243a.998.998 0 0 0 1.413 0l4.243-4.243a7 7 0 0 0 0-9.9ZM5.636 4.636a9 9 0 0 1 12.728 12.728l-3.502 3.502-.018.018-.723.723a2.998 2.998 0 0 1-4.241 0l-4.244-4.243a9 9 0 0 1 0-12.728ZM12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), vee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0v3h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm2 3h6V7a3 3 0 1 0-6 0v3Zm-3 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6Zm6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), pee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0v3h9a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm-1 5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6Zm6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), mee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4v1a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2H6Zm5.707 2.293a1 1 0 0 1 0 1.414L9.414 11H21a1 1 0 1 1 0 2H9.414l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm2 2.869V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.869l-6.336 4.223a3 3 0 0 1-3.328 0L4 9.87Zm16-2.404-7.445 4.963a1 1 0 0 1-1.11 0L4 7.465V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.465Z",
        clipRule: "evenodd"
      }
    )
  }
), wee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.555 4.572a1 1 0 0 0-1.11 0l-7 4.666a1 1 0 0 0-.304.32l7.304 4.87a1 1 0 0 0 1.11 0l7.304-4.87a1 1 0 0 0-.304-.32l-7-4.666Zm9.44 5.328a3 3 0 0 0-1.33-2.326l-7-4.666a3 3 0 0 0-3.33 0l-7 4.666A3 3 0 0 0 2 10.07V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8.93a3.028 3.028 0 0 0-.005-.17ZM20 11.868 16.053 14.5 20 17.131v-5.263Zm-.112 7.592-5.638-3.758-.586.39a3 3 0 0 1-3.328 0l-.586-.39-5.638 3.758A1 1 0 0 0 5 20h14a1 1 0 0 0 .888-.54ZM4 17.131 7.947 14.5 4 11.868v5.263Z",
        clipRule: "evenodd"
      }
    )
  }
), yee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.553 3.106a1 1 0 0 1 .894 0l5.447 2.723A2 2 0 0 1 22 7.618v10.764a2 2 0 0 1-2.894 1.789L15 18.118l-5.553 2.776a1 1 0 0 1-.894 0l-5.447-2.723A2 2 0 0 1 2 16.382V5.618a2 2 0 0 1 2.894-1.789L9 5.882l5.553-2.776ZM8 7.618l-4-2v10.764l4 2V7.618Zm2 10.764 4-2V5.618l-4 2v10.764Zm6-12.764v10.764l4 2V7.618l-4-2Z",
        clipRule: "evenodd"
      }
    )
  }
), xee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), See = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Cee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm9 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _ee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Ree = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 5a4 4 0 1 1 8 0v6a4 4 0 0 1-8 0V5Zm4-2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2Zm-7 7a1 1 0 0 1 1 1 6 6 0 0 0 12 0 1 1 0 1 1 2 0 8.001 8.001 0 0 1-7 7.938V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2.062A8.001 8.001 0 0 1 4 11a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Eee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Mee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Tee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Oee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.353 2.939a1 1 0 0 1 .22 1.08 8 8 0 0 0 10.408 10.408 1 1 0 0 1 1.301 1.3A10.003 10.003 0 0 1 12 22C6.477 22 2 17.523 2 12c0-4.207 2.598-7.805 6.273-9.282a1 1 0 0 1 1.08.22ZM7.086 5.687a8 8 0 1 0 11.228 11.228c-.43.056-.87.085-1.314.085-5.523 0-10-4.477-10-10 0-.445.03-.883.086-1.313Z",
        clipRule: "evenodd"
      }
    )
  }
), Dee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.615 2.212A1 1 0 0 1 22 3v13c0 .99-.602 1.765-1.324 2.246-.729.486-1.678.754-2.676.754-.998 0-1.947-.268-2.676-.754C14.602 17.766 14 16.991 14 16c0-.99.602-1.765 1.324-2.246C16.053 13.268 17.002 13 18 13c.712 0 1.4.136 2 .391v-5.11l-10 2.5V19c0 .99-.602 1.765-1.324 2.246C7.947 21.732 6.998 22 6 22c-.998 0-1.947-.268-2.676-.754C2.602 20.766 2 19.991 2 19c0-.99.602-1.765 1.324-2.246C4.053 16.268 5.002 16 6 16c.713 0 1.4.137 2 .391V6a1 1 0 0 1 .757-.97l12-3a1 1 0 0 1 .858.182ZM10 8.719l10-2.5V4.281l-10 2.5v1.938ZM8 19c0-.114-.07-.34-.433-.582C7.21 18.18 6.659 18 6 18c-.659 0-1.21.18-1.567.418C4.07 18.66 4 18.886 4 19c0 .114.07.34.433.582C4.79 19.82 5.341 20 6 20c.659 0 1.21-.18 1.567-.418C7.93 19.34 8 19.114 8 19Zm12-3c0-.114-.07-.34-.433-.582C19.209 15.18 18.658 15 18 15c-.659 0-1.21.18-1.567.418-.364.243-.433.468-.433.582 0 .114.07.34.433.582.358.238.909.418 1.567.418.659 0 1.21-.18 1.567-.418.364-.243.433-.468.433-.582Z",
        clipRule: "evenodd"
      }
    )
  }
), jee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3h1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm14.17 13H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12c0 .35.06.687.17 1ZM18 8v10a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1h-1ZM6 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8Zm2 1v2h4V9H8Zm-2 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Aee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v15h1a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2h1V5Zm2 15h3v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h3V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v15Zm7 0v-4h-2v4h2ZM8 7a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-5 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 .894.553l9 18a1 1 0 0 1-1.11 1.423L12 20.024l-8.783 1.952a1 1 0 0 1-1.111-1.423l9-18A1 1 0 0 1 12 2Zm1 16.198 6.166 1.37L12 5.236 4.834 19.568 11 18.198V11a1 1 0 1 1 2 0v7.198Z",
        clipRule: "evenodd"
      }
    )
  }
), Lee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.883 4.874-6.418 6.59a5 5 0 1 0 7.07 7.071h.001l6.258-6.243a1 1 0 1 1 1.412 1.416L14.95 19.95a7 7 0 0 1-9.905-9.895l6.42-6.59a5 5 0 0 1 7.075 7.066l-6.419 6.59A3 3 0 0 1 7.88 12.88l6.585-6.586a1 1 0 1 1 1.415 1.414l-6.586 6.586a1 1 0 0 0 1.41 1.418l6.418-6.59a3 3 0 0 0-4.238-4.247Z",
        clipRule: "evenodd"
      }
    )
  }
), Iee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm8-4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Hee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.56 4.44a1.5 1.5 0 0 0-2.12 0l-.794.792 2.122 2.122.793-.793a1.5 1.5 0 0 0 0-2.122Zm1.415 3.535a3.5 3.5 0 0 0-4.95-4.95l-1.5 1.5L2.293 16.757a1 1 0 0 0-.293.707v3.572a1 1 0 0 0 1 1h3.5a1 1 0 0 0 .707-.293L20.975 7.975Zm-3.621.793-2.122-2.122L4 17.88v2.156h2.086L17.354 8.768Z",
        clipRule: "evenodd"
      }
    )
  }
), Zee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 4.293a1 1 0 0 0-1.414 0L10 12.586V14h1.414l8.293-8.293a1 1 0 0 0 0-1.414ZM16.88 2.879a3 3 0 1 1 4.24 4.241l-8.585 8.586a1 1 0 0 1-.708.293H9a1 1 0 0 1-1-1v-2.828a1 1 0 0 1 .293-.708l8.586-8.585ZM6 6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-5a1 1 0 1 1 2 0v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h5a1 1 0 1 1 0 2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), Pee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Z",
        clipRule: "evenodd"
      }
    )
  }
), Nee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm15.293-1.707a1 1 0 1 1 1.414 1.414L17.414 8H20a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v2.586l4.293-4.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Vee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm10.293-.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Bee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm11 0a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L18.586 4H16Z",
        clipRule: "evenodd"
      }
    )
  }
), Fee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm2 10.414V18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.586l-1.293-1.293a1 1 0 0 0-1.414 0l-.879.879 1.293 1.293a1 1 0 0 1-1.414 1.414l-2-2-2.586-2.586a1 1 0 0 0-1.414 0L5 16.414Zm9-3.828-1.879-1.879a3 3 0 0 0-4.242 0L5 13.586V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5.592a3 3 0 0 0-4.121.115l-.879.879ZM13 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Uee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7-2.131c0-1.598 1.78-2.55 3.11-1.665l3.197 2.132a2 2 0 0 1 0 3.328l-3.198 2.132C10.78 16.682 9 15.729 9 14.132V9.869ZM14.197 12 11 9.869v4.263L14.197 12Z",
        clipRule: "evenodd"
      }
    )
  }
), Yee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 0 1 1 1v7h7a1 1 0 1 1 0 2h-7v7a1 1 0 1 1-2 0v-7H4a1 1 0 1 1 0-2h7V4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), $ee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Wee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v11a2 2 0 0 1-2 2h-4.586l2.293 2.293a1 1 0 0 1-1.414 1.414L12 18.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L9.586 18H5a2 2 0 0 1-2-2V5a1 1 0 0 1-1-1Zm3 1v11h14V5H5Zm11 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), qee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v11a2 2 0 0 1-2 2h-4.586l2.293 2.293a1 1 0 0 1-1.414 1.414L12 18.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L9.586 18H5a2 2 0 0 1-2-2V5a1 1 0 0 1-1-1Zm3 1v11h14V5H5Zm12.707 2.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0L10 10.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0L13 10.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Gee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3h1a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1V5Zm2 3h8V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3Zm-3 2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v-1a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5Zm11 5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Kee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a3 3 0 1 1 6 0v1h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1a1 1 0 1 0 0 2h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-1a1 1 0 1 0-2 0v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H4a3 3 0 1 1 0-6h1V7a2 2 0 0 1 2-2h3V4Zm3-1a1 1 0 0 0-1 1v1a2 2 0 0 1-2 2H7v3a2 2 0 0 1-2 2H4a1 1 0 1 0 0 2h1a2 2 0 0 1 2 2v3h3v-1a3 3 0 1 1 6 0v1h3v-3h-1a3 3 0 1 1 0-6h1V7h-3a2 2 0 0 1-2-2V4a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Qee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm4 0H5v2h2V5Zm5-2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm3 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm4 0h-2v2h2V5Zm-7 3a1 1 0 0 1 1 1v2h3.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Zm-9 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm16 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H20a1 1 0 0 1-1-1ZM3 17a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2Zm4 0H5v2h2v-2Zm4-1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-1v3a1 1 0 1 1-2 0v-4Zm6 0a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm-2 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Xee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4c-1.472 0-2.528.706-2.868 1.426a1 1 0 0 1-1.809-.852C8.082 6.964 9.99 6 12 6c1.3 0 2.515.394 3.428 1.079C16.343 7.764 17 8.786 17 10c0 2.07-1.834 3.508-3.817 3.889a.31.31 0 0 0-.162.083A.107.107 0 0 0 13 14a1 1 0 0 1-2 0c0-1.142.909-1.904 1.805-2.075C14.279 11.642 15 10.729 15 10c0-.443-.237-.92-.771-1.321C13.694 8.278 12.909 8 12 8Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Jee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L16 20.118l-3.553 1.776a1 1 0 0 1-.894 0L8 20.118l-3.553 1.776A1 1 0 0 1 3 21V5Zm3-1a1 1 0 0 0-1 1v14.382l2.553-1.276a1 1 0 0 1 .894 0L12 19.882l3.553-1.776a1 1 0 0 1 .894 0L19 19.382V5a1 1 0 0 0-1-1H6Zm5.707 2.293a1 1 0 0 1 0 1.414L10.414 9H12a5 5 0 0 1 5 5v1a1 1 0 1 1-2 0v-1a3 3 0 0 0-3-3h-1.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ete = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.496.868L15.5 20.152l-3.004 1.716a1 1 0 0 1-.992 0L8.5 20.152l-3.004 1.716A1 1 0 0 1 4 21V5Zm3-1a1 1 0 0 0-1 1v14.277l2.004-1.145a1 1 0 0 1 .992 0L12 19.848l3.004-1.716a1 1 0 0 1 .992 0L18 19.277V5a1 1 0 0 0-1-1H7Zm1 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6.293-1.207a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6ZM13 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        clipRule: "evenodd"
      }
    )
  }
), tte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a1 1 0 0 1 1 1v2.343A8.982 8.982 0 0 1 12 3a9.001 9.001 0 0 1 8.93 7.876 1 1 0 1 1-1.984.248A7.001 7.001 0 0 0 6.254 8H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm-.062 9.008a1 1 0 0 1 1.116.868A7.001 7.001 0 0 0 17.746 16H15a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.343A8.982 8.982 0 0 1 12 21a9.001 9.001 0 0 1-8.93-7.876 1 1 0 0 1 .868-1.116Z",
        clipRule: "evenodd"
      }
    )
  }
), nte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 3.293a1 1 0 0 1 0 1.414L5.414 9H13a9 9 0 0 1 9 9v2a1 1 0 1 1-2 0v-2a7 7 0 0 0-7-7H5.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.8 6.4C10.118 5.411 12 6.352 12 8v2l4.8-3.6C18.119 5.411 20 6.352 20 8v8c0 1.648-1.881 2.589-3.2 1.6L12 14v2c0 1.648-1.882 2.589-3.2 1.6l-5.333-4a2 2 0 0 1 0-3.2l5.333-4ZM10 8l-5.333 4L10 16V8Zm8 0-5.333 4L18 16V8Z",
        clipRule: "evenodd"
      }
    )
  }
), ate = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a1 1 0 0 1 1-1c7.732 0 14 6.268 14 14a1 1 0 1 1-2 0c0-6.627-5.373-12-12-12a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1 8 8 0 0 1 8 8 1 1 0 1 1-2 0 6 6 0 0 0-6-6 1 1 0 0 1-1-1Zm-1 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ite = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
        d: "M4 12c11 0 5 6 16 6M4 18C15 18 9 6 20 6M4 6c11 0 5 6 16 6"
      }
    )
  }
), lte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 0 1 1 1v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 11.586V4a1 1 0 0 1 1-1ZM2 9a3 3 0 0 1 3-3h3a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3a1 1 0 1 1 0-2h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9Z",
        clipRule: "evenodd"
      }
    )
  }
), ote = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2a1 1 0 0 1 1 1v6.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L13 9.586V3a1 1 0 0 1 1-1ZM6 7a3 3 0 0 1 3-3h1a1 1 0 1 1 0 2H9a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1a1 1 0 1 1 0-2h1a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1V7Zm0 3H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9a3 3 0 0 1-3-3v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), ute = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1.28l5 1.666 2.684-.895a1 1 0 0 1 .632 1.898l-2.051.683 2.668 8.003a1 1 0 0 1-.33 1.164 6.002 6.002 0 0 1-7.204 0 1 1 0 0 1-.348-1.115l2.684-8.052L13 6.387V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V6.387L7.265 7.632l2.668 8.003a1 1 0 0 1-.33 1.164 6.002 6.002 0 0 1-7.204 0 1 1 0 0 1-.348-1.115l2.684-8.052-2.051-.683a1 1 0 0 1 .632-1.898L6 5.946l5-1.667V3a1 1 0 0 1 1-1Zm-6 8.162-1.803 5.41a4.01 4.01 0 0 0 3.606 0L6 10.162Zm12 0-1.803 5.41a4.01 4.01 0 0 0 3.606 0L18 10.162Z",
        clipRule: "evenodd"
      }
    )
  }
), ste = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM3 7a4 4 0 1 1 7.446 2.032L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-9.261 9.261a4 4 0 1 1-1.414-1.414L10.586 12l-1.554-1.554A4 4 0 0 1 3 7Zm4 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6.414-1.586a1 1 0 0 1 1.414 0l4.88 4.879a1 1 0 0 1-1.415 1.414l-4.879-4.879a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), cte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Z",
        clipRule: "evenodd"
      }
    )
  }
), fte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 1.968 3.446l-2.26 2.261a1 1 0 0 1-1.415-1.414l2.261-2.261A3.984 3.984 0 0 1 9 11Z",
        clipRule: "evenodd"
      }
    )
  }
), dte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a1 1 0 0 1 .707.293l4 4a1 1 0 0 1-1.414 1.414L12 6.414 8.707 9.707a1 1 0 0 1-1.414-1.414l4-4A1 1 0 0 1 12 4ZM7.293 14.293a1 1 0 0 1 1.414 0L12 17.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), hte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v4c0 .768-.289 1.47-.764 2 .475.53.764 1.232.764 2v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4c0-.768.289-1.47.764-2A2.989 2.989 0 0 1 2 10V6Zm3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5Zm14-2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14Zm-3-3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), vte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 .983 2.626l-5.071 2.536a4.012 4.012 0 0 1 0 1.676l5.071 2.536a4 4 0 1 1-.895 1.788l-5.071-2.536a4 4 0 1 1 0-5.253l5.071-2.535A4.015 4.015 0 0 1 14 6Zm-8 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 6a2 2 0 1 0-.001 4A2 2 0 0 0 18 16Z",
        clipRule: "evenodd"
      }
    )
  }
), pte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333 2.2a1 1 0 0 1 1.334 0 10.955 10.955 0 0 0 7.9 2.786 1 1 0 0 1 1.019.748C21.856 6.778 22 7.874 22 9c0 6.059-4.144 11.147-9.75 12.59a1 1 0 0 1-.5 0C6.145 20.147 2 15.06 2 9c0-1.127.144-2.222.414-3.266a1 1 0 0 1 1.019-.748 10.955 10.955 0 0 0 7.9-2.786ZM4.181 6.998A11.092 11.092 0 0 0 4 9c0 5.034 3.382 9.28 8 10.586 4.618-1.305 8-5.552 8-10.586 0-.684-.062-1.353-.181-2.001a12.946 12.946 0 0 1-7.82-2.751 12.946 12.946 0 0 1-7.818 2.75Zm11.526 2.294a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), mte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333 2.2a1 1 0 0 1 1.334 0 10.955 10.955 0 0 0 7.9 2.786 1 1 0 0 1 1.019.748C21.856 6.778 22 7.874 22 9c0 6.059-4.144 11.147-9.75 12.59a1 1 0 0 1-.5 0C6.145 20.147 2 15.06 2 9c0-1.127.144-2.222.414-3.266a1 1 0 0 1 1.019-.748 10.955 10.955 0 0 0 7.9-2.786ZM4.181 6.998A11.092 11.092 0 0 0 4 9c0 5.034 3.382 9.28 8 10.586 4.618-1.305 8-5.552 8-10.586 0-.684-.062-1.353-.181-2.001a12.946 12.946 0 0 1-7.82-2.751 12.946 12.946 0 0 1-7.818 2.75ZM12 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-1 7a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), gte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0v1h2a1 1 0 0 1 .997.917l1 12A1 1 0 0 1 20 22H4a1 1 0 0 1-.997-1.083l1-12A1 1 0 0 1 5 8h2V7Zm0 3v1a1 1 0 1 0 2 0v-1h6v1a1 1 0 1 0 2 0v-1h1.08l.833 10H5.087l.833-10H7Zm8-2H9V7a3 3 0 1 1 6 0v1Z",
        clipRule: "evenodd"
      }
    )
  }
), wte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3a1 1 0 0 1 1-1h2a1 1 0 0 1 .98.804L6.22 4H21a1 1 0 0 1 .894 1.447l-4 8A1 1 0 0 1 17 14H7.414l-2 2H17a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.521-.326c-.98-.65-1.268-2.129-.309-3.088l1.914-1.915L4.18 4H3a1 1 0 0 1-1-1Zm5.82 9h8.562l3-6H6.62l1.2 6ZM7 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), yte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM19 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), xte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM3 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm11-2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Ste = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm14 2.414-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L18 10.414V20a1 1 0 1 1-2 0v-9.586ZM2 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Cte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm15-1a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 17.586V8a1 1 0 0 1 1-1ZM2 12a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 .949.684l2.135 6.404 5.267 1.976a1 1 0 0 1 0 1.872l-5.267 1.976-2.135 6.404a1 1 0 0 1-1.898 0l-2.135-6.404-5.267-1.976a1 1 0 0 1 0-1.872l5.267-1.976 2.135-6.404A1 1 0 0 1 13 2Zm0 4.162-1.337 4.011a1 1 0 0 1-.598.62L7.848 12l3.217 1.207a1 1 0 0 1 .598.62L13 17.837l1.337-4.01a1 1 0 0 1 .598-.62L18.152 12l-3.217-1.207a1 1 0 0 1-.598-.62L13 6.163ZM6 16a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _te = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.351 2.064A1 1 0 0 1 19 3v3.126a4.002 4.002 0 0 1 0 7.748V17a1 1 0 0 1-1.753.658c-.613-.702-1.699-1.375-3.188-1.872A14.547 14.547 0 0 0 12 15.271v3.97a2.76 2.76 0 0 1-5.359.927l-.002-.006-2.01-5.76A5 5 0 0 1 7 5h1.832a18.768 18.768 0 0 0 2.07-.112 15.426 15.426 0 0 0 3.157-.673c1.49-.497 2.575-1.17 3.188-1.872a1 1 0 0 1 1.104-.278ZM10 6.968A21.14 21.14 0 0 1 8.832 7H7a3 3 0 0 0 0 6h1.832c.394 0 .784.01 1.168.032V6.968Zm2 6.275V6.757a16.89 16.89 0 0 0 2.692-.646c.84-.28 1.62-.626 2.308-1.035v9.848a11.903 11.903 0 0 0-2.308-1.035A16.807 16.807 0 0 0 12 13.243Zm7-1.51a2 2 0 0 0 0-3.465v3.464Zm-9 3.303A19.108 19.108 0 0 0 8.832 15H6.955l1.57 4.496v.002A.76.76 0 0 0 10 19.24v-4.204Z",
        clipRule: "evenodd"
      }
    )
  }
), Rte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a3 3 0 0 0-3 3v1.17c-.313-.11-.65-.17-1-.17h-2a3 3 0 0 0-3 3v1.17c-.313-.11-.65-.17-1-.17H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764h2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764h2a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-2Zm-7 17v-5h4v5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1Zm4-7h-4V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3Zm-7 0a1 1 0 0 1 1 1v2H4v-2a1 1 0 0 1 1-1h2Zm-3 7v-2h4v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm12 0a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h-4v9Zm0-11V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Ete = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.098 2.618c.599-1.843 3.205-1.843 3.804 0l1.519 4.673h4.914c1.938 0 2.743 2.48 1.176 3.619l-3.976 2.889 1.519 4.674c.598 1.842-1.51 3.374-3.078 2.236L12 17.82l-3.976 2.889c-1.567 1.138-3.676-.394-3.078-2.236l1.519-4.674-3.976-2.89C.922 9.772 1.727 7.293 3.665 7.293h4.914l1.519-4.674ZM12 3.236 10.481 7.91A2 2 0 0 1 8.58 9.29H3.665l3.975 2.89a2 2 0 0 1 .727 2.235L6.848 19.09l3.977-2.888a2 2 0 0 1 2.35 0l3.976 2.888-1.518-4.674a2 2 0 0 1 .727-2.236l3.975-2.888h-4.914a2 2 0 0 1-1.902-1.382L12 3.236Z",
        clipRule: "evenodd"
      }
    )
  }
), Mte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l7.775 7.775a2.002 2.002 0 0 1 2.45 2.45l1.514 1.514a4.001 4.001 0 0 0-.618-4.86 1 1 0 0 1 1.415-1.415 6.002 6.002 0 0 1 .648 7.72l1.43 1.429a8.001 8.001 0 0 0-.664-10.563A1 1 0 1 1 19.07 4.93c3.667 3.667 3.89 9.472.672 13.4l1.964 1.964a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm1.495 5.885a1 1 0 0 1 .629 1.267 8 8 0 0 0 1.926 8.212A1 1 0 1 1 4.93 19.07 10 10 0 0 1 2.52 8.807a1 1 0 0 1 1.267-.629Zm3.121 3.539a1 1 0 0 1 1.131.85 3.978 3.978 0 0 0 1.132 2.261 1 1 0 0 1-1.415 1.415 5.978 5.978 0 0 1-1.697-3.396 1 1 0 0 1 .85-1.13Z",
        clipRule: "evenodd"
      }
    )
  }
), Tte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.343 4.929a1 1 0 0 1 0 1.414 8 8 0 0 0 0 11.314A1 1 0 1 1 4.93 19.07c-3.905-3.905-3.905-10.237 0-14.142a1 1 0 0 1 1.414 0Zm11.314 0a1 1 0 0 1 1.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414ZM9.172 7.757a1 1 0 0 1 0 1.415 4 4 0 0 0 0 5.656 1 1 0 1 1-1.415 1.415 6 6 0 0 1 0-8.486 1 1 0 0 1 1.415 0Zm5.656 0a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.415 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.415ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Ote = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4Zm6 0h-4v4h4v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Dte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.929 4.929a1 1 0 0 1 1.414 0l.707.707A1 1 0 1 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414Zm14.142 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm-5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm17 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-2.05 4.95a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1-1.414 1.414l-.707-.707a1 1 0 0 1 0-1.414Zm-11.314 0a1 1 0 0 1 1.414 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707ZM12 19a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), jte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.01 4.061a8.001 8.001 0 0 0-6.79 9.813l2.992-1.141a4.874 4.874 0 0 1 3.803-5.463l-.004-3.209Zm-3.112 10.55-2.97 1.133A7.999 7.999 0 0 0 12 20a7.999 7.999 0 0 0 7.067-4.248l-2.907-1.123a4.869 4.869 0 0 1-4.125 2.28 4.87 4.87 0 0 1-4.137-2.297ZM20 12.002c0 .647-.077 1.278-.222 1.881l-2.922-1.128a4.874 4.874 0 0 0-3.84-5.491l-.004-3.2A8.001 8.001 0 0 1 19.999 12ZM2 12C2 6.476 6.477 2 12 2c5.522 0 10 4.476 10 10 0 5.522-4.479 10-10 10-5.523 0-10-4.477-10-10Zm10.035-2.837a2.872 2.872 0 1 0 0 5.744 2.872 2.872 0 0 0 0-5.744Z",
        clipRule: "evenodd"
      }
    )
  }
), Ate = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.68 7.094A7.965 7.965 0 0 0 4 12c0 1.849.627 3.551 1.68 4.906l2.148-2.149A4.977 4.977 0 0 1 7 12c0-1.02.305-1.967.828-2.757L5.68 7.094ZM7.094 5.68l2.149 2.148A4.977 4.977 0 0 1 12 7c1.02 0 1.967.305 2.757.828l2.149-2.148A7.965 7.965 0 0 0 12 4a7.965 7.965 0 0 0-4.906 1.68ZM18.32 7.094l-2.148 2.149c.523.79.828 1.738.828 2.757 0 1.02-.305 1.967-.828 2.757l2.148 2.149A7.965 7.965 0 0 0 20 12a7.966 7.966 0 0 0-1.68-4.906ZM16.906 18.32l-2.149-2.148A4.977 4.977 0 0 1 12 17a4.977 4.977 0 0 1-2.757-.828L7.094 18.32A7.966 7.966 0 0 0 12 20a7.965 7.965 0 0 0 4.906-1.68ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), kte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.707 6.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L17.586 8H8a1 1 0 1 1 0-2h9.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4ZM6.414 16H16a1 1 0 1 1 0 2H6.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L6.414 16Z",
        clipRule: "evenodd"
      }
    )
  }
), Lte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.293 3.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L8 6.414V16a1 1 0 1 1-2 0V6.414L3.707 8.707a1 1 0 0 1-1.414-1.414l4-4ZM16 17.586V8a1 1 0 1 1 2 0v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 17.586Z",
        clipRule: "evenodd"
      }
    )
  }
), Ite = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8Zm3-1a1 1 0 0 0-1 1v1h16V8a1 1 0 0 0-1-1H5Zm15 4h-7v2h7v-2Zm0 4h-7v2h6a1 1 0 0 0 1-1v-1Zm-9 2v-2H4v1a1 1 0 0 0 1 1h6Zm-7-4h7v-2H4v2Z",
        clipRule: "evenodd"
      }
    )
  }
), Hte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a3 3 0 0 0-3 3v5c0 .299.13.566.339.75l.023.02 6.996 6.997A.992.992 0 0 0 12 20a.992.992 0 0 0 .642-.233l6.974-6.974a.96.96 0 0 1 .045-.043.996.996 0 0 0 .106-1.392l-6.974-6.974a.965.965 0 0 1-.043-.045A.995.995 0 0 0 12 4H7ZM2 7a5 5 0 0 1 5-5h5c.884 0 1.68.383 2.227.99l6.98 6.98.043.045c.466.529.75 1.225.75 1.985 0 .884-.383 1.68-.99 2.227l-6.98 6.98A2.992 2.992 0 0 1 12 22a2.992 2.992 0 0 1-2.03-.793l-6.98-6.98A2.995 2.995 0 0 1 2 12V7Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Zte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm16 0H5v2h14V5ZM3 13a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6Zm8 0H5v6h6v-6Zm4 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-6Zm4 0h-2v6h2v-6Z",
        clipRule: "evenodd"
      }
    )
  }
), Pte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm2.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L9.586 12 7.293 9.707a1 1 0 0 1 0-1.414ZM12 15a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Nte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.736 4a1 1 0 0 0-.894.553l-3.5 7A1 1 0 0 0 5.236 13H12a1 1 0 1 1 0 2h-1v4a1 1 0 0 0 1 1 4.62 4.62 0 0 1 .776-2.466L16 12.697V4.781l-3.004-.751a1 1 0 0 0-.242-.03H8.736ZM18 5v8h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1Zm-1.131 10-2.43 3.643c-.286.43-.439.936-.439 1.453A1.905 1.905 0 0 1 12.095 22H12a3 3 0 0 1-3-3v-4H5.236c-2.23 0-3.68-2.347-2.683-4.342l3.5-7A3 3 0 0 1 8.736 2h4.018a3 3 0 0 1 .727.09l3.642.91H19a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2.131Z",
        clipRule: "evenodd"
      }
    )
  }
), Vte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3.905C10 2.853 10.853 2 11.905 2H12a3 3 0 0 1 3 3v4h3.764c2.23 0 3.68 2.347 2.683 4.342l-3.5 7A3 3 0 0 1 15.264 22h-4.018a3 3 0 0 1-.727-.09L6.877 21H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2.131l2.43-3.643c.286-.43.439-.936.439-1.452ZM6 11H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1v-8Zm2 8.22v-7.917l3.224-4.837A4.617 4.617 0 0 0 12 4a1 1 0 0 1 1 1v4h-1a1 1 0 1 0 0 2h6.764a1 1 0 0 1 .894 1.447l-3.5 7a1 1 0 0 1-.894.553h-4.018a.996.996 0 0 1-.242-.03L8 19.22Z",
        clipRule: "evenodd"
      }
    )
  }
), Bte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1 1 1 0 1 0 0 2 1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3a1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1V7Zm14 11v-1a1 1 0 1 0-2 0v1H5a1 1 0 0 1-1-1v-2.17a3.001 3.001 0 0 0 0-5.66V7a1 1 0 0 1 1-1h9v1a1 1 0 1 0 2 0V6h3a1 1 0 0 1 1 1v2.17a3.001 3.001 0 0 0 0 5.66V17a1 1 0 0 1-1 1h-3Zm-1-8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Fte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 1 1 1v1h5a1 1 0 1 1 0 2h-1.422a18.914 18.914 0 0 1-3.292 7.286c.157.176.318.35.482.52a1 1 0 0 1-1.44 1.389 19.02 19.02 0 0 1-.328-.35 19.06 19.06 0 0 1-5.555 4.18 1 1 0 1 1-.89-1.792 17.062 17.062 0 0 0 5.159-3.947A18.978 18.978 0 0 1 5.49 9.389a1 1 0 1 1 1.842-.778A16.963 16.963 0 0 0 9 11.646 16.915 16.915 0 0 0 11.527 6H3a1 1 0 1 1 0-2h5V3a1 1 0 0 1 1-1Zm7 8a1 1 0 0 1 .894.553l3.491 6.982.02.037 1.49 2.98a1 1 0 1 1-1.79.895L18.883 19h-5.764l-1.224 2.447a1 1 0 1 1-1.788-.894l1.49-2.98.019-.038 3.49-6.982A1 1 0 0 1 16 10Zm-1.882 7h3.764L16 13.236 14.118 17Z",
        clipRule: "evenodd"
      }
    )
  }
), Ute = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-.069l-.8 11.214A3 3 0 0 1 16.137 22H7.862a3 3 0 0 1-2.992-2.786L4.069 8H4a1 1 0 0 1 0-2h4V4ZM6.074 8l.79 11.071a1 1 0 0 0 .998.929h8.276a1 1 0 0 0 .997-.929L17.926 8H6.074ZM14 6h-4V4h4v2Zm-4 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Yte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 6.293a1 1 0 0 1 1.414 0L9 11.586l3.293-3.293a1 1 0 0 1 1.414 0L20 14.586V9a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1h-8a1 1 0 1 1 0-2h5.586L13 10.414l-3.293 3.293a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), $te = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V9.414l-6.293 6.293a1 1 0 0 1-1.414 0L9 12.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0L13 13.586 18.586 8H13Z",
        clipRule: "evenodd"
      }
    )
  }
), Wte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2h2.586A2 2 0 0 1 18 6.586l-.707.707.707-.707L21.414 10A2 2 0 0 1 22 11.414V16a2 2 0 0 1-2 2h-.17a3.001 3.001 0 0 1-5.66 0H14a1.99 1.99 0 0 1-1-.268A1.99 1.99 0 0 1 12 18H9.83a3.001 3.001 0 0 1-5.66 0H4a2 2 0 0 1-2-2V6Zm2.17 10a3.001 3.001 0 0 1 5.66 0H12V7.997 8m0-.003V6H4v10h.17M14 16h.17a3.001 3.001 0 0 1 5.66 0H20v-4.586L16.586 8H14v8Zm-7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), zte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-1a1 1 0 1 1 2 0v1Zm2.293-8.293a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 6.414V16a1 1 0 1 1-2 0V6.414L8.707 8.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), qte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7Zm-.917 13h11.834a6.002 6.002 0 0 0-11.834 0ZM4 21a8 8 0 1 1 16 0 1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm14 1a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Zm-9 7a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-7 5a7 7 0 1 1 14 0v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Kte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 0 0-6.598 12.526A14.943 14.943 0 0 1 12 15c2.366 0 4.606.548 6.598 1.526A8 8 0 0 0 12 4Zm7.654 14.436A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 2.37 6.464A9.978 9.978 0 0 0 12 22a9.978 9.978 0 0 0 7.654-3.564ZM17.2 18.08A12.954 12.954 0 0 0 12 17c-1.85 0-3.607.386-5.199 1.08A7.968 7.968 0 0 0 12 20c1.985 0 3.8-.723 5.199-1.92ZM12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Qte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM8 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM5 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm17-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-4 4a4.002 4.002 0 0 0-4 4v1h8v-1a4.002 4.002 0 0 0-4-4Zm6 5h3v-1a2 2 0 0 0-3.213-1.59c.139.507.213 1.04.213 1.59v1Zm-1.071-4.422A5.992 5.992 0 0 0 12 12a5.993 5.993 0 0 0-4.929 2.578A4 4 0 0 0 1 18v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-2a4 4 0 0 0-6.071-3.422ZM6.213 16.41A2 2 0 0 0 3 18v1h3v-1c0-.55.074-1.083.213-1.59Z",
        clipRule: "evenodd"
      }
    )
  }
), Xte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm3-1a5 5 0 1 0 0 8 5 5 0 1 0 0-8Zm1.334 1.505C13.758 5.239 14 6.09 14 7s-.242 1.76-.666 2.495a3 3 0 1 0 0-4.99ZM9 15a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm7 5h4a5 5 0 0 0-6.001-4.9A6.977 6.977 0 0 1 16 20Zm-4-6.326A7 7 0 0 0 2 20v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1a7 7 0 0 0-10-6.326Z",
        clipRule: "evenodd"
      }
    )
  }
), Jte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.555 3.104a1 1 0 0 1 1.34.451A18.926 18.926 0 0 1 21.872 12c0 3.031-.71 5.9-1.975 8.445a1 1 0 0 1-1.791-.89A16.926 16.926 0 0 0 19.87 12c0-2.716-.636-5.28-1.766-7.555a1 1 0 0 1 .45-1.34Zm-13.239 0a1 1 0 0 1 .45 1.341A16.926 16.926 0 0 0 4 12c0 2.716.636 5.28 1.767 7.555a1 1 0 1 1-1.791.89A18.926 18.926 0 0 1 2 12c0-3.032.71-5.9 1.976-8.445a1 1 0 0 1 1.34-.45ZM8 9a1 1 0 0 1 1-1h1.246a2 2 0 0 1 1.923 1.45l.282.988 1.191-1.39A3 3 0 0 1 15.92 8H16a1 1 0 1 1 0 2h-.08a1 1 0 0 0-.76.35l-2.05 2.392.644 2.258H15a1 1 0 1 1 0 2h-1.246a2 2 0 0 1-1.923-1.45l-.282-.988-1.191 1.39A3 3 0 0 1 8.08 17H8a1 1 0 1 1 0-2h.08a1 1 0 0 0 .76-.35l2.05-2.392L10.247 10H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ene = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v.382l3.106-1.553A2 2 0 0 1 22 8.618v6.764a2 2 0 0 1-2.894 1.789L16 15.618V16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8Zm12 5.978a.97.97 0 0 0 0 .042V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.978Zm2-.596 4 2V8.618l-4 2v2.764Z",
        clipRule: "evenodd"
      }
    )
  }
), tne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h2c.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 11 4h2c.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 17 4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 13 20h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 7 20H5a3 3 0 0 1-3-3V7Zm8 10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10ZM8 7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7Zm8 0v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1Z",
        clipRule: "evenodd"
      }
    )
  }
), nne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM3 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Z",
        clipRule: "evenodd"
      }
    )
  }
), rne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ane = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.586 3.586C10.846 2.326 13 3.218 13 5v14c0 1.782-2.154 2.674-3.414 1.414L5.172 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.172l4.414-4.414ZM11 5 6.293 9.707a1 1 0 0 1-.707.293H4v4h1.586a1 1 0 0 1 .707.293L11 19V5Zm5.293 4.293a1 1 0 0 1 1.414 0L19 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L20.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L19 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L17.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), ine = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.586 3.586C10.846 2.326 13 3.218 13 5v14c0 1.782-2.154 2.674-3.414 1.414L5.172 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.172l4.414-4.414ZM11 5 6.293 9.707a1 1 0 0 1-.707.293H4v4h1.586a1 1 0 0 1 .707.293L11 19V5Zm6.657-.071a1 1 0 0 1 1.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414Zm-2.829 2.828a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.415 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), lne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.9 10.1c-5.468-5.467-14.332-5.467-19.8 0A1 1 0 0 1 .687 8.687c6.249-6.248 16.38-6.248 22.628 0a1 1 0 0 1-1.414 1.415Zm-3.536 3.536a9 9 0 0 0-12.728 0 1 1 0 0 1-1.414-1.414c4.296-4.296 11.26-4.296 15.556 0a1 1 0 0 1-1.414 1.414Zm-3.182 3.475a4.5 4.5 0 0 0-6.364 0 1 1 0 0 1-1.414-1.414 6.5 6.5 0 0 1 9.192 0 1 1 0 1 1-1.414 1.414ZM11 20a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), one = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), une = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.293-2.707a1 1 0 0 1 1.414 0L12 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L13.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L12 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L10.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), sne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Zm8-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H7a1 1 0 1 1 0-2h2V7a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Zm4 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.394 2.08a1 1 0 0 0-.788 0l-7 3a1 1 0 0 0 0 1.84L5.25 8.051a.999.999 0 0 1 .356-.257l4-1.714a1 1 0 1 1 .788 1.838l-2.727 1.17 1.94.831a1 1 0 0 0 .787 0l7-3a1 1 0 0 0 0-1.838l-7-3ZM3.31 9.397 5 10.12v4.102a8.969 8.969 0 0 0-1.05-.174 1 1 0 0 1-.89-.89 11.115 11.115 0 0 1 .25-3.762Zm5.99 7.176A9.026 9.026 0 0 0 7 14.935v-3.957l1.818.78a3 3 0 0 0 2.364 0l5.508-2.361a11.026 11.026 0 0 1 .25 3.762 1 1 0 0 1-.89.89 8.968 8.968 0 0 0-5.35 2.524 1 1 0 0 1-1.4 0ZM6 18a1 1 0 0 0 1-1v-2.065a8.935 8.935 0 0 0-2-.712V17a1 1 0 0 0 1 1Z"
      }
    )
  }
), dne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a1 1 0 0 0-2 0v7.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0v-1.268a2 2 0 0 0 0-3.464V4Zm6 0a1 1 0 1 0-2 0v1.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0V8.732a2 2 0 0 0 0-3.464V4Zm5-1a1 1 0 0 1 1 1v7.268a2 2 0 0 1 0 3.464V16a1 1 0 1 1-2 0v-1.268a2 2 0 0 1 0-3.464V4a1 1 0 0 1 1-1Z"
      }
    )
  }
), hne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 13V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3l3 3 3-3h3a2 2 0 0 0 2-2ZM5 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), vne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 3a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4H4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 8h14v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Zm5 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), pne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-11a1 1 0 1 0-2 0v3.586L7.707 9.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 10.586V7Z",
        clipRule: "evenodd"
      }
    )
  }
), mne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.707-10.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L9.414 11H13a1 1 0 1 0 0-2H9.414l1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), gne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-8.707-3-3a1 1 0 0 0-1.414 1.414L10.586 9H7a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), wne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-8.707-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13a1 1 0 1 0 2 0V9.414l1.293 1.293a1 1 0 0 0 1.414-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), yne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.707 10.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l4.293-4.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), xne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 16.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l4.293 4.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Sne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 12.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Cne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), bne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), _ne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 7.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L6.707 7.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Rne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Ene = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H6.414l2.293 2.293a1 1 0 0 1-1.414 1.414L5 6.414V8a1 1 0 0 1-2 0V4Zm9 1a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L13.586 5H12Zm-9 7a1 1 0 1 1 2 0v1.586l2.293-2.293a1 1 0 0 1 1.414 1.414L6.414 15H8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-4Zm13-1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.586l-2.293-2.293a1 1 0 0 1 1.414-1.414L15 13.586V12a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Mne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 10.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 12.586V5a1 1 0 0 1 2 0v7.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Tne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L7.414 9H15a1 1 0 1 1 0 2H7.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), One = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L12.586 11H5a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Dne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 9.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 7.414V15a1 1 0 1 1-2 0V7.414L6.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), jne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 9.707a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L4.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Ane = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.243 5.757a6 6 0 1 0-.986 9.284 1 1 0 1 1 1.087 1.678A8 8 0 1 1 18 10a3 3 0 0 1-4.8 2.401A4 4 0 1 1 14 10a1 1 0 1 0 2 0c0-1.537-.586-3.07-1.757-4.243ZM12 10a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), kne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_3957_11497)", children: [
        /* @__PURE__ */ f.jsx(
          "rect",
          {
            width: "42",
            height: "42",
            rx: "21",
            fill: "#161618",
            fillOpacity: "0.1"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M33.8 21C33.8 28.0692 28.0692 33.8 21 33.8C13.9308 33.8 8.2 28.0692 8.2 21C8.2 13.9308 13.9308 8.2 21 8.2C28.0692 8.2 33.8 13.9308 33.8 21ZM24.2 16.2C24.2 17.9673 22.7673 19.4 21 19.4C19.2327 19.4 17.8 17.9673 17.8 16.2C17.8 14.4327 19.2327 13 21 13C22.7673 13 24.2 14.4327 24.2 16.2ZM20.9999 22.6C17.7718 22.6 14.9903 24.5119 13.726 27.2651C15.4864 29.3072 18.0922 30.6 21 30.6C23.9076 30.6 26.5134 29.3073 28.2739 27.2653C27.0096 24.512 24.228 22.6 20.9999 22.6Z",
            fill: "#C8C7CB"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_3957_11497", children: /* @__PURE__ */ f.jsx("rect", { width: "42", height: "42", fill: "white" }) }) })
    ]
  }
), Lne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.707 4.879A3 3 0 0 1 8.828 4H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8.828a3 3 0 0 1-2.12-.879l-4.415-4.414a1 1 0 0 1 0-1.414l4.414-4.414Zm4 2.414a1 1 0 0 0-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L12 8.586l-1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Ine = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.267 3.455a3.066 3.066 0 0 0 1.745-.723 3.066 3.066 0 0 1 3.976 0 3.066 3.066 0 0 0 1.745.723 3.066 3.066 0 0 1 2.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 0 1 0 3.976 3.066 3.066 0 0 0-.723 1.745 3.066 3.066 0 0 1-2.812 2.812 3.066 3.066 0 0 0-1.745.723 3.066 3.066 0 0 1-3.976 0 3.066 3.066 0 0 0-1.745-.723 3.066 3.066 0 0 1-2.812-2.812 3.066 3.066 0 0 0-.723-1.745 3.066 3.066 0 0 1 0-3.976 3.066 3.066 0 0 0 .723-1.745 3.066 3.066 0 0 1 2.812-2.812Zm7.44 5.252a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Hne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4.523 4.89A6 6 0 0 1 5.11 6.524l8.367 8.368Zm1.414-1.414L6.524 5.11a6 6 0 0 1 8.367 8.367Z",
        clipRule: "evenodd"
      }
    )
  }
), Zne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 0-.707 1.707L7 4.414v3.758a1 1 0 0 1-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0 1 13 8.172V4.414l.707-.707A1 1 0 0 0 13 2H7Zm2 6.172V4h2v4.172a3 3 0 0 0 .879 2.12l1.027 1.028a4 4 0 0 0-2.171.102l-.47.156a4 4 0 0 1-2.53 0l-.563-.187a1.993 1.993 0 0 0-.114-.035l1.063-1.063A3 3 0 0 0 9 8.172Z",
        clipRule: "evenodd"
      }
    )
  }
), Pne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a6 6 0 0 0-6 6v3.586l-.707.707A1 1 0 0 0 4 14h12a1 1 0 0 0 .707-1.707L16 11.586V8a6 6 0 0 0-6-6Zm0 16a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3Z"
      }
    )
  }
), Nne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14l-5-2.5L5 18V4Z"
      }
    )
  }
), Vne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm11 1H6v8l4-2 4 2V6Z",
        clipRule: "evenodd"
      }
    )
  }
), Bne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 4.804A7.968 7.968 0 0 0 5.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 0 1 5.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0 1 14.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0 0 14.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 1 1-2 0V4.804Z"
      }
    )
  }
), Fne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 6V5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2a2 2 0 0 1 2 2v3.57A22.952 22.952 0 0 1 10 13a22.95 22.95 0 0 1-8-1.43V8a2 2 0 0 1 2-2h2Zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H8V5Zm1 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 13.692V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.308A24.974 24.974 0 0 1 10 15a24.98 24.98 0 0 1-8-1.308Z"
        }
      )
    ]
  }
), Une = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Zm2 3a1 1 0 0 0-2 0v1a2 2 0 0 0-2 2v1a2 2 0 0 0-2 2v.683a3.7 3.7 0 0 1 1.055.485 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0A3.7 3.7 0 0 1 18 12.683V12a2 2 0 0 0-2-2V9a2 2 0 0 0-2-2V6a1 1 0 1 0-2 0v1h-1V6a1 1 0 1 0-2 0v1H8V6Zm10 8.868a3.704 3.704 0 0 1-4.055-.036 1.704 1.704 0 0 0-1.89 0 3.704 3.704 0 0 1-4.11 0 1.704 1.704 0 0 0-1.89 0A3.704 3.704 0 0 1 2 14.868V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.132ZM9 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Z"
      }
    )
  }
), Yne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Zm6 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-3 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H10Zm-4 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H7Zm2 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm4-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H13ZM9 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1ZM7 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), $ne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1Zm0 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), Wne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.586a1 1 0 0 1-.707-.293l-1.121-1.121A2 2 0 0 0 11.172 3H8.828a2 2 0 0 0-1.414.586L6.293 4.707A1 1 0 0 1 5.586 5H4Zm6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }
    )
  }
), zne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 1a1 1 0 0 0 0 2h1.22l.305 1.222a.997.997 0 0 0 .01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 0 0 0-2H6.414l1-1H14a1 1 0 0 0 .894-.553l3-6A1 1 0 0 0 17 3H6.28l-.31-1.243A1 1 0 0 0 5 1H3Zm13 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      }
    )
  }
), qne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2V9a3 3 0 0 1 3-3h7a2 2 0 0 0-2-2H4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4Zm6 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Gne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5Zm6-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7Zm6-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z"
      }
    )
  }
), Kne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 10a8 8 0 0 1 8-8v8h8a8 8 0 1 1-16 0Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 2.252A8.014 8.014 0 0 1 17.748 8H12V2.252Z"
        }
      )
    ]
  }
), Qne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm9 4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7Zm-3 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-3 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Xne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 16 16",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        id: "icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.40039 3.9999C2.40039 3.11625 3.11674 2.3999 4.00039 2.3999H12.0004C12.884 2.3999 13.6004 3.11625 13.6004 3.9999V11.9999C13.6004 12.8836 12.884 13.5999 12.0004 13.5999H4.00039C3.11674 13.5999 2.40039 12.8836 2.40039 11.9999V3.9999ZM11.7661 5.76559C12.0785 6.07801 12.0785 6.58454 11.7661 6.89696L8.56608 10.097C8.25366 10.4094 7.74712 10.4094 7.43471 10.097L6.40039 9.06264L5.36608 10.097C5.05366 10.4094 4.54712 10.4094 4.23471 10.097C3.92229 9.78454 3.92229 9.27801 4.23471 8.96559L5.83471 7.36559C6.14712 7.05317 6.65366 7.05317 6.96608 7.36559L8.00039 8.3999L10.6347 5.76559C10.9471 5.45317 11.4537 5.45317 11.7661 5.76559Z",
        fill: "currentColor"
      }
    )
  }
), Jne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 0 1-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7ZM7 9H5v2h2V9Zm8 0h-2v2h2V9ZM9 9h2v2H9V9Z",
        clipRule: "evenodd"
      }
    )
  }
), ere = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 5v8a2 2 0 0 1-2 2h-5l-5 4v-4H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2ZM7 8H5v2h2V8Zm2 0h2v2H9V8Zm6 0h-2v2h2V8Z",
        clipRule: "evenodd"
      }
    )
  }
), tre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9l-3 3v-3H4a2 2 0 0 1-2-2V5Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 7v2a4 4 0 0 1-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1Z"
        }
      )
    ]
  }
), kT = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Nx = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-9.293a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Vx = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), BU = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), h8 = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), FU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), nre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L10 8.586l4.293-4.293a1 1 0 0 1 1.414 0Zm0 6a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 14.586l4.293-4.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 15.707a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1 0 1.414Zm-6 0a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 1.414L5.414 10l4.293 4.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), are = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.293 15.707a1 1 0 0 1 0-1.414L14.586 10l-4.293-4.293a1 1 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.293 15.707a1 1 0 0 1 0-1.414L8.586 10 4.293 5.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ire = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 15.707a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414 0Zm0-6a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 5.414 5.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), lre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M13 7H7v6h6V7Z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 2a1 1 0 0 1 2 0v1h2V2a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v2h1a1 1 0 1 1 0 2h-1v2h1a1 1 0 1 1 0 2h-1v2a2 2 0 0 1-2 2h-2v1a1 1 0 1 1-2 0v-1H9v1a1 1 0 1 1-2 0v-1H5a2 2 0 0 1-2-2v-2H2a1 1 0 1 1 0-2h1V9H2a1 1 0 0 1 0-2h1V5a2 2 0 0 1 2-2h2V2ZM5 5h10v10H5V5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ore = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "#fff",
          stroke: "#DCDBDD",
          strokeWidth: 0.6,
          d: "M5.32 1.3h9.36c2.22 0 4.02 1.8 4.02 4.02v9.36c0 2.22-1.8 4.02-4.02 4.02H5.32a4.02 4.02 0 0 1-4.02-4.02V5.32C1.3 3.1 3.1 1.3 5.32 1.3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#paint0_linear_590_7245)",
          fillRule: "evenodd",
          d: "m4.727 13.343 1.946-1.491c1.034 1.35 2.132 1.971 3.355 1.971 1.217 0 2.284-.614 3.272-1.953l1.973 1.455c-1.424 1.93-3.195 2.95-5.245 2.95-2.043 0-3.831-1.012-5.301-2.932Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#paint1_linear_590_7245)",
          fillRule: "evenodd",
          d: "M10.021 6.862 6.557 9.847 4.956 7.99l5.072-4.37 5.033 4.373-1.608 1.851-3.431-2.982Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsxs("defs", { children: [
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_590_7245",
            x1: 4.727,
            x2: 15.273,
            y1: 14.86,
            y2: 14.86,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { stopColor: "#8930FD" }),
              /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#49CCF9" })
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint1_linear_590_7245",
            x1: 4.956,
            x2: 15.061,
            y1: 7.855,
            y2: 7.855,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { stopColor: "#FF02F0" }),
              /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#FFC800" })
            ]
          }
        )
      ] })
    ]
  }
), ure = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 3 3 0 0 1-3 3H9a3 3 0 0 1-3-3Z"
        }
      )
    ]
  }
), sre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm9.707 5.707a1 1 0 0 0-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), cre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H8Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v6h-4.586l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L10.414 13H15v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm12 6h2a1 1 0 1 1 0 2h-2v-2Z"
        }
      )
    ]
  }
), fre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm3 4a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2H7Zm3 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3Zm-3 4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H7Zm3 0a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), UU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-12a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.828 2.829a1 1 0 1 0 1.415-1.415L11 9.586V6Z",
        clipRule: "evenodd"
      }
    )
  }
), dre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 16a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 16h-8Z"
      }
    )
  }
), hre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 9.5A3.5 3.5 0 0 0 5.5 13H9v2.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 1 0-.616-8.958 4.002 4.002 0 1 0-7.753 1.977A3.5 3.5 0 0 0 2 9.5Zm9 3.5H9V8a1 1 0 0 1 2 0v5Z",
        clipRule: "evenodd"
      }
    )
  }
), vre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 13a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 13H11V9.413l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13H5.5Z"
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M9 13h2v5a1 1 0 1 1-2 0v-5Z" })
    ]
  }
), pre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.316 3.051a1 1 0 0 1 .633 1.265l-4 12a1 1 0 1 1-1.898-.632l4-12a1 1 0 0 1 1.265-.633ZM5.707 6.293a1 1 0 0 1 0 1.414L3.414 10l2.293 2.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Zm8.586 0a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), mre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 0 1-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 0 1 .947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 0 1 2.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 0 1 2.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 0 1 .947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 0 1-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 0 1-2.287-.947ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }
    )
  }
), gre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7ZM4 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm-2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4Z"
      }
    )
  }
), wre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 2a2 2 0 0 0-2 2v11a3 3 0 1 0 6 0V4a2 2 0 0 0-2-2H4Zm1 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m10 14.243 4.9-4.9a2 2 0 0 0 0-2.828L13.485 5.1a2 2 0 0 0-2.828 0L10 5.757v8.486ZM16 18H9.071l6-6H16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2Z"
        }
      )
    ]
  }
), yre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 0-2 2v1h16V6a2 2 0 0 0-2-2H4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 9H2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9ZM4 13a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm5-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H9Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), xre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 17a1 1 0 0 0 1.447.894l4-2A1 1 0 0 0 17 15V9.236a1 1 0 0 0-1.447-.894l-4 2a1 1 0 0 0-.553.894V17Zm4.211-10.724a1 1 0 0 0 0-1.788l-4.764-2.382a1 1 0 0 0-.894 0L4.789 4.488a1 1 0 0 0 0 1.788l4.764 2.382a1 1 0 0 0 .894 0l4.764-2.382ZM4.447 8.342A1 1 0 0 0 3 9.236V15a1 1 0 0 0 .553.894l4 2A1 1 0 0 0 9 17v-5.764a1 1 0 0 0-.553-.894l-4-2Z"
      }
    )
  }
), Sre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.504 1.132a1 1 0 0 1 .992 0l1.75 1a1 1 0 1 1-.992 1.736L10 3.152l-1.254.716a1 1 0 1 1-.992-1.736l1.75-1ZM5.618 4.504a1 1 0 0 1-.372 1.364L5.016 6l.23.132a1 1 0 1 1-.992 1.736L4 7.723V8a1 1 0 0 1-2 0V6a.996.996 0 0 1 .52-.878l1.734-.99a1 1 0 0 1 1.364.372Zm8.764 0a1 1 0 0 1 1.364-.372l1.733.99A1.002 1.002 0 0 1 18 6v2a1 1 0 1 1-2 0v-.277l-.254.145a1 1 0 1 1-.992-1.736l.23-.132-.23-.132a1 1 0 0 1-.372-1.364Zm-7 4a1 1 0 0 1 1.364-.372L10 8.848l1.254-.716a1 1 0 1 1 .992 1.736L11 10.58V12a1 1 0 1 1-2 0v-1.42l-1.246-.712a1 1 0 0 1-.372-1.364ZM3 11a1 1 0 0 1 1 1v1.42l1.246.712a1 1 0 1 1-.992 1.736l-1.75-1A1 1 0 0 1 2 14v-2a1 1 0 0 1 1-1Zm14 0a1 1 0 0 1 1 1v2a1 1 0 0 1-.504.868l-1.75 1a1 1 0 1 1-.992-1.736L16 13.42V12a1 1 0 0 1 1-1Zm-9.618 5.504a1 1 0 0 1 1.364-.372l.254.145V16a1 1 0 1 1 2 0v.277l.254-.145a1 1 0 1 1 .992 1.736l-1.735.992a.995.995 0 0 1-1.022 0l-1.735-.992a1 1 0 0 1-.372-1.364Z"
      }
    )
  }
), Cre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 4a1 1 0 0 0 0 2 1 1 0 0 1 1 1v1H7a1 1 0 0 0 0 2h1v3a3 3 0 1 0 6 0v-1a1 1 0 1 0-2 0v1a1 1 0 1 1-2 0v-3h3a1 1 0 1 0 0-2h-3V7a3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), bre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 0 1-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582ZM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 0 1-.567.267Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a1 1 0 1 0-2 0v.092a4.535 4.535 0 0 0-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 1 0-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 1 0 2 0v-.092a4.535 4.535 0 0 0 1.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0 0 11 9.092V7.151c.391.127.68.317.843.504a1 1 0 1 0 1.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), _re = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 0 0 1.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 0 0 0 2h.013a9.358 9.358 0 0 0 0 1H6a1 1 0 1 0 0 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 1 0-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 0 1-.264-.521H10a1 1 0 1 0 0-2H8.017a7.36 7.36 0 0 1 0-1H10a1 1 0 1 0 0-2H8.472c.08-.185.167-.36.264-.521Z",
        clipRule: "evenodd"
      }
    )
  }
), Rre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-14a3 3 0 0 0-3 3v2H7a1 1 0 0 0 0 2h1v1a1 1 0 0 1-1 1 1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 1 0 0-2h-1V7a1 1 0 1 1 2 0 1 1 0 1 0 2 0 3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), Ere = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 5a1 1 0 1 0 0 2h1a2 2 0 0 1 1.732 1H7a1 1 0 1 0 0 2h2.732A2 2 0 0 1 8 11H7a1 1 0 0 0-.707 1.707l3 3a1 1 0 0 0 1.414-1.414l-1.483-1.484A4.008 4.008 0 0 0 11.874 10H13a1 1 0 1 0 0-2h-1.126a3.976 3.976 0 0 0-.41-1H13a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Mre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.858 5.485a1 1 0 0 0-1.715 1.03L7.633 9H7a1 1 0 1 0 0 2h1.834l.166.277V12H7a1 1 0 1 0 0 2h2v1a1 1 0 1 0 2 0v-1h2a1 1 0 1 0 0-2h-2v-.723l.166-.277H13a1 1 0 1 0 0-2h-.634l1.492-2.486a1 1 0 1 0-1.716-1.029L10.034 9h-.068L7.858 5.485Z",
        clipRule: "evenodd"
      }
    )
  }
), Tre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.672 1.912a1 1 0 0 0-1.932.517l.259.966a1 1 0 0 0 1.932-.518l-.26-.965ZM2.43 4.74a1 1 0 0 0-.519 1.932l.966.259a1 1 0 0 0 .518-1.932l-.966-.26Zm8.813-.568a1 1 0 0 0-1.415-1.415l-.707.707a1 1 0 1 0 1.415 1.415l.707-.707Zm-7.072 7.071.708-.707A1 1 0 0 0 3.464 9.12l-.707.707a1 1 0 0 0 1.414 1.415Zm3.2-5.171a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 1.824.075l1.379-2.759 3.019 3.02a1 1 0 1 0 1.414-1.415l-3.019-3.019 2.76-1.38a1 1 0 0 0-.077-1.822l-10-4Z"
      }
    )
  }
), Ore = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3Z"
        }
      )
    ]
  }
), Dre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.22l.123.489.804.804A1 1 0 0 1 13 18H7a1 1 0 0 1-.707-1.707l.804-.804L7.22 15H5a2 2 0 0 1-2-2V5Zm5.771 7H5V5h10v7H8.771Z",
        clipRule: "evenodd"
      }
    )
  }
), jre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Zm3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Are = ({
  size: e = "1em",
  fill: t = "#5865F2",
  ...a
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 71 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a,
    children: [
      /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0)", children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z",
          fill: t
        }
      ) }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ f.jsx("rect", { width: "71", height: "55", fill: "white" }) }) })
    ]
  }
), kre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Z",
        clipRule: "evenodd"
      }
    )
  }
), Lre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm5 6a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Ire = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm5 6a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Hre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6.414A2 2 0 0 0 16.414 5L14 2.586A2 2 0 0 0 12.586 2H9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a2 2 0 0 1 2-2v7a3 3 0 0 0 3 3h5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Z"
        }
      )
    ]
  }
), Zre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm1 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Pre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm2 10a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Zm2-3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm4-1a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Nre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2h-1.528A6 6 0 0 0 4 9.528V4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 10a4 4 0 0 0-3.446 6.032l-1.261 1.26a1 1 0 1 0 1.414 1.415l1.261-1.261A4 4 0 1 0 8 10Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Vre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Bre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9H5v2h2V9Zm8 0h-2v2h2V9ZM9 9h2v2H9V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Fre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      }
    )
  }
), Ure = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      }
    )
  }
), Yre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm3.293-7.707a1 1 0 0 1 1.414 0L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), $re = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4 4.5C2.89543 4.5 2 5.39543 2 6.5C2 7.60457 2.89543 8.5 4 8.5C5.10457 8.5 6 7.60457 6 6.5C6 5.39543 5.10457 4.5 4 4.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4 11.5C2.89543 11.5 2 12.3954 2 13.5C2 14.6046 2.89543 15.5 4 15.5C5.10457 15.5 6 14.6046 6 13.5C6 12.3954 5.10457 11.5 4 11.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8 6.5C8 5.39543 8.89543 4.5 10 4.5C11.1046 4.5 12 5.39543 12 6.5C12 7.60457 11.1046 8.5 10 8.5C8.89543 8.5 8 7.60457 8 6.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 11.5C8.89543 11.5 8 12.3954 8 13.5C8 14.6046 8.89543 15.5 10 15.5C11.1046 15.5 12 14.6046 12 13.5C12 12.3954 11.1046 11.5 10 11.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M14 6.5C14 5.39543 14.8954 4.5 16 4.5C17.1046 4.5 18 5.39543 18 6.5C18 7.60457 17.1046 8.5 16 8.5C14.8954 8.5 14 7.60457 14 6.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16 11.5C14.8954 11.5 14 12.3954 14 13.5C14 14.6046 14.8954 15.5 16 15.5C17.1046 15.5 18 14.6046 18 13.5C18 12.3954 17.1046 11.5 16 11.5Z",
          fill: "#322444"
        }
      )
    ]
  }
), Wre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2V8a3 3 0 0 1 3-3h5a2 2 0 0 0-2-2H5Z"
        }
      )
    ]
  }
), zre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.464 5.535a1 1 0 1 0-1.415-1.414 3 3 0 0 1-4.242 0 1 1 0 0 0-1.415 1.414 5 5 0 0 0 7.072 0Z",
        clipRule: "evenodd"
      }
    )
  }
), qre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7.536 5.879a1 1 0 0 0 1.415 0 3 3 0 0 1 4.242 0 1 1 0 0 0 1.415-1.415 5 5 0 0 0-7.072 0 1 1 0 0 0 0 1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), YU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.743 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92ZM11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-8a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-9a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Kre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1Zm10.293 9.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L14.586 9H7a1 1 0 1 0 0 2h7.586l-1.293 1.293Z"
      }
    )
  }
), Qre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2H5Z"
        }
      )
    ]
  }
), Xre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Jre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l14 14a1 1 0 0 0 1.414-1.414l-1.473-1.473A10.014 10.014 0 0 0 19.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 0 0-4.512 1.074l-1.78-1.781Zm4.261 4.26 1.514 1.515a2.003 2.003 0 0 1 2.45 2.45l1.514 1.514a4 4 0 0 0-5.478-5.478Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.454 16.697 9.75 13.992a4 4 0 0 1-3.742-3.741L2.335 6.578A9.98 9.98 0 0 0 .458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303Z"
        }
      )
    ]
  }
), eae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.555 5.168A1 1 0 0 0 3 6v8a1 1 0 0 0 1.555.832L10 11.202V14a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.664l-6-4A1 1 0 0 0 10 6v2.798l-5.445-3.63Z"
      }
    )
  }
), tae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm3 2h6v4H7V5Zm8 8v2h1v-2h-1Zm-2-2H7v4h6v-4Zm2 0h1V9h-1v2Zm1-4V5h-1v2h1ZM5 5v2H4V5h1Zm0 4H4v2h1V9Zm-1 4h1v2H4v-2Z",
        clipRule: "evenodd"
      }
    )
  }
), nae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-.293.707L12 11.414V15a1 1 0 0 1-.293.707l-2 2A1 1 0 0 1 8 17v-5.586L3.293 6.707A1 1 0 0 1 3 6V3Z",
        clipRule: "evenodd"
      }
    )
  }
), rae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.625 2.655A9 9 0 0 1 19 11a1 1 0 1 1-2 0 7 7 0 0 0-9.625-6.492 1 1 0 1 1-.75-1.853ZM4.662 4.959A1 1 0 0 1 4.75 6.37 6.97 6.97 0 0 0 3 11a1 1 0 1 1-2 0 8.97 8.97 0 0 1 2.25-5.953 1 1 0 0 1 1.412-.088Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 11a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 1 1-1.838-.789A9.964 9.964 0 0 0 5 11Zm8.921 2.012a1 1 0 0 1 .831 1.145 19.86 19.86 0 0 1-.545 2.436 1 1 0 1 1-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 0 1 1.144-.83Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 10a1 1 0 0 1 1 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 0 1-1.838-.789A13.952 13.952 0 0 0 9 11a1 1 0 0 1 1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), aae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.757 2.034a1 1 0 0 1 .638.519c.483.967.844 1.554 1.207 2.03.368.482.756.876 1.348 1.467A6.981 6.981 0 0 1 17 11 7 7 0 1 1 5.05 6.05a1 1 0 0 1 1.707.707c0 1.12.07 1.973.398 2.654.18.374.46.74.945 1.067.116-1.061.328-2.354.614-3.58.225-.966.505-1.93.839-2.734.167-.403.356-.785.57-1.116.208-.322.477-.65.822-.88a1 1 0 0 1 .812-.134Zm.364 13.087A3 3 0 0 1 7 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0 1 13 13a2.99 2.99 0 0 1-.879 2.121Z",
        clipRule: "evenodd"
      }
    )
  }
), iae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h10a1 1 0 0 1 .8 1.6L14.25 8l2.55 3.4A1 1 0 0 1 16 13H6a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0V6Z",
        clipRule: "evenodd"
      }
    )
  }
), lae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Z"
      }
    )
  }
), oae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm7 5a1 1 0 1 0-2 0v1H8a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V9Z",
        clipRule: "evenodd"
      }
    )
  }
), uae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm7 5a1 1 0 1 0-2 0v1.586l-.293-.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0-1.414-1.414l-.293.293V9Z",
        clipRule: "evenodd"
      }
    )
  }
), sae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h4l2 2h4a2 2 0 0 1 2 2v1H8a3 3 0 0 0-3 3v1.5a1.5 1.5 0 0 1-3 0V6Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 12a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2h2a2 2 0 0 0 2-2v-2Z"
        }
      )
    ]
  }
), cae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm4 6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  }
), fae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 5a3 3 0 0 1 5-2.236A3 3 0 0 1 14.83 6H16a2 2 0 1 1 0 4h-5V9a1 1 0 1 0-2 0v1H4a2 2 0 1 1 0-4h1.17C5.06 5.687 5 5.35 5 5Zm4 1V5a1 1 0 1 0-1 1h1Zm3 0a1 1 0 1 0-1-1v1h1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 11H3v5a2 2 0 0 0 2 2h4v-7Zm2 7h4a2 2 0 0 0 2-2v-5h-6v7Z"
        }
      )
    ]
  }
), dae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.95c-4.42 0-8 3.58-8 8 0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 18 9.95c0-4.42-3.58-8-8-8Z",
        clipRule: "evenodd"
      }
    )
  }
), hae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: e,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "feather feather-gitlab",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
      }
    )
  }
), vae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM4.332 8.027a6.012 6.012 0 0 1 1.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 0 1 9 7.5V8a2 2 0 0 0 4 0 2 2 0 0 1 1.523-1.943A5.977 5.977 0 0 1 16 10c0 .34-.028.675-.083 1H15a2 2 0 0 0-2 2v2.197A5.973 5.973 0 0 1 10 16v-2a2 2 0 0 0-2-2 2 2 0 0 1-2-2 2 2 0 0 0-1.668-1.973Z",
        clipRule: "evenodd"
      }
    )
  }
), pae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 0 0 4.083 9ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4Zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0 1 15.917 9h-1.946Zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556Zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 0 1-2.783 4.118Zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 0 0 2.783 4.118Z",
        clipRule: "evenodd"
      }
    )
  }
), mae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1603_12998)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#4285F4",
            d: "M18.215 10.368a7.05 7.05 0 0 0-.172-1.669h-7.665v3.03h4.5c-.092.753-.581 1.886-1.67 2.648l-.015.101 2.423 1.878.168.017c1.542-1.424 2.431-3.52 2.431-6.005Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#34A853",
            d: "M10.378 18.35c2.204 0 4.055-.726 5.406-1.977l-2.576-1.996c-.69.48-1.614.816-2.83.816-2.158 0-3.99-1.424-4.644-3.392l-.096.008-2.52 1.95-.032.092a8.157 8.157 0 0 0 7.292 4.499Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#FBBC05",
            d: "M5.734 11.801a5.025 5.025 0 0 1-.272-1.614c0-.563.1-1.107.263-1.615l-.004-.108-2.552-1.981-.083.04a8.17 8.17 0 0 0-.871 3.664 8.17 8.17 0 0 0 .87 3.664l2.65-2.05Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#EB4335",
            d: "M10.378 5.18c1.533 0 2.567.662 3.157 1.215l2.303-2.25c-1.414-1.314-3.256-2.122-5.46-2.122a8.157 8.157 0 0 0-7.292 4.5l2.64 2.05c.661-1.97 2.494-3.393 4.652-3.393Z"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_1603_12998", children: /* @__PURE__ */ f.jsx("path", { fill: "#fff", d: "M2.215 2h16v16.373h-16z" }) }) })
    ]
  }
), gae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M17.1997 9.0611C17.1733 8.79223 17.1292 8.48369 17.041 8.13988C16.9529 7.80049 16.8207 7.42583 16.6267 7.03796C16.4328 6.65008 16.1815 6.24897 15.8554 5.85669C15.7275 5.70242 15.5865 5.55256 15.4366 5.4071C15.6614 4.51234 15.1634 3.73658 15.1634 3.73658C14.3039 3.68369 13.7573 4.00545 13.5545 4.1509C13.5193 4.13768 13.4884 4.12005 13.4532 4.10683C13.3077 4.04953 13.1579 3.99223 12.9992 3.94374C12.8449 3.89526 12.6862 3.85118 12.5231 3.81151C12.3601 3.77184 12.197 3.74099 12.0295 3.71454C11.9986 3.71013 11.9722 3.70572 11.9413 3.70132C11.5667 2.50242 10.4912 1.99994 10.4912 1.99994C9.28788 2.76247 9.06308 3.82914 9.06308 3.82914C9.06308 3.82914 9.05868 3.85118 9.04986 3.89085C8.98375 3.90848 8.91763 3.93052 8.85151 3.94815C8.75895 3.97459 8.66639 4.00986 8.57824 4.04512C8.48567 4.08038 8.39752 4.11564 8.30496 4.15531C8.12424 4.23465 7.94353 4.3228 7.76722 4.41977C7.59532 4.51674 7.42782 4.62253 7.26474 4.73272L7.22066 4.71509C5.55455 4.08038 4.07796 4.84291 4.07796 4.84291C3.94132 6.61481 4.74353 7.72997 4.9022 7.93272C4.86253 8.04291 4.82727 8.15311 4.79201 8.2633C4.66859 8.6644 4.57603 9.07432 4.51873 9.50187C4.50992 9.56358 4.5011 9.62528 4.49669 9.68699C2.95399 10.4495 2.5 12.0054 2.5 12.0054C3.78264 13.482 5.28127 13.5746 5.28127 13.5746L5.28567 13.5702C5.47521 13.9096 5.69559 14.2313 5.94242 14.5355C6.04821 14.6633 6.15399 14.7823 6.26859 14.9013C5.80138 16.2413 6.33471 17.352 6.33471 17.352C7.76281 17.4049 8.70165 16.7261 8.9 16.5718C9.04105 16.6203 9.1865 16.6644 9.33196 16.6997C9.77273 16.8143 10.2223 16.8804 10.6719 16.898C10.7821 16.9024 10.8967 16.9068 11.0069 16.9024H11.1656L11.2361 16.898V16.9024C11.9105 17.8633 13.0917 17.9999 13.0917 17.9999C13.9336 17.114 13.9821 16.2324 13.9821 16.0429V15.9636C14.1584 15.8402 14.3259 15.7079 14.4846 15.5625C14.8196 15.2583 15.1149 14.9101 15.3617 14.5355L15.4278 14.4297C16.3799 14.4826 17.0543 13.8391 17.0543 13.8391C16.8956 12.8473 16.3314 12.3625 16.2124 12.2699C16.0934 12.1774 16.208 12.2655 16.1992 12.2611C16.1904 12.2567 16.1904 12.2523 16.1904 12.2523C16.1859 12.2479 16.1771 12.2435 16.1683 12.2391C16.1727 12.1773 16.1771 12.12 16.1815 12.0583C16.1904 11.9526 16.1904 11.8424 16.1904 11.7366V11.5691L16.1859 11.503L16.1815 11.4148C16.1815 11.384 16.1771 11.3575 16.1727 11.3311C16.1683 11.3046 16.1683 11.2738 16.1639 11.2473L16.1551 11.1636L16.1419 11.0798C16.1242 10.9696 16.1066 10.8639 16.0802 10.7537C15.9788 10.3261 15.8113 9.9206 15.5953 9.55476C15.3749 9.18892 15.1017 8.86716 14.7887 8.59388C14.4802 8.3206 14.132 8.10021 13.7705 7.93713C13.4047 7.77404 13.0256 7.66826 12.6466 7.61977C12.457 7.59333 12.2675 7.58451 12.078 7.58892H11.9369L11.8664 7.59333C11.8399 7.59333 11.8135 7.59774 11.7915 7.59774C11.6945 7.60655 11.5975 7.61977 11.505 7.6374C11.1259 7.70793 10.7689 7.84457 10.4559 8.0341C10.143 8.22363 9.8697 8.45724 9.64931 8.7217C9.42893 8.98617 9.25702 9.28148 9.13802 9.58561C9.01901 9.88975 8.95289 10.2071 8.93526 10.5112C8.93085 10.5862 8.93085 10.6655 8.93085 10.7404V10.7977L8.93526 10.8594C8.93967 10.8947 8.93967 10.9344 8.94408 10.9696C8.9573 11.1239 8.98815 11.2738 9.02782 11.4148C9.11157 11.7013 9.2438 11.9614 9.40689 12.1818C9.56997 12.4021 9.76832 12.5829 9.97548 12.7283C10.1826 12.8694 10.4074 12.9707 10.6278 13.0369C10.8482 13.103 11.0686 13.1294 11.2758 13.1294H11.3904C11.4036 13.1294 11.4168 13.1294 11.43 13.125C11.4521 13.125 11.4741 13.1206 11.4961 13.1206C11.5006 13.1206 11.5094 13.1206 11.5138 13.1162L11.5358 13.1118C11.549 13.1118 11.5623 13.1074 11.5755 13.1074C11.6019 13.103 11.624 13.0986 11.6504 13.0942C11.6769 13.0897 11.6989 13.0853 11.7209 13.0765C11.7694 13.0677 11.8135 13.0501 11.8576 13.0369C11.9457 13.006 12.0339 12.9707 12.1088 12.9311C12.1882 12.8914 12.2587 12.8429 12.3292 12.7988C12.3468 12.7856 12.3689 12.7724 12.3865 12.7548C12.457 12.6975 12.4702 12.5917 12.4129 12.5212C12.3645 12.4594 12.2763 12.4418 12.2058 12.4815L12.1529 12.5079C12.0912 12.5388 12.0295 12.5652 11.9634 12.5873C11.8972 12.6093 11.8267 12.6269 11.7562 12.6402C11.7209 12.6446 11.6857 12.649 11.646 12.6534C11.6284 12.6534 11.6107 12.6578 11.5887 12.6578H11.4829C11.4609 12.6578 11.4388 12.6578 11.4168 12.6534H11.3904C11.3815 12.6534 11.3683 12.6534 11.3595 12.649C11.3375 12.6446 11.3198 12.6446 11.2978 12.6402C11.1347 12.6181 10.9716 12.5696 10.8174 12.4991C10.6587 12.4286 10.5088 12.3316 10.3722 12.2082C10.2355 12.0848 10.1165 11.9393 10.024 11.7718C9.9314 11.6043 9.86529 11.4192 9.83443 11.2253C9.82121 11.1283 9.8124 11.0269 9.8168 10.93C9.8168 10.9035 9.82121 10.8771 9.82121 10.8506V10.8154C9.82121 10.8021 9.82562 10.7889 9.82562 10.7757C9.83003 10.7228 9.83884 10.6699 9.84766 10.617C9.92259 10.1939 10.1342 9.77955 10.4603 9.46661C10.5441 9.38727 10.6322 9.31674 10.7248 9.25063C10.8174 9.18451 10.9187 9.12721 11.0245 9.07873C11.1303 9.03024 11.2361 8.99057 11.3507 8.95972C11.4609 8.92886 11.5755 8.91123 11.6945 8.89801C11.7518 8.8936 11.8091 8.8892 11.8708 8.8892H12.0074L12.0559 8.8936C12.1837 8.90242 12.3072 8.92005 12.4306 8.9509C12.6774 9.0038 12.9198 9.09636 13.1446 9.21977C13.5942 9.47101 13.9777 9.85889 14.2113 10.3261C14.3303 10.5597 14.4141 10.811 14.4537 11.071C14.4625 11.1371 14.4713 11.2032 14.4758 11.2694L14.4846 11.3663V11.5559C14.4846 11.5867 14.4802 11.6396 14.4802 11.6705C14.4758 11.741 14.4669 11.8159 14.4581 11.8864C14.4493 11.957 14.4361 12.0275 14.4229 12.098C14.4096 12.1685 14.392 12.2391 14.3744 12.3052C14.3391 12.4418 14.295 12.5785 14.2421 12.7151C14.1364 12.9796 13.9953 13.2352 13.8278 13.4688C13.4884 13.936 13.0256 14.3151 12.4967 14.5575C12.2322 14.6765 11.9545 14.7647 11.668 14.8088C11.527 14.8352 11.3815 14.8484 11.2361 14.8528H11.0157C10.9364 14.8528 10.8614 14.8484 10.7821 14.8396C10.4736 14.8176 10.1694 14.7603 9.8697 14.6765C9.57438 14.5928 9.28788 14.4738 9.0146 14.3327C8.47245 14.0418 7.9832 13.6451 7.60413 13.1647C7.4146 12.9267 7.24711 12.6666 7.11047 12.3977C6.97383 12.1289 6.86364 11.8424 6.7843 11.5559C6.70496 11.265 6.65647 10.9696 6.63444 10.6699L6.63003 10.6126V10.2203C6.63443 10.0749 6.64766 9.9206 6.66529 9.77074C6.68292 9.62088 6.70937 9.46661 6.74022 9.31674C6.77107 9.16688 6.80634 9.01702 6.85041 8.86716C6.93416 8.57184 7.03994 8.28534 7.16336 8.01647C7.4146 7.47873 7.74077 6.99829 8.13306 6.61481C8.23003 6.51785 8.3314 6.42969 8.43719 6.34154C8.54297 6.25779 8.65317 6.17845 8.76777 6.10352C8.87796 6.02859 8.99697 5.96247 9.11598 5.90077C9.17328 5.86991 9.23499 5.83906 9.29669 5.81261L9.48182 5.73327C9.60523 5.68038 9.73306 5.6363 9.86529 5.59663C9.89614 5.58782 9.9314 5.579 9.96226 5.56578C9.99311 5.55696 10.0284 5.54815 10.0592 5.53933C10.1253 5.5217 10.1915 5.50407 10.2576 5.49085C10.2884 5.48203 10.3237 5.47762 10.359 5.46881C10.3942 5.45999 10.4251 5.45559 10.4603 5.44677C10.4956 5.44236 10.5264 5.43355 10.5617 5.42914L10.6102 5.42032L10.6631 5.41151C10.6983 5.4071 10.7292 5.40269 10.7645 5.39829C10.8041 5.39388 10.8394 5.38947 10.8791 5.38506C10.9099 5.38066 10.9628 5.37625 10.9937 5.37184C11.0157 5.36743 11.0421 5.36743 11.0642 5.36302L11.1127 5.35862L11.1347 5.35421H11.1612C11.2008 5.3498 11.2361 5.3498 11.2758 5.34539L11.3331 5.34099H11.3771C11.408 5.34099 11.4432 5.33658 11.4741 5.33658C11.6019 5.33217 11.7342 5.33217 11.862 5.33658C12.1176 5.34539 12.3689 5.37625 12.6113 5.42032C13.1005 5.51289 13.559 5.66716 13.9777 5.87432C14.3964 6.07707 14.7667 6.32831 15.0928 6.60159C15.1149 6.61922 15.1325 6.63685 15.1545 6.65448C15.1722 6.67212 15.1942 6.68975 15.2118 6.70738C15.2515 6.74264 15.2868 6.7779 15.3264 6.81316C15.3661 6.84842 15.4014 6.88369 15.4366 6.91895C15.4719 6.95421 15.5072 6.98947 15.5424 7.02914C15.6791 7.17459 15.8069 7.32005 15.9215 7.46991C16.1507 7.76523 16.3358 8.06495 16.4813 8.34705L16.5342 8.45283C16.5518 8.48809 16.5694 8.52336 16.5826 8.55862C16.6003 8.59388 16.6135 8.62473 16.6311 8.65999C16.6444 8.69526 16.662 8.72611 16.6752 8.76137C16.7281 8.8936 16.781 9.02143 16.8207 9.14043C16.8868 9.33437 16.9353 9.50628 16.9749 9.65614C16.9882 9.71785 17.0455 9.75751 17.1072 9.7487C17.1733 9.74429 17.2218 9.6914 17.2218 9.62528C17.2262 9.46661 17.2218 9.27707 17.1997 9.0611Z",
        fill: "#322444"
      }
    )
  }
), wae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 3a1 1 0 0 1 2 0v5.5a.5.5 0 0 0 1 0V4a1 1 0 1 1 2 0v4.5a.5.5 0 0 0 1 0V6a1 1 0 1 1 2 0v5a7 7 0 1 1-14 0V9a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 2 0v4.5a.5.5 0 0 0 1 0V3Z"
      }
    )
  }
), yae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.243 3.03a1 1 0 0 1 .727 1.213L9.53 6h2.94l.56-2.243a1 1 0 1 1 1.94.486L14.53 6H17a1 1 0 1 1 0 2h-2.97l-1 4H15a1 1 0 1 1 0 2h-2.47l-.56 2.242a1 1 0 1 1-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 1 1-1.94-.485L5.47 14H3a1 1 0 1 1 0-2h2.97l1-4H5a1 1 0 0 1 0-2h2.47l.56-2.243a1 1 0 0 1 1.213-.727ZM9.03 8l-1 4h2.938l1-4H9.031Z",
        clipRule: "evenodd"
      }
    )
  }
), xae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.172 5.172a4 4 0 0 1 5.656 0L10 6.343l1.172-1.171a4 4 0 1 1 5.656 5.656L10 17.657l-6.828-6.829a4 4 0 0 1 0-5.656Z",
        clipRule: "evenodd"
      }
    )
  }
), Sae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_590_7243)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#7957FF",
            d: "m8.922 12.62.129-.107 6.473-.056.04.164a.409.409 0 0 1-.04.1c-.056.098-.177.168-.419.308l-6.25 3.616c-.622.36-.933.54-1.125.497a.505.505 0 0 1-.363-.315c-.07-.184.065-.518.335-1.185l1.22-3.021Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#18B6AA",
            d: "M15.564 12.62H8.922l-.039-.274 2.01-4.915.165-.092 4.208 4.675.02.022c.173.193.26.294.282.4a.413.413 0 0 1-.004.185Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#F845C6",
            d: "m11.108 3.35-6.22 3.582c-.242.139-.364.209-.42.307a.413.413 0 0 0-.045.285c.023.11.116.215.303.423l4.196 4.674 2.136-5.282 1.203-2.985c.268-.665.402-.997.333-1.181a.505.505 0 0 0-.363-.315c-.192-.043-.502.135-1.123.493Z"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_590_7243", children: /* @__PURE__ */ f.jsx("path", { fill: "#fff", d: "M0 0h20v20H0z" }) }) })
    ]
  }
), Cae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 12 12",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsxs("g", { id: "Own color", children: [
      /* @__PURE__ */ f.jsx(
        "circle",
        {
          id: "Ellipse 132",
          cx: "5.99999",
          cy: "6",
          r: "5.6",
          fill: "#744ED4"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          id: "Subtract",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.54999 3.55C3.9977 3.55 3.54999 3.99772 3.54999 4.55V7.45C3.54999 8.00229 3.9977 8.45 4.54999 8.45H6.34999L4.59999 3.55H4.54999ZM5.64999 3.55L7.39999 8.45H7.44999C8.00227 8.45 8.44999 8.00229 8.44999 7.45V4.55C8.44999 3.99772 8.00227 3.55 7.44999 3.55H5.64999Z",
          fill: "white"
        }
      )
    ] })
  }
), bae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L4 10.414V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.586l.293.293a1 1 0 0 0 1.414-1.414l-7-7Z"
      }
    )
  }
), _ae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 2a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 4h3a3 3 0 0 0 6 0h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm2.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm2.45 4a2.5 2.5 0 1 0-4.9 0h4.9ZM12 9a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Zm-1 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Rae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm12 0H5v10h10V5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M4 12h3l1 2h4l1-2h3v4H4v-4Z" })
    ]
  }
), Eae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h1a1 1 0 0 1 0 2H5v10h10V5h-1a1 1 0 1 1 0-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12h3l1 2h4l1-2h3v4H4v-4Zm3.293-4.707a1 1 0 0 1 1.414 0L9 7.586V3a1 1 0 1 1 2 0v4.586l.293-.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z"
        }
      )
    ]
  }
), $U = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a1 1 0 0 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2v-3a1 1 0 0 0-1-1H9Z",
        clipRule: "evenodd"
      }
    )
  }
), Mae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1.5a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.269 7.269a.913.913 0 0 1 .988-.203l9.167 3.666a.917.917 0 0 1 .07 1.671L14 14l-1.597 3.493a.917.917 0 0 1-1.67-.07L7.065 8.258a.917.917 0 0 1 .203-.988Z"
        }
      )
    ]
  }
), Tae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M32 0H0V32H32V0Z", fill: "#0052CC" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M23.7199 7.64001H15.6399C15.6399 9.64001 17.2799 11.28 19.2799 11.28H20.7599V12.72C20.7599 14.72 22.3999 16.36 24.3999 16.36V8.32001C24.4399 7.96001 24.1199 7.64001 23.7199 7.64001Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.7199 11.64H11.6399C11.6399 13.64 13.2799 15.28 15.2799 15.28H16.7599V16.72C16.7599 18.72 18.3999 20.36 20.3999 20.36V12.36C20.4399 11.96 20.1199 11.64 19.7199 11.64Z",
          fill: "url(#paint0_linear)"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.7199 15.6801H7.63989C7.63989 17.6801 9.27988 19.3201 11.2799 19.3201H12.7599V20.7601C12.7599 22.7601 14.3999 24.4001 16.3999 24.4001V16.4001C16.4399 16.0001 16.1199 15.6801 15.7199 15.6801Z",
          fill: "url(#paint1_linear)"
        }
      ),
      /* @__PURE__ */ f.jsxs("defs", { children: [
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint0_linear",
            x1: "20.2597",
            y1: "11.6708",
            x2: "16.8183",
            y2: "15.2196",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { offset: "0.176", stopColor: "white", stopOpacity: "0.4" }),
              /* @__PURE__ */ f.jsx("stop", { offset: "1", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint1_linear",
            x1: "16.4844",
            y1: "15.7246",
            x2: "12.5054",
            y2: "19.596",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { offset: "0.176", stopColor: "white", stopOpacity: "0.4" }),
              /* @__PURE__ */ f.jsx("stop", { offset: "1", stopColor: "white" })
            ]
          }
        )
      ] })
    ]
  }
), Oae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 8a6 6 0 0 1-7.743 5.743L8 16H6v2H2v-4l4.257-4.257A6 6 0 1 1 18 8Zm-6-4a1 1 0 1 0 0 2 2 2 0 0 1 2 2 1 1 0 1 0 2 0 4 4 0 0 0-4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Dae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0V3Zm4.657 2.757a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707ZM18 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1ZM5.05 6.464A1 1 0 1 0 6.464 5.05l-.707-.707a1 1 0 0 0-1.414 1.414l.707.707ZM5 10a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1Zm3 6v-1h4v1a2 2 0 1 1-4 0Zm4-2c.015-.34.208-.646.477-.859a4 4 0 1 0-4.954 0c.27.213.462.519.476.859h4.002Z"
      }
    )
  }
), jae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.3 1.046A1 1 0 0 1 12 2v5h4a1 1 0 0 1 .82 1.573l-7 10A1 1 0 0 1 8 18v-5H4a1 1 0 0 1-.82-1.573l7-10a1 1 0 0 1 1.12-.38Z",
        clipRule: "evenodd"
      }
    )
  }
), Aae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "#5E6AD2",
        d: "m2.1 11.35 6.55 6.55a8.013 8.013 0 0 1-6.55-6.55ZM2 9.572 10.428 18a8.01 8.01 0 0 0 1.463-.214L2.214 8.109A8 8 0 0 0 2 9.572Zm.634-2.72 10.515 10.514a7.988 7.988 0 0 0 1.1-.577L3.21 5.75c-.22.351-.413.719-.577 1.1Zm1.29-2.066a8.006 8.006 0 1 1 11.29 11.29L3.924 4.786Z"
      }
    )
  }
), kae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.586 4.586a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0 1 1 0 0 0-1.414 1.414 4 4 0 0 0 5.656 0l3-3a4 4 0 0 0-5.656-5.656l-1.5 1.5a1 1 0 1 0 1.414 1.414l1.5-1.5Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.586 9.586a2 2 0 0 1 2.828 0 1 1 0 1 0 1.414-1.414 4 4 0 0 0-5.656 0l-3 3a4 4 0 1 0 5.656 5.656l1.5-1.5a1 1 0 1 0-1.414-1.414l-1.5 1.5a2 2 0 1 1-2.828-2.828l3-3Z"
        }
      )
    ]
  }
), WU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 3c0-.552.45-1.006.997-.938a8 8 0 0 1 .987 15.688c-.535.137-1.037-.257-1.107-.805-.069-.548.323-1.04.852-1.2a6 6 0 0 0-.734-11.662C10.451 3.991 10 3.553 10 3Z"
      }
    )
  }
), Lae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 114 39",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm3.423-10.045A5 5 0 0 0 18 15v5l3.423-3.645ZM74 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm2.409-10.781A5 5 0 0 0 74 15v5l-3.853 3.187a5 5 0 1 0 6.262-7.569ZM97 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm0-1.4a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          width: 113,
          height: 38,
          x: 0.5,
          y: 0.5,
          stroke: "currentColor",
          strokeDasharray: "10 5",
          rx: 4.5
        }
      )
    ]
  }
), Iae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.05 4.05a7 7 0 1 1 9.9 9.9L10 18.9l-4.95-4.95a7 7 0 0 1 0-9.9ZM10 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        clipRule: "evenodd"
      }
    )
  }
), Hae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 9V7a5 5 0 0 1 10 0v2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2Zm8-2v2H7V7a3 3 0 0 1 6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Zae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a5 5 0 0 0-5 5v2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H7V7a3 3 0 0 1 5.905-.75 1 1 0 0 0 1.937-.5A5.002 5.002 0 0 0 10 2Z"
      }
    )
  }
), Pae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm7.707 3.293a1 1 0 0 1 0 1.414L9.414 9H17a1 1 0 1 1 0 2H9.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Nae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 16 14",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm3 1.752c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 3.246a1.25 1.25 0 1 0 0 2.5h4.5a1.25 1.25 0 1 0 0-2.5h-4.5Z",
        clipRule: "evenodd"
      }
    )
  }
), Vae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2.003 5.884 10 9.882l7.997-3.998A2 2 0 0 0 16 4H4a2 2 0 0 0-1.997 1.884Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m18 8.118-8 4-8-4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.118Z"
        }
      )
    ]
  }
), Bae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.94 6.412A2 2 0 0 0 2 8.108V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.108a2 2 0 0 0-.94-1.696l-6-3.75a2 2 0 0 0-2.12 0l-6 3.75Zm2.615 2.423a1 1 0 1 0-1.11 1.664l5 3.333a1 1 0 0 0 1.11 0l5-3.333a1 1 0 0 0-1.11-1.664L10 11.798 5.555 8.835Z",
        clipRule: "evenodd"
      }
    )
  }
), Fae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12 1.586-4 4v12.828l4-4V1.586ZM3.707 3.293A1 1 0 0 0 2 4v10a1 1 0 0 0 .293.707L6 18.414V5.586L3.707 3.293Zm14 2L14 1.586v12.828l2.293 2.293A1 1 0 0 0 18 16V6a1 1 0 0 0-.293-.707Z",
        clipRule: "evenodd"
      }
    )
  }
), Uae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.496 2.132a1 1 0 0 0-.992 0l-7 4A1 1 0 0 0 3 8v7a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2V8a1 1 0 0 0 .496-1.868l-7-4ZM6 9a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0v-3Zm5-1a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Yae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), $ae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Wae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm6 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), qae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.97571 5.41622C6.82771 5.41622 4.31717 7.9012 4.31717 10.9162C4.31717 12.5499 5.04907 14.0212 6.22415 15.0337C6.71326 15.4551 6.76695 16.1918 6.34406 16.6793C5.92117 17.1667 5.18185 17.2202 4.69274 16.7987C3.03224 15.3681 1.97571 13.2648 1.97571 10.9162C1.97571 6.56745 5.58031 3.08289 9.97571 3.08289C10.3614 3.08289 10.7415 3.10969 11.1138 3.16172C11.7541 3.2511 12.2004 3.84087 12.1107 4.47898C12.021 5.11708 11.4292 5.56187 10.7889 5.47243C10.5239 5.43544 10.2524 5.41622 9.97571 5.41622Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16.5433 8.74081C17.182 8.6407 17.7812 9.0756 17.8816 9.71213C17.9436 10.1053 17.9757 10.5075 17.9757 10.9162C17.9757 13.2648 16.9192 15.3681 15.2587 16.7987C14.7696 17.2202 14.0302 17.1667 13.6074 16.6793C13.1845 16.1918 13.2382 15.4551 13.7273 15.0337C14.9023 14.0212 15.6342 12.5499 15.6342 10.9162C15.6342 10.6293 15.6117 10.3482 15.5686 10.0744C15.4682 9.43798 15.9046 8.84087 16.5433 8.74081Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M14.4775 4.83705C14.9447 4.37147 15.7022 4.37147 16.1694 4.83705C16.6366 5.30264 16.6366 6.05753 16.1694 6.52312L12.7775 9.9032C12.8998 10.2285 12.9666 10.5808 12.9666 10.9486C12.9666 12.5947 11.6275 13.9292 9.97571 13.9292C8.32387 13.9292 6.98479 12.5947 6.98479 10.9486C6.98479 9.30251 8.32387 7.96809 9.97571 7.96809C10.378 7.96809 10.7617 8.04722 11.1121 8.19076L14.4775 4.83705Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Kae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 4a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0V4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 14.93A7.001 7.001 0 0 0 17 8a1 1 0 1 0-2 0A5 5 0 0 1 5 8a1 1 0 0 0-2 0 7.001 7.001 0 0 0 6 6.93V17H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2.07Z"
        }
      )
    ]
  }
), Qae = ({
  size: e = "1em",
  fill: t = "#5865F2"
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    fill: t,
    width: e,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    className: "bi bi-microsoft-teams",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M9.186 4.797a2.42 2.42 0 1 0-2.86-2.448h1.178c.929 0 1.682.753 1.682 1.682v.766Zm-4.295 7.738h2.613c.929 0 1.682-.753 1.682-1.682V5.58h2.783a.7.7 0 0 1 .682.716v4.294a4.197 4.197 0 0 1-4.093 4.293c-1.618-.04-3-.99-3.667-2.35Zm10.737-9.372a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0Zm-2.238 9.488c-.04 0-.08 0-.12-.002a5.19 5.19 0 0 0 .381-2.07V6.306a1.692 1.692 0 0 0-.15-.725h1.792c.39 0 .707.317.707.707v3.765a2.598 2.598 0 0 1-2.598 2.598h-.013Z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M.682 3.349h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 10.853V4.03c0-.377.305-.682.682-.682Zm5.206 2.596v-.72h-3.59v.72h1.357V9.66h.87V5.945h1.363Z" })
    ]
  }
), zU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 10a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Xae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Jae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 10a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), eie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17.293 13.293A8 8 0 0 1 6.707 2.707a8.002 8.002 0 1 0 10.586 10.586Z"
      }
    )
  }
), tie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 3a1 1 0 0 0-1.196-.98l-10 2A1 1 0 0 0 6 5v9.114A4.369 4.369 0 0 0 5 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0 0 15 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3Z"
      }
    )
  }
), nie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2H4a2 2 0 0 1-2-2V5Zm3 1h6v4H5V6Zm6 6H5v2h6v-2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 7h1a2 2 0 0 1 2 2v5.5a1.5 1.5 0 0 1-3 0V7Z"
        }
      )
    ]
  }
), rie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2V4Zm3 1h2v2H7V5Zm2 4H7v2h2V9Zm2-4h2v2h-2V5Zm2 4h-2v2h2V9Z",
        clipRule: "evenodd"
      }
    )
  }
), aie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17.447 10.894a1 1 0 0 0 0-1.788l-14-7a1 1 0 0 0-1.409 1.169l1.429 5A1 1 0 0 0 4.429 9H9a1 1 0 1 1 0 2H4.429a1 1 0 0 0-.962.725l-1.429 5a1 1 0 0 0 1.41 1.17l14-7Z"
      }
    )
  }
), iie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a3 3 0 0 0-3 3v4a5 5 0 0 0 10 0V7a1 1 0 1 1 2 0v4a7 7 0 1 1-14 0V7a5 5 0 0 1 10 0v4a3 3 0 1 1-6 0V7a1 1 0 0 1 2 0v4a1 1 0 1 0 2 0V7a3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), lie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5Zm8 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), oie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM7 8a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0V8Zm5-1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13.586 3.586a2 2 0 1 1 2.828 2.828l-.793.793-2.828-2.828.793-.793Zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379-2.83-2.828Z"
      }
    )
  }
), sie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.414 2.586a2 2 0 0 0-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 0 0 0-2.828Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h4a1 1 0 0 1 0 2H4v10h10v-4a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), cie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
      }
    )
  }
), fie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.414 7 3.293-3.293a1 1 0 0 0-1.414-1.414L13 5.586V4a1 1 0 1 0-2 0v4.003a.996.996 0 0 0 .617.921A.997.997 0 0 0 12 9h4a1 1 0 1 0 0-2h-1.586Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      )
    ]
  }
), die = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.707 3.293a1 1 0 0 1 0 1.414L15.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 0 1 1.414-1.414L14 4.586l1.293-1.293a1 1 0 0 1 1.414 0Z"
        }
      )
    ]
  }
), hie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.924 2.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 17 2h-4a1 1 0 1 0 0 2h1.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L16 5.414V7a1 1 0 1 0 2 0V3a.997.997 0 0 0-.076-.383Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      )
    ]
  }
), vie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm12 12H4l4-8 3 6 2-4 3 6Z",
        clipRule: "evenodd"
      }
    )
  }
), pie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M16.14 11.572c1.311-.706 1.311-2.588 0-3.294L6.756 3.226C5.511 2.556 4 3.458 4 4.873v10.104c0 1.415 1.511 2.318 2.757 1.647l9.382-5.052Z"
      }
    )
  }
), mie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9.555 7.168A1 1 0 0 0 8 8v4a1 1 0 0 0 1.555.832l3-2a1 1 0 0 0 0-1.664l-3-2Z",
        clipRule: "evenodd"
      }
    )
  }
), gie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), wie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-11a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V7Z",
        clipRule: "evenodd"
      }
    )
  }
), yie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2H3Zm11 4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V7Zm-3 1a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V8ZM8 9a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Sie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2H3Zm11.707 4.707a1 1 0 0 0-1.414-1.414L10 9.586 8.707 8.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414L8 10.414l1.293 1.293a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Cie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4v3H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2Zm8 0H7v3h6V4Zm0 8H7v4h6v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), bie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 3.5a1.5 1.5 0 0 1 3 0V4a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.5a1.5 1.5 0 0 0 0 3h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-.5a1.5 1.5 0 0 0-3 0v.5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1h-.5a1.5 1.5 0 0 1 0-3H4a1 1 0 0 0 1-1V6a1 1 0 0 1 1-1h3a1 1 0 0 0 1-1v-.5Z"
      }
    )
  }
), _ie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm2 2V5h1v1H5Zm-2 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3Zm2 2v-1h1v1H5Zm8-12a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-3Zm1 2v1h1V5h-1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 4a1 1 0 1 0-2 0v1a1 1 0 0 0 2 0V4Zm-1 3a1 1 0 0 1 1 1v1h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm6 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2v2a1 1 0 1 1-2 0v-3Zm-2-2a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h3Zm10 2a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1Zm-1 4a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2h3Z"
        }
      )
    ]
  }
), Rie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-3a1 1 0 0 0-.867.5 1 1 0 1 1-1.731-1A3 3 0 0 1 13 8a3.001 3.001 0 0 1-2 2.83V11a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1 1 1 0 1 0 0-2Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Eie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2H5Zm4.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L8.414 9H10a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0v-1a5 5 0 0 0-5-5H8.414l1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Mie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: t.color,
        fillRule: "evenodd",
        d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2H5Zm2.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm6.207.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414ZM12.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        clipRule: "evenodd"
      }
    )
  }
), Tie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2a1 1 0 0 1 1 1v2.101a7.002 7.002 0 0 1 11.601 2.566 1 1 0 1 1-1.885.666A5.002 5.002 0 0 0 5.999 7H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm.008 9.057a1 1 0 0 1 1.276.61A5.002 5.002 0 0 0 14.001 13H11a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.101a7.002 7.002 0 0 1-11.601-2.566 1 1 0 0 1 .61-1.276Z",
        clipRule: "evenodd"
      }
    )
  }
), Oie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 3.293a1 1 0 0 1 0 1.414L5.414 7H11a7 7 0 0 1 7 7v2a1 1 0 1 1-2 0v-2a5 5 0 0 0-5-5H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Die = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.445 14.832A1 1 0 0 0 10 14v-2.798l5.445 3.63A1 1 0 0 0 17 14V6a1 1 0 0 0-1.555-.832L10 8.798V6a1 1 0 0 0-1.555-.832l-6 4a1 1 0 0 0 0 1.664l6 4Z"
      }
    )
  }
), jie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 3a1 1 0 0 0 0 2c5.523 0 10 4.477 10 10a1 1 0 1 0 2 0C17 8.373 11.627 3 5 3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 9a1 1 0 0 1 1-1 7 7 0 0 1 7 7 1 1 0 1 1-2 0 5 5 0 0 0-5-5 1 1 0 0 1-1-1Zm-1 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
        }
      )
    ]
  }
), Aie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.707 10.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V6h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5v5.586l-1.293-1.293ZM9 4a1 1 0 0 1 2 0v2H9V4Z"
      }
    )
  }
), kie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 8.586V5h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3v3.586L9.707 7.293ZM11 3a1 1 0 1 1 2 0v2h-2V3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2H7a3 3 0 0 1-3-3V9Z"
        }
      )
    ]
  }
), Lie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a1 1 0 0 1 1 1v1.323l3.954 1.582 1.599-.8a1 1 0 1 1 .894 1.79l-1.233.616 1.738 5.42a1 1 0 0 1-.285 1.05A3.989 3.989 0 0 1 15 15a3.989 3.989 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 0 1-.285 1.05A3.989 3.989 0 0 1 5 15a3.989 3.989 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.738-5.42-1.233-.617a1 1 0 0 1 .894-1.788l1.599.799L9 4.323V3a1 1 0 0 1 1-1Zm-5 8.274-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274Zm10 0-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274Z",
        clipRule: "evenodd"
      }
    )
  }
), Iie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 2a3.5 3.5 0 1 0 1.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 1 0 1.414 1.414l8.128-8.127a1 1 0 0 0-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 0 0 5.5 2ZM4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.828 11.414a1 1 0 0 0-1.414 1.414l3.879 3.88a1 1 0 0 0 1.414-1.415l-3.879-3.879Z"
        }
      )
    ]
  }
), LT = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z",
        clipRule: "evenodd"
      }
    )
  }
), Hie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M9 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a4 4 0 0 0-3.446 6.032l-2.261 2.26a1 1 0 1 0 1.414 1.415l2.261-2.261A4 4 0 1 0 11 5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Zie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.27 2.164c.47-.219.99-.219 1.46 0l6.885 3.203c.513.239.513 1.108 0 1.347L10.73 9.917c-.47.218-.99.218-1.46 0L2.385 6.714c-.513-.24-.513-1.108 0-1.347L9.27 2.164Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m3.527 8.87-1.142.53c-.513.24-.513 1.108 0 1.348L9.27 13.95c.47.219.99.219 1.46 0l6.885-3.202c.513-.24.513-1.109 0-1.348l-1.142-.53-5.743 2.671c-.47.218-.99.218-1.46 0L3.527 8.87Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.385 13.286 1.142-.53 5.743 2.671c.47.219.99.219 1.46 0l5.743-2.672 1.142.531c.513.24.513 1.109 0 1.347l-6.885 3.203c-.47.219-.99.219-1.46 0l-6.885-3.203c-.513-.238-.513-1.108 0-1.347Z"
        }
      )
    ]
  }
), IT = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 1 .707.293l3 3a1 1 0 0 1-1.414 1.414L10 5.414 7.707 7.707a1 1 0 0 1-1.414-1.414l3-3A1 1 0 0 1 10 3Zm-3.707 9.293a1 1 0 0 1 1.414 0L10 14.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Pie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2Zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Nie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15 8a3 3 0 1 0-2.977-2.63l-4.94 2.47a3 3 0 1 0 0 4.319l4.94 2.47a3 3 0 1 0 .895-1.789l-4.94-2.47a3.027 3.027 0 0 0 0-.74l4.94-2.47C13.456 7.68 14.19 8 15 8Z"
      }
    )
  }
), Vie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.166 4.999A11.954 11.954 0 0 0 10 1.944 11.954 11.954 0 0 0 17.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001Zm11.541 3.708a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Bie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.944A11.954 11.954 0 0 1 2.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0 1 10 1.944ZM11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-7a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V7Z",
        clipRule: "evenodd"
      }
    )
  }
), Fie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a4 4 0 0 0-4 4v1H5a1 1 0 0 0-.994.89l-1 9A1 1 0 0 0 4 18h12a1 1 0 0 0 .994-1.11l-1-9A1 1 0 0 0 15 7h-1V6a4 4 0 0 0-4-4Zm2 5V6a2 2 0 1 0-4 0v1h4Zm-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), Uie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15.833 3c-.644 0-1.166.522-1.166 1.167v11.666a1.167 1.167 0 1 0 2.333 0V4.167C17 3.522 16.478 3 15.833 3Zm-3.351 5.47a1.867 1.867 0 0 1 0 3.06l-6.545 4.58C4.7 16.978 3 16.093 3 14.582V5.42c0-1.51 1.7-2.396 2.937-1.53l6.545 4.582Z"
      }
    )
  }
), Yie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.167 17c.644 0 1.166-.522 1.166-1.167V4.167a1.167 1.167 0 1 0-2.333 0v11.666C3 16.478 3.522 17 4.167 17Zm3.351-5.47a1.867 1.867 0 0 1 0-3.06l6.545-4.58C15.3 3.022 17 3.907 17 5.418v9.162c0 1.51-1.7 2.396-2.937 1.53l-6.545-4.582Z"
      }
    )
  }
), $ie = ({ size: e = "1em", fill: t, ...a }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    ...a,
    children: [
      /* @__PURE__ */ f.jsxs("g", { id: "Slack logo", clipPath: "url(#clip0_10939_406962)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path2",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.44434 10.0775C4.44434 9.14544 5.14913 8.39508 6.02458 8.39508C6.90004 8.39508 7.60483 9.14544 7.60483 10.0775V14.2188C7.60483 15.1509 6.90004 15.9013 6.02458 15.9013C5.14913 15.9013 4.44434 15.1509 4.44434 14.2188V10.0775Z",
            fill: t ?? "#E01E5A",
            stroke: "#E01E5A",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path4",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0774 11.5556C9.14538 11.5556 8.39502 10.8508 8.39502 9.97533C8.39502 9.09987 9.14538 8.39508 10.0774 8.39508H14.2188C15.1508 8.39508 15.9012 9.09987 15.9012 9.97533C15.9012 10.8508 15.1508 11.5556 14.2188 11.5556H10.0774Z",
            fill: t ?? "#ECB22D",
            stroke: "#ECB22D",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path6",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.39502 1.78116C8.39502 0.849115 9.09981 0.0987549 9.97527 0.0987549C10.8507 0.0987549 11.5555 0.849115 11.5555 1.78116V5.9225C11.5555 6.85457 10.8507 7.60493 9.97527 7.60493C9.09981 7.60493 8.39502 6.85457 8.39502 5.9225V1.78116Z",
            fill: t ?? "#2FB67C",
            stroke: "#2FB67C",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path8",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.78104 7.60495C0.848993 7.60495 0.0986328 6.90016 0.0986328 6.0247C0.0986328 5.14925 0.848993 4.44446 1.78104 4.44446H5.92237C6.85444 4.44446 7.6048 5.14925 7.6048 6.0247C7.6048 6.90016 6.85444 7.60495 5.92237 7.60495H1.78104Z",
            fill: t ?? "#36C5F1",
            stroke: "#36C5F1",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsxs("g", { id: "g18", children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path10",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.39502 14.321C8.39458 14.5286 8.43515 14.7343 8.51441 14.9262C8.59367 15.1182 8.71005 15.2925 8.85688 15.4394C9.00371 15.5862 9.17809 15.7026 9.37001 15.7818C9.56194 15.8611 9.76762 15.9017 9.97527 15.9012C10.8507 15.9012 11.5555 15.1964 11.5555 14.321C11.556 14.1133 11.5154 13.9076 11.4361 13.7157C11.3569 13.5238 11.2405 13.3494 11.0937 13.2026C10.9468 13.0558 10.7725 12.9394 10.5805 12.8601C10.3886 12.7809 10.1829 12.7403 9.97527 12.7407H8.39502V14.321Z",
              fill: t ?? "#ECB22D",
              stroke: "#ECB22D",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path12",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.321 7.60495H12.7407V6.0247C12.7407 5.14925 13.4455 4.44446 14.321 4.44446C15.1964 4.44446 15.9012 5.14925 15.9012 6.0247C15.9012 6.90016 15.1964 7.60495 14.321 7.60495Z",
              fill: t ?? "#2FB67C",
              stroke: "#2FB67C",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path14",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.67888 8.39508H3.25913V9.97533C3.25913 10.8508 2.55434 11.5556 1.67888 11.5556C1.47124 11.556 1.26555 11.5154 1.07363 11.4362C0.881701 11.3569 0.70732 11.2405 0.560493 11.0937C0.413665 10.9469 0.297282 10.7725 0.218024 10.5806C0.138766 10.3887 0.0981937 10.183 0.0986364 9.97533C0.0986364 9.09987 0.803426 8.39508 1.67888 8.39508Z",
              fill: t ?? "#E01E5A",
              stroke: "#E01E5A",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path16",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.60483 1.67901V3.25925H6.02459C5.81694 3.25969 5.61125 3.21912 5.41933 3.13986C5.2274 3.06061 5.05302 2.94422 4.9062 2.7974C4.75937 2.65057 4.64298 2.47619 4.56373 2.28426C4.48447 2.09234 4.4439 1.88665 4.44434 1.67901C4.44434 0.803548 5.14913 0.0987585 6.02459 0.0987585C6.23223 0.0983158 6.43792 0.138888 6.62984 0.218146C6.82177 0.297404 6.99615 0.413787 7.14298 0.560615C7.2898 0.707442 7.40619 0.881823 7.48544 1.07375C7.5647 1.26567 7.60528 1.47136 7.60483 1.67901Z",
              fill: t ?? "#36C5F1",
              stroke: "#36C5F1",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_10939_406962", children: /* @__PURE__ */ f.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), Wie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), zie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm0 4a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H3Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H3Zm10 5a1 1 0 1 0 2 0v-5.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L13 10.414V16Z"
      }
    )
  }
), qie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm0 4a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2H3Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H3Zm12-3a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
      }
    )
  }
), Gie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1Zm0 10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H6v1a1 1 0 1 1-2 0v-1H3a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Zm7-10a1 1 0 0 1 .967.744L14.146 7.2 17.5 9.134a1 1 0 0 1 0 1.732l-3.354 1.935-1.18 4.455a1 1 0 0 1-1.933 0L9.854 12.8 6.5 10.866a1 1 0 0 1 0-1.732l3.354-1.935 1.18-4.455A1 1 0 0 1 12 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Kie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 3a1 1 0 0 0-1.447-.894L8.763 6H5a3 3 0 0 0 0 6h.28l1.771 5.316A1 1 0 0 0 8 18h1a1 1 0 0 0 1-1v-4.382l6.553 3.276A1 1 0 0 0 18 15V3Z"
      }
    )
  }
), Qie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.049 3.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 0 0 .95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 0 0-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.539 1.118l-2.8-2.034a1 1 0 0 0-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 0 0-.364-1.118L2.98 9.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 0 0 .951-.69l1.07-3.292Z"
      }
    )
  }
), Xie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 0 0 1.415-1.414l-.675-.675a9.001 9.001 0 0 0-.668-11.982A1 1 0 1 0 14.95 5.05a7.002 7.002 0 0 1 .657 9.143l-1.435-1.435a5.002 5.002 0 0 0-.636-6.294A1 1 0 0 0 12.12 7.88a3 3 0 0 1 .587 3.415l-1.992-1.992a.922.922 0 0 0-.018-.018l-6.99-6.991Zm-.469 5.894a1 1 0 0 0-1.933-.516 9 9 0 0 0 2.331 8.693 1 1 0 0 0 1.414-1.415 6.997 6.997 0 0 1-1.812-6.762ZM7.4 11.5a1 1 0 1 0-1.73 1c.214.371.48.72.795 1.035a1 1 0 0 0 1.414-1.414c-.191-.191-.35-.4-.478-.622Z"
      }
    )
  }
), Jie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.05 3.636a1 1 0 0 1 0 1.414 7 7 0 0 0 0 9.9 1 1 0 1 1-1.414 1.414 9 9 0 0 1 0-12.728 1 1 0 0 1 1.414 0Zm9.9 0a1 1 0 0 1 1.414 0 9 9 0 0 1 0 12.728 1 1 0 1 1-1.414-1.414 7 7 0 0 0 0-9.9 1 1 0 0 1 0-1.414ZM7.879 6.464a1 1 0 0 1 0 1.414 3 3 0 0 0 0 4.243 1 1 0 1 1-1.414 1.414 5 5 0 0 1 0-7.07 1 1 0 0 1 1.414 0Zm4.242 0a1 1 0 0 1 1.415 0 5 5 0 0 1 0 7.072 1 1 0 0 1-1.415-1.415 3 3 0 0 0 0-4.242 1 1 0 0 1 0-1.415ZM10.001 9a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ele = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H8Z",
        clipRule: "evenodd"
      }
    )
  }
), tle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.464 4.95.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 1.414Zm2.121-10.607a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0ZM17 11a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2h1Zm-7 4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1ZM5.05 6.464A1 1 0 1 0 6.465 5.05l-.708-.707a1 1 0 0 0-1.414 1.414l.707.707Zm1.414 8.486-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 1.414ZM4 11a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2h1Z"
      }
    )
  }
), nle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 0 0 .078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10Zm-5.165 3.913 1.58 1.58A5.98 5.98 0 0 1 10 16a5.978 5.978 0 0 1-2.516-.552l1.562-1.562a4.007 4.007 0 0 0 1.789.027Zm-4.677-2.796a4.002 4.002 0 0 1-.041-2.08l-.08.079-1.53-1.532A5.98 5.98 0 0 0 4 10c0 .954.223 1.856.619 2.656l1.54-1.539Zm1.088-6.45A5.974 5.974 0 0 1 10 4c.954 0 1.856.223 2.656.619l-1.539 1.54a4.002 4.002 0 0 0-2.346.033L7.246 4.668ZM12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rle = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 5a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L13.586 5H8Zm4 10a1 1 0 1 0 0-2H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 15H12Z"
      }
    )
  }
), ale = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 12a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L5 6.414V12Zm10-4a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
      }
    )
  }
), ile = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm-1 9v-1h5v2H5a1 1 0 0 1-1-1Zm7 1h4a1 1 0 0 0 1-1v-1h-5v2Zm0-4h5V8h-5v2ZM9 8H4v2h5V8Z",
        clipRule: "evenodd"
      }
    )
  }
), lle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.707 9.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7A.997.997 0 0 1 2 10V5a3 3 0 0 1 3-3h5c.256 0 .512.098.707.293l7 7ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), ole = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm0 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6Zm11-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), ule = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm3.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L7.586 10 5.293 7.707a1 1 0 0 1 0-1.414ZM11 12a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
        clipRule: "evenodd"
      }
    )
  }
), sle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 9.5a1.5 1.5 0 1 1-3 0v-6a1.5 1.5 0 0 1 3 0v6Zm-4 .167v-5.43a2 2 0 0 0-1.105-1.79l-.05-.025A4 4 0 0 0 11.055 2H5.64a2 2 0 0 0-1.962 1.608l-1.2 6A2 2 0 0 0 4.44 12H8v4a2 2 0 0 0 2 2 1 1 0 0 0 1-1v-.667a4 4 0 0 1 .8-2.4l1.4-1.866a4 4 0 0 0 .8-2.4Z"
      }
    )
  }
), cle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 10.5a1.5 1.5 0 1 1 3 0v6a1.5 1.5 0 0 1-3 0v-6Zm4-.167v5.43a2 2 0 0 0 1.106 1.79l.05.025A4 4 0 0 0 8.943 18h5.416a2 2 0 0 0 1.962-1.608l1.2-6A2 2 0 0 0 15.56 8H12V4a2 2 0 0 0-2-2 1 1 0 0 0-1 1v.667a4 4 0 0 1-.8 2.4L6.8 7.933a4 4 0 0 0-.8 2.4Z"
      }
    )
  }
), fle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4V6Z"
      }
    )
  }
), dle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 14 14",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3999 3.49998C1.3999 2.72678 2.0267 2.09998 2.7999 2.09998H11.1999C11.9731 2.09998 12.5999 2.72678 12.5999 3.49998C12.5999 4.27317 11.9731 4.89998 11.1999 4.89998H2.7999C2.0267 4.89998 1.3999 4.27317 1.3999 3.49998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3999 6.99998C1.3999 6.22678 2.0267 5.59998 2.7999 5.59998H4.1999C4.9731 5.59998 5.5999 6.22678 5.5999 6.99998C5.5999 7.77317 4.9731 8.39997 4.1999 8.39997H2.7999C2.0267 8.39997 1.3999 7.77317 1.3999 6.99998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.2999 6.99998C6.2999 6.22678 6.9267 5.59998 7.6999 5.59998C8.4731 5.59998 9.0999 6.22678 9.0999 6.99998C9.0999 7.77317 8.4731 8.39997 7.6999 8.39997C6.9267 8.39997 6.2999 7.77317 6.2999 6.99998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.7999 6.29998C9.7999 5.91338 10.1133 5.59998 10.4999 5.59998C10.8865 5.59998 11.1999 5.91338 11.1999 6.29998V7.69998C11.1999 8.08657 10.8865 8.39997 10.4999 8.39997C10.1133 8.39997 9.7999 8.08657 9.7999 7.69998V6.29998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.1499 10.5C3.1499 9.72678 3.7767 9.09997 4.5499 9.09997H9.4499C10.2231 9.09997 10.8499 9.72678 10.8499 10.5C10.8499 11.2732 10.2231 11.9 9.4499 11.9H4.5499C3.7767 11.9 3.1499 11.2732 3.1499 10.5Z"
        }
      )
    ]
  }
), hle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2H9.578a18.87 18.87 0 0 1-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 1 1-1.44 1.389 21.034 21.034 0 0 1-.554-.6 19.098 19.098 0 0 1-3.107 3.567 1 1 0 0 1-1.334-1.49 17.087 17.087 0 0 0 3.13-3.733 18.992 18.992 0 0 1-1.487-2.494 1 1 0 1 1 1.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 1 1 0-2h3V3a1 1 0 0 1 1-1Zm6 6a1 1 0 0 1 .894.553l2.991 5.982a.869.869 0 0 1 .02.037l.99 1.98a1 1 0 1 1-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 1 1-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0 1 13 8Zm-1.382 6h2.764L13 11.236 11.618 14Z",
        clipRule: "evenodd"
      }
    )
  }
), vle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 0-.894.553L7.382 4H4a1 1 0 0 0 0 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 1 0 0-2h-3.382l-.724-1.447A1 1 0 0 0 11 2H9ZM7 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V8Zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ple = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 13a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v2.586l-4.293-4.293a1 1 0 0 0-1.414 0L8 9.586 3.707 5.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0L11 9.414 14.586 13H12Z",
        clipRule: "evenodd"
      }
    )
  }
), mle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 7a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8.414l-4.293 4.293a1 1 0 0 1-1.414 0L8 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0L11 10.586 14.586 7H12Z",
        clipRule: "evenodd"
      }
    )
  }
), gle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.05a2.5 2.5 0 0 1 4.9 0H10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Zm11 3a1 1 0 0 0-1 1v6.05A2.5 2.5 0 0 1 15.95 16H17a1 1 0 0 0 1-1v-5a1 1 0 0 0-.293-.707l-2-2A1 1 0 0 0 15 7h-1Z"
        }
      )
    ]
  }
), wle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM6.293 6.707a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), yle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-7 9a7 7 0 1 1 14 0H3Z"
      }
    )
  }
), xle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 1 6 6H2a6 6 0 0 1 6-6Zm8-4a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V7Z"
      }
    )
  }
), Sle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 4a5 5 0 0 0-4.546 2.916A5.986 5.986 0 0 0 10 16a5.986 5.986 0 0 0 4.546-2.084A5 5 0 0 0 10 11Z",
        clipRule: "evenodd"
      }
    )
  }
), Cle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-4 7a4 4 0 0 0-8 0v3h8v-3ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 10v-3a5.972 5.972 0 0 0-.75-2.906A3.005 3.005 0 0 1 19 15v3h-3ZM4.75 12.094A5.973 5.973 0 0 0 4 15v3H1v-3a3 3 0 0 1 3.75-2.906Z"
      }
    )
  }
), ble = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 11a6 6 0 0 0-12 0h12Zm-1-9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
      }
    )
  }
), _le = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm8 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-4.07 11c.046-.327.07-.66.07-1a6.97 6.97 0 0 0-1.5-4.33A5 5 0 0 1 19 16v1h-6.07ZM6 11a5 5 0 0 1 5 5v1H1v-1a5 5 0 0 1 5-5Z"
      }
    )
  }
), Rle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.649 3.084A1 1 0 0 1 5.163 4.4 13.95 13.95 0 0 0 4 10c0 1.993.416 3.886 1.164 5.6a1 1 0 0 1-1.832.8A15.95 15.95 0 0 1 2 10c0-2.274.475-4.44 1.332-6.4a1 1 0 0 1 1.317-.516ZM12.961 7a3 3 0 0 0-2.342 1.126l-.328.41-.111-.279A2 2 0 0 0 8.323 7H8a1 1 0 0 0 0 2h.323l.532 1.33-1.035 1.295a1 1 0 0 1-.781.375H7a1 1 0 1 0 0 2h.039a3 3 0 0 0 2.342-1.126l.328-.41.111.279A2 2 0 0 0 11.677 14H12a1 1 0 1 0 0-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0 1 12.961 9H13a1 1 0 1 0 0-2h-.039Zm1.874-2.6a1 1 0 0 1 1.833-.8A15.95 15.95 0 0 1 18 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 1 1-1.832-.8A13.949 13.949 0 0 0 16 10c0-1.993-.416-3.886-1.165-5.6Z"
      }
    )
  }
), Ele = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm12.553 1.106A1 1 0 0 0 14 8v4a1 1 0 0 0 .553.894l2 1A1 1 0 0 0 18 13V7a1 1 0 0 0-1.447-.894l-2 1Z"
      }
    )
  }
), Mle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4Zm6 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4Zm7-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), Tle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H5Zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm0 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2Z"
      }
    )
  }
), Ole = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H5Zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm3 6a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
      }
    )
  }
), Dle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), jle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217Zm2.91 4.217a1 1 0 0 1 1.414 0L15 8.586l1.293-1.293a1 1 0 1 1 1.414 1.414L16.414 10l1.293 1.293a1 1 0 0 1-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Ale = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217Zm5.274-.147a1 1 0 0 1 1.414 0A9.972 9.972 0 0 1 19 10a9.972 9.972 0 0 1-2.929 7.071 1 1 0 0 1-1.414-1.414A7.971 7.971 0 0 0 17 10a7.97 7.97 0 0 0-2.343-5.657 1 1 0 0 1 0-1.414Zm-2.829 2.828a1 1 0 0 1 1.415 0A5.983 5.983 0 0 1 15 10a5.984 5.984 0 0 1-1.757 4.243 1 1 0 0 1-1.415-1.415A3.984 3.984 0 0 0 13 10a3.983 3.983 0 0 0-1.172-2.828 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), kle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 0 1 .808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 0 1-1.414 1.414ZM14.95 11.05a7 7 0 0 0-9.9 0 1 1 0 0 1-1.414-1.414 9 9 0 0 1 12.728 0 1 1 0 0 1-1.414 1.414Zm-2.83 2.83a3 3 0 0 0-4.242 0 1 1 0 0 1-1.415-1.415 5 5 0 0 1 7.072 0 1 1 0 0 1-1.415 1.415ZM9 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Bx = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0L10 8.586l4.293-4.293a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L8.586 10 4.293 5.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Fx = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.707 7.293a1 1 0 0 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L10 8.586 8.707 7.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Lle = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 8a1 1 0 0 1 1-1h1V6a1 1 0 0 1 2 0v1h1a1 1 0 1 1 0 2H9v1a1 1 0 1 1-2 0V9H6a1 1 0 0 1-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Zm6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ile = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var qU = Yi({ defaultClassName: "_1gg22ys2", variantClassNames: { kind: { info: "_1gg22ys3", error: "_1gg22ys4", warning: "_1gg22ys5" }, border: { true: "_1gg22ys6 _1gg22ys0 _1faqfmvf9 _1faqfmv6", false: "_1gg22ys7 _1gg22ys1" } }, defaultVariants: { kind: "info", border: !0 }, compoundVariants: [] });
const GU = {
  error: uh.theme.static.surface.sentiment.bad,
  info: uh.theme.static.surface.sentiment.neutral,
  warning: uh.theme.static.surface.sentiment.caution
}, KU = {
  error: uh.theme.static.content.sentiment.bad,
  info: uh.theme.static.content.weak,
  warning: uh.theme.static.content.sentiment.caution
}, Hle = ({
  children: e,
  kind: t = "info",
  title: a,
  icon: l,
  border: h,
  style: g = {},
  width: m,
  handleCloseClick: S
}) => {
  const b = l || QU[t];
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      p: "8",
      gap: "8",
      display: "flex",
      alignItems: "flex-start",
      borderRadius: "8",
      border: "secondary",
      cssClass: qU({ kind: t, border: h }),
      justifyContent: "space-between",
      style: {
        ...g,
        width: m || "auto"
      },
      children: [
        l !== !1 && /* @__PURE__ */ f.jsx(
          ct,
          {
            alignItems: "center",
            alignSelf: "flex-start",
            borderRadius: "5",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            style: {
              backgroundColor: GU[t],
              height: 22,
              width: 22
            },
            children: /* @__PURE__ */ f.jsx(b, { size: 14, color: KU[t] })
          }
        ),
        /* @__PURE__ */ f.jsxs(ct, { gap: "16", display: "flex", flexDirection: "column", width: "full", children: [
          a && /* @__PURE__ */ f.jsxs(ct, { display: "flex", position: "relative", children: [
            /* @__PURE__ */ f.jsx(ct, { mt: "6", children: /* @__PURE__ */ f.jsx(Yr, { color: "strong", weight: "bold", size: "small", children: a }) }),
            S && /* @__PURE__ */ f.jsx(
              ct,
              {
                flexShrink: 0,
                style: { position: "absolute", right: "0" },
                children: /* @__PURE__ */ f.jsx(
                  d3,
                  {
                    kind: "secondary",
                    emphasis: "low",
                    shape: "square",
                    size: "minimal",
                    icon: /* @__PURE__ */ f.jsx(Bx, { size: 16 }),
                    onClick: S
                  }
                )
              }
            )
          ] }),
          e
        ] })
      ]
    }
  );
}, QU = {
  error: Fx,
  info: $U,
  warning: YU
};
var XU = Yi({ defaultClassName: "_1kudzuf6", variantClassNames: { size: { small: "_1kudzuf7 _1kudzuf0 _1faqfmv2o", medium: "_1kudzuf8 _1kudzuf1 _1faqfmv2t", large: "_1kudzuf9 _1kudzuf2 _1faqfmv2u" }, border: { none: "_1kudzufa", primary: "_1kudzufb _1kudzuf3 _1faqfmvez", secondary: "_1kudzufc _1kudzuf4 _1faqfmvf9" }, rounded: { true: "_1kudzufd _1kudzuf5 _1faqfmv5", false: "_1kudzufe" } }, defaultVariants: { border: "secondary", rounded: !0, size: "medium" }, compoundVariants: [] });
const Zle = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(ct, { cssClass: XU({ ...t }), children: e });
var JU = "_45t5730", eY = "_45t5731", tY = Yk({ conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "desktop", "wide"], responsiveArray: void 0 }, styles: { flex: { values: { 1: { conditions: { mobile: "_45t5732", tablet: "_45t5733", desktop: "_45t5734", wide: "_45t5735" }, defaultClass: "_45t5732" }, 2: { conditions: { mobile: "_45t5736", tablet: "_45t5737", desktop: "_45t5738", wide: "_45t5739" }, defaultClass: "_45t5736" }, 3: { conditions: { mobile: "_45t573a", tablet: "_45t573b", desktop: "_45t573c", wide: "_45t573d" }, defaultClass: "_45t573a" }, 4: { conditions: { mobile: "_45t573e", tablet: "_45t573f", desktop: "_45t573g", wide: "_45t573h" }, defaultClass: "_45t573e" }, 5: { conditions: { mobile: "_45t573i", tablet: "_45t573j", desktop: "_45t573k", wide: "_45t573l" }, defaultClass: "_45t573i" }, 6: { conditions: { mobile: "_45t573m", tablet: "_45t573n", desktop: "_45t573o", wide: "_45t573p" }, defaultClass: "_45t573m" }, 7: { conditions: { mobile: "_45t573q", tablet: "_45t573r", desktop: "_45t573s", wide: "_45t573t" }, defaultClass: "_45t573q" }, 8: { conditions: { mobile: "_45t573u", tablet: "_45t573v", desktop: "_45t573w", wide: "_45t573x" }, defaultClass: "_45t573u" }, 9: { conditions: { mobile: "_45t573y", tablet: "_45t573z", desktop: "_45t57310", wide: "_45t57311" }, defaultClass: "_45t573y" }, 10: { conditions: { mobile: "_45t57312", tablet: "_45t57313", desktop: "_45t57314", wide: "_45t57315" }, defaultClass: "_45t57312" }, 11: { conditions: { mobile: "_45t57316", tablet: "_45t57317", desktop: "_45t57318", wide: "_45t57319" }, defaultClass: "_45t57316" }, 12: { conditions: { mobile: "_45t5731a", tablet: "_45t5731b", desktop: "_45t5731c", wide: "_45t5731d" }, defaultClass: "_45t5731a" }, auto: { conditions: { mobile: "_45t5731e", tablet: "_45t5731f", desktop: "_45t5731g", wide: "_45t5731h" }, defaultClass: "_45t5731e" } } } } }), pR = { mobile: { 0: "_45t5731i", 1: "_45t5731j", 2: "_45t5731k", 3: "_45t5731l", 4: "_45t5731m", 6: "_45t5731n", 7: "_45t5731o", 8: "_45t5731p", 9: "_45t5731q", 10: "_45t5731r", 12: "_45t5731s", 16: "_45t5731t", 20: "_45t5731u", 24: "_45t5731v", 28: "_45t5731w", 32: "_45t5731x", 36: "_45t5731y", 40: "_45t5731z", 44: "_45t57320", 48: "_45t57321" }, tablet: { 0: "_45t57322", 1: "_45t57323", 2: "_45t57324", 3: "_45t57325", 4: "_45t57326", 6: "_45t57327", 7: "_45t57328", 8: "_45t57329", 9: "_45t5732a", 10: "_45t5732b", 12: "_45t5732c", 16: "_45t5732d", 20: "_45t5732e", 24: "_45t5732f", 28: "_45t5732g", 32: "_45t5732h", 36: "_45t5732i", 40: "_45t5732j", 44: "_45t5732k", 48: "_45t5732l" }, desktop: { 0: "_45t5732m", 1: "_45t5732n", 2: "_45t5732o", 3: "_45t5732p", 4: "_45t5732q", 6: "_45t5732r", 7: "_45t5732s", 8: "_45t5732t", 9: "_45t5732u", 10: "_45t5732v", 12: "_45t5732w", 16: "_45t5732x", 20: "_45t5732y", 24: "_45t5732z", 28: "_45t57330", 32: "_45t57331", 36: "_45t57332", 40: "_45t57333", 44: "_45t57334", 48: "_45t57335" }, wide: { 0: "_45t57336", 1: "_45t57337", 2: "_45t57338", 3: "_45t57339", 4: "_45t5733a", 6: "_45t5733b", 7: "_45t5733c", 8: "_45t5733d", 9: "_45t5733e", 10: "_45t5733f", 12: "_45t5733g", 16: "_45t5733h", 20: "_45t5733i", 24: "_45t5733j", 28: "_45t5733k", 32: "_45t5733l", 36: "_45t5733m", 40: "_45t5733n", 44: "_45t5733o", 48: "_45t5733p" } };
const nY = (e) => {
  switch (typeof e) {
    case "object":
      return $k.map(
        (t) => pR[t][e[t]]
      ).join(" ");
    case "string":
      return pR.mobile[e];
    default:
      return "";
  }
}, HT = Sa.createContext({
  gap: "0"
}), rY = ({ children: e, gap: t }) => /* @__PURE__ */ f.jsx(HT.Provider, { value: { gap: t ?? "0" }, children: /* @__PURE__ */ f.jsx(ct, { cssClass: Fr(JU, nY(t)), children: e }) }), aY = ({
  children: e,
  span: t = "auto"
}) => {
  const { gap: a } = Sa.useContext(HT);
  return /* @__PURE__ */ f.jsx(
    ct,
    {
      cssClass: Fr(
        eY,
        tY({ flex: t }),
        Wy({ pl: a, pt: a })
      ),
      children: e
    }
  );
};
aY.Container = rY;
const Ple = X4, h3 = Sa.forwardRef(({ children: e, ...t }, a) => /* @__PURE__ */ f.jsx(iw, { ref: a, ...t, children: e })), iY = ({ children: e, ...t }) => (t.gutter = t.gutter ?? 4, /* @__PURE__ */ f.jsxs(VM, { ...t, children: [
  /* @__PURE__ */ f.jsx(Pp, { size: 0 }),
  e
] })), lY = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(H4, { ...t, children: e }), oY = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(TM, { ...t, children: e }), uY = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(MM, { ...t, children: e });
h3.Popover = iY;
h3.Item = lY;
h3.Group = oY;
h3.GroupLabel = uY;
const Oi = Sa.forwardRef(
  ({
    align: e,
    children: t,
    flex: a,
    justify: l,
    wrap: h,
    width: g,
    as: m = "div",
    gap: S = "16",
    direction: b = "column",
    ...R
  }, D) => (typeof h == "boolean" && (h = h ? "wrap" : void 0), /* @__PURE__ */ f.jsx(
    ct,
    {
      as: m,
      alignItems: e,
      display: "flex",
      flexDirection: b,
      flex: a,
      justifyContent: l,
      gap: S,
      flexWrap: h,
      width: g,
      ref: D,
      ...R,
      children: t
    }
  ))
);
var sY = "_1lamavh0", cY = "_1lamavh1", fY = "_1lamavh2", dY = "_1lamavh3", hY = "_1lamavh4", vY = "_1lamavh5", pY = "_1lamavh6", mY = "_1lamavh7", Zy = "_1lamavh8", mR = "_1lamavh9", gY = "_1lamavha";
const Nle = ({
  label: e,
  icon: t,
  value: a,
  valueRender: l,
  options: h,
  onChange: g,
  onChangeQuery: m,
  onClose: S,
  queryPlaceholder: b,
  cssClass: R,
  wrapperCssClass: D,
  popoverCssClass: T,
  creatableRender: j,
  defaultOpen: A,
  disabled: L,
  loadingRender: P,
  emptyStateRender: N,
  clearable: F
}) => {
  const Y = typeof a == "object", G = X4({
    setValue: (K) => {
      m == null || m(K);
    },
    resetValueOnHide: !0,
    defaultOpen: A
  }), z = Np({
    combobox: G,
    setValue: (K) => {
      g(K), Y && A && G.setOpen(!1);
    },
    value: a
  }), $ = new Set(a), ce = G.useState("value"), X = h === void 0, Ce = ce !== void 0 && ce !== "" && j !== void 0 ? [{ key: ce, render: j(ce) }] : [], ae = Y && j ? a.filter((K) => K !== ce).map((K) => ({ key: K, render: j(K) })) : [], me = Ce.concat(ae).concat(h ?? []);
  return /* @__PURE__ */ f.jsxs("div", { className: Fr(D), children: [
    /* @__PURE__ */ f.jsx(xw, { store: z, className: sY, children: e }),
    /* @__PURE__ */ f.jsx(
      c3,
      {
        store: z,
        className: Fr([
          cY,
          R,
          {
            [fY]: L
          }
        ]),
        disabled: L,
        children: /* @__PURE__ */ f.jsxs(
          Oi,
          {
            direction: "row",
            align: "center",
            justify: "space-between",
            width: "full",
            gap: "2",
            children: [
              /* @__PURE__ */ f.jsxs(ct, { children: [
                t,
                l && /* @__PURE__ */ f.jsx(
                  Yr,
                  {
                    size: "xSmall",
                    color: "secondaryContentText",
                    lines: "1",
                    children: l
                  }
                )
              ] }),
              F && !!a && /* @__PURE__ */ f.jsx(
                d3,
                {
                  icon: /* @__PURE__ */ f.jsx(Fx, {}),
                  onClick: () => g(void 0),
                  size: "xSmall",
                  emphasis: "none",
                  kind: "secondary"
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Sw,
      {
        store: z,
        className: Fr([mY, T]),
        gutter: 4,
        autoFocusOnHide: !1,
        onClose: S,
        children: [
          /* @__PURE__ */ f.jsx(Pp, { size: 0 }),
          m !== void 0 && /* @__PURE__ */ f.jsxs(
            "div",
            {
              className: Fr(hY, {
                [vY]: me.length > 0 || X || !!N
              }),
              children: [
                /* @__PURE__ */ f.jsx(LT, {}),
                /* @__PURE__ */ f.jsx(
                  iw,
                  {
                    store: G,
                    type: "text",
                    autoSelect: !0,
                    autoComplete: "none",
                    placeholder: b,
                    className: dY
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ f.jsxs(
            hx,
            {
              store: G,
              className: Fr([pY, "hide-scrollbar"]),
              children: [
                X && /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: Fr([
                      Zy,
                      mR
                    ]),
                    children: P
                  }
                ),
                N && !X && me.length === 0 && /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: Fr([
                      Zy,
                      mR
                    ]),
                    children: N
                  }
                ),
                z.useState("open") && me.map((K) => /* @__PURE__ */ f.jsx(
                  H4,
                  {
                    focusOnHover: !0,
                    className: Zy,
                    render: /* @__PURE__ */ f.jsxs(yw, { value: K.key, children: [
                      Y && /* @__PURE__ */ f.jsx(
                        "div",
                        {
                          className: gY,
                          style: {
                            backgroundColor: $.has(K.key) ? uh.theme.interactive.fill.primary.enabled : "white"
                          },
                          children: /* @__PURE__ */ f.jsx(Nx, { color: "white" })
                        }
                      ),
                      K.render
                    ] })
                  },
                  K.key
                ))
              ]
            }
          )
        ]
      }
    )
  ] });
};
var wY = "_821rm91", yY = "_821rm92";
const Vle = ({
  children: e,
  centered: t = !0,
  padded: a = !0,
  ...l
}) => /* @__PURE__ */ f.jsx(ct, { cssClass: wY, children: /* @__PURE__ */ f.jsx(
  ct,
  {
    cssClass: yY,
    px: a ? "20" : void 0,
    mx: t ? "auto" : void 0,
    ...l,
    children: e
  }
) }), A0 = (e, t, ...a) => !e || t == null ? /* @__PURE__ */ new Date() : new Date(e, t, ...a), C1 = (e) => ({
  D: e.getDate(),
  M: e.getMonth(),
  Y: e.getFullYear()
}), xY = (e) => e.getDay(), Bi = (e) => A0(C1(e).Y, C1(e).M, C1(e).D), v8 = (e) => A0(C1(e).Y, C1(e).M + 1, 0).getDate(), Rp = (e, t, a) => {
  const { Y: l, M: h, D: g } = C1(e), m = a === "date" ? g + t : a === "month" && g > v8(A0(l, h + t, 1)) ? v8(A0(l, h + t, 1)) : g;
  return A0(l + (a === "year" ? t : 0), h + (a === "month" ? t : 0), m);
}, gR = (e, t, a) => Rp(e, 0 - t, a), ZT = (e, t) => +e - +t, T5 = (e, t, a) => e.toLocaleDateString(t, a), SY = (e, { locale: t, monthName: a }) => T5(e, t, { month: a }), wR = (e, t) => e.concat(t).sort(ZT), yR = (e, t, a) => {
  let [l, h] = [e, t];
  return e && t && ([l, h] = [e, t].sort(a)), [l, h];
}, CY = (e, t) => t ? t.includes(e) : !1, bY = (e, t = []) => {
  const { M: a, D: l } = C1(e);
  return t.some((h) => {
    const { M: g, D: m } = C1(h);
    return a === g && l === m;
  });
}, _Y = (e, { day: t, date: a } = {}) => CY(e.getDay(), t) || bY(e, a);
var RY = 42;
function xR(e, t) {
  return (xY(e) + 7 - t) % 7;
}
function EY(e, t, { mode: a, startDay: l }) {
  const h = A0(t, e, 1), g = v8(h), m = xR(h, l), S = a === "static" ? RY : m + g + 6 - xR(A0(t, e, g), l);
  return {
    start: m,
    length: S
  };
}
const ku = (e, t) => +e == +t, O5 = (e, t) => e < t, p8 = (e, t) => e > t, SR = (e, t, a) => p8(t, e) && O5(t, a) || O5(t, e) && p8(t, a), P4 = (e, t) => !!e && p8(t, e), N4 = (e, t) => !!e && O5(t, e), Cw = (e, t) => e.some((a) => ku(Bi(a), Bi(t)));
var CR = {
  mode: "static",
  offsets: [0],
  startDay: 0
}, MY = {
  mode: "decade",
  /*
   * The default value for the numberOfYears is 12
   * it consists of 10 years + 1 year before + 1 year after
   */
  numberOfYears: 12,
  step: 10
}, TY = {
  mode: "single",
  toggle: !1,
  selectSameDate: !1
}, OY = {
  interval: 30,
  useLocales: !1
}, DY = {
  locale: "en-GB",
  day: "2-digit",
  year: "numeric",
  weekday: "short",
  monthName: "long",
  hour: "2-digit",
  minute: "2-digit",
  hour12: void 0,
  second: void 0
};
function jY({ selectedDates: e = [], onDatesChange: t, focusDate: a, offsetDate: l, onOffsetChange: h, calendar: g = {}, dates: m = {}, locale: S, time: b = {}, exclude: R = {}, years: D }) {
  const { minDate: T, maxDate: j, ...A } = m, { offsets: L = [], ...P } = g, { minTime: N, maxTime: F, ...Y } = b, [G, z] = yR(T, j, ZT), [$, ce] = yR(N, F, (Ce, ae) => Ce.h - ae.h), X = a && Cw(e, a) ? a : void 0;
  return {
    selectedDates: e,
    onDatesChange: t,
    offsetDate: l,
    onOffsetChange: h,
    focusDate: X,
    calendar: {
      ...CR,
      ...P,
      offsets: CR.offsets.concat(L)
    },
    years: { ...MY, ...D },
    dates: {
      ...TY,
      ...A,
      minDate: G && Bi(G),
      maxDate: z && Bi(z)
    },
    locale: {
      ...DY,
      ...S
    },
    time: {
      ...OY,
      minTime: $,
      maxTime: ce,
      ...Y
    },
    exclude: R
  };
}
function D4(e) {
  return e === "range";
}
const bR = "range-start", _R = "range-end", RR = "will-be-range-start", ER = "will-be-range-end", AY = (e, t, a, l) => {
  if (!D4(l) || a.length === 0)
    return "";
  const [h, g] = a;
  return h && g ? ku(e, Bi(h)) ? ku(Bi(h), Bi(g)) ? `${bR} ${_R}` : bR : ku(e, Bi(g)) ? _R : SR(Bi(h), e, Bi(g)) ? "in-range" : "" : !g && t ? SR(Bi(h), e, t) ? "will-be-in-range" : O5(t, Bi(h)) ? ku(e, t) ? RR : ku(e, Bi(h)) ? ER : "" : ku(e, Bi(h)) ? RR : ku(e, t) ? ER : "" : "";
}, kY = (e, t, a, { rangeEnd: l }, h) => {
  const { dates: { mode: g, minDate: m, maxDate: S }, locale: b, calendar: R, exclude: D } = h, { locale: T, day: j, year: A } = b, { M: L, Y: P } = C1(t), { start: N, length: F } = EY(L, P, R), Y = Array(F).fill(0).map((G, z) => {
    const $ = A0(P, L, z + 1 - N);
    return {
      $date: $,
      active: ku(e, $),
      day: T5($, T, { day: j }),
      now: ku(Bi(A0()), $),
      range: AY($, l, a, g),
      disabled: N4(m, $) || P4(S, $) || _Y($, D),
      selected: Cw(a, $),
      inCurrentMonth: C1($).M === L
    };
  });
  return {
    year: T5(t, T, { year: A }),
    month: SY(t, b),
    days: Y
  };
}, LY = ({ selectedDates: e, state: t, config: a, offsetDate: l }) => a.calendar.offsets.map((h) => kY(l, Rp(l, h, "month"), e, t, a));
var IY = ({ days: e }, { locale: { locale: t, weekday: a } }) => [0, 1, 2, 3, 4, 5, 6].map((l) => T5(e[l].$date, t, { weekday: a }));
const HY = (e) => {
  const t = LY(e);
  return Ur(() => ({
    calendars: t,
    weekDays: IY(t[0], e.config)
  }), [t, e.config]);
}, h5 = (...e) => (...t) => e.forEach((a) => a == null ? void 0 : a(...t)), v5 = (e) => (t, a) => e(a), p5 = (e, t, a = {}, l = !1) => ({
  role: "button",
  tabIndex: 0,
  ...e ? {
    disabled: !0,
    "aria-disabled": !0
  } : {
    onClick(h) {
      t(h);
    }
  },
  ...l ? { "aria-selected": !0 } : {},
  ...a
});
var PT = "SET_FOCUS_DATE", NT = "SET_OFFSET_DATE", VT = "SET_RANGE_END", ZY = "SET_YEAR", PY = (e, t) => {
  switch (t.type) {
    case PT:
      return {
        ...e,
        focusDate: t.date
      };
    case NT:
      return {
        ...e,
        offsetDate: t.date
      };
    case VT:
      return {
        ...e,
        rangeEnd: t.date
      };
    case ZY:
      return {
        ...e,
        offsetYear: t.year
      };
    default:
      return e;
  }
}, MR = (e, t) => {
  e({ type: PT, date: t });
}, NY = (e, t) => {
  e({ type: NT, date: t });
}, TR = (e, t) => {
  e({ type: VT, date: t });
};
const Py = ({ dispatch: e, config: { onOffsetChange: t, offsetDate: a } }) => (l) => {
  !t && !a && NY(e, l), t && t(l);
}, OR = (e, { days: t, months: a, years: l }) => {
  let h = e;
  return t && t !== 0 && (h = Rp(h, t, "date")), a && a !== 0 && (h = Rp(h, a, "month")), l && l !== 0 && (h = Rp(h, l, "year")), h;
}, DR = (e, { days: t = 0, months: a = 0, years: l = 0 }, h) => !h || ku(e, h) ? e : t !== 0 ? Ny(e, h, t, "date") : a !== 0 ? Ny(e, h, a, "month") : l !== 0 ? Ny(e, h, l, "year") : e, Ny = (e, t, a, l) => {
  const h = Rp(e, a, l);
  return a > 0 ? P4(t, h) ? gR(t, a, l) : e : N4(t, h) ? gR(t, a, l) : e;
}, VY = (e) => {
  const { config: { dates: t } } = e, { minDate: a, maxDate: l } = t, h = Ir((S, { disabled: b, onClick: R, ...D } = {}) => {
    const T = DR(e.offsetDate, S, l), j = OR(T, S), A = !!b || P4(l, j);
    return p5(A, (L) => h5(R, v5(Py(e)))(L, j), D);
  }, [l, e]), g = Ir(({ days: S = 0, months: b = 0, years: R = 0 }, { disabled: D, onClick: T, ...j } = {}) => {
    const A = {
      days: -S,
      months: -b,
      years: -R
    }, L = DR(e.offsetDate, A, a), P = OR(L, A), N = !!D || N4(a, P);
    return p5(N, (F) => h5(T, v5(Py(e)))(F, P), j);
  }, [a, e]), m = Ir((S, { disabled: b, onClick: R, ...D } = {}) => {
    const T = !!b || N4(a, S) || P4(l, S);
    return p5(T, (j) => h5(R, v5(Py(e)))(j, S), D);
  }, [e, l, a]);
  return {
    addOffset: h,
    setOffset: m,
    subtractOffset: g
  };
}, BY = (e, t, a) => P4(t, a) ? t : N4(e, a) ? e : a, FY = (e) => e - e % 10 - 1, UY = (e, t) => e - (t / 2 - (t % 2 === 0 ? 1 : 0)), YY = (e, t) => e - t + 1, $Y = (e) => e === "exact", WY = (e, { mode: t, numberOfYears: a }) => $Y(t) ? YY(e, a) : t === "decade" ? FY(e) : UY(e, a), zY = (e) => {
  const { selectedDates: t, offsetDate: a, focusDate: l, dates: { minDate: h, maxDate: g }, years: m } = e, S = a || (t.length > 0 ? t[t.length - 1] : BY(h, g, Bi(A0())));
  return {
    focusDate: l,
    rangeEnd: null,
    offsetDate: S,
    offsetYear: WY(C1(S).Y, m)
  };
}, qY = (e) => {
  const t = jY(e), [a, l] = iE(PY, zY(t));
  return {
    dispatch: l,
    selectedDates: t.selectedDates,
    offsetDate: t.offsetDate || a.offsetDate,
    state: a,
    config: t
  };
}, GY = (e, t, { mode: a, toggle: l, limit: h }) => l && Cw(e, t) ? e.filter((g) => !ku(Bi(g), t)) : a === "multiple" ? !h || e.length < h ? wR(e, t) : e : D4(a) ? e.length === 2 ? [t] : wR(e, t) : [t], KY = ({ config: e, selectedDates: t, dispatch: a }) => {
  const { onDatesChange: l, dates: { mode: h, toggle: g, selectSameDate: m } } = e;
  return { dayButton: Ir(({ $date: b, selected: R, disabled: D, active: T }, { onClick: j, disabled: A, ...L } = {}) => p5(D || !!A, (P) => {
    R && !g && (t.forEach((N) => {
      ku(Bi(N), b) && MR(a, N);
    }), !D4(h) || !m) || (D4(h) && t.length === 1 && TR(a, null), h5(j, v5((N) => {
      const F = GY(t, N, e.dates);
      MR(a, Cw(F, N) ? N : void 0), l(F);
    }))(P, b));
  }, {
    ...L,
    ...D4(h) && t.length === 1 && {
      onMouseEnter() {
        TR(a, b);
      }
    },
    tabIndex: T ? 0 : -1
  }, R), [
    h,
    g,
    e.dates,
    l,
    t,
    a,
    m
  ]) };
};
ka({});
var BT = ka({}), Ux = () => Ui(BT), QY = ({ children: e, config: t }) => Sa.createElement(BT.Provider, { value: qY(t) }, e);
const FT = () => HY(Ux()), XY = () => KY(Ux()), JY = () => VY(Ux());
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var UT;
function Ke() {
  return UT.apply(null, arguments);
}
function e$(e) {
  UT = e;
}
function _1(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function L2(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function or(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Yx(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (or(e, t))
      return !1;
  return !0;
}
function Qo(e) {
  return e === void 0;
}
function vf(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function v3(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function YT(e, t) {
  var a = [], l, h = e.length;
  for (l = 0; l < h; ++l)
    a.push(t(e[l], l));
  return a;
}
function lh(e, t) {
  for (var a in t)
    or(t, a) && (e[a] = t[a]);
  return or(t, "toString") && (e.toString = t.toString), or(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function P0(e, t, a, l) {
  return vO(e, t, a, l, !0).utc();
}
function t$() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function mn(e) {
  return e._pf == null && (e._pf = t$()), e._pf;
}
var m8;
Array.prototype.some ? m8 = Array.prototype.some : m8 = function(e) {
  var t = Object(this), a = t.length >>> 0, l;
  for (l = 0; l < a; l++)
    if (l in t && e.call(this, t[l], l, t))
      return !0;
  return !1;
};
function $x(e) {
  if (e._isValid == null) {
    var t = mn(e), a = m8.call(t.parsedDateParts, function(h) {
      return h != null;
    }), l = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && a);
    if (e._strict && (l = l && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = l;
    else
      return l;
  }
  return e._isValid;
}
function bw(e) {
  var t = P0(NaN);
  return e != null ? lh(mn(t), e) : mn(t).userInvalidated = !0, t;
}
var jR = Ke.momentProperties = [], Vy = !1;
function Wx(e, t) {
  var a, l, h, g = jR.length;
  if (Qo(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Qo(t._i) || (e._i = t._i), Qo(t._f) || (e._f = t._f), Qo(t._l) || (e._l = t._l), Qo(t._strict) || (e._strict = t._strict), Qo(t._tzm) || (e._tzm = t._tzm), Qo(t._isUTC) || (e._isUTC = t._isUTC), Qo(t._offset) || (e._offset = t._offset), Qo(t._pf) || (e._pf = mn(t)), Qo(t._locale) || (e._locale = t._locale), g > 0)
    for (a = 0; a < g; a++)
      l = jR[a], h = t[l], Qo(h) || (e[l] = h);
  return e;
}
function p3(e) {
  Wx(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Vy === !1 && (Vy = !0, Ke.updateOffset(this), Vy = !1);
}
function R1(e) {
  return e instanceof p3 || e != null && e._isAMomentObject != null;
}
function $T(e) {
  Ke.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ms(e, t) {
  var a = !0;
  return lh(function() {
    if (Ke.deprecationHandler != null && Ke.deprecationHandler(null, e), a) {
      var l = [], h, g, m, S = arguments.length;
      for (g = 0; g < S; g++) {
        if (h = "", typeof arguments[g] == "object") {
          h += `
[` + g + "] ";
          for (m in arguments[0])
            or(arguments[0], m) && (h += m + ": " + arguments[0][m] + ", ");
          h = h.slice(0, -2);
        } else
          h = arguments[g];
        l.push(h);
      }
      $T(
        e + `
Arguments: ` + Array.prototype.slice.call(l).join("") + `
` + new Error().stack
      ), a = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var AR = {};
function WT(e, t) {
  Ke.deprecationHandler != null && Ke.deprecationHandler(e, t), AR[e] || ($T(t), AR[e] = !0);
}
Ke.suppressDeprecationWarnings = !1;
Ke.deprecationHandler = null;
function N0(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function n$(e) {
  var t, a;
  for (a in e)
    or(e, a) && (t = e[a], N0(t) ? this[a] = t : this["_" + a] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function g8(e, t) {
  var a = lh({}, e), l;
  for (l in t)
    or(t, l) && (L2(e[l]) && L2(t[l]) ? (a[l] = {}, lh(a[l], e[l]), lh(a[l], t[l])) : t[l] != null ? a[l] = t[l] : delete a[l]);
  for (l in e)
    or(e, l) && !or(t, l) && L2(e[l]) && (a[l] = lh({}, a[l]));
  return a;
}
function zx(e) {
  e != null && this.set(e);
}
var w8;
Object.keys ? w8 = Object.keys : w8 = function(e) {
  var t, a = [];
  for (t in e)
    or(e, t) && a.push(t);
  return a;
};
var r$ = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function a$(e, t, a) {
  var l = this._calendar[e] || this._calendar.sameElse;
  return N0(l) ? l.call(t, a) : l;
}
function H0(e, t, a) {
  var l = "" + Math.abs(e), h = t - l.length, g = e >= 0;
  return (g ? a ? "+" : "" : "-") + Math.pow(10, Math.max(0, h)).toString().substr(1) + l;
}
var qx = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, o5 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, By = {}, Ep = {};
function $t(e, t, a, l) {
  var h = l;
  typeof l == "string" && (h = function() {
    return this[l]();
  }), e && (Ep[e] = h), t && (Ep[t[0]] = function() {
    return H0(h.apply(this, arguments), t[1], t[2]);
  }), a && (Ep[a] = function() {
    return this.localeData().ordinal(
      h.apply(this, arguments),
      e
    );
  });
}
function i$(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function l$(e) {
  var t = e.match(qx), a, l;
  for (a = 0, l = t.length; a < l; a++)
    Ep[t[a]] ? t[a] = Ep[t[a]] : t[a] = i$(t[a]);
  return function(h) {
    var g = "", m;
    for (m = 0; m < l; m++)
      g += N0(t[m]) ? t[m].call(h, e) : t[m];
    return g;
  };
}
function m5(e, t) {
  return e.isValid() ? (t = zT(t, e.localeData()), By[t] = By[t] || l$(t), By[t](e)) : e.localeData().invalidDate();
}
function zT(e, t) {
  var a = 5;
  function l(h) {
    return t.longDateFormat(h) || h;
  }
  for (o5.lastIndex = 0; a >= 0 && o5.test(e); )
    e = e.replace(
      o5,
      l
    ), o5.lastIndex = 0, a -= 1;
  return e;
}
var o$ = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function u$(e) {
  var t = this._longDateFormat[e], a = this._longDateFormat[e.toUpperCase()];
  return t || !a ? t : (this._longDateFormat[e] = a.match(qx).map(function(l) {
    return l === "MMMM" || l === "MM" || l === "DD" || l === "dddd" ? l.slice(1) : l;
  }).join(""), this._longDateFormat[e]);
}
var s$ = "Invalid date";
function c$() {
  return this._invalidDate;
}
var f$ = "%d", d$ = /\d{1,2}/;
function h$(e) {
  return this._ordinal.replace("%d", e);
}
var v$ = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function p$(e, t, a, l) {
  var h = this._relativeTime[a];
  return N0(h) ? h(e, t, a, l) : h.replace(/%d/i, e);
}
function m$(e, t) {
  var a = this._relativeTime[e > 0 ? "future" : "past"];
  return N0(a) ? a(t) : a.replace(/%s/i, t);
}
var j4 = {};
function $l(e, t) {
  var a = e.toLowerCase();
  j4[a] = j4[a + "s"] = j4[t] = e;
}
function Ts(e) {
  return typeof e == "string" ? j4[e] || j4[e.toLowerCase()] : void 0;
}
function Gx(e) {
  var t = {}, a, l;
  for (l in e)
    or(e, l) && (a = Ts(l), a && (t[a] = e[l]));
  return t;
}
var qT = {};
function Wl(e, t) {
  qT[e] = t;
}
function g$(e) {
  var t = [], a;
  for (a in e)
    or(e, a) && t.push({ unit: a, priority: qT[a] });
  return t.sort(function(l, h) {
    return l.priority - h.priority;
  }), t;
}
function _w(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Rs(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function _n(e) {
  var t = +e, a = 0;
  return t !== 0 && isFinite(t) && (a = Rs(t)), a;
}
function Bp(e, t) {
  return function(a) {
    return a != null ? (GT(this, e, a), Ke.updateOffset(this, t), this) : D5(this, e);
  };
}
function D5(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function GT(e, t, a) {
  e.isValid() && !isNaN(a) && (t === "FullYear" && _w(e.year()) && e.month() === 1 && e.date() === 29 ? (a = _n(a), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    a,
    e.month(),
    Dw(a, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](a));
}
function w$(e) {
  return e = Ts(e), N0(this[e]) ? this[e]() : this;
}
function y$(e, t) {
  if (typeof e == "object") {
    e = Gx(e);
    var a = g$(e), l, h = a.length;
    for (l = 0; l < h; l++)
      this[a[l].unit](e[a[l].unit]);
  } else if (e = Ts(e), N0(this[e]))
    return this[e](t);
  return this;
}
var KT = /\d/, Zu = /\d\d/, QT = /\d{3}/, Kx = /\d{4}/, Rw = /[+-]?\d{6}/, Jr = /\d\d?/, XT = /\d\d\d\d?/, JT = /\d\d\d\d\d\d?/, Ew = /\d{1,3}/, Qx = /\d{1,4}/, Mw = /[+-]?\d{1,6}/, Fp = /\d+/, Tw = /[+-]?\d+/, x$ = /Z|[+-]\d\d:?\d\d/gi, Ow = /Z|[+-]\d\d(?::?\d\d)?/gi, S$ = /[+-]?\d+(\.\d{1,3})?/, m3 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, j5;
j5 = {};
function Rt(e, t, a) {
  j5[e] = N0(t) ? t : function(l, h) {
    return l && a ? a : t;
  };
}
function C$(e, t) {
  return or(j5, e) ? j5[e](t._strict, t._locale) : new RegExp(b$(e));
}
function b$(e) {
  return Iu(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, a, l, h, g) {
        return a || l || h || g;
      }
    )
  );
}
function Iu(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var y8 = {};
function jr(e, t) {
  var a, l = t, h;
  for (typeof e == "string" && (e = [e]), vf(t) && (l = function(g, m) {
    m[t] = _n(g);
  }), h = e.length, a = 0; a < h; a++)
    y8[e[a]] = l;
}
function g3(e, t) {
  jr(e, function(a, l, h, g) {
    h._w = h._w || {}, t(a, h._w, h, g);
  });
}
function _$(e, t, a) {
  t != null && or(y8, e) && y8[e](t, a._a, a, e);
}
var Yl = 0, uf = 1, O0 = 2, Di = 3, S1 = 4, sf = 5, k2 = 6, R$ = 7, E$ = 8;
function M$(e, t) {
  return (e % t + t) % t;
}
var Qa;
Array.prototype.indexOf ? Qa = Array.prototype.indexOf : Qa = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Dw(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var a = M$(t, 12);
  return e += (t - a) / 12, a === 1 ? _w(e) ? 29 : 28 : 31 - a % 7 % 2;
}
$t("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
$t("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
$t("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
$l("month", "M");
Wl("month", 8);
Rt("M", Jr);
Rt("MM", Jr, Zu);
Rt("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Rt("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
jr(["M", "MM"], function(e, t) {
  t[uf] = _n(e) - 1;
});
jr(["MMM", "MMMM"], function(e, t, a, l) {
  var h = a._locale.monthsParse(e, l, a._strict);
  h != null ? t[uf] = h : mn(a).invalidMonth = e;
});
var T$ = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), eO = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), tO = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, O$ = m3, D$ = m3;
function j$(e, t) {
  return e ? _1(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || tO).test(t) ? "format" : "standalone"][e.month()] : _1(this._months) ? this._months : this._months.standalone;
}
function A$(e, t) {
  return e ? _1(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[tO.test(t) ? "format" : "standalone"][e.month()] : _1(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function k$(e, t, a) {
  var l, h, g, m = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], l = 0; l < 12; ++l)
      g = P0([2e3, l]), this._shortMonthsParse[l] = this.monthsShort(
        g,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[l] = this.months(g, "").toLocaleLowerCase();
  return a ? t === "MMM" ? (h = Qa.call(this._shortMonthsParse, m), h !== -1 ? h : null) : (h = Qa.call(this._longMonthsParse, m), h !== -1 ? h : null) : t === "MMM" ? (h = Qa.call(this._shortMonthsParse, m), h !== -1 ? h : (h = Qa.call(this._longMonthsParse, m), h !== -1 ? h : null)) : (h = Qa.call(this._longMonthsParse, m), h !== -1 ? h : (h = Qa.call(this._shortMonthsParse, m), h !== -1 ? h : null));
}
function L$(e, t, a) {
  var l, h, g;
  if (this._monthsParseExact)
    return k$.call(this, e, t, a);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), l = 0; l < 12; l++) {
    if (h = P0([2e3, l]), a && !this._longMonthsParse[l] && (this._longMonthsParse[l] = new RegExp(
      "^" + this.months(h, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[l] = new RegExp(
      "^" + this.monthsShort(h, "").replace(".", "") + "$",
      "i"
    )), !a && !this._monthsParse[l] && (g = "^" + this.months(h, "") + "|^" + this.monthsShort(h, ""), this._monthsParse[l] = new RegExp(g.replace(".", ""), "i")), a && t === "MMMM" && this._longMonthsParse[l].test(e))
      return l;
    if (a && t === "MMM" && this._shortMonthsParse[l].test(e))
      return l;
    if (!a && this._monthsParse[l].test(e))
      return l;
  }
}
function nO(e, t) {
  var a;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = _n(t);
    else if (t = e.localeData().monthsParse(t), !vf(t))
      return e;
  }
  return a = Math.min(e.date(), Dw(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, a), e;
}
function rO(e) {
  return e != null ? (nO(this, e), Ke.updateOffset(this, !0), this) : D5(this, "Month");
}
function I$() {
  return Dw(this.year(), this.month());
}
function H$(e) {
  return this._monthsParseExact ? (or(this, "_monthsRegex") || aO.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (or(this, "_monthsShortRegex") || (this._monthsShortRegex = O$), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Z$(e) {
  return this._monthsParseExact ? (or(this, "_monthsRegex") || aO.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (or(this, "_monthsRegex") || (this._monthsRegex = D$), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function aO() {
  function e(m, S) {
    return S.length - m.length;
  }
  var t = [], a = [], l = [], h, g;
  for (h = 0; h < 12; h++)
    g = P0([2e3, h]), t.push(this.monthsShort(g, "")), a.push(this.months(g, "")), l.push(this.months(g, "")), l.push(this.monthsShort(g, ""));
  for (t.sort(e), a.sort(e), l.sort(e), h = 0; h < 12; h++)
    t[h] = Iu(t[h]), a[h] = Iu(a[h]);
  for (h = 0; h < 24; h++)
    l[h] = Iu(l[h]);
  this._monthsRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
$t("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? H0(e, 4) : "+" + e;
});
$t(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
$t(0, ["YYYY", 4], 0, "year");
$t(0, ["YYYYY", 5], 0, "year");
$t(0, ["YYYYYY", 6, !0], 0, "year");
$l("year", "y");
Wl("year", 1);
Rt("Y", Tw);
Rt("YY", Jr, Zu);
Rt("YYYY", Qx, Kx);
Rt("YYYYY", Mw, Rw);
Rt("YYYYYY", Mw, Rw);
jr(["YYYYY", "YYYYYY"], Yl);
jr("YYYY", function(e, t) {
  t[Yl] = e.length === 2 ? Ke.parseTwoDigitYear(e) : _n(e);
});
jr("YY", function(e, t) {
  t[Yl] = Ke.parseTwoDigitYear(e);
});
jr("Y", function(e, t) {
  t[Yl] = parseInt(e, 10);
});
function A4(e) {
  return _w(e) ? 366 : 365;
}
Ke.parseTwoDigitYear = function(e) {
  return _n(e) + (_n(e) > 68 ? 1900 : 2e3);
};
var iO = Bp("FullYear", !0);
function P$() {
  return _w(this.year());
}
function N$(e, t, a, l, h, g, m) {
  var S;
  return e < 100 && e >= 0 ? (S = new Date(e + 400, t, a, l, h, g, m), isFinite(S.getFullYear()) && S.setFullYear(e)) : S = new Date(e, t, a, l, h, g, m), S;
}
function V4(e) {
  var t, a;
  return e < 100 && e >= 0 ? (a = Array.prototype.slice.call(arguments), a[0] = e + 400, t = new Date(Date.UTC.apply(null, a)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function A5(e, t, a) {
  var l = 7 + t - a, h = (7 + V4(e, 0, l).getUTCDay() - t) % 7;
  return -h + l - 1;
}
function lO(e, t, a, l, h) {
  var g = (7 + a - l) % 7, m = A5(e, l, h), S = 1 + 7 * (t - 1) + g + m, b, R;
  return S <= 0 ? (b = e - 1, R = A4(b) + S) : S > A4(e) ? (b = e + 1, R = S - A4(e)) : (b = e, R = S), {
    year: b,
    dayOfYear: R
  };
}
function B4(e, t, a) {
  var l = A5(e.year(), t, a), h = Math.floor((e.dayOfYear() - l - 1) / 7) + 1, g, m;
  return h < 1 ? (m = e.year() - 1, g = h + ff(m, t, a)) : h > ff(e.year(), t, a) ? (g = h - ff(e.year(), t, a), m = e.year() + 1) : (m = e.year(), g = h), {
    week: g,
    year: m
  };
}
function ff(e, t, a) {
  var l = A5(e, t, a), h = A5(e + 1, t, a);
  return (A4(e) - l + h) / 7;
}
$t("w", ["ww", 2], "wo", "week");
$t("W", ["WW", 2], "Wo", "isoWeek");
$l("week", "w");
$l("isoWeek", "W");
Wl("week", 5);
Wl("isoWeek", 5);
Rt("w", Jr);
Rt("ww", Jr, Zu);
Rt("W", Jr);
Rt("WW", Jr, Zu);
g3(
  ["w", "ww", "W", "WW"],
  function(e, t, a, l) {
    t[l.substr(0, 1)] = _n(e);
  }
);
function V$(e) {
  return B4(e, this._week.dow, this._week.doy).week;
}
var B$ = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function F$() {
  return this._week.dow;
}
function U$() {
  return this._week.doy;
}
function Y$(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function $$(e) {
  var t = B4(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
$t("d", 0, "do", "day");
$t("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
$t("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
$t("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
$t("e", 0, 0, "weekday");
$t("E", 0, 0, "isoWeekday");
$l("day", "d");
$l("weekday", "e");
$l("isoWeekday", "E");
Wl("day", 11);
Wl("weekday", 11);
Wl("isoWeekday", 11);
Rt("d", Jr);
Rt("e", Jr);
Rt("E", Jr);
Rt("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Rt("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Rt("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
g3(["dd", "ddd", "dddd"], function(e, t, a, l) {
  var h = a._locale.weekdaysParse(e, l, a._strict);
  h != null ? t.d = h : mn(a).invalidWeekday = e;
});
g3(["d", "e", "E"], function(e, t, a, l) {
  t[l] = _n(e);
});
function W$(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function z$(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Xx(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var q$ = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), oO = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), G$ = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), K$ = m3, Q$ = m3, X$ = m3;
function J$(e, t) {
  var a = _1(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Xx(a, this._week.dow) : e ? a[e.day()] : a;
}
function eW(e) {
  return e === !0 ? Xx(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function tW(e) {
  return e === !0 ? Xx(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function nW(e, t, a) {
  var l, h, g, m = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], l = 0; l < 7; ++l)
      g = P0([2e3, 1]).day(l), this._minWeekdaysParse[l] = this.weekdaysMin(
        g,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[l] = this.weekdaysShort(
        g,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[l] = this.weekdays(g, "").toLocaleLowerCase();
  return a ? t === "dddd" ? (h = Qa.call(this._weekdaysParse, m), h !== -1 ? h : null) : t === "ddd" ? (h = Qa.call(this._shortWeekdaysParse, m), h !== -1 ? h : null) : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 ? h : null) : t === "dddd" ? (h = Qa.call(this._weekdaysParse, m), h !== -1 || (h = Qa.call(this._shortWeekdaysParse, m), h !== -1) ? h : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 ? h : null)) : t === "ddd" ? (h = Qa.call(this._shortWeekdaysParse, m), h !== -1 || (h = Qa.call(this._weekdaysParse, m), h !== -1) ? h : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 ? h : null)) : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 || (h = Qa.call(this._weekdaysParse, m), h !== -1) ? h : (h = Qa.call(this._shortWeekdaysParse, m), h !== -1 ? h : null));
}
function rW(e, t, a) {
  var l, h, g;
  if (this._weekdaysParseExact)
    return nW.call(this, e, t, a);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), l = 0; l < 7; l++) {
    if (h = P0([2e3, 1]).day(l), a && !this._fullWeekdaysParse[l] && (this._fullWeekdaysParse[l] = new RegExp(
      "^" + this.weekdays(h, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[l] = new RegExp(
      "^" + this.weekdaysShort(h, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[l] = new RegExp(
      "^" + this.weekdaysMin(h, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[l] || (g = "^" + this.weekdays(h, "") + "|^" + this.weekdaysShort(h, "") + "|^" + this.weekdaysMin(h, ""), this._weekdaysParse[l] = new RegExp(g.replace(".", ""), "i")), a && t === "dddd" && this._fullWeekdaysParse[l].test(e))
      return l;
    if (a && t === "ddd" && this._shortWeekdaysParse[l].test(e))
      return l;
    if (a && t === "dd" && this._minWeekdaysParse[l].test(e))
      return l;
    if (!a && this._weekdaysParse[l].test(e))
      return l;
  }
}
function aW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = W$(e, this.localeData()), this.add(e - t, "d")) : t;
}
function iW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function lW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = z$(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function oW(e) {
  return this._weekdaysParseExact ? (or(this, "_weekdaysRegex") || Jx.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (or(this, "_weekdaysRegex") || (this._weekdaysRegex = K$), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function uW(e) {
  return this._weekdaysParseExact ? (or(this, "_weekdaysRegex") || Jx.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (or(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Q$), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function sW(e) {
  return this._weekdaysParseExact ? (or(this, "_weekdaysRegex") || Jx.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (or(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = X$), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Jx() {
  function e(D, T) {
    return T.length - D.length;
  }
  var t = [], a = [], l = [], h = [], g, m, S, b, R;
  for (g = 0; g < 7; g++)
    m = P0([2e3, 1]).day(g), S = Iu(this.weekdaysMin(m, "")), b = Iu(this.weekdaysShort(m, "")), R = Iu(this.weekdays(m, "")), t.push(S), a.push(b), l.push(R), h.push(S), h.push(b), h.push(R);
  t.sort(e), a.sort(e), l.sort(e), h.sort(e), this._weekdaysRegex = new RegExp("^(" + h.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + l.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function eS() {
  return this.hours() % 12 || 12;
}
function cW() {
  return this.hours() || 24;
}
$t("H", ["HH", 2], 0, "hour");
$t("h", ["hh", 2], 0, eS);
$t("k", ["kk", 2], 0, cW);
$t("hmm", 0, 0, function() {
  return "" + eS.apply(this) + H0(this.minutes(), 2);
});
$t("hmmss", 0, 0, function() {
  return "" + eS.apply(this) + H0(this.minutes(), 2) + H0(this.seconds(), 2);
});
$t("Hmm", 0, 0, function() {
  return "" + this.hours() + H0(this.minutes(), 2);
});
$t("Hmmss", 0, 0, function() {
  return "" + this.hours() + H0(this.minutes(), 2) + H0(this.seconds(), 2);
});
function uO(e, t) {
  $t(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
uO("a", !0);
uO("A", !1);
$l("hour", "h");
Wl("hour", 13);
function sO(e, t) {
  return t._meridiemParse;
}
Rt("a", sO);
Rt("A", sO);
Rt("H", Jr);
Rt("h", Jr);
Rt("k", Jr);
Rt("HH", Jr, Zu);
Rt("hh", Jr, Zu);
Rt("kk", Jr, Zu);
Rt("hmm", XT);
Rt("hmmss", JT);
Rt("Hmm", XT);
Rt("Hmmss", JT);
jr(["H", "HH"], Di);
jr(["k", "kk"], function(e, t, a) {
  var l = _n(e);
  t[Di] = l === 24 ? 0 : l;
});
jr(["a", "A"], function(e, t, a) {
  a._isPm = a._locale.isPM(e), a._meridiem = e;
});
jr(["h", "hh"], function(e, t, a) {
  t[Di] = _n(e), mn(a).bigHour = !0;
});
jr("hmm", function(e, t, a) {
  var l = e.length - 2;
  t[Di] = _n(e.substr(0, l)), t[S1] = _n(e.substr(l)), mn(a).bigHour = !0;
});
jr("hmmss", function(e, t, a) {
  var l = e.length - 4, h = e.length - 2;
  t[Di] = _n(e.substr(0, l)), t[S1] = _n(e.substr(l, 2)), t[sf] = _n(e.substr(h)), mn(a).bigHour = !0;
});
jr("Hmm", function(e, t, a) {
  var l = e.length - 2;
  t[Di] = _n(e.substr(0, l)), t[S1] = _n(e.substr(l));
});
jr("Hmmss", function(e, t, a) {
  var l = e.length - 4, h = e.length - 2;
  t[Di] = _n(e.substr(0, l)), t[S1] = _n(e.substr(l, 2)), t[sf] = _n(e.substr(h));
});
function fW(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var dW = /[ap]\.?m?\.?/i, hW = Bp("Hours", !0);
function vW(e, t, a) {
  return e > 11 ? a ? "pm" : "PM" : a ? "am" : "AM";
}
var cO = {
  calendar: r$,
  longDateFormat: o$,
  invalidDate: s$,
  ordinal: f$,
  dayOfMonthOrdinalParse: d$,
  relativeTime: v$,
  months: T$,
  monthsShort: eO,
  week: B$,
  weekdays: q$,
  weekdaysMin: G$,
  weekdaysShort: oO,
  meridiemParse: dW
}, fa = {}, _4 = {}, F4;
function pW(e, t) {
  var a, l = Math.min(e.length, t.length);
  for (a = 0; a < l; a += 1)
    if (e[a] !== t[a])
      return a;
  return l;
}
function kR(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function mW(e) {
  for (var t = 0, a, l, h, g; t < e.length; ) {
    for (g = kR(e[t]).split("-"), a = g.length, l = kR(e[t + 1]), l = l ? l.split("-") : null; a > 0; ) {
      if (h = jw(g.slice(0, a).join("-")), h)
        return h;
      if (l && l.length >= a && pW(g, l) >= a - 1)
        break;
      a--;
    }
    t++;
  }
  return F4;
}
function gW(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function jw(e) {
  var t = null, a;
  if (fa[e] === void 0 && typeof module < "u" && module && module.exports && gW(e))
    try {
      t = F4._abbr, a = require, a("./locale/" + e), ch(t);
    } catch {
      fa[e] = null;
    }
  return fa[e];
}
function ch(e, t) {
  var a;
  return e && (Qo(t) ? a = xf(e) : a = tS(e, t), a ? F4 = a : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), F4._abbr;
}
function tS(e, t) {
  if (t !== null) {
    var a, l = cO;
    if (t.abbr = e, fa[e] != null)
      WT(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), l = fa[e]._config;
    else if (t.parentLocale != null)
      if (fa[t.parentLocale] != null)
        l = fa[t.parentLocale]._config;
      else if (a = jw(t.parentLocale), a != null)
        l = a._config;
      else
        return _4[t.parentLocale] || (_4[t.parentLocale] = []), _4[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return fa[e] = new zx(g8(l, t)), _4[e] && _4[e].forEach(function(h) {
      tS(h.name, h.config);
    }), ch(e), fa[e];
  } else
    return delete fa[e], null;
}
function wW(e, t) {
  if (t != null) {
    var a, l, h = cO;
    fa[e] != null && fa[e].parentLocale != null ? fa[e].set(g8(fa[e]._config, t)) : (l = jw(e), l != null && (h = l._config), t = g8(h, t), l == null && (t.abbr = e), a = new zx(t), a.parentLocale = fa[e], fa[e] = a), ch(e);
  } else
    fa[e] != null && (fa[e].parentLocale != null ? (fa[e] = fa[e].parentLocale, e === ch() && ch(e)) : fa[e] != null && delete fa[e]);
  return fa[e];
}
function xf(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return F4;
  if (!_1(e)) {
    if (t = jw(e), t)
      return t;
    e = [e];
  }
  return mW(e);
}
function yW() {
  return w8(fa);
}
function nS(e) {
  var t, a = e._a;
  return a && mn(e).overflow === -2 && (t = a[uf] < 0 || a[uf] > 11 ? uf : a[O0] < 1 || a[O0] > Dw(a[Yl], a[uf]) ? O0 : a[Di] < 0 || a[Di] > 24 || a[Di] === 24 && (a[S1] !== 0 || a[sf] !== 0 || a[k2] !== 0) ? Di : a[S1] < 0 || a[S1] > 59 ? S1 : a[sf] < 0 || a[sf] > 59 ? sf : a[k2] < 0 || a[k2] > 999 ? k2 : -1, mn(e)._overflowDayOfYear && (t < Yl || t > O0) && (t = O0), mn(e)._overflowWeeks && t === -1 && (t = R$), mn(e)._overflowWeekday && t === -1 && (t = E$), mn(e).overflow = t), e;
}
var xW = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, SW = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, CW = /Z|[+-]\d\d(?::?\d\d)?/, u5 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Fy = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], bW = /^\/?Date\((-?\d+)/i, _W = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, RW = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fO(e) {
  var t, a, l = e._i, h = xW.exec(l) || SW.exec(l), g, m, S, b, R = u5.length, D = Fy.length;
  if (h) {
    for (mn(e).iso = !0, t = 0, a = R; t < a; t++)
      if (u5[t][1].exec(h[1])) {
        m = u5[t][0], g = u5[t][2] !== !1;
        break;
      }
    if (m == null) {
      e._isValid = !1;
      return;
    }
    if (h[3]) {
      for (t = 0, a = D; t < a; t++)
        if (Fy[t][1].exec(h[3])) {
          S = (h[2] || " ") + Fy[t][0];
          break;
        }
      if (S == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!g && S != null) {
      e._isValid = !1;
      return;
    }
    if (h[4])
      if (CW.exec(h[4]))
        b = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = m + (S || "") + (b || ""), aS(e);
  } else
    e._isValid = !1;
}
function EW(e, t, a, l, h, g) {
  var m = [
    MW(e),
    eO.indexOf(t),
    parseInt(a, 10),
    parseInt(l, 10),
    parseInt(h, 10)
  ];
  return g && m.push(parseInt(g, 10)), m;
}
function MW(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function TW(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function OW(e, t, a) {
  if (e) {
    var l = oO.indexOf(e), h = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (l !== h)
      return mn(a).weekdayMismatch = !0, a._isValid = !1, !1;
  }
  return !0;
}
function DW(e, t, a) {
  if (e)
    return RW[e];
  if (t)
    return 0;
  var l = parseInt(a, 10), h = l % 100, g = (l - h) / 100;
  return g * 60 + h;
}
function dO(e) {
  var t = _W.exec(TW(e._i)), a;
  if (t) {
    if (a = EW(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !OW(t[1], a, e))
      return;
    e._a = a, e._tzm = DW(t[8], t[9], t[10]), e._d = V4.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), mn(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function jW(e) {
  var t = bW.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (fO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (dO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Ke.createFromInputFallback(e);
}
Ke.createFromInputFallback = Ms(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function yp(e, t, a) {
  return e ?? t ?? a;
}
function AW(e) {
  var t = new Date(Ke.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function rS(e) {
  var t, a, l = [], h, g, m;
  if (!e._d) {
    for (h = AW(e), e._w && e._a[O0] == null && e._a[uf] == null && kW(e), e._dayOfYear != null && (m = yp(e._a[Yl], h[Yl]), (e._dayOfYear > A4(m) || e._dayOfYear === 0) && (mn(e)._overflowDayOfYear = !0), a = V4(m, 0, e._dayOfYear), e._a[uf] = a.getUTCMonth(), e._a[O0] = a.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = l[t] = h[t];
    for (; t < 7; t++)
      e._a[t] = l[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Di] === 24 && e._a[S1] === 0 && e._a[sf] === 0 && e._a[k2] === 0 && (e._nextDay = !0, e._a[Di] = 0), e._d = (e._useUTC ? V4 : N$).apply(
      null,
      l
    ), g = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Di] = 24), e._w && typeof e._w.d < "u" && e._w.d !== g && (mn(e).weekdayMismatch = !0);
  }
}
function kW(e) {
  var t, a, l, h, g, m, S, b, R;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (g = 1, m = 4, a = yp(
    t.GG,
    e._a[Yl],
    B4(Xr(), 1, 4).year
  ), l = yp(t.W, 1), h = yp(t.E, 1), (h < 1 || h > 7) && (b = !0)) : (g = e._locale._week.dow, m = e._locale._week.doy, R = B4(Xr(), g, m), a = yp(t.gg, e._a[Yl], R.year), l = yp(t.w, R.week), t.d != null ? (h = t.d, (h < 0 || h > 6) && (b = !0)) : t.e != null ? (h = t.e + g, (t.e < 0 || t.e > 6) && (b = !0)) : h = g), l < 1 || l > ff(a, g, m) ? mn(e)._overflowWeeks = !0 : b != null ? mn(e)._overflowWeekday = !0 : (S = lO(a, l, h, g, m), e._a[Yl] = S.year, e._dayOfYear = S.dayOfYear);
}
Ke.ISO_8601 = function() {
};
Ke.RFC_2822 = function() {
};
function aS(e) {
  if (e._f === Ke.ISO_8601) {
    fO(e);
    return;
  }
  if (e._f === Ke.RFC_2822) {
    dO(e);
    return;
  }
  e._a = [], mn(e).empty = !0;
  var t = "" + e._i, a, l, h, g, m, S = t.length, b = 0, R, D;
  for (h = zT(e._f, e._locale).match(qx) || [], D = h.length, a = 0; a < D; a++)
    g = h[a], l = (t.match(C$(g, e)) || [])[0], l && (m = t.substr(0, t.indexOf(l)), m.length > 0 && mn(e).unusedInput.push(m), t = t.slice(
      t.indexOf(l) + l.length
    ), b += l.length), Ep[g] ? (l ? mn(e).empty = !1 : mn(e).unusedTokens.push(g), _$(g, l, e)) : e._strict && !l && mn(e).unusedTokens.push(g);
  mn(e).charsLeftOver = S - b, t.length > 0 && mn(e).unusedInput.push(t), e._a[Di] <= 12 && mn(e).bigHour === !0 && e._a[Di] > 0 && (mn(e).bigHour = void 0), mn(e).parsedDateParts = e._a.slice(0), mn(e).meridiem = e._meridiem, e._a[Di] = LW(
    e._locale,
    e._a[Di],
    e._meridiem
  ), R = mn(e).era, R !== null && (e._a[Yl] = e._locale.erasConvertYear(R, e._a[Yl])), rS(e), nS(e);
}
function LW(e, t, a) {
  var l;
  return a == null ? t : e.meridiemHour != null ? e.meridiemHour(t, a) : (e.isPM != null && (l = e.isPM(a), l && t < 12 && (t += 12), !l && t === 12 && (t = 0)), t);
}
function IW(e) {
  var t, a, l, h, g, m, S = !1, b = e._f.length;
  if (b === 0) {
    mn(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (h = 0; h < b; h++)
    g = 0, m = !1, t = Wx({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[h], aS(t), $x(t) && (m = !0), g += mn(t).charsLeftOver, g += mn(t).unusedTokens.length * 10, mn(t).score = g, S ? g < l && (l = g, a = t) : (l == null || g < l || m) && (l = g, a = t, m && (S = !0));
  lh(e, a || t);
}
function HW(e) {
  if (!e._d) {
    var t = Gx(e._i), a = t.day === void 0 ? t.date : t.day;
    e._a = YT(
      [t.year, t.month, a, t.hour, t.minute, t.second, t.millisecond],
      function(l) {
        return l && parseInt(l, 10);
      }
    ), rS(e);
  }
}
function ZW(e) {
  var t = new p3(nS(hO(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function hO(e) {
  var t = e._i, a = e._f;
  return e._locale = e._locale || xf(e._l), t === null || a === void 0 && t === "" ? bw({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), R1(t) ? new p3(nS(t)) : (v3(t) ? e._d = t : _1(a) ? IW(e) : a ? aS(e) : PW(e), $x(e) || (e._d = null), e));
}
function PW(e) {
  var t = e._i;
  Qo(t) ? e._d = new Date(Ke.now()) : v3(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? jW(e) : _1(t) ? (e._a = YT(t.slice(0), function(a) {
    return parseInt(a, 10);
  }), rS(e)) : L2(t) ? HW(e) : vf(t) ? e._d = new Date(t) : Ke.createFromInputFallback(e);
}
function vO(e, t, a, l, h) {
  var g = {};
  return (t === !0 || t === !1) && (l = t, t = void 0), (a === !0 || a === !1) && (l = a, a = void 0), (L2(e) && Yx(e) || _1(e) && e.length === 0) && (e = void 0), g._isAMomentObject = !0, g._useUTC = g._isUTC = h, g._l = a, g._i = e, g._f = t, g._strict = l, ZW(g);
}
function Xr(e, t, a, l) {
  return vO(e, t, a, l, !1);
}
var NW = Ms(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Xr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : bw();
  }
), VW = Ms(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Xr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : bw();
  }
);
function pO(e, t) {
  var a, l;
  if (t.length === 1 && _1(t[0]) && (t = t[0]), !t.length)
    return Xr();
  for (a = t[0], l = 1; l < t.length; ++l)
    (!t[l].isValid() || t[l][e](a)) && (a = t[l]);
  return a;
}
function BW() {
  var e = [].slice.call(arguments, 0);
  return pO("isBefore", e);
}
function FW() {
  var e = [].slice.call(arguments, 0);
  return pO("isAfter", e);
}
var UW = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, R4 = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function YW(e) {
  var t, a = !1, l, h = R4.length;
  for (t in e)
    if (or(e, t) && !(Qa.call(R4, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (l = 0; l < h; ++l)
    if (e[R4[l]]) {
      if (a)
        return !1;
      parseFloat(e[R4[l]]) !== _n(e[R4[l]]) && (a = !0);
    }
  return !0;
}
function $W() {
  return this._isValid;
}
function WW() {
  return E1(NaN);
}
function Aw(e) {
  var t = Gx(e), a = t.year || 0, l = t.quarter || 0, h = t.month || 0, g = t.week || t.isoWeek || 0, m = t.day || 0, S = t.hour || 0, b = t.minute || 0, R = t.second || 0, D = t.millisecond || 0;
  this._isValid = YW(t), this._milliseconds = +D + R * 1e3 + // 1000
  b * 6e4 + // 1000 * 60
  S * 1e3 * 60 * 60, this._days = +m + g * 7, this._months = +h + l * 3 + a * 12, this._data = {}, this._locale = xf(), this._bubble();
}
function g5(e) {
  return e instanceof Aw;
}
function x8(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function zW(e, t, a) {
  var l = Math.min(e.length, t.length), h = Math.abs(e.length - t.length), g = 0, m;
  for (m = 0; m < l; m++)
    _n(e[m]) !== _n(t[m]) && g++;
  return g + h;
}
function mO(e, t) {
  $t(e, 0, 0, function() {
    var a = this.utcOffset(), l = "+";
    return a < 0 && (a = -a, l = "-"), l + H0(~~(a / 60), 2) + t + H0(~~a % 60, 2);
  });
}
mO("Z", ":");
mO("ZZ", "");
Rt("Z", Ow);
Rt("ZZ", Ow);
jr(["Z", "ZZ"], function(e, t, a) {
  a._useUTC = !0, a._tzm = iS(Ow, e);
});
var qW = /([\+\-]|\d\d)/gi;
function iS(e, t) {
  var a = (t || "").match(e), l, h, g;
  return a === null ? null : (l = a[a.length - 1] || [], h = (l + "").match(qW) || ["-", 0, 0], g = +(h[1] * 60) + _n(h[2]), g === 0 ? 0 : h[0] === "+" ? g : -g);
}
function lS(e, t) {
  var a, l;
  return t._isUTC ? (a = t.clone(), l = (R1(e) || v3(e) ? e.valueOf() : Xr(e).valueOf()) - a.valueOf(), a._d.setTime(a._d.valueOf() + l), Ke.updateOffset(a, !1), a) : Xr(e).local();
}
function S8(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Ke.updateOffset = function() {
};
function GW(e, t, a) {
  var l = this._offset || 0, h;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = iS(Ow, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !a && (e = e * 60);
    return !this._isUTC && t && (h = S8(this)), this._offset = e, this._isUTC = !0, h != null && this.add(h, "m"), l !== e && (!t || this._changeInProgress ? yO(
      this,
      E1(e - l, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Ke.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? l : S8(this);
}
function KW(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function QW(e) {
  return this.utcOffset(0, e);
}
function XW(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(S8(this), "m")), this;
}
function JW() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = iS(x$, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function ez(e) {
  return this.isValid() ? (e = e ? Xr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function tz() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function nz() {
  if (!Qo(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Wx(e, this), e = hO(e), e._a ? (t = e._isUTC ? P0(e._a) : Xr(e._a), this._isDSTShifted = this.isValid() && zW(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function rz() {
  return this.isValid() ? !this._isUTC : !1;
}
function az() {
  return this.isValid() ? this._isUTC : !1;
}
function gO() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var iz = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, lz = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function E1(e, t) {
  var a = e, l = null, h, g, m;
  return g5(e) ? a = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : vf(e) || !isNaN(+e) ? (a = {}, t ? a[t] = +e : a.milliseconds = +e) : (l = iz.exec(e)) ? (h = l[1] === "-" ? -1 : 1, a = {
    y: 0,
    d: _n(l[O0]) * h,
    h: _n(l[Di]) * h,
    m: _n(l[S1]) * h,
    s: _n(l[sf]) * h,
    ms: _n(x8(l[k2] * 1e3)) * h
    // the millisecond decimal point is included in the match
  }) : (l = lz.exec(e)) ? (h = l[1] === "-" ? -1 : 1, a = {
    y: j2(l[2], h),
    M: j2(l[3], h),
    w: j2(l[4], h),
    d: j2(l[5], h),
    h: j2(l[6], h),
    m: j2(l[7], h),
    s: j2(l[8], h)
  }) : a == null ? a = {} : typeof a == "object" && ("from" in a || "to" in a) && (m = oz(
    Xr(a.from),
    Xr(a.to)
  ), a = {}, a.ms = m.milliseconds, a.M = m.months), g = new Aw(a), g5(e) && or(e, "_locale") && (g._locale = e._locale), g5(e) && or(e, "_isValid") && (g._isValid = e._isValid), g;
}
E1.fn = Aw.prototype;
E1.invalid = WW;
function j2(e, t) {
  var a = e && parseFloat(e.replace(",", "."));
  return (isNaN(a) ? 0 : a) * t;
}
function LR(e, t) {
  var a = {};
  return a.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(a.months, "M").isAfter(t) && --a.months, a.milliseconds = +t - +e.clone().add(a.months, "M"), a;
}
function oz(e, t) {
  var a;
  return e.isValid() && t.isValid() ? (t = lS(t, e), e.isBefore(t) ? a = LR(e, t) : (a = LR(t, e), a.milliseconds = -a.milliseconds, a.months = -a.months), a) : { milliseconds: 0, months: 0 };
}
function wO(e, t) {
  return function(a, l) {
    var h, g;
    return l !== null && !isNaN(+l) && (WT(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), g = a, a = l, l = g), h = E1(a, l), yO(this, h, e), this;
  };
}
function yO(e, t, a, l) {
  var h = t._milliseconds, g = x8(t._days), m = x8(t._months);
  e.isValid() && (l = l ?? !0, m && nO(e, D5(e, "Month") + m * a), g && GT(e, "Date", D5(e, "Date") + g * a), h && e._d.setTime(e._d.valueOf() + h * a), l && Ke.updateOffset(e, g || m));
}
var uz = wO(1, "add"), sz = wO(-1, "subtract");
function xO(e) {
  return typeof e == "string" || e instanceof String;
}
function cz(e) {
  return R1(e) || v3(e) || xO(e) || vf(e) || dz(e) || fz(e) || e === null || e === void 0;
}
function fz(e) {
  var t = L2(e) && !Yx(e), a = !1, l = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], h, g, m = l.length;
  for (h = 0; h < m; h += 1)
    g = l[h], a = a || or(e, g);
  return t && a;
}
function dz(e) {
  var t = _1(e), a = !1;
  return t && (a = e.filter(function(l) {
    return !vf(l) && xO(e);
  }).length === 0), t && a;
}
function hz(e) {
  var t = L2(e) && !Yx(e), a = !1, l = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], h, g;
  for (h = 0; h < l.length; h += 1)
    g = l[h], a = a || or(e, g);
  return t && a;
}
function vz(e, t) {
  var a = e.diff(t, "days", !0);
  return a < -6 ? "sameElse" : a < -1 ? "lastWeek" : a < 0 ? "lastDay" : a < 1 ? "sameDay" : a < 2 ? "nextDay" : a < 7 ? "nextWeek" : "sameElse";
}
function pz(e, t) {
  arguments.length === 1 && (arguments[0] ? cz(arguments[0]) ? (e = arguments[0], t = void 0) : hz(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var a = e || Xr(), l = lS(a, this).startOf("day"), h = Ke.calendarFormat(this, l) || "sameElse", g = t && (N0(t[h]) ? t[h].call(this, a) : t[h]);
  return this.format(
    g || this.localeData().calendar(h, this, Xr(a))
  );
}
function mz() {
  return new p3(this);
}
function gz(e, t) {
  var a = R1(e) ? e : Xr(e);
  return this.isValid() && a.isValid() ? (t = Ts(t) || "millisecond", t === "millisecond" ? this.valueOf() > a.valueOf() : a.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function wz(e, t) {
  var a = R1(e) ? e : Xr(e);
  return this.isValid() && a.isValid() ? (t = Ts(t) || "millisecond", t === "millisecond" ? this.valueOf() < a.valueOf() : this.clone().endOf(t).valueOf() < a.valueOf()) : !1;
}
function yz(e, t, a, l) {
  var h = R1(e) ? e : Xr(e), g = R1(t) ? t : Xr(t);
  return this.isValid() && h.isValid() && g.isValid() ? (l = l || "()", (l[0] === "(" ? this.isAfter(h, a) : !this.isBefore(h, a)) && (l[1] === ")" ? this.isBefore(g, a) : !this.isAfter(g, a))) : !1;
}
function xz(e, t) {
  var a = R1(e) ? e : Xr(e), l;
  return this.isValid() && a.isValid() ? (t = Ts(t) || "millisecond", t === "millisecond" ? this.valueOf() === a.valueOf() : (l = a.valueOf(), this.clone().startOf(t).valueOf() <= l && l <= this.clone().endOf(t).valueOf())) : !1;
}
function Sz(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Cz(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function bz(e, t, a) {
  var l, h, g;
  if (!this.isValid())
    return NaN;
  if (l = lS(e, this), !l.isValid())
    return NaN;
  switch (h = (l.utcOffset() - this.utcOffset()) * 6e4, t = Ts(t), t) {
    case "year":
      g = w5(this, l) / 12;
      break;
    case "month":
      g = w5(this, l);
      break;
    case "quarter":
      g = w5(this, l) / 3;
      break;
    case "second":
      g = (this - l) / 1e3;
      break;
    case "minute":
      g = (this - l) / 6e4;
      break;
    case "hour":
      g = (this - l) / 36e5;
      break;
    case "day":
      g = (this - l - h) / 864e5;
      break;
    case "week":
      g = (this - l - h) / 6048e5;
      break;
    default:
      g = this - l;
  }
  return a ? g : Rs(g);
}
function w5(e, t) {
  if (e.date() < t.date())
    return -w5(t, e);
  var a = (t.year() - e.year()) * 12 + (t.month() - e.month()), l = e.clone().add(a, "months"), h, g;
  return t - l < 0 ? (h = e.clone().add(a - 1, "months"), g = (t - l) / (l - h)) : (h = e.clone().add(a + 1, "months"), g = (t - l) / (h - l)), -(a + g) || 0;
}
Ke.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Ke.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function _z() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Rz(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, a = t ? this.clone().utc() : this;
  return a.year() < 0 || a.year() > 9999 ? m5(
    a,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : N0(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", m5(a, "Z")) : m5(
    a,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Ez() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", a, l, h, g;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), a = "[" + e + '("]', l = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", h = "-MM-DD[T]HH:mm:ss.SSS", g = t + '[")]', this.format(a + l + h + g);
}
function Mz(e) {
  e || (e = this.isUtc() ? Ke.defaultFormatUtc : Ke.defaultFormat);
  var t = m5(this, e);
  return this.localeData().postformat(t);
}
function Tz(e, t) {
  return this.isValid() && (R1(e) && e.isValid() || Xr(e).isValid()) ? E1({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Oz(e) {
  return this.from(Xr(), e);
}
function Dz(e, t) {
  return this.isValid() && (R1(e) && e.isValid() || Xr(e).isValid()) ? E1({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function jz(e) {
  return this.to(Xr(), e);
}
function SO(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = xf(e), t != null && (this._locale = t), this);
}
var CO = Ms(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function bO() {
  return this._locale;
}
var k5 = 1e3, Mp = 60 * k5, L5 = 60 * Mp, _O = (365 * 400 + 97) * 24 * L5;
function Tp(e, t) {
  return (e % t + t) % t;
}
function RO(e, t, a) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, a) - _O : new Date(e, t, a).valueOf();
}
function EO(e, t, a) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, a) - _O : Date.UTC(e, t, a);
}
function Az(e) {
  var t, a;
  if (e = Ts(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? EO : RO, e) {
    case "year":
      t = a(this.year(), 0, 1);
      break;
    case "quarter":
      t = a(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = a(this.year(), this.month(), 1);
      break;
    case "week":
      t = a(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = a(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Tp(
        t + (this._isUTC ? 0 : this.utcOffset() * Mp),
        L5
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Tp(t, Mp);
      break;
    case "second":
      t = this._d.valueOf(), t -= Tp(t, k5);
      break;
  }
  return this._d.setTime(t), Ke.updateOffset(this, !0), this;
}
function kz(e) {
  var t, a;
  if (e = Ts(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? EO : RO, e) {
    case "year":
      t = a(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = a(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = a(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = a(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = a(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += L5 - Tp(
        t + (this._isUTC ? 0 : this.utcOffset() * Mp),
        L5
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Mp - Tp(t, Mp) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += k5 - Tp(t, k5) - 1;
      break;
  }
  return this._d.setTime(t), Ke.updateOffset(this, !0), this;
}
function Lz() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Iz() {
  return Math.floor(this.valueOf() / 1e3);
}
function Hz() {
  return new Date(this.valueOf());
}
function Zz() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Pz() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Nz() {
  return this.isValid() ? this.toISOString() : null;
}
function Vz() {
  return $x(this);
}
function Bz() {
  return lh({}, mn(this));
}
function Fz() {
  return mn(this).overflow;
}
function Uz() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
$t("N", 0, 0, "eraAbbr");
$t("NN", 0, 0, "eraAbbr");
$t("NNN", 0, 0, "eraAbbr");
$t("NNNN", 0, 0, "eraName");
$t("NNNNN", 0, 0, "eraNarrow");
$t("y", ["y", 1], "yo", "eraYear");
$t("y", ["yy", 2], 0, "eraYear");
$t("y", ["yyy", 3], 0, "eraYear");
$t("y", ["yyyy", 4], 0, "eraYear");
Rt("N", oS);
Rt("NN", oS);
Rt("NNN", oS);
Rt("NNNN", eq);
Rt("NNNNN", tq);
jr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, a, l) {
    var h = a._locale.erasParse(e, l, a._strict);
    h ? mn(a).era = h : mn(a).invalidEra = e;
  }
);
Rt("y", Fp);
Rt("yy", Fp);
Rt("yyy", Fp);
Rt("yyyy", Fp);
Rt("yo", nq);
jr(["y", "yy", "yyy", "yyyy"], Yl);
jr(["yo"], function(e, t, a, l) {
  var h;
  a._locale._eraYearOrdinalRegex && (h = e.match(a._locale._eraYearOrdinalRegex)), a._locale.eraYearOrdinalParse ? t[Yl] = a._locale.eraYearOrdinalParse(e, h) : t[Yl] = parseInt(e, 10);
});
function Yz(e, t) {
  var a, l, h, g = this._eras || xf("en")._eras;
  for (a = 0, l = g.length; a < l; ++a) {
    switch (typeof g[a].since) {
      case "string":
        h = Ke(g[a].since).startOf("day"), g[a].since = h.valueOf();
        break;
    }
    switch (typeof g[a].until) {
      case "undefined":
        g[a].until = 1 / 0;
        break;
      case "string":
        h = Ke(g[a].until).startOf("day").valueOf(), g[a].until = h.valueOf();
        break;
    }
  }
  return g;
}
function $z(e, t, a) {
  var l, h, g = this.eras(), m, S, b;
  for (e = e.toUpperCase(), l = 0, h = g.length; l < h; ++l)
    if (m = g[l].name.toUpperCase(), S = g[l].abbr.toUpperCase(), b = g[l].narrow.toUpperCase(), a)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (S === e)
            return g[l];
          break;
        case "NNNN":
          if (m === e)
            return g[l];
          break;
        case "NNNNN":
          if (b === e)
            return g[l];
          break;
      }
    else if ([m, S, b].indexOf(e) >= 0)
      return g[l];
}
function Wz(e, t) {
  var a = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Ke(e.since).year() : Ke(e.since).year() + (t - e.offset) * a;
}
function zz() {
  var e, t, a, l = this.localeData().eras();
  for (e = 0, t = l.length; e < t; ++e)
    if (a = this.clone().startOf("day").valueOf(), l[e].since <= a && a <= l[e].until || l[e].until <= a && a <= l[e].since)
      return l[e].name;
  return "";
}
function qz() {
  var e, t, a, l = this.localeData().eras();
  for (e = 0, t = l.length; e < t; ++e)
    if (a = this.clone().startOf("day").valueOf(), l[e].since <= a && a <= l[e].until || l[e].until <= a && a <= l[e].since)
      return l[e].narrow;
  return "";
}
function Gz() {
  var e, t, a, l = this.localeData().eras();
  for (e = 0, t = l.length; e < t; ++e)
    if (a = this.clone().startOf("day").valueOf(), l[e].since <= a && a <= l[e].until || l[e].until <= a && a <= l[e].since)
      return l[e].abbr;
  return "";
}
function Kz() {
  var e, t, a, l, h = this.localeData().eras();
  for (e = 0, t = h.length; e < t; ++e)
    if (a = h[e].since <= h[e].until ? 1 : -1, l = this.clone().startOf("day").valueOf(), h[e].since <= l && l <= h[e].until || h[e].until <= l && l <= h[e].since)
      return (this.year() - Ke(h[e].since).year()) * a + h[e].offset;
  return this.year();
}
function Qz(e) {
  return or(this, "_erasNameRegex") || uS.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Xz(e) {
  return or(this, "_erasAbbrRegex") || uS.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Jz(e) {
  return or(this, "_erasNarrowRegex") || uS.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function oS(e, t) {
  return t.erasAbbrRegex(e);
}
function eq(e, t) {
  return t.erasNameRegex(e);
}
function tq(e, t) {
  return t.erasNarrowRegex(e);
}
function nq(e, t) {
  return t._eraYearOrdinalRegex || Fp;
}
function uS() {
  var e = [], t = [], a = [], l = [], h, g, m = this.eras();
  for (h = 0, g = m.length; h < g; ++h)
    t.push(Iu(m[h].name)), e.push(Iu(m[h].abbr)), a.push(Iu(m[h].narrow)), l.push(Iu(m[h].name)), l.push(Iu(m[h].abbr)), l.push(Iu(m[h].narrow));
  this._erasRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  );
}
$t(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
$t(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function kw(e, t) {
  $t(0, [e, e.length], 0, t);
}
kw("gggg", "weekYear");
kw("ggggg", "weekYear");
kw("GGGG", "isoWeekYear");
kw("GGGGG", "isoWeekYear");
$l("weekYear", "gg");
$l("isoWeekYear", "GG");
Wl("weekYear", 1);
Wl("isoWeekYear", 1);
Rt("G", Tw);
Rt("g", Tw);
Rt("GG", Jr, Zu);
Rt("gg", Jr, Zu);
Rt("GGGG", Qx, Kx);
Rt("gggg", Qx, Kx);
Rt("GGGGG", Mw, Rw);
Rt("ggggg", Mw, Rw);
g3(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, a, l) {
    t[l.substr(0, 2)] = _n(e);
  }
);
g3(["gg", "GG"], function(e, t, a, l) {
  t[l] = Ke.parseTwoDigitYear(e);
});
function rq(e) {
  return MO.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function aq(e) {
  return MO.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function iq() {
  return ff(this.year(), 1, 4);
}
function lq() {
  return ff(this.isoWeekYear(), 1, 4);
}
function oq() {
  var e = this.localeData()._week;
  return ff(this.year(), e.dow, e.doy);
}
function uq() {
  var e = this.localeData()._week;
  return ff(this.weekYear(), e.dow, e.doy);
}
function MO(e, t, a, l, h) {
  var g;
  return e == null ? B4(this, l, h).year : (g = ff(e, l, h), t > g && (t = g), sq.call(this, e, t, a, l, h));
}
function sq(e, t, a, l, h) {
  var g = lO(e, t, a, l, h), m = V4(g.year, 0, g.dayOfYear);
  return this.year(m.getUTCFullYear()), this.month(m.getUTCMonth()), this.date(m.getUTCDate()), this;
}
$t("Q", 0, "Qo", "quarter");
$l("quarter", "Q");
Wl("quarter", 7);
Rt("Q", KT);
jr("Q", function(e, t) {
  t[uf] = (_n(e) - 1) * 3;
});
function cq(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
$t("D", ["DD", 2], "Do", "date");
$l("date", "D");
Wl("date", 9);
Rt("D", Jr);
Rt("DD", Jr, Zu);
Rt("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
jr(["D", "DD"], O0);
jr("Do", function(e, t) {
  t[O0] = _n(e.match(Jr)[0]);
});
var TO = Bp("Date", !0);
$t("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
$l("dayOfYear", "DDD");
Wl("dayOfYear", 4);
Rt("DDD", Ew);
Rt("DDDD", QT);
jr(["DDD", "DDDD"], function(e, t, a) {
  a._dayOfYear = _n(e);
});
function fq(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
$t("m", ["mm", 2], 0, "minute");
$l("minute", "m");
Wl("minute", 14);
Rt("m", Jr);
Rt("mm", Jr, Zu);
jr(["m", "mm"], S1);
var dq = Bp("Minutes", !1);
$t("s", ["ss", 2], 0, "second");
$l("second", "s");
Wl("second", 15);
Rt("s", Jr);
Rt("ss", Jr, Zu);
jr(["s", "ss"], sf);
var hq = Bp("Seconds", !1);
$t("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
$t(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
$t(0, ["SSS", 3], 0, "millisecond");
$t(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
$t(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
$t(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
$t(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
$t(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
$t(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
$l("millisecond", "ms");
Wl("millisecond", 16);
Rt("S", Ew, KT);
Rt("SS", Ew, Zu);
Rt("SSS", Ew, QT);
var oh, OO;
for (oh = "SSSS"; oh.length <= 9; oh += "S")
  Rt(oh, Fp);
function vq(e, t) {
  t[k2] = _n(("0." + e) * 1e3);
}
for (oh = "S"; oh.length <= 9; oh += "S")
  jr(oh, vq);
OO = Bp("Milliseconds", !1);
$t("z", 0, 0, "zoneAbbr");
$t("zz", 0, 0, "zoneName");
function pq() {
  return this._isUTC ? "UTC" : "";
}
function mq() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Ge = p3.prototype;
Ge.add = uz;
Ge.calendar = pz;
Ge.clone = mz;
Ge.diff = bz;
Ge.endOf = kz;
Ge.format = Mz;
Ge.from = Tz;
Ge.fromNow = Oz;
Ge.to = Dz;
Ge.toNow = jz;
Ge.get = w$;
Ge.invalidAt = Fz;
Ge.isAfter = gz;
Ge.isBefore = wz;
Ge.isBetween = yz;
Ge.isSame = xz;
Ge.isSameOrAfter = Sz;
Ge.isSameOrBefore = Cz;
Ge.isValid = Vz;
Ge.lang = CO;
Ge.locale = SO;
Ge.localeData = bO;
Ge.max = VW;
Ge.min = NW;
Ge.parsingFlags = Bz;
Ge.set = y$;
Ge.startOf = Az;
Ge.subtract = sz;
Ge.toArray = Zz;
Ge.toObject = Pz;
Ge.toDate = Hz;
Ge.toISOString = Rz;
Ge.inspect = Ez;
typeof Symbol < "u" && Symbol.for != null && (Ge[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Ge.toJSON = Nz;
Ge.toString = _z;
Ge.unix = Iz;
Ge.valueOf = Lz;
Ge.creationData = Uz;
Ge.eraName = zz;
Ge.eraNarrow = qz;
Ge.eraAbbr = Gz;
Ge.eraYear = Kz;
Ge.year = iO;
Ge.isLeapYear = P$;
Ge.weekYear = rq;
Ge.isoWeekYear = aq;
Ge.quarter = Ge.quarters = cq;
Ge.month = rO;
Ge.daysInMonth = I$;
Ge.week = Ge.weeks = Y$;
Ge.isoWeek = Ge.isoWeeks = $$;
Ge.weeksInYear = oq;
Ge.weeksInWeekYear = uq;
Ge.isoWeeksInYear = iq;
Ge.isoWeeksInISOWeekYear = lq;
Ge.date = TO;
Ge.day = Ge.days = aW;
Ge.weekday = iW;
Ge.isoWeekday = lW;
Ge.dayOfYear = fq;
Ge.hour = Ge.hours = hW;
Ge.minute = Ge.minutes = dq;
Ge.second = Ge.seconds = hq;
Ge.millisecond = Ge.milliseconds = OO;
Ge.utcOffset = GW;
Ge.utc = QW;
Ge.local = XW;
Ge.parseZone = JW;
Ge.hasAlignedHourOffset = ez;
Ge.isDST = tz;
Ge.isLocal = rz;
Ge.isUtcOffset = az;
Ge.isUtc = gO;
Ge.isUTC = gO;
Ge.zoneAbbr = pq;
Ge.zoneName = mq;
Ge.dates = Ms(
  "dates accessor is deprecated. Use date instead.",
  TO
);
Ge.months = Ms(
  "months accessor is deprecated. Use month instead",
  rO
);
Ge.years = Ms(
  "years accessor is deprecated. Use year instead",
  iO
);
Ge.zone = Ms(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  KW
);
Ge.isDSTShifted = Ms(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  nz
);
function gq(e) {
  return Xr(e * 1e3);
}
function wq() {
  return Xr.apply(null, arguments).parseZone();
}
function DO(e) {
  return e;
}
var ur = zx.prototype;
ur.calendar = a$;
ur.longDateFormat = u$;
ur.invalidDate = c$;
ur.ordinal = h$;
ur.preparse = DO;
ur.postformat = DO;
ur.relativeTime = p$;
ur.pastFuture = m$;
ur.set = n$;
ur.eras = Yz;
ur.erasParse = $z;
ur.erasConvertYear = Wz;
ur.erasAbbrRegex = Xz;
ur.erasNameRegex = Qz;
ur.erasNarrowRegex = Jz;
ur.months = j$;
ur.monthsShort = A$;
ur.monthsParse = L$;
ur.monthsRegex = Z$;
ur.monthsShortRegex = H$;
ur.week = V$;
ur.firstDayOfYear = U$;
ur.firstDayOfWeek = F$;
ur.weekdays = J$;
ur.weekdaysMin = tW;
ur.weekdaysShort = eW;
ur.weekdaysParse = rW;
ur.weekdaysRegex = oW;
ur.weekdaysShortRegex = uW;
ur.weekdaysMinRegex = sW;
ur.isPM = fW;
ur.meridiem = vW;
function I5(e, t, a, l) {
  var h = xf(), g = P0().set(l, t);
  return h[a](g, e);
}
function jO(e, t, a) {
  if (vf(e) && (t = e, e = void 0), e = e || "", t != null)
    return I5(e, t, a, "month");
  var l, h = [];
  for (l = 0; l < 12; l++)
    h[l] = I5(e, l, a, "month");
  return h;
}
function sS(e, t, a, l) {
  typeof e == "boolean" ? (vf(t) && (a = t, t = void 0), t = t || "") : (t = e, a = t, e = !1, vf(t) && (a = t, t = void 0), t = t || "");
  var h = xf(), g = e ? h._week.dow : 0, m, S = [];
  if (a != null)
    return I5(t, (a + g) % 7, l, "day");
  for (m = 0; m < 7; m++)
    S[m] = I5(t, (m + g) % 7, l, "day");
  return S;
}
function yq(e, t) {
  return jO(e, t, "months");
}
function xq(e, t) {
  return jO(e, t, "monthsShort");
}
function Sq(e, t, a) {
  return sS(e, t, a, "weekdays");
}
function Cq(e, t, a) {
  return sS(e, t, a, "weekdaysShort");
}
function bq(e, t, a) {
  return sS(e, t, a, "weekdaysMin");
}
ch("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, a = _n(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + a;
  }
});
Ke.lang = Ms(
  "moment.lang is deprecated. Use moment.locale instead.",
  ch
);
Ke.langData = Ms(
  "moment.langData is deprecated. Use moment.localeData instead.",
  xf
);
var rf = Math.abs;
function _q() {
  var e = this._data;
  return this._milliseconds = rf(this._milliseconds), this._days = rf(this._days), this._months = rf(this._months), e.milliseconds = rf(e.milliseconds), e.seconds = rf(e.seconds), e.minutes = rf(e.minutes), e.hours = rf(e.hours), e.months = rf(e.months), e.years = rf(e.years), this;
}
function AO(e, t, a, l) {
  var h = E1(t, a);
  return e._milliseconds += l * h._milliseconds, e._days += l * h._days, e._months += l * h._months, e._bubble();
}
function Rq(e, t) {
  return AO(this, e, t, 1);
}
function Eq(e, t) {
  return AO(this, e, t, -1);
}
function IR(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Mq() {
  var e = this._milliseconds, t = this._days, a = this._months, l = this._data, h, g, m, S, b;
  return e >= 0 && t >= 0 && a >= 0 || e <= 0 && t <= 0 && a <= 0 || (e += IR(C8(a) + t) * 864e5, t = 0, a = 0), l.milliseconds = e % 1e3, h = Rs(e / 1e3), l.seconds = h % 60, g = Rs(h / 60), l.minutes = g % 60, m = Rs(g / 60), l.hours = m % 24, t += Rs(m / 24), b = Rs(kO(t)), a += b, t -= IR(C8(b)), S = Rs(a / 12), a %= 12, l.days = t, l.months = a, l.years = S, this;
}
function kO(e) {
  return e * 4800 / 146097;
}
function C8(e) {
  return e * 146097 / 4800;
}
function Tq(e) {
  if (!this.isValid())
    return NaN;
  var t, a, l = this._milliseconds;
  if (e = Ts(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + l / 864e5, a = this._months + kO(t), e) {
      case "month":
        return a;
      case "quarter":
        return a / 3;
      case "year":
        return a / 12;
    }
  else
    switch (t = this._days + Math.round(C8(this._months)), e) {
      case "week":
        return t / 7 + l / 6048e5;
      case "day":
        return t + l / 864e5;
      case "hour":
        return t * 24 + l / 36e5;
      case "minute":
        return t * 1440 + l / 6e4;
      case "second":
        return t * 86400 + l / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + l;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Oq() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + _n(this._months / 12) * 31536e6 : NaN;
}
function Sf(e) {
  return function() {
    return this.as(e);
  };
}
var Dq = Sf("ms"), jq = Sf("s"), Aq = Sf("m"), kq = Sf("h"), Lq = Sf("d"), Iq = Sf("w"), Hq = Sf("M"), Zq = Sf("Q"), Pq = Sf("y");
function Nq() {
  return E1(this);
}
function Vq(e) {
  return e = Ts(e), this.isValid() ? this[e + "s"]() : NaN;
}
function W2(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Bq = W2("milliseconds"), Fq = W2("seconds"), Uq = W2("minutes"), Yq = W2("hours"), $q = W2("days"), Wq = W2("months"), zq = W2("years");
function qq() {
  return Rs(this.days() / 7);
}
var lf = Math.round, Cp = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Gq(e, t, a, l, h) {
  return h.relativeTime(t || 1, !!a, e, l);
}
function Kq(e, t, a, l) {
  var h = E1(e).abs(), g = lf(h.as("s")), m = lf(h.as("m")), S = lf(h.as("h")), b = lf(h.as("d")), R = lf(h.as("M")), D = lf(h.as("w")), T = lf(h.as("y")), j = g <= a.ss && ["s", g] || g < a.s && ["ss", g] || m <= 1 && ["m"] || m < a.m && ["mm", m] || S <= 1 && ["h"] || S < a.h && ["hh", S] || b <= 1 && ["d"] || b < a.d && ["dd", b];
  return a.w != null && (j = j || D <= 1 && ["w"] || D < a.w && ["ww", D]), j = j || R <= 1 && ["M"] || R < a.M && ["MM", R] || T <= 1 && ["y"] || ["yy", T], j[2] = t, j[3] = +e > 0, j[4] = l, Gq.apply(null, j);
}
function Qq(e) {
  return e === void 0 ? lf : typeof e == "function" ? (lf = e, !0) : !1;
}
function Xq(e, t) {
  return Cp[e] === void 0 ? !1 : t === void 0 ? Cp[e] : (Cp[e] = t, e === "s" && (Cp.ss = t - 1), !0);
}
function Jq(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var a = !1, l = Cp, h, g;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (a = e), typeof t == "object" && (l = Object.assign({}, Cp, t), t.s != null && t.ss == null && (l.ss = t.s - 1)), h = this.localeData(), g = Kq(this, !a, l, h), a && (g = h.pastFuture(+this, g)), h.postformat(g);
}
var Uy = Math.abs;
function gp(e) {
  return (e > 0) - (e < 0) || +e;
}
function Lw() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Uy(this._milliseconds) / 1e3, t = Uy(this._days), a = Uy(this._months), l, h, g, m, S = this.asSeconds(), b, R, D, T;
  return S ? (l = Rs(e / 60), h = Rs(l / 60), e %= 60, l %= 60, g = Rs(a / 12), a %= 12, m = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", b = S < 0 ? "-" : "", R = gp(this._months) !== gp(S) ? "-" : "", D = gp(this._days) !== gp(S) ? "-" : "", T = gp(this._milliseconds) !== gp(S) ? "-" : "", b + "P" + (g ? R + g + "Y" : "") + (a ? R + a + "M" : "") + (t ? D + t + "D" : "") + (h || l || e ? "T" : "") + (h ? T + h + "H" : "") + (l ? T + l + "M" : "") + (e ? T + m + "S" : "")) : "P0D";
}
var Qn = Aw.prototype;
Qn.isValid = $W;
Qn.abs = _q;
Qn.add = Rq;
Qn.subtract = Eq;
Qn.as = Tq;
Qn.asMilliseconds = Dq;
Qn.asSeconds = jq;
Qn.asMinutes = Aq;
Qn.asHours = kq;
Qn.asDays = Lq;
Qn.asWeeks = Iq;
Qn.asMonths = Hq;
Qn.asQuarters = Zq;
Qn.asYears = Pq;
Qn.valueOf = Oq;
Qn._bubble = Mq;
Qn.clone = Nq;
Qn.get = Vq;
Qn.milliseconds = Bq;
Qn.seconds = Fq;
Qn.minutes = Uq;
Qn.hours = Yq;
Qn.days = $q;
Qn.weeks = qq;
Qn.months = Wq;
Qn.years = zq;
Qn.humanize = Jq;
Qn.toISOString = Lw;
Qn.toString = Lw;
Qn.toJSON = Lw;
Qn.locale = SO;
Qn.localeData = bO;
Qn.toIsoString = Ms(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Lw
);
Qn.lang = CO;
$t("X", 0, 0, "unix");
$t("x", 0, 0, "valueOf");
Rt("x", Tw);
Rt("X", S$);
jr("X", function(e, t, a) {
  a._d = new Date(parseFloat(e) * 1e3);
});
jr("x", function(e, t, a) {
  a._d = new Date(_n(e));
});
//! moment.js
Ke.version = "2.29.4";
e$(Xr);
Ke.fn = Ge;
Ke.min = BW;
Ke.max = FW;
Ke.now = UW;
Ke.utc = P0;
Ke.unix = gq;
Ke.months = yq;
Ke.isDate = v3;
Ke.locale = ch;
Ke.invalid = bw;
Ke.duration = E1;
Ke.isMoment = R1;
Ke.weekdays = Sq;
Ke.parseZone = wq;
Ke.localeData = xf;
Ke.isDuration = g5;
Ke.monthsShort = xq;
Ke.weekdaysMin = bq;
Ke.defineLocale = tS;
Ke.updateLocale = wW;
Ke.locales = yW;
Ke.weekdaysShort = Cq;
Ke.normalizeUnits = Ts;
Ke.relativeTimeRounding = Qq;
Ke.relativeTimeThreshold = Xq;
Ke.calendarFormat = vz;
Ke.prototype = Ge;
Ke.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
var b8 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, t) {
  (function() {
    var a, l = "4.17.21", h = 200, g = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", m = "Expected a function", S = "Invalid `variable` option passed into `_.template`", b = "__lodash_hash_undefined__", R = 500, D = "__lodash_placeholder__", T = 1, j = 2, A = 4, L = 1, P = 2, N = 1, F = 2, Y = 4, G = 8, z = 16, $ = 32, ce = 64, X = 128, Ce = 256, ae = 512, me = 30, K = "...", we = 800, ue = 16, ge = 1, Te = 2, be = 3, Ue = 1 / 0, le = 9007199254740991, _e = 17976931348623157e292, Pe = NaN, mt = 4294967295, Ze = mt - 1, Nt = mt >>> 1, kt = [
      ["ary", X],
      ["bind", N],
      ["bindKey", F],
      ["curry", G],
      ["curryRight", z],
      ["flip", ae],
      ["partial", $],
      ["partialRight", ce],
      ["rearg", Ce]
    ], Qe = "[object Arguments]", rt = "[object Array]", vt = "[object AsyncFunction]", Ot = "[object Boolean]", yn = "[object Date]", Ar = "[object DOMException]", In = "[object Error]", zn = "[object Function]", er = "[object GeneratorFunction]", wr = "[object Map]", ea = "[object Number]", Ca = "[object Null]", Hr = "[object Object]", xt = "[object Promise]", ln = "[object Proxy]", dn = "[object RegExp]", Vt = "[object Set]", Rn = "[object String]", yr = "[object Symbol]", Xe = "[object Undefined]", Xt = "[object WeakMap]", En = "[object WeakSet]", Cn = "[object ArrayBuffer]", qe = "[object DataView]", wt = "[object Float32Array]", St = "[object Float64Array]", un = "[object Int8Array]", sr = "[object Int16Array]", ta = "[object Int32Array]", xr = "[object Uint8Array]", ji = "[object Uint8ClampedArray]", wn = "[object Uint16Array]", qn = "[object Uint32Array]", M1 = /\b__p \+= '';/g, _l = /\b(__p \+=) '' \+/g, Jo = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zl = /&(?:amp|lt|gt|quot|#39);/g, Eo = /[&<>"']/g, B0 = RegExp(zl.source), T1 = RegExp(Eo.source), Cf = /<%-([\s\S]+?)%>/g, O1 = /<%([\s\S]+?)%>/g, Pu = /<%=([\s\S]+?)%>/g, Mo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, To = /^\w*$/, $i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Oo = /[\\^$.*+?()[\]{}|]/g, eu = RegExp(Oo.source), Ds = /^\s+/, tu = /\s/, ql = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, J = /\{\n\/\* \[wrapped with (.+)\] \*/, $e = /,? & /, ft = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Et = /[()=,{}\[\]\/\s]/, Bn = /\\(\\)?/g, xn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, hn = /\w*$/, vn = /^[-+]0x[0-9a-f]+$/i, Za = /^0b[01]+$/i, Rr = /^\[object .+?Constructor\]$/, Er = /^0o[0-7]+$/i, di = /^(?:0|[1-9]\d*)$/, hi = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Gt = /($^)/, na = /['\n\r\u2028\u2029\\]/g, Xn = "\\ud800-\\udfff", bf = "\\u0300-\\u036f", D1 = "\\ufe20-\\ufe2f", Mh = "\\u20d0-\\u20ff", j1 = bf + D1 + Mh, Th = "\\u2700-\\u27bf", _f = "a-z\\xdf-\\xf6\\xf8-\\xff", F0 = "\\xac\\xb1\\xd7\\xf7", Do = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $p = "\\u2000-\\u206f", Wi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Rf = "A-Z\\xc0-\\xd6\\xd8-\\xde", nu = "\\ufe0e\\ufe0f", Ef = F0 + Do + $p + Wi, ru = "['’]", Mf = "[" + Xn + "]", Nu = "[" + Ef + "]", js = "[" + j1 + "]", Tf = "\\d+", Wp = "[" + Th + "]", A1 = "[" + _f + "]", Oh = "[^" + Xn + Ef + Tf + Th + _f + Rf + "]", k1 = "\\ud83c[\\udffb-\\udfff]", U0 = "(?:" + js + "|" + k1 + ")", Dh = "[^" + Xn + "]", Hn = "(?:\\ud83c[\\udde6-\\uddff]){2}", Fn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Vu = "[" + Rf + "]", en = "\\u200d", Y0 = "(?:" + A1 + "|" + Oh + ")", Ai = "(?:" + Vu + "|" + Oh + ")", As = "(?:" + ru + "(?:d|ll|m|re|s|t|ve))?", ks = "(?:" + ru + "(?:D|LL|M|RE|S|T|VE))?", Of = U0 + "?", va = "[" + nu + "]?", tr = "(?:" + en + "(?:" + [Dh, Hn, Fn].join("|") + ")" + va + Of + ")*", Bu = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Pa = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Na = va + Of + tr, Rl = "(?:" + [Wp, Hn, Fn].join("|") + ")" + Na, Fu = "(?:" + [Dh + js + "?", js, Hn, Fn, Mf].join("|") + ")", jh = RegExp(ru, "g"), Ah = RegExp(js, "g"), Uu = RegExp(k1 + "(?=" + k1 + ")|" + Fu + Na, "g"), zp = RegExp([
      Vu + "?" + A1 + "+" + As + "(?=" + [Nu, Vu, "$"].join("|") + ")",
      Ai + "+" + ks + "(?=" + [Nu, Vu + Y0, "$"].join("|") + ")",
      Vu + "?" + Y0 + "+" + As,
      Vu + "+" + ks,
      Pa,
      Bu,
      Tf,
      Rl
    ].join("|"), "g"), z2 = RegExp("[" + en + Xn + j1 + nu + "]"), Df = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, $0 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], q2 = -1, Zn = {};
    Zn[wt] = Zn[St] = Zn[un] = Zn[sr] = Zn[ta] = Zn[xr] = Zn[ji] = Zn[wn] = Zn[qn] = !0, Zn[Qe] = Zn[rt] = Zn[Cn] = Zn[Ot] = Zn[qe] = Zn[yn] = Zn[In] = Zn[zn] = Zn[wr] = Zn[ea] = Zn[Hr] = Zn[dn] = Zn[Vt] = Zn[Rn] = Zn[Xt] = !1;
    var Un = {};
    Un[Qe] = Un[rt] = Un[Cn] = Un[qe] = Un[Ot] = Un[yn] = Un[wt] = Un[St] = Un[un] = Un[sr] = Un[ta] = Un[wr] = Un[ea] = Un[Hr] = Un[dn] = Un[Vt] = Un[Rn] = Un[yr] = Un[xr] = Un[ji] = Un[wn] = Un[qn] = !0, Un[In] = Un[zn] = Un[Xt] = !1;
    var Ls = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, W0 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, G2 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, K2 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, z0 = parseFloat, q0 = parseInt, G0 = typeof S4 == "object" && S4 && S4.Object === Object && S4, jf = typeof self == "object" && self && self.Object === Object && self, Sr = G0 || jf || Function("return this")(), K0 = t && !t.nodeType && t, jo = K0 && !0 && e && !e.nodeType && e, Q0 = jo && jo.exports === K0, Is = Q0 && G0.process, Xa = function() {
      try {
        var oe = jo && jo.require && jo.require("util").types;
        return oe || Is && Is.binding && Is.binding("util");
      } catch {
      }
    }(), Af = Xa && Xa.isArrayBuffer, vi = Xa && Xa.isDate, Hs = Xa && Xa.isMap, kf = Xa && Xa.isRegExp, ra = Xa && Xa.isSet, Lf = Xa && Xa.isTypedArray;
    function Ja(oe, Re, pe) {
      switch (pe.length) {
        case 0:
          return oe.call(Re);
        case 1:
          return oe.call(Re, pe[0]);
        case 2:
          return oe.call(Re, pe[0], pe[1]);
        case 3:
          return oe.call(Re, pe[0], pe[1], pe[2]);
      }
      return oe.apply(Re, pe);
    }
    function If(oe, Re, pe, Je) {
      for (var zt = -1, Mn = oe == null ? 0 : oe.length; ++zt < Mn; ) {
        var Cr = oe[zt];
        Re(Je, Cr, pe(Cr), oe);
      }
      return Je;
    }
    function ei(oe, Re) {
      for (var pe = -1, Je = oe == null ? 0 : oe.length; ++pe < Je && Re(oe[pe], pe, oe) !== !1; )
        ;
      return oe;
    }
    function au(oe, Re) {
      for (var pe = oe == null ? 0 : oe.length; pe-- && Re(oe[pe], pe, oe) !== !1; )
        ;
      return oe;
    }
    function X0(oe, Re) {
      for (var pe = -1, Je = oe == null ? 0 : oe.length; ++pe < Je; )
        if (!Re(oe[pe], pe, oe))
          return !1;
      return !0;
    }
    function iu(oe, Re) {
      for (var pe = -1, Je = oe == null ? 0 : oe.length, zt = 0, Mn = []; ++pe < Je; ) {
        var Cr = oe[pe];
        Re(Cr, pe, oe) && (Mn[zt++] = Cr);
      }
      return Mn;
    }
    function Hf(oe, Re) {
      var pe = oe == null ? 0 : oe.length;
      return !!pe && Yu(oe, Re, 0) > -1;
    }
    function kh(oe, Re, pe) {
      for (var Je = -1, zt = oe == null ? 0 : oe.length; ++Je < zt; )
        if (pe(Re, oe[Je]))
          return !0;
      return !1;
    }
    function dr(oe, Re) {
      for (var pe = -1, Je = oe == null ? 0 : oe.length, zt = Array(Je); ++pe < Je; )
        zt[pe] = Re(oe[pe], pe, oe);
      return zt;
    }
    function lu(oe, Re) {
      for (var pe = -1, Je = Re.length, zt = oe.length; ++pe < Je; )
        oe[zt + pe] = Re[pe];
      return oe;
    }
    function J0(oe, Re, pe, Je) {
      var zt = -1, Mn = oe == null ? 0 : oe.length;
      for (Je && Mn && (pe = oe[++zt]); ++zt < Mn; )
        pe = Re(pe, oe[zt], zt, oe);
      return pe;
    }
    function Q2(oe, Re, pe, Je) {
      var zt = oe == null ? 0 : oe.length;
      for (Je && zt && (pe = oe[--zt]); zt--; )
        pe = Re(pe, oe[zt], zt, oe);
      return pe;
    }
    function Zf(oe, Re) {
      for (var pe = -1, Je = oe == null ? 0 : oe.length; ++pe < Je; )
        if (Re(oe[pe], pe, oe))
          return !0;
      return !1;
    }
    var X2 = Pf("length");
    function J2(oe) {
      return oe.split("");
    }
    function ou(oe) {
      return oe.match(ft) || [];
    }
    function ev(oe, Re, pe) {
      var Je;
      return pe(oe, function(zt, Mn, Cr) {
        if (Re(zt, Mn, Cr))
          return Je = Mn, !1;
      }), Je;
    }
    function L1(oe, Re, pe, Je) {
      for (var zt = oe.length, Mn = pe + (Je ? 1 : -1); Je ? Mn-- : ++Mn < zt; )
        if (Re(oe[Mn], Mn, oe))
          return Mn;
      return -1;
    }
    function Yu(oe, Re, pe) {
      return Re === Re ? Ff(oe, Re, pe) : L1(oe, tv, pe);
    }
    function ec(oe, Re, pe, Je) {
      for (var zt = pe - 1, Mn = oe.length; ++zt < Mn; )
        if (Je(oe[zt], Re))
          return zt;
      return -1;
    }
    function tv(oe) {
      return oe !== oe;
    }
    function tc(oe, Re) {
      var pe = oe == null ? 0 : oe.length;
      return pe ? Gl(oe, Re) / pe : Pe;
    }
    function Pf(oe) {
      return function(Re) {
        return Re == null ? a : Re[oe];
      };
    }
    function Va(oe) {
      return function(Re) {
        return oe == null ? a : oe[Re];
      };
    }
    function Ao(oe, Re, pe, Je, zt) {
      return zt(oe, function(Mn, Cr, nr) {
        pe = Je ? (Je = !1, Mn) : Re(pe, Mn, Cr, nr);
      }), pe;
    }
    function aa(oe, Re) {
      var pe = oe.length;
      for (oe.sort(Re); pe--; )
        oe[pe] = oe[pe].value;
      return oe;
    }
    function Gl(oe, Re) {
      for (var pe, Je = -1, zt = oe.length; ++Je < zt; ) {
        var Mn = Re(oe[Je]);
        Mn !== a && (pe = pe === a ? Mn : pe + Mn);
      }
      return pe;
    }
    function nc(oe, Re) {
      for (var pe = -1, Je = Array(oe); ++pe < oe; )
        Je[pe] = Re(pe);
      return Je;
    }
    function Nf(oe, Re) {
      return dr(Re, function(pe) {
        return [pe, oe[pe]];
      });
    }
    function nv(oe) {
      return oe && oe.slice(0, Uf(oe) + 1).replace(Ds, "");
    }
    function Ba(oe) {
      return function(Re) {
        return oe(Re);
      };
    }
    function rc(oe, Re) {
      return dr(Re, function(pe) {
        return oe[pe];
      });
    }
    function uu(oe, Re) {
      return oe.has(Re);
    }
    function Vf(oe, Re) {
      for (var pe = -1, Je = oe.length; ++pe < Je && Yu(Re, oe[pe], 0) > -1; )
        ;
      return pe;
    }
    function Lh(oe, Re) {
      for (var pe = oe.length; pe-- && Yu(Re, oe[pe], 0) > -1; )
        ;
      return pe;
    }
    function rv(oe, Re) {
      for (var pe = oe.length, Je = 0; pe--; )
        oe[pe] === Re && ++Je;
      return Je;
    }
    var av = Va(Ls), Ih = Va(W0);
    function iv(oe) {
      return "\\" + K2[oe];
    }
    function I1(oe, Re) {
      return oe == null ? a : oe[Re];
    }
    function H1(oe) {
      return z2.test(oe);
    }
    function lv(oe) {
      return Df.test(oe);
    }
    function Z1(oe) {
      for (var Re, pe = []; !(Re = oe.next()).done; )
        pe.push(Re.value);
      return pe;
    }
    function P1(oe) {
      var Re = -1, pe = Array(oe.size);
      return oe.forEach(function(Je, zt) {
        pe[++Re] = [zt, Je];
      }), pe;
    }
    function Bf(oe, Re) {
      return function(pe) {
        return oe(Re(pe));
      };
    }
    function zi(oe, Re) {
      for (var pe = -1, Je = oe.length, zt = 0, Mn = []; ++pe < Je; ) {
        var Cr = oe[pe];
        (Cr === Re || Cr === D) && (oe[pe] = D, Mn[zt++] = pe);
      }
      return Mn;
    }
    function $u(oe) {
      var Re = -1, pe = Array(oe.size);
      return oe.forEach(function(Je) {
        pe[++Re] = Je;
      }), pe;
    }
    function qp(oe) {
      var Re = -1, pe = Array(oe.size);
      return oe.forEach(function(Je) {
        pe[++Re] = [Je, Je];
      }), pe;
    }
    function Ff(oe, Re, pe) {
      for (var Je = pe - 1, zt = oe.length; ++Je < zt; )
        if (oe[Je] === Re)
          return Je;
      return -1;
    }
    function Gp(oe, Re, pe) {
      for (var Je = pe + 1; Je--; )
        if (oe[Je] === Re)
          return Je;
      return Je;
    }
    function Zs(oe) {
      return H1(oe) ? Hh(oe) : X2(oe);
    }
    function qi(oe) {
      return H1(oe) ? uv(oe) : J2(oe);
    }
    function Uf(oe) {
      for (var Re = oe.length; Re-- && tu.test(oe.charAt(Re)); )
        ;
      return Re;
    }
    var ov = Va(G2);
    function Hh(oe) {
      for (var Re = Uu.lastIndex = 0; Uu.test(oe); )
        ++Re;
      return Re;
    }
    function uv(oe) {
      return oe.match(Uu) || [];
    }
    function sv(oe) {
      return oe.match(zp) || [];
    }
    var Kp = function oe(Re) {
      Re = Re == null ? Sr : N1.defaults(Sr.Object(), Re, N1.pick(Sr, $0));
      var pe = Re.Array, Je = Re.Date, zt = Re.Error, Mn = Re.Function, Cr = Re.Math, nr = Re.Object, ac = Re.RegExp, Qp = Re.String, El = Re.TypeError, su = pe.prototype, Yf = Mn.prototype, ko = nr.prototype, Ps = Re["__core-js_shared__"], pa = Yf.toString, Tn = ko.hasOwnProperty, V1 = 0, $f = function() {
        var s = /[^.]+$/.exec(Ps && Ps.keys && Ps.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), ic = ko.toString, Wf = pa.call(nr), cv = Sr._, Zh = ac(
        "^" + pa.call(Tn).replace(Oo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Ns = Q0 ? Re.Buffer : a, Gi = Re.Symbol, lc = Re.Uint8Array, Vs = Ns ? Ns.allocUnsafe : a, Kl = Bf(nr.getPrototypeOf, nr), zf = nr.create, qf = ko.propertyIsEnumerable, B1 = su.splice, Gf = Gi ? Gi.isConcatSpreadable : a, ki = Gi ? Gi.iterator : a, Ml = Gi ? Gi.toStringTag : a, F1 = function() {
        try {
          var s = Il(nr, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), fv = Re.clearTimeout !== Sr.clearTimeout && Re.clearTimeout, hr = Je && Je.now !== Sr.Date.now && Je.now, Ph = Re.setTimeout !== Sr.setTimeout && Re.setTimeout, Wu = Cr.ceil, cu = Cr.floor, oc = nr.getOwnPropertySymbols, uc = Ns ? Ns.isBuffer : a, U1 = Re.isFinite, sc = su.join, Y1 = Bf(nr.keys, nr), ia = Cr.max, ti = Cr.min, cc = Je.now, Kf = Re.parseInt, fu = Cr.random, fc = su.reverse, $1 = Il(Re, "DataView"), du = Il(Re, "Map"), dc = Il(Re, "Promise"), Ki = Il(Re, "Set"), zu = Il(Re, "WeakMap"), hu = Il(nr, "create"), W1 = zu && new zu(), z1 = {}, hc = Hl($1), qu = Hl(du), dv = Hl(dc), q1 = Hl(Ki), Tl = Hl(zu), Qi = Gi ? Gi.prototype : a, Xi = Qi ? Qi.valueOf : a, Qf = Qi ? Qi.toString : a;
      function H(s) {
        if (ca(s) && !sn(s) && !(s instanceof Kt)) {
          if (s instanceof qt)
            return s;
          if (Tn.call(s, "__wrapped__"))
            return t1(s);
        }
        return new qt(s);
      }
      var Ql = /* @__PURE__ */ function() {
        function s() {
        }
        return function(d) {
          if (!Kr(d))
            return {};
          if (zf)
            return zf(d);
          s.prototype = d;
          var y = new s();
          return s.prototype = a, y;
        };
      }();
      function cr() {
      }
      function qt(s, d) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = a;
      }
      H.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Cf,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: O1,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Pu,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: H
        }
      }, H.prototype = cr.prototype, H.prototype.constructor = H, qt.prototype = Ql(cr.prototype), qt.prototype.constructor = qt;
      function Kt(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = mt, this.__views__ = [];
      }
      function Bs() {
        var s = new Kt(this.__wrapped__);
        return s.__actions__ = _a(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = _a(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = _a(this.__views__), s;
      }
      function Xf() {
        if (this.__filtered__) {
          var s = new Kt(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function pn() {
        var s = this.__wrapped__.value(), d = this.__dir__, y = sn(s), M = d < 0, I = y ? s.length : 0, B = Gh(0, I, this.__views__), q = B.start, te = B.end, se = te - q, je = M ? te : q - 1, Ie = this.__iteratees__, Be = Ie.length, it = 0, Tt = ti(se, this.__takeCount__);
        if (!y || !M && I == se && Tt == se)
          return as(s, this.__actions__);
        var At = [];
        e:
          for (; se-- && it < Tt; ) {
            je += d;
            for (var cn = -1, Yt = s[je]; ++cn < Be; ) {
              var rn = Ie[cn], fn = rn.iteratee, pr = rn.type, ar = fn(Yt);
              if (pr == Te)
                Yt = ar;
              else if (!ar) {
                if (pr == ge)
                  continue e;
                break e;
              }
            }
            At[it++] = Yt;
          }
        return At;
      }
      Kt.prototype = Ql(cr.prototype), Kt.prototype.constructor = Kt;
      function la(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++d < y; ) {
          var M = s[d];
          this.set(M[0], M[1]);
        }
      }
      function Yn() {
        this.__data__ = hu ? hu(null) : {}, this.size = 0;
      }
      function $n(s) {
        var d = this.has(s) && delete this.__data__[s];
        return this.size -= d ? 1 : 0, d;
      }
      function pi(s) {
        var d = this.__data__;
        if (hu) {
          var y = d[s];
          return y === b ? a : y;
        }
        return Tn.call(d, s) ? d[s] : a;
      }
      function Zr(s) {
        var d = this.__data__;
        return hu ? d[s] !== a : Tn.call(d, s);
      }
      function oa(s, d) {
        var y = this.__data__;
        return this.size += this.has(s) ? 0 : 1, y[s] = hu && d === a ? b : d, this;
      }
      la.prototype.clear = Yn, la.prototype.delete = $n, la.prototype.get = pi, la.prototype.has = Zr, la.prototype.set = oa;
      function Fa(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++d < y; ) {
          var M = s[d];
          this.set(M[0], M[1]);
        }
      }
      function G1() {
        this.__data__ = [], this.size = 0;
      }
      function Ua(s) {
        var d = this.__data__, y = Ya(d, s);
        if (y < 0)
          return !1;
        var M = d.length - 1;
        return y == M ? d.pop() : B1.call(d, y, 1), --this.size, !0;
      }
      function Li(s) {
        var d = this.__data__, y = Ya(d, s);
        return y < 0 ? a : d[y][1];
      }
      function Jf(s) {
        return Ya(this.__data__, s) > -1;
      }
      function Nh(s, d) {
        var y = this.__data__, M = Ya(y, s);
        return M < 0 ? (++this.size, y.push([s, d])) : y[M][1] = d, this;
      }
      Fa.prototype.clear = G1, Fa.prototype.delete = Ua, Fa.prototype.get = Li, Fa.prototype.has = Jf, Fa.prototype.set = Nh;
      function Ii(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++d < y; ) {
          var M = s[d];
          this.set(M[0], M[1]);
        }
      }
      function Gu() {
        this.size = 0, this.__data__ = {
          hash: new la(),
          map: new (du || Fa)(),
          string: new la()
        };
      }
      function Xl(s) {
        var d = al(this, s).delete(s);
        return this.size -= d ? 1 : 0, d;
      }
      function Jl(s) {
        return al(this, s).get(s);
      }
      function vc(s) {
        return al(this, s).has(s);
      }
      function ed(s, d) {
        var y = al(this, s), M = y.size;
        return y.set(s, d), this.size += y.size == M ? 0 : 1, this;
      }
      Ii.prototype.clear = Gu, Ii.prototype.delete = Xl, Ii.prototype.get = Jl, Ii.prototype.has = vc, Ii.prototype.set = ed;
      function vu(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.__data__ = new Ii(); ++d < y; )
          this.add(s[d]);
      }
      function Ol(s) {
        return this.__data__.set(s, b), this;
      }
      function eo(s) {
        return this.__data__.has(s);
      }
      vu.prototype.add = vu.prototype.push = Ol, vu.prototype.has = eo;
      function Mr(s) {
        var d = this.__data__ = new Fa(s);
        this.size = d.size;
      }
      function td() {
        this.__data__ = new Fa(), this.size = 0;
      }
      function Lo(s) {
        var d = this.__data__, y = d.delete(s);
        return this.size = d.size, y;
      }
      function Ji(s) {
        return this.__data__.get(s);
      }
      function el(s) {
        return this.__data__.has(s);
      }
      function Fs(s, d) {
        var y = this.__data__;
        if (y instanceof Fa) {
          var M = y.__data__;
          if (!du || M.length < h - 1)
            return M.push([s, d]), this.size = ++y.size, this;
          y = this.__data__ = new Ii(M);
        }
        return y.set(s, d), this.size = y.size, this;
      }
      Mr.prototype.clear = td, Mr.prototype.delete = Lo, Mr.prototype.get = Ji, Mr.prototype.has = el, Mr.prototype.set = Fs;
      function Io(s, d) {
        var y = sn(s), M = !y && o1(s), I = !y && !M && mo(s), B = !y && !M && !I && gs(s), q = y || M || I || B, te = q ? nc(s.length, Qp) : [], se = te.length;
        for (var je in s)
          (d || Tn.call(s, je)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
          (je == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          I && (je == "offset" || je == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          B && (je == "buffer" || je == "byteLength" || je == "byteOffset") || // Skip index properties.
          Or(je, se))) && te.push(je);
        return te;
      }
      function to(s) {
        var d = s.length;
        return d ? s[He(0, d - 1)] : a;
      }
      function Ku(s, d) {
        return e1(_a(s), pu(d, 0, s.length));
      }
      function Vh(s) {
        return e1(_a(s));
      }
      function K1(s, d, y) {
        (y !== a && !Vi(s[d], y) || y === a && !(d in s)) && Ho(s, d, y);
      }
      function Us(s, d, y) {
        var M = s[d];
        (!(Tn.call(s, d) && Vi(M, y)) || y === a && !(d in s)) && Ho(s, d, y);
      }
      function Ya(s, d) {
        for (var y = s.length; y--; )
          if (Vi(s[y][0], d))
            return y;
        return -1;
      }
      function Hi(s, d, y, M) {
        return Zo(s, function(I, B, q) {
          d(M, I, y(I), q);
        }), M;
      }
      function br(s, d) {
        return s && wi(d, ui(d), s);
      }
      function no(s, d) {
        return s && wi(d, Nl(d), s);
      }
      function Ho(s, d, y) {
        d == "__proto__" && F1 ? F1(s, d, {
          configurable: !0,
          enumerable: !0,
          value: y,
          writable: !0
        }) : s[d] = y;
      }
      function $r(s, d) {
        for (var y = -1, M = d.length, I = pe(M), B = s == null; ++y < M; )
          I[y] = B ? a : wm(s, d[y]);
        return I;
      }
      function pu(s, d, y) {
        return s === s && (y !== a && (s = s <= y ? s : y), d !== a && (s = s >= d ? s : d)), s;
      }
      function $a(s, d, y, M, I, B) {
        var q, te = d & T, se = d & j, je = d & A;
        if (y && (q = I ? y(s, M, I, B) : y(s)), q !== a)
          return q;
        if (!Kr(s))
          return s;
        var Ie = sn(s);
        if (Ie) {
          if (q = cs(s), !te)
            return _a(s, q);
        } else {
          var Be = za(s), it = Be == zn || Be == er;
          if (mo(s))
            return _c(s, te);
          if (Be == Hr || Be == Qe || it && !I) {
            if (q = se || it ? {} : Ra(s), !te)
              return se ? Jp(s, no(q, s)) : qs(s, br(q, s));
          } else {
            if (!Un[Be])
              return I ? s : {};
            q = em(s, Be, te);
          }
        }
        B || (B = new Mr());
        var Tt = B.get(s);
        if (Tt)
          return Tt;
        B.set(s, q), gm(s) ? s.forEach(function(Yt) {
          q.add($a(Yt, d, y, Yt, s, B));
        }) : _3(s) && s.forEach(function(Yt, rn) {
          q.set(rn, $a(Yt, d, y, rn, s, B));
        });
        var At = je ? se ? c0 : Dc : se ? Nl : ui, cn = Ie ? a : At(s);
        return ei(cn || s, function(Yt, rn) {
          cn && (rn = Yt, Yt = s[rn]), Us(q, rn, $a(Yt, d, y, rn, s, B));
        }), q;
      }
      function nd(s) {
        var d = ui(s);
        return function(y) {
          return ro(y, s, d);
        };
      }
      function ro(s, d, y) {
        var M = y.length;
        if (s == null)
          return !M;
        for (s = nr(s); M--; ) {
          var I = y[M], B = d[I], q = s[I];
          if (q === a && !(I in s) || !B(q))
            return !1;
        }
        return !0;
      }
      function Bh(s, d, y) {
        if (typeof s != "function")
          throw new El(m);
        return Uo(function() {
          s.apply(a, y);
        }, d);
      }
      function Dl(s, d, y, M) {
        var I = -1, B = Hf, q = !0, te = s.length, se = [], je = d.length;
        if (!te)
          return se;
        y && (d = dr(d, Ba(y))), M ? (B = kh, q = !1) : d.length >= h && (B = uu, q = !1, d = new vu(d));
        e:
          for (; ++I < te; ) {
            var Ie = s[I], Be = y == null ? Ie : y(Ie);
            if (Ie = M || Ie !== 0 ? Ie : 0, q && Be === Be) {
              for (var it = je; it--; )
                if (d[it] === Be)
                  continue e;
              se.push(Ie);
            } else B(d, Be, M) || se.push(Ie);
          }
        return se;
      }
      var Zo = kl(tl), hv = kl(Qu, !0);
      function Po(s, d) {
        var y = !0;
        return Zo(s, function(M, I, B) {
          return y = !!d(M, I, B), y;
        }), y;
      }
      function Pr(s, d, y) {
        for (var M = -1, I = s.length; ++M < I; ) {
          var B = s[M], q = d(B);
          if (q != null && (te === a ? q === q && !sl(q) : y(q, te)))
            var te = q, se = B;
        }
        return se;
      }
      function at(s, d, y, M) {
        var I = s.length;
        for (y = Ft(y), y < 0 && (y = -y > I ? 0 : I + y), M = M === a || M > I ? I : Ft(M), M < 0 && (M += I), M = y > M ? 0 : Zd(M); y < M; )
          s[y++] = d;
        return s;
      }
      function jl(s, d) {
        var y = [];
        return Zo(s, function(M, I, B) {
          d(M, I, B) && y.push(M);
        }), y;
      }
      function Pn(s, d, y, M, I) {
        var B = -1, q = s.length;
        for (y || (y = f0), I || (I = []); ++B < q; ) {
          var te = s[B];
          d > 0 && y(te) ? d > 1 ? Pn(te, d - 1, y, M, I) : lu(I, te) : M || (I[I.length] = te);
        }
        return I;
      }
      var rd = u0(), pc = u0(!0);
      function tl(s, d) {
        return s && rd(s, d, ui);
      }
      function Qu(s, d) {
        return s && pc(s, d, ui);
      }
      function Q1(s, d) {
        return iu(d, function(y) {
          return ms(s[y]);
        });
      }
      function vr(s, d) {
        d = gi(d, s);
        for (var y = 0, M = d.length; s != null && y < M; )
          s = s[ho(d[y++])];
        return y && y == M ? s : a;
      }
      function ad(s, d, y) {
        var M = d(s);
        return sn(s) ? M : lu(M, y(s));
      }
      function Wa(s) {
        return s == null ? s === a ? Xe : Ca : Ml && Ml in nr(s) ? Ni(s) : Js(s);
      }
      function Xu(s, d) {
        return s > d;
      }
      function nl(s, d) {
        return s != null && Tn.call(s, d);
      }
      function ao(s, d) {
        return s != null && d in nr(s);
      }
      function Ju(s, d, y) {
        return s >= ti(d, y) && s < ia(d, y);
      }
      function id(s, d, y) {
        for (var M = y ? kh : Hf, I = s[0].length, B = s.length, q = B, te = pe(B), se = 1 / 0, je = []; q--; ) {
          var Ie = s[q];
          q && d && (Ie = dr(Ie, Ba(d))), se = ti(Ie.length, se), te[q] = !y && (d || I >= 120 && Ie.length >= 120) ? new vu(q && Ie) : a;
        }
        Ie = s[0];
        var Be = -1, it = te[0];
        e:
          for (; ++Be < I && je.length < se; ) {
            var Tt = Ie[Be], At = d ? d(Tt) : Tt;
            if (Tt = y || Tt !== 0 ? Tt : 0, !(it ? uu(it, At) : M(je, At, y))) {
              for (q = B; --q; ) {
                var cn = te[q];
                if (!(cn ? uu(cn, At) : M(s[q], At, y)))
                  continue e;
              }
              it && it.push(At), je.push(Tt);
            }
          }
        return je;
      }
      function mu(s, d, y, M) {
        return tl(s, function(I, B, q) {
          d(M, y(I), B, q);
        }), M;
      }
      function Al(s, d, y) {
        d = gi(d, s), s = Ea(s, d);
        var M = s == null ? s : s[ho(oi(d))];
        return M == null ? a : Ja(M, s, y);
      }
      function ld(s) {
        return ca(s) && Wa(s) == Qe;
      }
      function vv(s) {
        return ca(s) && Wa(s) == Cn;
      }
      function gu(s) {
        return ca(s) && Wa(s) == yn;
      }
      function rl(s, d, y, M, I) {
        return s === d ? !0 : s == null || d == null || !ca(s) && !ca(d) ? s !== s && d !== d : mc(s, d, y, M, rl, I);
      }
      function mc(s, d, y, M, I, B) {
        var q = sn(s), te = sn(d), se = q ? rt : za(s), je = te ? rt : za(d);
        se = se == Qe ? Hr : se, je = je == Qe ? Hr : je;
        var Ie = se == Hr, Be = je == Hr, it = se == je;
        if (it && mo(s)) {
          if (!mo(d))
            return !1;
          q = !0, Ie = !1;
        }
        if (it && !Ie)
          return B || (B = new Mr()), q || gs(s) ? qh(s, d, y, M, I, B) : vd(s, d, se, y, M, I, B);
        if (!(y & L)) {
          var Tt = Ie && Tn.call(s, "__wrapped__"), At = Be && Tn.call(d, "__wrapped__");
          if (Tt || At) {
            var cn = Tt ? s.value() : s, Yt = At ? d.value() : d;
            return B || (B = new Mr()), I(cn, Yt, y, M, B);
          }
        }
        return it ? (B || (B = new Mr()), mv(s, d, y, M, I, B)) : !1;
      }
      function pv(s) {
        return ca(s) && za(s) == wr;
      }
      function X1(s, d, y, M) {
        var I = y.length, B = I, q = !M;
        if (s == null)
          return !B;
        for (s = nr(s); I--; ) {
          var te = y[I];
          if (q && te[2] ? te[1] !== s[te[0]] : !(te[0] in s))
            return !1;
        }
        for (; ++I < B; ) {
          te = y[I];
          var se = te[0], je = s[se], Ie = te[1];
          if (q && te[2]) {
            if (je === a && !(se in s))
              return !1;
          } else {
            var Be = new Mr();
            if (M)
              var it = M(je, Ie, se, s, d, Be);
            if (!(it === a ? rl(Ie, je, L | P, M, Be) : it))
              return !1;
          }
        }
        return !0;
      }
      function Fh(s) {
        if (!Kr(s) || Kh(s))
          return !1;
        var d = ms(s) ? Zh : Rr;
        return d.test(Hl(s));
      }
      function gc(s) {
        return ca(s) && Wa(s) == dn;
      }
      function No(s) {
        return ca(s) && za(s) == Vt;
      }
      function wc(s) {
        return ca(s) && Du(s.length) && !!Zn[Wa(s)];
      }
      function Ys(s) {
        return typeof s == "function" ? s : s == null ? Vl : typeof s == "object" ? sn(s) ? et(s[0], s[1]) : J1(s) : Y3(s);
      }
      function wu(s) {
        if (!oo(s))
          return Y1(s);
        var d = [];
        for (var y in nr(s))
          Tn.call(s, y) && y != "constructor" && d.push(y);
        return d;
      }
      function od(s) {
        if (!Kr(s))
          return d0(s);
        var d = oo(s), y = [];
        for (var M in s)
          M == "constructor" && (d || !Tn.call(s, M)) || y.push(M);
        return y;
      }
      function es(s, d) {
        return s < d;
      }
      function Uh(s, d) {
        var y = -1, M = ul(s) ? pe(s.length) : [];
        return Zo(s, function(I, B, q) {
          M[++y] = d(I, B, q);
        }), M;
      }
      function J1(s) {
        var d = ss(s);
        return d.length == 1 && d[0][2] ? uo(d[0][0], d[0][1]) : function(y) {
          return y === s || X1(y, s, d);
        };
      }
      function et(s, d) {
        return dt(s) && fs(d) ? uo(ho(s), d) : function(y) {
          var M = wm(y, s);
          return M === a && M === d ? ym(y, s) : rl(d, M, L | P);
        };
      }
      function on(s, d, y, M, I) {
        s !== d && rd(d, function(B, q) {
          if (I || (I = new Mr()), Kr(B))
            Nn(s, d, q, y, on, M, I);
          else {
            var te = M ? M(Fo(s, q), B, q + "", s, d, I) : a;
            te === a && (te = B), K1(s, q, te);
          }
        }, Nl);
      }
      function Nn(s, d, y, M, I, B, q) {
        var te = Fo(s, y), se = Fo(d, y), je = q.get(se);
        if (je) {
          K1(s, y, je);
          return;
        }
        var Ie = B ? B(te, se, y + "", s, d, q) : a, Be = Ie === a;
        if (Be) {
          var it = sn(se), Tt = !it && mo(se), At = !it && !Tt && gs(se);
          Ie = se, it || Tt || At ? sn(te) ? Ie = te : wa(te) ? Ie = _a(te) : Tt ? (Be = !1, Ie = _c(se, !0)) : At ? (Be = !1, Ie = ls(se, !0)) : Ie = [] : Yc(se) || o1(se) ? (Ie = te, o1(te) ? Ie = s1(te) : (!Kr(te) || ms(te)) && (Ie = Ra(se))) : Be = !1;
        }
        Be && (q.set(se, Ie), I(Ie, se, M, B, q), q.delete(se)), K1(s, y, Ie);
      }
      function _r(s, d) {
        var y = s.length;
        if (y)
          return d += d < 0 ? y : 0, Or(d, y) ? s[d] : a;
      }
      function Zi(s, d, y) {
        d.length ? d = dr(d, function(B) {
          return sn(B) ? function(q) {
            return vr(q, B.length === 1 ? B[0] : B);
          } : B;
        }) : d = [Vl];
        var M = -1;
        d = dr(d, Ba(Dt()));
        var I = Uh(s, function(B, q, te) {
          var se = dr(d, function(je) {
            return je(B);
          });
          return { criteria: se, index: ++M, value: B };
        });
        return aa(I, function(B, q) {
          return Xp(B, q, y);
        });
      }
      function ud(s, d) {
        return ts(s, d, function(y, M) {
          return ym(s, M);
        });
      }
      function ts(s, d, y) {
        for (var M = -1, I = d.length, B = {}; ++M < I; ) {
          var q = d[M], te = vr(s, q);
          y(te, q) && ni(B, gi(q, s), te);
        }
        return B;
      }
      function kr(s) {
        return function(d) {
          return vr(d, s);
        };
      }
      function Wr(s, d, y, M) {
        var I = M ? ec : Yu, B = -1, q = d.length, te = s;
        for (s === d && (d = _a(d)), y && (te = dr(s, Ba(y))); ++B < q; )
          for (var se = 0, je = d[B], Ie = y ? y(je) : je; (se = I(te, Ie, se, M)) > -1; )
            te !== s && B1.call(te, se, 1), B1.call(s, se, 1);
        return s;
      }
      function zr(s, d) {
        for (var y = s ? d.length : 0, M = y - 1; y--; ) {
          var I = d[y];
          if (y == M || I !== B) {
            var B = I;
            Or(I) ? B1.call(s, I, 1) : t0(s, I);
          }
        }
        return s;
      }
      function He(s, d) {
        return s + cu(fu() * (d - s + 1));
      }
      function Nr(s, d, y, M) {
        for (var I = -1, B = ia(Wu((d - s) / (y || 1)), 0), q = pe(B); B--; )
          q[M ? B : ++I] = s, s += y;
        return q;
      }
      function It(s, d) {
        var y = "";
        if (!s || d < 1 || d > le)
          return y;
        do
          d % 2 && (y += s), d = cu(d / 2), d && (s += s);
        while (d);
        return y;
      }
      function tn(s, d) {
        return il(so(s, d, Vl), s + "");
      }
      function Tr(s) {
        return to(c1(s));
      }
      function yu(s, d) {
        var y = c1(s);
        return e1(y, pu(d, 0, y.length));
      }
      function ni(s, d, y, M) {
        if (!Kr(s))
          return s;
        d = gi(d, s);
        for (var I = -1, B = d.length, q = B - 1, te = s; te != null && ++I < B; ) {
          var se = ho(d[I]), je = y;
          if (se === "__proto__" || se === "constructor" || se === "prototype")
            return s;
          if (I != q) {
            var Ie = te[se];
            je = M ? M(Ie, se, te) : a, je === a && (je = Kr(Ie) ? Ie : Or(d[I + 1]) ? [] : {});
          }
          Us(te, se, je), te = te[se];
        }
        return s;
      }
      var ns = W1 ? function(s, d) {
        return W1.set(s, d), s;
      } : Vl, mi = F1 ? function(s, d) {
        return F1(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Tm(d),
          writable: !0
        });
      } : Vl;
      function ri(s) {
        return e1(c1(s));
      }
      function ba(s, d, y) {
        var M = -1, I = s.length;
        d < 0 && (d = -d > I ? 0 : I + d), y = y > I ? I : y, y < 0 && (y += I), I = d > y ? 0 : y - d >>> 0, d >>>= 0;
        for (var B = pe(I); ++M < I; )
          B[M] = s[M + d];
        return B;
      }
      function yc(s, d) {
        var y;
        return Zo(s, function(M, I, B) {
          return y = d(M, I, B), !y;
        }), !!y;
      }
      function rs(s, d, y) {
        var M = 0, I = s == null ? M : s.length;
        if (typeof d == "number" && d === d && I <= Nt) {
          for (; M < I; ) {
            var B = M + I >>> 1, q = s[B];
            q !== null && !sl(q) && (y ? q <= d : q < d) ? M = B + 1 : I = B;
          }
          return I;
        }
        return e0(s, d, Vl, y);
      }
      function e0(s, d, y, M) {
        var I = 0, B = s == null ? 0 : s.length;
        if (B === 0)
          return 0;
        d = y(d);
        for (var q = d !== d, te = d === null, se = sl(d), je = d === a; I < B; ) {
          var Ie = cu((I + B) / 2), Be = y(s[Ie]), it = Be !== a, Tt = Be === null, At = Be === Be, cn = sl(Be);
          if (q)
            var Yt = M || At;
          else je ? Yt = At && (M || it) : te ? Yt = At && it && (M || !Tt) : se ? Yt = At && it && !Tt && (M || !cn) : Tt || cn ? Yt = !1 : Yt = M ? Be <= d : Be < d;
          Yt ? I = Ie + 1 : B = Ie;
        }
        return ti(B, Ze);
      }
      function xc(s, d) {
        for (var y = -1, M = s.length, I = 0, B = []; ++y < M; ) {
          var q = s[y], te = d ? d(q) : q;
          if (!y || !Vi(te, se)) {
            var se = te;
            B[I++] = q === 0 ? 0 : q;
          }
        }
        return B;
      }
      function Sc(s) {
        return typeof s == "number" ? s : sl(s) ? Pe : +s;
      }
      function ai(s) {
        if (typeof s == "string")
          return s;
        if (sn(s))
          return dr(s, ai) + "";
        if (sl(s))
          return Qf ? Qf.call(s) : "";
        var d = s + "";
        return d == "0" && 1 / s == -1 / 0 ? "-0" : d;
      }
      function io(s, d, y) {
        var M = -1, I = Hf, B = s.length, q = !0, te = [], se = te;
        if (y)
          q = !1, I = kh;
        else if (B >= h) {
          var je = d ? null : Tc(s);
          if (je)
            return $u(je);
          q = !1, I = uu, se = new vu();
        } else
          se = d ? [] : te;
        e:
          for (; ++M < B; ) {
            var Ie = s[M], Be = d ? d(Ie) : Ie;
            if (Ie = y || Ie !== 0 ? Ie : 0, q && Be === Be) {
              for (var it = se.length; it--; )
                if (se[it] === Be)
                  continue e;
              d && se.push(Be), te.push(Ie);
            } else I(se, Be, y) || (se !== te && se.push(Be), te.push(Ie));
          }
        return te;
      }
      function t0(s, d) {
        return d = gi(d, s), s = Ea(s, d), s == null || delete s[ho(oi(d))];
      }
      function Cc(s, d, y, M) {
        return ni(s, d, y(vr(s, d)), M);
      }
      function $s(s, d, y, M) {
        for (var I = s.length, B = M ? I : -1; (M ? B-- : ++B < I) && d(s[B], B, s); )
          ;
        return y ? ba(s, M ? 0 : B, M ? B + 1 : I) : ba(s, M ? B + 1 : 0, M ? I : B);
      }
      function as(s, d) {
        var y = s;
        return y instanceof Kt && (y = y.value()), J0(d, function(M, I) {
          return I.func.apply(I.thisArg, lu([M], I.args));
        }, y);
      }
      function n0(s, d, y) {
        var M = s.length;
        if (M < 2)
          return M ? io(s[0]) : [];
        for (var I = -1, B = pe(M); ++I < M; )
          for (var q = s[I], te = -1; ++te < M; )
            te != I && (B[I] = Dl(B[I] || q, s[te], d, y));
        return io(Pn(B, 1), d, y);
      }
      function Ws(s, d, y) {
        for (var M = -1, I = s.length, B = d.length, q = {}; ++M < I; ) {
          var te = M < B ? d[M] : a;
          y(q, s[M], te);
        }
        return q;
      }
      function is(s) {
        return wa(s) ? s : [];
      }
      function zs(s) {
        return typeof s == "function" ? s : Vl;
      }
      function gi(s, d) {
        return sn(s) ? s : dt(s, d) ? [s] : yd(bn(s));
      }
      var sd = tn;
      function lo(s, d, y) {
        var M = s.length;
        return y = y === a ? M : y, !d && y >= M ? s : ba(s, d, y);
      }
      var bc = fv || function(s) {
        return Sr.clearTimeout(s);
      };
      function _c(s, d) {
        if (d)
          return s.slice();
        var y = s.length, M = Vs ? Vs(y) : new s.constructor(y);
        return s.copy(M), M;
      }
      function r0(s) {
        var d = new s.constructor(s.byteLength);
        return new lc(d).set(new lc(s)), d;
      }
      function a0(s, d) {
        var y = d ? r0(s.buffer) : s.buffer;
        return new s.constructor(y, s.byteOffset, s.byteLength);
      }
      function Yh(s) {
        var d = new s.constructor(s.source, hn.exec(s));
        return d.lastIndex = s.lastIndex, d;
      }
      function i0(s) {
        return Xi ? nr(Xi.call(s)) : {};
      }
      function ls(s, d) {
        var y = d ? r0(s.buffer) : s.buffer;
        return new s.constructor(y, s.byteOffset, s.length);
      }
      function Pi(s, d) {
        if (s !== d) {
          var y = s !== a, M = s === null, I = s === s, B = sl(s), q = d !== a, te = d === null, se = d === d, je = sl(d);
          if (!te && !je && !B && s > d || B && q && se && !te && !je || M && q && se || !y && se || !I)
            return 1;
          if (!M && !B && !je && s < d || je && y && I && !M && !B || te && y && I || !q && I || !se)
            return -1;
        }
        return 0;
      }
      function Xp(s, d, y) {
        for (var M = -1, I = s.criteria, B = d.criteria, q = I.length, te = y.length; ++M < q; ) {
          var se = Pi(I[M], B[M]);
          if (se) {
            if (M >= te)
              return se;
            var je = y[M];
            return se * (je == "desc" ? -1 : 1);
          }
        }
        return s.index - d.index;
      }
      function fr(s, d, y, M) {
        for (var I = -1, B = s.length, q = y.length, te = -1, se = d.length, je = ia(B - q, 0), Ie = pe(se + je), Be = !M; ++te < se; )
          Ie[te] = d[te];
        for (; ++I < q; )
          (Be || I < B) && (Ie[y[I]] = s[I]);
        for (; je--; )
          Ie[te++] = s[I++];
        return Ie;
      }
      function l0(s, d, y, M) {
        for (var I = -1, B = s.length, q = -1, te = y.length, se = -1, je = d.length, Ie = ia(B - te, 0), Be = pe(Ie + je), it = !M; ++I < Ie; )
          Be[I] = s[I];
        for (var Tt = I; ++se < je; )
          Be[Tt + se] = d[se];
        for (; ++q < te; )
          (it || I < B) && (Be[Tt + y[q]] = s[I++]);
        return Be;
      }
      function _a(s, d) {
        var y = -1, M = s.length;
        for (d || (d = pe(M)); ++y < M; )
          d[y] = s[y];
        return d;
      }
      function wi(s, d, y, M) {
        var I = !y;
        y || (y = {});
        for (var B = -1, q = d.length; ++B < q; ) {
          var te = d[B], se = M ? M(y[te], s[te], te, y, s) : a;
          se === a && (se = s[te]), I ? Ho(y, te, se) : Us(y, te, se);
        }
        return y;
      }
      function qs(s, d) {
        return wi(s, rr(s), d);
      }
      function Jp(s, d) {
        return wi(s, gv(s), d);
      }
      function cd(s, d) {
        return function(y, M) {
          var I = sn(y) ? If : Hi, B = d ? d() : {};
          return I(y, s, Dt(M, 2), B);
        };
      }
      function o0(s) {
        return tn(function(d, y) {
          var M = -1, I = y.length, B = I > 1 ? y[I - 1] : a, q = I > 2 ? y[2] : a;
          for (B = s.length > 3 && typeof B == "function" ? (I--, B) : a, q && li(y[0], y[1], q) && (B = I < 3 ? a : B, I = 1), d = nr(d); ++M < I; ) {
            var te = y[M];
            te && s(d, te, M, B);
          }
          return d;
        });
      }
      function kl(s, d) {
        return function(y, M) {
          if (y == null)
            return y;
          if (!ul(y))
            return s(y, M);
          for (var I = y.length, B = d ? I : -1, q = nr(y); (d ? B-- : ++B < I) && M(q[B], B, q) !== !1; )
            ;
          return y;
        };
      }
      function u0(s) {
        return function(d, y, M) {
          for (var I = -1, B = nr(d), q = M(d), te = q.length; te--; ) {
            var se = q[s ? te : ++I];
            if (y(B[se], se, B) === !1)
              break;
          }
          return d;
        };
      }
      function fd(s, d, y) {
        var M = d & N, I = s0(s);
        function B() {
          var q = this && this !== Sr && this instanceof B ? I : s;
          return q.apply(M ? y : this, arguments);
        }
        return B;
      }
      function Rc(s) {
        return function(d) {
          d = bn(d);
          var y = H1(d) ? qi(d) : a, M = y ? y[0] : d.charAt(0), I = y ? lo(y, 1).join("") : d.slice(1);
          return M[s]() + I;
        };
      }
      function os(s) {
        return function(d) {
          return J0(B3(Uv(d).replace(jh, "")), s, "");
        };
      }
      function s0(s) {
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return new s();
            case 1:
              return new s(d[0]);
            case 2:
              return new s(d[0], d[1]);
            case 3:
              return new s(d[0], d[1], d[2]);
            case 4:
              return new s(d[0], d[1], d[2], d[3]);
            case 5:
              return new s(d[0], d[1], d[2], d[3], d[4]);
            case 6:
              return new s(d[0], d[1], d[2], d[3], d[4], d[5]);
            case 7:
              return new s(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
          }
          var y = Ql(s.prototype), M = s.apply(y, d);
          return Kr(M) ? M : y;
        };
      }
      function $h(s, d, y) {
        var M = s0(s);
        function I() {
          for (var B = arguments.length, q = pe(B), te = B, se = qr(I); te--; )
            q[te] = arguments[te];
          var je = B < 3 && q[0] !== se && q[B - 1] !== se ? [] : zi(q, se);
          if (B -= je.length, B < y)
            return ua(
              s,
              d,
              Gs,
              I.placeholder,
              a,
              q,
              je,
              a,
              a,
              y - B
            );
          var Ie = this && this !== Sr && this instanceof I ? M : s;
          return Ja(Ie, this, q);
        }
        return I;
      }
      function Vo(s) {
        return function(d, y, M) {
          var I = nr(d);
          if (!ul(d)) {
            var B = Dt(y, 3);
            d = ui(d), y = function(te) {
              return B(I[te], te, I);
            };
          }
          var q = s(d, y, M);
          return q > -1 ? I[B ? d[q] : q] : a;
        };
      }
      function dd(s) {
        return Ll(function(d) {
          var y = d.length, M = y, I = qt.prototype.thru;
          for (s && d.reverse(); M--; ) {
            var B = d[M];
            if (typeof B != "function")
              throw new El(m);
            if (I && !q && Qs(B) == "wrapper")
              var q = new qt([], !0);
          }
          for (M = q ? M : y; ++M < y; ) {
            B = d[M];
            var te = Qs(B), se = te == "wrapper" ? jc(B) : a;
            se && Ac(se[0]) && se[1] == (X | G | $ | Ce) && !se[4].length && se[9] == 1 ? q = q[Qs(se[0])].apply(q, se[3]) : q = B.length == 1 && Ac(B) ? q[te]() : q.thru(B);
          }
          return function() {
            var je = arguments, Ie = je[0];
            if (q && je.length == 1 && sn(Ie))
              return q.plant(Ie).value();
            for (var Be = 0, it = y ? d[Be].apply(this, je) : Ie; ++Be < y; )
              it = d[Be].call(this, it);
            return it;
          };
        });
      }
      function Gs(s, d, y, M, I, B, q, te, se, je) {
        var Ie = d & X, Be = d & N, it = d & F, Tt = d & (G | z), At = d & ae, cn = it ? a : s0(s);
        function Yt() {
          for (var rn = arguments.length, fn = pe(rn), pr = rn; pr--; )
            fn[pr] = arguments[pr];
          if (Tt)
            var ar = qr(Yt), fl = rv(fn, ar);
          if (M && (fn = fr(fn, M, I, Tt)), B && (fn = l0(fn, B, q, Tt)), rn -= fl, Tt && rn < je) {
            var Wn = zi(fn, ar);
            return ua(
              s,
              d,
              Gs,
              Yt.placeholder,
              y,
              fn,
              Wn,
              te,
              se,
              je - rn
            );
          }
          var Ga = Be ? y : this, si = it ? Ga[s] : s;
          return rn = fn.length, te ? fn = co(fn, te) : At && rn > 1 && fn.reverse(), Ie && se < rn && (fn.length = se), this && this !== Sr && this instanceof Yt && (si = cn || s0(si)), si.apply(Ga, fn);
        }
        return Yt;
      }
      function Wh(s, d) {
        return function(y, M) {
          return mu(y, s, d(M), {});
        };
      }
      function Ec(s, d) {
        return function(y, M) {
          var I;
          if (y === a && M === a)
            return d;
          if (y !== a && (I = y), M !== a) {
            if (I === a)
              return M;
            typeof y == "string" || typeof M == "string" ? (y = ai(y), M = ai(M)) : (y = Sc(y), M = Sc(M)), I = s(y, M);
          }
          return I;
        };
      }
      function Bo(s) {
        return Ll(function(d) {
          return d = dr(d, Ba(Dt())), tn(function(y) {
            var M = this;
            return s(d, function(I) {
              return Ja(I, M, y);
            });
          });
        });
      }
      function xu(s, d) {
        d = d === a ? " " : ai(d);
        var y = d.length;
        if (y < 2)
          return y ? It(d, s) : d;
        var M = It(d, Wu(s / Zs(d)));
        return H1(d) ? lo(qi(M), 0, s).join("") : M.slice(0, s);
      }
      function us(s, d, y, M) {
        var I = d & N, B = s0(s);
        function q() {
          for (var te = -1, se = arguments.length, je = -1, Ie = M.length, Be = pe(Ie + se), it = this && this !== Sr && this instanceof q ? B : s; ++je < Ie; )
            Be[je] = M[je];
          for (; se--; )
            Be[je++] = arguments[++te];
          return Ja(it, I ? y : this, Be);
        }
        return q;
      }
      function Mc(s) {
        return function(d, y, M) {
          return M && typeof M != "number" && li(d, y, M) && (y = M = a), d = u1(d), y === a ? (y = d, d = 0) : y = u1(y), M = M === a ? d < y ? 1 : -1 : u1(M), Nr(d, y, M, s);
        };
      }
      function ii(s) {
        return function(d, y) {
          return typeof d == "string" && typeof y == "string" || (d = cl(d), y = cl(y)), s(d, y);
        };
      }
      function ua(s, d, y, M, I, B, q, te, se, je) {
        var Ie = d & G, Be = Ie ? q : a, it = Ie ? a : q, Tt = Ie ? B : a, At = Ie ? a : B;
        d |= Ie ? $ : ce, d &= ~(Ie ? ce : $), d & Y || (d &= -4);
        var cn = [
          s,
          d,
          I,
          Tt,
          Be,
          At,
          it,
          te,
          se,
          je
        ], Yt = y.apply(a, cn);
        return Ac(s) && gd(Yt, cn), Yt.placeholder = M, wd(Yt, s, d);
      }
      function jt(s) {
        var d = Cr[s];
        return function(y, M) {
          if (y = cl(y), M = M == null ? 0 : ti(Ft(M), 292), M && U1(y)) {
            var I = (bn(y) + "e").split("e"), B = d(I[0] + "e" + (+I[1] + M));
            return I = (bn(B) + "e").split("e"), +(I[0] + "e" + (+I[1] - M));
          }
          return d(y);
        };
      }
      var Tc = Ki && 1 / $u(new Ki([, -0]))[1] == Ue ? function(s) {
        return new Ki(s);
      } : Wc;
      function hd(s) {
        return function(d) {
          var y = za(d);
          return y == wr ? P1(d) : y == Vt ? qp(d) : Nf(d, s(d));
        };
      }
      function Su(s, d, y, M, I, B, q, te) {
        var se = d & F;
        if (!se && typeof s != "function")
          throw new El(m);
        var je = M ? M.length : 0;
        if (je || (d &= -97, M = I = a), q = q === a ? q : ia(Ft(q), 0), te = te === a ? te : Ft(te), je -= I ? I.length : 0, d & ce) {
          var Ie = M, Be = I;
          M = I = a;
        }
        var it = se ? a : jc(s), Tt = [
          s,
          d,
          y,
          M,
          I,
          Ie,
          Be,
          B,
          q,
          te
        ];
        if (it && bu(Tt, it), s = Tt[0], d = Tt[1], y = Tt[2], M = Tt[3], I = Tt[4], te = Tt[9] = Tt[9] === a ? se ? 0 : s.length : ia(Tt[9] - je, 0), !te && d & (G | z) && (d &= -25), !d || d == N)
          var At = fd(s, d, y);
        else d == G || d == z ? At = $h(s, d, te) : (d == $ || d == (N | $)) && !I.length ? At = us(s, d, y, M) : At = Gs.apply(a, Tt);
        var cn = it ? ns : gd;
        return wd(cn(At, Tt), s, d);
      }
      function zh(s, d, y, M) {
        return s === a || Vi(s, ko[y]) && !Tn.call(M, y) ? d : s;
      }
      function Oc(s, d, y, M, I, B) {
        return Kr(s) && Kr(d) && (B.set(d, s), on(s, d, a, Oc, B), B.delete(d)), s;
      }
      function Ks(s) {
        return Yc(s) ? a : s;
      }
      function qh(s, d, y, M, I, B) {
        var q = y & L, te = s.length, se = d.length;
        if (te != se && !(q && se > te))
          return !1;
        var je = B.get(s), Ie = B.get(d);
        if (je && Ie)
          return je == d && Ie == s;
        var Be = -1, it = !0, Tt = y & P ? new vu() : a;
        for (B.set(s, d), B.set(d, s); ++Be < te; ) {
          var At = s[Be], cn = d[Be];
          if (M)
            var Yt = q ? M(cn, At, Be, d, s, B) : M(At, cn, Be, s, d, B);
          if (Yt !== a) {
            if (Yt)
              continue;
            it = !1;
            break;
          }
          if (Tt) {
            if (!Zf(d, function(rn, fn) {
              if (!uu(Tt, fn) && (At === rn || I(At, rn, y, M, B)))
                return Tt.push(fn);
            })) {
              it = !1;
              break;
            }
          } else if (!(At === cn || I(At, cn, y, M, B))) {
            it = !1;
            break;
          }
        }
        return B.delete(s), B.delete(d), it;
      }
      function vd(s, d, y, M, I, B, q) {
        switch (y) {
          case qe:
            if (s.byteLength != d.byteLength || s.byteOffset != d.byteOffset)
              return !1;
            s = s.buffer, d = d.buffer;
          case Cn:
            return !(s.byteLength != d.byteLength || !B(new lc(s), new lc(d)));
          case Ot:
          case yn:
          case ea:
            return Vi(+s, +d);
          case In:
            return s.name == d.name && s.message == d.message;
          case dn:
          case Rn:
            return s == d + "";
          case wr:
            var te = P1;
          case Vt:
            var se = M & L;
            if (te || (te = $u), s.size != d.size && !se)
              return !1;
            var je = q.get(s);
            if (je)
              return je == d;
            M |= P, q.set(s, d);
            var Ie = qh(te(s), te(d), M, I, B, q);
            return q.delete(s), Ie;
          case yr:
            if (Xi)
              return Xi.call(s) == Xi.call(d);
        }
        return !1;
      }
      function mv(s, d, y, M, I, B) {
        var q = y & L, te = Dc(s), se = te.length, je = Dc(d), Ie = je.length;
        if (se != Ie && !q)
          return !1;
        for (var Be = se; Be--; ) {
          var it = te[Be];
          if (!(q ? it in d : Tn.call(d, it)))
            return !1;
        }
        var Tt = B.get(s), At = B.get(d);
        if (Tt && At)
          return Tt == d && At == s;
        var cn = !0;
        B.set(s, d), B.set(d, s);
        for (var Yt = q; ++Be < se; ) {
          it = te[Be];
          var rn = s[it], fn = d[it];
          if (M)
            var pr = q ? M(fn, rn, it, d, s, B) : M(rn, fn, it, s, d, B);
          if (!(pr === a ? rn === fn || I(rn, fn, y, M, B) : pr)) {
            cn = !1;
            break;
          }
          Yt || (Yt = it == "constructor");
        }
        if (cn && !Yt) {
          var ar = s.constructor, fl = d.constructor;
          ar != fl && "constructor" in s && "constructor" in d && !(typeof ar == "function" && ar instanceof ar && typeof fl == "function" && fl instanceof fl) && (cn = !1);
        }
        return B.delete(s), B.delete(d), cn;
      }
      function Ll(s) {
        return il(so(s, a, Sd), s + "");
      }
      function Dc(s) {
        return ad(s, ui, rr);
      }
      function c0(s) {
        return ad(s, Nl, gv);
      }
      var jc = W1 ? function(s) {
        return W1.get(s);
      } : Wc;
      function Qs(s) {
        for (var d = s.name + "", y = z1[d], M = Tn.call(z1, d) ? y.length : 0; M--; ) {
          var I = y[M], B = I.func;
          if (B == null || B == s)
            return I.name;
        }
        return d;
      }
      function qr(s) {
        var d = Tn.call(H, "placeholder") ? H : s;
        return d.placeholder;
      }
      function Dt() {
        var s = H.iteratee || Om;
        return s = s === Om ? Ys : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function al(s, d) {
        var y = s.__data__;
        return Xs(d) ? y[typeof d == "string" ? "string" : "hash"] : y.map;
      }
      function ss(s) {
        for (var d = ui(s), y = d.length; y--; ) {
          var M = d[y], I = s[M];
          d[y] = [M, I, fs(I)];
        }
        return d;
      }
      function Il(s, d) {
        var y = I1(s, d);
        return Fh(y) ? y : a;
      }
      function Ni(s) {
        var d = Tn.call(s, Ml), y = s[Ml];
        try {
          s[Ml] = a;
          var M = !0;
        } catch {
        }
        var I = ic.call(s);
        return M && (d ? s[Ml] = y : delete s[Ml]), I;
      }
      var rr = oc ? function(s) {
        return s == null ? [] : (s = nr(s), iu(oc(s), function(d) {
          return qf.call(s, d);
        }));
      } : Am, gv = oc ? function(s) {
        for (var d = []; s; )
          lu(d, rr(s)), s = Kl(s);
        return d;
      } : Am, za = Wa;
      ($1 && za(new $1(new ArrayBuffer(1))) != qe || du && za(new du()) != wr || dc && za(dc.resolve()) != xt || Ki && za(new Ki()) != Vt || zu && za(new zu()) != Xt) && (za = function(s) {
        var d = Wa(s), y = d == Hr ? s.constructor : a, M = y ? Hl(y) : "";
        if (M)
          switch (M) {
            case hc:
              return qe;
            case qu:
              return wr;
            case dv:
              return xt;
            case q1:
              return Vt;
            case Tl:
              return Xt;
          }
        return d;
      });
      function Gh(s, d, y) {
        for (var M = -1, I = y.length; ++M < I; ) {
          var B = y[M], q = B.size;
          switch (B.type) {
            case "drop":
              s += q;
              break;
            case "dropRight":
              d -= q;
              break;
            case "take":
              d = ti(d, s + q);
              break;
            case "takeRight":
              s = ia(s, d - q);
              break;
          }
        }
        return { start: s, end: d };
      }
      function pd(s) {
        var d = s.match(J);
        return d ? d[1].split($e) : [];
      }
      function md(s, d, y) {
        d = gi(d, s);
        for (var M = -1, I = d.length, B = !1; ++M < I; ) {
          var q = ho(d[M]);
          if (!(B = s != null && y(s, q)))
            break;
          s = s[q];
        }
        return B || ++M != I ? B : (I = s == null ? 0 : s.length, !!I && Du(I) && Or(q, I) && (sn(s) || o1(s)));
      }
      function cs(s) {
        var d = s.length, y = new s.constructor(d);
        return d && typeof s[0] == "string" && Tn.call(s, "index") && (y.index = s.index, y.input = s.input), y;
      }
      function Ra(s) {
        return typeof s.constructor == "function" && !oo(s) ? Ql(Kl(s)) : {};
      }
      function em(s, d, y) {
        var M = s.constructor;
        switch (d) {
          case Cn:
            return r0(s);
          case Ot:
          case yn:
            return new M(+s);
          case qe:
            return a0(s, y);
          case wt:
          case St:
          case un:
          case sr:
          case ta:
          case xr:
          case ji:
          case wn:
          case qn:
            return ls(s, y);
          case wr:
            return new M();
          case ea:
          case Rn:
            return new M(s);
          case dn:
            return Yh(s);
          case Vt:
            return new M();
          case yr:
            return i0(s);
        }
      }
      function tm(s, d) {
        var y = d.length;
        if (!y)
          return s;
        var M = y - 1;
        return d[M] = (y > 1 ? "& " : "") + d[M], d = d.join(y > 2 ? ", " : " "), s.replace(ql, `{
/* [wrapped with ` + d + `] */
`);
      }
      function f0(s) {
        return sn(s) || o1(s) || !!(Gf && s && s[Gf]);
      }
      function Or(s, d) {
        var y = typeof s;
        return d = d ?? le, !!d && (y == "number" || y != "symbol" && di.test(s)) && s > -1 && s % 1 == 0 && s < d;
      }
      function li(s, d, y) {
        if (!Kr(y))
          return !1;
        var M = typeof d;
        return (M == "number" ? ul(y) && Or(d, y.length) : M == "string" && d in y) ? Vi(y[d], s) : !1;
      }
      function dt(s, d) {
        if (sn(s))
          return !1;
        var y = typeof s;
        return y == "number" || y == "symbol" || y == "boolean" || s == null || sl(s) ? !0 : To.test(s) || !Mo.test(s) || d != null && s in nr(d);
      }
      function Xs(s) {
        var d = typeof s;
        return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? s !== "__proto__" : s === null;
      }
      function Ac(s) {
        var d = Qs(s), y = H[d];
        if (typeof y != "function" || !(d in Kt.prototype))
          return !1;
        if (s === y)
          return !0;
        var M = jc(y);
        return !!M && s === M[0];
      }
      function Kh(s) {
        return !!$f && $f in s;
      }
      var nm = Ps ? ms : km;
      function oo(s) {
        var d = s && s.constructor, y = typeof d == "function" && d.prototype || ko;
        return s === y;
      }
      function fs(s) {
        return s === s && !Kr(s);
      }
      function uo(s, d) {
        return function(y) {
          return y == null ? !1 : y[s] === d && (d !== a || s in nr(y));
        };
      }
      function Cu(s) {
        var d = ze(s, function(M) {
          return y.size === R && y.clear(), M;
        }), y = d.cache;
        return d;
      }
      function bu(s, d) {
        var y = s[1], M = d[1], I = y | M, B = I < (N | F | X), q = M == X && y == G || M == X && y == Ce && s[7].length <= d[8] || M == (X | Ce) && d[7].length <= d[8] && y == G;
        if (!(B || q))
          return s;
        M & N && (s[2] = d[2], I |= y & N ? 0 : Y);
        var te = d[3];
        if (te) {
          var se = s[3];
          s[3] = se ? fr(se, te, d[4]) : te, s[4] = se ? zi(s[3], D) : d[4];
        }
        return te = d[5], te && (se = s[5], s[5] = se ? l0(se, te, d[6]) : te, s[6] = se ? zi(s[5], D) : d[6]), te = d[7], te && (s[7] = te), M & X && (s[8] = s[8] == null ? d[8] : ti(s[8], d[8])), s[9] == null && (s[9] = d[9]), s[0] = d[0], s[1] = I, s;
      }
      function d0(s) {
        var d = [];
        if (s != null)
          for (var y in nr(s))
            d.push(y);
        return d;
      }
      function Js(s) {
        return ic.call(s);
      }
      function so(s, d, y) {
        return d = ia(d === a ? s.length - 1 : d, 0), function() {
          for (var M = arguments, I = -1, B = ia(M.length - d, 0), q = pe(B); ++I < B; )
            q[I] = M[d + I];
          I = -1;
          for (var te = pe(d + 1); ++I < d; )
            te[I] = M[I];
          return te[d] = y(q), Ja(s, this, te);
        };
      }
      function Ea(s, d) {
        return d.length < 2 ? s : vr(s, ba(d, 0, -1));
      }
      function co(s, d) {
        for (var y = s.length, M = ti(d.length, y), I = _a(s); M--; ) {
          var B = d[M];
          s[M] = Or(B, y) ? I[B] : a;
        }
        return s;
      }
      function Fo(s, d) {
        if (!(d === "constructor" && typeof s[d] == "function") && d != "__proto__")
          return s[d];
      }
      var gd = fo(ns), Uo = Ph || function(s, d) {
        return Sr.setTimeout(s, d);
      }, il = fo(mi);
      function wd(s, d, y) {
        var M = d + "";
        return il(s, tm(M, h0(pd(M), y)));
      }
      function fo(s) {
        var d = 0, y = 0;
        return function() {
          var M = cc(), I = ue - (M - y);
          if (y = M, I > 0) {
            if (++d >= we)
              return arguments[0];
          } else
            d = 0;
          return s.apply(a, arguments);
        };
      }
      function e1(s, d) {
        var y = -1, M = s.length, I = M - 1;
        for (d = d === a ? M : d; ++y < d; ) {
          var B = He(y, I), q = s[B];
          s[B] = s[y], s[y] = q;
        }
        return s.length = d, s;
      }
      var yd = Cu(function(s) {
        var d = [];
        return s.charCodeAt(0) === 46 && d.push(""), s.replace($i, function(y, M, I, B) {
          d.push(I ? B.replace(Bn, "$1") : M || y);
        }), d;
      });
      function ho(s) {
        if (typeof s == "string" || sl(s))
          return s;
        var d = s + "";
        return d == "0" && 1 / s == -1 / 0 ? "-0" : d;
      }
      function Hl(s) {
        if (s != null) {
          try {
            return pa.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function h0(s, d) {
        return ei(kt, function(y) {
          var M = "_." + y[0];
          d & y[1] && !Hf(s, M) && s.push(M);
        }), s.sort();
      }
      function t1(s) {
        if (s instanceof Kt)
          return s.clone();
        var d = new qt(s.__wrapped__, s.__chain__);
        return d.__actions__ = _a(s.__actions__), d.__index__ = s.__index__, d.__values__ = s.__values__, d;
      }
      function v0(s, d, y) {
        (y ? li(s, d, y) : d === a) ? d = 1 : d = ia(Ft(d), 0);
        var M = s == null ? 0 : s.length;
        if (!M || d < 1)
          return [];
        for (var I = 0, B = 0, q = pe(Wu(M / d)); I < M; )
          q[B++] = ba(s, I, I += d);
        return q;
      }
      function xd(s) {
        for (var d = -1, y = s == null ? 0 : s.length, M = 0, I = []; ++d < y; ) {
          var B = s[d];
          B && (I[M++] = B);
        }
        return I;
      }
      function Zl() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var d = pe(s - 1), y = arguments[0], M = s; M--; )
          d[M - 1] = arguments[M];
        return lu(sn(y) ? _a(y) : [y], Pn(d, 1));
      }
      var On = tn(function(s, d) {
        return wa(s) ? Dl(s, Pn(d, 1, wa, !0)) : [];
      }), Ma = tn(function(s, d) {
        var y = oi(d);
        return wa(y) && (y = a), wa(s) ? Dl(s, Pn(d, 1, wa, !0), Dt(y, 2)) : [];
      }), sa = tn(function(s, d) {
        var y = oi(d);
        return wa(y) && (y = a), wa(s) ? Dl(s, Pn(d, 1, wa, !0), a, y) : [];
      });
      function ma(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (d = y || d === a ? 1 : Ft(d), ba(s, d < 0 ? 0 : d, M)) : [];
      }
      function ll(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (d = y || d === a ? 1 : Ft(d), d = M - d, ba(s, 0, d < 0 ? 0 : d)) : [];
      }
      function _u(s, d) {
        return s && s.length ? $s(s, Dt(d, 3), !0, !0) : [];
      }
      function Gr(s, d) {
        return s && s.length ? $s(s, Dt(d, 3), !0) : [];
      }
      function p0(s, d, y, M) {
        var I = s == null ? 0 : s.length;
        return I ? (y && typeof y != "number" && li(s, d, y) && (y = 0, M = I), at(s, d, y, M)) : [];
      }
      function ds(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = y == null ? 0 : Ft(y);
        return I < 0 && (I = ia(M + I, 0)), L1(s, Dt(d, 3), I);
      }
      function kc(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = M - 1;
        return y !== a && (I = Ft(y), I = y < 0 ? ia(M + I, 0) : ti(I, M - 1)), L1(s, Dt(d, 3), I, !0);
      }
      function Sd(s) {
        var d = s == null ? 0 : s.length;
        return d ? Pn(s, 1) : [];
      }
      function Lc(s) {
        var d = s == null ? 0 : s.length;
        return d ? Pn(s, Ue) : [];
      }
      function Ta(s, d) {
        var y = s == null ? 0 : s.length;
        return y ? (d = d === a ? 1 : Ft(d), Pn(s, d)) : [];
      }
      function Ic(s) {
        for (var d = -1, y = s == null ? 0 : s.length, M = {}; ++d < y; ) {
          var I = s[d];
          M[I[0]] = I[1];
        }
        return M;
      }
      function vo(s) {
        return s && s.length ? s[0] : a;
      }
      function Ru(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = y == null ? 0 : Ft(y);
        return I < 0 && (I = ia(M + I, 0)), Yu(s, d, I);
      }
      function Cd(s) {
        var d = s == null ? 0 : s.length;
        return d ? ba(s, 0, -1) : [];
      }
      var bd = tn(function(s) {
        var d = dr(s, is);
        return d.length && d[0] === s[0] ? id(d) : [];
      }), Eu = tn(function(s) {
        var d = oi(s), y = dr(s, is);
        return d === oi(y) ? d = a : y.pop(), y.length && y[0] === s[0] ? id(y, Dt(d, 2)) : [];
      }), n1 = tn(function(s) {
        var d = oi(s), y = dr(s, is);
        return d = typeof d == "function" ? d : a, d && y.pop(), y.length && y[0] === s[0] ? id(y, a, d) : [];
      });
      function po(s, d) {
        return s == null ? "" : sc.call(s, d);
      }
      function oi(s) {
        var d = s == null ? 0 : s.length;
        return d ? s[d - 1] : a;
      }
      function qa(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = M;
        return y !== a && (I = Ft(y), I = I < 0 ? ia(M + I, 0) : ti(I, M - 1)), d === d ? Gp(s, d, I) : L1(s, tv, I, !0);
      }
      function hs(s, d) {
        return s && s.length ? _r(s, Ft(d)) : a;
      }
      var m0 = tn(Mu);
      function Mu(s, d) {
        return s && s.length && d && d.length ? Wr(s, d) : s;
      }
      function yi(s, d, y) {
        return s && s.length && d && d.length ? Wr(s, d, Dt(y, 2)) : s;
      }
      function Yo(s, d, y) {
        return s && s.length && d && d.length ? Wr(s, d, a, y) : s;
      }
      var ol = Ll(function(s, d) {
        var y = s == null ? 0 : s.length, M = $r(s, d);
        return zr(s, dr(d, function(I) {
          return Or(I, y) ? +I : I;
        }).sort(Pi)), M;
      });
      function Oa(s, d) {
        var y = [];
        if (!(s && s.length))
          return y;
        var M = -1, I = [], B = s.length;
        for (d = Dt(d, 3); ++M < B; ) {
          var q = s[M];
          d(q, M, s) && (y.push(q), I.push(M));
        }
        return zr(s, I), y;
      }
      function _d(s) {
        return s == null ? s : fc.call(s);
      }
      function g0(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (y && typeof y != "number" && li(s, d, y) ? (d = 0, y = M) : (d = d == null ? 0 : Ft(d), y = y === a ? M : Ft(y)), ba(s, d, y)) : [];
      }
      function Rd(s, d) {
        return rs(s, d);
      }
      function rm(s, d, y) {
        return e0(s, d, Dt(y, 2));
      }
      function vs(s, d) {
        var y = s == null ? 0 : s.length;
        if (y) {
          var M = rs(s, d);
          if (M < y && Vi(s[M], d))
            return M;
        }
        return -1;
      }
      function wv(s, d) {
        return rs(s, d, !0);
      }
      function Hc(s, d, y) {
        return e0(s, d, Dt(y, 2), !0);
      }
      function r1(s, d) {
        var y = s == null ? 0 : s.length;
        if (y) {
          var M = rs(s, d, !0) - 1;
          if (Vi(s[M], d))
            return M;
        }
        return -1;
      }
      function Qh(s) {
        return s && s.length ? xc(s) : [];
      }
      function a1(s, d) {
        return s && s.length ? xc(s, Dt(d, 2)) : [];
      }
      function yv(s) {
        var d = s == null ? 0 : s.length;
        return d ? ba(s, 1, d) : [];
      }
      function xv(s, d, y) {
        return s && s.length ? (d = y || d === a ? 1 : Ft(d), ba(s, 0, d < 0 ? 0 : d)) : [];
      }
      function Ed(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (d = y || d === a ? 1 : Ft(d), d = M - d, ba(s, d < 0 ? 0 : d, M)) : [];
      }
      function Md(s, d) {
        return s && s.length ? $s(s, Dt(d, 3), !1, !0) : [];
      }
      function am(s, d) {
        return s && s.length ? $s(s, Dt(d, 3)) : [];
      }
      var im = tn(function(s) {
        return io(Pn(s, 1, wa, !0));
      }), Sv = tn(function(s) {
        var d = oi(s);
        return wa(d) && (d = a), io(Pn(s, 1, wa, !0), Dt(d, 2));
      }), Cv = tn(function(s) {
        var d = oi(s);
        return d = typeof d == "function" ? d : a, io(Pn(s, 1, wa, !0), a, d);
      });
      function i1(s) {
        return s && s.length ? io(s) : [];
      }
      function Xh(s, d) {
        return s && s.length ? io(s, Dt(d, 2)) : [];
      }
      function w0(s, d) {
        return d = typeof d == "function" ? d : a, s && s.length ? io(s, a, d) : [];
      }
      function Td(s) {
        if (!(s && s.length))
          return [];
        var d = 0;
        return s = iu(s, function(y) {
          if (wa(y))
            return d = ia(y.length, d), !0;
        }), nc(d, function(y) {
          return dr(s, Pf(y));
        });
      }
      function Lr(s, d) {
        if (!(s && s.length))
          return [];
        var y = Td(s);
        return d == null ? y : dr(y, function(M) {
          return Ja(d, a, M);
        });
      }
      var bv = tn(function(s, d) {
        return wa(s) ? Dl(s, d) : [];
      }), _v = tn(function(s) {
        return n0(iu(s, wa));
      }), lm = tn(function(s) {
        var d = oi(s);
        return wa(d) && (d = a), n0(iu(s, wa), Dt(d, 2));
      }), om = tn(function(s) {
        var d = oi(s);
        return d = typeof d == "function" ? d : a, n0(iu(s, wa), a, d);
      }), Rv = tn(Td);
      function Ev(s, d) {
        return Ws(s || [], d || [], Us);
      }
      function um(s, d) {
        return Ws(s || [], d || [], ni);
      }
      var Pl = tn(function(s) {
        var d = s.length, y = d > 1 ? s[d - 1] : a;
        return y = typeof y == "function" ? (s.pop(), y) : a, Lr(s, y);
      });
      function Zc(s) {
        var d = H(s);
        return d.__chain__ = !0, d;
      }
      function Jh(s, d) {
        return d(s), s;
      }
      function xi(s, d) {
        return d(s);
      }
      var Od = Ll(function(s) {
        var d = s.length, y = d ? s[0] : 0, M = this.__wrapped__, I = function(B) {
          return $r(B, s);
        };
        return d > 1 || this.__actions__.length || !(M instanceof Kt) || !Or(y) ? this.thru(I) : (M = M.slice(y, +y + (d ? 1 : 0)), M.__actions__.push({
          func: xi,
          args: [I],
          thisArg: a
        }), new qt(M, this.__chain__).thru(function(B) {
          return d && !B.length && B.push(a), B;
        }));
      });
      function ps() {
        return Zc(this);
      }
      function Pc() {
        return new qt(this.value(), this.__chain__);
      }
      function Dd() {
        this.__values__ === a && (this.__values__ = T3(this.value()));
        var s = this.__index__ >= this.__values__.length, d = s ? a : this.__values__[this.__index__++];
        return { done: s, value: d };
      }
      function e2() {
        return this;
      }
      function Mv(s) {
        for (var d, y = this; y instanceof cr; ) {
          var M = t1(y);
          M.__index__ = 0, M.__values__ = a, d ? I.__wrapped__ = M : d = M;
          var I = M;
          y = y.__wrapped__;
        }
        return I.__wrapped__ = s, d;
      }
      function t2() {
        var s = this.__wrapped__;
        if (s instanceof Kt) {
          var d = s;
          return this.__actions__.length && (d = new Kt(this)), d = d.reverse(), d.__actions__.push({
            func: xi,
            args: [_d],
            thisArg: a
          }), new qt(d, this.__chain__);
        }
        return this.thru(_d);
      }
      function sm() {
        return as(this.__wrapped__, this.__actions__);
      }
      var Tv = cd(function(s, d, y) {
        Tn.call(s, y) ? ++s[y] : Ho(s, y, 1);
      });
      function n2(s, d, y) {
        var M = sn(s) ? X0 : Po;
        return y && li(s, d, y) && (d = a), M(s, Dt(d, 3));
      }
      function Nc(s, d) {
        var y = sn(s) ? iu : jl;
        return y(s, Dt(d, 3));
      }
      var Vc = Vo(ds), l1 = Vo(kc);
      function r2(s, d) {
        return Pn(Fc(s, d), 1);
      }
      function Ov(s, d) {
        return Pn(Fc(s, d), Ue);
      }
      function a2(s, d, y) {
        return y = y === a ? 1 : Ft(y), Pn(Fc(s, d), y);
      }
      function Bc(s, d) {
        var y = sn(s) ? ei : Zo;
        return y(s, Dt(d, 3));
      }
      function jd(s, d) {
        var y = sn(s) ? au : hv;
        return y(s, Dt(d, 3));
      }
      var Ad = cd(function(s, d, y) {
        Tn.call(s, y) ? s[y].push(d) : Ho(s, y, [d]);
      });
      function i2(s, d, y, M) {
        s = ul(s) ? s : c1(s), y = y && !M ? Ft(y) : 0;
        var I = s.length;
        return y < 0 && (y = ia(I + y, 0)), s2(s) ? y <= I && s.indexOf(d, y) > -1 : !!I && Yu(s, d, y) > -1;
      }
      var cm = tn(function(s, d, y) {
        var M = -1, I = typeof d == "function", B = ul(s) ? pe(s.length) : [];
        return Zo(s, function(q) {
          B[++M] = I ? Ja(d, q, y) : Al(q, d, y);
        }), B;
      }), kd = cd(function(s, d, y) {
        Ho(s, y, d);
      });
      function Fc(s, d) {
        var y = sn(s) ? dr : Uh;
        return y(s, Dt(d, 3));
      }
      function Tu(s, d, y, M) {
        return s == null ? [] : (sn(d) || (d = d == null ? [] : [d]), y = M ? a : y, sn(y) || (y = y == null ? [] : [y]), Zi(s, d, y));
      }
      var Uc = cd(function(s, d, y) {
        s[y ? 0 : 1].push(d);
      }, function() {
        return [[], []];
      });
      function Ld(s, d, y) {
        var M = sn(s) ? J0 : Ao, I = arguments.length < 3;
        return M(s, Dt(d, 4), y, I, Zo);
      }
      function i(s, d, y) {
        var M = sn(s) ? Q2 : Ao, I = arguments.length < 3;
        return M(s, Dt(d, 4), y, I, hv);
      }
      function o(s, d) {
        var y = sn(s) ? iu : jl;
        return y(s, bt(Dt(d, 3)));
      }
      function v(s) {
        var d = sn(s) ? to : Tr;
        return d(s);
      }
      function w(s, d, y) {
        (y ? li(s, d, y) : d === a) ? d = 1 : d = Ft(d);
        var M = sn(s) ? Ku : yu;
        return M(s, d);
      }
      function C(s) {
        var d = sn(s) ? Vh : ri;
        return d(s);
      }
      function E(s) {
        if (s == null)
          return 0;
        if (ul(s))
          return s2(s) ? Zs(s) : s.length;
        var d = za(s);
        return d == wr || d == Vt ? s.size : wu(s).length;
      }
      function Z(s, d, y) {
        var M = sn(s) ? Zf : yc;
        return y && li(s, d, y) && (d = a), M(s, Dt(d, 3));
      }
      var W = tn(function(s, d) {
        if (s == null)
          return [];
        var y = d.length;
        return y > 1 && li(s, d[0], d[1]) ? d = [] : y > 2 && li(d[0], d[1], d[2]) && (d = [d[0]]), Zi(s, Pn(d, 1), []);
      }), ee = hr || function() {
        return Sr.Date.now();
      };
      function xe(s, d) {
        if (typeof d != "function")
          throw new El(m);
        return s = Ft(s), function() {
          if (--s < 1)
            return d.apply(this, arguments);
        };
      }
      function Ve(s, d, y) {
        return d = y ? a : d, d = s && d == null ? s.length : d, Su(s, X, a, a, a, a, d);
      }
      function Ye(s, d) {
        var y;
        if (typeof d != "function")
          throw new El(m);
        return s = Ft(s), function() {
          return --s > 0 && (y = d.apply(this, arguments)), s <= 1 && (d = a), y;
        };
      }
      var Ne = tn(function(s, d, y) {
        var M = N;
        if (y.length) {
          var I = zi(y, qr(Ne));
          M |= $;
        }
        return Su(s, M, d, y, I);
      }), ot = tn(function(s, d, y) {
        var M = N | F;
        if (y.length) {
          var I = zi(y, qr(ot));
          M |= $;
        }
        return Su(d, M, s, y, I);
      });
      function yt(s, d, y) {
        d = y ? a : d;
        var M = Su(s, G, a, a, a, a, a, d);
        return M.placeholder = yt.placeholder, M;
      }
      function Ct(s, d, y) {
        d = y ? a : d;
        var M = Su(s, z, a, a, a, a, a, d);
        return M.placeholder = Ct.placeholder, M;
      }
      function Vr(s, d, y) {
        var M, I, B, q, te, se, je = 0, Ie = !1, Be = !1, it = !0;
        if (typeof s != "function")
          throw new El(m);
        d = cl(d) || 0, Kr(y) && (Ie = !!y.leading, Be = "maxWait" in y, B = Be ? ia(cl(y.maxWait) || 0, d) : B, it = "trailing" in y ? !!y.trailing : it);
        function Tt(Wn) {
          var Ga = M, si = I;
          return M = I = a, je = Wn, q = s.apply(si, Ga), q;
        }
        function At(Wn) {
          return je = Wn, te = Uo(rn, d), Ie ? Tt(Wn) : q;
        }
        function cn(Wn) {
          var Ga = Wn - se, si = Wn - je, $v = d - Ga;
          return Be ? ti($v, B - si) : $v;
        }
        function Yt(Wn) {
          var Ga = Wn - se, si = Wn - je;
          return se === a || Ga >= d || Ga < 0 || Be && si >= B;
        }
        function rn() {
          var Wn = ee();
          if (Yt(Wn))
            return fn(Wn);
          te = Uo(rn, cn(Wn));
        }
        function fn(Wn) {
          return te = a, it && M ? Tt(Wn) : (M = I = a, q);
        }
        function pr() {
          te !== a && bc(te), je = 0, M = se = I = te = a;
        }
        function ar() {
          return te === a ? q : fn(ee());
        }
        function fl() {
          var Wn = ee(), Ga = Yt(Wn);
          if (M = arguments, I = this, se = Wn, Ga) {
            if (te === a)
              return At(se);
            if (Be)
              return bc(te), te = Uo(rn, d), Tt(se);
          }
          return te === a && (te = Uo(rn, d)), q;
        }
        return fl.cancel = pr, fl.flush = ar, fl;
      }
      var fe = tn(function(s, d) {
        return Bh(s, 1, d);
      }), ne = tn(function(s, d, y) {
        return Bh(s, cl(d) || 0, y);
      });
      function de(s) {
        return Su(s, ae);
      }
      function ze(s, d) {
        if (typeof s != "function" || d != null && typeof d != "function")
          throw new El(m);
        var y = function() {
          var M = arguments, I = d ? d.apply(this, M) : M[0], B = y.cache;
          if (B.has(I))
            return B.get(I);
          var q = s.apply(this, M);
          return y.cache = B.set(I, q) || B, q;
        };
        return y.cache = new (ze.Cache || Ii)(), y;
      }
      ze.Cache = Ii;
      function bt(s) {
        if (typeof s != "function")
          throw new El(m);
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, d[0]);
            case 2:
              return !s.call(this, d[0], d[1]);
            case 3:
              return !s.call(this, d[0], d[1], d[2]);
          }
          return !s.apply(this, d);
        };
      }
      function Zt(s) {
        return Ye(2, s);
      }
      var Bt = sd(function(s, d) {
        d = d.length == 1 && sn(d[0]) ? dr(d[0], Ba(Dt())) : dr(Pn(d, 1), Ba(Dt()));
        var y = d.length;
        return tn(function(M) {
          for (var I = -1, B = ti(M.length, y); ++I < B; )
            M[I] = d[I].call(this, M[I]);
          return Ja(s, this, M);
        });
      }), Wt = tn(function(s, d) {
        var y = zi(d, qr(Wt));
        return Su(s, $, a, d, y);
      }), ga = tn(function(s, d) {
        var y = zi(d, qr(ga));
        return Su(s, ce, a, d, y);
      }), Dn = Ll(function(s, d) {
        return Su(s, Ce, a, a, a, d);
      });
      function Ou(s, d) {
        if (typeof s != "function")
          throw new El(m);
        return d = d === a ? d : Ft(d), tn(s, d);
      }
      function fm(s, d) {
        if (typeof s != "function")
          throw new El(m);
        return d = d == null ? 0 : ia(Ft(d), 0), tn(function(y) {
          var M = y[d], I = lo(y, 0, d);
          return M && lu(I, M), Ja(s, this, I);
        });
      }
      function Zw(s, d, y) {
        var M = !0, I = !0;
        if (typeof s != "function")
          throw new El(m);
        return Kr(y) && (M = "leading" in y ? !!y.leading : M, I = "trailing" in y ? !!y.trailing : I), Vr(s, d, {
          leading: M,
          maxWait: d,
          trailing: I
        });
      }
      function y3(s) {
        return Ve(s, 1);
      }
      function dm(s, d) {
        return Wt(zs(d), s);
      }
      function Pw() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return sn(s) ? s : [s];
      }
      function Nw(s) {
        return $a(s, A);
      }
      function Vw(s, d) {
        return d = typeof d == "function" ? d : a, $a(s, A, d);
      }
      function Bw(s) {
        return $a(s, T | A);
      }
      function Fw(s, d) {
        return d = typeof d == "function" ? d : a, $a(s, T | A, d);
      }
      function Uw(s, d) {
        return d == null || ro(s, d, ui(d));
      }
      function Vi(s, d) {
        return s === d || s !== s && d !== d;
      }
      var hm = ii(Xu), l2 = ii(function(s, d) {
        return s >= d;
      }), o1 = ld(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ld : function(s) {
        return ca(s) && Tn.call(s, "callee") && !qf.call(s, "callee");
      }, sn = pe.isArray, Yw = Af ? Ba(Af) : vv;
      function ul(s) {
        return s != null && Du(s.length) && !ms(s);
      }
      function wa(s) {
        return ca(s) && ul(s);
      }
      function Dv(s) {
        return s === !0 || s === !1 || ca(s) && Wa(s) == Ot;
      }
      var mo = uc || km, vm = vi ? Ba(vi) : gu;
      function x3(s) {
        return ca(s) && s.nodeType === 1 && !Yc(s);
      }
      function jv(s) {
        if (s == null)
          return !0;
        if (ul(s) && (sn(s) || typeof s == "string" || typeof s.splice == "function" || mo(s) || gs(s) || o1(s)))
          return !s.length;
        var d = za(s);
        if (d == wr || d == Vt)
          return !s.size;
        if (oo(s))
          return !wu(s).length;
        for (var y in s)
          if (Tn.call(s, y))
            return !1;
        return !0;
      }
      function S3(s, d) {
        return rl(s, d);
      }
      function C3(s, d, y) {
        y = typeof y == "function" ? y : a;
        var M = y ? y(s, d) : a;
        return M === a ? rl(s, d, a, y) : !!M;
      }
      function Av(s) {
        if (!ca(s))
          return !1;
        var d = Wa(s);
        return d == In || d == Ar || typeof s.message == "string" && typeof s.name == "string" && !Yc(s);
      }
      function b3(s) {
        return typeof s == "number" && U1(s);
      }
      function ms(s) {
        if (!Kr(s))
          return !1;
        var d = Wa(s);
        return d == zn || d == er || d == vt || d == ln;
      }
      function pm(s) {
        return typeof s == "number" && s == Ft(s);
      }
      function Du(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= le;
      }
      function Kr(s) {
        var d = typeof s;
        return s != null && (d == "object" || d == "function");
      }
      function ca(s) {
        return s != null && typeof s == "object";
      }
      var _3 = Hs ? Ba(Hs) : pv;
      function o2(s, d) {
        return s === d || X1(s, d, ss(d));
      }
      function mm(s, d, y) {
        return y = typeof y == "function" ? y : a, X1(s, d, ss(d), y);
      }
      function R3(s) {
        return Dr(s) && s != +s;
      }
      function $w(s) {
        if (nm(s))
          throw new zt(g);
        return Fh(s);
      }
      function E3(s) {
        return s === null;
      }
      function Ww(s) {
        return s == null;
      }
      function Dr(s) {
        return typeof s == "number" || ca(s) && Wa(s) == ea;
      }
      function Yc(s) {
        if (!ca(s) || Wa(s) != Hr)
          return !1;
        var d = Kl(s);
        if (d === null)
          return !0;
        var y = Tn.call(d, "constructor") && d.constructor;
        return typeof y == "function" && y instanceof y && pa.call(y) == Wf;
      }
      var Id = kf ? Ba(kf) : gc;
      function u2(s) {
        return pm(s) && s >= -9007199254740991 && s <= le;
      }
      var gm = ra ? Ba(ra) : No;
      function s2(s) {
        return typeof s == "string" || !sn(s) && ca(s) && Wa(s) == Rn;
      }
      function sl(s) {
        return typeof s == "symbol" || ca(s) && Wa(s) == yr;
      }
      var gs = Lf ? Ba(Lf) : wc;
      function zw(s) {
        return s === a;
      }
      function kv(s) {
        return ca(s) && za(s) == Xt;
      }
      function Hd(s) {
        return ca(s) && Wa(s) == En;
      }
      var qw = ii(es), M3 = ii(function(s, d) {
        return s <= d;
      });
      function T3(s) {
        if (!s)
          return [];
        if (ul(s))
          return s2(s) ? qi(s) : _a(s);
        if (ki && s[ki])
          return Z1(s[ki]());
        var d = za(s), y = d == wr ? P1 : d == Vt ? $u : c1;
        return y(s);
      }
      function u1(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = cl(s), s === Ue || s === -1 / 0) {
          var d = s < 0 ? -1 : 1;
          return d * _e;
        }
        return s === s ? s : 0;
      }
      function Ft(s) {
        var d = u1(s), y = d % 1;
        return d === d ? y ? d - y : d : 0;
      }
      function Zd(s) {
        return s ? pu(Ft(s), 0, mt) : 0;
      }
      function cl(s) {
        if (typeof s == "number")
          return s;
        if (sl(s))
          return Pe;
        if (Kr(s)) {
          var d = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Kr(d) ? d + "" : d;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = nv(s);
        var y = Za.test(s);
        return y || Er.test(s) ? q0(s.slice(2), y ? 2 : 8) : vn.test(s) ? Pe : +s;
      }
      function s1(s) {
        return wi(s, Nl(s));
      }
      function O3(s) {
        return s ? pu(Ft(s), -9007199254740991, le) : s === 0 ? s : 0;
      }
      function bn(s) {
        return s == null ? "" : ai(s);
      }
      var $c = o0(function(s, d) {
        if (oo(d) || ul(d)) {
          wi(d, ui(d), s);
          return;
        }
        for (var y in d)
          Tn.call(d, y) && Us(s, y, d[y]);
      }), c2 = o0(function(s, d) {
        wi(d, Nl(d), s);
      }), Pd = o0(function(s, d, y, M) {
        wi(d, Nl(d), s, M);
      }), Lv = o0(function(s, d, y, M) {
        wi(d, ui(d), s, M);
      }), f2 = Ll($r);
      function D3(s, d) {
        var y = Ql(s);
        return d == null ? y : br(y, d);
      }
      var Iv = tn(function(s, d) {
        s = nr(s);
        var y = -1, M = d.length, I = M > 2 ? d[2] : a;
        for (I && li(d[0], d[1], I) && (M = 1); ++y < M; )
          for (var B = d[y], q = Nl(B), te = -1, se = q.length; ++te < se; ) {
            var je = q[te], Ie = s[je];
            (Ie === a || Vi(Ie, ko[je]) && !Tn.call(s, je)) && (s[je] = B[je]);
          }
        return s;
      }), j3 = tn(function(s) {
        return s.push(a, Oc), Ja(Nv, a, s);
      });
      function A3(s, d) {
        return ev(s, Dt(d, 3), tl);
      }
      function Gw(s, d) {
        return ev(s, Dt(d, 3), Qu);
      }
      function Kw(s, d) {
        return s == null ? s : rd(s, Dt(d, 3), Nl);
      }
      function Hv(s, d) {
        return s == null ? s : pc(s, Dt(d, 3), Nl);
      }
      function Zv(s, d) {
        return s && tl(s, Dt(d, 3));
      }
      function k3(s, d) {
        return s && Qu(s, Dt(d, 3));
      }
      function Qw(s) {
        return s == null ? [] : Q1(s, ui(s));
      }
      function Pv(s) {
        return s == null ? [] : Q1(s, Nl(s));
      }
      function wm(s, d, y) {
        var M = s == null ? a : vr(s, d);
        return M === a ? y : M;
      }
      function Xw(s, d) {
        return s != null && md(s, d, nl);
      }
      function ym(s, d) {
        return s != null && md(s, d, ao);
      }
      var Jw = Wh(function(s, d, y) {
        d != null && typeof d.toString != "function" && (d = ic.call(d)), s[d] = y;
      }, Tm(Vl)), e6 = Wh(function(s, d, y) {
        d != null && typeof d.toString != "function" && (d = ic.call(d)), Tn.call(s, d) ? s[d].push(y) : s[d] = [y];
      }, Dt), t6 = tn(Al);
      function ui(s) {
        return ul(s) ? Io(s) : wu(s);
      }
      function Nl(s) {
        return ul(s) ? Io(s, !0) : od(s);
      }
      function n6(s, d) {
        var y = {};
        return d = Dt(d, 3), tl(s, function(M, I, B) {
          Ho(y, d(M, I, B), M);
        }), y;
      }
      function r6(s, d) {
        var y = {};
        return d = Dt(d, 3), tl(s, function(M, I, B) {
          Ho(y, I, d(M, I, B));
        }), y;
      }
      var xm = o0(function(s, d, y) {
        on(s, d, y);
      }), Nv = o0(function(s, d, y, M) {
        on(s, d, y, M);
      }), Sm = Ll(function(s, d) {
        var y = {};
        if (s == null)
          return y;
        var M = !1;
        d = dr(d, function(B) {
          return B = gi(B, s), M || (M = B.length > 1), B;
        }), wi(s, c0(s), y), M && (y = $a(y, T | j | A, Ks));
        for (var I = d.length; I--; )
          t0(y, d[I]);
        return y;
      });
      function Cm(s, d) {
        return Nd(s, bt(Dt(d)));
      }
      var a6 = Ll(function(s, d) {
        return s == null ? {} : ud(s, d);
      });
      function Nd(s, d) {
        if (s == null)
          return {};
        var y = dr(c0(s), function(M) {
          return [M];
        });
        return d = Dt(d), ts(s, y, function(M, I) {
          return d(M, I[0]);
        });
      }
      function d2(s, d, y) {
        d = gi(d, s);
        var M = -1, I = d.length;
        for (I || (I = 1, s = a); ++M < I; ) {
          var B = s == null ? a : s[ho(d[M])];
          B === a && (M = I, B = y), s = ms(B) ? B.call(s) : B;
        }
        return s;
      }
      function i6(s, d, y) {
        return s == null ? s : ni(s, d, y);
      }
      function L3(s, d, y, M) {
        return M = typeof M == "function" ? M : a, s == null ? s : ni(s, d, y, M);
      }
      var I3 = hd(ui), H3 = hd(Nl);
      function Z3(s, d, y) {
        var M = sn(s), I = M || mo(s) || gs(s);
        if (d = Dt(d, 4), y == null) {
          var B = s && s.constructor;
          I ? y = M ? new B() : [] : Kr(s) ? y = ms(B) ? Ql(Kl(s)) : {} : y = {};
        }
        return (I ? ei : tl)(s, function(q, te, se) {
          return d(y, q, te, se);
        }), y;
      }
      function l6(s, d) {
        return s == null ? !0 : t0(s, d);
      }
      function o6(s, d, y) {
        return s == null ? s : Cc(s, d, zs(y));
      }
      function P3(s, d, y, M) {
        return M = typeof M == "function" ? M : a, s == null ? s : Cc(s, d, zs(y), M);
      }
      function c1(s) {
        return s == null ? [] : rc(s, ui(s));
      }
      function Vv(s) {
        return s == null ? [] : rc(s, Nl(s));
      }
      function Bv(s, d, y) {
        return y === a && (y = d, d = a), y !== a && (y = cl(y), y = y === y ? y : 0), d !== a && (d = cl(d), d = d === d ? d : 0), pu(cl(s), d, y);
      }
      function h2(s, d, y) {
        return d = u1(d), y === a ? (y = d, d = 0) : y = u1(y), s = cl(s), Ju(s, d, y);
      }
      function v2(s, d, y) {
        if (y && typeof y != "boolean" && li(s, d, y) && (d = y = a), y === a && (typeof d == "boolean" ? (y = d, d = a) : typeof s == "boolean" && (y = s, s = a)), s === a && d === a ? (s = 0, d = 1) : (s = u1(s), d === a ? (d = s, s = 0) : d = u1(d)), s > d) {
          var M = s;
          s = d, d = M;
        }
        if (y || s % 1 || d % 1) {
          var I = fu();
          return ti(s + I * (d - s + z0("1e-" + ((I + "").length - 1))), d);
        }
        return He(s, d);
      }
      var u6 = os(function(s, d, y) {
        return d = d.toLowerCase(), s + (y ? Fv(d) : d);
      });
      function Fv(s) {
        return Em(bn(s).toLowerCase());
      }
      function Uv(s) {
        return s = bn(s), s && s.replace(hi, av).replace(Ah, "");
      }
      function s6(s, d, y) {
        s = bn(s), d = ai(d);
        var M = s.length;
        y = y === a ? M : pu(Ft(y), 0, M);
        var I = y;
        return y -= d.length, y >= 0 && s.slice(y, I) == d;
      }
      function c6(s) {
        return s = bn(s), s && T1.test(s) ? s.replace(Eo, Ih) : s;
      }
      function hS(s) {
        return s = bn(s), s && eu.test(s) ? s.replace(Oo, "\\$&") : s;
      }
      var f6 = os(function(s, d, y) {
        return s + (y ? "-" : "") + d.toLowerCase();
      }), d6 = os(function(s, d, y) {
        return s + (y ? " " : "") + d.toLowerCase();
      }), h6 = Rc("toLowerCase");
      function v6(s, d, y) {
        s = bn(s), d = Ft(d);
        var M = d ? Zs(s) : 0;
        if (!d || M >= d)
          return s;
        var I = (d - M) / 2;
        return xu(cu(I), y) + s + xu(Wu(I), y);
      }
      function p6(s, d, y) {
        s = bn(s), d = Ft(d);
        var M = d ? Zs(s) : 0;
        return d && M < d ? s + xu(d - M, y) : s;
      }
      function m6(s, d, y) {
        s = bn(s), d = Ft(d);
        var M = d ? Zs(s) : 0;
        return d && M < d ? xu(d - M, y) + s : s;
      }
      function bm(s, d, y) {
        return y || d == null ? d = 0 : d && (d = +d), Kf(bn(s).replace(Ds, ""), d || 0);
      }
      function g6(s, d, y) {
        return (y ? li(s, d, y) : d === a) ? d = 1 : d = Ft(d), It(bn(s), d);
      }
      function w6() {
        var s = arguments, d = bn(s[0]);
        return s.length < 3 ? d : d.replace(s[1], s[2]);
      }
      var _m = os(function(s, d, y) {
        return s + (y ? "_" : "") + d.toLowerCase();
      });
      function y6(s, d, y) {
        return y && typeof y != "number" && li(s, d, y) && (d = y = a), y = y === a ? mt : y >>> 0, y ? (s = bn(s), s && (typeof d == "string" || d != null && !Id(d)) && (d = ai(d), !d && H1(s)) ? lo(qi(s), 0, y) : s.split(d, y)) : [];
      }
      var Rm = os(function(s, d, y) {
        return s + (y ? " " : "") + Em(d);
      });
      function N3(s, d, y) {
        return s = bn(s), y = y == null ? 0 : pu(Ft(y), 0, s.length), d = ai(d), s.slice(y, y + d.length) == d;
      }
      function x6(s, d, y) {
        var M = H.templateSettings;
        y && li(s, d, y) && (d = a), s = bn(s), d = Pd({}, d, M, zh);
        var I = Pd({}, d.imports, M.imports, zh), B = ui(I), q = rc(I, B), te, se, je = 0, Ie = d.interpolate || Gt, Be = "__p += '", it = ac(
          (d.escape || Gt).source + "|" + Ie.source + "|" + (Ie === Pu ? xn : Gt).source + "|" + (d.evaluate || Gt).source + "|$",
          "g"
        ), Tt = "//# sourceURL=" + (Tn.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++q2 + "]") + `
`;
        s.replace(it, function(Yt, rn, fn, pr, ar, fl) {
          return fn || (fn = pr), Be += s.slice(je, fl).replace(na, iv), rn && (te = !0, Be += `' +
__e(` + rn + `) +
'`), ar && (se = !0, Be += `';
` + ar + `;
__p += '`), fn && (Be += `' +
((__t = (` + fn + `)) == null ? '' : __t) +
'`), je = fl + Yt.length, Yt;
        }), Be += `';
`;
        var At = Tn.call(d, "variable") && d.variable;
        if (!At)
          Be = `with (obj) {
` + Be + `
}
`;
        else if (Et.test(At))
          throw new zt(S);
        Be = (se ? Be.replace(M1, "") : Be).replace(_l, "$1").replace(Jo, "$1;"), Be = "function(" + (At || "obj") + `) {
` + (At ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (te ? ", __e = _.escape" : "") + (se ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Be + `return __p
}`;
        var cn = F3(function() {
          return Mn(B, Tt + "return " + Be).apply(a, q);
        });
        if (cn.source = Be, Av(cn))
          throw cn;
        return cn;
      }
      function S6(s) {
        return bn(s).toLowerCase();
      }
      function C6(s) {
        return bn(s).toUpperCase();
      }
      function b6(s, d, y) {
        if (s = bn(s), s && (y || d === a))
          return nv(s);
        if (!s || !(d = ai(d)))
          return s;
        var M = qi(s), I = qi(d), B = Vf(M, I), q = Lh(M, I) + 1;
        return lo(M, B, q).join("");
      }
      function V3(s, d, y) {
        if (s = bn(s), s && (y || d === a))
          return s.slice(0, Uf(s) + 1);
        if (!s || !(d = ai(d)))
          return s;
        var M = qi(s), I = Lh(M, qi(d)) + 1;
        return lo(M, 0, I).join("");
      }
      function _6(s, d, y) {
        if (s = bn(s), s && (y || d === a))
          return s.replace(Ds, "");
        if (!s || !(d = ai(d)))
          return s;
        var M = qi(s), I = Vf(M, qi(d));
        return lo(M, I).join("");
      }
      function R6(s, d) {
        var y = me, M = K;
        if (Kr(d)) {
          var I = "separator" in d ? d.separator : I;
          y = "length" in d ? Ft(d.length) : y, M = "omission" in d ? ai(d.omission) : M;
        }
        s = bn(s);
        var B = s.length;
        if (H1(s)) {
          var q = qi(s);
          B = q.length;
        }
        if (y >= B)
          return s;
        var te = y - Zs(M);
        if (te < 1)
          return M;
        var se = q ? lo(q, 0, te).join("") : s.slice(0, te);
        if (I === a)
          return se + M;
        if (q && (te += se.length - te), Id(I)) {
          if (s.slice(te).search(I)) {
            var je, Ie = se;
            for (I.global || (I = ac(I.source, bn(hn.exec(I)) + "g")), I.lastIndex = 0; je = I.exec(Ie); )
              var Be = je.index;
            se = se.slice(0, Be === a ? te : Be);
          }
        } else if (s.indexOf(ai(I), te) != te) {
          var it = se.lastIndexOf(I);
          it > -1 && (se = se.slice(0, it));
        }
        return se + M;
      }
      function E6(s) {
        return s = bn(s), s && B0.test(s) ? s.replace(zl, ov) : s;
      }
      var M6 = os(function(s, d, y) {
        return s + (y ? " " : "") + d.toUpperCase();
      }), Em = Rc("toUpperCase");
      function B3(s, d, y) {
        return s = bn(s), d = y ? a : d, d === a ? lv(s) ? sv(s) : ou(s) : s.match(d) || [];
      }
      var F3 = tn(function(s, d) {
        try {
          return Ja(s, a, d);
        } catch (y) {
          return Av(y) ? y : new zt(y);
        }
      }), Mm = Ll(function(s, d) {
        return ei(d, function(y) {
          y = ho(y), Ho(s, y, Ne(s[y], s));
        }), s;
      });
      function T6(s) {
        var d = s == null ? 0 : s.length, y = Dt();
        return s = d ? dr(s, function(M) {
          if (typeof M[1] != "function")
            throw new El(m);
          return [y(M[0]), M[1]];
        }) : [], tn(function(M) {
          for (var I = -1; ++I < d; ) {
            var B = s[I];
            if (Ja(B[0], this, M))
              return Ja(B[1], this, M);
          }
        });
      }
      function O6(s) {
        return nd($a(s, T));
      }
      function Tm(s) {
        return function() {
          return s;
        };
      }
      function D6(s, d) {
        return s == null || s !== s ? d : s;
      }
      var j6 = dd(), A6 = dd(!0);
      function Vl(s) {
        return s;
      }
      function Om(s) {
        return Ys(typeof s == "function" ? s : $a(s, T));
      }
      function k6(s) {
        return J1($a(s, T));
      }
      function U3(s, d) {
        return et(s, $a(d, T));
      }
      var Dm = tn(function(s, d) {
        return function(y) {
          return Al(y, s, d);
        };
      }), L6 = tn(function(s, d) {
        return function(y) {
          return Al(s, y, d);
        };
      });
      function jm(s, d, y) {
        var M = ui(d), I = Q1(d, M);
        y == null && !(Kr(d) && (I.length || !M.length)) && (y = d, d = s, s = this, I = Q1(d, ui(d)));
        var B = !(Kr(y) && "chain" in y) || !!y.chain, q = ms(s);
        return ei(I, function(te) {
          var se = d[te];
          s[te] = se, q && (s.prototype[te] = function() {
            var je = this.__chain__;
            if (B || je) {
              var Ie = s(this.__wrapped__), Be = Ie.__actions__ = _a(this.__actions__);
              return Be.push({ func: se, args: arguments, thisArg: s }), Ie.__chain__ = je, Ie;
            }
            return se.apply(s, lu([this.value()], arguments));
          });
        }), s;
      }
      function Yv() {
        return Sr._ === this && (Sr._ = cv), this;
      }
      function Wc() {
      }
      function I6(s) {
        return s = Ft(s), tn(function(d) {
          return _r(d, s);
        });
      }
      var H6 = Bo(dr), Z6 = Bo(X0), P6 = Bo(Zf);
      function Y3(s) {
        return dt(s) ? Pf(ho(s)) : kr(s);
      }
      function N6(s) {
        return function(d) {
          return s == null ? a : vr(s, d);
        };
      }
      var V6 = Mc(), $3 = Mc(!0);
      function Am() {
        return [];
      }
      function km() {
        return !1;
      }
      function B6() {
        return {};
      }
      function F6() {
        return "";
      }
      function U6() {
        return !0;
      }
      function Y6(s, d) {
        if (s = Ft(s), s < 1 || s > le)
          return [];
        var y = mt, M = ti(s, mt);
        d = Dt(d), s -= mt;
        for (var I = nc(M, d); ++y < s; )
          d(y);
        return I;
      }
      function $6(s) {
        return sn(s) ? dr(s, ho) : sl(s) ? [s] : _a(yd(bn(s)));
      }
      function W6(s) {
        var d = ++V1;
        return bn(s) + d;
      }
      var z6 = Ec(function(s, d) {
        return s + d;
      }, 0), q6 = jt("ceil"), G6 = Ec(function(s, d) {
        return s / d;
      }, 1), K6 = jt("floor");
      function Q6(s) {
        return s && s.length ? Pr(s, Vl, Xu) : a;
      }
      function X6(s, d) {
        return s && s.length ? Pr(s, Dt(d, 2), Xu) : a;
      }
      function J6(s) {
        return tc(s, Vl);
      }
      function e7(s, d) {
        return tc(s, Dt(d, 2));
      }
      function Vd(s) {
        return s && s.length ? Pr(s, Vl, es) : a;
      }
      function Bd(s, d) {
        return s && s.length ? Pr(s, Dt(d, 2), es) : a;
      }
      var Lm = Ec(function(s, d) {
        return s * d;
      }, 1), p2 = jt("round"), Im = Ec(function(s, d) {
        return s - d;
      }, 0);
      function t7(s) {
        return s && s.length ? Gl(s, Vl) : 0;
      }
      function n7(s, d) {
        return s && s.length ? Gl(s, Dt(d, 2)) : 0;
      }
      return H.after = xe, H.ary = Ve, H.assign = $c, H.assignIn = c2, H.assignInWith = Pd, H.assignWith = Lv, H.at = f2, H.before = Ye, H.bind = Ne, H.bindAll = Mm, H.bindKey = ot, H.castArray = Pw, H.chain = Zc, H.chunk = v0, H.compact = xd, H.concat = Zl, H.cond = T6, H.conforms = O6, H.constant = Tm, H.countBy = Tv, H.create = D3, H.curry = yt, H.curryRight = Ct, H.debounce = Vr, H.defaults = Iv, H.defaultsDeep = j3, H.defer = fe, H.delay = ne, H.difference = On, H.differenceBy = Ma, H.differenceWith = sa, H.drop = ma, H.dropRight = ll, H.dropRightWhile = _u, H.dropWhile = Gr, H.fill = p0, H.filter = Nc, H.flatMap = r2, H.flatMapDeep = Ov, H.flatMapDepth = a2, H.flatten = Sd, H.flattenDeep = Lc, H.flattenDepth = Ta, H.flip = de, H.flow = j6, H.flowRight = A6, H.fromPairs = Ic, H.functions = Qw, H.functionsIn = Pv, H.groupBy = Ad, H.initial = Cd, H.intersection = bd, H.intersectionBy = Eu, H.intersectionWith = n1, H.invert = Jw, H.invertBy = e6, H.invokeMap = cm, H.iteratee = Om, H.keyBy = kd, H.keys = ui, H.keysIn = Nl, H.map = Fc, H.mapKeys = n6, H.mapValues = r6, H.matches = k6, H.matchesProperty = U3, H.memoize = ze, H.merge = xm, H.mergeWith = Nv, H.method = Dm, H.methodOf = L6, H.mixin = jm, H.negate = bt, H.nthArg = I6, H.omit = Sm, H.omitBy = Cm, H.once = Zt, H.orderBy = Tu, H.over = H6, H.overArgs = Bt, H.overEvery = Z6, H.overSome = P6, H.partial = Wt, H.partialRight = ga, H.partition = Uc, H.pick = a6, H.pickBy = Nd, H.property = Y3, H.propertyOf = N6, H.pull = m0, H.pullAll = Mu, H.pullAllBy = yi, H.pullAllWith = Yo, H.pullAt = ol, H.range = V6, H.rangeRight = $3, H.rearg = Dn, H.reject = o, H.remove = Oa, H.rest = Ou, H.reverse = _d, H.sampleSize = w, H.set = i6, H.setWith = L3, H.shuffle = C, H.slice = g0, H.sortBy = W, H.sortedUniq = Qh, H.sortedUniqBy = a1, H.split = y6, H.spread = fm, H.tail = yv, H.take = xv, H.takeRight = Ed, H.takeRightWhile = Md, H.takeWhile = am, H.tap = Jh, H.throttle = Zw, H.thru = xi, H.toArray = T3, H.toPairs = I3, H.toPairsIn = H3, H.toPath = $6, H.toPlainObject = s1, H.transform = Z3, H.unary = y3, H.union = im, H.unionBy = Sv, H.unionWith = Cv, H.uniq = i1, H.uniqBy = Xh, H.uniqWith = w0, H.unset = l6, H.unzip = Td, H.unzipWith = Lr, H.update = o6, H.updateWith = P3, H.values = c1, H.valuesIn = Vv, H.without = bv, H.words = B3, H.wrap = dm, H.xor = _v, H.xorBy = lm, H.xorWith = om, H.zip = Rv, H.zipObject = Ev, H.zipObjectDeep = um, H.zipWith = Pl, H.entries = I3, H.entriesIn = H3, H.extend = c2, H.extendWith = Pd, jm(H, H), H.add = z6, H.attempt = F3, H.camelCase = u6, H.capitalize = Fv, H.ceil = q6, H.clamp = Bv, H.clone = Nw, H.cloneDeep = Bw, H.cloneDeepWith = Fw, H.cloneWith = Vw, H.conformsTo = Uw, H.deburr = Uv, H.defaultTo = D6, H.divide = G6, H.endsWith = s6, H.eq = Vi, H.escape = c6, H.escapeRegExp = hS, H.every = n2, H.find = Vc, H.findIndex = ds, H.findKey = A3, H.findLast = l1, H.findLastIndex = kc, H.findLastKey = Gw, H.floor = K6, H.forEach = Bc, H.forEachRight = jd, H.forIn = Kw, H.forInRight = Hv, H.forOwn = Zv, H.forOwnRight = k3, H.get = wm, H.gt = hm, H.gte = l2, H.has = Xw, H.hasIn = ym, H.head = vo, H.identity = Vl, H.includes = i2, H.indexOf = Ru, H.inRange = h2, H.invoke = t6, H.isArguments = o1, H.isArray = sn, H.isArrayBuffer = Yw, H.isArrayLike = ul, H.isArrayLikeObject = wa, H.isBoolean = Dv, H.isBuffer = mo, H.isDate = vm, H.isElement = x3, H.isEmpty = jv, H.isEqual = S3, H.isEqualWith = C3, H.isError = Av, H.isFinite = b3, H.isFunction = ms, H.isInteger = pm, H.isLength = Du, H.isMap = _3, H.isMatch = o2, H.isMatchWith = mm, H.isNaN = R3, H.isNative = $w, H.isNil = Ww, H.isNull = E3, H.isNumber = Dr, H.isObject = Kr, H.isObjectLike = ca, H.isPlainObject = Yc, H.isRegExp = Id, H.isSafeInteger = u2, H.isSet = gm, H.isString = s2, H.isSymbol = sl, H.isTypedArray = gs, H.isUndefined = zw, H.isWeakMap = kv, H.isWeakSet = Hd, H.join = po, H.kebabCase = f6, H.last = oi, H.lastIndexOf = qa, H.lowerCase = d6, H.lowerFirst = h6, H.lt = qw, H.lte = M3, H.max = Q6, H.maxBy = X6, H.mean = J6, H.meanBy = e7, H.min = Vd, H.minBy = Bd, H.stubArray = Am, H.stubFalse = km, H.stubObject = B6, H.stubString = F6, H.stubTrue = U6, H.multiply = Lm, H.nth = hs, H.noConflict = Yv, H.noop = Wc, H.now = ee, H.pad = v6, H.padEnd = p6, H.padStart = m6, H.parseInt = bm, H.random = v2, H.reduce = Ld, H.reduceRight = i, H.repeat = g6, H.replace = w6, H.result = d2, H.round = p2, H.runInContext = oe, H.sample = v, H.size = E, H.snakeCase = _m, H.some = Z, H.sortedIndex = Rd, H.sortedIndexBy = rm, H.sortedIndexOf = vs, H.sortedLastIndex = wv, H.sortedLastIndexBy = Hc, H.sortedLastIndexOf = r1, H.startCase = Rm, H.startsWith = N3, H.subtract = Im, H.sum = t7, H.sumBy = n7, H.template = x6, H.times = Y6, H.toFinite = u1, H.toInteger = Ft, H.toLength = Zd, H.toLower = S6, H.toNumber = cl, H.toSafeInteger = O3, H.toString = bn, H.toUpper = C6, H.trim = b6, H.trimEnd = V3, H.trimStart = _6, H.truncate = R6, H.unescape = E6, H.uniqueId = W6, H.upperCase = M6, H.upperFirst = Em, H.each = Bc, H.eachRight = jd, H.first = vo, jm(H, function() {
        var s = {};
        return tl(H, function(d, y) {
          Tn.call(H.prototype, y) || (s[y] = d);
        }), s;
      }(), { chain: !1 }), H.VERSION = l, ei(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        H[s].placeholder = H;
      }), ei(["drop", "take"], function(s, d) {
        Kt.prototype[s] = function(y) {
          y = y === a ? 1 : ia(Ft(y), 0);
          var M = this.__filtered__ && !d ? new Kt(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = ti(y, M.__takeCount__) : M.__views__.push({
            size: ti(y, mt),
            type: s + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, Kt.prototype[s + "Right"] = function(y) {
          return this.reverse()[s](y).reverse();
        };
      }), ei(["filter", "map", "takeWhile"], function(s, d) {
        var y = d + 1, M = y == ge || y == be;
        Kt.prototype[s] = function(I) {
          var B = this.clone();
          return B.__iteratees__.push({
            iteratee: Dt(I, 3),
            type: y
          }), B.__filtered__ = B.__filtered__ || M, B;
        };
      }), ei(["head", "last"], function(s, d) {
        var y = "take" + (d ? "Right" : "");
        Kt.prototype[s] = function() {
          return this[y](1).value()[0];
        };
      }), ei(["initial", "tail"], function(s, d) {
        var y = "drop" + (d ? "" : "Right");
        Kt.prototype[s] = function() {
          return this.__filtered__ ? new Kt(this) : this[y](1);
        };
      }), Kt.prototype.compact = function() {
        return this.filter(Vl);
      }, Kt.prototype.find = function(s) {
        return this.filter(s).head();
      }, Kt.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Kt.prototype.invokeMap = tn(function(s, d) {
        return typeof s == "function" ? new Kt(this) : this.map(function(y) {
          return Al(y, s, d);
        });
      }), Kt.prototype.reject = function(s) {
        return this.filter(bt(Dt(s)));
      }, Kt.prototype.slice = function(s, d) {
        s = Ft(s);
        var y = this;
        return y.__filtered__ && (s > 0 || d < 0) ? new Kt(y) : (s < 0 ? y = y.takeRight(-s) : s && (y = y.drop(s)), d !== a && (d = Ft(d), y = d < 0 ? y.dropRight(-d) : y.take(d - s)), y);
      }, Kt.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Kt.prototype.toArray = function() {
        return this.take(mt);
      }, tl(Kt.prototype, function(s, d) {
        var y = /^(?:filter|find|map|reject)|While$/.test(d), M = /^(?:head|last)$/.test(d), I = H[M ? "take" + (d == "last" ? "Right" : "") : d], B = M || /^find/.test(d);
        I && (H.prototype[d] = function() {
          var q = this.__wrapped__, te = M ? [1] : arguments, se = q instanceof Kt, je = te[0], Ie = se || sn(q), Be = function(rn) {
            var fn = I.apply(H, lu([rn], te));
            return M && it ? fn[0] : fn;
          };
          Ie && y && typeof je == "function" && je.length != 1 && (se = Ie = !1);
          var it = this.__chain__, Tt = !!this.__actions__.length, At = B && !it, cn = se && !Tt;
          if (!B && Ie) {
            q = cn ? q : new Kt(this);
            var Yt = s.apply(q, te);
            return Yt.__actions__.push({ func: xi, args: [Be], thisArg: a }), new qt(Yt, it);
          }
          return At && cn ? s.apply(this, te) : (Yt = this.thru(Be), At ? M ? Yt.value()[0] : Yt.value() : Yt);
        });
      }), ei(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var d = su[s], y = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(s);
        H.prototype[s] = function() {
          var I = arguments;
          if (M && !this.__chain__) {
            var B = this.value();
            return d.apply(sn(B) ? B : [], I);
          }
          return this[y](function(q) {
            return d.apply(sn(q) ? q : [], I);
          });
        };
      }), tl(Kt.prototype, function(s, d) {
        var y = H[d];
        if (y) {
          var M = y.name + "";
          Tn.call(z1, M) || (z1[M] = []), z1[M].push({ name: d, func: y });
        }
      }), z1[Gs(a, F).name] = [{
        name: "wrapper",
        func: a
      }], Kt.prototype.clone = Bs, Kt.prototype.reverse = Xf, Kt.prototype.value = pn, H.prototype.at = Od, H.prototype.chain = ps, H.prototype.commit = Pc, H.prototype.next = Dd, H.prototype.plant = Mv, H.prototype.reverse = t2, H.prototype.toJSON = H.prototype.valueOf = H.prototype.value = sm, H.prototype.first = H.prototype.head, ki && (H.prototype[ki] = e2), H;
    }, N1 = Kp();
    jo ? ((jo.exports = N1)._ = N1, K0._ = N1) : Sr._ = N1;
  }).call(S4);
})(b8, b8.exports);
var eG = b8.exports, Iw = { exports: {} }, LO = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ả: "A",
  Ạ: "A",
  Ẩ: "A",
  Ẫ: "A",
  Ậ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ẻ: "E",
  Ẽ: "E",
  Ẹ: "E",
  Ể: "E",
  Ễ: "E",
  Ệ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ỉ: "I",
  Ị: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ỏ: "O",
  Ọ: "O",
  Ổ: "O",
  Ỗ: "O",
  Ộ: "O",
  Ờ: "O",
  Ở: "O",
  Ỡ: "O",
  Ớ: "O",
  Ợ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ủ: "U",
  Ụ: "U",
  Ử: "U",
  Ữ: "U",
  Ự: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ả: "a",
  ạ: "a",
  ẩ: "a",
  ẫ: "a",
  ậ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ẻ: "e",
  ẽ: "e",
  ẹ: "e",
  ể: "e",
  ễ: "e",
  ệ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ỉ: "i",
  ị: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ỏ: "o",
  ọ: "o",
  ổ: "o",
  ỗ: "o",
  ộ: "o",
  ờ: "o",
  ở: "o",
  ỡ: "o",
  ớ: "o",
  ợ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ủ: "u",
  ụ: "u",
  ử: "u",
  ữ: "u",
  ự: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z",
  й: "и",
  Й: "И",
  ё: "е",
  Ё: "Е"
}, IO = Object.keys(LO).join("|"), tG = new RegExp(IO, "g"), nG = new RegExp(IO, "");
function rG(e) {
  return LO[e];
}
var HO = function(e) {
  return e.replace(tG, rG);
}, aG = function(e) {
  return !!e.match(nG);
};
Iw.exports = HO;
Iw.exports.has = aG;
Iw.exports.remove = HO;
var iG = Iw.exports;
const lG = /* @__PURE__ */ _E(iG);
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2020 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const Co = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
}, oG = (e, t) => String(e.rankedValue).localeCompare(String(t.rankedValue));
function y5(e, t, a) {
  a === void 0 && (a = {});
  const {
    keys: l,
    threshold: h = Co.MATCHES,
    baseSort: g = oG,
    sorter: m = (R) => R.sort((D, T) => fG(D, T, g))
  } = a, S = e.reduce(b, []);
  return m(S).map((R) => {
    let {
      item: D
    } = R;
    return D;
  });
  function b(R, D, T) {
    const j = uG(D, l, t, a), {
      rank: A,
      keyThreshold: L = h
    } = j;
    return A >= L && R.push({
      ...j,
      item: D,
      index: T
    }), R;
  }
}
y5.rankings = Co;
function uG(e, t, a, l) {
  if (!t) {
    const g = e;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: g,
      rank: HR(g, a, l),
      keyIndex: -1,
      keyThreshold: l.threshold
    };
  }
  return vG(e, t).reduce((g, m, S) => {
    let {
      rank: b,
      rankedValue: R,
      keyIndex: D,
      keyThreshold: T
    } = g, {
      itemValue: j,
      attributes: A
    } = m, L = HR(j, a, l), P = R;
    const {
      minRanking: N,
      maxRanking: F,
      threshold: Y
    } = A;
    return L < N && L >= Co.MATCHES ? L = N : L > F && (L = F), L > b && (b = L, D = S, T = Y, P = j), {
      rankedValue: P,
      rank: b,
      keyIndex: D,
      keyThreshold: T
    };
  }, {
    rankedValue: e,
    rank: Co.NO_MATCH,
    keyIndex: -1,
    keyThreshold: l.threshold
  });
}
function HR(e, t, a) {
  return e = ZR(e, a), t = ZR(t, a), t.length > e.length ? Co.NO_MATCH : e === t ? Co.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? Co.EQUAL : e.startsWith(t) ? Co.STARTS_WITH : e.includes(` ${t}`) ? Co.WORD_STARTS_WITH : e.includes(t) ? Co.CONTAINS : t.length === 1 ? Co.NO_MATCH : sG(e).includes(t) ? Co.ACRONYM : cG(e, t));
}
function sG(e) {
  let t = "";
  return e.split(" ").forEach((l) => {
    l.split("-").forEach((g) => {
      t += g.substr(0, 1);
    });
  }), t;
}
function cG(e, t) {
  let a = 0, l = 0;
  function h(b, R, D) {
    for (let T = D, j = R.length; T < j; T++)
      if (R[T] === b)
        return a += 1, T + 1;
    return -1;
  }
  function g(b) {
    const R = 1 / b, D = a / t.length;
    return Co.MATCHES + D * R;
  }
  const m = h(t[0], e, 0);
  if (m < 0)
    return Co.NO_MATCH;
  l = m;
  for (let b = 1, R = t.length; b < R; b++) {
    const D = t[b];
    if (l = h(D, e, l), !(l > -1))
      return Co.NO_MATCH;
  }
  const S = l - m;
  return g(S);
}
function fG(e, t, a) {
  const {
    rank: g,
    keyIndex: m
  } = e, {
    rank: S,
    keyIndex: b
  } = t;
  return g === S ? m === b ? a(e, t) : m < b ? -1 : 1 : g > S ? -1 : 1;
}
function ZR(e, t) {
  let {
    keepDiacritics: a
  } = t;
  return e = `${e}`, a || (e = lG(e)), e;
}
function dG(e, t) {
  typeof t == "object" && (t = t.key);
  let a;
  if (typeof t == "function")
    a = t(e);
  else if (e == null)
    a = null;
  else if (Object.hasOwnProperty.call(e, t))
    a = e[t];
  else {
    if (t.includes("."))
      return hG(t, e);
    a = null;
  }
  return a == null ? [] : Array.isArray(a) ? a : [String(a)];
}
function hG(e, t) {
  const a = e.split(".");
  let l = [t];
  for (let h = 0, g = a.length; h < g; h++) {
    const m = a[h];
    let S = [];
    for (let b = 0, R = l.length; b < R; b++) {
      const D = l[b];
      if (D != null)
        if (Object.hasOwnProperty.call(D, m)) {
          const T = D[m];
          T != null && S.push(T);
        } else m === "*" && (S = S.concat(D));
    }
    l = S;
  }
  return Array.isArray(l[0]) ? [].concat(...l) : l;
}
function vG(e, t) {
  const a = [];
  for (let l = 0, h = t.length; l < h; l++) {
    const g = t[l], m = pG(g), S = dG(e, g);
    for (let b = 0, R = S.length; b < R; b++)
      a.push({
        itemValue: S[b],
        attributes: m
      });
  }
  return a;
}
const PR = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function pG(e) {
  return typeof e == "string" ? PR : {
    ...PR,
    ...e
  };
}
var mG = "_1fw0vff1 _1fw0vff0 _1faqfmv35 _1faqfmv3p _1faqfmvsz _1faqfmv9j _1faqfmvf9 _1faqfmv5 _1faqfmv1x _1faqfmv8a", ZO = "_1fw0vff3 _1fw0vff2 _1faqfmv4e _1faqfmv4y _1faqfmv38 _1faqfmv3s _1faqfmvsz _1faqfmv1u _1faqfmv1x _1faqfmvuf", gG = "_1fw0vff5 _1fw0vff4 _1faqfmv37 _1faqfmv3r _1faqfmv9j _1faqfmvf9 _1faqfmv3 _1faqfmv24 _1faqfmvn5", wG = "_1fw0vff7 _1fw0vff6 _1faqfmv4e _1faqfmv4y _1faqfmv38 _1faqfmv3s _1faqfmv5w _1faqfmv6h _1faqfmv72 _1faqfmv7n _1faqfmvfl _1faqfmv3 _1faqfmv8a", yG = "_1fw0vff9 _1fw0vff8 _1faqfmvsz _1faqfmvf9 _1faqfmv3 _1faqfmv1x _1faqfmvwf", xG = "_1fw0vffa", SG = "_1fw0vffc";
const PO = Sa.createContext({
  checkType: "checkmark",
  displayMode: "normal",
  loading: !1
}), Hw = () => {
  const e = Sa.useContext(PO);
  if (!e)
    throw new Error(
      "Select components must be used within a SelectProvider"
    );
  return e;
}, NR = ({
  children: e,
  options: t,
  value: a,
  onValueChange: l,
  ...h
}) => {
  const g = (t ?? []).map(E8), [m, S] = Qt(a), b = (R) => {
    const D = Array.isArray(m) ? m.length === 0 : !m, T = !g.length && D || h.loading;
    let j;
    g.length ? Array.isArray(R) && Array.isArray(m) ? (j = [...m], R.forEach((A) => {
      const L = g.find(
        (N) => cf(N, A)
      ), P = j.some(
        (N) => cf(N, L)
      );
      L && !P && j.push(L);
    }), j = j.filter(
      (A) => R.some((L) => cf(L, A))
    )) : j = g.find(
      (A) => cf(A, R)
    ) : j = Array.isArray(R) ? R.map(k4) : k4(R), S(j), l && !T && l(j);
  };
  return /* @__PURE__ */ f.jsx(
    PO.Provider,
    {
      value: {
        options: g,
        value: m,
        setValue: b,
        ...h
      },
      children: e
    }
  );
}, V0 = ({
  checkType: e,
  children: t,
  clearable: a,
  creatable: l,
  displayMode: h,
  filterable: g,
  customFilterable: m,
  loading: S,
  resultsLoading: b,
  store: R,
  value: D,
  options: T,
  onValueChange: j,
  onSearchValueChange: A,
  onCreate: L,
  ...P
}) => {
  const [N, F] = Qt(""), Y = (K) => {
    F(K), A && A(K);
  }, G = D ?? P.defaultValue, [z, $] = Qt(
    Yy(T)
  );
  l = l || !!L, R = R ?? Np({
    defaultValue: P.defaultValue ? M8(P.defaultValue) : void 0
  });
  const ce = {
    checkType: e,
    clearable: a,
    defaultValue: P.defaultValue,
    displayMode: h,
    loading: S,
    options: z,
    value: Yy(G),
    // eslint-disable-line @typescript-eslint/no-explicit-any
    onValueChange: j,
    setOptions: $
  }, X = async (K) => {
    R == null || R.setValue(K);
  }, Ce = (K) => {
    $([
      ...z,
      { name: K, value: K }
    ]);
    const we = R == null ? void 0 : R.getState().value, ue = Array.isArray(we);
    setTimeout(() => {
      X(ue ? [...we, K] : K);
    }), L && L(K);
  };
  gt(() => {
    if (R && D) {
      const K = R.getState().value, we = M8(D);
      eG.isEqual(we, K) || X(we);
    }
  }, [D]), gt(() => {
    if (R && T) {
      const { value: K } = R.getState();
      let we = Yy(T);
      if (Array.isArray(we)) {
        if (Array.isArray(K)) {
          const ue = K.filter(
            (ge) => !we.some(
              (Te) => cf(Te, ge)
            )
          ).map((ge) => ({ name: ge, value: ge }));
          ue.length && (we = [...we, ...ue]);
        } else K && !we.some((ue) => cf(ue, K)) && (we = [...we, { name: K, value: K }]);
        $(we);
      }
    }
  }, [T]);
  const ae = Ur(
    () => g ? y5(z, N, { keys: ["name", "value"] }) : z,
    [z, N]
  ), me = Ur(
    () => g ? y5(ae, N, {
      keys: ["name", "value"],
      threshold: y5.rankings.CASE_SENSITIVE_EQUAL
    }).length > 0 : !1,
    [ae, N]
  );
  return g || m ? /* @__PURE__ */ f.jsx(
    EM,
    {
      resetValueOnHide: !0,
      setValue: (K) => Y(K),
      children: /* @__PURE__ */ f.jsx(NR, { ...ce, children: /* @__PURE__ */ f.jsxs(BR, { store: R, options: z, children: [
        /* @__PURE__ */ f.jsx(VR, { ...P }),
        /* @__PURE__ */ f.jsxs(R8, { children: [
          /* @__PURE__ */ f.jsxs(ct, { px: "4", pb: "4", display: "flex", alignItems: "center", children: [
            /* @__PURE__ */ f.jsx(
              iw,
              {
                autoSelect: !0,
                placeholder: "Search...",
                className: wG,
                value: N,
                onChange: (K) => Y(K.target.value)
              }
            ),
            b && /* @__PURE__ */ f.jsx(
              WU,
              {
                className: SG,
                color: oE.static.content.weak
              }
            )
          ] }),
          /* @__PURE__ */ f.jsxs(hx, { children: [
            N && !me && l && /* @__PURE__ */ f.jsxs(
              H4,
              {
                className: ZO,
                value: N,
                onClick: () => {
                  Ce(N), Y("");
                },
                children: [
                  /* @__PURE__ */ f.jsx(NO, {}),
                  /* @__PURE__ */ f.jsx(
                    Yr,
                    {
                      size: "small",
                      weight: "medium",
                      color: "secondaryContentOnEnabled",
                      children: N
                    }
                  )
                ]
              }
            ),
            ae.map((K) => /* @__PURE__ */ f.jsx(
              _8,
              {
                value: String(K.value),
                render: /* @__PURE__ */ f.jsx(H4, {}),
                onClick: () => Y(""),
                children: K.name
              },
              K.value
            ))
          ] })
        ] })
      ] }) })
    }
  ) : /* @__PURE__ */ f.jsx(NR, { ...ce, children: /* @__PURE__ */ f.jsxs(BR, { store: R, options: z, children: [
    /* @__PURE__ */ f.jsx(VR, { ...P }),
    /* @__PURE__ */ f.jsx(R8, { children: Array.isArray(T) ? z.map((K) => /* @__PURE__ */ f.jsx(
      _8,
      {
        value: String(K.value),
        children: K.name
      },
      K.value
    )) : t })
  ] }) });
}, VR = ({
  renderValue: e,
  trigger: t,
  ...a
}) => {
  const l = t ?? CG, h = yf(), g = h.useState("value"), { displayMode: m, loading: S, options: b } = Hw();
  S && (a.disabled = !0);
  const R = (T) => {
    const j = h.getState().items;
    if (!(b != null && b.length) && !j.length)
      return Array.isArray(T) ? T.map(k4) : k4(T);
    if (!(b != null && b.length)) {
      const L = Array.isArray(T) ? T : [T], P = j.filter(
        (N) => L.some((F) => cf(N.value, F))
      );
      return Array.isArray(T) ? VO(P) : BO(P[0]);
    }
    const A = (L) => (b ?? []).map(
      (N) => typeof N == "string" ? {
        name: N,
        value: N
      } : N
    ).find((N) => cf(N, L)) ?? k4(L);
    return Array.isArray(T) ? T.map(A) : A(T);
  }, D = (T) => {
    if (e)
      return e(T) ?? a.placeholder ?? "Select...";
    const j = R(T);
    return m === "tags" ? !j || Array.isArray(j) && !j.length ? a.placeholder ?? "Select..." : /* @__PURE__ */ f.jsx(
      Oi,
      {
        direction: "row",
        align: "center",
        gap: "6",
        flexWrap: "wrap",
        whiteSpace: "normal",
        width: "full",
        children: Array.isArray(j) ? j.map((A) => /* @__PURE__ */ f.jsx(UR, { value: A.value, children: A.name }, A.value)) : /* @__PURE__ */ f.jsx(UR, { value: j.value, children: j.name })
      }
    ) : Array.isArray(j) ? j.length ? j.map((A) => A.name).join(", ") : a.placeholder ?? "Select..." : j.name;
  };
  return /* @__PURE__ */ f.jsx(l, { style: { opacity: a.disabled ? 0.7 : 1 }, ...a, children: g ? D(g) : /* @__PURE__ */ f.jsx(Yr, { color: "secondaryContentOnEnabled", children: a.placeholder ?? "Select..." }) });
}, BR = ({ children: e, ...t }) => {
  const { value: a, setOptions: l, setValue: h } = Hw(), g = t.store.useState("items");
  return gt(() => {
    l && !t.options && g.length && l(VO(g));
  }, [g]), /* @__PURE__ */ f.jsx(
    bT,
    {
      value: M8(a),
      setValue: h,
      ...t,
      children: e
    }
  );
}, CG = ({
  children: e,
  hideArrow: t,
  ...a
}) => {
  const { clearable: l, value: h, setValue: g } = Hw(), m = Array.isArray(h), S = Pt(null);
  return /* @__PURE__ */ f.jsx(
    c3,
    {
      className: mG,
      ...a,
      toggleOnPress: (b) => {
        var R;
        return !((R = S.current) != null && R.contains(b.target) || S.current === b.target);
      },
      children: /* @__PURE__ */ f.jsxs(
        Oi,
        {
          direction: "row",
          align: "center",
          justify: "space-between",
          width: "full",
          children: [
            typeof e == "string" ? /* @__PURE__ */ f.jsx(
              Yr,
              {
                color: "secondaryContentOnEnabled",
                lines: "1",
                align: "left",
                children: e
              }
            ) : e,
            /* @__PURE__ */ f.jsxs(Oi, { direction: "row", align: "center", gap: "6", children: [
              l && (m ? h.length > 0 : !!h) && /* @__PURE__ */ f.jsx(
                d3,
                {
                  ref: S,
                  icon: /* @__PURE__ */ f.jsx(Fx, {}),
                  onClick: (b) => {
                    b.preventDefault(), b.stopPropagation(), Array.isArray(h) ? g([]) : g(void 0);
                  },
                  size: "xSmall",
                  emphasis: "none",
                  kind: "secondary"
                }
              ),
              !t && /* @__PURE__ */ f.jsx(
                ww,
                {
                  render: /* @__PURE__ */ f.jsx(
                    IT,
                    {
                      color: oE.static.content.moderate
                    }
                  )
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, bG = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(c3, { ...t, render: /* @__PURE__ */ f.jsx(f3, {}), children: /* @__PURE__ */ f.jsxs(Oi, { direction: "row", gap: "4", align: "center", children: [
  e,
  /* @__PURE__ */ f.jsx(ww, { render: /* @__PURE__ */ f.jsx(IT, {}) })
] }) }), _G = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(xw, { ...t, children: e }), _8 = ({
  children: e,
  value: t,
  ...a
}) => {
  const l = [t];
  typeof e == "string" && (l.push(e), t === void 0 && (t = e));
  const h = yf().useState("value"), g = Array.isArray(h) ? l.some((m) => h.includes(m)) : l.includes(h);
  return /* @__PURE__ */ f.jsxs(
    yw,
    {
      focusOnHover: !0,
      value: t,
      className: ZO,
      ...a,
      children: [
        /* @__PURE__ */ f.jsx(NO, { checked: g, style: { flexShrink: 0 } }),
        e ? typeof e == "string" ? /* @__PURE__ */ f.jsx(
          Yr,
          {
            size: "small",
            weight: "medium",
            color: "secondaryContentOnEnabled",
            lines: "1",
            children: e
          }
        ) : e : /* @__PURE__ */ f.jsx(
          Yr,
          {
            size: "small",
            weight: "medium",
            color: "secondaryContentOnEnabled",
            lines: "1",
            children: t
          }
        )
      ]
    }
  );
}, NO = ({
  children: e,
  ...t
}) => {
  const { checkType: a } = Hw();
  return a === "checkbox" ? /* @__PURE__ */ f.jsx(ct, { cssClass: yG, children: t.checked && /* @__PURE__ */ f.jsx(Nx, { color: "white", size: "13" }) }) : /* @__PURE__ */ f.jsx(ET, { ...t, className: xG, children: e ?? /* @__PURE__ */ f.jsx(kT, { size: "16" }) });
}, R8 = ({ children: e, ...t }) => /* @__PURE__ */ f.jsxs(Sw, { gutter: 4, className: gG, ...t, children: [
  /* @__PURE__ */ f.jsx(Pp, { size: 0 }),
  e
] }), RG = ({ children: e }) => /* @__PURE__ */ f.jsx(RT, { children: e }), EG = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(_T, { ...t, children: e }), bp = (e) => e !== null && typeof e == "object", E8 = (e) => bp(e) ? e : {
  name: String(e),
  value: String(e)
}, Yy = (e) => {
  if (e !== void 0)
    return Array.isArray(e) ? e.map(E8) : E8(e);
}, FR = (e) => e === void 0 ? "" : bp(e) ? String(e.value) : String(e), VO = (e) => e.map(BO), BO = (e) => {
  var t;
  return {
    name: String(((t = e.element) == null ? void 0 : t.innerText) ?? e.value),
    value: e.value
  };
}, k4 = (e) => ({
  name: String(e),
  value: e
}), M8 = (e) => Array.isArray(e) ? e.map(FR) : FR(e), cf = (e, t) => {
  if (t === void 0)
    return !1;
  if (bp(e) && bp(t)) {
    const a = [e.value, e.name].map(String), l = [t.value, t.name].map(String);
    return a.some((h) => l.includes(h));
  } else {
    if (bp(e))
      return [e.value, e.name].map(String).includes(String(t));
    if (bp(t))
      return [t.value, t.name].map(String).includes(String(e));
  }
  return String(e) === String(t);
}, UR = ({
  children: e,
  value: t
}) => {
  const a = yf(), l = a.useState("value"), h = e;
  return /* @__PURE__ */ f.jsx(
    Vp,
    {
      cursor: "pointer",
      shape: "basic",
      variant: "white",
      size: "medium",
      label: h,
      iconEnd: /* @__PURE__ */ f.jsx(Bx, {}),
      onMouseDown: (g) => {
        g.preventDefault(), g.stopPropagation();
        const m = Array.isArray(l) ? l.filter(
          (S) => !cf(S, { name: h, value: t })
        ) : "";
        a.setValue(m);
      }
    }
  );
};
V0.Label = _G;
V0.Group = RG;
V0.GroupLabel = EG;
V0.Option = _8;
V0.Popover = R8;
V0.SelectTriggerButton = bG;
V0.useContext = yf;
V0.useStore = Np;
var MG = Yi({ defaultClassName: "_33k3h10", variantClassNames: { truncate: { true: "_33k3h11", false: "_33k3h12" }, size: { xSmall: "_33k3h13", small: "_33k3h14" }, collapsed: { true: "_33k3h15", false: "_33k3h16" }, outline: { true: "_33k3h17", false: "_33k3h18" }, rounded: { first: "_33k3h19", middle: "_33k3h1a", last: "_33k3h1b", true: "_33k3h1c" } }, defaultVariants: { size: "small", outline: !0, truncate: !1 }, compoundVariants: [] }), TG = "_33k3h1e", OG = "_33k3h1f", YR = "_33k3h1g", $R = "_33k3h1h";
const cS = ({
  label: e,
  name: t,
  tag: a,
  optional: l,
  disabled: h
}) => /* @__PURE__ */ f.jsxs(ct, { display: "flex", flexDirection: "row", gap: "6", children: [
  e && /* @__PURE__ */ f.jsxs(
    ct,
    {
      display: "flex",
      alignItems: "center",
      gap: "6",
      style: { height: 16 },
      children: [
        /* @__PURE__ */ f.jsx(FE, { name: t, children: /* @__PURE__ */ f.jsx(
          Yr,
          {
            userSelect: "none",
            size: "xSmall",
            weight: "medium",
            color: h ? "secondaryContentOnDisabled" : "weak",
            children: e
          }
        ) }),
        a
      ]
    }
  ),
  l && /* @__PURE__ */ f.jsx(Vp, { shape: "basic", size: "small", label: "Optional" })
] }), FO = ({
  children: e,
  label: t,
  disabled: a,
  name: l,
  tag: h,
  icon: g,
  optional: m = !1
}) => t ? /* @__PURE__ */ f.jsxs(ct, { display: "flex", flexDirection: "column", width: "full", gap: "4", children: [
  /* @__PURE__ */ f.jsxs(ct, { display: "flex", flexDirection: "row", gap: "6", alignItems: "center", children: [
    t && /* @__PURE__ */ f.jsx(
      cS,
      {
        label: t,
        name: l,
        tag: h,
        disabled: a
      }
    ),
    m && /* @__PURE__ */ f.jsx(Vp, { shape: "basic", size: "small", label: "Optional" }),
    g
  ] }),
  e
] }) : /* @__PURE__ */ f.jsx(f.Fragment, { children: e }), Os = ({
  children: e,
  defaultValues: t,
  store: a,
  noValidate: l = !1,
  // use browser validation by default
  ...h
}) => /* @__PURE__ */ f.jsx(PE, { defaultValues: t, store: a, children: /* @__PURE__ */ f.jsx(ZE, { noValidate: l, ...h, role: "form", children: e }) }), DG = ({ ...e }) => /* @__PURE__ */ f.jsx(NE, { ...e, render: /* @__PURE__ */ f.jsx(ct, { color: "bad" }) }), jG = (e) => /* @__PURE__ */ f.jsx(qE, { render: /* @__PURE__ */ f.jsx(f3, {}), ...e }), AG = O8(
  ({
    label: e,
    labelTag: t,
    icon: a,
    cssClass: l,
    size: h,
    collapsed: g,
    truncate: m,
    outline: S,
    name: b,
    rounded: R,
    ...D
  }, T) => {
    const j = Pt(null), A = T ?? j;
    Sa.useEffect(() => {
      g && A.current && A.current.blur();
    }, [g]), A.current && A.current.value && (g = !1);
    const L = D.type === "number";
    L && (D.step = D.step ?? 1);
    const P = () => {
      const N = new Event("change", {
        bubbles: !0
      });
      A.current.dispatchEvent(N);
    };
    return /* @__PURE__ */ f.jsx(
      FO,
      {
        label: e,
        name: b,
        icon: a,
        tag: t,
        disabled: D.disabled,
        children: /* @__PURE__ */ f.jsxs(ct, { position: "relative", flex: "stretch", children: [
          /* @__PURE__ */ f.jsx(
            J8,
            {
              ref: A,
              name: b,
              className: Fr(
                MG({
                  size: h,
                  collapsed: g,
                  outline: S,
                  truncate: m,
                  rounded: R
                }),
                l,
                {
                  [TG]: L
                }
              ),
              ...D
            }
          ),
          L && /* @__PURE__ */ f.jsxs(
            ct,
            {
              display: "flex",
              position: "absolute",
              flexDirection: "column",
              style: { top: 0, right: 0, bottom: 0 },
              children: [
                /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    type: "button",
                    className: YR,
                    onClick: (N) => {
                      var Y;
                      const F = N.shiftKey ? 10 : 1;
                      (Y = A.current) == null || Y.stepUp(F), P();
                    },
                    children: /* @__PURE__ */ f.jsx(
                      FU,
                      {
                        size: "16",
                        className: $R
                      }
                    )
                  }
                ),
                /* @__PURE__ */ f.jsx(ct, { cssClass: OG }),
                /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    type: "button",
                    className: YR,
                    onClick: (N) => {
                      var Y;
                      const F = N.shiftKey ? 10 : 1;
                      (Y = A.current) == null || Y.stepDown(F), P();
                    },
                    children: /* @__PURE__ */ f.jsx(
                      Vx,
                      {
                        size: "16",
                        className: $R
                      }
                    )
                  }
                )
              ]
            }
          )
        ] })
      }
    );
  }
), kG = ({
  children: e,
  label: t = "",
  tag: a,
  optional: l,
  name: h,
  options: g,
  creatable: m,
  disabled: S,
  filterable: b,
  checkType: R,
  defaultValue: D,
  displayMode: T,
  loading: j,
  trigger: A,
  onValueChange: L,
  onCreate: P,
  renderValue: N,
  ...F
}) => {
  const Y = Ro(), G = F.value ?? Y.useValue(h);
  return /* @__PURE__ */ f.jsxs(Oi, { direction: "column", gap: "4", children: [
    t.trim() !== "" && /* @__PURE__ */ f.jsx(
      cS,
      {
        label: t,
        name: h,
        tag: a,
        optional: l,
        disabled: S
      }
    ),
    /* @__PURE__ */ f.jsx(
      J8,
      {
        name: h,
        render: /* @__PURE__ */ f.jsx(
          V0,
          {
            value: G,
            options: g,
            creatable: m,
            disabled: S,
            filterable: b,
            checkType: R,
            defaultValue: D,
            displayMode: T,
            loading: j,
            trigger: A,
            renderValue: N,
            onCreate: P,
            onValueChange: (z) => {
              Y.setValue(h, z.value), L && L(z);
            }
          }
        ),
        ...F,
        children: e
      }
    )
  ] });
}, LG = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(V0.Option, { ...t, children: e });
Os.Input = AG;
Os.Error = DG;
Os.Submit = jG;
Os.Label = cS;
Os.Select = kG;
Os.Option = LG;
Os.NamedSection = FO;
Os.useStore = G8;
Os.useContext = Ro;
var IG = "_11uj8320", HG = Yi({ defaultClassName: "_11uj8322 _11uj8321 _1faqfmv4e _1faqfmv4y _1faqfmv37 _1faqfmv3r _1faqfmvsz _1faqfmv1x _1faqfmvtn", variantClassNames: { selected: { true: "_11uj8323", false: "_11uj8324" } }, defaultVariants: { selected: !1 }, compoundVariants: [] }), ZG = "_11uj8325", PG = "_11uj8326";
const da = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(eT, { ...t, children: e }), NG = ({
  children: e,
  ...t
}) => {
  const a = wf(), l = t.icon && !e ? /* @__PURE__ */ f.jsx(d3, { icon: t.icon }) : /* @__PURE__ */ f.jsx(f3, {});
  return /* @__PURE__ */ f.jsx(nT, { render: l, store: a, ...t, children: e });
}, VG = ({ children: e, cssClass: t, ...a }) => {
  const l = wf();
  return /* @__PURE__ */ f.jsxs(
    JM,
    {
      store: l,
      gutter: 4,
      className: Fr(IG, t),
      ...a,
      children: [
        /* @__PURE__ */ f.jsx(tT, { size: 0 }),
        e
      ]
    }
  );
}, BG = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(
  oT,
  {
    className: HG({ selected: !1 }),
    ...t,
    children: typeof e == "string" ? /* @__PURE__ */ f.jsx(Yr, { children: e }) : e
  }
), UO = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(uT, { className: ZG, ...t, children: e }), FG = ({
  children: e,
  className: t,
  ...a
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    lT,
    {
      className: Fr(PG, t),
      ...a,
      children: e
    }
  ),
  /* @__PURE__ */ f.jsx(UO, {})
] });
da.Button = NG;
da.List = VG;
da.Item = BG;
da.Divider = UO;
da.Heading = FG;
da.useStore = Tx;
da.useContext = wf;
const UG = (e) => {
  const { selected: t, disabled: a, range: l } = e;
  return a ? "n8" : t || l == "will-be-range-start" || l == "will-be-range-end" ? "white" : "inherit";
}, YG = (e) => {
  const { range: t, selected: a, now: l } = e;
  return !a && !l && t === "" || l || a && t === "" || l && t === "will-be-range-end" || a && t === "range-start" || l && a || t === "will-be-range-start" ? "6" : "inherit";
}, $G = (e) => {
  const { range: t, selected: a, now: l } = e;
  return !a && !l && t === "" || l || a && t === "" || l && a || a && t === "range-end" || t === "will-be-range-end" ? "6" : "inherit";
}, WG = (e) => {
  const { range: t, selected: a, now: l } = e;
  return !a && !l && t === "" || l || a && t === "" || l && t === "will-be-range-end" || l && a || a && t === "range-start" || t === "will-be-range-start" ? "6" : "inherit";
}, zG = (e) => {
  const { range: t, selected: a, now: l } = e;
  return !a && !l && t === "" || l || a && t === "range-end" || l && a || a && t === "" ? "6" : a && t === "in-range" ? "inherit" : t === "will-be-range-end" ? "6" : "inherit";
}, qG = (e) => {
  const { selected: t, range: a, now: l, disabled: h } = e;
  return h ? "inherit" : l && t || l && a === "will-be-range-end" ? "p9" : l && a === "will-be-in-range" || t || a === "will-be-range-end" || a === "will-be-range-start" ? "p6" : "inherit";
}, GG = (e) => {
  const { selected: t, range: a, now: l, disabled: h } = e;
  return h ? "inherit" : l ? "lb300" : t || a == "will-be-range-end" || a == "will-be-range-start" ? "p9" : a == "will-be-in-range" || a == "in-range" ? "p6" : "inherit";
}, s5 = (e) => {
  const { selected: t, range: a, now: l } = e;
  return l ? "round" : t || a == "will-be-range-start" || a == "will-be-range-end" ? "6" : "inherit";
}, KG = (e) => {
  const { disabled: t } = e;
  return t ? "not-allowed" : "pointer";
}, QG = (e) => {
  const { now: t } = e;
  return t ? "24px" : "36px";
}, XG = (e) => {
  const { now: t } = e;
  return t ? "24px" : "34px";
}, WR = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, JG = ({ children: e, day: t, onMouseEnter: a, onMouseLeave: l }) => {
  const { dayButton: h } = XY(), g = t.now ? ct : lE, m = t.now ? {
    style: WR,
    backgroundColor: t.range === "will-be-in-range" || t.range === "in-range" || t.range === "will-be-range-end" || t.selected ? "p6" : "inherit",
    borderTopRightRadius: t.range === "range-end" || t.range === "will-be-range-end" ? "6" : "inherit",
    borderBottomRightRadius: t.range === "range-end" || t.range === "will-be-range-end" ? "6" : "inherit"
  } : {}, S = h(t);
  return /* @__PURE__ */ f.jsx(g, { ...m, children: /* @__PURE__ */ f.jsx(
    ct,
    {
      onMouseLeave: l,
      ...S,
      onMouseEnter: function() {
        var b;
        a == null || a(), (b = S == null ? void 0 : S.onMouseEnter) == null || b.call(S);
      },
      cursor: KG(t),
      style: WR,
      backgroundColor: {
        default: qG(t),
        hover: t.disabled || t.selected || t.range === "will-be-range-end" || t.range === "will-be-range-start" ? void 0 : "p4"
      },
      borderTopLeftRadius: YG(t),
      borderTopRightRadius: $G(t),
      borderBottomLeftRadius: WG(t),
      borderBottomRightRadius: zG(
        t
      ),
      children: /* @__PURE__ */ f.jsx(
        ct,
        {
          color: UG(t),
          backgroundColor: GG(t),
          padding: "10",
          style: {
            width: QG(t),
            height: XG(t),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          borderTopLeftRadius: s5(t),
          borderBottomLeftRadius: s5(t),
          borderTopRightRadius: s5(t),
          borderBottomRightRadius: s5(t),
          children: e
        }
      )
    }
  ) });
};
var zR = "xcbb8h0", eK = "xcbb8h1", tK = "xcbb8h2";
Yi({ defaultClassName: "xcbb8h3", variantClassNames: {}, defaultVariants: {}, compoundVariants: [] });
const nK = ({
  prevButton: e,
  nextButton: t,
  calendar: a,
  hasSelectedRange: l
}) => {
  const { weekDays: h } = FT(), [g, m] = Qt(!1), { days: S, month: b, year: R } = a;
  return /* @__PURE__ */ f.jsxs(ct, { backgroundColor: "white", p: "10", cursor: "default", children: [
    /* @__PURE__ */ f.jsxs(Oi, { direction: "row", align: "center", children: [
      e,
      /* @__PURE__ */ f.jsx(ct, { flexGrow: 1, children: /* @__PURE__ */ f.jsxs(Yr, { userSelect: "none", align: "center", children: [
        b,
        " ",
        R
      ] }) }),
      t
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: eK, children: h.map((D) => /* @__PURE__ */ f.jsx(Yr, { align: "center", userSelect: "none", children: D }, D)) }),
    /* @__PURE__ */ f.jsx(
      "main",
      {
        className: tK,
        onMouseLeave: function() {
          m(!0);
        },
        children: S.map((D) => /* @__PURE__ */ f.jsx(
          JG,
          {
            day: {
              ...D,
              range: l ? D.range : g ? "" : D.range
            },
            onMouseEnter: function() {
              m(D.disabled);
            },
            children: /* @__PURE__ */ f.jsx(Yr, { userSelect: "none", align: "center", children: D.day })
          },
          D.$date.toString()
        ))
      }
    )
  ] });
}, rK = ({ hasSelectedRange: e }) => {
  const { calendars: t } = FT(), { addOffset: a, subtractOffset: l } = JY();
  return /* @__PURE__ */ f.jsx(
    nK,
    {
      hasSelectedRange: e,
      prevButton: /* @__PURE__ */ f.jsx(
        ct,
        {
          cursor: "pointer",
          ...l({ months: 1 }),
          cssClass: zR,
          children: /* @__PURE__ */ f.jsx(BU, {})
        }
      ),
      nextButton: /* @__PURE__ */ f.jsx(
        ct,
        {
          cursor: "pointer",
          ...a({ months: 1 }),
          cssClass: zR,
          children: /* @__PURE__ */ f.jsx(h8, {})
        }
      ),
      calendar: t[0]
    }
  );
};
function qR({ name: e, onDateChange: t, placeholder: a }) {
  const [l, h] = Qt(a), g = (S) => {
    const { value: b } = S.target;
    h(b);
  }, m = () => {
    l && t(l);
  };
  return gt(
    function() {
      h(a);
    },
    [a]
  ), /* @__PURE__ */ f.jsx(
    Os.Input,
    {
      name: e,
      placeholder: a,
      type: "input",
      color: "n12",
      value: l,
      style: {
        border: "none",
        background: "none",
        fontSize: "13px",
        fontWeight: "500 !important",
        paddingLeft: "6px",
        width: "130px"
      },
      className: "date-input",
      onChange: g,
      onBlur: m,
      onKeyDown: (S) => {
        S.key === "Enter" && m();
      }
    }
  );
}
function GR({ placeholder: e, name: t, onTimeChange: a }) {
  const [l, h] = Qt(""), g = (S) => {
    const { value: b } = S.target;
    h(b);
  }, m = () => {
    l && a(l);
  };
  return /* @__PURE__ */ f.jsx(
    Os.Input,
    {
      name: t,
      placeholder: e,
      type: "input",
      color: "n12",
      value: l,
      style: {
        border: "none",
        background: "none",
        fontSize: "13px",
        fontWeight: "500 !important",
        paddingLeft: "6px",
        width: "130px"
      },
      className: "date-input",
      onChange: g,
      onBlur: m,
      onKeyDown: (S) => {
        S.key === "Enter" && m();
      }
    }
  );
}
const aK = "MMM DD, YYYY", iK = "MMM DD YYYY", lK = "MMM DD", oK = "MMM D, YYYY", uK = "MMM D YYYY", sK = "MMM D", cK = "MMMM DD, YYYY", fK = "MMMM DD YYYY", dK = "MMMM DD", hK = "MMMM D, YYYY", vK = "MMMM D YYYY", pK = "MMMM D", mK = "MM/DD/YYYY", gK = "MM/DD", wK = "MM-DD-YYYY", yK = "MM-DD", xK = "MM.DD.YYYY", SK = "MM.DD", YO = "HH:mm a", CK = "HH:mma", bK = "h:mm a", _K = "h:mma", RK = "HH:mm", EK = "h:mm", MK = "h a", TK = "h", OK = "ha", DK = "HH", jK = "hh:mm a", KR = [
  mK,
  wK,
  xK,
  aK,
  iK,
  uK,
  oK,
  cK,
  dK,
  lK,
  sK,
  gK,
  yK,
  SK,
  fK,
  hK,
  vK,
  pK
], QR = [
  YO,
  CK,
  bK,
  _K,
  MK,
  OK,
  TK,
  DK,
  RK,
  EK
], XR = (e) => e ? new Date(e).toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric"
}) : "", JR = (e, t) => e ? Ke(e).format(jK) : t ? "11:59pm" : "12:00 AM", eE = (e) => {
  const t = Ke(e, YO);
  return {
    hour: t.format("HH"),
    minute: t.minute(),
    timeOfDay: t.format("a"),
    hour24: t.hour()
  };
}, H5 = (e, t) => t ? T8(t) === T8(e) : !1, AK = ({
  presets: e,
  selectedValue: t
}) => !e.find((l) => H5(l, t.selectedPreset)), tE = (e, t) => {
  const a = {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  return t && (a.year = "numeric"), e.toLocaleDateString("en-us", a);
}, c5 = (e, t, a) => {
  const l = new Date(e);
  return l.setHours(t), l.setMinutes(a), l;
}, nE = ({
  selectedValue: e,
  presets: t
}) => {
  const a = t.find((g) => H5(g, e.selectedPreset));
  if (a)
    return $O(a);
  const { startDate: l, endDate: h } = e;
  if (l && h) {
    const g = h.getFullYear() > l.getFullYear();
    return `${tE(l, g)} - ${tE(
      h,
      g
    )}`;
  }
  return "";
};
var kK = /* @__PURE__ */ ((e) => (e[e.Default = 0] = "Default", e[e.Custom = 1] = "Custom", e))(kK || {});
const LK = [
  {
    unit: "minutes",
    quantity: 15
  },
  {
    unit: "minutes",
    quantity: 60
  },
  {
    unit: "hours",
    quantity: 4
  },
  {
    unit: "hours",
    quantity: 24
  },
  {
    unit: "days",
    quantity: 7
  },
  {
    unit: "days",
    quantity: 30
  }
], Ble = LK.concat({
  unit: "months",
  quantity: 3
}), $O = (e) => e.label || `Last ${e.quantity} ${e.unit}`, T8 = (e) => e.value || `last_${e.quantity}_${e.unit}`, Fle = (e) => {
  const [, t, a] = e.split("_");
  return {
    quantity: Number(t),
    unit: a
  };
}, IK = (e) => Ke().subtract(e.quantity, e.unit).toDate(), Ule = (e) => {
  const [t, a] = Qt(!1);
  return /* @__PURE__ */ f.jsx(da, { open: t, setOpen: a, placement: "bottom-end", children: /* @__PURE__ */ f.jsx(HK, { ...e, open: t }) });
}, $y = ({
  isSelected: e,
  size: t = 16
}) => /* @__PURE__ */ f.jsx(ct, { style: { height: t, width: t }, color: "primaryEnabled", children: e && /* @__PURE__ */ f.jsx(kT, { size: t }) }), HK = ({
  selectedValue: e,
  onDatesChange: t,
  presets: a,
  noCustom: l,
  defaultPreset: h,
  setDefaultPreset: g,
  minDate: m,
  maxDate: S = Ke().toDate(),
  open: b,
  ...R
}) => {
  const [D, T] = Sa.useState(
    0
    /* Default */
  ), [j, A] = Qt(!0), [L, P] = Qt(!0), [N, F] = Qt(!0), [Y, G] = Qt(!0), z = !e.selectedPreset, [$, ce] = Qt(
    z ? [e.startDate, e.endDate] : []
  ), X = wf();
  gt(() => {
    b || T(
      0
      /* Default */
    );
  }, [b]);
  const Ce = Ur(
    () => XR(e.startDate),
    [e.startDate]
  ), ae = Ur(
    () => XR(e.endDate),
    [e.endDate]
  ), me = Ur(
    () => JR(e.startDate),
    [e.startDate]
  ), K = Ur(
    () => JR(e.endDate, !0),
    [e.endDate]
  ), [we, ue] = Qt(
    nE({ selectedValue: e, presets: a })
  ), ge = ({
    startDate: Qe,
    endDate: rt,
    selectedPreset: vt
  }) => {
    t(Qe, rt, vt), Qe && rt && (X.setOpen(!1), T(
      0
      /* Default */
    ));
  }, Te = (Qe) => {
    const rt = KR.find(
      (vt) => Ke(Qe, vt, !0).isValid()
    );
    if (A(!!rt), rt) {
      const vt = Ke(Qe, rt).toDate(), Ot = c5(
        vt,
        e.startDate.getHours(),
        e.startDate.getMinutes()
      );
      t(Ot, e.endDate, void 0);
    }
  }, be = (Qe) => {
    const rt = KR.find(
      (vt) => Ke(Qe, vt, !0).isValid()
    );
    if (P(!!rt), rt) {
      const vt = Ke(Qe, rt).toDate(), Ot = c5(
        vt,
        e.endDate.getHours(),
        e.endDate.getMinutes()
      );
      t(e.startDate, Ot, void 0);
    }
  }, Ue = (Qe) => {
    const rt = QR.map(
      (vt) => Ke(Qe, vt, !0).isValid()
    ).some((vt) => vt);
    if (F(rt), rt && e.startDate) {
      const vt = eE(Qe), Ot = c5(
        e.startDate,
        vt.hour24,
        vt.minute
      );
      t(Ot, e.endDate, void 0);
    }
  }, le = (Qe) => {
    const rt = QR.map(
      (vt) => Ke(Qe, vt, !0).isValid()
    ).some((vt) => vt);
    if (G(rt), rt && e.endDate) {
      const vt = eE(Qe), Ot = c5(
        e.endDate,
        vt.hour24,
        vt.minute
      );
      t(e.startDate, Ot, void 0);
    }
  };
  gt(() => {
    (e.selectedPreset || e.startDate && e.endDate) && ue(nE({ selectedValue: e, presets: a }));
  }, [e]);
  const _e = Ur(
    () => e.startDate && e.endDate && [e.startDate, e.endDate].filter(
      (Qe) => Ke(Qe).isValid()
    ).length === 2,
    [e]
  ), Pe = Ur(() => a.map((Qe) => ({
    label: $O(Qe),
    value: T8(Qe),
    quantity: Qe.quantity,
    unit: Qe.unit
  })), [a]), mt = (Qe) => {
    let rt = Qe[0], vt = Qe[1];
    rt && (rt = Ke.max(Ke(rt).startOf("day"), Ke(m)).toDate()), vt && (vt = Ke.min(Ke(vt).endOf("day"), Ke(S)).toDate()), rt && vt && ge({ startDate: rt, endDate: vt });
    const Ot = [rt, vt].filter((yn) => !!yn);
    ce(Ot);
  }, Ze = (Qe) => {
    const rt = Ke().toDate(), vt = IK(Qe);
    ge({
      startDate: vt,
      endDate: rt,
      selectedPreset: Qe
    });
  }, Nt = j && N, kt = L && Y;
  return /* @__PURE__ */ f.jsxs(
    QY,
    {
      config: {
        selectedDates: $,
        onDatesChange: mt,
        dates: {
          mode: "range",
          minDate: m,
          maxDate: S,
          selectSameDate: !0
        }
      },
      children: [
        /* @__PURE__ */ f.jsx(
          da.Button,
          {
            kind: "secondary",
            iconRight: /* @__PURE__ */ f.jsx(Vx, {}),
            style: {
              whiteSpace: "nowrap",
              overflow: "hidden"
            },
            ...R,
            children: we
          }
        ),
        /* @__PURE__ */ f.jsxs(da.List, { children: [
          D === 0 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            Pe.map((Qe) => /* @__PURE__ */ f.jsx(
              da.Item,
              {
                onClick: (rt) => {
                  rt.preventDefault(), rt.stopPropagation(), Ze(Qe);
                },
                children: /* @__PURE__ */ f.jsxs(
                  Oi,
                  {
                    py: "2",
                    direction: "row",
                    align: "center",
                    gap: "4",
                    children: [
                      /* @__PURE__ */ f.jsx(
                        $y,
                        {
                          isSelected: H5(
                            Qe,
                            e.selectedPreset
                          )
                        }
                      ),
                      /* @__PURE__ */ f.jsx(Yr, { userSelect: "none", children: Qe.label })
                    ]
                  }
                )
              },
              Qe.label
            )),
            l ? null : /* @__PURE__ */ f.jsx(
              da.Item,
              {
                onClick: (Qe) => {
                  Qe.preventDefault(), Qe.stopPropagation(), T(
                    1
                    /* Custom */
                  );
                },
                children: /* @__PURE__ */ f.jsxs(
                  Oi,
                  {
                    width: "full",
                    display: "flex",
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                      /* @__PURE__ */ f.jsxs(
                        Oi,
                        {
                          direction: "row",
                          align: "center",
                          gap: "4",
                          children: [
                            /* @__PURE__ */ f.jsx(
                              $y,
                              {
                                isSelected: AK({
                                  presets: a,
                                  selectedValue: e
                                })
                              }
                            ),
                            /* @__PURE__ */ f.jsx(Yr, { userSelect: "none", children: "Custom" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ f.jsx(h8, { size: 16 })
                    ]
                  }
                )
              }
            ),
            h && g && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
              /* @__PURE__ */ f.jsx(da.Divider, {}),
              /* @__PURE__ */ f.jsxs(da, { children: [
                /* @__PURE__ */ f.jsx(da.Button, { render: /* @__PURE__ */ f.jsx(da.Item, {}), children: /* @__PURE__ */ f.jsxs(
                  Oi,
                  {
                    width: "full",
                    display: "flex",
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                      /* @__PURE__ */ f.jsxs(
                        Oi,
                        {
                          direction: "row",
                          align: "center",
                          gap: "4",
                          children: [
                            /* @__PURE__ */ f.jsx(UU, { size: 16 }),
                            /* @__PURE__ */ f.jsx(Yr, { userSelect: "none", children: "Default" }),
                            /* @__PURE__ */ f.jsx(
                              Vp,
                              {
                                label: `${h.quantity} ${h.unit}`
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ f.jsx(h8, { size: 16 })
                    ]
                  }
                ) }),
                /* @__PURE__ */ f.jsx(da.List, { children: Pe.map((Qe) => /* @__PURE__ */ f.jsx(
                  da.Item,
                  {
                    onClick: (rt) => {
                      rt.preventDefault(), rt.stopPropagation(), g(Qe);
                    },
                    children: /* @__PURE__ */ f.jsxs(
                      Oi,
                      {
                        py: "2",
                        direction: "row",
                        align: "center",
                        gap: "4",
                        children: [
                          /* @__PURE__ */ f.jsx(
                            $y,
                            {
                              isSelected: H5(
                                Qe,
                                h
                              )
                            }
                          ),
                          /* @__PURE__ */ f.jsx(Yr, { userSelect: "none", children: `${Qe.quantity} ${Qe.unit}` })
                        ]
                      }
                    )
                  },
                  Qe.label
                )) })
              ] })
            ] })
          ] }),
          D === 1 && /* @__PURE__ */ f.jsxs(Os, { children: [
            /* @__PURE__ */ f.jsxs(
              ct,
              {
                borderBottom: "divider",
                pb: "4",
                px: "4",
                display: "flex",
                gap: "4",
                children: [
                  /* @__PURE__ */ f.jsxs(
                    ct,
                    {
                      style: { width: 130 },
                      border: Nt ? "secondary" : "error",
                      borderRadius: "6",
                      children: [
                        /* @__PURE__ */ f.jsx(
                          ct,
                          {
                            borderBottom: Nt ? "secondary" : "error",
                            children: /* @__PURE__ */ f.jsx(
                              qR,
                              {
                                name: "startDate",
                                placeholder: Ce || "Start date",
                                onDateChange: Te
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ f.jsx(ct, { children: /* @__PURE__ */ f.jsx(
                          GR,
                          {
                            name: "startTime",
                            placeholder: me,
                            onTimeChange: Ue
                          }
                        ) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ f.jsxs(
                    ct,
                    {
                      style: { width: 130 },
                      border: kt ? "secondary" : "error",
                      borderRadius: "6",
                      children: [
                        /* @__PURE__ */ f.jsx(
                          ct,
                          {
                            borderBottom: kt ? "secondary" : "error",
                            children: /* @__PURE__ */ f.jsx(
                              qR,
                              {
                                name: "endDate",
                                placeholder: ae || "End date",
                                onDateChange: be
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ f.jsx(ct, { children: /* @__PURE__ */ f.jsx(
                          GR,
                          {
                            name: "endTime",
                            placeholder: K,
                            onTimeChange: le
                          }
                        ) })
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ f.jsx(
              da.Item,
              {
                style: { padding: 0 },
                onClick: (Qe) => {
                  Qe.preventDefault(), Qe.stopPropagation();
                },
                children: /* @__PURE__ */ f.jsx(rK, { hasSelectedRange: _e })
              }
            )
          ] })
        ] })
      ]
    }
  );
}, ZK = Ke(), Yle = () => ZK.clone(), fS = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(ox, { ...t, children: e });
fS.useStore = q4;
fS.useContext = W4;
fS.Provider = ux;
var PK = Yi({ defaultClassName: "_1njg9051 _1njg9050 _1faqfmv5b", variantClassNames: { align: { center: "_1njg9052" }, level: { h1: "_1njg9053", h2: "_1njg9054", h3: "_1njg9055", h4: "_1njg9056" } }, defaultVariants: {}, compoundVariants: [] });
const $le = ({
  align: e,
  as: t,
  children: a,
  level: l = "h2",
  lines: h,
  title: g,
  ...m
}) => {
  const S = h ? /* @__PURE__ */ f.jsx(Zx, { lines: h, children: a }) : a;
  return /* @__PURE__ */ f.jsx(
    ct,
    {
      as: t || l,
      cssClass: PK({ align: e, level: l }),
      title: g,
      ...m,
      children: S
    }
  );
};
var NK = Yi({ defaultClassName: "_10i04yv0", variantClassNames: { size: { medium: "_10i04yv1" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
const Wle = ({ ...e }) => {
  const [t, a] = Sa.useState(
    e.selectedKey ?? e.options[0].key
  );
  return /* @__PURE__ */ f.jsxs(da, { children: [
    /* @__PURE__ */ f.jsx(
      da.Button,
      {
        size: e.size,
        kind: "secondary",
        emphasis: "low",
        className: NK({ size: e.size }),
        children: /* @__PURE__ */ f.jsxs(ct, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ f.jsx(Yr, { case: "capital", children: t }),
          /* @__PURE__ */ f.jsx(Vx, {})
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx(da.List, { children: e.options.map((l, h) => {
      var m;
      const g = /* @__PURE__ */ f.jsx(
        da.Item,
        {
          onClick: () => {
            a(l.key), e.onChange(l.key);
          },
          children: l.variants ? /* @__PURE__ */ f.jsx(ct, { display: "flex", alignItems: "center", children: /* @__PURE__ */ f.jsx(
            Vp,
            {
              size: "medium",
              label: (m = l.render) == null ? void 0 : m.toString(),
              ...l.variants
            }
          ) }) : /* @__PURE__ */ f.jsx(ct, { paddingLeft: "2", children: /* @__PURE__ */ f.jsx(Yr, { children: l.render }) })
        },
        l.key
      );
      return e.divider && e.options.length > 2 && h === 0 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        g,
        /* @__PURE__ */ f.jsx(da.Divider, {})
      ] }) : g;
    }) })
  ] });
};
var VK = "_48zb7v0";
const Up = ({
  children: e,
  hideOnInteractOutside: t,
  unmountOnHide: a,
  width: l = 360,
  onClose: h,
  ...g
}) => /* @__PURE__ */ f.jsx(ux, { ...g, children: /* @__PURE__ */ f.jsx(
  ox,
  {
    modal: !0,
    render: /* @__PURE__ */ f.jsx(
      ct,
      {
        border: "divider",
        borderRadius: "8",
        boxShadow: "small",
        overflow: "hidden",
        cssClass: VK,
        style: { width: l }
      }
    ),
    hideOnInteractOutside: t,
    unmountOnHide: a,
    onClose: h,
    getPersistentElements: () => Array.from(
      document.querySelectorAll(
        "[data-persistent-element]"
      )
    ).filter((m) => m != null),
    backdrop: /* @__PURE__ */ f.jsx(
      ct,
      {
        style: {
          backgroundColor: "rgba(111, 110, 119, 0.48)"
        }
      }
    ),
    children: e
  }
) }), BK = ({ children: e }) => {
  const t = W4();
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      py: "6",
      px: "8",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bb: "divider",
      borderTopLeftRadius: "8",
      borderTopRightRadius: "8",
      backgroundColor: "raised",
      position: "relative",
      children: [
        /* @__PURE__ */ f.jsx(Oi, { align: "center", direction: "row", gap: "6", children: e }),
        /* @__PURE__ */ f.jsx(
          d3,
          {
            icon: /* @__PURE__ */ f.jsx(Bx, {}),
            size: "xSmall",
            emphasis: "low",
            kind: "secondary",
            onClick: t.hide,
            style: { position: "absolute", top: 6, right: 8 }
          }
        )
      ]
    }
  );
}, FK = ({ children: e }) => /* @__PURE__ */ f.jsx(ct, { backgroundColor: "white", padding: "12", children: e }), UK = ({ actions: e, children: t }) => /* @__PURE__ */ f.jsxs(
  ct,
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4",
    borderTop: "divider",
    borderBottomLeftRadius: "8",
    borderBottomRightRadius: "8",
    backgroundColor: "raised",
    children: [
      /* @__PURE__ */ f.jsx(ct, { display: "flex", alignItems: "center", flexDirection: "row", children: t }),
      /* @__PURE__ */ f.jsx(Oi, { gap: "4", direction: "row", children: e })
    ]
  }
), YK = (e) => {
  const t = W4();
  return /* @__PURE__ */ f.jsx(
    f3,
    {
      onClick: t.hide,
      kind: "secondary",
      emphasis: "high",
      ...e,
      children: "Cancel"
    }
  );
};
Up.Header = BK;
Up.Body = FK;
Up.Footer = UK;
Up.CancelButton = YK;
Up.useStore = q4;
Up.useContext = W4;
var $K = "v28rj20", WK = "v28rj21", zK = "v28rj22", qK = "v28rj23", GK = "v28rj24", KK = "v28rj25";
const zle = ({
  label: e,
  icon: t,
  defaultValue: a,
  value: l,
  options: h,
  onChange: g,
  selected: m
}) => {
  const S = Np({
    defaultValue: a ? [a] : [],
    value: l,
    setValue: (b) => g(b)
  });
  return /* @__PURE__ */ f.jsxs(ct, { children: [
    /* @__PURE__ */ f.jsx(
      xw,
      {
        store: S,
        className: $K,
        children: e
      }
    ),
    /* @__PURE__ */ f.jsx(
      c3,
      {
        store: S,
        className: Fr(WK, {
          [zK]: m
        }),
        children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          t,
          /* @__PURE__ */ f.jsx(
            Yr,
            {
              size: "xSmall",
              color: m ? "white" : "secondaryContentText",
              children: e
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Sw,
      {
        store: S,
        gutter: 4,
        className: qK,
        children: [
          /* @__PURE__ */ f.jsx(Pp, { size: 0 }),
          h.map((b) => /* @__PURE__ */ f.jsxs(
            yw,
            {
              value: b.key,
              className: GK,
              children: [
                /* @__PURE__ */ f.jsx("div", { className: KK, children: b.clearsOnClick && !l.includes(b.key) ? /* @__PURE__ */ f.jsx(zU, { color: "grey" }) : /* @__PURE__ */ f.jsx(Nx, { color: "white" }) }),
                b.render
              ]
            },
            b.key
          ))
        ]
      }
    )
  ] });
};
var QK = "high", XK = "primary", JK = "rounded", eQ = "medium", rE = Yi({ defaultClassName: "p08wka0", variantClassNames: { size: { small: "p08wka1", medium: "p08wka2", large: "p08wka3" } }, defaultVariants: { size: "medium" }, compoundVariants: [] }), tQ = Yi({ defaultClassName: "p08wkak p08wka4 _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvsz _1faqfmvex _1faqfmv21 _1faqfmv2g", variantClassNames: { emphasis: { low: "p08wkal", medium: "p08wkam", high: "p08wkan" }, kind: { primary: "p08wkao", secondary: "p08wkap", danger: "p08wkaq", success: "p08wkar" }, shape: { rounded: "p08wkas", basic: "p08wkat", leftBasic: "p08wkau", rightBasic: "p08wkav", square: "p08wkaw" }, size: { small: "p08wkax", medium: "p08wkay", large: "p08wkaz" } }, defaultVariants: { emphasis: "high", kind: "primary", size: "medium", shape: "rounded" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "p08wka10"], [{ kind: "primary", emphasis: "medium" }, "p08wka11"], [{ kind: "primary", emphasis: "low" }, "p08wka12"], [{ kind: "secondary", emphasis: "high" }, "p08wka13"], [{ kind: "secondary", emphasis: "medium" }, "p08wka14"], [{ kind: "secondary", emphasis: "low" }, "p08wka15"], [{ size: "small", shape: "rounded" }, "p08wka16 p08wka5 _1faqfmv4c _1faqfmv4w _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmva"], [{ size: "medium", shape: "rounded" }, "p08wka17 p08wka6 _1faqfmv4e _1faqfmv4y _1faqfmv35 _1faqfmv3p _1faqfmvub _1faqfmv9"], [{ size: "large", shape: "rounded" }, "p08wka18 p08wka7 _1faqfmv4g _1faqfmv50 _1faqfmv35 _1faqfmv3p _1faqfmvub _1faqfmv7"], [{ size: "small", shape: "basic" }, "p08wka19 p08wka8 _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmv2"], [{ size: "medium", shape: "basic" }, "p08wka1a p08wka9 _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmv4"], [{ size: "large", shape: "basic" }, "p08wka1b p08wkaa _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmv5"], [{ size: "small", shape: "leftBasic" }, "p08wka1c p08wkab _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmvf _1faqfmv15"], [{ size: "medium", shape: "leftBasic" }, "p08wka1d p08wkac _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvh _1faqfmv17"], [{ size: "large", shape: "leftBasic" }, "p08wka1e p08wkad _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvi _1faqfmv18"], [{ size: "small", shape: "square" }, "p08wka1f p08wkae _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7"], [{ size: "medium", shape: "square" }, "p08wka1g p08wkaf _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7"], [{ size: "large", shape: "square" }, "p08wka1h p08wkag _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7"], [{ size: "small", shape: "rightBasic" }, "p08wka1i p08wkah _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmvs _1faqfmv1i"], [{ size: "medium", shape: "rightBasic" }, "p08wka1j p08wkai _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvu _1faqfmv1k"], [{ size: "large", shape: "rightBasic" }, "p08wka1k p08wkaj _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvv _1faqfmv1l"]] });
const nQ = {
  small: "xSmall",
  medium: "xSmall",
  large: "small"
}, dS = ({
  children: e,
  className: t,
  icon: a,
  iconLeft: l,
  iconRight: h,
  emphasis: g = QK,
  shape: m = JK,
  size: S = eQ,
  kind: b = XK,
  lines: R,
  wordBreak: D,
  onIconLeftClick: T,
  onIconRightClick: j,
  ...A
}) => {
  const L = nQ[S];
  return a = a || l, /* @__PURE__ */ f.jsxs(
    Y5,
    {
      render: /* @__PURE__ */ f.jsx("button", {}),
      className: Fr([
        t,
        tQ({
          emphasis: g,
          kind: b,
          size: S,
          shape: m
        })
      ]),
      style: { cursor: A.onClick ? "pointer" : "default" },
      type: "button",
      ...A,
      children: [
        a && /* @__PURE__ */ f.jsx(
          ct,
          {
            as: "span",
            display: "inline-flex",
            cssClass: rE({ size: S }),
            onClick: T,
            children: a
          }
        ),
        e && /* @__PURE__ */ f.jsx(
          Yr,
          {
            lines: R,
            size: L,
            userSelect: "none",
            color: "inherit",
            display: "inline-flex",
            break: D,
            children: e
          }
        ),
        h && /* @__PURE__ */ f.jsx(
          ct,
          {
            as: "span",
            display: "inline-flex",
            cssClass: rE({ size: S }),
            onClick: j,
            children: h
          }
        )
      ]
    }
  );
}, Yp = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(BM, { placement: "bottom", ...t, children: e }), rQ = ({
  children: e,
  ...t
}) => {
  const a = _h();
  return /* @__PURE__ */ f.jsx(
    cw,
    {
      store: a,
      render: /* @__PURE__ */ f.jsx(f3, {}),
      ...t,
      children: e
    }
  );
}, aQ = ({
  children: e,
  ...t
}) => {
  const a = _h();
  return /* @__PURE__ */ f.jsx(cw, { store: a, render: /* @__PURE__ */ f.jsx(dS, {}), ...t, children: e });
}, iQ = ({ children: e, ...t }) => {
  const a = _h();
  return /* @__PURE__ */ f.jsx(cw, { store: a, render: /* @__PURE__ */ f.jsx(ct, {}), ...t, children: e });
}, lQ = ({ children: e, className: t, ...a }) => {
  const l = _h();
  return /* @__PURE__ */ f.jsxs(
    NM,
    {
      ...a,
      className: t,
      store: l,
      gutter: 4,
      children: [
        /* @__PURE__ */ f.jsx(Pp, { size: 0 }),
        e
      ]
    }
  );
};
Yp.ButtonTrigger = rQ;
Yp.TagTrigger = aQ;
Yp.BoxTrigger = iQ;
Yp.Content = lQ;
Yp.useContext = _h;
Yp.useStore = cx;
var oQ = Yi({ defaultClassName: "_1c7l6so1 _1c7l6so0 _1faqfmv5", variantClassNames: { size: { xxSmall: "_1c7l6so2", xSmall: "_1c7l6so3", small: "_1c7l6so4", medium: "_1c7l6so5" }, variant: { checked: "_1c7l6so6", unchecked: "_1c7l6so7" } }, defaultVariants: { variant: "unchecked" }, compoundVariants: [] });
const qle = ({
  onChange: e,
  checked: t,
  size: a,
  iconLeft: l,
  iconRight: h,
  children: g,
  ...m
}) => {
  const S = oQ({
    size: a,
    variant: t ? "checked" : "unchecked"
  }), b = U4();
  return /* @__PURE__ */ f.jsxs(
    kE,
    {
      render: /* @__PURE__ */ f.jsx("button", {}),
      className: S,
      store: b,
      onChange: e,
      checked: t,
      ...m,
      children: [
        l && /* @__PURE__ */ f.jsx(ct, { as: "span", display: "inline-flex", children: l }),
        g && /* @__PURE__ */ f.jsx(Yr, { size: "xSmall", children: g }),
        h && /* @__PURE__ */ f.jsx(ct, { as: "span", display: "inline-flex", children: h })
      ]
    }
  );
}, uQ = Sa.forwardRef(
  ({ children: e, ...t }, a) => /* @__PURE__ */ f.jsx(ct, { ref: a, ...t, children: e })
);
var sQ = "_1j3v9ks0";
const WO = ({ children: e, icon: t, ...a }) => /* @__PURE__ */ f.jsxs(
  ct,
  {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: a.onClick ? "pointer" : void 0,
    gap: "6",
    cssClass: sQ,
    borderRadius: "6",
    p: "8",
    ...a,
    children: [
      t && /* @__PURE__ */ f.jsx(ct, { as: "span", display: "inline-flex", children: t }),
      e
    ]
  }
);
var cQ = "_13pq1ik0", fQ = "_13pq1ik1", dQ = "_13pq1ik2", hQ = "_13pq1ik3";
const vQ = ({
  children: e,
  trigger: t = "cell"
}) => /* @__PURE__ */ f.jsx(
  ct,
  {
    display: "flex",
    cssClass: Fr(cQ, {
      [fQ]: t === "row",
      [dQ]: t === "cell",
      [hQ]: t === "header"
    }),
    children: e
  }
);
var pQ = "_1kalioo0", mQ = "_1kalioo1";
const zO = ({
  children: e,
  gridColumns: t,
  selected: a,
  forwardRef: l,
  className: h,
  ...g
}) => {
  const S = Sa.Children.toArray(e).map(() => "1fr").join(" ");
  return /* @__PURE__ */ f.jsx(
    ct,
    {
      ref: l,
      cssClass: Fr(pQ, h, {
        [mQ]: a
      }),
      cursor: g.onClick ? "pointer" : void 0,
      style: {
        gridTemplateColumns: t ? t.join(" ") : S
      },
      ...g,
      children: e
    }
  );
}, gQ = ({ children: e }) => /* @__PURE__ */ f.jsx(zO, { gridColumns: ["100%"], children: /* @__PURE__ */ f.jsx(WO, { justifyContent: "center", my: "8", children: e }) });
var wQ = "_1pj3g9p0";
const yQ = ({ children: e, className: t, ...a }) => /* @__PURE__ */ f.jsx(ct, { cssClass: Fr(wQ, t), ...a, children: e });
var xQ = "_1z0mwsn0", SQ = "_1z0mwsn1";
const CQ = O8(
  ({ children: e, noPadding: t, ...a }, l) => /* @__PURE__ */ f.jsx(
    ct,
    {
      cssClass: Fr(xQ, {
        [SQ]: t
      }),
      ref: l,
      ...a,
      children: /* @__PURE__ */ f.jsx(Yr, { size: "xSmall", children: e })
    }
  )
);
var bQ = "_16l1zil1 _16l1zil0 _1faqfmv38 _1faqfmv3s", _Q = "_16l1zil2";
const RQ = ({ placeholder: e, handleChange: t }) => {
  const a = X4();
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      cssClass: bQ,
      px: "8",
      gap: "8",
      children: [
        /* @__PURE__ */ f.jsx(LT, { color: uh.theme.static.content.default }),
        /* @__PURE__ */ f.jsx(
          h3,
          {
            store: a,
            name: "search",
            placeholder: e ?? "Search...",
            className: _Q,
            onChange: t
          }
        )
      ]
    }
  );
};
var EQ = "_84yol10", MQ = "_84yol11";
const TQ = ({
  children: e,
  className: t,
  noBorder: a,
  ...l
}) => /* @__PURE__ */ f.jsx(
  ct,
  {
    cssClass: Fr(EQ, t, {
      [MQ]: a
    }),
    width: "full",
    ...l,
    children: e
  }
), Eh = TQ;
Eh.Body = uQ;
Eh.Cell = WO;
Eh.Discoverable = vQ;
Eh.FullRow = gQ;
Eh.Head = yQ;
Eh.Header = CQ;
Eh.Row = zO;
Eh.Search = RQ;
const qO = ka({
  size: "sm"
}), w3 = ({
  children: e,
  defaultSelectedId: t,
  selectedId: a,
  size: l = "sm",
  onChange: h,
  scrollable: g
}) => {
  const m = gw({
    defaultSelectedId: t,
    setSelectedId: (S) => {
      h && h(S);
    }
  });
  return /* @__PURE__ */ f.jsx(qO.Provider, { value: { size: l }, children: /* @__PURE__ */ f.jsx(xT, { store: m, selectedId: a, children: /* @__PURE__ */ f.jsx(
    Oi,
    {
      direction: "column",
      flexGrow: 1,
      gap: "0",
      width: "full",
      overflowY: g ? "hidden" : void 0,
      children: e
    }
  ) }) });
}, OQ = ({
  children: e,
  gap: t = "16",
  ...a
}) => /* @__PURE__ */ f.jsx(
  ST,
  {
    ...a,
    render: /* @__PURE__ */ f.jsx(
      Oi,
      {
        align: "center",
        direction: "row",
        gap: t,
        borderBottom: "dividerWeak",
        children: e
      }
    )
  }
), DQ = ({ badgeText: e, children: t, icon: a, ...l }) => {
  const { size: h } = Ui(qO), m = Hx().useState("selectedId") === l.id, [S, b] = Qt(!1), R = S || m;
  return /* @__PURE__ */ f.jsx(
    yT,
    {
      ...l,
      render: /* @__PURE__ */ f.jsxs(
        ct,
        {
          display: "flex",
          gap: "4",
          pb: "6",
          flexDirection: "row",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
          onMouseEnter: () => b(!0),
          onMouseLeave: () => b(!1),
          children: [
            /* @__PURE__ */ f.jsx(
              dS,
              {
                shape: "basic",
                size: h === "xs" ? "medium" : "large",
                emphasis: "low",
                kind: m ? "primary" : "secondary",
                icon: a,
                children: t
              }
            ),
            e && /* @__PURE__ */ f.jsx(
              Vp,
              {
                label: e,
                variant: m ? "purple" : "gray",
                shape: "basic",
                size: "small"
              }
            ),
            R && /* @__PURE__ */ f.jsx(
              ct,
              {
                position: "absolute",
                backgroundColor: m ? "p9" : "n7",
                borderTopLeftRadius: "2",
                borderTopRightRadius: "2",
                width: "full",
                style: {
                  height: 2,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  width: "100%"
                }
              }
            )
          ]
        }
      )
    }
  );
}, jQ = ({
  children: e,
  scrollable: t,
  unmountOnHide: a = !0,
  ...l
}) => /* @__PURE__ */ f.jsx(
  CT,
  {
    ...l,
    unmountOnHide: a,
    render: /* @__PURE__ */ f.jsx(
      Oi,
      {
        direction: "column",
        flexGrow: 1,
        id: l.id,
        overflowY: t ? "auto" : void 0,
        children: e
      }
    )
  }
);
w3.Tab = DQ;
w3.List = OQ;
w3.Panel = jQ;
w3.useStore = gw;
w3.useContext = Hx;
const Gle = ({
  background: e = !0,
  defaultValue: t,
  name: a,
  options: l,
  onChange: h,
  cssClass: g,
  disabled: m
}) => {
  const [S, b] = Qt(
    t ?? l[0]
  ), R = (D) => {
    b(D), h && h(D);
  };
  return /* @__PURE__ */ f.jsx(OT, { children: /* @__PURE__ */ f.jsx(
    DT,
    {
      "data-testid": "radio-group",
      className: Fr(g),
      children: /* @__PURE__ */ f.jsx(
        Oi,
        {
          direction: "row",
          gap: "4",
          p: "4",
          borderRadius: "8",
          backgroundColor: e ? "elevated" : void 0,
          flexGrow: 0,
          style: { borderRadius: 9 },
          children: l.map((D, T) => {
            const j = S === D;
            return /* @__PURE__ */ f.jsx(
              zE,
              {
                name: a,
                value: D,
                disabled: m,
                render: /* @__PURE__ */ f.jsx(
                  dS,
                  {
                    kind: j ? "primary" : "secondary",
                    emphasis: j ? "high" : "low",
                    size: "large",
                    shape: "basic",
                    onClick: () => R(D),
                    style: {
                      alignItems: "center",
                      justifyContent: "center",
                      flex: 1,
                      textAlign: "center"
                    },
                    "data-testid": "radio-option",
                    type: "button",
                    children: D
                  },
                  D
                )
              },
              T
            );
          })
        }
      )
    }
  ) });
};
var AQ = Yi({ defaultClassName: "cuhupy0", variantClassNames: { underline: { none: "cuhupy1", solid: "cuhupy2" }, color: { none: "cuhupy3", default: "cuhupy4" } }, defaultVariants: { underline: "none" }, compoundVariants: [] });
const Kle = ({
  children: e,
  href: t,
  underline: a,
  target: l,
  rel: h,
  color: g
}) => /* @__PURE__ */ f.jsx(
  "a",
  {
    className: AQ({ underline: a, color: g }),
    href: t,
    target: l ?? "_blank",
    rel: h ?? "noreferrer",
    children: e
  }
), kQ = 500, Qle = ({
  children: e,
  trigger: t,
  disabled: a,
  style: l,
  delayed: h,
  renderInLine: g,
  maxWidth: m,
  shift: S,
  ...b
}) => {
  const R = Ax({
    placement: "top",
    timeout: h ? kQ : 0,
    ...b
  });
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      fT,
      {
        store: R,
        style: { display: "flex", ...l },
        children: t
      }
    ),
    !a && /* @__PURE__ */ f.jsxs(
      cT,
      {
        store: R,
        gutter: 4,
        style: { zIndex: 20001 },
        portal: !g,
        shift: S,
        children: [
          /* @__PURE__ */ f.jsx(dT, { size: 0 }),
          /* @__PURE__ */ f.jsx(LQ, { maxWidth: m, children: e })
        ]
      }
    )
  ] });
}, LQ = ({ children: e, maxWidth: t = 350 }) => /* @__PURE__ */ f.jsx(
  ct,
  {
    backgroundColor: "white",
    border: "secondary",
    p: "4",
    borderRadius: "6",
    shadow: "small",
    wordBreak: "break-word",
    style: { maxWidth: t },
    children: e
  }
);
export {
  FQ as Ariakit,
  Vp as Badge,
  ct as Box,
  f3 as Button,
  ZU as ButtonContent,
  d3 as ButtonIcon,
  WQ as ButtonLink,
  Hle as Callout,
  Zle as Card,
  aY as Column,
  h3 as Combobox,
  Nle as ComboboxSelect,
  Vle as Container,
  LK as DEFAULT_TIME_PRESETS,
  Ule as DateRangePicker,
  fS as Dialog,
  Ble as EXTENDED_TIME_PRESETS,
  DG as Error,
  Os as Form,
  oY as Group,
  uY as GroupLabel,
  $le as Heading,
  zQ as IconOutlineAcademicCap,
  qQ as IconOutlineAdjustments,
  GQ as IconOutlineAnnotation,
  KQ as IconOutlineArchive,
  QQ as IconOutlineArrowCircleDown,
  XQ as IconOutlineArrowCircleLeft,
  JQ as IconOutlineArrowCircleRight,
  eX as IconOutlineArrowCircleUp,
  tX as IconOutlineArrowDown,
  nX as IconOutlineArrowLeft,
  rX as IconOutlineArrowNarrowDown,
  aX as IconOutlineArrowNarrowLeft,
  iX as IconOutlineArrowNarrowRight,
  lX as IconOutlineArrowNarrowUp,
  oX as IconOutlineArrowRight,
  sX as IconOutlineArrowSmDown,
  cX as IconOutlineArrowSmLeft,
  fX as IconOutlineArrowSmRight,
  dX as IconOutlineArrowSmUp,
  hX as IconOutlineArrowUp,
  uX as IconOutlineArrowsExpand,
  vX as IconOutlineAtSymbol,
  pX as IconOutlineBackspace,
  mX as IconOutlineBadgeCheck,
  gX as IconOutlineBan,
  wX as IconOutlineBeaker,
  yX as IconOutlineBell,
  CX as IconOutlineBookOpen,
  xX as IconOutlineBookmark,
  SX as IconOutlineBookmarkAlt,
  bX as IconOutlineBriefcase,
  _X as IconOutlineCake,
  RX as IconOutlineCalculator,
  EX as IconOutlineCalendar,
  MX as IconOutlineCamera,
  TX as IconOutlineCash,
  OX as IconOutlineChartBar,
  DX as IconOutlineChartPie,
  jX as IconOutlineChartSquareBar,
  AX as IconOutlineChat,
  kX as IconOutlineChatAlt,
  LX as IconOutlineChatAlt_2,
  IX as IconOutlineCheck,
  HX as IconOutlineCheckCircle,
  ZX as IconOutlineCheveronDown,
  PX as IconOutlineCheveronLeft,
  NX as IconOutlineCheveronRight,
  VX as IconOutlineCheveronUp,
  BX as IconOutlineChevronDoubleDown,
  FX as IconOutlineChevronDoubleLeft,
  UX as IconOutlineChevronDoubleRight,
  YX as IconOutlineChevronDoubleUp,
  $X as IconOutlineChip,
  WX as IconOutlineClipboard,
  zX as IconOutlineClipboardCheck,
  qX as IconOutlineClipboardCopy,
  GX as IconOutlineClipboardList,
  KX as IconOutlineClock,
  QX as IconOutlineCloud,
  XX as IconOutlineCloudDownload,
  JX as IconOutlineCloudUpload,
  eJ as IconOutlineCode,
  tJ as IconOutlineCog,
  nJ as IconOutlineCollection,
  rJ as IconOutlineColorSwatch,
  aJ as IconOutlineCreditCard,
  iJ as IconOutlineCube,
  lJ as IconOutlineCubeTransparent,
  oJ as IconOutlineCurrencyBangladeshi,
  uJ as IconOutlineCurrencyDollar,
  sJ as IconOutlineCurrencyEuro,
  cJ as IconOutlineCurrencyPound,
  fJ as IconOutlineCurrencyRupee,
  dJ as IconOutlineCurrencyYen,
  hJ as IconOutlineCursorClick,
  vJ as IconOutlineDatabase,
  pJ as IconOutlineDesktopComputer,
  mJ as IconOutlineDeviceMobile,
  gJ as IconOutlineDeviceTablet,
  wJ as IconOutlineDocument,
  yJ as IconOutlineDocumentAdd,
  xJ as IconOutlineDocumentDownload,
  SJ as IconOutlineDocumentDuplicate,
  CJ as IconOutlineDocumentRemove,
  bJ as IconOutlineDocumentReport,
  _J as IconOutlineDocumentSearch,
  RJ as IconOutlineDocumentText,
  EJ as IconOutlineDotsCircleHorizontal,
  MJ as IconOutlineDotsHorizontal,
  TJ as IconOutlineDotsVertical,
  OJ as IconOutlineDownload,
  DJ as IconOutlineDuplicate,
  jJ as IconOutlineEmojiHappy,
  AJ as IconOutlineEmojiSad,
  kJ as IconOutlineExclamation,
  LJ as IconOutlineExclamationCircle,
  IJ as IconOutlineExit,
  HJ as IconOutlineExternalLink,
  ZJ as IconOutlineEye,
  PJ as IconOutlineEyeOff,
  NJ as IconOutlineFastForward,
  VJ as IconOutlineFilm,
  BJ as IconOutlineFilter,
  FJ as IconOutlineFingerPrint,
  UJ as IconOutlineFire,
  YJ as IconOutlineFlag,
  $J as IconOutlineFolder,
  WJ as IconOutlineFolderAdd,
  zJ as IconOutlineFolderDownload,
  qJ as IconOutlineFolderOpen,
  GJ as IconOutlineFolderRemove,
  KJ as IconOutlineGift,
  QJ as IconOutlineGlobe,
  XJ as IconOutlineGlobeAlt,
  JJ as IconOutlineHand,
  eee as IconOutlineHashtag,
  tee as IconOutlineHeart,
  nee as IconOutlineHome,
  ree as IconOutlineIconUserRemove,
  aee as IconOutlineIdentification,
  iee as IconOutlineInbox,
  lee as IconOutlineInboxIn,
  oee as IconOutlineInformationCircle,
  uee as IconOutlineKey,
  see as IconOutlineLibrary,
  cee as IconOutlineLightBulb,
  fee as IconOutlineLightningBolt,
  dee as IconOutlineLink,
  hee as IconOutlineLocationMarker,
  vee as IconOutlineLockClosed,
  pee as IconOutlineLockOpen,
  mee as IconOutlineLogout,
  gee as IconOutlineMail,
  wee as IconOutlineMailOpen,
  yee as IconOutlineMap,
  xee as IconOutlineMenu,
  See as IconOutlineMenuAlt_1,
  Cee as IconOutlineMenuAlt_2,
  bee as IconOutlineMenuAlt_3,
  _ee as IconOutlineMenuAlt_4,
  Ree as IconOutlineMicrophone,
  Eee as IconOutlineMinus,
  Mee as IconOutlineMinusCircle,
  Tee as IconOutlineMinusSm,
  Oee as IconOutlineMoon,
  Dee as IconOutlineMusicNote,
  jee as IconOutlineNewspaper,
  Aee as IconOutlineOfficeBuilding,
  kee as IconOutlinePaperAirplane,
  Lee as IconOutlinePaperClip,
  Iee as IconOutlinePauseCircle,
  Hee as IconOutlinePencil,
  Zee as IconOutlinePencilAlt,
  Pee as IconOutlinePhone,
  Nee as IconOutlinePhoneIncoming,
  Vee as IconOutlinePhoneMissedCall,
  Bee as IconOutlinePhoneOutgoing,
  Fee as IconOutlinePhotograph,
  Uee as IconOutlinePlayCircle,
  Yee as IconOutlinePlus,
  $ee as IconOutlinePlusCircle,
  Wee as IconOutlinePlusSm,
  zee as IconOutlinePresentationChartBar,
  qee as IconOutlinePresentationChartLine,
  Gee as IconOutlinePrinter,
  Kee as IconOutlinePuzzle,
  Qee as IconOutlineQrCode,
  Xee as IconOutlineQuestionMarkCircle,
  Jee as IconOutlineReceiptRefund,
  ete as IconOutlineReceiptTax,
  tte as IconOutlineRefresh,
  nte as IconOutlineReply,
  rte as IconOutlineRewind,
  ate as IconOutlineRss,
  ite as IconOutlineSankeyChart,
  lte as IconOutlineSave,
  ote as IconOutlineSaveAs,
  ute as IconOutlineScale,
  ste as IconOutlineScissors,
  cte as IconOutlineSearch,
  fte as IconOutlineSearchCircle,
  dte as IconOutlineSelector,
  hte as IconOutlineServer,
  vte as IconOutlineShare,
  pte as IconOutlineShieldCheck,
  mte as IconOutlineShieldExclamation,
  gte as IconOutlineShoppingBag,
  wte as IconOutlineShoppingCart,
  yte as IconOutlineSixDotsVertical,
  xte as IconOutlineSmViewGridAdd,
  Ste as IconOutlineSortAscending,
  Cte as IconOutlineSortDescending,
  bte as IconOutlineSparkles,
  _te as IconOutlineSpeakerphone,
  Rte as IconOutlineStackedBarChart,
  Ete as IconOutlineStar,
  Mte as IconOutlineStatusOffline,
  Tte as IconOutlineStatusOnline,
  Ote as IconOutlineStopCircle,
  Dte as IconOutlineSun,
  jte as IconOutlineSunburstChart,
  Ate as IconOutlineSupport,
  kte as IconOutlineSwitchHorizontal,
  Lte as IconOutlineSwitchVertical,
  Ite as IconOutlineTable,
  Hte as IconOutlineTag,
  Zte as IconOutlineTemplate,
  Pte as IconOutlineTerminal,
  Nte as IconOutlineThumbDown,
  Vte as IconOutlineThumbUp,
  Bte as IconOutlineTicket,
  Fte as IconOutlineTranslate,
  Ute as IconOutlineTrash,
  Yte as IconOutlineTrendingDown,
  $te as IconOutlineTrendingUp,
  Wte as IconOutlineTruck,
  zte as IconOutlineUpload,
  qte as IconOutlineUser,
  Gte as IconOutlineUserAdd,
  Kte as IconOutlineUserCircle,
  Qte as IconOutlineUserGroup,
  Xte as IconOutlineUsers,
  Jte as IconOutlineVariable,
  ene as IconOutlineVideoCamera,
  tne as IconOutlineViewBoards,
  nne as IconOutlineViewGrid,
  rne as IconOutlineViewList,
  ane as IconOutlineVolumeOff,
  ine as IconOutlineVolumeUp,
  lne as IconOutlineWifi,
  one as IconOutlineX,
  une as IconOutlineXCircle,
  sne as IconOutlineZoomIn,
  cne as IconOutlineZoomOut,
  fne as IconSolidAcademicCap,
  dne as IconSolidAdjustments,
  hne as IconSolidAnnotation,
  vne as IconSolidArchive,
  pne as IconSolidArrowCircleDown,
  mne as IconSolidArrowCircleLeft,
  gne as IconSolidArrowCircleRight,
  wne as IconSolidArrowCircleUp,
  yne as IconSolidArrowDown,
  xne as IconSolidArrowLeft,
  Sne as IconSolidArrowNarrowDown,
  Cne as IconSolidArrowNarrowLeft,
  bne as IconSolidArrowNarrowRight,
  _ne as IconSolidArrowNarrowUp,
  Rne as IconSolidArrowRight,
  Mne as IconSolidArrowSmDown,
  Tne as IconSolidArrowSmLeft,
  One as IconSolidArrowSmRight,
  Dne as IconSolidArrowSmUp,
  jne as IconSolidArrowUp,
  Ene as IconSolidArrowsExpand,
  Ane as IconSolidAtSymbol,
  kne as IconSolidAvatar,
  Lne as IconSolidBackspace,
  Ine as IconSolidBadgeCheck,
  Hne as IconSolidBan,
  Zne as IconSolidBeaker,
  Pne as IconSolidBell,
  Bne as IconSolidBookOpen,
  Nne as IconSolidBookmark,
  Vne as IconSolidBookmarkAlt,
  Fne as IconSolidBriefcase,
  Une as IconSolidCake,
  Yne as IconSolidCalculator,
  $ne as IconSolidCalendar,
  Wne as IconSolidCamera,
  zne as IconSolidCart,
  qne as IconSolidCash,
  Gne as IconSolidChartBar,
  Kne as IconSolidChartPie,
  Qne as IconSolidChartSquareBar,
  Xne as IconSolidChartSquareLine,
  Jne as IconSolidChat,
  ere as IconSolidChatAlt,
  tre as IconSolidChatAlt_2,
  kT as IconSolidCheck,
  Nx as IconSolidCheckCircle,
  Vx as IconSolidCheveronDown,
  BU as IconSolidCheveronLeft,
  h8 as IconSolidCheveronRight,
  FU as IconSolidCheveronUp,
  nre as IconSolidChevronDoubleDown,
  rre as IconSolidChevronDoubleLeft,
  are as IconSolidChevronDoubleRight,
  ire as IconSolidChevronDoubleUp,
  lre as IconSolidChip,
  ore as IconSolidClickUp,
  ure as IconSolidClipboard,
  sre as IconSolidClipboardCheck,
  cre as IconSolidClipboardCopy,
  fre as IconSolidClipboardList,
  UU as IconSolidClock,
  dre as IconSolidCloud,
  hre as IconSolidCloudDownload,
  vre as IconSolidCloudUpload,
  pre as IconSolidCode,
  mre as IconSolidCog,
  gre as IconSolidCollection,
  wre as IconSolidColorSwatch,
  yre as IconSolidCreditCard,
  xre as IconSolidCube,
  Sre as IconSolidCubeTransparent,
  Cre as IconSolidCurrencyBangladeshi,
  bre as IconSolidCurrencyDollar,
  _re as IconSolidCurrencyEuro,
  Rre as IconSolidCurrencyPound,
  Ere as IconSolidCurrencyRupee,
  Mre as IconSolidCurrencyYen,
  Tre as IconSolidCursorClick,
  Ore as IconSolidDatabase,
  Dre as IconSolidDesktopComputer,
  jre as IconSolidDeviceMobile,
  Are as IconSolidDiscord,
  kre as IconSolidDocument,
  Lre as IconSolidDocumentAdd,
  Ire as IconSolidDocumentDownload,
  Hre as IconSolidDocumentDuplicate,
  Zre as IconSolidDocumentRemove,
  Pre as IconSolidDocumentReport,
  Nre as IconSolidDocumentSearch,
  Vre as IconSolidDocumentText,
  Bre as IconSolidDotsCircleHorizontal,
  Fre as IconSolidDotsHorizontal,
  Ure as IconSolidDotsVertical,
  Yre as IconSolidDownload,
  $re as IconSolidDragger,
  Wre as IconSolidDuplicate,
  zre as IconSolidEmojiHappy,
  qre as IconSolidEmojiSad,
  YU as IconSolidExclamation,
  Gre as IconSolidExclamationCircle,
  Kre as IconSolidExitRight,
  Qre as IconSolidExternalLink,
  Xre as IconSolidEye,
  Jre as IconSolidEyeOff,
  eae as IconSolidFastForward,
  tae as IconSolidFilm,
  nae as IconSolidFilter,
  rae as IconSolidFingerPrint,
  aae as IconSolidFire,
  iae as IconSolidFlag,
  lae as IconSolidFolder,
  oae as IconSolidFolderAdd,
  uae as IconSolidFolderDownload,
  sae as IconSolidFolderOpen,
  cae as IconSolidFolderRemove,
  fae as IconSolidGift,
  dae as IconSolidGithub,
  hae as IconSolidGitlab,
  vae as IconSolidGlobe,
  pae as IconSolidGlobeAlt,
  mae as IconSolidGoogle,
  gae as IconSolidGrafana,
  wae as IconSolidHand,
  yae as IconSolidHashtag,
  xae as IconSolidHeart,
  Sae as IconSolidHeight,
  Cae as IconSolidHighlight,
  bae as IconSolidHome,
  _ae as IconSolidIdentification,
  Rae as IconSolidInbox,
  Eae as IconSolidInboxIn,
  $U as IconSolidInformationCircle,
  Mae as IconSolidInspect,
  Tae as IconSolidJira,
  Oae as IconSolidKey,
  Dae as IconSolidLightBulb,
  jae as IconSolidLightningBolt,
  Aae as IconSolidLinear,
  kae as IconSolidLink,
  WU as IconSolidLoading,
  Lae as IconSolidLoadingProgress,
  Iae as IconSolidLocationMarker,
  Hae as IconSolidLockClosed,
  Zae as IconSolidLockOpen,
  Pae as IconSolidLogout,
  Nae as IconSolidLogs,
  Vae as IconSolidMail,
  Bae as IconSolidMailOpen,
  Fae as IconSolidMap,
  Uae as IconSolidMdLibrary,
  Yae as IconSolidMenu,
  $ae as IconSolidMenuAlt_1,
  Wae as IconSolidMenuAlt_2,
  zae as IconSolidMenuAlt_3,
  qae as IconSolidMenuAlt_4,
  Gae as IconSolidMetrics,
  Kae as IconSolidMicrophone,
  Qae as IconSolidMicrosoftTeams,
  zU as IconSolidMinus,
  Xae as IconSolidMinusCircle,
  Jae as IconSolidMinusSm,
  eie as IconSolidMoon,
  tie as IconSolidMusicNote,
  nie as IconSolidNewspaper,
  rie as IconSolidOfficeBuilding,
  aie as IconSolidPaperAirplane,
  iie as IconSolidPaperClip,
  lie as IconSolidPause,
  oie as IconSolidPauseCircle,
  uie as IconSolidPencil,
  sie as IconSolidPencilAlt,
  cie as IconSolidPhone,
  fie as IconSolidPhoneIncoming,
  die as IconSolidPhoneMissedCall,
  hie as IconSolidPhoneOutgoing,
  vie as IconSolidPhotograph,
  pie as IconSolidPlay,
  mie as IconSolidPlayCircle,
  gie as IconSolidPlus,
  wie as IconSolidPlusCircle,
  yie as IconSolidPlusSm,
  xie as IconSolidPresentationChartBar,
  Sie as IconSolidPresentationChartLine,
  Cie as IconSolidPrinter,
  bie as IconSolidPuzzle,
  _ie as IconSolidQrCode,
  Rie as IconSolidQuestionMarkCircle,
  Eie as IconSolidReceiptRefund,
  Mie as IconSolidReceiptTax,
  Tie as IconSolidRefresh,
  Oie as IconSolidReply,
  Die as IconSolidRewind,
  jie as IconSolidRss,
  Aie as IconSolidSave,
  kie as IconSolidSaveAs,
  Lie as IconSolidScale,
  Iie as IconSolidScissors,
  LT as IconSolidSearch,
  Hie as IconSolidSearchCircle,
  Zie as IconSolidSegment,
  IT as IconSolidSelector,
  Pie as IconSolidServer,
  Nie as IconSolidShare,
  Vie as IconSolidShieldCheck,
  Bie as IconSolidShieldExclamation,
  Fie as IconSolidShoppingBag,
  Uie as IconSolidSkip,
  Yie as IconSolidSkipLeft,
  $ie as IconSolidSlack,
  Wie as IconSolidSmartphone,
  zie as IconSolidSortAscending,
  qie as IconSolidSortDescending,
  Gie as IconSolidSparkles,
  Kie as IconSolidSpeakerphone,
  Qie as IconSolidStar,
  Xie as IconSolidStatusOffline,
  Jie as IconSolidStatusOnline,
  ele as IconSolidStopCircle,
  tle as IconSolidSun,
  nle as IconSolidSupport,
  rle as IconSolidSwitchHorizontal,
  ale as IconSolidSwitchVertical,
  ile as IconSolidTable,
  lle as IconSolidTag,
  ole as IconSolidTemplate,
  ule as IconSolidTerminal,
  sle as IconSolidThumbDown,
  cle as IconSolidThumbUp,
  fle as IconSolidTicket,
  dle as IconSolidTraces,
  hle as IconSolidTranslate,
  vle as IconSolidTrash,
  ple as IconSolidTrendingDown,
  mle as IconSolidTrendingUp,
  gle as IconSolidTruck,
  wle as IconSolidUpload,
  yle as IconSolidUser,
  xle as IconSolidUserAdd,
  Sle as IconSolidUserCircle,
  Cle as IconSolidUserGroup,
  ble as IconSolidUserRemove,
  _le as IconSolidUsers,
  Rle as IconSolidVariable,
  Ele as IconSolidVideoCamera,
  Mle as IconSolidViewBoards,
  Tle as IconSolidViewGrid,
  Ole as IconSolidViewGridAdd,
  Dle as IconSolidViewList,
  jle as IconSolidVolumeOff,
  Ale as IconSolidVolumeUp,
  kle as IconSolidWifi,
  Bx as IconSolidX,
  Fx as IconSolidXCircle,
  Lle as IconSolidZoomIn,
  Ile as IconSolidZoomOut,
  AG as Input,
  lY as Item,
  cS as Label,
  da as Menu,
  Wle as MenuButton,
  kK as MenuState,
  Up as Modal,
  zle as MultiSelectButton,
  FO as NamedSection,
  LG as Option,
  Yp as Popover,
  V0 as Select,
  Oi as Stack,
  jG as Submit,
  qle as SwitchButton,
  Eh as Table,
  w3 as Tabs,
  dS as Tag,
  Gle as TagSwitchGroup,
  Yr as Text,
  Kle as TextLink,
  Qle as Tooltip,
  LQ as TooltipContent,
  $Q as buttonStyles,
  Yle as getNow,
  Fle as parsePreset,
  $O as presetLabel,
  IK as presetStartDate,
  T8 as presetValue,
  UQ as sMonotype,
  YQ as typographyStyles,
  Ple as useComboboxStore
};
//# sourceMappingURL=components.js.map
